'use strict'
define('scripts/appModule',["js/qlik"], 
	function (qlik) {	
		// defines controller class
		//Controller load order: 1. routProvide cntroller, 2. html ng-controller 
		var appMod = angular.module("appModule", ['ngRoute']);
		appMod.config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
			$routeProvider	
				.when('/invalid', { templateUrl: 'templates/invalidSurvey.html'})
				.when('/sed',   { templateUrl: 'templates/surveyContent.html', controller: 'SedCtrl' })
				.when('/gss',   { templateUrl: 'templates/surveyContent.html', controller: 'GssCtrl' })
				.when('/herd', { templateUrl: 'templates/surveyContent.html', controller: 'HerdCtrl' })
				.when('/ffs', { templateUrl: 'templates/surveyContent.html', controller: 'FfsCtrl' })
				.when('/fss', { templateUrl: 'templates/surveyContent.html', controller: 'FssCtrl' })			
				.when('/fac', { templateUrl: 'templates/surveyContent.html', controller: 'FacCtrl' })
				.when('/ipeds_c', { templateUrl: 'templates/surveyContent.html', controller: 'IpedsCompCtrl' })
				.when('/nscg', { templateUrl: 'templates/surveyContent.html', controller: 'NscgCtrl' })
				.when('/sdr', { templateUrl: 'templates/surveyContent.html', controller: 'LgsdrCtrl' })
				.when('/sgrd', { templateUrl: 'templates/surveyContent.html', controller: 'SgrdCtrl' })
				.when('/ffrdc_pd', { templateUrl: 'templates/surveyContent.html', controller: 'FfrdcPdCtrl' })
				.when('/ntews', { templateUrl: 'templates/surveyContent.html', controller: 'NtewsCtrl' })
				.when('/ffrdc_rd', { templateUrl: 'templates/surveyContent.html', controller: 'FfrdcRdCtrl' })
				.when('/welcome', { templateUrl: 'templates/landing.html', controller: 'LandingCtrl' })
				.when('/ipeds_e', { templateUrl: 'templates/ipedseNotice.html'})
				.otherwise({
					redirectTo: '/invalid'
			});	
			$locationProvider.html5Mode({
				enabled: true,
				requireBase: true
			});
		}]);	

	// define the angular module with its controller
	return appMod;
});
define('scripts/shared/webProperties',[],function () {

	var properties = {
		"_comment_environment": "prod-ids",
		nscg : {
			"appName" : "d41caaa8-9c7a-453e-9655-3c3b7f70e903"
		},
		herd : {
			"appName" : "5148d32f-cc23-434d-b7a3-a79588eb7899"
		},
		gss : {
			"appName" : "6794af41-79be-476e-af30-010d2e2f6a8a"
		},
		ffs : {
			"appName" : "d027d4ee-5d0d-4e37-b6c4-c5da47b81989"
		},
		fss : {
			"appName" : "de2b1847-0edb-4fb1-bb78-de583e2c1cd3"
		},
		sed : {
			"appName" : "ab4cb704-e37d-49e9-9a0c-0f48ab912eb3"
		},
		ipeds_c : {
			"appName" : "6d50ca63-4891-4470-aa11-38587423d291"
		},
		fac : {
			"appName" : "f6195125-f5ff-48cd-b9bf-fceab47bf9cb"
		},
		sdr : {
			"appName" : "3ad0b9b5-af19-4b00-a4a8-bd9db099ec22"
		},
		ntews : {
			appName : "4f1b0f0f-2454-4f93-b45e-d422cc736bf8",
		},		
		sgrd : {
			appName : "1bdce400-f6fe-4cea-baf4-a8df9bb0c3e4",
		},
		ffrdc_pd : {
			"appName" : "",
		},
		ffrdc_rd : {
			"appName" : "",
		},
		exportUrl : "https://ncsesdata.nsf.gov/ecache/",
		webUrl :  "https://ncsesdata.nsf.gov/builder/",
		metadataApiUrl :  "https://ncsesdata.nsf.gov/api/v1/",
		lpUrl : "https://ncsesdata.nsf.gov/home",
		meUrl : "https://ncsesdata.nsf.gov/explorer",
		webinarUrl : "https://ncsesdata.nsf.gov/webinar",
        kbUrl: "https://now.nsf.gov/ncses"
	};
	return {
		props : properties
	};
});

'use strict'
define('scripts/shared/appUtilities',["scripts/shared/webProperties"], function (webProperties) {
	var getAppVariable = function (qApp, unitName) {
		qApp.variable.getContent(unitName).then(function (resp) {
			return resp.qContent.qString;
		}, function (err) {
			console.log("Get App Variable error:",err);
			return null;
		});
	};

	var setAppVariable = function (qApp, unitName, unitValue) {
		qApp.variable.setStringValue(unitName, unitValue);
	};

	var getPredefinedTable = function (qlik, $http, file) {
		return new qlik.Promise(function (resolve, reject) {
			$http.get(webProperties.props.webUrl + "tabledefs/" + file, {
				withCredentials: false
			}).then(function (response) {
				if (response == null) {
					console.log("Table not found");
					return reject('Table not found');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("Predefined Table retrieval failed:",error);
				return reject('Predefined Table retrieval failed');
			});
		})
	};
	
	var getResource = function (qlik, $http, path) {
		return new qlik.Promise(function (resolve, reject) {
			$http.get(webProperties.props.webUrl + path)
			.then(function (response) {
				return resolve(response);
			}, function (error) {
				console.log(path + " resource not found");
				return reject();
			});
		})
	};	

	var getSurveyProperties = function ($http, $q, abbr) {
		var deferred = $q.defer();
		$http.get(webProperties.props.metadataApiUrl + 'metadata/surveys/' + abbr + '?key=header.payload.signature', {
			withCredentials: false
		}).then(function (response) {
			if (response == null || response.data == null || response.data.body == null) {
				console.log("Metadata API survey returned no data");
				deferred.reject('Metadata API survey returned no data');
			} else {
				deferred.resolve(response);
			}
		}, function (error) {
			console.log("Metadata API survey failed:", error);
			deferred.reject('Metadata API survey failed');
		});
		return deferred.promise;
	};

	var getSurveyList = function ($http, $q) {
		var deferred = $q.defer();
		$http.get(webProperties.props.metadataApiUrl + 'metadata/surveys' + '?key=header.payload.signaturee&profile=summary', {
			withCredentials: false
		}).then(function (response) {
			if (response == null || response.data == null || response.data.body == null || response.data.body.content == null) {
				console.log("Metadata API survey list returned no data");
				deferred.reject('Metadata API survey list returned no data');
			} else {
				deferred.resolve(response);
			}	
		}, function (error) {
			console.log("Metadata API survey list failed:", error);
			deferred.reject('Metadata API survey list failed');
		});
		return deferred.promise;
	};

	var getSurveyMetaFieldsFromApi = function (qlik, $http) {
		return new qlik.Promise(function (resolve, reject) {
			$http.get(webProperties.props.metadataApiUrl + 'metadata/surveys/fieldNames?key=header.payload.signature', {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null || response.data.body == null) {
					console.log('Metadata API survey variable list returned no data');
					return reject('Metadata API survey variable list returned no data');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("error: " + error);
				return reject('Metadata API survey variable list failed');
			});
		});
	};	
	
	var getSurveyVariableListFromApi = function (qlik, $http, ids) {
		return new qlik.Promise(function (resolve, reject) {
			var size = ids.length;
			$http.get(webProperties.props.metadataApiUrl + 'metadata/variables?ids=' + ids.toString() + '&key=header.payload.signature&survey&size=' + size, {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null || response.data.body == null) {
					console.log('Metadata API survey variable list returned no data')
					return reject('Metadata API survey variable list returned no data');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("error: " + error);
				return reject('Metadata API survey variable list failed');
			});
		});
	};

	var getVariableMetaFieldsFromApi = function (qlik, $http) {
		return new qlik.Promise(function (resolve, reject) {
			$http.get(webProperties.props.metadataApiUrl + 'metadata/variables/fieldNames?key=header.payload.signature', {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null || response.data.body == null) {
					console.log('Metadata API survey variable list returned no data');
					return reject('Metadata API survey variable list returned no data');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("error: " + error);
				return reject('Metadata API survey variable list failed');
			});
		});
	};


	function exportVariableDetailsFromApi(qlik, $http, id, fields, fileType) {
		return new qlik.Promise(function (resolve, reject) {
			
			let str = webProperties.props.metadataApiUrl + 'metadata/variables/' + id + '/export' + '?fields=' + fields + '&exportType=' + fileType + '&key=header.payload.signature&profile=details';
			var req ={
				method: "GET",
				withCredentials: false
			}
			if(fileType == "xlsx")
				req.responseType = "blob";
			
			$http.get(str, req).then(function (response) {
				if (response == null || response.data == null) {
					console.log("Metadata API export variable summary returned no data");
					return reject('Metadata API survey variable details returned no data');
				} else {
					return resolve(response);
				}				
			}, function (error) {
				console.log("Metadata API survey variable list failed:",error);
				return reject('Metadata API survey variable list failed');
			});			
		});
	};
	
	
	function exportSurveyDetailsFromApi(qlik, $http, abbr, fields, fileType) {
		return new qlik.Promise(function (resolve, reject) {
			
			let str = webProperties.props.metadataApiUrl + 'metadata/surveys/' + abbr + '/export' + '?fields=' + fields + '&exportType=' + fileType + '&key=header.payload.signature&profile=details';
			var req ={
				method: "GET",
				withCredentials: false
			}
			if(fileType == "xlsx")
				req.responseType = "blob";
			
			$http.get(str, req).then(function (response) {
				if (response == null || response.data == null) {
					console.log("Metadata API export variable summary returned no data");
					return reject('Metadata API survey variable details returned no data');
				} else {
					return resolve(response);
				}				
			}, function (error) {
				console.log("Metadata API survey variable list failed:", error);
				return reject('Metadata API survey variable list failed');
			});			
		});
	};	

	function exportVariableSummaryFromApi(qlik, $http, ids) {
		return new qlik.Promise(function (resolve, reject) {
			var size = ids.length;
			$http.get(webProperties.props.metadataApiUrl + 'metadata/variables/export?ids=' + ids.toString() + '&key=header.payload.signature&size=' + size, {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null) {
					console.log("Metadata API export variable summary returned no data");
					return reject('Metadata API survey variable details returned no data');
				} else {
					return resolve(response);
				}				
			}, function (error) {
				console.log("Metadata API survey variable summary failed:",error);
				return reject('Metadata API survey variable summary failed');
			});
		});
	};

	var getSurveyVariableDetailsFromApi = function (qlik, $http, id) {
		return new qlik.Promise(function (resolve, reject) {
			$http.get(webProperties.props.metadataApiUrl + 'metadata/variables/' + id + '?key=header.payload.signature&survey', {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null || response.data.body == null) {
					console.log("Metadata API survey variable details returned no data");
					return reject('Metadata API survey variable details returned no data');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("Metadata API survey variable details failed:", error);
			});
		});
	};

	var getVariableCountsFromApi = function (qlik, $http, id, surveyYear) {
		return new qlik.Promise(function (resolve, reject) {
			$http.get(webProperties.props.metadataApiUrl + 'metadata/variables/' + id.toString() + '/counts?surveyYear=' + surveyYear + '&key=header.payload.signature', {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null || response.data.body == null) {
					console.log('Metadata API survey variable counts returned no data');
					return reject('Metadata API survey variable counts returned no data');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("Metadata API survey variable  counts failed:", error);
				return reject('Metadata API survey variable  counts failed');
			});
		});

	}

	var getSurveyVariableValuesFromApi = function (qlik, $http, id) {
		return new qlik.Promise(function (resolve, reject) {
			$http.get(webProperties.props.metadataApiUrl + 'metadata/variables/' + id + '/fieldValues?key=header.payload.signature&survey', {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null || response.data.body == null) {
					console.log("Metadata API survey variable values are empty");
					return reject('empty');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("Metadata API survey variable values failed:",error);
				return reject('Metadata API survey variable values failed');
			});
		});
	};

	var getTypeaheadSuggestionsFromApi = function (qlik, $http, term, survey) {
		return new qlik.Promise(function (resolve, reject) {
			$http.get(webProperties.props.metadataApiUrl + 'metadata/suggestions?term=' + encodeURIComponent(term) + '&survey=' + survey
				 + '&applyExclusions=builder' + '&size=200&number=0&key=header.payload.signature', {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null || response.data.body == null) {
					console.log("Metadata API suggestions returned empty")
					return reject('empty');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("Metadata API suggestions failed:", error);
				return reject('Metadata API suggestions failed');
			});
		});
	};

	var getSuggestionVariableIdsFromApi = function (qlik, $http, term, topic, survey) {
		return new qlik.Promise(function (resolve, reject) {
			var url = webProperties.props.metadataApiUrl + 'metadata/variables?term=' + encodeURIComponent(term) + (topic == 'All Results' ? ('&exactMatch=no') : ('&topic=' + encodeURIComponent(topic)))
				 + '&survey=' + survey + '&profile=summary&page=0&size=20&key=header.payload.signature&applyExclusions=builder';
			$http.get(url, {
				withCredentials: false
			}).then(function (response) {
				if (response == null || response.data == null || response.data.body == null) {
					console.log("Metadata API suggestion varaible IDs returned empty")
					return reject('empty');
				} else {
					return resolve(response);
				}
			}, function (error) {
				console.log("Metadata API suggestion varaible IDs failed:", error);
				return reject('Metadata API suggestion varaible IDs failed');
			});
		});
	};

	var replaceString = function (inStr, oldStr, newStr) {
		inStr.replace(/oldStr/g, newStr);
		return
	};

	var removeQlikFormating = function (inStr) {
		var result = inStr.replace(/^(=\[|=)/, '');
		result = result.replace(/(\])$/, '');
		return result;
	};

	var showError = function (err) {
		if (typeof err == 'object' && err.message == "Object not found") {
			console.log(err.message);
			return;
		} else if (typeof err == 'object' && 'method' in err && err.method == "OnSessionTimedOut") {
			$('#errorMsg').text("Your session has timed out. Please refresh to continue.");
		} else if (typeof err == 'object' && err.message == "ProxyError.OnSessionTimedOut") {
			$('#errorMsg').text("Your session has timed out. Please refresh to continue.");
		} else if (typeof err == 'object' && err.message == "Result too large") {
			$('#errorMsg').text("Application error, results to large");
		} else if (typeof err == 'object' && err.message == "Socket closed") {
			$('#errorMsg').text("Network error. The network connection was reset.");
		} else {
			$('#errorMsg').text("Application error, please try refreshing page");
			if(typeof err == 'object' && err.message != null) {
				$('#errorInfo').text(err.message)
/* 				if(err.stack != null) {
					$('#errorDetails').text(err.stack)				
				} */
			} else if(err != '') {
				$('#errorInfo').text(err)
			}
		}
		console.log(err);
		$('#DisplayErrorMessage').modal({
			toggle: true,
			backdrop: 'static',
			keyboard: false
		});
	};

	var setUpKeepAlive = function (scope, qApp, interval) {
		//web server socket connetion is set to 30 min, keepAlive function pads this with another 30 min.
		//The keepAlive function poles server every 4 1/2 min with 7 iterations, so just over 30 min.
		//Upon completion of last keepAlive pole request, the web server will keep session alive for another 30 min for a total of 60 min 
		scope.qlikInvokedCounter = 0;
		var keepAlive = function () {
			if (typeof qApp != "undefined") {
				try {
					qApp.getObject(scope.visObjId).then(function (obj) {
						obj.getEffectiveProperties().then(function (obj_properties) {
							//console.log("keepAlive polling - " + new Date());
						}, function(err) {
							console.error('Prop Error: ' + err);
						});
					}, function(err) {
						console.error('Prop Error: ' + err);
					}).catch(error => { 
						console.log('Error: ' + error); });
				} catch (err) {
					console.error("keepAlive polling error - " + new Date());
				}
			} else {
				console.error("keepAlive qApp obj is undefined - " + new Date());
			}
		};
		if (scope.keepAliveCall != null) {
			destroyKeepAlive();
		}
		scope.keepAliveCall = interval(keepAlive, 270000, 7);
		scope.keepAliveCall.then(function (cnt) {
			//console.log('keepAlive interval completed - ' + new Date());
		});

		var resetKeepAlive = function (newValue, oldValue) {
			if (newValue !== oldValue) {
				if (scope.keepAliveCall != null) {
					//console.log('resetting keepAlive - ' + new Date());
					destroyKeepAlive();
					scope.keepAliveCall = interval(keepAlive, 270000, 7);
					scope.keepAliveCall.then(function (cnt) {
						//console.log('keepAlive reset interval completed - ' + new Date());
					});
				}
			}
		};
		scope.$watch(function () {
			return scope.qlikInvokedCounter
		}, resetKeepAlive);

		var destroyKeepAlive = function () {
			if (scope.keepAliveCall != null) {
				interval.cancel(scope.keepAliveCall);
				scope.keepAliveCall = null;
				//console.log('keepAlive destroyed - ' + new Date());
			}
		}
		scope.$on('$destroy', function () {
			destroyKeepAlive();
		});
	}

	function compareValues(key, order) {
		return function innerSort(a, b) {
			if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
				return 0;
			}

			var varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
			var varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];

			var comparison = 0;
			if (varA > varB) {
				comparison = 1;
			} else if (varA < varB) {
				comparison = -1;
			}
			return (
				(order === 'desc') ? (comparison * -1) : comparison);
		};
	}

	function compareNumerics(key, order) {
		return function innerSort(a, b) {
			if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
				return 0;
			}

			var varA = (typeof a[key] === 'string') ? parseInt(a[key]) : a[key];
			var varB = (typeof b[key] === 'string') ? parseInt(b[key]) : b[key];

			var comparison = 0;
			if (varA > varB) {
				comparison = 1;
			} else if (varA < varB) {
				comparison = -1;
			}
			return (
				(order === 'desc') ? (comparison * -1) : comparison);
		};
	}
	function search(key, searchValue, searchArray) {
		for (var i = 0; i < searchArray.length; i++) {
			if (searchArray[i][key] === searchValue) {
				return searchArray[i];
			}
		}
		return null;
	}

	function findMatches(key, searchValue, searchArray) {
		var retArr = [];
		for (var i = 0; i < searchArray.length; i++) {
			if (searchArray[i][key] === searchValue) {
				retArr.push(searchArray[i]);
			}
		}
		return retArr;
	}

	function removeDuplicates(originalArray, prop) {
		var newArray = [];
		var lookupObject = {};

		for (var i in originalArray) {
			lookupObject[originalArray[i][prop]] = originalArray[i];
		}

		for (i in lookupObject) {
			newArray.push(lookupObject[i]);
		}
		return newArray;
	}

	function findValuesMatches(key, searchValue, searchArray) {
		var retArr = [],
		srchValue = [];
		if (!Array.isArray(searchValue)) {
			srchValue = [];
			srchValue.push(searchValue);
		} else {
			srchValue = searchValue;
		}
		for (var i = 0; i < searchArray.length; i++) {
			if (srchValue.indexOf(searchArray[i][key]) > -1) {
				retArr.push(searchArray[i]);
			}
		}
		return retArr;
	}

	function findIndexList(key, searchValue, searchArray) {
		var retArr = [];
		for (var i = 0; i < searchArray.length; i++) {
			if (searchArray[i][key] === searchValue) {
				retArr.push(searchArray[i].qElemNumber);
			}
		}
		return retArr;
	}

	function findIndex(key, searchValue, searchArray) {
		var ret = -1;
		for (var i = 0; i < searchArray.length; i++) {
			if (searchArray[i][key] === searchValue) {
				return i;
			}
		}
		return ret;
	}

	function initSpinner() {
		var _top = $(window).height() / 3;
		var _left = $(window).width() / 2;
		var spinnerOpts = {
			lines: 50,
			length: 0,
			width: 8,
			radius: 38,
			scale: 0.25,
			corners: 0,
			color: '#94b6ea',
			opacity: .15,
			rotate: 0,
			direction: 1,
			speed: 1.5,
			trail: 60,
			fps: 20,
			zIndex: 2e9,
			className: 'spinner',
			shadow: false,
			hwaccel: false,
			top: _top,
			left: _left
		}

		var target = document.getElementById("SpinnerContainer");
		var spinner = new Spinner(spinnerOpts).spin(target);
		return spinner;
	}

	function getChartWidth(cube, $rootScope) {
		var barsCnt = 1,
		chartWidth = 600; //170;

		if($rootScope.chart.barType == 'v-stacked') {
			barsCnt = cube.qDimensionInfo.length;
		} else {
			for (var x = 0; x < cube.qDimensionInfo.length; x++) {
				//barsCnt = barsCnt * (cube.qDimensionInfo[x].qCardinalities.qHypercubeCardinal > 10?10:cube.qDimensionInfo[x].qCardinalities.qHypercubeCardinal);
				barsCnt = barsCnt * cube.qDimensionInfo[x].qCardinalities.qHypercubeCardinal
					//barsCnt += cube.qDimensionInfo[x].qCardinalities.qHypercubeCardinal;
			}
		}

		if (barsCnt == 1) {
			//use default width
		} else if (barsCnt <= 10) {
			chartWidth += barsCnt * 70;
		} else {
			chartWidth += barsCnt * 30;
		}

		if (cube.qDimensionInfo.length > 1) {
			//include legend
			chartWidth += 220;
		}

		//var contWidth = $("#chartWrapper").innerWidth();
		//var contWidth = Math.max($("#customTabPanel").innerWidth(), 465) - 8; //account for margin
		var contWidth = $("#content-wrapper #content").innerWidth() - 8; //account for margin
		if (chartWidth > contWidth)
			return contWidth;
		else
			return chartWidth;

	}

	function replaceIllegalChars(id) {
		var removedIllegalChars = '';
		if(id) {
			removedIllegalChars = id.replaceAll(' ', '-');
			removedIllegalChars = removedIllegalChars.replaceAll('&', 'amp');
			removedIllegalChars = removedIllegalChars.replaceAll('/', '-');
			removedIllegalChars = removedIllegalChars.replaceAll('\\', '-');
			removedIllegalChars = removedIllegalChars.replaceAll('(', '');
			removedIllegalChars = removedIllegalChars.replaceAll(')', '');
			removedIllegalChars = removedIllegalChars.replaceAll(',', '');
			removedIllegalChars = removedIllegalChars.replaceAll('\'', '');
			removedIllegalChars = removedIllegalChars.replaceAll('\"', '');
		}
		return removedIllegalChars;
	}

	function randomCid() {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (var i = 0; i < 7; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	};

	function loadJsonFile(file, dimsObj) {
		return new Promise(function (resolve, reject) {
			let fr;

			if (typeof window.FileReader !== 'function') {
				return reject("The file API isn't supported on this browser");
			}
			fr = new FileReader();
			fr.onload = receivedText;
			fr.readAsText(file);

			function receivedText(e) {
				let resp = e.target.result;
				try {
					let tmpObj = JSON.parse(resp);
					if (!tmpObj) {
						return reject("Invlaid json file, missing result property");
					}
					return resolve(tmpObj);
				} catch (err) {
					console.log('Error opening file', err);
					return reject("File is not a valid JSON file. Please verify file was downloaded previously from this tool.");
				}
			}
		});
	}
 
    function getSurveySource($rootScope) {
        let strSource = "";
        if($rootScope.survey.abbreviation == "IPEDS_C") {
            let msrList = [];
            for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
                var apiGrps = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups;
                for (var j = 0; j < apiGrps.length; j++) {
                    for (var k = 0; k < apiGrps[j].measures.length; k++) {
                        if (apiGrps[j].measures[k].selected == true) {
                            msrList.push(apiGrps[j].measures[k]);
                        }
                    }
                }
            }                                                                        
            
            if(msrList.find(function(val) {
              return val.shortName == "mInstCount"
            })){
                if(msrList.length > 1) {
                   strSource = $rootScope.survey.source.combinedMsrs;
                } else {
                   strSource = $rootScope.survey.source.mInstCount; 
                }
            } else {
                strSource = $rootScope.survey.source.mAwrdsConfrd;
            }
        } else {
            strSource = $rootScope.survey.source;
        }
        return strSource;      
    }
    
    const getDefaultFontSize = () => {
        const element = document.createElement('div');
        element.style.width = '1rem';
        element.style.display = 'none';
        document.body.append(element);

        const widthMatch = window
            .getComputedStyle(element)
            .getPropertyValue('width')
            .match(/\d+/);

        element.remove();

        if (!widthMatch || widthMatch.length < 1) {
            return null;
        }

        const result = Number(widthMatch[0]);
        return !isNaN(result) ? result : null;
    }; 

    function cleanUrlParams(location) {
        Object.keys(location.search()).forEach(key => {
            if(!validParam(key)){
                location.search(key, null);               
            }
            if(!validParam(location.search()[key])){
                location.search(key, null);
                //location.search().tabledef = null;
            }            
        })

        function validParam(val) {
            const pattern = /[^\.a-zA-Z0-9_-]+/;
            
            if (pattern.test(val)) {
                return false;
            } else {
                return true;
            }
        }
    }

	function getParentDimensionByRecodeCid($rootScope, cId) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (currentItem.hierarchyAvailable == 'Y') {
						if (currentItem.recodeTrees != null) {
							for (var y = 0; y < currentItem.recodeTrees.length; y++) {
								if (currentItem.recodeTrees[y].cId == cId) {
									return currentItem;
								}
								if (currentItem.recodeTrees[y].dimensions != null) {
									for (var z = 0; z < currentItem.recodeTrees[y].dimensions.length; z++) {
										if (cId == currentItem.recodeTrees[y].dimensions[z].cId) {
											return currentItem;
										}
									}
								}
							}
						}
					} else if (currentItem.recodes != null) {
						for (var l = 0; l < currentItem.recodes.length; l++) {
							if (cId == currentItem.recodes[l].cId) {
								return currentItem;
							}
						}
					}
				}
			}
		}
		return {}
	};
	
	function isJSON(str) {
		try {
			return JSON.parse(str) && !!str;
		} catch (e) {
			return false;
		}
	}

	function toTitleCase(str) {
		return str.replace(
			/\w\S*/g,
			function (txt) {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		});
	}

	function parseXmlDomIntoJson(data) {
		const parser = new DOMParser();
		const htmlDoc = parser.parseFromString(data, 'text/html');
		let notice = {showNoticeFlag: false};

		let tagText = htmlDoc.getElementsByTagName('name');
		if(tagText != null && tagText.length > 0) {
			notice.name= tagText[0].innerHTM;
		}					
		
		tagText = htmlDoc.getElementsByTagName('showNoticeFlag');
		if(tagText != null && tagText.length > 0) {
			notice.showNoticeFlag = (tagText[0].innerHTML.trim() == 'true');
		}

		tagText = htmlDoc.getElementsByTagName('borderClass');
		if(tagText != null && tagText.length > 0) {
			notice.borderClass = tagText[0].innerHTML;
		}					

		tagText = htmlDoc.getElementsByTagName('bannerMsg');
		if(tagText != null && tagText.length > 0) {
			notice.bannerMsg = tagText[0].innerHTML;
		}

		tagText = htmlDoc.getElementsByTagName('showFullMsgFlag');
		if(tagText != null && tagText.length > 0) {
			notice.showFullMsgFlag = (tagText[0].innerHTML.trim() == 'true');
		}
		
		tagText = htmlDoc.getElementsByTagName('fullMsg');
		if(tagText != null && tagText.length > 0) {
			notice.fullMsg = tagText[0].innerHTML;
		}						
		return notice;
	}	

	return {
		getAppVariable: getAppVariable,
		setAppVariable: setAppVariable,
		getResource: getResource,
		getSurveyProperties: getSurveyProperties,
		getSurveyList: getSurveyList,
		getSurveyMetaFieldsFromApi: getSurveyMetaFieldsFromApi,
		getVariableMetaFieldsFromApi: getVariableMetaFieldsFromApi,
		exportSurveyDetailsFromApi: exportSurveyDetailsFromApi,
		exportVariableDetailsFromApi: exportVariableDetailsFromApi,
		getSurveyVariableListFromApi: getSurveyVariableListFromApi,
		getSurveyVariableDetailsFromApi: getSurveyVariableDetailsFromApi,
		exportVariableSummaryFromApi: exportVariableSummaryFromApi,
		getSurveyVariableValuesFromApi: getSurveyVariableValuesFromApi,
		getTypeaheadSuggestionsFromApi: getTypeaheadSuggestionsFromApi,
		getSuggestionVariableIdsFromApi: getSuggestionVariableIdsFromApi,
		getVariableCountsFromApi: getVariableCountsFromApi,
		replaceString: replaceString,
		removeQlikFormating: removeQlikFormating,
		showError: showError,
		setUpKeepAlive: setUpKeepAlive,
		compareValues: compareValues,
		compareNumerics: compareNumerics,
		search: search,
		findMatches: findMatches,
		findIndexList: findIndexList,
		removeDuplicates: removeDuplicates,
		findValuesMatches: findValuesMatches,
		findIndex: findIndex,
		initSpinner: initSpinner,
		getChartWidth: getChartWidth,
		randomCid: randomCid,
		replaceIllegalChars: replaceIllegalChars,
		getPredefinedTable: getPredefinedTable,
		loadJsonFile: loadJsonFile,
		getSurveySource: getSurveySource,
		getDefaultFontSize: getDefaultFontSize,
		cleanUrlParams: cleanUrlParams,
		getParentDimensionByRecodeCid: getParentDimensionByRecodeCid,
		isJSON: isJSON,
		toTitleCase: toTitleCase,
		parseXmlDomIntoJson: parseXmlDomIntoJson
	};

});

'use strict'

    function skipToMain() {
        var id = document.getElementsByClassName("expand-collapse-bar");
        if(id[0].classList.contains("ng-hide") == true)	{
            document.getElementById('left-rail-expand-btn').focus();
        } else {
            document.getElementById('left-rail-collapse').focus();
        }        
        
    }

define('scripts/directives/headerDirective',["scripts/shared/webProperties"], function (webProperties) {
	angular.module("appModule").directive("dtHeader", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtHeader.html',
		scope: true,
		transclude : false,
		controller: 'HeaderController'
	  };
	});

	angular.module("appModule").controller("HeaderController", ["$scope", "$location", "$rootScope", function ($scope, $location, $rootScope) {
		var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
		let keyEvent = null;
		$scope.lpUrl = webProperties.props.lpUrl
		$scope.meUrl = webProperties.props.meUrl

		$('.navbar-expand-custom').on('shown.bs.collapse', function() {
			if(keyEvent != null && keyEvent.keyCode == 13) {
				$("#dt-header .navbar-collapse.navmenu  .nav-item:first-child button").focus();
				keyEvent = null;
			}
		});

		$scope.clickLink = function(e, tag, url) {
		  	e.preventDefault();
			gtag('event', displayType + 'Link ' + tag, { 'event_label': 'link', 'event_category': tag.toLowerCase()});
			window.open(url, '_self');            
		}

		$scope.returnHome = function () {
			e.preventDefault();
			gtag('event', displayType + 'Link Landing Page', { 'event_label': 'open', 'event_category': 'landing_page'});
			window.open(webProperties.props.lpUrl, "_self");
		}
		$scope.exploreData = function () {
			e.preventDefault();
			gtag('event', displayType + 'Link Explorer', { 'event_label': 'open', 'event_category': 'explorer'});
			window.open(webProperties.props.meUrl, "_self");
		}

		$scope.trackLink = function(page) {
			//google analytics tracking
			gtag('event', displayType + 'Link ' + page, { 'event_label': 'link', 'event_category': 'pub'});
			window.open("https://ncses.nsf.gov/explore-data/microdata", "_blank")
		}

		$scope.expandHeaderMenu = function(e) {
			keyEvent = e;
		} 
		
		$scope.clickOpenFeedback = function(e) {
			gtag('event', displayType + 'Open Feedback', { 'event_label': 'open', 'event_category': 'feedback'});
			$rootScope.$broadcast('openFeedbackEvent');
		} 		
		
	}])
});



'use strict'
define('scripts/directives/footerDirective',[], function () {
	angular.module("appModule").directive("dtFooter", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtFooter.html',
		scope: true,
        transclude : false,
        controller: 'FooterController'
	  };
    });

	angular.module("appModule").controller("FooterController", ["$scope", "$rootScope",
	function ($scope, $rootScope) {
		var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
		$scope.clickOpenFeedback = function (tab) {
			//google analytics tracking
			gtag('event', displayType + 'Open Feedback', {
				'event_label': 'open',
				'event_category': 'feedback'
			});
			//$rootScope.$broadcast('openFeedbackEvent');
			// $scope.postSuccessful = false;
			// $scope.postHasErrors = false;

            if(tab) {
                $('#feedbackMenu a[href="#' + tab + '"]').tab('show');
                //$('#feedbackList '+ tab).tab('show')
            }
            $("#feedbackModal").modal();
        }
    }]);
});



'use strict'
define('scripts/directives/helpDirective',["scripts/shared/webProperties"], function (webProperties) {
	angular.module("appModule").directive("dtHelp", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtHelp.html',
		scope: true,
		controller: 'HelpController'
	  };
	});

	angular.module("appModule").controller("HelpController", ["$scope", "$location", "$rootScope", function ($scope, $location, $rootScope) {
		var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

		$scope.kbLink = function (path) {
			gtag('event', displayType + 'Help Knowledgebase', { 'event_label': 'link', 'event_category': 'knowledgebase'});
			let url = webProperties.props.kbUrl + path;
			window.open(url, "_blank");
		}
	}])
});

'use strict'
define('scripts/directives/releaseNotesDirective',["js/qlik", "scripts/shared/webProperties", "scripts/shared/appUtilities"], function (qlik, webProperties, appUtilities) {
	angular.module("appModule").directive("dtReleaseNotes", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtReleaseNotes.html',
		scope: true,
		controller: 'ReleaseNotesController'
	  };
	});

	angular.module("appModule").controller("ReleaseNotesController", ["$scope", "$location", "$rootScope", "$http",
		function ($scope, $location, $rootScope, $http) {
		var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
		$scope.webinarUrl = webProperties.props.webinarUrl;
		
		$scope.openWelcome = function (productType) {
			window.open(webProperties.props.webUrl + "welcome?type=chart", "_blank");
		}

		$scope.$on('openReleaseNotesEvent', function() {
			//$scope.test1 = 'hi'
			appUtilities.getResource(qlik, $http, 'notices/relNotes.xml').then(
				function (resp) {
					parseXmlDomIntoXML(resp.data) 
				}, function () {
					// $scope.surveyNotice = null;
				}
			)					
			setTimeout(function() {
				//document.getElementById('closebtn').focus();
				$("#btn-close-help-release").focus();
			}, 200);  			
		})


		function parseXmlDomIntoXML(data) {
			const parser = new DOMParser();
			const htmlDoc = parser.parseFromString(data, "text/html");

			// Each Release Note
			let tagText = '';
			$scope.releases = [];
			$scope.relNotes = {};
			let tmp = htmlDoc.getElementsByTagName('release')
			for (x = 0; x < tmp.length; x++) {
				let newRelease = {};
				let release = tmp[x];
				newRelease.version = release.querySelector('version').innerHTML;

				newRelease.date = release.querySelector('date').innerHTML;
				newRelease.type = release.querySelector('type').innerHTML;
				//newRelease.notes = $sce.trustAsHtml(release.querySelector('notes').innerHTML);	
				newRelease.notes = release.querySelector('notes').innerHTML.trim();					

				let splitNotes = newRelease.notes.split("\n");
				newRelease.notes = "";
				for(let i=0; i < splitNotes.length; i++) {
					newRelease.notes = newRelease.notes + splitNotes[i].trim() + "\n";
				}
				newRelease.notes = parseMarkup(newRelease.notes.trim());
				$scope.releases.push(newRelease);
			}
	
			tagText = htmlDoc.getElementsByTagName('currentVersion');
			if(tagText != null && tagText.length > 0) {
				$scope.relNotes.currentVersion = tagText[0].innerHTML;
			}


			tagText = htmlDoc.getElementsByTagName('knownIssuesFunctionality');
			if(tagText != null && tagText.length > 0) {
				$scope.relNotes.knownIssuesFunctionality = tagText[0].innerHTML.trim();
				let splitKnownIssueFunctionality = $scope.relNotes.knownIssuesFunctionality.split("\n");
				$scope.relNotes.knownIssuesFunctionality = "";
				for(let i=0; i < splitKnownIssueFunctionality.length; i++) {
					$scope.relNotes.knownIssuesFunctionality = $scope.relNotes.knownIssuesFunctionality + splitKnownIssueFunctionality[i].trim() + "\n";
				}
				$scope.relNotes.knownIssuesFunctionality = parseMarkup($scope.relNotes.knownIssuesFunctionality.trim());
			}

			tagText = htmlDoc.getElementsByTagName('knownIssuesData');
			if(tagText != null && tagText.length > 0) {
				$scope.relNotes.knownIssuesData = tagText[0].innerHTML.trim();
				let splitKnownIssueData = $scope.relNotes.knownIssuesData.split("\n");
				$scope.relNotes.knownIssuesData = "";
				for(let i=0; i < splitKnownIssueData.length; i++) {
				  $scope.relNotes.knownIssuesData = $scope.relNotes.knownIssuesData + splitKnownIssueData[i].trim() + "\n";
				}
				$scope.relNotes.knownIssuesData = parseMarkup($scope.relNotes.knownIssuesData.trim());
			}

			tagText = htmlDoc.getElementsByTagName('upcomingReleaseFeaturesFunctionality');
			if(tagText != null && tagText.length > 0) {
				$scope.relNotes.upcomingReleaseFeaturesFunctionality = tagText[0].innerHTML.trim();
				let splitUpcomingReleaseFeaturesFunctionality = $scope.relNotes.upcomingReleaseFeaturesFunctionality.split("\n");
				$scope.relNotes.upcomingReleaseFeaturesFunctionality = "";
				for(let i=0; i < splitUpcomingReleaseFeaturesFunctionality.length; i++) {
				  $scope.relNotes.upcomingReleaseFeaturesFunctionality = $scope.relNotes.upcomingReleaseFeaturesFunctionality + splitUpcomingReleaseFeaturesFunctionality[i].trim() + "\n";
				}
				$scope.relNotes.upcomingReleaseFeaturesFunctionality = parseMarkup($scope.relNotes.upcomingReleaseFeaturesFunctionality.trim());
			}

			tagText = htmlDoc.getElementsByTagName('upcomingReleaseFeaturesData');
			if(tagText != null && tagText.length > 0) {
				$scope.relNotes.upcomingReleaseFeaturesData = tagText[0].innerHTML.trim();
				let splitUpcomingReleaseFeaturesData = $scope.relNotes.upcomingReleaseFeaturesData.split("\n");
				$scope.relNotes.upcomingReleaseFeaturesData = "";
				for(let i=0; i < splitUpcomingReleaseFeaturesData.length; i++) {
				  $scope.relNotes.upcomingReleaseFeaturesData = $scope.relNotes.upcomingReleaseFeaturesData + splitUpcomingReleaseFeaturesData[i].trim() + "\n";
				}
				$scope.relNotes.upcomingReleaseFeaturesData = parseMarkup($scope.relNotes.upcomingReleaseFeaturesData.trim());
			}

			tagText = htmlDoc.getElementsByTagName('upcomingReleaseFeaturesMaintenance');
			if(tagText != null && tagText.length > 0) {
				$scope.relNotes.upcomingReleaseFeaturesMaintenance = tagText[0].innerHTML.trim();
				let splitUpcomingReleaseFeaturesMaintenancea = $scope.relNotes.upcomingReleaseFeaturesMaintenance.split("\n");
				$scope.relNotes.upcomingReleaseFeaturesMaintenance = "";
				for(let i=0; i < splitUpcomingReleaseFeaturesMaintenancea.length; i++) {
				$scope.relNotes.upcomingReleaseFeaturesMaintenance = $scope.relNotes.upcomingReleaseFeaturesMaintenance + splitUpcomingReleaseFeaturesMaintenancea[i].trim() + "\n";
				}
				$scope.relNotes.upcomingReleaseFeaturesMaintenance = parseMarkup($scope.relNotes.upcomingReleaseFeaturesMaintenance.trim());
			}
			
		}

		function parseMarkup(field) {
			field = marked.parse(field);
			return field;
		}		
	}])
});



'use strict'
define('scripts/directives/helpReleaseDirective',["js/qlik", "scripts/shared/appUtilities"],
function (qlik, appUtilities) {
	angular.module("appModule").directive("dtHelpRelease", function() {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtHelpRelease.html',
            scope: true,
			controller: ("helpReleaseCtrl", ["$scope", "$rootScope", "$timeout", "$http", function($scope, $rootScope, $timeout, $http) {

                $scope.helpReleaseDisplay = false;
                var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';			
				
				function helpPanelEventListener(e){
					if(e.target.textContent == 'Help' || e.target.textContent == 'Help Panel') {
						null;
					} else if (!document.getElementById('helpReleaseSideNav').contains(e.target)){
						//clicked outside left rail
						//console.log(e.target);
						$scope.helpReleaseDisplay = false;
						document.removeEventListener('click', helpPanelEventListener);
						var phase = $rootScope.$$phase;
						if (phase !== '$apply' && phase !== '$digest') {
							//console.log('invoking apply()')
							$scope.$apply();
						}
					}
				}					
				

                $scope.clickCloseHelpRelease = function() {
					$scope.helpReleaseDisplay = false;
                }


                $scope.clickOpenHelpRelease = function() {
                    //google analytics tracking
                    gtag('event',  displayType + 'Help-Release Notes', { 'event_label': 'open', 'event_category': 'help_release'});
                    $scope.helpReleaseDisplay = true;
					document.addEventListener('click', helpPanelEventListener);	
					//console.log('clickOpenHelpRelease');
					
					$scope.$broadcast('openReleaseNotesEvent');       
                }

                $scope.crossClick = function(){
                    $scope.clickCloseHelpRelease();
                }

				let section = "";
                $scope.$on('openHelpEvent', function(e, item) {
                    $scope.clickOpenHelpRelease(); 
					if(item != null) {
						section = item
						$timeout(scrollSection, 200);
					}      
                });

                function scrollSection() {
					let elem = document.getElementById(section);
					if(elem != null)
						elem.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                }
			}])
		};
	});
});
'use strict'
define('scripts/directives/resizeDirective',["scripts/appModule"], function (appModule) {
	/** verticle resize **/
	angular.module("appModule").directive('dtResize', ['$window', '$timeout', function ($window, $timeout) {
		return {
			scope: true,
			link: function(scope, elem, attrs) {		
				var w = angular.element($window);
				scope.$watch(function () {
					return {
						'h': w.height()
					};
				}, function (newValue, oldValue) {
					var getPos = function (el) {
						for (var lx=0, ly=0, tmp='';
							 el != null;
							 lx += el.offsetLeft, ly += el.offsetTop, tmp=el, el = el.offsetParent)
							 //{console.log('el',el);}
						return {x: lx,y: ly};
					}; 
									
					scope.resizeHeightWithOffset = function (offsetH) {
						var elementTopPos = getPos(elem[0]).y;
						offsetH = offsetH + elementTopPos; 
						scope.$eval(attrs.notifier);
						return { 
							'height': (newValue.h - offsetH) + 'px',
							'width': newValue.w  + 'px'
						};						
						
					};	

					scope.test = function() {
						alert('test');
					};
				}, true); 
				w.bind('resize', function () {
					scope.resizeHeightWithOffset();
					scope.$apply();
				});			
			}
		}
	}]);
});
'use strict'
define('scripts/shared/measures',["qlik", "scripts/shared/webProperties", "scripts/shared/appUtilities"], function (qlik, webProperties, appUtilities) {
	const PercentageType = {
	  COLUMN: 'column',
	  ROW: 'row',
	  ANNUAL: 'annual'
	};
	
	function getMeasuresFromQlik(qApp) {
		return new qlik.Promise(function (resolve, reject) {
			qApp.createGenericObject({
				qInfo: {
					qType: "MeasureList"
				},
				qMeasureListDef: {
					qType: "measure",
					qData: {
						qMeasure: "/qMeasure"
					}
				}
			}).then(function (resp) {
				return resolve(resp);
			}, function (err) {
				console.log('qlik engine API dimensions failed:', err);
				return reject('qlik engine API dimensions failed');
			})
		});
	}

	var getMeasuresFromWeb = function ($http, $q, abbr) {
		var deferred = $q.defer();
		$http.get(webProperties.props.webUrl + 'content/json/' + abbr.toLowerCase() + '_measures.json')
		.then(function (res) {
			if (res.data != null) {
				deferred.resolve(res);
			} else {
				deferred.reject('measures failed');
			}
		}, function (err) {
			console.log('Web measures retrieval failed', err)
			//deferred.reject("Web measures retrieval failed");
			deferred.resolve();  //it is not an error if web measures not found
		});
		return deferred.promise;
	}

	var getMeasuresFromApi = function ($http, $q, abbr) {
		var deferred = $q.defer();
		$http.get(webProperties.props.metadataApiUrl + 'metadata/surveys/' + abbr + '/measures?key=header.payload.signature', {
			withCredentials: false
		}).then(function (response) {
			//console.log('survey', $rootScope.survey.properties);
			if (response == null || response.data == null || response.data.body == null) {
				console.log("Metadata API measures returned no data");
				deferred.reject('Metadata API measures returned no data');
			} else {
				deferred.resolve(response);
			}
		}, function (error) {
			console.log("Metadata API measures failed:", error);
			deferred.reject('Metadata API measures failed');
		});
		return deferred.promise;
	};

	// This function will remove a measure from the Pivot Table
	function removeMeasure(qApp, $rootScope, item) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {
			qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getProperties().then(function (props) {

					var remove_index = -1;
					props.qHyperCubeDef.qMeasures.forEach(function (qMeasure, index) {
						if (qMeasure.qLibraryId == item.qId) {
							remove_index = index;
						}
					});
					if (remove_index != -1) {
						removeMeasureFromPivot($rootScope, props, remove_index);
						if (props.qHyperCubeDef.qMeasures.length == 0) {
							var dummy = {
								qDef: {
									qDef: "=Count(1)",
									qLabel: "placeHolder",
                                    cId: "placeholder"
								}
							};
							props.qHyperCubeDef.qMeasures.push(dummy);
						}
					} else if ($rootScope.displayVisType != 'pivot-table') {
						props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qMeasures.forEach(function (qMeasure, index) {
							if (qMeasure.qLibraryId == item.qId) {
								remove_index = index;
							} else if (qMeasure.qDef.qFieldDefs[0] == item.title) {
								remove_index = index;
							}
						});
						if (remove_index != -1) {
							props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qMeasures.splice(remove_index, 1);
						}
					}

					if (remove_index != -1) {
						obj.setProperties(props).then(function (properties_set) {
							if (item.unit == "DOLLARS") {
								$rootScope.selectedAmountCount -= 1;
							}
							return resolve();
						}, function (err) {
							console.log("error", err);
							return reject(err);
						});
					} else {
						return resolve();
					}
				});
			});
		});
	}

	function defineMeasure($rootScope, item, props) {
		var eligible_to_add = eligibleMsrToAdd(props.qHyperCubeDef.qMeasures, item.qDef);
		if (eligible_to_add) {
			var new_measure = newMeasureFromLibrary(item);
			if (item.unit == "DOLLARS") {
				$rootScope.selectedAmountCount += 1;
			}
			updateLayoutProps($rootScope.displayVisType, props, new_measure, null);
		} else {
			console.log("Measure not eligible to add");
		}
	};
	
	function definePercentageMeasure($rootScope, index, item, props) {
		var new_measure = newMeasureFromLibrary(item);
		new_measure.qDef.qNumFormat.qType = "R";
		new_measure.qDef.qNumFormat.qFmt = "#.##%";
		updateLayoutProps($rootScope.displayVisType, props, new_measure, index);
	};

	// Verify if the measure is ok to add (mostly is it there already)
	function eligibleMsrToAdd(qMeasures, def) {
		var elibible_to_add = true;

		qMeasures.forEach(function (measure) {
			if (measure.qDef == def)
				elibible_to_add = false;
		});

		return elibible_to_add;
	}

	// Create new object properties that include the new measure
	function newMeasureFromLibrary(selected_measure) {
		var new_measure = {
			//"qLibraryId": "update_here",
			"qDef": {
				"qDef": selected_measure.def,
				"qLabel": selected_measure.variableName != null ? selected_measure.variableName : selected_measure.title,
				"qTags": [],
				"qGrouping": "N",
				"qNumFormat": {
					"qType": "F",
					"qnDec": 2,
					"qUseThou": 0,
					"qThou": ",",
					"qDec": ".",
					"qFmt": "#,##0"
					//"qFmt": "#,##0.000"
				},
				"qAggrFunc": "Expr",
				"qAccumulate": 0,
				"qActiveExpression": 0,
				"qExpressions": [],
				"autoSort": true,
				"cId": selected_measure.cId,
				"numFormatFromTemplate": true,
/*				"textAlign": {
					"auto": true,
					"align": "left"
				} */
			},
			"qAttributeExpressions": [],
			"qAttributeDimensions": [],
			"qCalcCond": {}
		}

		//new_measure.qLibraryId = selected_measure.qId;
		//new_measure.qDef.cId = randomCidMsr();

		return new_measure;
	}

	function updateLayoutProps(displayVisType, props, new_measure, index) {
		if(index == null) {
			props.qHyperCubeDef.qMeasures.push(new_measure);
		} else {
			props.qHyperCubeDef.qMeasures.splice(index, 0, new_measure);
		}
		if (displayVisType == 'pivot-table') {
			let i = props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1);			
			if (props.qHyperCubeDef.qMeasures.length > 1 && i == -1) {
				props.qHyperCubeDef.qInterColumnSortOrder.push(-1);
			}
		}
	}

	// Removes the measure
	var removeMeasureFromPivot = function ($rootScope, props, remove_index) {
		var orgInterColumnSortOrder = angular.copy(props.qHyperCubeDef.qInterColumnSortOrder);
		var orgNoLeftDims = angular.copy(props.qHyperCubeDef.qNoOfLeftDims);
		var qMeasures = props.qHyperCubeDef.qMeasures;

		if (remove_index != -1) {
			qMeasures.splice(remove_index, 1);
		}

		// remove the -1 from the sort order if only one measure is left.
		if (qMeasures.length == 1) {
			var pos = orgInterColumnSortOrder.indexOf(-1);
			if (pos > -1) {
				orgInterColumnSortOrder.splice(pos, 1);

				//reduce the number of left dims, if measures was in the left columns
				if (pos < orgNoLeftDims) {
					orgNoLeftDims--;
				}
			}
		}
		//reset sort order and no of left just incase soft patches were cleared
		if ($rootScope.displayVisType == 'pivot-table') {
			props.qHyperCubeDef.qInterColumnSortOrder = orgInterColumnSortOrder;
			props.qHyperCubeDef.qNoOfLeftDims = orgNoLeftDims;
		} else {
			props.qHyperCubeDef.qInterColumnSortOrder = [];
			props.qHyperCubeDef.qNoOfLeftDims = -1;
		}

		props.qHyperCubeDef.qMeasures = qMeasures;

		return props;

	}

	// Random cId generator for Measures - used for adds
	function randomCidMsr() {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (var i = 0; i < 7; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	}

	function hasMeasureGroupNameWithVariableIdChecked($rootScope, topicName, groupName, variableId) {
		//console.log(' apiMeasureTopic: ', $rootScope.measureProperties.apiMeasureTopics)
		for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
			var measureTopic = $rootScope.measureProperties.apiMeasureTopics[i];
			for (var j = 0; j < $rootScope.measureProperties.apiMeasureTopics[i].measureGroups.length; j++) {
				var measureGroup = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j];
				for (var k = 0; k < measureGroup.measures.length; k++) {
					var measure = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j].measures[k];
					if (measureTopic.topicName != topicName && measureGroup.groupName == groupName && measure.variableId == variableId) {
						if (measure.checked == true) {
							return true;
						} else {
							return false;
						}
					}
				}
			}
		}
		return false;
	}

	function getMeasureById($rootScope, id) {
		for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
			for (var j = 0; j < $rootScope.measureProperties.apiMeasureTopics[i].measureGroups.length; j++) {
				for (var k = 0; k < $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j].measures.length; k++) {
					var currentItem = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j].measures[k];
					if (id == currentItem.qId) {
						return currentItem;
					}
				}
			}
		}
		return {};
	};

	function getMeasureGroupNameByVariableId($rootScope, varId) {
		for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
			for (var j = 0; j < $rootScope.measureProperties.apiMeasureTopics[i].measureGroups.length; j++) {
				var measureGroup = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j];
				for (var k = 0; k < measureGroup.measures.length; k++) {
					var currentItem = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j].measures[k];
					if (varId == currentItem.variableId) {
						return measureGroup.groupName;
					}
				}
			}
		}
		return {};
	};

	function getMeasureByCid($rootScope, cid) {
		for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
			for (var j = 0; j < $rootScope.measureProperties.apiMeasureTopics[i].measureGroups.length; j++) {
				for (var k = 0; k < $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j].measures.length; k++) {
					var currentItem = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j].measures[k];
					if (cid == currentItem.cId) {
						return currentItem;
					}
				}
			}
		}
		return {};
	};

	function getMeasureSelected($rootScope) {
		let msrs = [];
		for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
			for (var j = 0; j < $rootScope.measureProperties.apiMeasureTopics[i].measureGroups.length; j++) {
				for (var k = 0; k < $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j].measures.length; k++) {
					var currentItem = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups[j].measures[k];
					if (currentItem.selected) {
						msrs.push(currentItem);
					}
				}
			}
		}
		return msrs;
	};	
	
	function applyPercentages($rootScope, props) {

		//remove existing percentage measdures before re-applying any updated percentage measures
		props.qHyperCubeDef.qMeasures.forEach(function (msr, index) {
			if (msr.qDef.cId.startsWith("percent")) {
				props.qHyperCubeDef.qMeasures.splice(index, 1);
			}
		})
						
		
		if($rootScope.displayTablePercentageType == null) {
			//remove pseudo dim (-1) from order if now only one measure		
			if(props.qHyperCubeDef.qMeasures.length == 1 && props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1) > -1) {
				if(props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1) < props.qHyperCubeDef.qNoOfLeftDims) {
					props.qHyperCubeDef.qNoOfLeftDims--;
				}
				props.qHyperCubeDef.qInterColumnSortOrder.splice(props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1), 1);
			}
		} else {
			for(let n = 0; n < props.qHyperCubeDef.qMeasures.length; n++) {
				let msr = props.qHyperCubeDef.qMeasures[n]
				let msrPct = {};
				msrPct.cId = "percent" + appUtilities.randomCid();
				let pct = getMeasureByCid($rootScope, msr.qDef.cId);
				msrPct.def = pct.percentDef;
				
				if($rootScope.displayTablePercentageType == PercentageType.COLUMN) {					
					//example % by col - totals by year and those fields in columns
					//=Sum(WTSURVY)/sum(TOTAL <REFYR, GENDER, CTZN> WTSURVY)
					//where gender, ctzn are placed in cols; and total by year regardless of placement
					//and n2OCPRMG and N2OCPRNG are in rows
					let totalsByFields = "<" + $rootScope.survey.dimToLock;
					for(let x = props.qHyperCubeDef.qNoOfLeftDims; x < props.qHyperCubeDef.qDimensions.length; x++) {
						let dim = props.qHyperCubeDef.qDimensions[x];

						if(dim.qDef.qFieldDefs[0] !== $rootScope.survey.dimToLock) {
                            if(dim.qDef.cId.startsWith("recode")) {
                                let parent = appUtilities.getParentDimensionByRecodeCid($rootScope, dim.qDef.cId);
                                totalsByFields += ", " + parent.def;
                            } else {
                                totalsByFields += ", " + dim.qDef.qFieldDefs[0];
                            }
						} 
					}
					totalsByFields += ">";
					msrPct.def = msrPct.def.replace("<GROUP>", totalsByFields);
					msrPct.title = "% of Column Total"
					
					definePercentageMeasure($rootScope, ++n, msrPct, props);			
				} else if($rootScope.displayTablePercentageType == PercentageType.ROW) {
					//example % by row - totals by year and those fields in rows
					//=Sum(WTSURVY)/sum(TOTAL <REFYR, N2OCPRMG, N2OCPRNG> WTSURVY)
					//where N2OCPRMG, N2OCPRNG are placed in rows; and total by year regardless of placement
					//and n2OCPRMG and N2OCPRNG are in cols
					let totalsByFields = "<" + $rootScope.survey.dimToLock;
					for(let x = 0; x < props.qHyperCubeDef.qNoOfLeftDims; x++) {
						let dim = props.qHyperCubeDef.qDimensions[x];
						if(dim.qDef.qFieldDefs[0] !== $rootScope.survey.dimToLock) {
                            if(dim.qDef.cId.startsWith("recode")) {
                                let parent = appUtilities.getParentDimensionByRecodeCid($rootScope, dim.qDef.cId);
                                totalsByFields += ", " + parent.def;
                            } else {
                                totalsByFields += ", " + dim.qDef.qFieldDefs[0];
                            }
						} 					
					}
					totalsByFields += ">";
					msrPct.def = msrPct.def.replace("<GROUP>", totalsByFields);
					msrPct.title = "% of Row Total"
					
					definePercentageMeasure($rootScope, ++n, msrPct, props);
				} else if($rootScope.displayTablePercentageType == PercentageType.ANNUAL) {
					//example % by Annual
					//=Sum(WTSURVY)/sum(TOTAL <REFYR> WTSURVY)
					//where fer, gender, ctzn are placed in cols
					//and n2OCPRMG and N2OCPRNG are in rows
					let totalsByFields = "<" + $rootScope.survey.dimToLock + ">";
					msrPct.def = msrPct.def.replace("<GROUP>", totalsByFields);
					msrPct.title = "% of Annual Total"
					
					definePercentageMeasure($rootScope, ++n, msrPct, props);
				}
			}
		}	
	
	}

	return {
		PercentageType: PercentageType,
		getApiMeasures: getMeasuresFromApi,
		getQlikMeasures: getMeasuresFromQlik,
		getWebMeasures: getMeasuresFromWeb,
		getMeasureById: getMeasureById,
		getMeasureByCid: getMeasureByCid,
		defineMeasure: defineMeasure,
		getMeasureGroupNameByVariableId: getMeasureGroupNameByVariableId,
		hasMeasureGroupNameWithVariableIdChecked: hasMeasureGroupNameWithVariableIdChecked,
		getMeasureSelected: getMeasureSelected,
		applyPercentages: applyPercentages
	}
});

'use strict'
define('scripts/shared/dimensions',["qlik", "scripts/shared/webProperties", "scripts/shared/measures"], function (qlik, webProperties, measures) {

	function getDimensionsFromQlik(qApp) {
		return new qlik.Promise(function (resolve, reject) {

			qApp.createGenericObject({
				qInfo: {
					qType: "DimensionList"
				},
				qDimensionListDef: {
					qType: "dimension",
					qData: {
						qDimension: "/qDim"
					}
				}
			}).then(function (resp) {	
				if (resp.layout != null) {
					return resolve(resp);
				} else {
					console.log('Qlik engine API dimensions returned no data');
					return reject('Qlik engine API dimensions returned no data');
				}
			}, function (err) {
				console.log('Qlik engine API dimensions returned error', err);
				return reject('Qlik engine API dimensions returned error');
			})
		})
	}

	//Live method
	var getDimensionsFromApi = function ($http, $q, abbr) {
		var deferred = $q.defer();
		$http.get(webProperties.props.metadataApiUrl + 'metadata/surveys/' + abbr + '/dimensions?key=header.payload.signature', {
			withCredentials: false
		}).then(function (response) {
			//console.log('survey', $rootScope.survey.properties);
			if (response == null || response.data == null || response.data.body == null) {
				console.log('Metadata API dimensions returned no data');
				deferred.reject('Metadata API dimensions returned no data');
			} else {
				deferred.resolve(response);
			}
		}, function (error) {
			console.log("Metadata API dimensions failed:", error);
			deferred.reject('Metadata API dimensions failed');
		});
		return deferred.promise;
	};

	//  API call for filter Modal
	var getSubFiltersFromApi = function ($http, $q, id) {
		var deferred = $q.defer();
		$http.get(webProperties.props.metadataApiUrl + 'metadata/variables/' + id.toString() + '/filterAssociations?key=header.payload.signature', {
			withCredentials: false
		}).then(function (response) {
			//console.log('survey', $rootScope.survey.properties);
			if (response.data.body == null) {
				console.log('Metadata API Variable Filter Associations returned no data');
				deferred.reject('Metadata API Variable Filter Associations returned no data');
			} else {
				deferred.resolve(response);
			}
		}, function (error) {
			console.log("Metadata API Variable Filter Associations failed:", error);
			deferred.reject('Metadata API Variable Filter Associations failed');
		});
		return deferred.promise;
	};

	// This function will add a dimension to the visualization if it is not already present (eligible to add)
	function addDimension(qApp, $rootScope, item, addToCol, suppressNull) {
		return new qlik.Promise(function (resolve, reject) {
			var eligible_to_add = false;
			qApp.getObject($rootScope.visObjId).then(function (obj) {
				//getEffectiveProperties - same results as getProps, once alt dim is selected, new dims added afterwards are not showing in chart drop-down
				obj.getEffectiveProperties().then(function (props) {
					if(defineDimension($rootScope, item, props, addToCol, suppressNull)) {

						//if percentages have already been applied, may need to upodate the percent definition based on new dimension 
						if ($rootScope.displayVisType == "pivot-table") {
							measures.applyPercentages($rootScope, props);
						}
						obj.setProperties(props).then(function () {
							return resolve(item);
						}, function (err) {
							console.log("error", err);
							return reject(err);
						});
					} else {
						return resolve(item);
					}
				});
			});
		});
	};

	// This function will remove a dimension from the Pivot Table
	function removeDimension(qApp, $rootScope, chart, item) {
		return new qlik.Promise(function (resolve, reject) {
			qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getEffectiveProperties().then(function (props) {
					var remove_index = -1;
					var found = false;

					if ($rootScope.displayVisType == "pivot-table") {
						props.qHyperCubeDef.qDimensions.forEach(function (qDimension, index) {
							if (qDimension.qDef.cId == item.cId) {
								remove_index = index;
								found = true;
							}
						});
						if (remove_index != -1) {
							removeDimensionFromPivot($rootScope, props, remove_index);
						}
					} else {
						props.qHyperCubeDef.qDimensions.forEach(function (qDimension, index) {
							if (qDimension.qDef.cId == item.cId) {
								found = true;
								props.qHyperCubeDef.qDimensions.splice(index, 1);

								//Check if an alternate dim exist and should be moved to hypercube
								//Do this when an alternate dim is defined and there is an available spot in the main hypercube
								if (props.qHyperCubeDef.qDimensions.length < 2 && props.qHyperCubeDef.qLayoutExclude
									 && props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length > 0) {
									for (var x = 0; x < props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length; x++) {
										props.qHyperCubeDef.qDimensions.push(props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions[x]);
										props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.splice([x], 1);
										break;
									}
								}
							}
						});

						if (!found && props.qHyperCubeDef.qLayoutExclude && props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length > 0) {
							props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.forEach(function (qDimension, index) {
								if (qDimension.qDef.cId == item.cId) {
									found = true;
									props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.splice(index, 1);
								}
							});
						}
						props.qHyperCubeDef.qInterColumnSortOrder = [];
						setChartProperties($rootScope.displayVisType, props, chart);
					}

					if (found) {
						obj.setProperties(props).then(function (properties_set) {
							return resolve();
						}, function (err) {
							console.log('retry props update');
							obj.setProperties(props).then(function (properties_set) {
								return resolve();
							}, function (err) {
								console.log("error", err);
								return reject(err);
							});							
						});
					} else {
						return resolve();
					}
				})
			});
		});
	}

	function removeTreeDimension(qApp, $rootScope, $scope, items) {
		return new qlik.Promise(function (resolve, reject) {
			qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getProperties().then(function (props) {
					var removeIndxs = [];
					var found = false;
					for (var i = 0; i < props.qHyperCubeDef.qDimensions.length; i++) {
						var qDimension = props.qHyperCubeDef.qDimensions[i];
						for (var x = 0; x < items.length; x++) {
							if (qDimension.qDef.cId == items[x].cId) {
								removeIndxs.push(i);
								found = true;
							}
						}
					};
					if (props.qHyperCubeDef.qLayoutExclude
						 && props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length > 0) {
						for (var i = props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length - 1; i >= 0; i--) {
							var qDimension = props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions[i];
							for (var x = 0; x < items.length; x++) {
								if (qDimension.qDef.cId == items[x].cId) {
									found = true;
									props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.splice(i, 1);
								}
							}
						};
					}
					if (found) {
						if ($rootScope.displayVisType == "pivot-table") {
							for (var x = removeIndxs.length - 1; x >= 0; x--) {
								removeDimensionFromPivot($rootScope, props, removeIndxs[x]);
							}
						} else {
							props.qHyperCubeDef.qInterColumnSortOrder = [];
							for (var x = removeIndxs.length - 1; x >= 0; x--) {
								props.qHyperCubeDef.qDimensions.splice(removeIndxs[x], 1);
								//removeDimensionFromPivot($rootScope, props, removeIndxs[x]);
							}
							setChartProperties($rootScope.displayVisType, props, $rootScope.chart);
						}
						obj.setProperties(props).then(function () {
							return resolve();
						}, function (err) {
							console.log('retry props update');
							obj.setProperties(props).then(function () {
								return resolve();
							}, function (err) {
								console.log("error", err);
								return reject(err);
							});
						});
					} else {
						return resolve();
					}
				})
			});
		});
	}

	function defineDimension($rootScope, item, props, addToCol, suppressNull) {
		var eligible_to_add = eligibleDimToAdd(props.qHyperCubeDef.qDimensions, item);
		if (eligible_to_add) {
			//Default sort order should be set to 0 in dimension.json
			var code = '';
			var sortDir = getSortDefault(item.valueSortDefault);
			var new_dimension = newDimensionFromLibrary(item, sortDir);
			if (suppressNull)
				new_dimension.qNullSuppression = true;
			else
				new_dimension.qNullSuppression = false;			
			updateLayoutProps($rootScope, props, new_dimension, item.shortName, addToCol, $rootScope.chart);
			if ($rootScope.displayVisType == "pivot-table") {
				applyTotalsProperties($rootScope, props);
			}
			//if percentages hjave already been applied, may need to upodate the percent definition based on new dimension 
			//measures.applyPercentages($rootScope, $scope, props);
			return true;
		} else {
			console.log("dimension not eligible to add");
			return false;
		}
	};

	function getSortDefault(val) {
		switch (val) {
		case 'DESC':
			return -1;
			break;
		case 'ASC':
			return 1
			break;
		default:
			return 0;
		}
	}

	// Check if dimension is eligible to add (mostly is it already there)
	var eligibleDimToAdd = function (qDimensions, new_dimension) {
		var eligible_to_add = true;
		qDimensions.forEach(function (qDimension) {
			if (qDimension.qDef.cId == new_dimension.cId)
				eligible_to_add = false;
		});
		return eligible_to_add;
	};

	// Removes the dimension
	var removeDimensionFromPivot = function ($rootScope, props, dimIdx) {
		if (dimIdx > -1) {
			props.qHyperCubeDef.qDimensions.splice(dimIdx, 1);

			var dimSortIdx = props.qHyperCubeDef.qInterColumnSortOrder.indexOf(dimIdx);
			var meaIdx = props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1);

			if (meaIdx > -1) {
				props.qHyperCubeDef.qInterColumnSortOrder.splice(meaIdx, 1);
				props.qHyperCubeDef.qInterColumnSortOrder.pop();
				if (dimIdx < meaIdx) {
					props.qHyperCubeDef.qInterColumnSortOrder.splice(meaIdx - 1, 0, -1);
				} else {
					props.qHyperCubeDef.qInterColumnSortOrder.splice(meaIdx, 0, -1);
				}
			} else {
				props.qHyperCubeDef.qInterColumnSortOrder.pop();
			}

			if (dimSortIdx < props.qHyperCubeDef.qNoOfLeftDims) {
				props.qHyperCubeDef.qNoOfLeftDims--;
			}            

			//Toggle Totals on/off based on toggle switch and placement of variables, redefine percent msr based on dims selected
			applyTotalsProperties($rootScope, props);
            //adding/removing dimensions will impact applied percentages
			measures.applyPercentages($rootScope, props);	
		}
		return;
	};

	// Prepares the new dimension to add based on a template for a library dimension
	var newDimensionFromLibrary = function (dim, sortDirection) {
		//dim.recodeDef = "=aggr(if(Match([instState], 'Washington','West Virginia','Wisconsin','Wyoming'), 'AW cat', if(Match([instState], 'Alabama','Alaska','Arizona'), 'WA', if(Match([instState], 'Illinois','Indiana','Iowa'), 'GI cat', [instState]))), [instState])";
		//console.log(dim.recodeDef);
		var new_dimension = {
			"qDef": {
				"cId": dim.cId,
				"qGrouping": "N",
				"qFieldLabels": [dim.recodeName != null ? dim.recodeName : dim.title],
				"qFieldDefs": [dim.recodeDef != null && dim.recodeDef.length > 0 ? dim.recodeDef : dim.def],
				"autoSort": false,
				"qSortCriterias": [
						{
							"qSortByState": 0,
							"qSortByFrequency": 0,
							"qSortByNumeric": 0,
							"qSortByAscii": 0,
							"qSortByLoadOrder": 0,
							"qSortByExpression": 0,
							"qExpression": {
								"qv": "", //dim.recodeDef
							},
							"qSortByGreyness": 0
						}
					]
			}
    };
		if(sortDirection == 0) {
			new_dimension.qDef.qSortCriterias[0].qSortByLoadOrder = 1;
		} else {
			new_dimension.qDef.qSortCriterias[0].qSortByAscii = sortDirection;
		}
		return new_dimension;
	};

	function updateLayoutProps($rootScope, obj_properties, new_dimension, shortName, addToCol, chart) {
        if ($rootScope.displayVisType == 'pivot-table') {
			if (obj_properties.qHyperCubeDef.qNoOfLeftDims == -1) {
				obj_properties.qHyperCubeDef.qInterColumnSortOrder = [0];
				//Default Year to columns section
				if (shortName != null && shortName.toLowerCase() == "year"
					 || shortName != null && shortName.toLowerCase() == "refyr") {
					obj_properties.qHyperCubeDef.qNoOfLeftDims = 0;
                } else {
					obj_properties.qHyperCubeDef.qNoOfLeftDims = 1;
                }
				obj_properties.qHyperCubeDef.qDimensions.push(new_dimension);
			} else {
				var mIdx = obj_properties.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1);
				if (mIdx > -1) {
					//2 or more measures are selected
					if (mIdx < obj_properties.qHyperCubeDef.qNoOfLeftDims) {
						//Measures Values is in Rows
						if (addToCol == true) {
							obj_properties.qHyperCubeDef.qDimensions.push(new_dimension);
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.push(obj_properties.qHyperCubeDef.qDimensions.length - 1);
							if (obj_properties.qHyperCubeDef.qSortbyYValue) {
								delete obj_properties.qHyperCubeDef.qSortbyYValue;
							}
						} else {
							obj_properties.qHyperCubeDef.qDimensions.splice(obj_properties.qHyperCubeDef.qNoOfLeftDims - 1, 0, new_dimension);
							obj_properties.qHyperCubeDef.qNoOfLeftDims++;
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.push(obj_properties.qHyperCubeDef.qDimensions.length - 1);
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.splice(mIdx, 1);
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.splice(mIdx + 1, 0, -1);
						}
					} else {
						//Measures Values is in Cols
						if (addToCol == true) {
							obj_properties.qHyperCubeDef.qDimensions.push(new_dimension);
							//Ensure multiple measures button is placed last when adding a new dim
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.splice(mIdx,1);
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.push(obj_properties.qHyperCubeDef.qDimensions.length - 1);
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.push(-1);
							if (obj_properties.qHyperCubeDef.qSortbyYValue) {
								delete obj_properties.qHyperCubeDef.qSortbyYValue;
							}
						} else {
							obj_properties.qHyperCubeDef.qDimensions.splice(obj_properties.qHyperCubeDef.qNoOfLeftDims, 0, new_dimension);
							obj_properties.qHyperCubeDef.qNoOfLeftDims++;

							obj_properties.qHyperCubeDef.qInterColumnSortOrder.splice(mIdx, 1);
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.push(obj_properties.qHyperCubeDef.qDimensions.length - 1);
							obj_properties.qHyperCubeDef.qInterColumnSortOrder.push(-1);
						}
					}
				} else {

					//By default all dims are added to rows, so if AddToColoumn flag set then do not update qNoOfLeftDims
					if (addToCol == true) {
						obj_properties.qHyperCubeDef.qDimensions.push(new_dimension);
						if (obj_properties.qHyperCubeDef.qSortbyYValue) {
							delete obj_properties.qHyperCubeDef.qSortbyYValue;
						}
					} else {
						obj_properties.qHyperCubeDef.qDimensions.splice(obj_properties.qHyperCubeDef.qNoOfLeftDims, 0, new_dimension);
						obj_properties.qHyperCubeDef.qNoOfLeftDims++;
					}
					obj_properties.qHyperCubeDef.qInterColumnSortOrder.push(obj_properties.qHyperCubeDef.qDimensions.length - 1);
				}       				
			}
		} else {

			//Charts can only have 2 dims, if adding more than 2 then chart will not render
			//solution is to add dim as an alternate dim to the qLayoutExclude object
			if (obj_properties.qHyperCubeDef.qDimensions.length < 2) {
				obj_properties.qHyperCubeDef.qDimensions.push(new_dimension);
				obj_properties.qHyperCubeDef.qInterColumnSortOrder = [];
				for(let x=0; x< (obj_properties.qHyperCubeDef.qDimensions.length);x++) {
					obj_properties.qHyperCubeDef.qInterColumnSortOrder.push(x);
				}
			} else {
				if (obj_properties.qHyperCubeDef.qLayoutExclude == null)
					obj_properties.qHyperCubeDef.qLayoutExclude = {};
				if (obj_properties.qHyperCubeDef.qLayoutExclude.qHyperCubeDef == null)
					obj_properties.qHyperCubeDef.qLayoutExclude.qHyperCubeDef = {};
				if (obj_properties.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions == null)
					obj_properties.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions = [];
				obj_properties.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.push(new_dimension);
			}
			setChartProperties($rootScope.displayVisType, obj_properties, chart);
		}
	}

	function setChartProperties(type, props, chart) {
		props.barGrouping = {};
		if (props.qHyperCubeDef.qDimensions.length > 1) {		
			props.color.auto = true;
			props.color.mode = "primary";
			props.color.dimensionScheme = "12";
			props.color.byDimDef = {};
			props.color.altLabel = {};				

			if (type == 'linechart') {
				props.qHyperCubeDef.qMode = 'K';
				props.qHyperCubeDef.qAlwaysFullyExpanded = true;
			} else {
				if (chart != null && (chart.barType == 'v-grouped' || chart.barType == 'h-grouped')) {
					props.qHyperCubeDef.qMode = 'S';
					props.qHyperCubeDef.qAlwaysFullyExpanded = false;
					props.barGrouping.grouping = "grouped";

				} else {
					props.qHyperCubeDef.qMode = 'K';
					props.qHyperCubeDef.qAlwaysFullyExpanded = true;
					props.barGrouping.grouping = "stacked";
				}
			}
		} else {
			props.qHyperCubeDef.qMode = 'S';
			props.qHyperCubeDef.qAlwaysFullyExpanded = false;
			props.barGrouping.grouping = "";

			props.color.auto = true;
			props.color.mode = "primary";
			props.color.dimensionScheme = "12";
			props.color.byDimDef = {};
			props.color.altLabel = {};
			//props.color.useMeasureGradient = true;
		}
		return;
	}

	function getValuesByDimension(qApp, dim, searchField, altState, startRow, maxHeight, values, totalCnt) {
		return new qlik.Promise(function (resolve, reject) {
			var row = startRow == null ? 0 : startRow;
			qApp.createGenericObject(getDimListDef(row, dim, altState, maxHeight)).then(function (dimList) {
				if (totalCnt == null)
					totalCnt = 0;

				if (values == null)
					values = [];
				if (searchField) {
					dimList.searchListObjectFor("/qListObjectDef", searchField).then(function (resp) {
						dimList.getLayout().then(function (layout) {
							if (layout.qListObject.qDataPages.length > 0) {
								var data = layout.qListObject.qDataPages[0].qMatrix;
								totalCnt = totalCnt + data.length;
								data.forEach(function (e) {
									if (e[0].qText != null)
										values.push(e[0]);
								});
								return resolve(values);
							} else {
								return resolve(values);
							}
						});
					}, function (err) {
						console.log('searchFilter', err);
					});
				} else {
					dimList.getLayout().then(function (layout) {
						dim.totalValuesCount = layout.qListObject.qSize.qcy;
						if (layout.qListObject.qDataPages.length > 0) {
							var data = layout.qListObject.qDataPages[0].qMatrix;
							totalCnt = totalCnt + data.length;
							data.forEach(function (e) {
								if (e[0].qText != null) //causes list looping to fail because values.length will never equsal qcy
									values.push(e[0]);
							});

							if (maxHeight == null && totalCnt < layout.qListObject.qSize.qcy) {
								startRow = values.length;
								getValuesByDimension(qApp, dim, searchField, altState, startRow, null, values, totalCnt).then(function () {
									return resolve(values);
								}, function(err) {
									return reject(err)
								});
							} else {
								return resolve(values);
							}
						} else {
							return resolve(values);
						}
					}, function(err) {
						return reject(err)
					});
				}
			}, function (err) {
				return reject(err);
			});
		});
	}

	function addDimensionFilterValue(qApp, dim, values) {
		return new qlik.Promise(function (resolve, reject) {
			qApp.createGenericObject(getDimListDef(0, dim)).then(function (dimList) {
				dimList.selectListObjectValues("/qListObjectDef", values, true).then(function (obj) {
					return resolve();
				}, function (err) {
					console.log('err', err);
					return reject(err);
				});
			}, function (err) {
				return reject(err);
			});
		});
	}

	//This method replacing addDimensionFilterValue()
	function addDimensionValues(qApp, dim, values) {
		return new qlik.Promise(function (resolve, reject) {
			var myField = qApp.field(dim.shortName);
			var state = qApp.selectionState();
			var skipClear = true;
			for (var x = 0; x < state.selections.length; x++) {
				if (state.selections[x].fieldName == dim.shortName) {
					if (state.selections[x].selectedCount != state.selections[x].totalCount) {
						skipClear = false;
						myField.clear().then(function () {
							myField.select(values, false, true).then(function () {
								return resolve();
							}, function (err) {
								console.log('err', err);
								return reject(err);
							});
						}, function (err) {
							console.log('err', err);
							return reject(err);
						});
					}
				}
			}

			if (skipClear) {
				myField.select(values, false, true).then(function () {
					return resolve();
				}, function (err) {
					console.log('err', err);
					return reject(err);
				});
			}
		});
	}

	function getDimListDef(startRow, dim, altState, maxHeight) {
		var sortDir = getSortDefault(dim.valueSortDefault);
		maxHeight = maxHeight == null ? 10000 : maxHeight;
		var dimListDef = {
			"qInfo": {
				"qType": "filter"
			},
			"qListObjectDef": {
				"qDef": {
					"qFieldDefs": [dim.shortName],
					"qSortCriterias": [{
							"qSortByAscii": sortDir,
							"qSortByLoadOrder": 1
						}
					]
				},
				"qShowAlternatives": true,
				"qInitialDataFetch": [{
						"qLeft": 0,
						"qWidth": 1,
						"qTop": startRow,
						"qHeight": maxHeight
					}
				]
			}
		}
		if (altState != null) {
			dimListDef.qListObjectDef.qStateName = altState;
		}
		return dimListDef;
	}

	function getDimensionByCid($rootScope, cId) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (cId == currentItem.cId) {
						return currentItem;
					} else if (currentItem.hierarchyAvailable == 'Y') {
						var trees = getDimensionsForTree(currentItem);
						for (var x = 0; x < trees.length; x++) {
							if (trees[x].cId == cId) {
								return trees[x];
							}
						}
						if (currentItem.recodeTrees != null) {
							for (var y = 0; y < currentItem.recodeTrees.length; y++) {
								if (currentItem.recodeTrees[y].cId == cId) {
									return currentItem.recodeTrees[y];
								}
								if (currentItem.recodeTrees[y].dimensions != null) {
									for (var z = 0; z < currentItem.recodeTrees[y].dimensions.length; z++) {
										if (cId == currentItem.recodeTrees[y].dimensions[z].cId) {
											return currentItem.recodeTrees[y].dimensions[z];
										}
									}
								}
							}
						}
						if (currentItem.commonRecodeTrees != null) {
							for (var y = 0; y < currentItem.commonRecodeTrees.length; y++) {
								if (currentItem.commonRecodeTrees[y].cId == cId) {
									return currentItem.commonRecodeTrees[y];
								}
								if (currentItem.commonRecodeTrees[y].dimensions != null) {
									for (var z = 0; z < currentItem.commonRecodeTrees[y].dimensions.length; z++) {
										if (cId == currentItem.commonRecodeTrees[y].dimensions[z].cId) {
											return currentItem.commonRecodeTrees[y].dimensions[z];
										}
									}
								}
							}
						}
					} else if (currentItem.recodes != null) {
						for (var l = 0; l < currentItem.recodes.length; l++) {
							if (cId == currentItem.recodes[l].cId) {
								return currentItem.recodes[l];
							}
						}
					} else if (currentItem.commonRecodes != null) {
						for (var l = 0; l < currentItem.commonRecodes.length; l++) {
							if (cId == currentItem.commonRecodes[l].cId) {
								return currentItem.commonRecodes[l];
							}
						}
					}
				}
			}
		}
		return {}
	};

/* 	function getSelectedDimensionByCid($rootScope, cId) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (cId == currentItem.cId && currentItem.selected) {
						return currentItem;
					} else if (currentItem.hierarchyAvailable == 'Y') {
						var trees = getDimensionsForTree(currentItem);
						for (var x = 0; x < trees.length; x++) {
							if (trees[x].cId == cId && trees[x].selected) {
								return trees[x];
							}
						}
						if (currentItem.recodeTrees != null) {
							for (var y = 0; y < currentItem.recodeTrees.length; y++) {
								if (currentItem.recodeTrees[y].cId == cId && currentItem.recodeTrees[y].selected) {
									return currentItem.recodeTrees[y];
								}
								if (currentItem.recodeTrees[y].dimensions != null) {
									for (var z = 0; z < currentItem.recodeTrees[y].dimensions.length; z++) {
										if (cId == currentItem.recodeTrees[y].dimensions[z].cId && currentItem.recodeTrees[y].dimensions[z].selected) {
											return currentItem.recodeTrees[y].dimensions[z];
										}
									}
								}
							}
						}
					} else if (currentItem.recodes != null) {
						for (var l = 0; l < currentItem.recodes.length; l++) {
							if (cId == currentItem.recodes[l].cId && currentItem.recodes[l].selected) {
								return currentItem.recodes[l];
							}
						}
					}
				}
			}
		}
		return {};
	}; */
    
	function getDimensionByTitle($rootScope, title) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (title == currentItem.title) {
						return currentItem;
					}
				}
			}
		}
		return {};
	};    

	function getDimensionArrayIndexByCid($rootScope, cId) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (cId == currentItem.cId) {
						return k;
					}
				}
			}
		}
		return -1;
	};

	function getSelectedDimensionByName($rootScope, name) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (name == currentItem.shortName && currentItem.selected) {
						return currentItem;
					}
				}
			}
		}
		return {};
	};

	function getDimensionByName($rootScope, name) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (name == currentItem.shortName) {
						return currentItem;
					}
				}
			}
		}
		return {};
	};

	function getDimensionBySubFilter($rootScope, subFilter) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (subFilter.shortName == currentItem.shortName) {
						currentItem.displayOrder = subFilter.displayOrder;
						return currentItem;
					}
				}
			}
		}
		return {};
	};

	function getDimensionById($rootScope, id) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (id == currentItem.qId) {
						return currentItem;
					}
				}
			}
		}
		return {};
	};

	function getTreeRootByBranchCID($rootScope, cid) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					var tree = getDimensionsForTree(currentItem);
					for (var x = 0; x < tree.length; x++) {
						if (cid == tree[x].cId)
							return currentItem;
					}
				}
			}
		}
		return {};
	};

	function getTreeRootByBranchName($rootScope, name) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					var tree = getDimensionsForTree(currentItem);
					for (var x = 0; x < tree.length; x++) {
						if (name == tree[x].shortName)
							return currentItem;
					}
				}
			}
		}
		return {};
	};

	function getDimensionTopicByDim($rootScope, name) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (name == currentItem.shortName) {
						return $rootScope.dimensionProperties.apiDimTopics[i];
					}
				}
			}
		}
		return {};
	};

	function getDimensionGrpsByTopic($rootScope, topic) {
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			if ($rootScope.dimensionProperties.apiDimTopics[i].topicName == topic.topicName) {
				return $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups;
			}
		}
		return [];
	}

	function getDimensionsForTree(dim) {
		if (dim.hierarchyAvailable == 'Y') {
			//workaround, api returns associations for top root level but not each sub-hierarchy level
			//so get assoc and then add them to the 1st dim
			//var rootAssociations = dim.associations;
			var tmpDim = dim,
			tree = [],
			maxLevels = 15;
			for (var i = 1; i < maxLevels; i++) {
				if (tmpDim["dimHier" + i] != null) {
					tmpDim = tmpDim["dimHier" + i][0];
					// Table2Chart needs the Title from the dim itself
					tmpDim.matchTitle = dim.title;
					tmpDim.matchLevel = i - 1;
					// if(i == 1)
					// tmpDim.associations = rootAssociations;
					tree.push(tmpDim);
				} else {
					break;
				}
			}
			return tree;
		}
		return [];
	};

	function syncApiDimensions(rootDim, savedTree) {
		var rootTree = getDimensionsForTree(rootDim);
		for (var x = 0; x < savedTree.length; x++) {
			for (var y = 0; y < rootTree.length; y++) {
				if (savedTree[x].variableId == rootTree[y].variableId) {
					rootTree[y].selected = savedTree[x].selected;
				}
			}
		}
		return;
	}

	function getDimensionsForValueTree(dim) {

		var tmpDim = dim,
		tree = [],
		maxLevels = 15;
		for (var i = 1; i < maxLevels; i++) {
			if (tmpDim["varDimHier" + i] != null) {
				tmpDim = tmpDim["varDimHier" + i][0];
				tree.push({
					title: tmpDim.title
				});
			} else {
				break;
			}
		}
		return tree;
	};

	function getCodeValueTree(srcObj, level) {

		var tmpCode = {},
		tree = [],
		maxLevels = 15;
		for (var i = 0; i < srcObj.length; i++) {
			var tmpCode = {};
			tmpCode.codeValue = srcObj[i].codeValue;

			if (srcObj[i]["codeHier" + (++level)] != null) {
				var tmpNode = srcObj[i]["codeHier" + level];
				tmpCode.node = tmpNode;
				tree.push(tmpCode);
				getCodeValueTree(tmpCode, level)
			} else {
				tree.push(tmpCode);
			}
		}
		return tree;
	};

	function setYearFilter(qApp, props) {
		return new qlik.Promise(function (resolve, reject) {

			var maxYr = 0;
			var found = false;
			for (var x = 0; x < props.qHyperCubeDef.qDimensions.length; x++) {
				var name = props.qHyperCubeDef.qDimensions[x].qDef.qFieldDefs[0].match(/[a-zA-Z]+/g)[0];
				if (name.toLowerCase() == "year" || name.toLowerCase() == "refyr") {
					found = true;
					var dim = props.qHyperCubeDef.qDimensions[x];
					var myField = qApp.field(name);
					//console.log('fieldData', myField);
					//myField.clear();
					myField.OnData.bind(function () {
						//console.log('rows', myField.rows);
						myField.rows.forEach(function (row) {
							if (row.qNum > maxYr)
								maxYr = row.qNum;
						});
						if (maxYr > 0) {
							myField.selectValues([maxYr], false, true);
						}
						myField.OnData.observers = [];
						return resolve(dim);
					});
					myField.getData({
						rows: 100
					});
				}
			}
			if (!found)
				return resolve();
		});
	}

	function getDimensionRequired($rootScope) {
		var items = [];
		for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
			for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
				var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
				for (var k = 0; k < grp.dimensions.length; k++) {
					var currentItem = grp.dimensions[k];
					if (currentItem.dimensionRequiredFlag) {
						items.push(currentItem);
					}
				}
			}
		}
		return items;
	};

	function resetDimension($rootScope, dim) {
		dim.selected = false;
		dim.selectedValuesCount = 0;
		dim.disabled = false;
		delete dim.newTitle;
		if(dim.savedValues) {
			dim.savedValues = [];
		}
		if (dim.hierarchyAvailable == "Y") {
			dim.disabled = false;
			dim.savedList = [];
			dim.savedDims = [];

			var tmpTree = getDimensionsForTree(dim);
			for (var x = 0; x < tmpTree.length; x++) {
				tmpTree[x].selected = false;
			}
		} else if (dim.type == "recodeTree") {
			dim.savedDims = [];
			dim.savedList = [];
			for (var x = 0; x < dim.dimensions.length; x++) {
				dim.dimensions[x].selected = false;
			}			
		} else if (dim.type == "recode") {
			dim.nonRecodeValues = [];
			for (var y = 0; y < dim.categories.length; y++) {
				dim.categories[y].selected = false;
				dim.categories[y].class = "";
				dim.categories[y].qState = "O";
			}
			var parentDim = getDimensionByCid($rootScope, dim.dimCid);
			parentDim.recodeSelected = false;
			if(parentDim.recodes) {
				parentDim.recodes.forEach(function(r) {
					if(r.selected)
						parentDim.recodeSelected = true;
				})
			}
		}
	}
	
	function applyTotalsProperties($rootScope, props) {
		props.qHyperCubeDef.qInterColumnSortOrder.forEach(function (val, index) {
			// -1: indicates a pseudoDim for 2 or more applied measuress, skip it since totals not applied to measures
			if(val != -1) {
				let dim = props.qHyperCubeDef.qDimensions[val];
				if (getDimensionByCid($rootScope,  dim.qDef.cId).shortName === $rootScope.survey.dimToLock) {
					dim.qOtherTotalSpec = {"qTotalMode": "TOTAL_OFF"};
					dim.qTotalLabel = {};
				} else if($rootScope.displayTableTotals) {
					//Totals only added to first pos in Rows except when 1st pos is Year or psuedoDim then no row totals
					if(index >= props.qHyperCubeDef.qNoOfLeftDims ) {
						dim.qOtherTotalSpec = {"qTotalMode": "TOTAL_EXPR"};
						dim.qTotalLabel = { "qv": "Total"};
					} else if(index == 0) {
						dim.qOtherTotalSpec = {"qTotalMode": "TOTAL_EXPR"};
						dim.qTotalLabel = { "qv": "Total"};
					} else {
						dim.qOtherTotalSpec = {"qTotalMode": "TOTAL_OFF"};
						dim.qTotalLabel = {};
					}					
				} else {
					dim.qOtherTotalSpec = {"qTotalMode": "TOTAL_OFF"};
					dim.qTotalLabel = {};
				} 
			}
		});
		return;		
	};	

	return {
		getApiDimensions: getDimensionsFromApi,
		getSubFilters: getSubFiltersFromApi,
		getQlikDimensions: getDimensionsFromQlik,
		addDimension: addDimension,
		removeDimension: removeDimension,
		removeTreeDimension: removeTreeDimension,
		getDimensionById: getDimensionById,
		getDimensionByCid: getDimensionByCid,
		//getSelectedDimensionByCid: getSelectedDimensionByCid,
		getDimensionArrayIndexByCid: getDimensionArrayIndexByCid,
		getDimensionByTitle: getDimensionByTitle,
		getDimensionByName: getDimensionByName,
		getDimensionBySubFilter: getDimensionBySubFilter,
		getSelectedDimensionByName: getSelectedDimensionByName,
		getTreeRootByBranchCID: getTreeRootByBranchCID,
		getTreeRootByBranchName: getTreeRootByBranchName,
		defineDimension: defineDimension,
		getDimensionGrpsByTopic: getDimensionGrpsByTopic,
		getDimensionTopicByDim: getDimensionTopicByDim,
		getValuesByDimension: getValuesByDimension,
		addDimensionFilterValue: addDimensionFilterValue,
		addDimensionValues: addDimensionValues,
		getDimensionsForTree: getDimensionsForTree,
		getDimensionsForValueTree: getDimensionsForValueTree,
		getCodeValueTree: getCodeValueTree,
		syncApiDimensions: syncApiDimensions,
		setYearFilter: setYearFilter,
		getDimensionRequired: getDimensionRequired,
		resetDimension: resetDimension,
		getSortDefault: getSortDefault,
		applyTotalsProperties: applyTotalsProperties
	}
});

'use strict'
define('scripts/shared/hyperCubeProperties',["qlik", "scripts/shared/appUtilities", "scripts/shared/measures", "scripts/shared/dimensions"],
	function (qlik, appUtilities, measures, dimensions) {
	var props;
	var effProps;
	const MetaDataType = {
		DIM: "dimensions",
		MSR: "measures"
	}

	var getAppliedModel = function (app) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {

			app.getList("SelectionObject").then(function (model) {
				return resolve(model);
			}, function (err) {
				return reject('get filters failed');
			});

		});
	};

	var getDimensionList = function (app, $q) {
		var deferred = $q.defer();
		app.getList("DimensionList").then(function (dims) {
			deferred.resolve(dims);
		}, function (err) {
			deferred.reject('get dims failed');
		});
		return deferred.promise;
	};

	// This function is called by 'updateSelection' and is invoked each time a measure/dimension with Association data is selected or unselected.
	// It will
	//      1) Read in metadata that details the correct associations for each measure or dimension that remains on the Pivot Table
	//      2) Invoke a routine that determines which items are common among those associations
	//      3) Invoke a routine that will hide measures/dimensions that are not appropriaate for the chosen measures/dimensions, preventing the
	//         the user from making selections that don't make sense
	//
	//  Association Value Notes: If there are association values, (other than "X" or " " empty) it means that all of the measures/dimensions listed are associated
	//  with the selected variable and should remain enabled.  For dimensions only, an " " empty value means the dimension is associated with all measures (i.e. Institutional Data)
	//  and should always remain enabled.  For measures only: an "X" value means no specific dimensions are associated with the measure and only the 'always available' dimensions should be enabled.
	//
	var getSelectedAssociations = function ($rootScope, item) {
		var varListSelectedMeasureAssociations = [];
		var varListSelectedDimensionAssociations = [];
		var varListEnabledMeasureAssociations = [];

		var dimensionSelected = [];
		var measureSelected = [];
		var currentItem = "";

		// 1. Get the associated dimensions from the selected measures.
		//	Also, record array of selected measures with associations
		for (var x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
			var apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
			for (var y = 0; y < apiGrps.length; y++) {
				for (var z = 0; z < apiGrps[y].measures.length; z++) {
					currentItem = apiGrps[y].measures[z];
					if (hasAssociationsArray(currentItem) && currentItem.selected) {
						measureSelected.push(currentItem);
						varListSelectedMeasureAssociations.push(currentItem.associations.map(function (v) {
								return v.toLowerCase().trim();
							}));
					}
				};
			};
		};

		//2. Hide dimensions based on the common associated dimensions from selected measures in step 1
		if (item.type == "measure") {
			var associatedDimensionItems = getIntersection(varListSelectedMeasureAssociations);
			hideUnAssociatedDims(associatedDimensionItems, $rootScope.dimensionProperties.apiDimTopics, measureSelected);
		}

		//3. Get the associated measures for the selected dimensions.
		//   Also, record array of selected dimensions with associations
		if (item.type == "dimension" || item.type == 'dim-branch' || item.type == 'recode' || item.type == 'recodeTree') {
			for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
				for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
					var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
					for (var k = 0; k < grp.dimensions.length; k++) {
						currentItem = grp.dimensions[k];
						//3a. Get the associated measures for the selected dimensions with associations
						if (currentItem.hierarchyAvailable == "Y") {
							if(currentItem.selected) {
								var tmpTree = currentItem.savedDims; //dimensions.getDimensionsForTree(currentItem);
								if(tmpTree != null) {
									for (var x = 0; x < tmpTree.length; x++) {
										if (tmpTree[x].selected && hasAssociationsArray(tmpTree[x])) {
											dimensionSelected.push(tmpTree[x]);
											varListSelectedDimensionAssociations.push(tmpTree[x].associations.map(function (v) {
												return v.toLowerCase().trim();
											}));
										}
									}
								}
							}
							if (currentItem.recodeTrees != null) {
								for (var a = 0; a < currentItem.recodeTrees.length; a++) {
									if (currentItem.recodeTrees[a].selected) {
										var recodeTree = currentItem.recodeTrees[a];			
										for (var a = 0; a < recodeTree.dimensions.length; a++) {
											if (recodeTree.dimensions[a].selected) {
												dimensionSelected.push(recodeTree.dimensions[a]);
												varListSelectedDimensionAssociations.push(recodeTree.dimensions[a].associations.map(function (v) {
														return v.toLowerCase().trim();
													}));
											}
										}
									}
								}
							}
						} else if (currentItem.selected && hasAssociationsArray(currentItem)) {
							dimensionSelected.push(currentItem);
							varListSelectedDimensionAssociations.push(currentItem.associations.map(function (v) {
									return v.toLowerCase().trim();
								}));
						} else if (currentItem.recodes != null && currentItem.recodes.length > 0) {
							for (var z = 0; z < currentItem.recodes.length; z++) {
								if (currentItem.recodes[z].selected) {
									dimensionSelected.push(currentItem.recodes[z]);
									varListSelectedDimensionAssociations.push(currentItem.associations.map(function (v) {
											return v.toLowerCase().trim();
										}));
								}
							}
						}
					}
				}
			}
			//3b. Hide measures based on the common associated measures from selected dimensions in step 3a
			var associatedMeasureItems = getIntersection(varListSelectedDimensionAssociations);
			hideUnAssociatedMsrs(associatedMeasureItems, $rootScope.measureProperties.apiMeasureTopics, dimensionSelected);
		}

		// ** Maybe make this a separate function **
		// After all measures/dimensions are disabled above we need to see if more dimensions, on bottom, should be disabled based on the measures that were just disabled
		// Repeat the first 'For Loop', above, for measures, this time checking NOT if the measure was selected (currentItem.qMeta.selected) but instead if it is enabled - if so add to array of enabled measures
		// Then take all the dimensions associations for the enabled measures and ensure all those dimensions are enabled, and those that are not are disabled
		// Bottom line is to disable dimensions that should not be selectable from the measures that remain

		//5. if there are no selected measures,
		//   then find the associated measures for the selected dimensions
		//   and then find all possible options for associated dimensions based on the enabled measures from step 3.
		if (item.type == "dimension" && measureSelected.length == 0) {
			//5a. Get all associated dimensions from the enabled measures with associations
			for (var x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
				var apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
				for (var y = 0; y < apiGrps.length; y++) {
					for (var z = 0; z < apiGrps[y].measures.length; z++) {
						currentItem = apiGrps[y].measures[z];
						if (hasAssociationsArray(currentItem) && currentItem.disabled == false) {
							varListEnabledMeasureAssociations.push(currentItem.associations.map(function (v) {
									return v.toLowerCase().trim();
								}));
						}
					}
				}
			}

			//5b. Build an array with a concatenation of all the dimensions associated with the enabled measures, with no dups from step 5a.
			var unionAssociatedDimensions = getUnion(varListEnabledMeasureAssociations);

			var disabled_flag = false;
			var currentItem = "";

			//5c. Hide dimensions based on the associated dimensions from de-duped enabled measures in step 5b
			for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
				for (var j = 0; j < $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups.length; j++) {
					var grp = $rootScope.dimensionProperties.apiDimTopics[i].dimensionGroups[j];
					for (var k = 0; k < grp.dimensions.length; k++) {
						currentItem = grp.dimensions[k];
						//only hide/show if loop.item associations array is not empty, skip dimensions that associate with everything
						if (currentItem.hierarchyAvailable == "Y") {
							var tmpTree = dimensions.getDimensionsForTree(currentItem);
							for (var x = 0; x < tmpTree.length; x++) {

								if (hasAssociationsArray(tmpTree[x])) {
									currentItem.disabled = true;
									// If the dimension is not in the array of values that are associated with the enabled measures disable it, otherwise enable
									if (unionAssociatedDimensions.indexOf(tmpTree[x].shortName.toLowerCase().trim()) > -1) {
										currentItem.disabled = false;
										tmpTree[x].disabled = false;
									} else {
										tmpTree[x].disabled = true;
									}

								}
							}
						} else if (hasAssociationsArray(currentItem)) {
							// If the dimension is not in the array of values that are associated with the enabled measures disable it, otherwise enable
							if (unionAssociatedDimensions.indexOf(currentItem.shortName.toLowerCase().trim()) > -1) {
								disabled_flag = false;
							} else {
								disabled_flag = true;
							}
							if (currentItem.disabled != disabled_flag) {
								currentItem.disabled = disabled_flag;
							}
						}
					}
				}
			}

		}
	};

	// This function is invoked by getSelectedAssociations, which itself is invoked each time a measure or dimension is selected or unselected.
	// It reads in a set of arrays containing all of the measures and dimensions that relate to (are 'associated' with) each selected measure and dimension
	// and returns an array containing only the measures/dimensions that are common (that 'intersect') among the arrays.  We use this information to enable/disable
	// the measures/dimensions so the user cannot choose a combination that does not make sense.
	var getIntersection = function (associations) {
		var result = [];
		if (typeof associations != 'undefined' && associations instanceof Array && associations.length > 0) {
			result = associations.shift().filter(function (v) {
				return associations.every(function (a) {
					return a.indexOf(v) !== -1;
				});
			});
		} else {
			console.log("issue with finding intersection of array: ", associations)
		}
		return result;
	};

	// This function will walk an array of arrays, combining/concatinating all the values without adding duplicates
	var getUnion = function (associations) {
		var result = [];

		if (typeof associations != 'undefined' && associations instanceof Array && associations.length > 0) {
			var uniqueAssociation = {};
			for (var i = 0; i < associations.length; i++) {
				var associationToEvaluate = associations[i];
				for (var j = associationToEvaluate.length - 1; j >= 0; --j)
					uniqueAssociation[associationToEvaluate[j]] = associationToEvaluate[j];
			}

			var result = [];
			for (var k in uniqueAssociation) {
				result.push(uniqueAssociation[k]);
			}
			return result;
		} else {
			console.log("issue with finding union of arrays: ", associations)
		}
		return result;
	};

	// Invoked each time a measure or dimension is selected or unselected, this function reads in a list of valid measure/dimensions created in 'getIntersection' so that we can
	// enable or disable (hide) the appropriate measures and dimensions, thus preventing the user from selecting combinations that do not make sense.
	var hideUnAssociatedDims = function (associatedItems, apiDimTopics, selectedItems) {

		var disabled_flag = false;
		var currentItem = "";

		for (var w = 0; w < apiDimTopics.length; w++) {
			var topic = apiDimTopics[w];
			for (var x = 0; x < topic.dimensionGroups.length; x++) {
				var grp = topic.dimensionGroups[x];

				for (var y = 0; y < grp.dimensions.length; y++) {
					currentItem = grp.dimensions[y];
					if (currentItem.hierarchyAvailable == "Y") {
						if (currentItem.selected) {
							currentItem.disabled = false;
						} else {
							currentItem.disabled = true;
						}
						var tmpTree = dimensions.getDimensionsForTree(currentItem);
						for (var z = 0; z < tmpTree.length; z++) {
							//only hide/show if associations array is not empty
							if (hasAssociationsArray(tmpTree[z])) {
								if (associatedItems.indexOf(tmpTree[z].shortName.toLowerCase().trim()) > -1 || selectedItems.length == 0) {
									currentItem.disabled = false;
									tmpTree[z].disabled = false;
								} else {
									tmpTree[z].disabled = true;
								}
							}
						}
					} else if (hasAssociationsArray(currentItem)) {
						//only hide/show if associations array is not empty
						if (currentItem.selected || associatedItems.indexOf(currentItem.shortName.toLowerCase().trim()) > -1 || selectedItems.length == 0) {
							currentItem.disabled = false;
						} else {
							currentItem.disabled = true;
						}
						//disable any selected recodes if they exist
						if (currentItem.recodes != null && currentItem.recodes.length > 0) {
							for (var z = 0; z < currentItem.recodes.length; z++) {
								if (currentItem.recodes[z].selected || associatedItems.indexOf(currentItem.shortName.toLowerCase().trim()) > -1 || selectedItems.length == 0) {
									currentItem.recodes[z].disabled = false;
								} else {
									currentItem.recodes[z].disabled = true;
								}
							}
						}
					}
				}
			}
		}
	};

	var hideUnAssociatedMsrs = function (associatedItems, apiMeasureTopics, selectedItems) {

		var disabled_flag = false;
		var currentItem = "";

		for (var x = 0; x < apiMeasureTopics.length; x++) {
			var apiGrps = apiMeasureTopics[x].measureGroups;
			for (var y = 0; y < apiGrps.length; y++) {
				for (var z = 0; z < apiGrps[y].measures.length; z++) {
					currentItem = apiGrps[y].measures[z];
					if (hasAssociationsArray(currentItem)) {
						//only hide/show if associations array is not empty
						if (currentItem.selected || associatedItems.indexOf(currentItem.shortName.toLowerCase().trim()) > -1 || selectedItems.length == 0) {
							disabled_flag = false;
						} else {
							disabled_flag = true;
						}
						currentItem.disabled = disabled_flag;
					}
				};
			};
		};
	};

	var isArray = function (currentArray) {
		if (typeof currentArray == 'undefined' || currentArray instanceof Array == false || currentArray.length == 0) {
			return false;
		}
		return true;
	}

	var hasAssociationsArray = function (item) {
		if (isArray(item.associations) && item.associations[0] != "") {
			return true;
		}
		return false;
	};

	var setVisualizationDefaults = function ($rootScope, $scope, qApp, measureParms, dimensionParms) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {
			var currentItem = {};
			qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getProperties().then(function (props) {

					props.qHyperCubeDef.qInterColumnSortOrder = [];
					props.qHyperCubeDef.qNoOfLeftDims = -1;
					props.qHyperCubeDef.qMeasures = [];
					props.qHyperCubeDef.qDimensions = [];
					props.qHyperCubeDef.qSortbyYValue = 0;
					//props.title = "";

					if (props.qHyperCubeDef.qLayoutExclude)
						props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions = [];

					var collection = [];
					//If only 1 measure, then default to that measure
					if ($rootScope.measureProperties.apiMeasureTopics.length == 1
						 && $rootScope.measureProperties.apiMeasureTopics[0].measureGroups.length == 1
						 && $rootScope.measureProperties.apiMeasureTopics[0].measureGroups[0].measures.length == 1) {
						var item = $rootScope.measureProperties.apiMeasureTopics[0].measureGroups[0].measures[0];
						item.selected = true;
						item.checked = true;
						try {
							measures.defineMeasure($rootScope, item, props);
							getSelectedAssociations($rootScope, item);
						} catch (err) {
							return reject(err)
						}
					} else {
						var dummy = {
							qDef: {
								qDef: "=Count(1)",
								qLabel: "placeHolder",
								cId: "placeholder"
							}
						};
						props.qHyperCubeDef.qMeasures.push(dummy);
					}
					
					var processesDefaultDim = function ($rootScope, $scope, currentItem, props) {
						var Promise = qlik.Promise;
						return new Promise(function (resolve, reject) {

							currentItem.selected = true;
							try {
								if (dimensions.defineDimension($rootScope, currentItem, props, false)) {
									getSelectedAssociations($rootScope, currentItem);
									dimensions.getValuesByDimension(qApp, currentItem).then(function (values) {
										currentItem.selectedValuesCount = values.length;
										var elms = [];
										for (var x = 0; x < values.length; x++) {
											elms.push(values[x].qElemNumber);
										}
										return resolve({
											dim: currentItem,
											values: elms
										});
									}, function(err) {
										return reject(err)
									});
								} else {
									return resolve();
								}
							} catch (err) {
								return reject(err)
							}
						});
					}

					var promises = [];
					//set required dimensions as defaults
					$rootScope.dimensionProperties.apiDimTopics.forEach(function (topic) {
						topic.dimensionGroups.forEach(function (grp) {
							grp.dimensions.forEach(function (currentItem) {
								if (currentItem.dimensionRequiredFlag == true) {
									promises.push(processesDefaultDim($rootScope, $scope, currentItem, props));
								}
							});
						});
					});
					
					Promise.all(promises).then(function (retObj) {
						//first, populate collection with any default dims and values
						if (retObj != null && retObj.length > 0 && retObj[0] != null) {
							collection.push({
								dim: retObj[0].dim,
								values: retObj[0].values
							});
						}
						//next, populate measure/dims passed in URL from caller Data Explorer
						setCallerParms($rootScope, $scope, qApp, props, measureParms, dimensionParms).then(function (retObj) {
							if (retObj != null && retObj.length > 0 && retObj[0] != null) {
								if ($scope.tableToChartSession) {
									for (var x = 0; x < retObj.length; x++) {
										if(retObj[x] !== undefined) {
											collection.push({
												dim: retObj[x].dim,
												values: retObj[x].values
											});
										}
									}
								}
								else {
									collection.push({
										dim: retObj[0].dim,
										values: retObj[0].values
									});
								}
							}

							updateHypercubeProperties($rootScope, $scope, qApp, obj, props, collection).then(function() {
								return resolve();
							}, function(err) {
								return reject(err);
							})
						}, function (err) {
							return reject(err);
						});

					}, function(err) {
						return reject(err)
					});
				});
			});
		}, function(err) {
			return reject(err)
		});
	};
	
	function updateHypercubeProperties($rootScope, $scope, qApp, obj, props, collection) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {
			if ($rootScope.displayVisType == "barchart") {
				if ($rootScope.chart.barType == "v-stacked") {
					props.qHyperCubeDef.qMode = "K";
					props.qHyperCubeDef.qAlwaysFullyExpanded = true;
					props.barGrouping = {};
					props.barGrouping.grouping = "stacked";
					$scope.qAdhocProps.orientation = "vertical"
				} else if ($rootScope.chart.barType == "v-grouped") { //cluster
					props.qHyperCubeDef.qMode = "S";
					props.qHyperCubeDef.qAlwaysFullyExpanded = false;
					props.barGrouping = {};
					props.barGrouping.grouping = "grouped";
					$scope.qAdhocProps.orientation = "vertical"
				} else if ($rootScope.chart.barType == "h-stacked") {
					props.qHyperCubeDef.qMode = "K";
					props.qHyperCubeDef.qAlwaysFullyExpanded = true;
					props.barGrouping = {};
					props.barGrouping.grouping = "stacked";
					props.orientation = "horizontal"
				} else if ($rootScope.chart.barType == "h-grouped") {
					props.qHyperCubeDef.qMode = "S";
					props.qHyperCubeDef.qAlwaysFullyExpanded = false;
					props.barGrouping = {};
					props.barGrouping.grouping = "grouped";
					props.orientation = "horizontal";
				} 									
			} else if ($rootScope.displayVisType == "linechart") {
				if (props.qHyperCubeDef.qDimensions.length > 1) {
					props.qHyperCubeDef.qMode = 'K';
				} else {
					props.qHyperCubeDef.qMode = 'S';
				}
			}
		
			obj.setProperties(props).then(function (properties_set) {
				let promises2 = [];
				for (let x = 0; x < collection.length; x++) {
					let tree = collection[x].tree;
					let dim = collection[x].dim;
					let values = collection[x].values;
					let item = tree != null?tree:dim;
					promises2.push(dimensions.addDimensionFilterValue(qApp, dim, values));
				}
				Promise.all(promises2).then(function (retObj) {
					return resolve();
				}, function (err) {
					console.log('setPropErr1stTry');
					return reject(err);
				});
			}, function (err) {
				console.log('setPropErr1stTry');
				return reject(err);
			});		
		})
	}

	//method handles params passed in by ME
	var setCallerParms = function ($rootScope, $scope, qApp, props, msrParms, dimParms) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {

			if ((msrParms == null || msrParms.length == 0) && (dimParms == null || dimParms.length == 0))
				return resolve();
			
			if (msrParms != null && msrParms.length > 0) {
				props.qHyperCubeDef.qMeasures = [];
				for (var x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
					var apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
					for (var y = 0; y < apiGrps.length; y++) {
						for (var z = 0; z < apiGrps[y].measures.length; z++) {
							var currentItem = apiGrps[y].measures[z];
							msrParms.forEach(function (currentParm) {
								if (currentItem.shortName.toLowerCase().trim() == currentParm.toLowerCase().trim()) {
									currentItem.selected = true;
									//currentItem.checked = true;
									measures.defineMeasure($rootScope, currentItem, props);
									getSelectedAssociations($rootScope, currentItem);
								}
							});
						};
					};
				};
			}

			var processesCallerDim = function ($rootScope, $scope, item, treeRoot, props) {
				var Promise = qlik.Promise;
				return new Promise(function (resolve, reject) {

					item.initializeToMeParam = true;
					if (dimensions.defineDimension($rootScope, item, props, false)) {
						item.selected = true;
						getSelectedAssociations($rootScope, item);
						dimensions.getValuesByDimension(qApp, item).then(function (values) {
							if (treeRoot)
								treeRoot.selectedValuesCount = values.length;
							else
								item.selectedValuesCount = values.length;

							var elms = [];
							for (var x = 0; x < values.length; x++) {
								elms.push(values[x].qElemNumber);
							}
							return resolve({
								dim: item,
								values: elms
							});
						});
					} else {
						return resolve();
					}
				});
			}

			var promises = [];
			dimParms.forEach(function (currentParm) {
				$rootScope.dimensionProperties.apiDimTopics.forEach(function (topic) {
					topic.dimensionGroups.forEach(function (grp) {
						for (var x = 0; x < grp.dimensions.length; x++) {
							var currentItem = grp.dimensions[x];
							if (currentItem.hierarchyAvailable == 'Y') {
								//check if called param is in tree of current dim
								var tree = dimensions.getDimensionsForTree(currentItem);
								for (var i = 0; i < tree.length; i++) {
									if(tree[i].shortName.toLowerCase().trim() == currentParm.toLowerCase().trim()) {
										currentItem.selected = true;
										//tree[i].selected = true;
										promises.push(processesCallerDim($rootScope, $scope, tree[i], currentItem, props));
										break;
									}
								}
								if (currentItem.selected) {
									currentItem.savedDims = tree;
									break;
								}
							} else if (currentItem.shortName.toLowerCase().trim() == currentParm.toLowerCase().trim()) {
								promises.push(processesCallerDim($rootScope, $scope, currentItem, null, props));
								break;
							}
						}
					});
				});
			});
			Promise.all(promises).then(function (retObj) {
				return resolve(retObj);
			}, function(err) {
				return reject(err)
			});
		});
	};
	
	var setTableChartVariables = function ($rootScope, $scope, qApp) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {

			//loading dim(s) and recodes from table/chart conversion
			if($scope.tableToChartSession.expired) {
				return resolve();
			}

			qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getProperties().then(function (props) {

					let dimParms = [];
					dimParms.push($scope.tableToChartSession.conversionPrimaryDimensionValues.shortName);

					$scope.tableToChartSession.conversionLineDimensionsValuesMap = new Map(Object.entries($scope.tableToChartSession.conversionLineDimensionsValuesMap));
					$scope.tableToChartSession.conversionLineDimensionsSecondaryValuesMap = new Map(Object.entries($scope.tableToChartSession.conversionLineDimensionsSecondaryValuesMap));
					$scope.tableToChartSession.hierDimTitles = new Map(Object.entries($scope.tableToChartSession.hierDimTitles));
					
					for (const [key, value] of $scope.tableToChartSession.conversionLineDimensionsValuesMap) {
						dimParms.push(key);
					}
					for (const [key, value] of $scope.tableToChartSession.conversionLineDimensionsSecondaryValuesMap) {
						dimParms.push(key);
					}
					

					if($scope.tableToChartSession.barChartStyle != null) {
						$rootScope.chart.barType = $scope.tableToChartSession.barChartStyle.value;
					}
					
					props.qHyperCubeDef.qMeasures = [];
					for (var x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
						var apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
						for (var y = 0; y < apiGrps.length; y++) {
							for (var z = 0; z < apiGrps[y].measures.length; z++) {
								var currentItem = apiGrps[y].measures[z];
								if(currentItem.variableName == $scope.tableToChartSession.conversionMeasure.variableName) {
									currentItem.selected = true;
									measures.defineMeasure($rootScope, currentItem, props);
									getSelectedAssociations($rootScope, currentItem);
								}
							};
						};
					};


					var promises = [];
					let found = false;
					dimParms.forEach(function (currentParm) {
						var isRecode = false;
						if($scope.tableToChartSession.allRecodesByCID
							&& $scope.tableToChartSession.allRecodesByCID.length > 0) {
							for (var i=0; i < $scope.tableToChartSession.allRecodesByCID.length; i++) {
								var recodeByCID = $scope.tableToChartSession.allRecodesByCID[i];
								
								if(recodeByCID.type == 'recodeTree' || recodeByCID.type == 'commonRecodeTree') {
									for (var j=0; j < recodeByCID.dimensions.length; j++) {
										if(currentParm == recodeByCID.dimensions[j].label) {											
											$rootScope.dimensionProperties.apiDimTopics.forEach(function (topic) {
												topic.dimensionGroups.forEach(function (grp) {
													for (var x = 0; x < grp.dimensions.length; x++) {
														var currentItem = grp.dimensions[x];
														if (currentItem.hierarchyAvailable == 'Y') {
															if(currentItem.recodeTrees && currentItem.recodeTrees.length > 0) {
																for(let y=0; y < currentItem.recodeTrees.length; y++) {
																	let tree = currentItem.recodeTrees[y];
																	for(let z=0; z < tree.dimensions.length; z++) {
																		let branch = tree.dimensions[z];
																		let isBranchRecode = false;
																		if(branch.type == "recode") {
																			isBranchRecode = true;
																		}										
																		let label = isBranchRecode?branch.recodeName:branch.title;
																		if(label.toLowerCase().trim() == recodeByCID.dimensions[j].label.toLowerCase().trim()
																			&& tree.treeName == recodeByCID.dimensions[j].treeName) {
																			branch.selected = true;
																			tree.selected = true;
																			promises.push({
																				isTree: true,
																				isRecode: isBranchRecode,
																				dimension: branch,
																				treeRoot: tree,
																				props: props});
																			isRecode = true;
																			break;
																		}
																	}
																}
															} else if(currentItem.commonRecodeTrees && currentItem.commonRecodeTrees.length > 0) {
																for(let y=0; y < currentItem.commonRecodeTrees.length; y++) {
																	let tree = currentItem.commonRecodeTrees[y];
																	for(let z=0; z < tree.dimensions.length; z++) {
																		let branch = tree.dimensions[z];
																		let isBranchRecode = false;
																		if(branch.type == "recode") {
																			isBranchRecode = true;
																		}										
																		let label = isBranchRecode?branch.recodeName:branch.title;
																		if(label.toLowerCase().trim() == recodeByCID.dimensions[j].label.toLowerCase().trim()
																			&& tree.treeName == recodeByCID.dimensions[j].treeName) {
																			branch.selected = true;
																			tree.selected = true;
																			promises.push({
																				isTree: true,
																				isRecode: isBranchRecode,
																				dimension: branch,
																				treeRoot: tree,
																				props: props});
																			isRecode = true;
																			break;
																		}
																	}
																}
															}
															break;
														} 
													}
												});
											});	
										}	
									}
								}
								else {
									if(recodeByCID.label == currentParm) {
										promises.push({
											isTree: false,
											isRecode: true,
											dimension: recodeByCID,
											treeRoot: null,
											props: props});
										isRecode = true;
										break;
									}
								}
							}
						}
						if(!isRecode) {
							found = false
							for(let v = 0; v < $rootScope.dimensionProperties.apiDimTopics.length; v++) {;
								let topic = $rootScope.dimensionProperties.apiDimTopics[v];
								for(let w = 0; w < topic.dimensionGroups.length; w++) {
									let grp = topic.dimensionGroups[w];
									for (var x = 0; x < grp.dimensions.length; x++) {
										var currentItem = grp.dimensions[x];
										if (currentItem.hierarchyAvailable == 'Y' && $scope.tableToChartSession.hierDimTitles.size > 0) {											
											let sessionTree = $scope.tableToChartSession.hierDimTitles.get(currentItem.title)
											var tree = dimensions.getDimensionsForTree(currentItem);
											for (var i = 0; i < tree.length; i++) {
												if(tree[i].shortName.toLowerCase().trim() == currentParm.toLowerCase().trim()
													&& tree[i].matchTitle == sessionTree.title) {
													currentItem.selected = true;
													tree[i].selected = true;
													currentItem.savedList = sessionTree.savedList
													currentItem.selectedValuesCount = sessionTree.selectedValuesCount;
													promises.push({
														isTree: true,
														tree: currentItem,
														dimension: tree[i],
														props: props});
													break;
												}
											}
											if (currentItem.selected) {
												currentItem.savedDims = tree;
												break;
											}											
										} else if (currentItem.shortName != null && currentItem.shortName.toLowerCase().trim() == currentParm.toLowerCase().trim()) {
											//currentItem.selected = true;
											promises.push({
												isTree: false,
												dimension: currentItem,
												treeRoot: null,
												props: props});
											found = true;
											break;
										}
									}
									if(found)
										break;									
								};
								if(found)
									break;								
							};
						}
					});
					
					async function runPromisesInSequence(promisesSeq) {
						var selections = [];
						for (let promise of promisesSeq) {
							if(promise.isTree && !promise.isRecode) {
								selections.push(await processesCallerDimConversion($rootScope, $scope, qApp, promise.dimension, promise.treeRoot, promise.props));
							}
							else if(promise.isTree && promise.isRecode) {					
								selections.push(await conversionAddRecode($rootScope, $scope, qApp, promise.dimension, promise.treeRoot, promise.props));
							}
							else if(!promise.isTree && promise.isRecode) {
								selections.push(await conversionAddRecode($rootScope, $scope, qApp, promise.dimension, null, promise.props));
							}
							else {
								selections.push(await processesCallerDimConversion($rootScope, $scope, qApp, promise.dimension, null, promise.props));
							}
							getSelectedAssociations($rootScope, promise.dimension);
						}
						
						if ((props.qHyperCubeDef.qMeasures == null || props.qHyperCubeDef.qMeasures.length == 0) && (props.qHyperCubeDef.qDimensions == null || props.qHyperCubeDef.qDimensions.length == 0))
							return resolve();
						
						updateHypercubeProperties($rootScope, $scope, qApp, obj, props, selections).then(function() {
							return resolve();
						}, function(err) {
							return reject(err);
						})						
					}
					runPromisesInSequence(promises);									
				});				
			})
		})
	};	
	
	var processesCallerDimConversion = function ($rootScope, $scope, qApp, item, treeRoot, props) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {

			
			if (dimensions.defineDimension($rootScope, item, props, false)) {
				item.selected = true;
				var selectedValues = [];
				
				var elms = [];
				if (item.shortName == $scope.tableToChartSession.conversionPrimaryDimensionValues.shortName) {
					selectedValues = $scope.tableToChartSession.conversionPrimaryDimensionValues.values;
				}
				else {
					for(const [key, value] of $scope.tableToChartSession.conversionLineDimensionsValuesMap) {
						if(item.shortName == key) {
							selectedValues = value;
						}
					}
					
					for(const [key, value] of $scope.tableToChartSession.conversionLineDimensionsSecondaryValuesMap) {
						if(item.shortName == key) {
							selectedValues = value;
						}
					}
				}

				if (item.type == "dim-branch" || item.shortName == "instName") {
					for(var x = 0; x < selectedValues.length; x++) {
						if (selectedValues[x].class == 's') {
							elms.push(selectedValues[x].qElemNumber);
						}
					}
					item.selectedValuesCount = elms.length;
					if(item.shortName == "instName") {
						item.savedValues = selectedValues;
					}
				}
				else {
					for(var x = 0; x < selectedValues.length; x++) {
						if (selectedValues[x].qState == 'S') {
							elms.push(selectedValues[x].qElemNumber);
						}
					}
					item.selectedValuesCount = elms.length;
				}
				
				return resolve({
					tree: treeRoot,
					dim: item,
					values: elms
				});
			} else {
				return resolve();
			}
		});
	}
	
	function conversionAddRecode($rootScope, $scope, qApp, item, treeRoot, props) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {
			var conversionDim;
			var conversionRecode;
			var conversionFromRecode; // = $scope.tableToChartSession.allRecodesByCID;
			for (var i = 0; i < $scope.tableToChartSession.allRecodesByCID.length; i++) {
				if(treeRoot != null) {
					if($scope.tableToChartSession.allRecodesByCID[i].type == "recodeTree" || $scope.tableToChartSession.allRecodesByCID[i].type == "commonRecodeTree") {
						for(let j=0; j < $scope.tableToChartSession.allRecodesByCID[i].dimensions.length; j++) {
							if($scope.tableToChartSession.allRecodesByCID[i].dimensions[j].recodeName != null
								&& $scope.tableToChartSession.allRecodesByCID[i].dimensions[j].recodeName == item.recodeName) {
								conversionFromRecode = $scope.tableToChartSession.allRecodesByCID[i].dimensions[j];
								//treeRoot.savedDims = $scope.tableToChartSession.allRecodesByCID[i].savedDims;
								//treeRoot.savedList = $scope.tableToChartSession.allRecodesByCID[i].savedList;
								break;							
							}
						}
						if(conversionFromRecode)
							break;
					}
					if($scope.tableToChartSession.allRecodesByCID[i].treeName == treeRoot.treeName) {
						conversionFromRecode = $scope.tableToChartSession.allRecodesByCID[i];
						break;
					}				
				} else {
					if($scope.tableToChartSession.allRecodesByCID[i].recodeName == item.recodeName) {
						conversionFromRecode = $scope.tableToChartSession.allRecodesByCID[i];
						break;
					}					
				}
			}
			
			if(conversionFromRecode == null)
				return reject('Custom dimension failed to load')
			
			for (var i = 0; i < $rootScope.dimensionProperties.apiDimTopics.length; i++) {
				var apiDimTopic = $rootScope.dimensionProperties.apiDimTopics[i];
				for (var j = 0; j < apiDimTopic.dimensionGroups.length; j++) {
					var grp = apiDimTopic.dimensionGroups[j];
					for (var k = 0; k < grp.dimensions.length; k++) {
						var dim = grp.dimensions[k];
						if(treeRoot != null) {
							if(dim.recodeTrees) {
								for(var k = 0; k < dim.recodeTrees.length; k++) {
									if(conversionFromRecode.treeName == dim.recodeTrees[k].treeName) {
										for (var l = 0; l < dim.recodeTrees[k].dimensions.length; l++) {
											var level = dim.recodeTrees[k].dimensions[l]
											if(item.recodeName == level.recodeName) {
												conversionRecode = level;
												conversionDim = dim.recodedSrcDims.filter(function(dim) {
													return dim.cId == level.dimCid;
												})[0];
												//conversionRecode.associations = conversionDim.associations;
											}
										}
									}
								}		
							} else if(dim.commonRecodeTrees) {
								for(var k = 0; k < dim.commonRecodeTrees.length; k++) {
									if(conversionFromRecode.treeName == dim.commonRecodeTrees[k].treeName) {
										for (var l = 0; l < dim.commonRecodeTrees[k].dimensions.length; l++) {
											var level = dim.commonRecodeTrees[k].dimensions[l]
											if(item.recodeName == level.recodeName) {
												conversionRecode = level;
												conversionDim = dim.recodedSrcDims.filter(function(dim) {
													return dim.cId == level.dimCid;
												})[0];
												//conversionRecode.associations = conversionDim.associations;
											}
										}
									}
								}
							}
						} else {
							if(dim.recodes) {
								for (var l = 0; l < dim.recodes.length; l++) {
									var recode = dim.recodes[l]
									if(recode.recodeName == item.recodeName) {
										conversionRecode = recode;
										conversionDim = dim;
									}
								}
							} else if(dim.commonRecodes) {
								for (var l = 0; l < dim.commonRecodes.length; l++) {
									var recode = dim.commonRecodes[l]
									if(recode.recodeName == item.recodeName) {
										conversionRecode = recode;
										conversionDim = dim;
									}
								}
							}
						}
					}
				}
			}
			
			conversionRecode.selected = conversionFromRecode.selected;
			//set values to selected so values are found by generic applyRecode() method
			var nonRecodeSelected = conversionFromRecode.nonRecodeValues;
			conversionRecode.nonRecodeValues = nonRecodeSelected;
			conversionRecode.selectedValuesCount = conversionFromRecode.selectedValuesCount;
			conversionRecode.categories = conversionFromRecode.categories;
			
			conversionRecode.def = buildRecode(conversionDim, conversionRecode);
			dimensions.defineDimension($rootScope, conversionRecode, props, false, true);
			
			var selArray = [];
			var addElm = [];
			if(treeRoot) {
				for (var x = 0; x < treeRoot.savedList.length; x++) {
					if (treeRoot.savedList[x].shortName == conversionDim.shortName && treeRoot.savedList[x].selected) {
						addElm.push(treeRoot.savedList[x].qElemNumber);
					}
				}
			} else {
				if (conversionRecode.nonRecodeValues != null && conversionRecode.nonRecodeValues.length > 0)
					selArray = conversionRecode.nonRecodeValues.slice(0);

				for (var x = 0; x < conversionRecode.categories.length; x++) {
					if (conversionRecode.categories[x].selected) {
						selArray = selArray.concat(conversionRecode.categories[x].values);
					}
				}					

				
				for (var x = 0; x < selArray.length; x++) {
					addElm.push(Number(selArray[x].qElemNumber));
				}
			}
			return resolve({
				tree: treeRoot,
				dim: conversionRecode,
				values: addElm
			});
		});
	};
	
	// Invoked each time a measure or dimension is selected, this function will oversee the addition or removal of the selected variable from the Pivot Table
	function updateSelected(qApp, $rootScope, $scope, item, action, addToCol) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {
			if (action == 'add') {
				if (item.type == "dimension") {
					dimensions.addDimension(qApp, $rootScope, item, addToCol).then(function () {
						if (hasAssociationsArray(item)) {
							getSelectedAssociations($rootScope, item);
						};
						return resolve();
					}, function (err) {
						return reject(err);
					});
				}
			}
			if (action == 'remove') {
				if (item.type == "dimension" || item.type == "recode") {
					getAppliedModel(qApp).then(function (model) {

						dimensions.removeDimension(qApp, $rootScope, $rootScope.chart, item).then(function () {
							if (hasAssociationsArray(item)) {
								getSelectedAssociations($rootScope, item);
							}

							var selArray = [];
							var id = item.type == "recode" ? item.dimCid : item.cId;

							var dim = dimensions.getDimensionByCid($rootScope, id);
							if (dim.recodes != null) {
								for (var x = 0; x < dim.recodes.length; x++) {									
									//get all recodes values except current recode values
									if (item.cId != dim.recodes[x].cId && dim.recodes[x].selected) {
										for (var y = 0; y < dim.recodes[x].categories.length; y++) {
											if (dim.recodes[x].categories[y].selected) {
												for (var z = 0; z < dim.recodes[x].categories[y].values.length; z++) {
													selArray.push(Number(dim.recodes[x].categories[y].values[z].qElemNumber));
												}
											}
										}
										for (var y = 0; y < dim.recodes[x].nonRecodeValues.length; y++) {
											if (dim.recodes[x].nonRecodeValues[y].selected) {
												selArray.push(Number(dim.recodes[x].nonRecodeValues[y].qElemNumber));
											}
										}
									}
								};
							}
												
							if (selArray.length == 0) {
								//If parent dim is also selcted then show it's selected values
								if (dim.shortName == "instName" && dim.type == "dimension" && dim.savedValues) {
									for (var x = 0; x < dim.savedValues.length; x++) {
										selArray.push(dim.savedValues[x].qElemNumber);
									}
								} else if (dim.selected && dim.values) {
									for (var x = 0; x < dim.values.length; x++) {
										if (dim.values[x].selected)
											selArray.push(dim.values[x].qElemNumber);
									}
								}
								if (selArray.length > 0) {
									dimensions.addDimensionValues(qApp, dim, selArray).then(function () {
										//$rootScope.visObj.table.OnData.bind( $scope.tblListener );
										return resolve();
									}, function (err) {
										return reject(err);
									});
								} else {
									qApp.field(dim.shortName).clear().then(function() {
										return resolve();
									});
								}
							}
						}, function (err) {
							return reject(err);
						})
					})
				}
			}
		});
	};

	function updateMultipleSelected(qApp, $rootScope) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {

			qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getProperties().then(function (props) {

					props.qHyperCubeDef.qMeasures = [];

					var selectedMsrs = [];
					var topics = $rootScope.measureProperties.apiMeasureTopics;
					for (var x = 0; x < topics.length; x++) {
						for (var y = 0; y < topics[x].measureGroups.length; y++) {
							for (var z = 0; z < topics[x].measureGroups[y].measures.length; z++) {
								if (topics[x].measureGroups[y].measures[z].selected == true) {
									var msr = topics[x].measureGroups[y].measures[z];
									if ($rootScope.displayVisType !== "pivot-table") {
										msr.chartTitle = topics[x].measureGroups[y].groupName;
									}
									selectedMsrs.push(msr);
								} 
							}
						}
					}

					$rootScope.selectedAmountCount = 0;
					for (var x = 0; x < selectedMsrs.length; x++) {
						var item = selectedMsrs[x];
						item.selected = true;
						measures.defineMeasure($rootScope, item, props);

						if (hasAssociationsArray(item)) {
							getSelectedAssociations($rootScope, item);
						}
					};
					//workaround to allow users to apply filter to a dimension.  Filters require a hypercube exist and
					//a hypercube must have a minimum of 1 measure and 1 dimension to exist
					if (props.qHyperCubeDef.qMeasures.length == 0) {
						var dummy = {
							qDef: {
								qDef: "=Count(1)",
								qLabel: "placeHolder",
								cId: 'dummyId'
							}
						};
						props.qHyperCubeDef.qMeasures.push(dummy);
						for (var x = 0; x < topics.length; x++) {
							for (var y = 0; y < topics[x].measureGroups.length; y++) {
								for (var z = 0; z < topics[x].measureGroups[y].measures.length; z++) {
									var msr = topics[x].measureGroups[y].measures[z];
									getSelectedAssociations($rootScope, msr);
								}
							}
						}					
					}
					
					//If update results in only 1 measure selected, then remove -1 (msr indicator) if it is in the sort order
					if(props.qHyperCubeDef.qMeasures.length == 1 && props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1) > -1) {
						if(props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1) < props.qHyperCubeDef.qNoOfLeftDims) {
							props.qHyperCubeDef.qNoOfLeftDims--
						}
						props.qHyperCubeDef.qInterColumnSortOrder.splice(props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1), 1);
					}
					measures.applyPercentages($rootScope, props)

					obj.setProperties(props).then(function (properties_set) {
						return resolve('ok');
					}, function (err) {
						console.log('setPropErr1stTry');
						return reject(err);
					});
				}, function (err) {
					return reject(err);
				});
			}, function (err) {
				return reject(err);
			});
		});
	};

	function updateFilterValueSingleList(qApp, $rootScope, $scope, dim, addToCol) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {

			qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getProperties().then(function (props) {

					var selArray = dim.values;
					var addElm = [];
					for (var x = 0; x < selArray.length; x++) {
						if (selArray[x].selected) {
							addElm.push(Number(selArray[x].qElemNumber));
						}
					}

					var foundDim = false;
					for (var x = 0; x < props.qHyperCubeDef.qDimensions.length; x++) {
						if (props.qHyperCubeDef.qDimensions[x].qDef.cId === dim.cId) {
							foundDim = true;
							break;
						}
					}

					if (!foundDim && $rootScope.displayVisType !== "pivot-table") {
						if (props.qHyperCubeDef.qLayoutExclude && props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length > 0) {
							for (var x = 0; x < props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length; x++) {
								if (props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions[x].qDef.cId === dim.cId) {
									foundDim = true;
									break;
								}
							}
						}
					}

					if (foundDim) {
						if (addElm.length == 0) {
							dim.selected = false;
							updateSelected(qApp, $rootScope, $scope, dim, "remove").then(function () {
								return resolve("del");
							}, function (err) {
								return reject(err);
							});
						} else if (addElm.length > 0) {
							dimensions.addDimensionValues(qApp, dim, addElm).then(function () {
								return resolve();
							}, function (err) {
								return reject(err);
							});
						} else {
							//bothing to do
							return resolve();
						}
					} else {
						//2 updates to hypercube, so unbind for 1st update, then re-bind so hypercube listener triggered one time
						$rootScope.visObj.table.OnData.unbind($scope.tblListener);
						updateSelected(qApp, $rootScope, $scope, dim, "add", addToCol).then(function () {
							dimensions.addDimensionValues(qApp, dim, addElm).then(function () {
								$rootScope.visObj.table.OnData.bind($scope.tblListener);
								return resolve();
							}, function (err) {
								return reject(err);
							});															
							
							
							//add delay to avoid occassional non-critical data item not found error
/* 							setTimeout(function () {
								$rootScope.visObj.table.OnData.bind($scope.tblListener);
								dimensions.addDimensionValues(qApp, dim, addElm).then(function () {
									return resolve();
								}, function (err) {
									return reject(err);
								});								
								return resolve();
							}, 500); */	
								
/* 							dimensions.addDimensionValues(qApp, dim, addElm).then(function () {
								setTimeout(function () {
									$rootScope.visObj.table.OnData.bind($scope.tblListener);
									$rootScope.$broadcast('modifiedVisualizationEvent');
									return resolve();
								}, 500);										
							}, function (err) {
								return reject(err);
							});	 */							
							
						}, function (err) {
							return reject(err);
						});

					}
				}, function (err) {
					return reject(err);
				});
			}, function (err) {
				return reject(err);
			});
		});
	}

	function applyRecode(qApp, $rootScope, $scope, addToCol) {
		var Promise = qlik.Promise;
		return new Promise(function (resolve, reject) {
			var dim = $scope.dim;
			var recode = $scope.recode;

			qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getProperties().then(function (props) {

					var selArray = [];
					if (recode.nonRecodeValues != null && recode.nonRecodeValues.length > 0)
						selArray = recode.nonRecodeValues.slice(0);

					for (var x = 0; x < recode.categories.length; x++) {
						if (recode.categories[x].selected) {
							selArray = selArray.concat(recode.categories[x].values);
						}
					}					

					var addElm = [];
					for (var x = 0; x < selArray.length; x++) {
						addElm.push(Number(selArray[x].qElemNumber));
					}

					var foundDim = null;
					for (var x = 0; x < props.qHyperCubeDef.qDimensions.length; x++) {
						if (props.qHyperCubeDef.qDimensions[x].qDef.cId === recode.cId) {
							foundDim = props.qHyperCubeDef.qDimensions[x];
							break;
						}
					}

					if (!foundDim && $rootScope.displayVisType !== "pivot-table") {
						if (props.qHyperCubeDef.qLayoutExclude && props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length > 0) {
							for (var x = 0; x < props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length; x++) {
								if (props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions[x].qDef.cId === recode.cId) {
									foundDim = props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions[x];
									break;
								}
							}
						}
					}

					recode.recodeDef = buildRecode(dim, recode);

					if (foundDim) {
						//recode already added, apply updated definition
						if (foundDim.qDef.qFieldDefs[0] != recode.recodeDef) {
							//recode was selected so set dim def to recode definition
							$rootScope.visObj.table.OnData.unbind($scope.tblListener);
							foundDim.qDef.qFieldDefs = [recode.recodeDef];
							obj.setProperties(props).then(function (properties_set) {
								dimensions.addDimensionValues(qApp, dim, addElm).then(function () {
									$rootScope.visObj.table.OnData.bind($scope.tblListener);
									getSelectedAssociations($rootScope, dim);
									return resolve();
								}, function (err) {
									return reject(err);
								});
							}, function (err) {
								return reject(err);
							})

						} else {

							if (addElm.length == 0) {
								var recodedDim = {}
								recodedDim.cId = recode.cId;
								recode.selected = false;
								dimensions.removeDimension(qApp, $rootScope, $rootScope.chart, recodedDim).then(function () {
									getSelectedAssociations($rootScope, dim);

									if (addElm.length == 0) {
										//If parent dim is also selcted then show it's selected values
										if (dim.selected) {
											for (var x = 0; x < dim.values.length; x++) {
												if (dim.values[x].selected)
													addElm.push(dim.values[x].qElemNumber);
											}
										}
									}

									dimensions.addDimensionValues(qApp, dim, addElm).then(function () {
										return resolve("del");
									}, function (err) {
										return reject(err);
									});
								});
							} else if (addElm.length > 0) {
								dimensions.addDimensionValues(qApp, dim, addElm).then(function () {
									getSelectedAssociations($rootScope, dim);
									$scope.dim.recodeSelected = true;
									return resolve();
								}, function (err) {
									return reject(err);
								});
							}
						}
					} else {
						var recodedDim = {}
						recodedDim.cId = recode.cId;
						recodedDim.shortName = dim.shortName;
						recodedDim.def = recode.recodeDef;
						recodedDim.title = recode.recodeName;
						recodedDim.valueSortDefault = dim.valueSortDefault;
						$rootScope.visObj.table.OnData.unbind($scope.tblListener);
						dimensions.addDimension(qApp, $rootScope, recodedDim, addToCol, false).then(function () {
							dimensions.addDimensionValues(qApp, recodedDim, addElm).then(function () {
								$rootScope.visObj.table.OnData.bind($scope.tblListener);
								$scope.dim.recodeSelected = true;
								// if (dim.type == "dim-branch" && dim.treeRoot) {
									// dim.treeRoot.recodeSelected = true;
								// }
								getSelectedAssociations($rootScope, dim);
								return resolve();
							}, function (err) {
								//console.log(err);
								return reject(err);
							});
						}, function (err) {
							return reject(err);
						});

					}
				}, function (err) {
					return reject(err);
				});
			}, function (err) {
				return reject(err);
			});
		});
	}
 
	function buildRecode(dim, recode) {
		var defs = [];
		var defStr = "<FIELD>";

		for (var x = 0; x < recode.categories.length; x++) {
			//if(recode.categories[x].selected) {
				var val = "";
				for (var y = 0; y < recode.categories[x].values.length; y++) {
					val += "'" + recode.categories[x].values[y].qText.replace(/\'/g, "''") + "',";
				}
				val = val.substring(0, val.lastIndexOf(","));
				defs.push("if(Match([" + dim.shortName + "], " + val + "), '" + recode.categories[x].qText.replace("'", "''") + "', <FIELD>)");
			//}
		}

		defStr = "<FIELD>";
		for (var x = 0; x < defs.length; x++) {
			if (x == 0)
				defStr = defs[x];
			else {
				defStr = defStr.replace("<FIELD>", defs[x]);
			}
		}
		defStr = "=aggr(" + defStr.replace("<FIELD>", "[" + dim.shortName + "]") + ", [" + dim.shortName + "])";
		return defStr;
	}

	function updateTreeFilterValue(qApp, $rootScope, $scope, addToCol) {
		return new Promise(function (resolve, reject) {
			$rootScope.visObj.table.OnData.unbind($scope.tblListener);
			//clear out old filter
			removeTreeFilters(qApp, $rootScope, $scope, $scope.tree.rootDim).then(function () {
				var selArray = appUtilities.findValuesMatches("class", ["s", "t"], $scope.tree.selectedTreeValues);
				if (selArray.length == 0) {
					$rootScope.visObj.table.OnData.bind($scope.tblListener);
					return resolve("del");
				}
				qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getProperties().then(function (props) {
						var dims = appUtilities.findMatches("selected", true, $scope.tree.dimensions);
						for (var i = 0; i < dims.length; i++) {
							dimensions.defineDimension($rootScope, dims[i], props, addToCol);
						}

						switch ($rootScope.displayVisType) {
						case 'linechart':
							if (props.qHyperCubeDef.qDimensions.length > 1) {
								props.qHyperCubeDef.qMode = 'K';
								props.qHyperCubeDef.qAlwaysFullyExpanded = true;
							} else {
								props.qHyperCubeDef.qMode = 'S';
								props.qHyperCubeDef.qAlwaysFullyExpanded = false;
							}
							break;
						case 'barchart':
							if ($rootScope.chart.barType == 'v-stacked' || $rootScope.chart.barType == 'h-stacked') {
								props.qHyperCubeDef.qMode = 'K';
								props.qHyperCubeDef.qAlwaysFullyExpanded = true;
							} else {
								props.qHyperCubeDef.qMode = 'S';
								props.qHyperCubeDef.qAlwaysFullyExpanded = false;
							}
							break;
						}
						//applying filters before adding dimensions to hypercube so that selectionState is refreshed prior to
						//table listener is triggered - this solved problems with Tree dimensions triggering listener before selection state refreshed
						//alternative approach is to link a seperate listener to selection state
						
						applyTreeFilters(qApp, selArray, $scope.tree).then(function () {
							obj.setProperties(props).then(function (properties_set) {
								$rootScope.visObj.table.OnData.bind($scope.tblListener);
								resolve();
							}, function (err) {
								console.log('setPropErr');
							});
						}, function (err) {
							reject(err);
						});
					}, function (err) {
						return reject(err);
					});
				}, function (err) {
					return reject(err);
				});
			})
		});
	}
	

 	function updateRecodeTreeFilterValue(qApp, $rootScope, $scope, recodeTree, addToCol) {
		return new Promise(function (resolve, reject) {
			$rootScope.visObj.table.OnData.unbind($scope.tblListener);
			//clear out old filter
			removeTreeFilters(qApp, $rootScope, $scope, null, recodeTree).then(function () {
				var selArray = appUtilities.findValuesMatches("class", ["s", "t"], recodeTree.selectedTreeValues);
			
				var testObj = {}
				if (selArray.length == 0) {
					$rootScope.visObj.table.OnData.bind($scope.tblListener);
					return resolve("del");
				}
				qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getProperties().then(function (props) {
						var dims = appUtilities.findMatches("selected", true, recodeTree.dimensions);
						for (var i = 0; i < dims.length; i++) {
							if(dims[i].type == "recode") {
								dims[i].recodeDef = buildRecode(dims[i], dims[i]);
								dimensions.defineDimension($rootScope, dims[i], props, addToCol);
							} else {
								dimensions.defineDimension($rootScope, dims[i], props, addToCol);
							}
						
						}

						switch ($rootScope.displayVisType) {
						case 'linechart':
							if (props.qHyperCubeDef.qDimensions.length > 1) {
								props.qHyperCubeDef.qMode = 'K';
								props.qHyperCubeDef.qAlwaysFullyExpanded = true;
							} else {
								props.qHyperCubeDef.qMode = 'S';
								props.qHyperCubeDef.qAlwaysFullyExpanded = false;
							}
							break;
						case 'barchart':
							if ($rootScope.chart.barType == 'v-stacked' || $rootScope.chart.barType == 'h-stacked') {
								props.qHyperCubeDef.qMode = 'K';
								props.qHyperCubeDef.qAlwaysFullyExpanded = true;
							} else {
								props.qHyperCubeDef.qMode = 'S';
								props.qHyperCubeDef.qAlwaysFullyExpanded = false;
							}
							break;
						}
						//applying filters before adding dimensions to hypercube so that selectionState is refreshed prior to
						//table listener is triggered - this solved problems with Tree dimensions triggering listener before selection state refreshed
						//alternative approach is to link a seperate listener to selection state
						applyTreeFilters(qApp, selArray, recodeTree).then(function () {
							obj.setProperties(props).then(function (properties_set) {
								$rootScope.visObj.table.OnData.bind($scope.tblListener);
								resolve();
							}, function (err) {
								console.log('setPropErr');
							});
						}, function (err) {
							reject(err);
						});
					}, function (err) {
						return reject(err);
					});
				}, function (err) {
					return reject(err);
				});
			})
		});
	}	

	function removeTreeFilters(qApp, $rootScope, $scope, rootDim, recodeTree) {
		return new Promise(function (resolve, reject) {
			
		
			var treeDims;
			if(rootDim) {
				treeDims = dimensions.getDimensionsForTree(rootDim);
				rootDim.selected = false;
			} else {
				treeDims = recodeTree.dimensions;
				recodeTree.selected = false;
			}
			dimensions.removeTreeDimension(qApp, $rootScope, $scope, treeDims).then(function () {
				getAppliedModel(qApp).then(function (model) {
					function clearField(field) {
						return new Promise(function (resolve, reject) {
							field.clear().then(function (obj) {
								//console.log(obj);
								return resolve();
							});
						})
					}

					var promises = [];
					for (var h = 0; h < model.layout.qSelectionObject.qSelections.length; h++) {
						for (var j = 0; j < treeDims.length; j++) {
							if (treeDims[j].shortName.toLowerCase().trim() == model.layout.qSelectionObject.qSelections[h].qField.toLowerCase().trim() ||
								treeDims[j].shortName.toLowerCase().trim() == (model.layout.qSelectionObject.qSelections[h].qReadableName == null ? "" : model.layout.qSelectionObject.qSelections[h].qReadableName.toLowerCase().trim())) {
								for (var i = 0; i < $rootScope.selState.selections.length; i++) {
									if (model.layout.qSelectionObject.qSelections[h].qField == $rootScope.selState.selections[i].fieldName) {
										promises.push(clearField($rootScope.selState.selections[i].field));
									}
								}
							}
						}
					}
					Promise.all(promises).then(function (retObj) {
						return resolve();
					})
				})
			}, function (err) {
				//appUtilities.showError(err);
				return reject(err);
			})

		})
	}
	
	function applyTreeFilters(qApp, selArray, tree) {
		return new Promise(function (resolve, reject) {
			if (selArray.length == tree.selectedTreeValues.length) {
				return resolve();
			} else {
				var selDims = appUtilities.findMatches("selected", true, tree.dimensions);
				var i;
				for (i = 0; i < selDims.length; i++) {
					var dimValues = appUtilities.findMatches("shortName", selDims[i].shortName, selArray);
					var values = [];
					
					//extract value label to apply filter - if value is a recode, then get the underlying values represented by the recode
					for (var z = 0; z < dimValues.length; z++) {
						if(dimValues[z].recode) {
							if(selDims[i].categories != null) {
								for(var a = 0; a < selDims[i].categories.length; a++) {
									if(dimValues[z].qText == selDims[i].categories[a].qText) {
										for(var b =0; b < selDims[i].categories[a].values.length; b++) {
											values.push(selDims[i].categories[a].values[b].qText);
										}
									}
								}
							}
						} else {
							values.push(dimValues[z].qText);
						}
					}
					if (values.length > 0) {
						qApp.field(selDims[i].shortName).selectValues(values, false, true).then(function () {	
							return resolve();
						}, function(err) {
							console.log('err', err);
							return reject;
						});
					}
				}
				if (i < 0)
					return resolve();
			}
		})
	}

	function getExportSupplementalData(qlik, $rootScope, $scope, $http, dateStr, notes) {
		return new qlik.Promise(function (resolve, reject) {

			async function getDimensions() {
				var state = $rootScope.qApp.selectionState();
				var list = [];
				var strFilter = "Filters:\n";
				for (var w = 0; w < $rootScope.dimensionProperties.apiDimTopics.length; w++) {
					var topic = $rootScope.dimensionProperties.apiDimTopics[w];
					for (var x = 0; x < topic.dimensionGroups.length; x++) {
						var grp = topic.dimensionGroups[x];
						for (var y = 0; y < grp.dimensions.length; y++) {
							if (grp.dimensions[y].hierarchyAvailable == "Y") {
								if (grp.dimensions[y].selected == true) {
									for (var z = 0; z < grp.dimensions[y].savedDims.length; z++) {
										if (grp.dimensions[y].savedDims[z].selected) {
											let branch = grp.dimensions[y].savedDims[z];
											var dim = {};
											dim.field = state.selections.find(function(fld) {
												if (branch.shortName == fld.fieldName) {
													return fld;
												}
											})
											if(dim.field == null) {
												if (branch.newTitle != null && branch.newTitle.length > 0) {
													dim.title = branch.newTitle;
												} else {
													dim.title = branch.title;
												}
												list.push(dim);	
											} else {
												//dim.values = await getSelectedValues(dim.field);
												dim.values = [];
												let values = await dimensions.getValuesByDimension($rootScope.qApp,branch);
												for(let x = 0; x < values.length; x++) {
													if (values[x].qState == 'S') {
														dim.values.push(values[x].qText);
													}
												}												
												if (branch.newTitle != null && branch.newTitle.length > 0)
													dim.title = branch.newTitle;
												else
													dim.title = branch.title;
												list.push(dim);
											}
										}
									}
								} else if (grp.dimensions[y].recodeTrees) {
									for(let a = 0; a < grp.dimensions[y].recodeTrees.length; a++) {
									
										if(grp.dimensions[y].recodeTrees[a].selected) {
											let tmpTree = grp.dimensions[y].recodeTrees[a];
											if (tmpTree.selected) {
												for (var b = 0; b < tmpTree.dimensions.length; b++) {
													if (tmpTree.dimensions[b].selected) {
														let dim = {};
														let branch = tmpTree.dimensions[b];
														dim.field = state.selections.find(function(fld) {
															if (branch.shortName == fld.fieldName) {
																return fld;
															}
														})
														if(dim.field == null) {
															if (branch.newTitle != null && branch.newTitle.length > 0) {
																dim.title = branch.newTitle;
															} else {
																dim.title = branch.title;
															}
															list.push(dim);
														} else {
															dim.values = [];
															if(branch.type == "dim-branch") {
																//dim.values = await getSelectedValues(dim.field);
																dim.values = [];
																let values = await dimensions.getValuesByDimension($rootScope.qApp,branch);
																for(let x = 0; x < values.length; x++) {
																	if (values[x].qState == 'S') {
																		dim.values.push(values[x].qText);
																	}
																}

																if (branch.newTitle != null && branch.newTitle.length > 0)
																	dim.title = branch.newTitle;
																else
																	dim.title = branch.title;
															} else if(branch.type == "recode") {
																tmpTree.selectedTreeValues.forEach(function(val) {
																	if(val.selected == true && val.shortName == branch.shortName) {
																		dim.values.push(val.qText)
																	}
																})
																dim.title = branch.recodeName + " [Custom Dimension of " + branch.title + "]";																			
															}
															list.push(dim);
														}
													}
												}
											}
										}
									}
								} else if (grp.dimensions[y].commonRecodeTrees) {
									for(let a = 0; a < grp.dimensions[y].commonRecodeTrees.length; a++) {
									
										if(grp.dimensions[y].commonRecodeTrees[a].selected) {
											let tmpTree = grp.dimensions[y].commonRecodeTrees[a];
											if (tmpTree.selected) {
												for (var b = 0; b < tmpTree.dimensions.length; b++) {
													if (tmpTree.dimensions[b].selected) {
														let dim = {};
														let branch = tmpTree.dimensions[b];
														dim.field = state.selections.find(function(fld) {
															if (branch.shortName == fld.fieldName) {
																return fld;
															}
														})
														if(dim.field == null) {
															if (branch.newTitle != null && branch.newTitle.length > 0) {
																dim.title = branch.newTitle;
															} else {
																dim.title = branch.title;
															}
															list.push(dim);
														} else {
															dim.values = [];
															if(branch.type == "dim-branch") {
																//dim.values = await getSelectedValues(dim.field);
																dim.values = [];
																let values = await dimensions.getValuesByDimension($rootScope.qApp,branch);
																for(let x = 0; x < values.length; x++) {
																	if (values[x].qState == 'S') {
																		dim.values.push(values[x].qText);
																	}
																}

																if (branch.newTitle != null && branch.newTitle.length > 0)
																	dim.title = branch.newTitle;
																else
																	dim.title = branch.title;
															} else if(branch.type == "recode") {
																tmpTree.selectedTreeValues.forEach(function(val) {
																	if(val.selected == true && val.shortName == branch.shortName) {
																		dim.values.push(val.qText)
																	}
																})
																dim.title = branch.recodeName + " [Custom Dimension of " + branch.title + "]";																			
															}
															list.push(dim);
														}
													}
												}
											}
										}
									}
								}
							} else if (grp.dimensions[y].selected) {
								var dim = {};
								if (grp.dimensions[y].newTitle != null && grp.dimensions[y].newTitle.length > 0) {
									dim.title = grp.dimensions[y].newTitle;
								} else {
									dim.title = grp.dimensions[y].title;
								}
								dim.field = state.selections.find(function(fld) {
									if (grp.dimensions[y].shortName == fld.fieldName) {
										return fld;
									}
								})
								if(dim.field == null) {
									if (grp.dimensions[y].newTitle != null && grp.dimensions[y].newTitle.length > 0) {
										dim.title = grp.dimensions[y].newTitle;
									} else {
										dim.title = grp.dimensions[y].title;
									}
									list.push(dim);
								} else {
									//dim.values = await getSelectedValues(dim.field);
									dim.values = [];
									let values = await dimensions.getValuesByDimension($rootScope.qApp, grp.dimensions[y]);
									for(let x = 0; x < values.length; x++) {
										if (values[x].qState == 'S') {
											dim.values.push(values[x].qText);
										}
									}
									if (grp.dimensions[y].newTitle != null && grp.dimensions[y].newTitle.length > 0) {
										dim.title = grp.dimensions[y].newTitle;
									} else {
										dim.title = grp.dimensions[y].title;
									}
									list.push(dim);
								}
							} else if (grp.dimensions[y].recodes) {
								for (let a = 0; a < grp.dimensions[y].recodes.length; a++) {
									if (grp.dimensions[y].recodes[a].selected) {
										let dim = {};
										let recode = grp.dimensions[y].recodes[a];
										dim.values = [];
										recode.categories.forEach(function(cat) {
											if(cat.selected)
												dim.values.push(cat.qText)
										})
										recode.nonRecodeValues.forEach(function(val) {
											dim.values.push(val.qText)
										})
										dim.title = grp.dimensions[y].recodes[a].recodeName + " [Custom Dimension of " + grp.dimensions[y].title + "]";
										list.push(dim);
									}
								}
							} else if (grp.dimensions[y].commonRecodes) {
								for (let a = 0; a < grp.dimensions[y].commonRecodes.length; a++) {
									if (grp.dimensions[y].commonRecodes[a].selected) {
										let dim = {};
										let recode = grp.dimensions[y].commonRecodes[a];
										dim.values = [];
										recode.categories.forEach(function(cat) {
											if(cat.selected)
												dim.values.push(cat.qText)
										})
										recode.nonRecodeValues.forEach(function(val) {
											dim.values.push(val.qText)
										})
										dim.title = grp.dimensions[y].commonRecodes[a].recodeName + " [Custom Dimension of " + grp.dimensions[y].title + "]";
										list.push(dim);
									}
								}
							}
						
						};
					}
				};

				for (var v = 0; v < list.length; v++) {
					var strDim = "  " + list[v].title + "\n"; //+ (type == 'csv' ? "," : " - ");
					var strLine = "";
					if(list[v].field == null && list[v].values == null) {
						strLine += "    ALL" + "\n";
					} else if (list[v].field != null && list[v].field.selectedCount == list[v].field.totalCount) {
						strLine += "    ALL" + "\n";
					} else if(list[v].values != null) {
						list[v].values.map(function(val) {
							strLine += "    " + val + "\n";
						})
					}
					strFilter += strDim + strLine + "\n";
				}
				return(strFilter)
			}

			function getRecodes(props) {

				var strRecodes = '';
				var recodes = [];
				for (var w = 0; w < $rootScope.dimensionProperties.apiDimTopics.length; w++) {
					var topic = $rootScope.dimensionProperties.apiDimTopics[w];
					for (var x = 0; x < topic.dimensionGroups.length; x++) {
						var grp = topic.dimensionGroups[x];
						for (var y = 0; y < grp.dimensions.length; y++) {
							
							if (grp.dimensions[y].hierarchyAvailable == "Y") {
								if(grp.dimensions[y].recodeTrees != null) {
									for (var z = 0; z < grp.dimensions[y].recodeTrees.length; z++) {
										let tree = grp.dimensions[y].recodeTrees[z];
										if (tree.selected) {
											for (var a = 0; a < tree.savedDims.length; a++) {
												if (tree.savedDims[a].type == "recode") {
													addRecodeToList(props, recodes, tree.savedDims[a]);
												}
											}
										}
									}
								} else if(grp.dimensions[y].commonRecodeTrees != null) {
									for (var z = 0; z < grp.dimensions[y].commonRecodeTrees.length; z++) {
										let tree = grp.dimensions[y].commonRecodeTrees[z];
										if (tree.selected) {
											for (var a = 0; a < tree.savedDims.length; a++) {
												if (tree.savedDims[a].type == "recode") {
													addRecodeToList(props, recodes, tree.savedDims[a]);
												}
											}
										}
									}
								}
							} else if (grp.dimensions[y].recodes) {
								for (var a = 0; a < grp.dimensions[y].recodes.length; a++) {
									if (grp.dimensions[y].recodes[a].selected) {
										addRecodeToList(props, recodes, grp.dimensions[y].recodes[a]);
									}
								}
							} else if (grp.dimensions[y].commonRecodes) {
								for (var a = 0; a < grp.dimensions[y].commonRecodes.length; a++) {
									if (grp.dimensions[y].commonRecodes[a].selected) {
										addRecodeToList(props, recodes, grp.dimensions[y].commonRecodes[a]);
									}
								}
							}
						}
					}
				}

				var strLine = "";
				for (var v = 0; v < recodes.length; v++) {
					strLine += "  " + recodes[v].recodeName + "\n";
					for (var x = 0; x < recodes[v].categories.length; x++) {
						strLine += "    " + recodes[v].categories[x].qText + "\n";
						for (var y = 0; y < recodes[v].categories[x].values.length; y++) {
							strLine += "      " + recodes[v].categories[x].values[y].qText + "\n"
						}
					}
					strLine += "\n"
				}
				if (strLine.length > 0)
					strRecodes = "Custom Dimension Definitions:\n  Name/Category/Value:\n" + strLine + "\n";

				return strRecodes;
			}
			
			function addRecodeToList(props, recodes, item) {
				var recode = {};
				recode.recodeName = item.recodeName;
				recode.showInRow = isRecodePlacedInRows(props, item);
				recode.categories = [];
				for (var x = 0; x < item.categories.length; x++) {
					//if (item.categories[x].selected)
					recode.categories.push(item.categories[x]);
				};
				recodes.push(recode);
			}

			function isRecodePlacedInRows(props, recode) {
				for (var x = 0; x < props.qHyperCubeDef.qDimensions.length; x++) {
					if (props.qHyperCubeDef.qDimensions[x].qDef.cId == recode.cId) {
						if (x < props.qHyperCubeDef.qNoOfLeftDims)
							return true;
						else
							return false;
					}
				}
			}				

			function buildMeasureLabel(qlik, $rootScope, $http) {
				return new qlik.Promise(function (resolve, reject) {
					var list = [];
					var strMsrs = "Measures:\n";
					for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
						var apiGrps = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups;
						for (var j = 0; j < apiGrps.length; j++) {
							for (var k = 0; k < apiGrps[j].measures.length; k++) {
								if (apiGrps[j].measures[k].selected == true) {
									list.push(apiGrps[j].measures[k].variableId);
								}
							}
						}
					}

					appUtilities.getSurveyVariableListFromApi(qlik, $http, list).then(function (apiDetails) {
						for (var d = 0; d < apiDetails.data.body.content.length; d++) {
							var content = apiDetails.data.body.content[d];
							strMsrs += "  " + content.variableShortDescription + "\n";
						}
						return resolve(strMsrs+"\n");
					}, function (err) {
						return reject(err);
					});

				});
			}

			function buildDisplayOptions($scope) {
				var strOptions = ""
				if ($rootScope.selectedAmountCount > 0 && $scope.amountOptions.show) {
					for (var i = 0; i < $scope.amountOptions.deflators.length; i++) {
						if ($scope.amountOptions.deflators[i].value == $scope.deflatorSelected)
							strOptions = "Deflator: " + $scope.amountOptions.deflators[i].name + "\n";
					}
					for (var i = 0; i < $scope.amountOptions.unitsOfMeasure.length; i++) {
						if ($scope.amountOptions.unitsOfMeasure[i].value == $scope.unitsSelected)
							strOptions += "Unit of Measure: " + $scope.amountOptions.unitsOfMeasure[i].name + "\n";
					}
					strOptions + "\n";
				}
				return strOptions;
			}
			
			function getFooter() {
				let footer = ""

				if(notes && notes.length > 0) {
					//For most surveys that are show Totals, UnitsOfMsr needs to be $1000, but for NSCG and SDR which do not support UoM they always show Totals
					if($rootScope.survey.showTotalsNotice && ($rootScope.unitsOfMeasureValue == 0 || $rootScope.unitsOfMeasureValue > 1)) {
						footer = "Because of rounding, detail may not add to total.\n";
					}
					for(let x = 0; x < notes.length; x++) {
						footer += notes[x] + "\n";
					}
				}
				if(footer != "") 
					footer = "\nNotes:\n" + footer

				return footer;
			}

			$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getEffectiveProperties().then(function (props) {

					let strContent = "Data Download from NCSES " + ($rootScope.displayVisType == 'pivot-table'?"Table Builder":"Chart Builder") + "\n";
					strContent += appUtilities.getSurveySource($rootScope) +  "\nDownloaded: " + dateStr + "\n\n";
					buildMeasureLabel(qlik, $rootScope, $http).then(function (msrs) {
						strContent += msrs;
						getDimensions().then(function(content) {
							strContent += content;
							strContent += getRecodes(props);
							strContent += buildDisplayOptions($scope);
							if($rootScope.displayVisType == "pivot-table"){
								strContent += getFooter();
							}
							return resolve(strContent);
						})
					}, function (err) {
						return reject(err);
					})
				})
			})
		});
	}

	return {
		getAppliedModel: getAppliedModel,
		getDimensionList: getDimensionList,
		getSelectedAssociations: getSelectedAssociations,
		hasAssociationsArray: hasAssociationsArray,
		setVisualizationDefaults: setVisualizationDefaults,
		setTableChartVariables: setTableChartVariables,
		updateFilterValueSingleList: updateFilterValueSingleList,
		updateTreeFilterValue: updateTreeFilterValue,
		updateSelected: updateSelected,
		updateMultipleSelected: updateMultipleSelected,
		removeTreeFilters: removeTreeFilters,
		getExportSupplementalData: getExportSupplementalData,
		applyRecode: applyRecode,
		buildRecode: buildRecode,
		updateRecodeTreeFilterValue: updateRecodeTreeFilterValue
	};
});

/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define('scripts/lib/jszip',[],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.JSZip = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";
var utils = require("./utils");
var support = require("./support");
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;

    var isArray = utils.getTypeOf(input) !== "string";
    while (i < input.length) {
        remainingBytes = len - i;

        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;

        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));

    }

    return output.join("");
};

// public method for decoding
exports.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;

    var dataUrlPrefix = "data:";

    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
        // This is a common error: people give a data url
        // (data:image/png;base64,iVBOR...) with a {base64: true} and
        // wonders why things don't work.
        // We can detect that the string input looks like a data url but we
        // *can't* be sure it is one: removing everything up to the comma would
        // be too dangerous.
        throw new Error("Invalid base64 input, it looks like a data url.");
    }

    input = input.replace(/[^A-Za-z0-9+/=]/g, "");

    var totalLength = input.length * 3 / 4;
    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if (totalLength % 1 !== 0) {
        // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        //   beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
    }
    var output;
    if (support.uint8array) {
        output = new Uint8Array(totalLength|0);
    } else {
        output = new Array(totalLength|0);
    }

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output[resultIndex++] = chr1;

        if (enc3 !== 64) {
            output[resultIndex++] = chr2;
        }
        if (enc4 !== 64) {
            output[resultIndex++] = chr3;
        }

    }

    return output;
};

},{"./support":30,"./utils":32}],2:[function(require,module,exports){
"use strict";

var external = require("./external");
var DataWorker = require("./stream/DataWorker");
var Crc32Probe = require("./stream/Crc32Probe");
var DataLengthProbe = require("./stream/DataLengthProbe");

/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */
function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}

CompressedObject.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */
    getContentWorker: function () {
        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
            .pipe(this.compression.uncompressWorker())
            .pipe(new DataLengthProbe("data_length"));

        var that = this;
        worker.on("end", function () {
            if (this.streamInfo["data_length"] !== that.uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */
    getCompressedWorker: function () {
        return new DataWorker(external.Promise.resolve(this.compressedContent))
            .withStreamInfo("compressedSize", this.compressedSize)
            .withStreamInfo("uncompressedSize", this.uncompressedSize)
            .withStreamInfo("crc32", this.crc32)
            .withStreamInfo("compression", this.compression)
        ;
    }
};

/**
 * Chain the given worker with other workers to compress the content with the
 * given compression.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */
CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker
        .pipe(new Crc32Probe())
        .pipe(new DataLengthProbe("uncompressedSize"))
        .pipe(compression.compressWorker(compressionOptions))
        .pipe(new DataLengthProbe("compressedSize"))
        .withStreamInfo("compression", compression);
};

module.exports = CompressedObject;

},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(require,module,exports){
"use strict";

var GenericWorker = require("./stream/GenericWorker");

exports.STORE = {
    magic: "\x00\x00",
    compressWorker : function () {
        return new GenericWorker("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker("STORE decompression");
    }
};
exports.DEFLATE = require("./flate");

},{"./flate":7,"./stream/GenericWorker":28}],4:[function(require,module,exports){
"use strict";

var utils = require("./utils");

/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];

    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
    }

    return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

// That's all for the pako functions.

/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */
function crc32str(crc, str, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

module.exports = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if(isArray) {
        return crc32(crc|0, input, input.length, 0);
    } else {
        return crc32str(crc|0, input, input.length, 0);
    }
};

},{"./utils":32}],5:[function(require,module,exports){
"use strict";
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = true;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;

},{}],6:[function(require,module,exports){
"use strict";

// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var ES6Promise = null;
if (typeof Promise !== "undefined") {
    ES6Promise = Promise;
} else {
    ES6Promise = require("lie");
}

/**
 * Let the user use/change some implementations.
 */
module.exports = {
    Promise: ES6Promise
};

},{"lie":37}],7:[function(require,module,exports){
"use strict";
var USE_TYPEDARRAY = (typeof Uint8Array !== "undefined") && (typeof Uint16Array !== "undefined") && (typeof Uint32Array !== "undefined");

var pako = require("pako");
var utils = require("./utils");
var GenericWorker = require("./stream/GenericWorker");

var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";

/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */
function FlateWorker(action, options) {
    GenericWorker.call(this, "FlateWorker/" + action);

    this._pako = null;
    this._pakoAction = action;
    this._pakoOptions = options;
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};
}

utils.inherits(FlateWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
FlateWorker.prototype.processChunk = function (chunk) {
    this.meta = chunk.meta;
    if (this._pako === null) {
        this._createPako();
    }
    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
};

/**
 * @see GenericWorker.flush
 */
FlateWorker.prototype.flush = function () {
    GenericWorker.prototype.flush.call(this);
    if (this._pako === null) {
        this._createPako();
    }
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */
FlateWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this._pako = null;
};

/**
 * Create the _pako object.
 * TODO: lazy-loading this object isn't the best solution but it's the
 * quickest. The best solution is to lazy-load the worker list. See also the
 * issue #446.
 */
FlateWorker.prototype._createPako = function () {
    this._pako = new pako[this._pakoAction]({
        raw: true,
        level: this._pakoOptions.level || -1 // default compression
    });
    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data : data,
            meta : self.meta
        });
    };
};

exports.compressWorker = function (compressionOptions) {
    return new FlateWorker("Deflate", compressionOptions);
};
exports.uncompressWorker = function () {
    return new FlateWorker("Inflate", {});
};

},{"./stream/GenericWorker":28,"./utils":32,"pako":38}],8:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var GenericWorker = require("../stream/GenericWorker");
var utf8 = require("../utf8");
var crc32 = require("../crc32");
var signature = require("../signature");

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "", i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */
var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

    var result = unixPermissions;
    if (!unixPermissions) {
        // I can't use octal values in strict mode, hence the hexa.
        //  040775 => 0x41fd
        // 0100664 => 0x81b4
        result = isDir ? 0x41fd : 0x81b4;
    }
    return (result & 0xFFFF) << 16;
};

/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */
var generateDosExternalFileAttr = function (dosPermissions) {
    // the dir flag is already set for compatibility
    return (dosPermissions || 0)  & 0x3F;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with information about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */
var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo["file"],
        compression = streamInfo["compression"],
        useCustomEncoding = encodeFileName !== utf8.utf8encode,
        encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
        comment = file.comment,
        encodedComment = utils.transformTo("string", encodeFileName(comment)),
        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
        useUTF8ForComment = utfEncodedComment.length !== comment.length,
        dosTime,
        dosDate,
        extraFields = "",
        unicodePathExtraField = "",
        unicodeCommentExtraField = "",
        dir = file.dir,
        date = file.date;


    var dataInfo = {
        crc32 : 0,
        compressedSize : 0,
        uncompressedSize : 0
    };

    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo["crc32"];
        dataInfo.compressedSize = streamInfo["compressedSize"];
        dataInfo.uncompressedSize = streamInfo["uncompressedSize"];
    }

    var bitflag = 0;
    if (streamedContent) {
        // Bit 3: the sizes/crc32 are set to zero in the local header.
        // The correct values are put in the data descriptor immediately
        // following the compressed data.
        bitflag |= 0x0008;
    }
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
        // Bit 11: Language encoding flag (EFS).
        bitflag |= 0x0800;
    }


    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) {
        // dos or unix, we set the dos dir flag
        extFileAttr |= 0x00010;
    }
    if(platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else { // DOS or other, fallback to DOS
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
    }

    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;

    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getUTCMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(encodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(crc32(encodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    header += decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(dataInfo.crc32, 4);
    // compressed size
    header += decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += decToHex(encodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};

/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */
var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = utils.transformTo("string", encodeFileName(comment));

    // end of central dir signature
    dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;

    return dirEnd;
};

/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing information
 * on the file entry.
 * @return {String} the data descriptors.
 */
var generateDataDescriptors = function (streamInfo) {
    var descriptor = "";
    descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo["crc32"], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo["compressedSize"], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo["uncompressedSize"], 4);

    return descriptor;
};


/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */
function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
    GenericWorker.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emitted metadata.
    this.currentFile = null;



    this._sources = [];
}
utils.inherits(ZipFileWorker, GenericWorker);

/**
 * @see GenericWorker.push
 */
ZipFileWorker.prototype.push = function (chunk) {

    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;

    if(this.accumulate) {
        this.contentBuffer.push(chunk);
    } else {
        this.bytesWritten += chunk.data.length;

        GenericWorker.prototype.push.call(this, {
            data : chunk.data,
            meta : {
                currentFile : this.currentFile,
                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};

/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */
ZipFileWorker.prototype.openedSource = function (streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo["file"].name;

    var streamedContent = this.streamFiles && !streamInfo["file"].dir;

    // don't stream folders (because they don't have any content)
    if(streamedContent) {
        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
    } else {
        // we need to wait for the whole file before pushing anything
        this.accumulate = true;
    }
};

/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */
ZipFileWorker.prototype.closedSource = function (streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);

    this.dirRecords.push(record.dirRecord);
    if(streamedContent) {
        // after the streamed file, we put data descriptors
        this.push({
            data : generateDataDescriptors(streamInfo),
            meta : {percent:100}
        });
    } else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
        while(this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
        }
    }
    this.currentFile = null;
};

/**
 * @see GenericWorker.flush
 */
ZipFileWorker.prototype.flush = function () {

    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++) {
        this.push({
            data : this.dirRecords[i],
            meta : {percent:100}
        });
    }
    var centralDirLength = this.bytesWritten - localDirLength;

    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);

    this.push({
        data : dirEnd,
        meta : {percent:100}
    });
};

/**
 * Prepare the next source to be read.
 */
ZipFileWorker.prototype.prepareNextSource = function () {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) {
        this.previous.pause();
    } else {
        this.previous.resume();
    }
};

/**
 * @see GenericWorker.registerPrevious
 */
ZipFileWorker.prototype.registerPrevious = function (previous) {
    this._sources.push(previous);
    var self = this;

    previous.on("data", function (chunk) {
        self.processChunk(chunk);
    });
    previous.on("end", function () {
        self.closedSource(self.previous.streamInfo);
        if(self._sources.length) {
            self.prepareNextSource();
        } else {
            self.end();
        }
    });
    previous.on("error", function (e) {
        self.error(e);
    });
    return this;
};

/**
 * @see GenericWorker.resume
 */
ZipFileWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};

/**
 * @see GenericWorker.error
 */
ZipFileWorker.prototype.error = function (e) {
    var sources = this._sources;
    if(!GenericWorker.prototype.error.call(this, e)) {
        return false;
    }
    for(var i = 0; i < sources.length; i++) {
        try {
            sources[i].error(e);
        } catch(e) {
            // the `error` exploded, nothing to do
        }
    }
    return true;
};

/**
 * @see GenericWorker.lock
 */
ZipFileWorker.prototype.lock = function () {
    GenericWorker.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++) {
        sources[i].lock();
    }
};

module.exports = ZipFileWorker;

},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(require,module,exports){
"use strict";

var compressions = require("../compressions");
var ZipFileWorker = require("./ZipFileWorker");

/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */
var getCompression = function (fileCompression, zipCompression) {

    var compressionName = fileCompression || zipCompression;
    var compression = compressions[compressionName];
    if (!compression) {
        throw new Error(compressionName + " is not a valid compression method !");
    }
    return compression;
};

/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */
exports.generateWorker = function (zip, options, comment) {

    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {

        zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;

            file._compressWorker(compression, compressionOptions)
                .withStreamInfo("file", {
                    name : relativePath,
                    dir : dir,
                    date : date,
                    comment : file.comment || "",
                    unixPermissions : file.unixPermissions,
                    dosPermissions : file.dosPermissions
                })
                .pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }

    return zipFileWorker;
};

},{"../compressions":3,"./ZipFileWorker":8}],10:[function(require,module,exports){
"use strict";

/**
 * Representation a of zip file in js
 * @constructor
 */
function JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZip)) {
        return new JSZip();
    }

    if(arguments.length) {
        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    }

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    // NOTE: we use a null prototype because we do not
    // want filenames like "toString" coming from a zip file
    // to overwrite methods and attributes in a normal Object.
    this.files = Object.create(null);

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new JSZip();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZip.prototype = require("./object");
JSZip.prototype.loadAsync = require("./load");
JSZip.support = require("./support");
JSZip.defaults = require("./defaults");

// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
JSZip.version = "3.10.1";

JSZip.loadAsync = function (content, options) {
    return new JSZip().loadAsync(content, options);
};

JSZip.external = require("./external");
module.exports = JSZip;

},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(require,module,exports){
"use strict";
var utils = require("./utils");
var external = require("./external");
var utf8 = require("./utf8");
var ZipEntries = require("./zipEntries");
var Crc32Probe = require("./stream/Crc32Probe");
var nodejsUtils = require("./nodejsUtils");

/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */
function checkEntryCRC32(zipEntry) {
    return new external.Promise(function (resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
        worker.on("error", function (e) {
            reject(e);
        })
            .on("end", function () {
                if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
                    reject(new Error("Corrupted zip : CRC32 mismatch"));
                } else {
                    resolve();
                }
            })
            .resume();
    });
}

module.exports = function (data, options) {
    var zip = this;
    options = utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: utf8.utf8decode
    });

    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    }

    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
        .then(function (data) {
            var zipEntries = new ZipEntries(options);
            zipEntries.load(data);
            return zipEntries;
        }).then(function checkCRC32(zipEntries) {
            var promises = [external.Promise.resolve(zipEntries)];
            var files = zipEntries.files;
            if (options.checkCRC32) {
                for (var i = 0; i < files.length; i++) {
                    promises.push(checkEntryCRC32(files[i]));
                }
            }
            return external.Promise.all(promises);
        }).then(function addFiles(results) {
            var zipEntries = results.shift();
            var files = zipEntries.files;
            for (var i = 0; i < files.length; i++) {
                var input = files[i];

                var unsafeName = input.fileNameStr;
                var safeName = utils.resolve(input.fileNameStr);

                zip.file(safeName, input.decompressed, {
                    binary: true,
                    optimizedBinaryString: true,
                    date: input.date,
                    dir: input.dir,
                    comment: input.fileCommentStr.length ? input.fileCommentStr : null,
                    unixPermissions: input.unixPermissions,
                    dosPermissions: input.dosPermissions,
                    createFolders: options.createFolders
                });
                if (!input.dir) {
                    zip.file(safeName).unsafeOriginalName = unsafeName;
                }
            }
            if (zipEntries.zipComment.length) {
                zip.comment = zipEntries.zipComment;
            }

            return zip;
        });
};

},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var GenericWorker = require("../stream/GenericWorker");

/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */
function NodejsStreamInputAdapter(filename, stream) {
    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}

utils.inherits(NodejsStreamInputAdapter, GenericWorker);

/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */
NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream
        .on("data", function (chunk) {
            self.push({
                data: chunk,
                meta : {
                    percent : 0
                }
            });
        })
        .on("error", function (e) {
            if(self.isPaused) {
                this.generatedError = e;
            } else {
                self.error(e);
            }
        })
        .on("end", function () {
            if(self.isPaused) {
                self._upstreamEnded = true;
            } else {
                self.end();
            }
        });
};
NodejsStreamInputAdapter.prototype.pause = function () {
    if(!GenericWorker.prototype.pause.call(this)) {
        return false;
    }
    this._stream.pause();
    return true;
};
NodejsStreamInputAdapter.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if(this._upstreamEnded) {
        this.end();
    } else {
        this._stream.resume();
    }

    return true;
};

module.exports = NodejsStreamInputAdapter;

},{"../stream/GenericWorker":28,"../utils":32}],13:[function(require,module,exports){
"use strict";

var Readable = require("readable-stream").Readable;

var utils = require("../utils");
utils.inherits(NodejsStreamOutputAdapter, Readable);

/**
* A nodejs stream using a worker as source.
* @see the SourceWrapper in http://nodejs.org/api/stream.html
* @constructor
* @param {StreamHelper} helper the helper wrapping the worker
* @param {Object} options the nodejs stream options
* @param {Function} updateCb the update callback.
*/
function NodejsStreamOutputAdapter(helper, options, updateCb) {
    Readable.call(this, options);
    this._helper = helper;

    var self = this;
    helper.on("data", function (data, meta) {
        if (!self.push(data)) {
            self._helper.pause();
        }
        if(updateCb) {
            updateCb(meta);
        }
    })
        .on("error", function(e) {
            self.emit("error", e);
        })
        .on("end", function () {
            self.push(null);
        });
}


NodejsStreamOutputAdapter.prototype._read = function() {
    this._helper.resume();
};

module.exports = NodejsStreamOutputAdapter;

},{"../utils":32,"readable-stream":16}],14:[function(require,module,exports){
"use strict";

module.exports = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */
    isNode : typeof Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer from an existing content.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */
    newBufferFrom: function(data, encoding) {
        if (Buffer.from && Buffer.from !== Uint8Array.from) {
            return Buffer.from(data, encoding);
        } else {
            if (typeof data === "number") {
                // Safeguard for old Node.js versions. On newer versions,
                // Buffer.from(number) / Buffer(number, encoding) already throw.
                throw new Error("The \"data\" argument must not be a number");
            }
            return new Buffer(data, encoding);
        }
    },
    /**
     * Create a new nodejs Buffer with the specified size.
     * @param {Integer} size the size of the buffer.
     * @return {Buffer} a new Buffer.
     */
    allocBuffer: function (size) {
        if (Buffer.alloc) {
            return Buffer.alloc(size);
        } else {
            var buf = new Buffer(size);
            buf.fill(0);
            return buf;
        }
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */
    isBuffer : function(b){
        return Buffer.isBuffer(b);
    },

    isStream : function (obj) {
        return obj &&
            typeof obj.on === "function" &&
            typeof obj.pause === "function" &&
            typeof obj.resume === "function";
    }
};

},{}],15:[function(require,module,exports){
"use strict";
var utf8 = require("./utf8");
var utils = require("./utils");
var GenericWorker = require("./stream/GenericWorker");
var StreamHelper = require("./stream/StreamHelper");
var defaults = require("./defaults");
var CompressedObject = require("./compressedObject");
var ZipObject = require("./zipObject");
var generate = require("./generate");
var nodejsUtils = require("./nodejsUtils");
var NodejsStreamInputAdapter = require("./nodejs/NodejsStreamInputAdapter");


/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;


    /*
     * Correct options.
     */

    var o = utils.extend(originalOptions || {}, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) {
        o.compression = o.compression.toUpperCase();
    }

    if (typeof o.unixPermissions === "string") {
        o.unixPermissions = parseInt(o.unixPermissions, 8);
    }

    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
        o.dir = true;
    }
    // Bit 4    Directory
    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
        o.dir = true;
    }

    if (o.dir) {
        name = forceTrailingSlash(name);
    }
    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") {
        o.binary = !isUnicodeString;
    }


    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;

    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }

    /*
     * Convert content to fit.
     */

    var zipObjectContent = null;
    if (data instanceof CompressedObject || data instanceof GenericWorker) {
        zipObjectContent = data;
    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        zipObjectContent = new NodejsStreamInputAdapter(name, data);
    } else {
        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    }

    var object = new ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
    /*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) === "/") {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf("/");
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */
var forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") {
        path += "/"; // IE doesn't like substr(-1)
    }
    return path;
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    createFolders = (typeof createFolders !== "undefined") ? createFolders : defaults.createFolders;

    name = forceTrailingSlash(name);

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}

// return the actual prototype of JSZip
var out = {
    /**
     * @see loadAsync
     */
    load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },


    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */
    forEach: function(cb) {
        var filename, relativePath, file;
        // ignore warning about unwanted properties because this.files is a null prototype object
        /* eslint-disable-next-line guard-for-in */
        for (filename in this.files) {
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
        }
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [];
        this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) { // the file matches the function
                result.push(entry);
            }

        });
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) {
                    return obj;
                } else {
                    return null;
                }
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * @deprecated This method has been removed in JSZip 3.0, please check the upgrade guide.
     */
    generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },

    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */
    generateInternalStream: function(options) {
        var worker, opts = {};
        try {
            opts = utils.extend(options || {}, {
                streamFiles: false,
                compression: "STORE",
                compressionOptions : null,
                type: "",
                platform: "DOS",
                comment: null,
                mimeType: "application/zip",
                encodeFileName: utf8.utf8encode
            });

            opts.type = opts.type.toLowerCase();
            opts.compression = opts.compression.toUpperCase();

            // "binarystring" is preferred but the internals use "string".
            if(opts.type === "binarystring") {
                opts.type = "string";
            }

            if (!opts.type) {
                throw new Error("No output type specified.");
            }

            utils.checkSupport(opts.type);

            // accept nodejs `process.platform`
            if(
                opts.platform === "darwin" ||
                opts.platform === "freebsd" ||
                opts.platform === "linux" ||
                opts.platform === "sunos"
            ) {
                opts.platform = "UNIX";
            }
            if (opts.platform === "win32") {
                opts.platform = "DOS";
            }

            var comment = opts.comment || this.comment || "";
            worker = generate.generateWorker(this, opts, comment);
        } catch (e) {
            worker = new GenericWorker("error");
            worker.error(e);
        }
        return new StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) {
            options.type = "nodebuffer";
        }
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
module.exports = out;

},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(require,module,exports){
"use strict";
/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */
module.exports = require("stream");

},{"stream":undefined}],17:[function(require,module,exports){
"use strict";
var DataReader = require("./DataReader");
var utils = require("../utils");

function ArrayReader(data) {
    DataReader.call(this, data);
    for(var i = 0; i < this.data.length; i++) {
        data[i] = data[i] & 0xFF;
    }
}
utils.inherits(ArrayReader, DataReader);
/**
 * @see DataReader.byteAt
 */
ArrayReader.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
        }
    }

    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */
ArrayReader.prototype.readAndCheckSignature = function (sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3),
        data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */
ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        return [];
    }
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = ArrayReader;

},{"../utils":32,"./DataReader":18}],18:[function(require,module,exports){
"use strict";
var utils = require("../utils");

function DataReader(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specified index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function() {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function() {
        // see implementations
    },
    /**
     * Find the last occurrence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurrence, -1 if not found.
     */
    lastIndexOfSignature: function() {
        // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */
    readAndCheckSignature: function() {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC(
            ((dostime >> 25) & 0x7f) + 1980, // year
            ((dostime >> 21) & 0x0f) - 1, // month
            (dostime >> 16) & 0x1f, // day
            (dostime >> 11) & 0x1f, // hour
            (dostime >> 5) & 0x3f, // minute
            (dostime & 0x1f) << 1)); // second
    }
};
module.exports = DataReader;

},{"../utils":32}],19:[function(require,module,exports){
"use strict";
var Uint8ArrayReader = require("./Uint8ArrayReader");
var utils = require("../utils");

function NodeBufferReader(data) {
    Uint8ArrayReader.call(this, data);
}
utils.inherits(NodeBufferReader, Uint8ArrayReader);

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;

},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(require,module,exports){
"use strict";
var DataReader = require("./DataReader");
var utils = require("../utils");

function StringReader(data) {
    DataReader.call(this, data);
}
utils.inherits(StringReader, DataReader);
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */
StringReader.prototype.readAndCheckSignature = function (sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;

},{"../utils":32,"./DataReader":18}],21:[function(require,module,exports){
"use strict";
var ArrayReader = require("./ArrayReader");
var utils = require("../utils");

function Uint8ArrayReader(data) {
    ArrayReader.call(this, data);
}
utils.inherits(Uint8ArrayReader, ArrayReader);
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;

},{"../utils":32,"./ArrayReader":17}],22:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var support = require("../support");
var ArrayReader = require("./ArrayReader");
var StringReader = require("./StringReader");
var NodeBufferReader = require("./NodeBufferReader");
var Uint8ArrayReader = require("./Uint8ArrayReader");

/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */
module.exports = function (data) {
    var type = utils.getTypeOf(data);
    utils.checkSupport(type);
    if (type === "string" && !support.uint8array) {
        return new StringReader(data);
    }
    if (type === "nodebuffer") {
        return new NodeBufferReader(data);
    }
    if (support.uint8array) {
        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
    }
    return new ArrayReader(utils.transformTo("array", data));
};

},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(require,module,exports){
"use strict";
exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";

},{}],24:[function(require,module,exports){
"use strict";

var GenericWorker = require("./GenericWorker");
var utils = require("../utils");

/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */
function ConvertWorker(destType) {
    GenericWorker.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
utils.inherits(ConvertWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
ConvertWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : utils.transformTo(this.destType, chunk.data),
        meta : chunk.meta
    });
};
module.exports = ConvertWorker;

},{"../utils":32,"./GenericWorker":28}],25:[function(require,module,exports){
"use strict";

var GenericWorker = require("./GenericWorker");
var crc32 = require("../crc32");
var utils = require("../utils");

/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */
function Crc32Probe() {
    GenericWorker.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
utils.inherits(Crc32Probe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Crc32Probe.prototype.processChunk = function (chunk) {
    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
module.exports = Crc32Probe;

},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var GenericWorker = require("./GenericWorker");

/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */
function DataLengthProbe(propName) {
    GenericWorker.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
utils.inherits(DataLengthProbe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
DataLengthProbe.prototype.processChunk = function (chunk) {
    if(chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    GenericWorker.prototype.processChunk.call(this, chunk);
};
module.exports = DataLengthProbe;


},{"../utils":32,"./GenericWorker":28}],27:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var GenericWorker = require("./GenericWorker");

// the size of the generated chunks
// TODO expose this as a public variable
var DEFAULT_BLOCK_SIZE = 16 * 1024;

/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */
function DataWorker(dataP) {
    GenericWorker.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";

    this._tickScheduled = false;

    dataP.then(function (data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = utils.getTypeOf(data);
        if(!self.isPaused) {
            self._tickAndRepeat();
        }
    }, function (e) {
        self.error(e);
    });
}

utils.inherits(DataWorker, GenericWorker);

/**
 * @see GenericWorker.cleanUp
 */
DataWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this.data = null;
};

/**
 * @see GenericWorker.resume
 */
DataWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        utils.delay(this._tickAndRepeat, [], this);
    }
    return true;
};

/**
 * Trigger a tick a schedule an other call to this function.
 */
DataWorker.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if(this.isPaused || this.isFinished) {
        return;
    }
    this._tick();
    if(!this.isFinished) {
        utils.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};

/**
 * Read and push a chunk.
 */
DataWorker.prototype._tick = function() {

    if(this.isPaused || this.isFinished) {
        return false;
    }

    var size = DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) {
        // EOF
        return this.end();
    } else {
        switch(this.type) {
        case "string":
            data = this.data.substring(this.index, nextIndex);
            break;
        case "uint8array":
            data = this.data.subarray(this.index, nextIndex);
            break;
        case "array":
        case "nodebuffer":
            data = this.data.slice(this.index, nextIndex);
            break;
        }
        this.index = nextIndex;
        return this.push({
            data : data,
            meta : {
                percent : this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};

module.exports = DataWorker;

},{"../utils":32,"./GenericWorker":28}],28:[function(require,module,exports){
"use strict";

/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */
function GenericWorker(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        "data":[],
        "end":[],
        "error":[]
    };
    // the previous worker, if any
    this.previous = null;
}

GenericWorker.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */
    push : function (chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */
    end : function () {
        if (this.isFinished) {
            return false;
        }

        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */
    error : function (e) {
        if (this.isFinished) {
            return false;
        }

        if(this.isPaused) {
            this.generatedError = e;
        } else {
            this.isFinished = true;

            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if(this.previous) {
                this.previous.error(e);
            }

            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */
    on : function (name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */
    cleanUp : function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */
    emit : function (name, arg) {
        if (this._listeners[name]) {
            for(var i = 0; i < this._listeners[name].length; i++) {
                this._listeners[name][i].call(this, arg);
            }
        }
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */
    pipe : function (next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */
    registerPrevious : function (previous) {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }

        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous =  previous;
        var self = this;
        previous.on("data", function (chunk) {
            self.processChunk(chunk);
        });
        previous.on("end", function () {
            self.end();
        });
        previous.on("error", function (e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */
    pause : function () {
        if(this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = true;

        if(this.previous) {
            this.previous.pause();
        }
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */
    resume : function () {
        if(!this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = false;

        // if true, the worker tried to resume but failed
        var withError = false;
        if(this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if(this.previous) {
            this.previous.resume();
        }

        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */
    flush : function () {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */
    processChunk : function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */
    withStreamInfo : function (key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */
    mergeStreamInfo : function () {
        for(var key in this.extraStreamInfo) {
            if (!Object.prototype.hasOwnProperty.call(this.extraStreamInfo, key)) {
                continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },

    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */
    lock: function () {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }
        this.isLocked = true;
        if (this.previous) {
            this.previous.lock();
        }
    },

    /**
     *
     * Pretty print the workers chain.
     */
    toString : function () {
        var me = "Worker " + this.name;
        if (this.previous) {
            return this.previous + " -> " + me;
        } else {
            return me;
        }
    }
};

module.exports = GenericWorker;

},{}],29:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var ConvertWorker = require("./ConvertWorker");
var GenericWorker = require("./GenericWorker");
var base64 = require("../base64");
var support = require("../support");
var external = require("../external");

var NodejsStreamOutputAdapter = null;
if (support.nodestream) {
    try {
        NodejsStreamOutputAdapter = require("../nodejs/NodejsStreamOutputAdapter");
    } catch(e) {
        // ignore
    }
}

/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} type the name of the final type
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */
function transformZipOutput(type, content, mimeType) {
    switch(type) {
    case "blob" :
        return utils.newBlob(utils.transformTo("arraybuffer", content), mimeType);
    case "base64" :
        return base64.encode(content);
    default :
        return utils.transformTo(type, content);
    }
}

/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */
function concat (type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++) {
        totalLength += dataArray[i].length;
    }
    switch(type) {
    case "string":
        return dataArray.join("");
    case "array":
        return Array.prototype.concat.apply([], dataArray);
    case "uint8array":
        res = new Uint8Array(totalLength);
        for(i = 0; i < dataArray.length; i++) {
            res.set(dataArray[i], index);
            index += dataArray[i].length;
        }
        return res;
    case "nodebuffer":
        return Buffer.concat(dataArray);
    default:
        throw new Error("concat : unsupported type '"  + type + "'");
    }
}

/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */
function accumulate(helper, updateCallback) {
    return new external.Promise(function (resolve, reject){
        var dataArray = [];
        var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
        helper
            .on("data", function (data, meta) {
                dataArray.push(data);
                if(updateCallback) {
                    updateCallback(meta);
                }
            })
            .on("error", function(err) {
                dataArray = [];
                reject(err);
            })
            .on("end", function (){
                try {
                    var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
                    resolve(result);
                } catch (e) {
                    reject(e);
                }
                dataArray = [];
            })
            .resume();
    });
}

/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */
function StreamHelper(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType) {
    case "blob":
    case "arraybuffer":
        internalType = "uint8array";
        break;
    case "base64":
        internalType = "string";
        break;
    }

    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        utils.checkSupport(internalType);
        this._worker = worker.pipe(new ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch(e) {
        this._worker = new GenericWorker("error");
        this._worker.error(e);
    }
}

StreamHelper.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */
    accumulate : function (updateCb) {
        return accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */
    on : function (evt, fn) {
        var self = this;

        if(evt === "data") {
            this._worker.on(evt, function (chunk) {
                fn.call(self, chunk.data, chunk.meta);
            });
        } else {
            this._worker.on(evt, function () {
                utils.delay(fn, arguments, self);
            });
        }
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    resume : function () {
        utils.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    pause : function () {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */
    toNodejsStream : function (updateCb) {
        utils.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
        }

        return new NodejsStreamOutputAdapter(this, {
            objectMode : this._outputType !== "nodebuffer"
        }, updateCb);
    }
};


module.exports = StreamHelper;

},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(require,module,exports){
"use strict";

exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob("application/zip").size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

try {
    exports.nodestream = !!require("readable-stream").Readable;
} catch(e) {
    exports.nodestream = false;
}

},{"readable-stream":16}],31:[function(require,module,exports){
"use strict";

var utils = require("./utils");
var support = require("./support");
var nodejsUtils = require("./nodejsUtils");
var GenericWorker = require("./stream/GenericWorker");

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
    _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodejsUtils.newBufferFrom(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    return buf2string(buf);
};

/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */
function Utf8DecodeWorker() {
    GenericWorker.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
utils.inherits(Utf8DecodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8DecodeWorker.prototype.processChunk = function (chunk) {

    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if(support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else {
            data = this.leftOver.concat(data);
        }
        this.leftOver = null;
    }

    var nextBoundary = utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }

    this.push({
        data : exports.utf8decode(usableData),
        meta : chunk.meta
    });
};

/**
 * @see GenericWorker.flush
 */
Utf8DecodeWorker.prototype.flush = function () {
    if(this.leftOver && this.leftOver.length) {
        this.push({
            data : exports.utf8decode(this.leftOver),
            meta : {}
        });
        this.leftOver = null;
    }
};
exports.Utf8DecodeWorker = Utf8DecodeWorker;

/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */
function Utf8EncodeWorker() {
    GenericWorker.call(this, "utf-8 encode");
}
utils.inherits(Utf8EncodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8EncodeWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : exports.utf8encode(chunk.data),
        meta : chunk.meta
    });
};
exports.Utf8EncodeWorker = Utf8EncodeWorker;

},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(require,module,exports){
"use strict";

var support = require("./support");
var base64 = require("./base64");
var nodejsUtils = require("./nodejsUtils");
var external = require("./external");
require("setimmediate");


/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */
function string2binary(str) {
    var result = null;
    if (support.uint8array) {
        result = new Uint8Array(str.length);
    } else {
        result = new Array(str.length);
    }
    return stringToArrayLike(str, result);
}

/**
 * Create a new blob with the given content and the given type.
 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 *
 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
 * when a large amount of Array is used to create the Blob, the amount of
 * memory consumed is nearly 100 times the original data amount.
 *
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */
exports.newBlob = function(part, type) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob([part], {
            type: type
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(part);
            return builder.getBlob(type);
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * An helper for the function arrayLikeToString.
 * This contains static information and functions that
 * can be optimized by the browser JIT compiler.
 */
var arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */
    stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
        }
        while (k < len) {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */
    stringifyByChar: function(array){
        var resultStr = "";
        for(var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
        }
        return resultStr;
    },
    applyCanBeUsed : {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */
        uint8array : (function () {
            try {
                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        })(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */
        nodebuffer : (function () {
            try {
                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        })()
    }
};

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536,
        type = exports.getTypeOf(array),
        canUseApply = true;
    if (type === "uint8array") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
    } else if (type === "nodebuffer") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
    }

    if (canUseApply) {
        while (chunk > 1) {
            try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
    }

    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return arrayToStringHelper.stringifyByChar(array);
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return input.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Resolve all relative path components, "." and "..", in a path. If these relative components
 * traverse above the root then the resulting path will only contain the final path component.
 *
 * All empty components, e.g. "//", are removed.
 * @param {string} path A path with / or \ separators
 * @returns {string} The path with all relative path components resolved.
 */
exports.resolve = function(path) {
    var parts = path.split("/");
    var result = [];
    for (var index = 0; index < parts.length; index++) {
        var part = parts[index];
        // Allow the first and last component to be empty for trailing slashes.
        if (part === "." || (part === "" && index !== 0 && index !== parts.length - 1)) {
            continue;
        } else if (part === "..") {
            result.pop();
        } else {
            result.push(part);
        }
    }
    return result.join("/");
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this platform");
    }
};

exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = "",
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */
exports.delay = function(callback, args, self) {
    setImmediate(function () {
        callback.apply(self || null, args || []);
    });
};

/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */
exports.inherits = function (ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
exports.extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (Object.prototype.hasOwnProperty.call(arguments[i], attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */
exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {

    // if inputData is already a promise, this flatten it.
    var promise = external.Promise.resolve(inputData).then(function(data) {


        var isBlob = support.blob && (data instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(data)) !== -1);

        if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
        } else {
            return data;
        }
    });

    return promise.then(function(data) {
        var dataType = exports.getTypeOf(data);

        if (!dataType) {
            return external.Promise.reject(
                new Error("Can't read the data of '" + name + "'. Is it " +
                          "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
            );
        }
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
        } else if (dataType === "string") {
            if (isBase64) {
                data = base64.decode(data);
            }
            else if (isBinary) {
                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                if (isOptimizedBinaryString !== true) {
                    // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
        }
        return data;
    });
};

},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,"setimmediate":54}],33:[function(require,module,exports){
"use strict";
var readerFor = require("./reader/readerFor");
var utils = require("./utils");
var sig = require("./signature");
var ZipEntry = require("./zipEntry");
var support = require("./support");
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the specified signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */
    isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = utils.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }

        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
                // We expected some records but couldn't find ANY.
                // This is really suspicious, as if something went wrong.
                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
                // We found some records but not all.
                // Something is wrong but we got something for the user: no error here.
                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

            if (isGarbage) {
                throw new Error("Can't find end of central directory : is this a zip file ? " +
                                "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
                throw new Error("Corrupted zip: can't find end of central directory");
            }

        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }

        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
        }

        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
                // The offsets seem wrong, but we have something at the specified offset.
                // So… we keep it.
            } else {
                // the offset is wrong, update the "zero" of the reader
                // this happens if data has been prepended (crx files for example)
                this.reader.zero = extraBytes;
            }
        } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
        }
    },
    prepareReader: function(data) {
        this.reader = readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;

},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(require,module,exports){
"use strict";
var readerFor = require("./reader/readerFor");
var utils = require("./utils");
var CompressedObject = require("./compressedObject");
var crc32fn = require("./crc32");
var utf8 = require("./utf8");
var compressions = require("./compressions");
var support = require("./support");

var MADE_BY_DOS = 0x00;
var MADE_BY_UNIX = 0x03;

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
var findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!Object.prototype.hasOwnProperty.call(compressions, method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};

// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough information from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
        }

        compression = findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
        }
        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },

    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */
    processAttributes: function () {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;

        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

        if(madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
        }

        if(madeBy === MADE_BY_UNIX) {
            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
        }

        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === "/") {
            this.dir = true;
        }
    },

    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function() {
        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = readerFor(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        if (!this.extraFields) {
            this.extraFields = {};
        }

        while (reader.index + 4 < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }

        reader.setIndex(end);
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = utf8.utf8decode(this.fileName);
            this.fileCommentStr = utf8.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileNameStr = upath;
            } else {
                // ASCII text or unsupported code page
                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }

            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileCommentStr = ucomment;
            } else {
                // ASCII text or unsupported code page
                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = readerFor(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = readerFor(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;

},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(require,module,exports){
"use strict";

var StreamHelper = require("./stream/StreamHelper");
var DataWorker = require("./stream/DataWorker");
var utf8 = require("./utf8");
var CompressedObject = require("./compressedObject");
var GenericWorker = require("./stream/GenericWorker");

/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;

    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression : options.compression,
        compressionOptions : options.compressionOptions
    };
};

ZipObject.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */
    internalStream: function (type) {
        var result = null, outputType = "string";
        try {
            if (!type) {
                throw new Error("No output type specified.");
            }
            outputType = type.toLowerCase();
            var askUnicodeString = outputType === "string" || outputType === "text";
            if (outputType === "binarystring" || outputType === "text") {
                outputType = "string";
            }
            result = this._decompressWorker();

            var isUnicodeString = !this._dataBinary;

            if (isUnicodeString && !askUnicodeString) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            if (!isUnicodeString && askUnicodeString) {
                result = result.pipe(new utf8.Utf8DecodeWorker());
            }
        } catch (e) {
            result = new GenericWorker("error");
            result.error(e);
        }

        return new StreamHelper(result, outputType, "");
    },

    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */
    async: function (type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },

    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */
    nodeStream: function (type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },

    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */
    _compressWorker: function (compression, compressionOptions) {
        if (
            this._data instanceof CompressedObject &&
            this._data.compression.magic === compression.magic
        ) {
            return this._data.getCompressedWorker();
        } else {
            var result = this._decompressWorker();
            if(!this._dataBinary) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */
    _decompressWorker : function () {
        if (this._data instanceof CompressedObject) {
            return this._data.getContentWorker();
        } else if (this._data instanceof GenericWorker) {
            return this._data;
        } else {
            return new DataWorker(this._data);
        }
    }
};

var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
var removedFn = function () {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};

for(var i = 0; i < removedMethods.length; i++) {
    ZipObject.prototype[removedMethods[i]] = removedFn;
}
module.exports = ZipObject;

},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(require,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],37:[function(require,module,exports){
'use strict';
var immediate = require('immediate');

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["finally"] = function (callback) {
  if (typeof callback !== 'function') {
    return this;
  }
  var p = this.constructor;
  return this.then(resolve, reject);

  function resolve(value) {
    function yes () {
      return value;
    }
    return p.resolve(callback()).then(yes);
  }
  function reject(reason) {
    function no () {
      throw reason;
    }
    return p.resolve(callback()).then(no);
  }
};
Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"immediate":36}],38:[function(require,module,exports){
// Top level file is just a mixin of submodules & constants


var assign    = require('./lib/utils/common').assign;

var deflate   = require('./lib/deflate');
var inflate   = require('./lib/inflate');
var constants = require('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;

},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(require,module,exports){
'use strict';


var zlib_deflate = require('./zlib/deflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overriden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;

},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(require,module,exports){
'use strict';


var zlib_inflate = require('./zlib/inflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var c            = require('./zlib/constants');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');
var GZheader     = require('./zlib/gzheader');

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overriden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;
  var dict;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      // Convert data if needed
      if (typeof dictionary === 'string') {
        dict = strings.string2buf(dictionary);
      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
        dict = new Uint8Array(dictionary);
      } else {
        dict = dictionary;
      }

      status = zlib_inflate.inflateSetDictionary(this.strm, dict);

    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 alligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');


exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (source.hasOwnProperty(p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],42:[function(require,module,exports){
// String encode/decode helpers



var utils = require('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safary
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // use fallback for big arrays to avoid stack overflow
  if (len < 65537) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Fuckup - very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means vuffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":41}],43:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],44:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

},{}],45:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],46:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = require('../utils/common');
var trees   = require('./trees');
var adler32 = require('./adler32');
var crc32   = require('./crc32');
var msg     = require('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/

},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;

},{}],48:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],49:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = require('../utils/common');
var adler32       = require('./adler32');
var crc32         = require('./crc32');
var inflate_fast  = require('./inffast');
var inflate_table = require('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
    case HEAD:
      if (state.wrap === 0) {
        state.mode = TYPEDO;
        break;
      }
      //=== NEEDBITS(16);
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//

        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = FLAGS;
        break;
      }
      state.flags = 0;           /* expect zlib header */
      if (state.head) {
        state.head.done = false;
      }
      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
        strm.msg = 'incorrect header check';
        state.mode = BAD;
        break;
      }
      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
      len = (hold & 0x0f)/*BITS(4)*/ + 8;
      if (state.wbits === 0) {
        state.wbits = len;
      }
      else if (len > state.wbits) {
        strm.msg = 'invalid window size';
        state.mode = BAD;
        break;
      }
      state.dmax = 1 << len;
      //Tracev((stderr, "inflate:   zlib header ok\n"));
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = hold & 0x200 ? DICTID : TYPE;
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      break;
    case FLAGS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.flags = hold;
      if ((state.flags & 0xff) !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      if (state.flags & 0xe000) {
        strm.msg = 'unknown header flags set';
        state.mode = BAD;
        break;
      }
      if (state.head) {
        state.head.text = ((hold >> 8) & 1);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = TIME;
      /* falls through */
    case TIME:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.time = hold;
      }
      if (state.flags & 0x0200) {
        //=== CRC4(state.check, hold)
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        hbuf[2] = (hold >>> 16) & 0xff;
        hbuf[3] = (hold >>> 24) & 0xff;
        state.check = crc32(state.check, hbuf, 4, 0);
        //===
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = OS;
      /* falls through */
    case OS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.xflags = (hold & 0xff);
        state.head.os = (hold >> 8);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = EXLEN;
      /* falls through */
    case EXLEN:
      if (state.flags & 0x0400) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length = hold;
        if (state.head) {
          state.head.extra_len = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      else if (state.head) {
        state.head.extra = null/*Z_NULL*/;
      }
      state.mode = EXTRA;
      /* falls through */
    case EXTRA:
      if (state.flags & 0x0400) {
        copy = state.length;
        if (copy > have) { copy = have; }
        if (copy) {
          if (state.head) {
            len = state.head.extra_len - state.length;
            if (!state.head.extra) {
              // Use untyped array for more conveniend processing later
              state.head.extra = new Array(state.head.extra_len);
            }
            utils.arraySet(
              state.head.extra,
              input,
              next,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              copy,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              len
            );
            //zmemcpy(state.head.extra + len, next,
            //        len + copy > state.head.extra_max ?
            //        state.head.extra_max - len : copy);
          }
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          state.length -= copy;
        }
        if (state.length) { break inf_leave; }
      }
      state.length = 0;
      state.mode = NAME;
      /* falls through */
    case NAME:
      if (state.flags & 0x0800) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          // TODO: 2 or 1 bytes?
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.name_max*/)) {
            state.head.name += String.fromCharCode(len);
          }
        } while (len && copy < have);

        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.name = null;
      }
      state.length = 0;
      state.mode = COMMENT;
      /* falls through */
    case COMMENT:
      if (state.flags & 0x1000) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.comm_max*/)) {
            state.head.comment += String.fromCharCode(len);
          }
        } while (len && copy < have);
        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.comment = null;
      }
      state.mode = HCRC;
      /* falls through */
    case HCRC:
      if (state.flags & 0x0200) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.check & 0xffff)) {
          strm.msg = 'header crc mismatch';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      if (state.head) {
        state.head.hcrc = ((state.flags >> 9) & 1);
        state.head.done = true;
      }
      strm.adler = state.check = 0;
      state.mode = TYPE;
      break;
    case DICTID:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      strm.adler = state.check = zswap32(hold);
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = DICT;
      /* falls through */
    case DICT:
      if (state.havedict === 0) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        return Z_NEED_DICT;
      }
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      /* falls through */
    case TYPE:
      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case TYPEDO:
      if (state.last) {
        //--- BYTEBITS() ---//
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        state.mode = CHECK;
        break;
      }
      //=== NEEDBITS(3); */
      while (bits < 3) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.last = (hold & 0x01)/*BITS(1)*/;
      //--- DROPBITS(1) ---//
      hold >>>= 1;
      bits -= 1;
      //---//

      switch ((hold & 0x03)/*BITS(2)*/) {
      case 0:                             /* stored block */
        //Tracev((stderr, "inflate:     stored block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = STORED;
        break;
      case 1:                             /* fixed block */
        fixedtables(state);
        //Tracev((stderr, "inflate:     fixed codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = LEN_;             /* decode codes */
        if (flush === Z_TREES) {
          //--- DROPBITS(2) ---//
          hold >>>= 2;
          bits -= 2;
          //---//
          break inf_leave;
        }
        break;
      case 2:                             /* dynamic block */
        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = TABLE;
        break;
      case 3:
        strm.msg = 'invalid block type';
        state.mode = BAD;
      }
      //--- DROPBITS(2) ---//
      hold >>>= 2;
      bits -= 2;
      //---//
      break;
    case STORED:
      //--- BYTEBITS() ---// /* go to byte boundary */
      hold >>>= bits & 7;
      bits -= bits & 7;
      //---//
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
        strm.msg = 'invalid stored block lengths';
        state.mode = BAD;
        break;
      }
      state.length = hold & 0xffff;
      //Tracev((stderr, "inflate:       stored length %u\n",
      //        state.length));
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = COPY_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case COPY_:
      state.mode = COPY;
      /* falls through */
    case COPY:
      copy = state.length;
      if (copy) {
        if (copy > have) { copy = have; }
        if (copy > left) { copy = left; }
        if (copy === 0) { break inf_leave; }
        //--- zmemcpy(put, next, copy); ---
        utils.arraySet(output, input, next, copy, put);
        //---//
        have -= copy;
        next += copy;
        left -= copy;
        put += copy;
        state.length -= copy;
        break;
      }
      //Tracev((stderr, "inflate:       stored end\n"));
      state.mode = TYPE;
      break;
    case TABLE:
      //=== NEEDBITS(14); */
      while (bits < 14) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
//#ifndef PKZIP_BUG_WORKAROUND
      if (state.nlen > 286 || state.ndist > 30) {
        strm.msg = 'too many length or distance symbols';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracev((stderr, "inflate:       table sizes ok\n"));
      state.have = 0;
      state.mode = LENLENS;
      /* falls through */
    case LENLENS:
      while (state.have < state.ncode) {
        //=== NEEDBITS(3);
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
        //--- DROPBITS(3) ---//
        hold >>>= 3;
        bits -= 3;
        //---//
      }
      while (state.have < 19) {
        state.lens[order[state.have++]] = 0;
      }
      // We have separate tables & no pointers. 2 commented lines below not needed.
      //state.next = state.codes;
      //state.lencode = state.next;
      // Switch to use dynamic table
      state.lencode = state.lendyn;
      state.lenbits = 7;

      opts = { bits: state.lenbits };
      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
      state.lenbits = opts.bits;

      if (ret) {
        strm.msg = 'invalid code lengths set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, "inflate:       code lengths ok\n"));
      state.have = 0;
      state.mode = CODELENS;
      /* falls through */
    case CODELENS:
      while (state.have < state.nlen + state.ndist) {
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_val < 16) {
          //--- DROPBITS(here.bits) ---//
          hold >>>= here_bits;
          bits -= here_bits;
          //---//
          state.lens[state.have++] = here_val;
        }
        else {
          if (here_val === 16) {
            //=== NEEDBITS(here.bits + 2);
            n = here_bits + 2;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            if (state.have === 0) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            len = state.lens[state.have - 1];
            copy = 3 + (hold & 0x03);//BITS(2);
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
          }
          else if (here_val === 17) {
            //=== NEEDBITS(here.bits + 3);
            n = here_bits + 3;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 3 + (hold & 0x07);//BITS(3);
            //--- DROPBITS(3) ---//
            hold >>>= 3;
            bits -= 3;
            //---//
          }
          else {
            //=== NEEDBITS(here.bits + 7);
            n = here_bits + 7;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 11 + (hold & 0x7f);//BITS(7);
            //--- DROPBITS(7) ---//
            hold >>>= 7;
            bits -= 7;
            //---//
          }
          if (state.have + copy > state.nlen + state.ndist) {
            strm.msg = 'invalid bit length repeat';
            state.mode = BAD;
            break;
          }
          while (copy--) {
            state.lens[state.have++] = len;
          }
        }
      }

      /* handle error breaks in while */
      if (state.mode === BAD) { break; }

      /* check for end-of-block code (better have one) */
      if (state.lens[256] === 0) {
        strm.msg = 'invalid code -- missing end-of-block';
        state.mode = BAD;
        break;
      }

      /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */
      state.lenbits = 9;

      opts = { bits: state.lenbits };
      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.lenbits = opts.bits;
      // state.lencode = state.next;

      if (ret) {
        strm.msg = 'invalid literal/lengths set';
        state.mode = BAD;
        break;
      }

      state.distbits = 6;
      //state.distcode.copy(state.codes);
      // Switch to use dynamic table
      state.distcode = state.distdyn;
      opts = { bits: state.distbits };
      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.distbits = opts.bits;
      // state.distcode = state.next;

      if (ret) {
        strm.msg = 'invalid distances set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, 'inflate:       codes ok\n'));
      state.mode = LEN_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case LEN_:
      state.mode = LEN;
      /* falls through */
    case LEN:
      if (have >= 6 && left >= 258) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        inflate_fast(strm, _out);
        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        if (state.mode === TYPE) {
          state.back = -1;
        }
        break;
      }
      state.back = 0;
      for (;;) {
        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if (here_bits <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if (here_op && (here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.lencode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      state.length = here_val;
      if (here_op === 0) {
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        state.mode = LIT;
        break;
      }
      if (here_op & 32) {
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.back = -1;
        state.mode = TYPE;
        break;
      }
      if (here_op & 64) {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break;
      }
      state.extra = here_op & 15;
      state.mode = LENEXT;
      /* falls through */
    case LENEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
      //Tracevv((stderr, "inflate:         length %u\n", state.length));
      state.was = state.length;
      state.mode = DIST;
      /* falls through */
    case DIST:
      for (;;) {
        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if ((here_bits) <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if ((here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.distcode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      if (here_op & 64) {
        strm.msg = 'invalid distance code';
        state.mode = BAD;
        break;
      }
      state.offset = here_val;
      state.extra = (here_op) & 15;
      state.mode = DISTEXT;
      /* falls through */
    case DISTEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
//#ifdef INFLATE_STRICT
      if (state.offset > state.dmax) {
        strm.msg = 'invalid distance too far back';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
      state.mode = MATCH;
      /* falls through */
    case MATCH:
      if (left === 0) { break inf_leave; }
      copy = _out - left;
      if (state.offset > copy) {         /* copy from window */
        copy = state.offset - copy;
        if (copy > state.whave) {
          if (state.sane) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          }
// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
        }
        if (copy > state.wnext) {
          copy -= state.wnext;
          from = state.wsize - copy;
        }
        else {
          from = state.wnext - copy;
        }
        if (copy > state.length) { copy = state.length; }
        from_source = state.window;
      }
      else {                              /* copy from output */
        from_source = output;
        from = put - state.offset;
        copy = state.length;
      }
      if (copy > left) { copy = left; }
      left -= copy;
      state.length -= copy;
      do {
        output[put++] = from_source[from++];
      } while (--copy);
      if (state.length === 0) { state.mode = LEN; }
      break;
    case LIT:
      if (left === 0) { break inf_leave; }
      output[put++] = state.length;
      left--;
      state.mode = LEN;
      break;
    case CHECK:
      if (state.wrap) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          // Use '|' insdead of '+' to make sure that result is signed
          hold |= input[next++] << bits;
          bits += 8;
        }
        //===//
        _out -= left;
        strm.total_out += _out;
        state.total += _out;
        if (_out) {
          strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

        }
        _out = left;
        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
          strm.msg = 'incorrect data check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   check matches trailer\n"));
      }
      state.mode = LENGTH;
      /* falls through */
    case LENGTH:
      if (state.wrap && state.flags) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.total & 0xffffffff)) {
          strm.msg = 'incorrect length check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   length matches trailer\n"));
      }
      state.mode = DONE;
      /* falls through */
    case DONE:
      ret = Z_STREAM_END;
      break inf_leave;
    case BAD:
      ret = Z_DATA_ERROR;
      break inf_leave;
    case MEM:
      return Z_MEM_ERROR;
    case SYNC:
      /* falls through */
    default:
      return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/

},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = require('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":41}],51:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],52:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = require('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"../utils/common":41}],53:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}],54:[function(require,module,exports){
(function (global){
(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[10])(10)
});
(function(a,b){if("function"==typeof define&&define.amd)define('scripts/lib/FileSaver.min.js',[],b);else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map;
'use strict'
define('scripts/directives/tableOptionsDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions", "scripts/lib/jszip", "scripts/lib/FileSaver.min.js"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, JSZip) {

	angular.module("appModule").directive("dtTableOptions", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtTableOptions.html',
		scope: true,
		controller: 'TblOptionsController'
	  };
	});

	angular.module("appModule").controller("TblOptionsController", ["$scope", "$rootScope", "$q", "$location", "$http",
	function ($scope, $rootScope, $q, $location, $http) {

		let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
		$scope.tblTab = "table";
		if($scope.amountOptions.show) {
			//$scope.unitsOfMeasure = [{'value':'1', 'name': 'Dollars'},{'value': '1000', 'name':'Thousands of Dollars'}];               
			$scope.unitsSelected = String($scope.amountOptions.unitsOfMeasure[$scope.amountOptions.defaultUnitsOfMeasure].value);
			$scope.unitsSelectedName = String($scope.amountOptions.unitsOfMeasure[$scope.amountOptions.defaultUnitsOfMeasure].name);
			appUtilities.setAppVariable($rootScope.qApp, 'vUnitsOfMeasure', $scope.unitsSelected);

			//$scope.deflators = [{'value':'1.0', 'name': 'Current Dollars'},{'value': 'CY_2012_Deflator', 'name':'2012 Dollars'}];
			$scope.deflatorSelected = String($scope.amountOptions.deflators[0].value);
			$scope.deflatorSelectedName = String($scope.amountOptions.deflators[0].name);           
		}

		// Units of Measure code
		$scope.ddlUpdateUnits = function() {
			appUtilities.setAppVariable($rootScope.qApp, 'vUnitsOfMeasure', $scope.unitsSelected);
			$rootScope.unitsOfMeasureValue = Number($scope.unitsSelected);
			//google analytics tracking
			gtag('event', displayType + $rootScope.survey.abbreviation+'-UnitsOfMeasure-'+$scope.unitsSelectedName, { 'event_label': 'select', 'event_category': 'table-options'});
		}

		// Deflator code
		$scope.ddlUpdateDeflator = function() {
			appUtilities.setAppVariable($rootScope.qApp, 'vDeflatorValue', $scope.deflatorSelected);
			//google analytics tracking
			gtag('event', displayType + $rootScope.survey.abbreviation+'-Deflator-'+$scope.deflatorSelectedName, { 'event_label': 'select', 'event_category': 'table-options'});
		}

		$scope.clickDataSummary = function(e) {
			e.preventDefault();
			if(e.currentTarget.ariaSelected == "true")
				return;

			if(displayType == "CB-") {
				let container = $("#data-summary-container");
				container.css("max-height", "calc(100vh - 375px)");
			}
			gtag('event',  displayType + $rootScope.survey.abbreviation+'-View data summary', { 'event_label': 'view', 'event_category': 'metadata'});
			$scope.tblTab = 'summary';
			//$scope.toggleReadOnly(true);
			$scope.disablePage(true);
			
			$rootScope.$broadcast('loadDataSummaryEvent');
		}

		$scope.clickCustomizeData = function(e) {
			e.preventDefault();
			if(e.currentTarget.ariaSelected == "true")
				return;
			let action = displayType == 'TB-'?'-View table':'-View chart'			
			gtag('event',  displayType + $rootScope.survey.abbreviation+action, { 'event_label': 'view', 'event_category': 'visualization'});
			$scope.tblTab = 'table';
			$scope.disablePage(false);
		}

		$scope.clickChartData = function(e) {
			e.preventDefault();
			if(e.currentTarget.ariaSelected == "true")
				return;
			
			gtag('event', displayType + $rootScope.survey.abbreviation+'-View Chart Data table', { 'event_label': 'view', 'event_category': 'visualization-data'});
			$scope.tblTab = 'chartData';
			//$scope.toggleReadOnly(true);
			$scope.disablePage(true);
			//$scope.tblListener();
			//$("#tblTabs a[href='#chartDataTabPanel']").tab('show');

			function setTblProps(type) {
				//$scope.pivotObjId = randomQID();
				$scope.tblProps = {
					"qInfo": {
						"qType": type,
						"qId": $scope.pivotObjId
					},
					//"qMetaDef": {},
					"qHyperCubeDef": {
						qSuppressZero: false,
						qSuppressMissing: true,
					},
					"scrollbar": {
						"size": "medium"
					}
				};
			};

			function resizeVizContainer() {
				/* 88 - header
				42 - survey header
				34 - variable sec
				40 - tab header
				64 - footer
				--------
				268 */
				var ht = 288; //total height + 8 for padding
				var vcWrp = $("#QV02").parent()
				vcWrp.css("height", "calc(100vh - " + ht + "px)");
			}

			$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getEffectiveProperties().then(function(props) {
					setTblProps("table");
					$scope.tblProps.qHyperCubeDef.qDimensions = props.qHyperCubeDef.qDimensions;
					$scope.tblProps.qHyperCubeDef.qMeasures = props.qHyperCubeDef.qMeasures;
					$scope.tblProps.qHyperCubeDef.qMode = "S";
					$scope.tblProps.qHyperCubeDef.qAlwaysFullyExpanded = false;
					$scope.tblProps.qHyperCubeDef.qShowTotalsAbove = true;
					$scope.tblProps.showTitles = props.showTitles;
					$scope.tblProps.title = props.title;
					$scope.tblProps.footnote = props.footnote;
					for(var x = 0; x < $scope.tblProps.qHyperCubeDef.qDimensions.length; x++) {
						$scope.tblProps.qHyperCubeDef.qDimensions[x].qTotalLabel = {};
						$scope.tblProps.qHyperCubeDef.qDimensions[x].qShowTotal = false;
					}
					$scope.tblProps.totals = {
						"show": false,
						"position": "noTotals",
						"label": ""
					};
					$scope.tblProps.scrolling = {
						"horizontal": true,
						"keepFirstColumnInView": false,
						"keepFirstColumnInViewTouch": false
					};
					//$scope.qAdhocProps.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions = [];
					$rootScope.qApp.visualization.create('table', [], $scope.tblProps).then(function(vis) {
						resizeVizContainer();
						vis.show("QV02");
					})
				})
			})
		}

		$scope.clickConvertTableToChart = function (evt) {
			$("#ddTableToChart").modal('show');
		}

		$scope.clickExportDataSummary = function () {
			var file, dateTime, filename, getTableData;
			var ids = [], tags = [];
			for(var x=0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
				var apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
				for(var y = 0; y < apiGrps.length; y++) {
					for(var z=0; z < apiGrps[y].measures.length; z++) {
						if(apiGrps[y].measures[z].selected == true)
						{
							ids.push(apiGrps[y].measures[z].variableId);
							tags.push(apiGrps[y].measures[z].shortName);
						}
					}
				}
			}

			var recodes = [];
			for(var w=0; w < $rootScope.dimensionProperties.apiDimTopics.length; w++) {
				var topic = $rootScope.dimensionProperties.apiDimTopics[w];
				for(var x = 0; x < topic.dimensionGroups.length; x++) {
					var grp = topic.dimensionGroups[x];
					for(var y=0; y < grp.dimensions.length; y++) {

						if(grp.dimensions[y].hierarchyAvailable == "Y") {
							if (grp.dimensions[y].selected) {
								var tmpTree = grp.dimensions[y].savedDims;
								for(var z =0; z < tmpTree.length; z++) {
									if(grp.dimensions[y].selected && tmpTree[z].selected) {
										ids.push(tmpTree[z].variableId);
										tags.push(tmpTree[z].shortName);
									}
								}
							} else if (grp.dimensions[y].recodeTrees != null) {
								var recodeTree = grp.dimensions[y].recodeTrees;
								for (var z = 0; z < recodeTree.length; z++) {
									if (recodeTree[z].selected) {
										for (var a = 0; a < recodeTree[z].dimensions.length; a++) {
											if (recodeTree[z].dimensions[a].selected) {
												ids.push(recodeTree[z].dimensions[a].variableId);
												tags.push(recodeTree[z].dimensions[a].shortName);
											}
										}
									}
								}
							}
						} else if (grp.dimensions[y].commonRecodeTrees != null) {
							var recodeTree = grp.dimensions[y].commonRecodeTrees;
							for (var z = 0; z < recodeTree.length; z++) {
								if (recodeTree[z].selected) {
									for (var a = 0; a < recodeTree[z].dimensions.length; a++) {
										if (recodeTree[z].dimensions[a].selected) {
											ids.push(recodeTree[z].dimensions[a].variableId);
											tags.push(recodeTree[z].dimensions[a].shortName);
										}
									}
								}
							}
						} else if(grp.dimensions[y].selected == true) {
							ids.push(grp.dimensions[y].variableId);
							tags.push(grp.dimensions[y].shortName);
						} else if(grp.dimensions[y].recodes) {
							for(var a=0; a < grp.dimensions[y].recodes.length; a++) {
								if(grp.dimensions[y].recodes[a].selected) {
									//var item = grp.dimensions[y];
									//item.recodeName = grp.dimensions[y].recodes[a].recodeName;
									recodes.push(grp.dimensions[y].recodes[a].recodeName);
									ids.push(grp.dimensions[y].variableId);
									tags.push(grp.dimensions[y].shortName);
								}
							}
						} else if(grp.dimensions[y].commonRecodes) {
							for(var a=0; a < grp.dimensions[y].commonRecodes.length; a++) {
								if(grp.dimensions[y].commonRecodes[a].selected) {
									//var item = grp.dimensions[y];
									//item.recodeName = grp.dimensions[y].recodes[a].recodeName;
									recodes.push(grp.dimensions[y].commonRecodes[a].recodeName);
									ids.push(grp.dimensions[y].variableId);
									tags.push(grp.dimensions[y].shortName);
								}
							}
						}
					};
				};
			};
			gtag('event', displayType + $rootScope.survey.abbreviation + '-Export data summary', { 'event_label': 'data-summary', 'event_category': 'download'});
			appUtilities.exportVariableSummaryFromApi(qlik, $http, ids).then(function(resp) {
				//write to file
				if(recodes.length > 0) {
					//resp.data
				}
				file = new Blob([resp.data], { type: 'application/csv' });

				dateTime = new Date();
				var product = ($rootScope.displayVisType == "pivot-table" ? 'table' : 'chart');
				filename = "ncses_" + product +"_var_meta_smry_" + $rootScope.survey.abbreviation + "_" + dateTime.toISOString().split('.')[0]+"Z";
				saveAs(file, filename + ".csv");
			}, function (err) {
				appUtilities.showError(err);
			})
		}

		$scope.clickExportChartData = function (surveyAbbreviation) {
			//var spinner = appUtilities.initSpinner();
			$scope.toggleReadOnly(true)
			// google analytics tracking
			gtag('event', displayType + $rootScope.survey.abbreviation+'-Export Chart Data Table', { 'event_label': 'chart_data', 'event_category': 'download'});
			$rootScope.qApp.visualization.get($rootScope.visObjId ).then(function(vis){
				vis.exportData({format:'CSV_C', state: 'A'}).then(function (link) {
					//bug workaround
					var n = link.lastIndexOf("https");
					if(n > 0)  {
						link = link.substr(n);
					}
					$http.get(link,{responseType: 'arraybuffer'}).then(function (response) {
						console.log('csv: ', response);
						var zip = new JSZip();
						var csvObj = new Blob([response.data]);
						var dateObj = new Date();
						var dateStr = dateObj.toString();
						var filename = "ncses_chart_srv_data_" + $rootScope.survey.abbreviation + "_" + dateObj.toISOString().replace(/:/g, "_").split('.')[0]+"Z";
						zip.file(filename + ".csv", csvObj, {base64: true});						

						hyperCubeProperties.getExportSupplementalData(qlik, $rootScope, $scope, $http, dateStr).then(function(metadata) {

							zip.file("chart-description-"+$rootScope.survey.abbreviation+".txt", metadata);						
							zip.generateAsync({type:'blob'}).then(function(content) {
								saveAs(content, filename + ".zip");
								//spinner.stop();
								$scope.toggleReadOnly(false);
							});
						});
					}, function (err) {
						//spinner.stop();
						$scope.toggleReadOnly(false);
						console.log('csvErr', err);
						return;
					});
				}, function(err) {
					//spinner.stop();
					$scope.toggleReadOnly(false);
					console.log('csvErr', err);
				});
			});
		}

		$scope.showPopup = function() {
			//console.log(this);
			if($rootScope.chart.dimCount > 2 &&($rootScope.displayVisType == "linechart" || $rootScope.chart.barType == "v-grouped" || $rootScope.chart.barType == "v-stacked") ) {
				var chart = document.getElementById('QV01');
				var msg = document.getElementById('chartTip');
				msg.setAttribute("style", "left: " + (parseInt(chart.clientWidth) / 2) + "px");
				return true;
			} else if($rootScope.chart.dimCount > 2 &&($rootScope.chart.barType == "h-grouped" || $rootScope.chart.barType == "h-stacked")){
				var chart = document.getElementById('QV01');
				var msg = document.getElementById('chartTip');
				msg.setAttribute("style", "left: 30px");
				return true;
			}
			else {
				return false;
			}
		}


	}])
});
'use strict'
define('scripts/directives/modalSortDirective',["js/qlik",  "scripts/appModule", "scripts/shared/dimensions", "scripts/shared/measures"], 
function (qlik, appModule, dimensions, measures) {
		
		angular.module("appModule").directive("dtModalSort", function() {	
			return {
				restrict: 'EA',
				templateUrl: 'templates/dtModalSort.html',
				controller: 'ModalSortController'
			}  
		});

	angular.module("appModule").controller("ModalSortController", ["$scope", "$rootScope", "$q", 
		function ($scope, $rootScope, $q) {	
			$scope.display = {}
			$scope.display.sortType = 'Xaxis';
			$scope.sortOptions = [{'value': "-1", 'name': 'Descending'},{'value': "1", 'name':'Ascending'},{'value': "0", 'name': 'Default'}];

			$scope.selectedMeasureArray=[];
			$scope.selectedDimensionArray=[];
			$scope.clickSortTable = function () {
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getEffectiveProperties().then(function (props) {
						
						if($rootScope.displayVisType == 'barchart') {
							//Measure sorting is used when 1st pos of sort order = 1 (1 dim selected)
							//or when 2nd pos = 2 (2 dims are selected)
							if(props.qHyperCubeDef.qInterColumnSortOrder.length > 0 &&
								props.qHyperCubeDef.qInterColumnSortOrder[0] == 1) {
								if($rootScope.chart.barType == 'h-grouped' || $rootScope.chart.barType == 'h-stacked') {
									$scope.display.sortType = 'Xaxis';
								} else {
									$scope.display.sortType = 'Yaxis';
								}
							} else if(props.qHyperCubeDef.qInterColumnSortOrder.length > 1 &&
								props.qHyperCubeDef.qInterColumnSortOrder[1] == 2) {
								if($rootScope.chart.barType == 'h-grouped' || $rootScope.chart.barType == 'h-stacked') {
									$scope.display.sortType = 'Xaxis';
								} else {
									$scope.display.sortType = 'Yaxis';
								}
							} else {
								if($rootScope.chart.barType == 'h-grouped' || $rootScope.chart.barType == 'h-stacked') {
									$scope.display.sortType = 'Yaxis';
								} else {
									$scope.display.sortType = 'Xaxis';
								}								
							}
						} else if($scope.displayVisType == 'linechart') {
							$scope.display.sortType = 'Xaxis';
						} else {
							//pivot table
							$scope.display.disableTblMsrs = false;
							if(props.qHyperCubeDef.qDimensions.length == props.qHyperCubeDef.qNoOfLeftDims) {
								if(props.qHyperCubeDef.qSortbyYValue != null
								&& props.qHyperCubeDef.qSortbyYValue != 0)
									$scope.display.sortType = 'Yaxis';
								else
									$scope.display.sortType = 'Xaxis';
							} else {
								$scope.display.sortType = 'Xaxis';
								$scope.display.disableTblMsrs = true;
							}
						}
						$scope.selectedMeasureArray = getMeasureSortOptions(obj, props);
						$scope.selectedDimensionArray = getDimensionSortOptions(obj, props);						
					});
				});
				$('#modal-sort-options').modal('toggle');
			}
			
			$scope.applySortSelections = function() {
				gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-')  + $rootScope.survey.abbreviation + '-Apply Sort', {
					'event_label': 'apply',
					'event_category': 'sort'
				});					
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getEffectiveProperties().then(function (props) {
						if($rootScope.displayVisType == 'pivot-table') {	
							if($scope.display.sortType == 'Yaxis') {
								setMeasureTableSort(props);
							} else {
								setDimensionSort(props);
								props.qHyperCubeDef.qSortbyYValue = 0;
							}	
						} else if($scope.displayVisType == 'barchart') {
							if(($rootScope.chart.barType == 'v-grouped' || $rootScope.chart.barType == 'v-stacked')
							&& $scope.display.sortType == 'Yaxis') {
								if($scope.selectedDimensionArray.length > 1) {
									setDimensionSort(props)
								}
								setMeasureChartSort(props);
							} else if(($rootScope.chart.barType == 'h-grouped' || $rootScope.chart.barType == 'h-stacked')
							&& $scope.display.sortType == 'Xaxis') {
								if($scope.selectedDimensionArray.length > 1) {
									setDimensionSort(props)
								}
								setMeasureChartSort(props);
							} else {
								setDimensionSort(props);
								props.qHyperCubeDef.qSortbyYValue = 0;
							}							
						} else { //line chart
							setDimensionSort(props);
							props.qHyperCubeDef.qSortbyYValue = 0;
						}
						
						obj.setProperties(props).then(function() {	
							$('#modal-sort-options').modal('toggle');
							return;
						 }, function(err) { 
							console.log('err', err);
							$('#modal-sort-options').modal('toggle');
							return;
						});	 
								
					});						
				});			
				
			}
		
			function setDimensionSort(props) {
				var sortDir = 1;
				for (var i = 0; i < $scope.selectedDimensionArray.length; i++) {
					for (var j = 0; j < props.qHyperCubeDef.qDimensions.length; j++) {
						if($scope.selectedDimensionArray[i].cId == props.qHyperCubeDef.qDimensions[j].qDef.cId) {
							
							sortDir = parseInt($scope.selectedDimensionArray[i].sortIndicator);							
							props.qHyperCubeDef.qDimensions[j].qDef.qSortCriterias[0].qSortByExpression = 0;
							props.qHyperCubeDef.qDimensions[j].qDef.qSortCriterias[0].qExpression = {};
							
							props.qHyperCubeDef.qDimensions[j].qDef.qSortCriterias[0].qSortByAscii = sortDir;
							props.qHyperCubeDef.qDimensions[j].qDef.qSortCriterias[0].qSortByNumeric = sortDir;
							if(sortDir == 0)
								props.qHyperCubeDef.qDimensions[j].qDef.qSortCriterias[0].qSortByLoadOrder = 1;
							else
								props.qHyperCubeDef.qDimensions[j].qDef.qSortCriterias[0].qSortByLoadOrder = 0;

							props.qHyperCubeDef.qDimensions[j].qDef.autoSort = false;
						}
					}
				}
				
				//if sort by Y then skip since colSortOrder defined by measures
				if($scope.display.sortType == 'Xaxis' && ($rootScope.chart.barType == "v-grouped" || $rootScope.chart.barType == "v-stacked")) {
					if($scope.selectedDimensionArray.length > 1){
						props.qHyperCubeDef.qInterColumnSortOrder = [0,1, 2]
					} else {
						props.qHyperCubeDef.qInterColumnSortOrder = [0, 1];
					}								
				} else if($scope.display.sortType == 'Yaxis' && ($rootScope.chart.barType == "h-grouped" || $rootScope.chart.barType == "h-stacked")) {
					if($scope.selectedDimensionArray.length > 1){
						props.qHyperCubeDef.qInterColumnSortOrder = [0,1, 2]
					} else {
						props.qHyperCubeDef.qInterColumnSortOrder = [0, 1];
					}								
				}				
			}
			
			
			
			function setMeasureChartSort(props) {
				var sortDir = 1;		
				sortDir = parseInt($scope.selectedMeasureArray[0].sortIndicator);
				
				var sortDef = {
					"qSortByState": 0,
					"qSortByFrequency": 0,
					"qSortByNumeric": sortDir,
					"qSortByAscii": 0,
					"qSortByLoadOrder": 0,
					"qSortByExpression": 0,
					"qExpression": {
						"qv": ""
					},
					"qSortByGreyness": 0
				};
				props.qHyperCubeDef.qMeasures[0].qSortBy = sortDef;
				if($rootScope.chart.barType == "v-stacked" || $rootScope.chart.barType == "h-stacked"){
					var dimSort = props.qHyperCubeDef.qDimensions[0].qDef.qSortCriterias;
					dimSort[0].qExpression.qv = props.qHyperCubeDef.qMeasures[0].qDef.qDef;
					dimSort[0].qSortByExpression = sortDir;
				}				
				
				var arr = [];
				if($scope.selectedDimensionArray.length > 1)
					props.qHyperCubeDef.qInterColumnSortOrder = [0,2,1]
				else 
					props.qHyperCubeDef.qInterColumnSortOrder = [1, 0]; //[2,0,1]
			}

			function setMeasureTableSort(props) {
				var sortDir = 1;		
				sortDir = parseInt($scope.selectedMeasureArray[0].sortIndicator)
				props.qHyperCubeDef.qSortbyYValue = sortDir;
				
			}

			function getMeasureSortOptions(obj, props) {
				var msrs=[];
				for (var i = 0; i < obj.layout.qHyperCube.qMeasureInfo.length; i++) {
					for (var j = 0; j < props.qHyperCubeDef.qMeasures.length; j++) {
						if(obj.layout.qHyperCube.qMeasureInfo[i].cId == props.qHyperCubeDef.qMeasures[j].qDef.cId) {
							var item = obj.layout.qHyperCube.qMeasureInfo[i];
							var msr = props.qHyperCubeDef.qMeasures[j];
							var cId = msr.qDef.cId;
							var sortByProperty;
							if($scope.display.sortType == 'Xaxis' && ($rootScope.chart.barType == "v-grouped" || $rootScope.chart.barType == "v-stacked")) {
								sortByProperty = null;
							} else if($scope.display.sortType == 'Yaxis' && ($rootScope.chart.barType == "h-grouped" || $rootScope.chart.barType == "h-stacked")) {
								sortByProperty = null;
							} else {
								if($rootScope.displayVisType == 'pivot-table') {
									sortByProperty = props.qHyperCubeDef.qSortbyYValue == null?null:props.qHyperCubeDef.qSortbyYValue.toString();
								} else {
										sortByProperty = null;									
								}
							}
							msrs.push({"position" : i, "cId": cId, "name": item.qFallbackTitle, "sortIndicator": sortByProperty});
							return msrs;  //sorts can only use first measure 
						}
					}
				}					
				return msrs;				
			}
			
			function getDimensionSortOptions(obj, props) {
				var dims = [];
				for (var i = 0; i < obj.layout.qHyperCube.qDimensionInfo.length; i++) {
					for (var j = 0; j < props.qHyperCubeDef.qDimensions.length; j++) {
						if(obj.layout.qHyperCube.qDimensionInfo[i].cId == props.qHyperCubeDef.qDimensions[j].qDef.cId) {
							var item = obj.layout.qHyperCube.qDimensionInfo[i];
							var dim = props.qHyperCubeDef.qDimensions[j];
							var cId = dim.qDef.cId;
							var criteria = dim.qDef.qSortCriterias[0];
							var sortByProperty;

							if(props.qHyperCubeDef.qSortbyYValue != null && props.qHyperCubeDef.qSortbyYValue != 0)
								sortByProperty = null;
							else if(criteria.qSortByAscii == undefined)
								sortByProperty = "0";
							else
								sortByProperty = criteria.qSortByAscii.toString();  //item.qSortIndicator;

							dims.push({"position" : i, "cId": cId, "name": item.qFallbackTitle, "sortIndicator": sortByProperty});
						}
					}
				}
				 return dims;					
			}

			$scope.disableApply = function() {
				var disable = false;
				if($rootScope.chart.barType == 'h-grouped' || $rootScope.chart.barType == 'h-stacked') {
					if($scope.display.sortType == 'Xaxis') {
						for (var i = 0; i < $scope.selectedMeasureArray.length; i++) {
							if($scope.selectedMeasureArray[i].sortIndicator == null)
								disable = true;
						}						
					} else if($scope.display.sortType == 'Yaxis') {
						for (var i = 0; i < $scope.selectedDimensionArray.length; i++) {
							if($scope.selectedDimensionArray[i].sortIndicator == null)
								disable = true;
						}
					}						
				} else {
					if($scope.display.sortType == 'Xaxis') {
						for (var i = 0; i < $scope.selectedDimensionArray.length; i++) {
							if($scope.selectedDimensionArray[i].sortIndicator == null)
								disable = true;
						}
					} else if($scope.display.sortType == 'Yaxis') {
						for (var i = 0; i < $scope.selectedMeasureArray.length; i++) {
							if($scope.selectedMeasureArray[i].sortIndicator == null)
								disable = true;
						}					
					}
				}
				return disable;
			}
		}])			
});
'use strict'
define('scripts/directives/modalMsgDirective',["js/qlik",  "scripts/appModule", "scripts/shared/webProperties"], 
	function (qlik, appModule, webProperties) {
		
		angular.module("appModule").directive("dtModalMsg", function() {	
		return {
		restrict: 'EA',	
		templateUrl: 'templates/dtModalMsg.html',
		controller: 'ModalMsgController'
		}  
	});	
	
	angular.module("appModule").controller("ModalMsgController", ["$scope", "$sce",   
		function ($scope, $sce) {	
		
 		$scope.btnDeflatorMsgClick = function () {                                        
			$scope.msgTitle = $scope.amountOptions.deflatorTooltip.title;
			$scope.msgText =  $sce.trustAsHtml($scope.amountOptions.deflatorTooltip.msg);			    
			$('#modal-msg').modal('toggle');
		}
		
		$scope.$on('showMsgModalEvent', function (e, msg) {
			//console.log('e', e);
			//console.log('$scope', $scope)
			$scope.msgTitle = msg.title;
			$scope.msgText =  $sce.trustAsHtml(msg.text);	
			$('#modal-msg').modal('toggle');
		});		
				
	}])		
	
});
'use strict'
define('scripts/directives/modalErrorDirective',["js/qlik",  "scripts/appModule", "scripts/shared/webProperties"], 
	function (qlik, appModule, webProperties) {
		
		angular.module("appModule").directive("dtModalError", function() {	
		return {
			restrict: 'EA',	
			templateUrl: 'templates/dtModalError.html'
		}  
	});
});
'use strict'
define('scripts/directives/modalOfflineErrorDirective',["js/qlik",  "scripts/appModule", "scripts/shared/webProperties"], 
	function (qlik, appModule, webProperties) {
		
		angular.module("appModule").directive("dtModalOfflineError", function() {	
		return {
		restrict: 'EA',	
		templateUrl: 'templates/dtModalOfflineError.html'
		}  
	});
});
'use strict'
define('scripts/directives/feedbackDirective',["qlik", "scripts/shared/appUtilities", "scripts/shared/webProperties"], function (qlik, appUtilities, webProperties) {
	angular.module("appModule").directive("dtFeedback", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtFeedback.html',
			scope: true,
			controller: 'FeedbackController',
			link: function (scope, element, attrs, cntrl) {
				$( "#feedbackModal" ).on('shown.bs.modal', function(){
					scope.clearAll();
				})
			}
		};
	});

	angular.module("appModule").controller("FeedbackController", ["$scope", "$rootScope", "$location", "$http", '$q',
	function ($scope, $rootScope, $location, $http, $q) {
		var appObj = $rootScope.qApp;
		$scope.bugModel = {};
		$scope.commentModel = {};
		$scope.postCommentSuccessful = false;
		$scope.postBugSuccessful = false;
		$scope.postHasErrors = false;
		$scope.postMessage;
		$scope.postErrors;
		$scope.postTimestamp;
		var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';


		appUtilities.getSurveyList($http, $q).then(
			function (resp) {
				if (resp && resp.data && resp.data.body && resp.data.body.content) {
					resp.data.body.content.splice(0, 0, {
						survey: "",
						surveyShortName: "Choose one..."
					});
					$scope.surveys = resp.data.body.content
				} else {
					appUtilities.showError(resp);
				}
			}
		);

		$scope.clearMsg = function() {
			$scope.clearAll();
		}

		$scope.$on('openFeedbackEvent', function (e) {
			$scope.clickOpenFeedback();
		});		

		$scope.clickOpenFeedback = function () {
			//google analytics tracking
			gtag('event', displayType + 'Open Feedback', {
				'event_label': 'open',
				'event_category': 'feedback'
			});
			//$scope.clearAll();

			$("#feedbackModal").modal();
			$('#comments-link').tab('show');
			$scope.tabSelected = "comment";

			 $scope.initCommentSurveyDisplay = true;
			 $scope.initBugSurveyDisplay = true;
		}

		$scope.clickTabComment = function(e) {
			e.preventDefault();
			//$scope.postSuccessful = false;
			$scope.postHasErrors = false;
			$scope.tabSelected = "comment";
			$("#feedbackMenu a[href='#comments-tab']").tab('show');
		}

		$scope.clickTabBug = function(e) {
			e.preventDefault();
			//$scope.postSuccessful = false;
			$scope.postHasErrors = false;
			$("#feedbackMenu a[href='#bug-tab']").tab('show');
			$scope.tabSelected = "bug";
		}

		$scope.clickTabContact = function(e) {
			e.preventDefault();
			//$scope.postSuccessful = false;
			$scope.postHasErrors = false;
			$scope.tabSelected = "contact";
			$("#feedbackMenu a[href='#contact-tab']").tab('show');
		}

		$scope.clickCommentSurvey = function() {
			if($scope.commentModel.commentSurvey == "")
				$scope.initCommentSurveyDisplay = true;
			else
				$scope.initCommentSurveyDisplay = false;

			if($scope.surveys.map(function(e) {
				return e.survey;
			}).indexOf($scope.commentModel.commentSurvey) > 0)
				$("#commentSurvey").css("color", "#000");
			else
				$("#commentSurvey").css("color", "#b0b0b0");
		}

		$scope.clickBugSurvey = function() {
			$scope.initBugSurveyDisplay = false;
			if($scope.bugModel.bugSurvey == "")
				$scope.initBugSurveyDisplay = true;
			else
				$scope.initBugSurveyDisplay = false;
		}

		$scope.clearAll = function() {
			$scope.postCommentSuccessful = false;
			$scope.postBugSuccessful = false;
			$scope.postHasErrors = false;

			$scope.commentModel.commentComments = "";
			$scope.commentModel.commentSurvey = "";
			$scope.commentModel.commentFirstName = "";
			$scope.commentModel.commentLastName = "";
			$scope.commentModel.commentContactMe = "";
			$scope.commentModel.commentNsfOptIn = "";
			$scope.commentModel.commentEmail = "";
			$scope.postCommentMessage = "";

			$scope.bugModel.bugComments = "";
			$scope.bugModel.bugSurvey = "";
			$scope.bugModel.bugFirstName = "";
			$scope.bugModel.bugLastName = "";
			$scope.bugModel.bugContactMe = "";
			$scope.bugModel.bugNsfOptIn = "";
			$scope.bugModel.bugEmail = "";
			$scope.postBugMessage = "";

			$scope.commentForm.$setPristine();
			$scope.commentForm.$setUntouched();
			$scope.bugForm.$setPristine();
			$scope.bugForm.$setUntouched();
		}

		$scope.checkCommentNsfOptIn = function() {
			if($scope.commentModel.commentNsfOptIn) {
				$scope.postCommentMessage = "Thank you for subscribing to the NCSES Web User Community listserv. You will receive a confirmation email soon, acknowledging your successful subscription to the listserv.";
			} else {
				$scope.postCommentMessage = "";
			}
		}

		$scope.checkBugNsfOptIn = function() {
			if($scope.bugModel.bugNsfOptIn) {
				$scope.postBugMessage = "Thank you for subscribing to the NCSES Web User Community listserv. You will receive a confirmation email soon, acknowledging your successful subscription to the listserv.";
			} else {
				$scope.postBugMessage = "";
			}
		}

		$scope.clickSubmitComment = function () {
			$scope.postCommentSuccessful = false;
			$scope.postHasErrors = false;
			//$scope.postMessage = "";

      //google analytics tracking
      gtag('event', displayType + ($scope.commentModel.commentSurvey != ''?$scope.commentModel.commentSurvey:'') + ' feedback comment-submit', 
				{ 'event_label': 'submit', 
					'event_category': 'feedback'}
				);
			var type = $rootScope.displayVisType == "pivot-table" ? 'TT' : 'CB';
			var json = {
				comment: $scope.commentModel.commentComments,
				type: "comment",
				survey: $scope.commentModel.commentSurvey !=""?$scope.commentModel.commentSurvey:null,
				firstName: $scope.commentModel.commentFirstName != ""?$scope.commentModel.commentFirstName:null,
				lastName: $scope.commentModel.commentLastName != ""?$scope.commentModel.commentLastName:null,
				optInFeedbackCorr: $scope.commentModel.commentContactMe ? "yes" : null,
				optInNsfCorr: $scope.commentModel.commentNsfOptIn ? "yes" : null,
				email: $scope.commentModel.commentEmail != "" ? $scope.commentModel.commentEmail: null,
				product: type
			}

			postFeeddback(json).then(function (resp) {
				$scope.postCommentSuccessful = true;
				$scope.postTimestamp = resp.data.status.timestamp;
			}, function (err) {
				if (err.data && err.data.status) {
					$scope.postHasErrors = err.data.status.hasErrors;
					$scope.postMessage = err.data.status.message;
					$scope.postErrors = err.data.status.errors;
				} else {
					$scope.postHasErrors = true;
					$scope.postMessage = "Connection error";
				}
			});
		};

		$scope.clickSubmitBug = function () {
			$scope.postBugSuccessful = false;
			$scope.postHasErrors = false;

      //google analytics tracking
      gtag('event',  displayType + ($scope.bugModel.bugSurvey != ''?$scope.bugModel.bugSurvey:'') + ' feedback bug-submit', 
				{ 'event_label': 'submit', 
					'event_category': 'feedback'}
				);
			var type = $rootScope.displayVisType == "pivot-table" ? 'TT' : 'CB';
			var json = {
				comment: $scope.bugModel.bugComments,
				type: "issue",
				survey: $scope.bugModel.bugSurvey != ""?$scope.bugModel.bugSurvey:null,
				firstName: $scope.bugModel.bugFirstName != ""?$scope.bugModel.bugFirstName:null,
				lastName: $scope.bugModel.bugLastName != ""?$scope.bugModel.bugLastName:null,
				optInFeedbackCorr: $scope.bugModel.bugContactMe ? "yes" : null,
				optInNsfCorr: $scope.bugModel.bugNsfOptIn ? "yes" : null,
				email: $scope.bugModel.bugEmail != "" ? $scope.bugModel.bugEmail: null,
				product: type

			}
			postFeeddback(json).then(function (resp) {
				$scope.postBugSuccessful = true;
				$scope.postTimestamp = resp.data.status.timestamp;
			}, function (err) {
				if (err.data && err.data.status) {
					$scope.postHasErrors = err.data.status.hasErrors;
					$scope.postMessage = err.data.status.message;
					$scope.postErrors = err.data.status.errors;
				} else {
					$scope.postHasErrors = true;
					$scope.postMessage = "Connection error";
				}
			});
		};

		function postFeeddback(json) {
			var Promise = qlik.Promise;
			return new Promise(function (resolve, reject) {
				$http({
					method: 'POST',
					url: webProperties.props.metadataApiUrl + 'feedback',
					withCredentials: false,
					data: json,
				}).then(function (data) {
					return resolve(data);
				}, function (err) {
					return reject(err);
				});
			});
		}
	}]);
});
'use strict'
define('scripts/directives/surveyDropDownDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/appUtilities"],
	function (qlik, webProperties, appModule, appUtilities) {

	angular.module("appModule").directive("dtSurveyDropDown", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtSurveyDropDown.html',
		scope: true,
		transclude : false,
		controller: 'SurveyDropDownController'
	  };
	});
	angular.module("appModule").controller("SurveyDropDownController", ["$scope", "$rootScope", "$q", "$location", "$http", '$route',
	function ($scope, $rootScope, $q, $location, $http, $route) {
		var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-'; 
        let keyEvent = null;
        $scope.url = webProperties.props.webUrl;

		appUtilities.getSurveyList($http, $q).then(
			function(resp){
				if(resp && resp.data && resp.data.body  && resp.data.body.content){
					$scope.surveys = resp.data.body.content;
					var typeParam = $location.search().type != null
					if(typeParam) {
						$("#table-link-btn").removeClass('active-link');
					} else {
						$("#table-link-btn").addClass('active-link');
					}

				}
				else {
					appUtilities.showError(resp);
				}
			}
		);

		$scope.ddlSelectSurvey = function(e, survey) {
			e.preventDefault();
			//google analytics tracking
			gtag('event', displayType + survey+'-Select survey', { 'event_label': 'select', 'event_category': 'survey_selection'});
			$location.search({});
			$location.path( "/" + survey.toLowerCase());

			$("#chart-link-btn").removeClass('active-link');
			$("#table-link-btn").addClass('active-link');
		}

		$scope.replaceIllegalChars = function(id) {
			return appUtilities.replaceIllegalChars(id);
		}

	}])
});

'use strict'
define('scripts/directives/buildChartDropDownDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/appUtilities"],
	function (qlik, webProperties, appModule, appUtilities) {

	angular.module("appModule").directive("dtBuildChartDropDown", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtBuildChartDropDown.html',
		scope: true,
		transclude : false,
		controller: 'BuildChartDropDownController'
	  };
	});

	angular.module("appModule").controller("BuildChartDropDownController", ["$scope", "$rootScope", "$route", "$q", "$location", "$http",
	function ($scope, $rootScope, $route, $q, $location, $http) {
        var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
        let keyEvent = null;
        $scope.url = webProperties.props.webUrl;
        
        //Note: bootstrap4 requires jQuery to handle dropdown events like "show.bs.dropdown"
        //Bootstrap5 allows events to be handled by straight javascript like document.getElementById()


             
		appUtilities.getSurveyList($http, $q).then(
			function(resp){
				if(resp && resp.data && resp.data.body  && resp.data.body.content) {
					$scope.surveys = resp.data.body.content;
					var typeParam = $location.search().type != null
					if(typeParam) {
						$("#chart-link-btn").addClass('active-link')
					} else {
						$("#chart-link-btn").removeClass('active-link')
					}
                    
				}
				else {
					appUtilities.showError(resp);
				}
			}
		);

		$scope.ddlSelectSurvey = function(e, survey) {
			e.preventDefault();
			//google analytics tracking
			gtag('event', displayType +  survey+'-Select survey', { 'event_label': 'select', 'event_category': 'survey_selection'});

			$location.search({type: 'chart'});
			$location.path( "/" + survey.toLowerCase());
			$("#chart-link-btn").addClass('active-link');
			$("#table-link-btn").removeClass('active-link');
		}

		$scope.replaceIllegalChars = function(id) {
			return appUtilities.replaceIllegalChars(id);
		}

/* 		$scope.expandBuildChartMenu = function(e) {
				keyEvent = e;
		} */

	}])
});

/******
This module contains the methods for setting up the recodes selection page.  The recodes selection page will be 
depending on the dimension being recoded. If the dimension has less than 20 values than the selections will be 
through checkboxs on the left rail slide out.  If over 20 values will use a scrollable list box.  Institutions
and hierarchal dimensions will also use selectable listboxes.   Each typr of recode interface works a little 
dirrerently so these methods are flexable to work with each recode type's requirements.
- Slide out checkbox:  selections are determined on the value's .selected property.
- Standard scrollable lists (ie. State): Selections are determined by value's .qState property
- Institutions scrollable list: Selections are determined by value's .class property
*******/
define('scripts/shared/recodes',["scripts/shared/appUtilities", "scripts/shared/dimensions"], function (appUtilities, dimensions) {

	const INST = "institution";
	
	function excludeValuesAppliedByOtherRecodes(list, parentDim, recode) {
		if (parentDim.recodes == null || parentDim.recodes.length == 0)
			return list;

		list = list.map(function (v) {
			var excludeFlg = false;
			//When parent dim has been previously selected then set recode values to the same exclusions set in dim
			//if recode is null, then skip to next section to make sure dim excluded values are in sync with applied recodes
			if (parentDim.selected && recode != null) {
				//class edit used to accomidate institution recodes, all other recodes will uswe qState
				if(v.class != null) {
					if(v.class !== 's') {
						excludeFlg = true;
					}					
				} else if(v.qState !== 'S') {
					excludeFlg = true;
				}
			} else {
				for (var x = 0; x < parentDim.recodes.length; x++) {
					//Check if value is selected with another recode dimension
					if (parentDim.recodes[x].selected && (recode == null || parentDim.recodes[x].cId != recode.cId)) {
						//Check if value is part of other recode def
						excludeFlg = true;
						for (var y = 0; y < parentDim.recodes[x].categories.length; y++) {
							for (var z = 0; z < parentDim.recodes[x].categories[y].values.length; z++) {
								if (parentDim.recodes[x].categories[y].values[z].qText == v.qText) {
									excludeFlg = false;
									break;
								}
							}
							if (excludeFlg == false)
								break
						}

						//Check if non-recode value was selected with another recode dimension
						if (excludeFlg) {
							for (var y = 0; y < parentDim.recodes[x].nonRecodeValues.length; y++) {
								if (parentDim.recodes[x].nonRecodeValues[y].qText == v.qText
									 && parentDim.recodes[x].nonRecodeValues[y].selected) {
									excludeFlg = false;
									break;
								}
							}
						}
						if (excludeFlg == false)
							break
					}
				}
			}

			if(excludeFlg) {
				v.disabled = true;
				v.qState = 'X';
				if(v.class != null) {
					v.class = 'x';
				}
			} 			
			return v;
		});
		return list;
	}
	
	function showRecodeCategories(list, dim, recode, mode) {			
		//Prepare categories for selection. This method will set recode's categories states so that the categories 
		//are listed within the list of non-recoded vales and that the categories appear in the correct lists
		//of either available for selection or selected.  Method will also check if any other recodes have been selected 
		//for the current dimension.  If true and if any of this recode's category values are also in the other selected recode's
		//category then this recode's category states are set to allow selection of matching current recode's category

	
		//Update recode values with qElemNumber.  This syncing of qElems is required after a user has imported recode definitions
		for (var a = 0; a < recode.categories.length; a++) {
			for (var b = 0; b < recode.categories[a].values.length; b++) {
				for (var x = 0; x < list.length; x++) {
					if (list[x].qText == recode.categories[a].values[b].qText) {
						recode.categories[a].values[b].qElemNumber = list[x].qElemNumber;
						break;
					}	
				}
			}
		}

		//The logic for Inst values is driven by class property instead of qState, so this section
		//will apply class update for inst nonRecode values that have a selected qState
		if(mode == INST && recode.nonRecodeValues != null) {
			for (var a = 0; a < recode.nonRecodeValues.length; a++) {
				for (var b = 0; b < list.length; b++) {
					if (recode.nonRecodeValues[a].qText == list[b].qText) {
						//list[b].class = 's';
						list[b].qState = 'S'
						break;
					}	
				}
			}
		}

		//If dim has been selected, then get list of select values. This list will be used to mark categories as selected or not
		var selectedValues  = [];
		
		//This IF clause was used previously when a combination of parent dim and a recode was allowed.
		//This capability is no longer allowed, but this code is needed if this capability is requested in future
		if(dim.selected) {
			selectedValues = list.filter(function (v) {
				//set class to accommodate special handling for institution recodes, all other recodes will use qState
				if(mode == INST) {
					if(v.class == 's') {
						return v;
					}					
				} else if(v.qState == 'S') {
					return v;
				}					
			});
		} else {
			//Refresh state for all recoded categories defined for dim, mark category as selected or excluded 
			for (var a = 0; a < recode.categories.length; a++) {
				if (recode.categories[a].selected) {
					//mark category to show up selected, non-Inst lists use qState
					recode.categories[a].qState = 'S';
					//institutions modal use class property
					recode.categories[a].class = 's';
					for (var b = 0; b < recode.categories[a].values.length; b++) {
						selectedValues.push(recode.categories[a].values[b]);							
					}
				} else {
					//default category to available
					recode.categories[a].qState = 'O';
					recode.categories[a].class = 'o';
					recode.categories[a].disabled = false;
					//next, exclude category if all its values are excluded due to other applied filters							
					let excludedValues = recode.categories[a].values.filter(function (catVal) {
						//X - value is excluded; XS - value was initially selected but has been excluded due to other applied dim filters
						let val = list.find(function(value) {
							return catVal.qText == value.qText && (value.qState == 'X' || value.qState == 'XS')
						})
						return val;				
					});
					if(excludedValues != null && excludedValues.length == recode.categories[a].values.length) {
						recode.categories[a].qState = 'X';
						recode.categories[a].class = 'x';
						recode.categories[a].disabled = true;
					}
				}
			}
		}

		//mark each category value as selected or excluded; these values will be applied to the Qlik engine when recode is selected
		for (var a = recode.categories.length - 1; a >= 0; a--) {
			excludeCatFlg = true;
			for (var b = 0; b < recode.categories[a].values.length; b++) {
				if(selectedValues.length > 0) {
					for (var x = 0; x < selectedValues.length; x++) {
						//if at least 1 value in category is selected, then mark entire category as selected
						if (selectedValues[x].qText == recode.categories[a].values[b].qText) {
							excludeCatFlg = false;
							recode.categories[a].values[b].selected = true;
							recode.categories[a].values[b].qState = 'S';
							recode.categories[a].values[b].disabled = false;
							break;
						} 
						else {
							recode.categories[a].values[b].selected = false;
							
							recode.categories[a].values[b].disabled = false;
							if(recode.categories[a].qState == 'X')
								recode.categories[a].values[b].qState = 'X';
							else
								recode.categories[a].values[b].qState = 'O';
						}
					}
				}
			}
			//Add category into list. Category obj contains the correct selction properties (selected, qState, class)
			list.unshift(recode.categories[a]);	
		};

		//Remove values from list of values displayed to user if the value is also part of a category in the current recode
		//Note: A value can be recoded multile times as long as the recoded categories are in different dim recodes.
		list = list.filter(function (v) {
			//for(var x = 0; x < dim.recodes.length; x++) {
			for (var y = 0; y < recode.categories.length; y++) {
				for (var z = 0; z < recode.categories[y].values.length; z++) {
					if (recode.categories[y].values[z].qText == v.qText) {
						return null;
					}
				}
			}
			if(mode == INST) {
				if(v.class == 's') {
					v.selected = true;
				}
			} else if(v.qState == 'S') {
				v.selected = true;
			}
			return v;
		});

		//console.log(list);
		return list;
	};
	
	//Disable unassigned values to current recode if value has been assigned to another selected recode
	//disableValuesAssignedToOtherSelectedRecodes
	function processRecodedValues(dimValues, dim, recode) {
		var list = dimValues;

		//Remove values from list if they have been added to the recode values definition
		if (recode != null && recode.categories) {
			list = dimValues.filter(function (v) {
				for (var y = 0; y < recode.categories.length; y++) {
					for (var z = 0; z < recode.categories[y].values.length; z++) {
						if (recode.categories[y].values[z].qText == v.qText) {
							return null;
						}
					}
				}
				return v;
			});
		}

		list = list.map(function (v) {
			if (v.disabled || v.qState == 'S')
				return v;

			var disableFlg = false;
			if (dim.recodes) {
				for (var x = 0; x < dim.recodes.length; x++) {
					//Check if value is selected with another recode dimension
					if (dim.recodes[x].selected && (recode == null || recode.cId != dim.recodes[x].cId)) {
						//Check if value is part of other recode def
						disableFlg = true;
						for (var y = 0; y < dim.recodes[x].categories.length; y++) {
							if (dim.recodes[x].categories[y].selected) {
								for (var z = 0; z < dim.recodes[x].categories[y].values.length; z++) {
									if (dim.recodes[x].categories[y].values[z].qText == v.qText) {
										disableFlg = false;
										break;
									}
								}
							}
						}
					}
				}
				//Next, check if parent dim is selected and the value is selected, if not true disable
				if (dim.selected && recode != null) {
					disableFlg = true;
					for (var y = 0; y < dim.values.length; y++) {
						if (dim.values[y].selected && dim.values[y].qText == v.qText) {
							disableFlg = false;
							break;
						}
					}
				}
			}

			v.disabled = disableFlg;
			return v;
		});

		return list;
	}	

	function getDefinedRecodes($rootScope) {
		//$scope.recodesDefinedCount = 0;
		let retArr= [];
		for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
			var topic = $rootScope.dimensionProperties.apiDimTopics[x];
			for (var y = 0; y < topic.dimensionGroups.length; y++) {
				var grp = topic.dimensionGroups[y];
				for (var z = 0; z < grp.dimensions.length; z++) {
					if (grp.dimensions[z].recodes && grp.dimensions[z].recodes.length > 0) {
						let dim = {}
						dim.name = grp.dimensions[z].title
						dim.recodes = []
						for (var a = 0; a < grp.dimensions[z].recodes.length; a++) {
							let recode = {}
							recode.name = grp.dimensions[z].recodes[a].recodeName
							recode.type = "recode"
							recode.categories = []
							for (var b = 0; b < grp.dimensions[z].recodes[a].categories.length; b++) {
								let cat = {}
								cat.name = grp.dimensions[z].recodes[a].categories[b].qText;
								recode.categories.push(cat);
							}
							dim.recodes.push(recode);
						}
						retArr.push(dim)
					} else if (grp.dimensions[z].hierarchyAvailable == 'Y') {
						if(grp.dimensions[z].recodeTrees && grp.dimensions[z].recodeTrees.length > 0) {
							let dim = {}
							dim.name = grp.dimensions[z].title
							dim.recodes = []
							for (var a = 0; a < grp.dimensions[z].recodeTrees.length; a++) {
								let recodeTree = {};
								recodeTree.type = "recodeTree"
								recodeTree.name = grp.dimensions[z].recodeTrees[a].treeName
								recodeTree.dimensions = []
								for (var b = 0; b < grp.dimensions[z].recodeTrees[a].dimensions.length; b++) {	
									let branch = {}
									if(grp.dimensions[z].recodeTrees[a].dimensions[b].type == "recode") {
										branch.name = grp.dimensions[z].recodeTrees[a].dimensions[b].recodeName;
										branch.categories = []
										for (var c = 0; c < grp.dimensions[z].recodeTrees[a].dimensions[b].categories.length;c++) {
											let cat = {}
											cat.name = grp.dimensions[z].recodeTrees[a].dimensions[b].categories[c].qText;
											branch.categories.push(cat);
										}																			
									} else {
										branch.name = grp.dimensions[z].recodeTrees[a].dimensions[b].title;
									}
									recodeTree.dimensions.push(branch);
								}
								dim.recodes.push(recodeTree);
							}
							retArr.push(dim)
						}
					}
				};
			};
		};
		return retArr;
	}


	function saveRecodes($rootScope) {
		var recodedDims = getRecodes($rootScope);
		if (recodedDims != null && recodedDims.length > 0) {
			var jsonObj = {};
			jsonObj.survey = $rootScope.survey.abbreviation;
			jsonObj.lastReloadTime = $rootScope.qApp.model.layout.qLastReloadTime;
			jsonObj.title = $rootScope.qApp.model.layout.qTitle;
			jsonObj.recodedDims = recodedDims;
			return jsonObj;
		}
	}

	function getRecodes($rootScope) {
		var recodeObjs = [];
		for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
			var topic = $rootScope.dimensionProperties.apiDimTopics[x];
			for (var y = 0; y < topic.dimensionGroups.length; y++) {
				var grp = topic.dimensionGroups[y];
				for (var z = 0; z < grp.dimensions.length; z++) {
					if (grp.dimensions[z].recodes) {
						// var dim = {};
						// dim.shortName = grp.dimensions[z].shortName;
						// dim.recodes = grp.dimensions[z].recodes;
						var dimProp = grp.dimensions[z];
						var dim = {};
						dim.shortName = dimProp.shortName;
						dim.type = "recode";
						dim.recodes = [];
						for (var b = 0; b < dimProp.recodes.length; b++) {
							var recode = {};
							recode.shortName = dimProp.recodes[b].shortName;
							//recode.dimCid = dimProp.recodes[b].dimCid;
							recode.recodeName = dimProp.recodes[b].recodeName;
							recode.title = dimProp.recodes[b].title;
							//recode.cId = dimProp.recodes[b].cId;
							//recode.title = dimProp.recodes[b].title;
							recode.type = dimProp.recodes[b].type;
							recode.categories = [];
							for (var c = 0; c < dimProp.recodes[b].categories.length; c++) {
								var recodeValue = {};
								recodeValue.qText = dimProp.recodes[b].categories[c].qText;
								//recodeValue.cId = dimProp.recodes[b].categories[c].cId;
								recodeValue.type = dimProp.recodes[b].categories[c].type;
								//recodeValue.values = dimProp.recodes[b].categories[c].values;
								var cat = dimProp.recodes[b].categories[c];
								recodeValue.values = [];
								for(var d = 0; d < cat.values.length; d++) {
									var value = {}
									value.qText = cat.values[d].qText;
									recodeValue.values.push(value);
								}
								if(dimProp.recodes[b].categories[c].dropDowns && dimProp.recodes[b].categories[c].dropDowns.length > 0) {
									recodeValue.dropDowns = dimProp.recodes[b].categories[c].dropDowns;
								}
								recode.categories.push(recodeValue);
							}
							dim.recodes.push(recode);
						}
						recodeObjs.push(dim);
					} else if (grp.dimensions[z].hierarchyAvailable == 'Y') {

						if(grp.dimensions[z].recodeTrees != null) {
							var trees = grp.dimensions[z].recodeTrees;
							if(trees.length > 0) {
								var recode = {};
								recode.shortName = grp.dimensions[z].shortName;
								recode.title = grp.dimensions[z].title;
								recode.type = "recodeTree";
								recode.recodeTrees = [];


								for (var a = 0; a < trees.length; a++) {
									//if (dims[a].recodes) {
										var t = trees[a];
										var tree = {};
										tree.treeName = t.treeName;
										tree.type = t.type;
										tree.dimensions = [];


										for(var b = 0; b < t.dimensions.length; b++) {
											var dim = {};
											dim.shortName = t.dimensions[b].shortName;
											dim.title = t.dimensions[b].title;
											//dim."def": "fieldBroad"
											dim.type = t.dimensions[b].type;
											if(dim.type == "recode") {
												dim.recodeName = t.dimensions[b].recodeName;
												//dim.nonRecodeValues = t.dimensions[b].nonRecodeValues;
												dim.categories = [];
												var cats = t.dimensions[b].categories;
												for(var c = 0; c < cats.length; c++) {
													var cat = {};
													cat.qText = cats[c].qText;
													cat.type = cats[c].type;
													cat.values = [];
													for(var d = 0; d < cats[c].values.length; d++) {
														var value = {}
														value.qText = cats[c].values[d].qText;
														cat.values.push(value);
													}
													dim.categories.push(cat);
												}
											}
											tree.dimensions.push(dim);
										}
										recode.recodeTrees.push(tree);

									//}
								}

								if(grp.dimensions[z].recodedSrcDims !=null) {
									var recodedSrcDims = [];
									for (var a = 0; a < grp.dimensions[z].recodedSrcDims.length; a++) {
										var dim = {};
										dim.shortName = grp.dimensions[z].recodedSrcDims[a].shortName;
										dim.title = grp.dimensions[z].recodedSrcDims[a].title;
										dim.type = grp.dimensions[z].recodedSrcDims[a].type;
										if(grp.dimensions[z].recodedSrcDims[a].recodes != null) {
											dim.recodes = [];
											for(var b = 0; b < grp.dimensions[z].recodedSrcDims[a].recodes.length; b++) {
												var src = grp.dimensions[z].recodedSrcDims[a].recodes[b];
												var catRecode = {};
												catRecode.shortName = src.shortName;
												catRecode.recodeName = src.recodeName;
												catRecode.type = src.type;
												catRecode.title = src.title;
												catRecode.categories = [];
												if(src.categories != null) {
													for(var c = 0; c < src.categories.length; c++) {
														var cat = {};
														cat.qText = src.categories[c].qText;
														cat.qElemNumber = src.categories[c].qElemNumber;
														cat.values = [];
														for(var d = 0; d < cats[c].values.length; d++) {
															var value = {}
															value.qText = cats[c].values[d].qText;
															cat.values.push(value);
														}
														catRecode.categories.push(cat);
													}
												}
												dim.recodes.push(catRecode);
											}
										}
										recodedSrcDims.push(dim);
									}
									recode.recodedSrcDims = recodedSrcDims;
								}
								recodeObjs.push(recode);
							}
						}
					}
				};
			};
		};
		return recodeObjs;
	}

	function loadRecodeObj($rootScope, qApp, recodeObj) {
		return new Promise(function (resolve, reject) {
			verifyJsonRecode($rootScope, qApp, recodeObj).then(function (unMatchedCount) {
				if(unMatchedCount > 0) {
					let recodeErrs = []
					recodeObj.recodedDims.forEach(function(dim) {
						if(dim.type == "recode") {
							processErrors(dim, dim.recodes);
						} else if(dim.type == "recodeTree") {
							dim.recodeTrees.forEach(function(tree) {
								processErrors(dim, tree.dimensions);
							})
						}
					})
					
					function processErrors(dim, recodes) {
						recodes.forEach(function(recode) {
							if(dim.unMatched || recode.unMatched) {
								let badRecode = {unmatched: "title", title: recode.title + " [" + recode.shortName + "]", recode: recode.recodeName}
								recodeErrs.push(badRecode);
							} else {
								if(recode.type == "recode") {
									recode.categories.forEach(function(cat) {
										let badVals = []
										cat.values = cat.values.filter(function(val) {
											if(val.unMatched) {
												badVals.push(val.qText);
												return;
											} else {
												return val;
											}
										})
										if(badVals.length > 0) {
											let badRecode = {unmatched: "value", title: recode.title, recode: recode.recodeName, cat: cat.qText, values: badVals}
											recodeErrs.push(badRecode);
										}
									})
								}
							}
						})
					}
					return resolve(recodeErrs)
				} else {
					return resolve(null);
				}
			}, function (err) {
				return reject(err);
			});
		});
	}

	//sync dimensionProperties.apiDimTopics with recodes defined in both tableToChartSession.recodedDims and tableToChartSession.apiDimTopics
	function loadRecodes($rootScope, $scope) {
		setRecodes($rootScope, $scope.tableToChartSession.recodedDims);

		function setRecodes($rootScope, recodeObj) {
			for (var i = 0; i < recodeObj.recodedDims.length; i++) {
				for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
					var topic = $rootScope.dimensionProperties.apiDimTopics[x];
					for (var y = 0; y < topic.dimensionGroups.length; y++) {
						var grp = topic.dimensionGroups[y];
						for (var z = 0; z < grp.dimensions.length; z++) {
							if (recodeObj.recodedDims[i].type == "recode") {
								if (recodeObj.recodedDims[i].shortName == grp.dimensions[z].shortName) {
									for(var a = 0; a < recodeObj.recodedDims[i].recodes.length; a++) {
										recodeObj.recodedDims[i].recodes[a].cId = 'recode' + appUtilities.randomCid();
										recodeObj.recodedDims[i].recodes[a].dimCid = grp.dimensions[z].cId;
										for(var b=0; b < recodeObj.recodedDims[i].recodes[a].categories.length; b++) {
											recodeObj.recodedDims[i].recodes[a].categories[b].cId = appUtilities.randomCid();		
										}
										grp.dimensions[z].recodes = recodeObj.recodedDims[i].recodes;
									}
								}
							} else if (recodeObj.recodedDims[i].type == "recodeTree") {
								//additional logic for trees, in addition to poulating left rail, need to sync up properties in the redodeTree with srcDims
								//recodeTree properties must reference srcDims properties for editing and disabling to work
								if (grp.dimensions[z].hierarchyAvailable == 'Y'
									&& recodeObj.recodedDims[i].shortName == grp.dimensions[z].shortName
									&& recodeObj.recodedDims[i].title == grp.dimensions[z].title) {

									//populate srcDims with key properties from API properties
									//srcDims will be then used to populate key recodeTree properties in next section
									var tree = dimensions.getDimensionsForTree(grp.dimensions[z]).slice(0);
									grp.dimensions[z].recodedSrcDims = [];
									for (var a = 0; a < recodeObj.recodedDims[i].recodedSrcDims.length; a++) {
										var srcDim = recodeObj.recodedDims[i].recodedSrcDims[a];
										for(var b = 0; b < tree.length; b++) {
											if(tree[b].shortName  == srcDim.shortName
											&& tree[b].title == srcDim.title) {
												if(srcDim.recodes != null) {
													tree[b].recodes = [];
													for(var c = 0; c < srcDim.recodes.length; c++) {
														srcDim.recodes[c].cId = 'recode' + appUtilities.randomCid();
														srcDim.recodes[c].dimCid = tree[b].cId;
														srcDim.recodes[c].variableId = tree[b].variableId;
														srcDim.recodes[c].associations = tree[b].associations;
														 if(srcDim.recodes[c].categories) {
															for(var d = 0; d < srcDim.recodes[c].categories.length; d++) {
																srcDim.recodes[c].categories[d].cId = appUtilities.randomCid();
															}
														}
														tree[b].recodes.push(srcDim.recodes[c]);
													}
												}
												grp.dimensions[z].recodedSrcDims.push(tree[b]);
											}
										}
									}



									//populte recodeTrees with key properties from srcDims
									grp.dimensions[z].recodeTrees = [];
									for (var a = 0; a < recodeObj.recodedDims[i].recodeTrees.length; a++) {
										var recodeTree = recodeObj.recodedDims[i].recodeTrees[a];
										if(recodeTree.type == "recodeTree") {
											recodeTree.cId = appUtilities.randomCid();
											recodeTree.dimCid = grp.dimensions[z].cId;
											recodeTree.rootTitle = recodeObj.recodedDims[i].title;
											recodeTree.rootShortName = recodeObj.recodedDims[i].shortName;
											grp.dimensions[z].recodeTrees.push(recodeTree);

											for(var b = 0; b < recodeTree.dimensions.length; b++) {
												if(recodeTree.dimensions[b].type == "recode") {
													for(var c = 0; c < grp.dimensions[z].recodedSrcDims.length; c++) {
														if(grp.dimensions[z].recodedSrcDims[c].shortName  == recodeTree.dimensions[b].shortName
														&& grp.dimensions[z].recodedSrcDims[c].title == recodeTree.dimensions[b].title) {
															
															recodeTree.dimensions[b].cId = grp.dimensions[z].recodedSrcDims[c].cId;
															recodeTree.dimensions[b].variableId = grp.dimensions[z].recodedSrcDims[c].variableId;
															recodeTree.dimensions[b].associations = grp.dimensions[z].recodedSrcDims[c].associations;
															recodeTree.dimensions[b].selected = true;
															if(recodeTree.dimensions[b].categories) {
																for(var d = 0; d < grp.dimensions[z].recodedSrcDims[c].recodes.length; d++) {
																	recodeTree.dimensions[b].cId = grp.dimensions[z].recodedSrcDims[c].recodes[d].cId;
																	recodeTree.dimensions[b].dimCid = grp.dimensions[z].recodedSrcDims[c].recodes[d].dimCid;
																	recodeTree.dimensions[b].variableId = grp.dimensions[z].recodedSrcDims[c].recodes[d].variableId;
																	recodeTree.dimensions[b].selected = true;
																	if(grp.dimensions[z].recodedSrcDims[c].recodes[d].recodeName == recodeTree.dimensions[b].recodeName) {
																		for(var e = 0; e < recodeTree.dimensions[b].categories.length; e++) {
																			for(var f=0; f < grp.dimensions[z].recodedSrcDims[c].recodes[d].categories.length; f++) {
																				if(recodeTree.dimensions[b].categories[e].qText == grp.dimensions[z].recodedSrcDims[c].recodes[d].categories[f].qText) {
																					recodeTree.dimensions[b].categories[e].cId = grp.dimensions[z].recodedSrcDims[c].recodes[d].categories[f].cId;
																				}
																			} 
																		}
																	}
																}
															}
														}
													}
												} else {  //type=dim-branch
													for(var c = 0; c < grp.dimensions[z].recodedSrcDims.length; c++) {
														if(grp.dimensions[z].recodedSrcDims[c].shortName  == recodeTree.dimensions[b].shortName
														&& grp.dimensions[z].recodedSrcDims[c].title == recodeTree.dimensions[b].title) {
															recodeTree.dimensions[b] = grp.dimensions[z].recodedSrcDims[c];
															recodeTree.dimensions[b].selected = true;
															break;
														}
													}
												}
											}
										}
									}

									//sync left rail apiTopics with recode selection properties from the tableToChartSession.apiDimTopics
									for (var j = 0; j < $scope.tableToChartSession.apiDimTopics.length; j++) {
										var sessionTopic = $scope.tableToChartSession.apiDimTopics[j];
										for (var k = 0; k < sessionTopic.dimensionGroups.length; k++) {
											let sessionGrps	= sessionTopic.dimensionGroups[k];
											
											for (var l = 0; l < sessionGrps.dimensions.length; l++) {
												if (sessionGrps.dimensions[l].recodeTrees) {
													for (var m = 0; m < sessionGrps.dimensions[l].recodeTrees.length; m++) {	
														var sessionRecodeTree = sessionGrps.dimensions[l].recodeTrees[m];					
														if(sessionRecodeTree.type == "recodeTree") {														
															if (grp.dimensions[z].hierarchyAvailable == 'Y'
															&& sessionRecodeTree.rootShortName == grp.dimensions[z].shortName
															&& sessionRecodeTree.rootTitle == grp.dimensions[z].title) {
																
																for(var n = 0; n < grp.dimensions[z].recodeTrees.length; n++) {
																	if(sessionRecodeTree.treeName = grp.dimensions[z].recodeTrees[n].treeName) {
																		grp.dimensions[z].recodeTrees[n].availTreeValues = sessionRecodeTree.availTreeValues;
																		grp.dimensions[z].recodeTrees[n].savedDims = recodeTree.dimensions; //sessionRecodeTree.savedDims;
																		grp.dimensions[z].recodeTrees[n].savedList = sessionRecodeTree.savedList;
																		grp.dimensions[z].recodeTrees[n].selectedTreeValues = sessionRecodeTree.selectedTreeValues;
																		grp.dimensions[z].recodeTrees[n].selectedValuesCount = sessionRecodeTree.selectedValuesCount;
																		grp.dimensions[z].recodeTrees[n].selected = sessionRecodeTree.selected;
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						};
					};
				};
			};
			return;
		}
	}

	function verifyJsonRecode($rootScope, qApp, jsonObj) {
		return new Promise(function (resolve, reject) {
			for(let x=0; x < jsonObj.recodedDims.length; x++) {
				let unMatchedCount = verifyRecodedVariable($rootScope, jsonObj.recodedDims[x]);

				async function processValues() {
					for (let i = 0; i < jsonObj.recodedDims.length; i++) {
						let recodedDim = jsonObj.recodedDims[i];
						if(recodedDim.type == "recode" && recodedDim.unMatched == null) {
							for (let j = 0; j < recodedDim.recodes.length; j++) {
								let cnts = await verifyRecodedValues(qApp, recodedDim.recodes[j]);
								unMatchedCount += cnts.unMatchedCount;
							}
						} else if(recodedDim.type == "recodeTree") {
							for (let j = 0; j < recodedDim.recodeTrees.length; j++) {
								for (let k = 0; k < recodedDim.recodeTrees[j].dimensions.length; k++) {
									if(recodedDim.recodeTrees[j].dimensions[k].type == "recode"
									&& recodedDim.recodeTrees[j].dimensions[k].unMatched == null) {
										let cnts = await verifyRecodedValues(qApp, recodedDim.recodeTrees[j].dimensions[k]);
										unMatchedCount += cnts.unMatchedCount;
									}
								}
							}
						}
					}
					return resolve(unMatchedCount);
				}
				processValues();
			}
		})
	}
	
	function verifyRecodedVariable($rootScope, jsonDim) {
		let unMatchedCount = 0;
		if (jsonDim.type == "recode") {
			let item = dimensions.getDimensionByName($rootScope, jsonDim.shortName);
			if(item.shortName == null) {
				jsonDim.unMatched = true;
				unMatchedCount++;
			}  
		} else if (jsonDim.type == "recodeTree") { 
			for (let i = 0; i < jsonDim.recodeTrees.length; i++) {
				let tree = jsonDim.recodeTrees[i];
				for (let j = 0; j < tree.dimensions.length; j++) { 
					let item = dimensions.getTreeRootByBranchName($rootScope, jsonDim.recodeTrees[i].dimensions[j].shortName);
					if(item.shortName == null) {
						jsonDim.recodeTrees[i].dimensions[j].unMatched = true;
						tree.unMatched = true;
						unMatchedCount++; 
					 }
				}
			}
		}
		return unMatchedCount;
	};
	
	function verifyRecodedValues(qApp, recodedDim) {
		return new Promise(function (resolve, reject) {
			let retObj = {};
			let unMatchedCount = 0;
			dimensions.getValuesByDimension(qApp, recodedDim).then(function (qlikValues) {
				var selectedCnt = 0,
				found = false;
				for (var x = 0; x < recodedDim.categories.length; x++) {
					let cat = recodedDim.categories[x];
					for (var y = 0; y < cat.values.length; y++) {
						found = false;
						selectedCnt++;
						for (var z = 0; z < qlikValues.length; z++) {
							if (cat.values[y].qText === qlikValues[z].qText) {
								found = true;
								break;
							}
						}
						if (!found) {
							cat.values[y].unMatched = true;
							unMatchedCount++;
						}
					}
				}

				retObj.selectedValuesCount = selectedCnt;
				retObj.totalValuesCount = qlikValues.length;
				retObj.unMatchedCount = unMatchedCount;
				return resolve(retObj);
			});
		})
	}

	//populate left rail properties with loaded recodes
	function setRecodeValues($rootScope, recodeObj, commonFlg) {
		for (var i = 0; i < recodeObj.recodedDims.length; i++) {
			for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
				var topic = $rootScope.dimensionProperties.apiDimTopics[x];
				for (var y = 0; y < topic.dimensionGroups.length; y++) {
					var grp = topic.dimensionGroups[y];
					for (var z = 0; z < grp.dimensions.length; z++) {
						if (recodeObj.recodedDims[i].type == "recode") {
							if (recodeObj.recodedDims[i].shortName == grp.dimensions[z].shortName) {
								for (var a = 0; a < recodeObj.recodedDims[i].recodes.length; a++) {
									recodeObj.recodedDims[i].recodes[a].cId = 'recode' + appUtilities.randomCid();
									recodeObj.recodedDims[i].recodes[a].dimCid = grp.dimensions[z].cId;
									recodeObj.recodedDims[i].recodes[a].associations = grp.dimensions[z].associations;
									for (var b = 0; b < recodeObj.recodedDims[i].recodes[a].categories.length; b++) {
										recodeObj.recodedDims[i].recodes[a].categories[b].cId = appUtilities.randomCid();
									}
									if(commonFlg) {
										grp.dimensions[z].commonRecodes = recodeObj.recodedDims[i].recodes;
									} else {
										grp.dimensions[z].recodes = recodeObj.recodedDims[i].recodes;
									}
								}
							}
						} else if (recodeObj.recodedDims[i].type == "recodeTree") {
							//additional logic for trees, in addition to poulating left rail, need to sync up properties in the redodeTree with srcDims
							//recodeTree properties must reference srcDims properties for editing and disabling to work
							if (grp.dimensions[z].hierarchyAvailable == 'Y'
								 && recodeObj.recodedDims[i].shortName == grp.dimensions[z].shortName
								 && recodeObj.recodedDims[i].title == grp.dimensions[z].title) {

								//First, populate srcDims with key properties from API properties
								//srcDims are used to create new recoded trees and will be then used to populate
								//the imported recoded tree with key recodeTree properties in next section
								var tree = dimensions.getDimensionsForTree(grp.dimensions[z]).slice(0);
								grp.dimensions[z].recodedSrcDims = [];
								for (var a = 0; a < recodeObj.recodedDims[i].recodedSrcDims.length; a++) {
									var srcDim = recodeObj.recodedDims[i].recodedSrcDims[a];
									for (var b = 0; b < tree.length; b++) {
										if (tree[b].shortName == srcDim.shortName
											 && tree[b].title == srcDim.title) {
											if (srcDim.recodes != null) {
												tree[b].recodes = [];
												for (var c = 0; c < srcDim.recodes.length; c++) {
													srcDim.recodes[c].cId = 'recode' + appUtilities.randomCid();
													srcDim.recodes[c].dimCid = tree[b].cId;
													srcDim.recodes[c].variableId = tree[b].variableId;
													srcDim.recodes[c].associations = tree[b].associations;
													if (srcDim.recodes[c].categories) {
														for (var d = 0; d < srcDim.recodes[c].categories.length; d++) {
															srcDim.recodes[c].categories[d].cId = appUtilities.randomCid();
														}
													}
													tree[b].recodes.push(srcDim.recodes[c]);
												}
											}
											grp.dimensions[z].recodedSrcDims.push(tree[b]);
										}
									}
								}

								//Next, populte the imported recodeTrees with key properties from srcDims.  The recoded trees are the imported
								// recoded trees previously defined and exported
								if(commonFlg) {
									grp.dimensions[z].commonRecodeTrees = [];
								} else {
									grp.dimensions[z].recodeTrees = [];
								}
								for (var a = 0; a < recodeObj.recodedDims[i].recodeTrees.length; a++) {
									var recodeTree = recodeObj.recodedDims[i].recodeTrees[a];
									//if tree has bad dim name in recode definition, do not add
									if(recodeTree.unMatched)
										break;
									recodeTree.cId = appUtilities.randomCid();
									recodeTree.dimCid = grp.dimensions[z].cId;
									recodeTree.rootTitle = recodeObj.recodedDims[i].title;
									recodeTree.rootShortName = recodeObj.recodedDims[i].shortName;

									for (var b = 0; b < recodeTree.dimensions.length; b++) {
										if (recodeTree.dimensions[b].type == "recode") {
											for (var c = 0; c < grp.dimensions[z].recodedSrcDims.length; c++) {
												if (grp.dimensions[z].recodedSrcDims[c].shortName == recodeTree.dimensions[b].shortName
													 && grp.dimensions[z].recodedSrcDims[c].title == recodeTree.dimensions[b].title) {
													if (recodeTree.dimensions[b].categories) {
														for (var d = 0; d < grp.dimensions[z].recodedSrcDims[c].recodes.length; d++) {
															recodeTree.dimensions[b].cId = grp.dimensions[z].recodedSrcDims[c].recodes[d].cId;
															recodeTree.dimensions[b].dimCid = grp.dimensions[z].recodedSrcDims[c].recodes[d].dimCid;
															recodeTree.dimensions[b].variableId = grp.dimensions[z].recodedSrcDims[c].recodes[d].variableId;
															recodeTree.dimensions[b].associations = grp.dimensions[z].recodedSrcDims[c].recodes[d].associations;
															if (grp.dimensions[z].recodedSrcDims[c].recodes[d].recodeName == recodeTree.dimensions[b].recodeName) {
																for (var e = 0; e < recodeTree.dimensions[b].categories.length; e++) {
																	for (var f = 0; f < grp.dimensions[z].recodedSrcDims[c].recodes[d].categories.length; f++) {
																		if (recodeTree.dimensions[b].categories[e].qText == grp.dimensions[z].recodedSrcDims[c].recodes[d].categories[f].qText) {
																			recodeTree.dimensions[b].categories[e].cId = grp.dimensions[z].recodedSrcDims[c].recodes[d].categories[f].cId;
																		}
																	}
																}
															}
														}
													}
												}
											}
										} else { //type=dim-branch
											for (var c = 0; c < grp.dimensions[z].recodedSrcDims.length; c++) {
												if (grp.dimensions[z].recodedSrcDims[c].shortName == recodeTree.dimensions[b].shortName
													 && grp.dimensions[z].recodedSrcDims[c].title == recodeTree.dimensions[b].title) {
													recodeTree.dimensions[b] = grp.dimensions[z].recodedSrcDims[c];
													break;
												}
											}
										}
									}
									if(commonFlg) {
										grp.dimensions[z].commonRecodeTrees.push(recodeTree);
									} else {
										grp.dimensions[z].recodeTrees.push(recodeTree);
									}
								}
							}
						}
					};
				};
			};
		};
	}
	return {
		excludeValuesAppliedByOtherRecodes : excludeValuesAppliedByOtherRecodes,
		showRecodeCategories : showRecodeCategories,
		processRecodedValues : processRecodedValues,
		getDefinedRecodes: getDefinedRecodes,
		saveRecodes: saveRecodes,
		loadRecodes: loadRecodes,
		loadRecodeObj: loadRecodeObj,
		verifyJsonRecode: verifyJsonRecode,
		setRecodeValues: setRecodeValues
	};
});

'use strict'
define('scripts/directives/leftRail0Directive',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/measures", "scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, recodes) {

	angular.module("appModule").directive("dtLeftRail0", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtLeftRail0.html',
			scope: true,
			controller: 'LeftRail0Controller'
		};
	});

	angular.module("appModule").controller("LeftRail0Controller", ["$scope", "$rootScope", "$timeout", "$document",
			function ($scope, $rootScope, $timeout, $document) {
				var qApp = $rootScope.qApp;

				$rootScope.leftRail = {};
				$rootScope.leftRail.card1 = {};
				$rootScope.leftRail.card2 = {};
				//let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				var modal = document.getElementById("modal-background");

 				document.addEventListener('click', function(e){   
					//if user clicks outside left variable panel slideouts, close them
					if (!document.getElementById('left-rail-container').contains(e.target)){
						//console.log('outside');
						if($rootScope.leftRail.card1.show || $rootScope.leftRail.card2.show) {
							//console.log('clearing left side')
							if($rootScope.leftRail.card2.group != null && $rootScope.leftRail.card2.group.measures != null &&
							$rootScope.leftRail.card2.group.resetMsrs != null) {
								$rootScope.leftRail.card2.group.measures = angular.copy($rootScope.leftRail.card2.group.resetMsrs);
									delete $rootScope.leftRail.card2.group.resetMsrs
							}								
							if ($rootScope.leftRail.btn)
							    $rootScope.leftRail.btn.classList.remove("active");
							$rootScope.leftRail.card1.show = false;
							$rootScope.leftRail.card2.show = false;

							var phase = $rootScope.$$phase;
							if (phase !== '$apply' && phase !== '$digest') {
								//console.log('invoking apply()')
								$scope.$apply();
							}
							let dimCnt = $scope.getDimensionsCnt();
							let msrSelectedCnt = $scope.getMeasuresCnt();
							$rootScope.$broadcast('showFirstStepEvent', dimCnt, msrSelectedCnt > 0?true:false);
						}
					
					}
				});

				$scope.btnLeftRailMeasureGrp = function (topic, group, btn) {
					$scope.closeLeftRail();
					$scope.$broadcast('leftRail2OpenMsrEvent', group, btn);
				}

				$scope.closeFirstStepMsg = function() {
					$('#measure-section').removeClass("highlight"); 
					$('.first-step-msg').css('display', 'none');
					//$('#welcomeInfoTbl').css('display', 'block');
					$rootScope.showFirstStepTip = false;

				}

				$scope.btnLeftRailDimTopic = function (topic, btn) {
					$scope.closeLeftRail();
					
					//if ($rootScope.leftRail.btn)
					//	$rootScope.leftRail.btn.classList.remove("active");					
					$rootScope.leftRail.btn = btn;

					//Determine if commonRecodes exists and if true show commonRecode section
					topic.dimensionGroups.forEach(function(grp) {
						grp.dimensions.forEach(function(dim) {
							if(dim.commonRecodes || dim.commonRecodeTrees) {
								$rootScope.leftRail.card1.showCommonRecodes = true;
							}
						})
					})					
					$rootScope.leftRail.card1.topic = topic;
					$rootScope.leftRail.card1.dimGroups = dimensions.getDimensionGrpsByTopic($rootScope, topic);
					$rootScope.leftRail.card1.dimGroups.map(function (dGroup) {
						return dGroup.dimensions.map(function (d) {
							if (d.disabled == true) {
								d.disabled = true;
							} else {
								d.disabled = false;
							}
						})
					}); 

					$rootScope.leftRail.card1.show = true;
					$rootScope.leftRail.card1.type = 'dim';
					$rootScope.leftRail.card1.title = topic.topicName;
					btn.classList.add("active");

					if($rootScope.leftRail.card1.dimGroups.length == 1 &&
						$rootScope.leftRail.card1.dimGroups[0].dimensions.length == 1 &&
						($rootScope.leftRail.card1.dimGroups[0].dimensions[0].commonRecodes == null || $rootScope.leftRail.card1.dimGroups[0].dimensions[0].commonRecodes.length == 0)){
						if($rootScope.leftRail.card1.dimGroups[0].dimensions[0].disabled == false)
							$rootScope.$broadcast('openLeftRailDimGrp', $rootScope.leftRail.card1.dimGroups[0].dimensions[0], null);
					} else {

						// set focus to first item in slideout
						$timeout(function(){
							var dimGrps = $('#left-rail-slideout-dimGroups-repeat');
							dimGrps[0].children[0].children[0].children[0].focus();
						}, 30);
					}

				}

				$scope.clickToggleLeftRail = function (evt) {
					if($scope.expandbar) {
						$('.col-custom-left-rail ').width('');
						$('.col-custom-left-rail ').css('padding-right','');
						$('#content').css('padding-left','');
						setTimeout(function() {
								document.getElementById('left-rail-collapse').focus();
						}, 200);
						//document.getElementById('header-home').focus();  
					}
					else if(!$scope.expandbar) {
						$('.col-custom-left-rail ').css('padding-right','0');
						$('.col-custom-left-rail ').css('width','72');
						$('#content').css('padding-left','0px');

						setTimeout(function() {
								document.getElementById('left-rail-expand-btn').focus();
						}, 200);
						//document.getElementById('header-home').focus();
					}
					$scope.expandbar = !$scope.expandbar;
		
					qlik.resize();
				}

				$scope.closeLeftRail = function() { 

 					if($rootScope.leftRail.card2.group != null && $rootScope.leftRail.card2.group.measures != null &&
					$rootScope.leftRail.card2.group.resetMsrs != null) {
						$rootScope.leftRail.card2.group.measures = angular.copy($rootScope.leftRail.card2.group.resetMsrs);
							delete $rootScope.leftRail.card2.group.resetMsrs
					} 
					if ($rootScope.leftRail["card1"].btn && $rootScope.leftRail["card1"].btn.classList)
						$rootScope.leftRail["card1"].btn.classList.remove("active");

					if ($rootScope.leftRail["card2"].btn && $rootScope.leftRail["card2"].btn.classList)
						$rootScope.leftRail["card2"].btn.classList.remove("active");

					$rootScope.leftRail.card1 = {};
					$rootScope.leftRail.card2 = {};
					$rootScope.leftRail.card1.show = false;
					$rootScope.leftRail.card2.show = false;
					if ($rootScope.leftRail.btn && $rootScope.leftRail.btn.classList) {				
						$rootScope.leftRail.btn.classList.remove("active");
					}

					let dimCnt = $scope.getDimensionsCnt();
					let msrSelectedCnt = $scope.getMeasuresCnt();
					if(dimCnt > 1 && msrSelectedCnt == 0) {
						$rootScope.$broadcast('showFirstStepEvent', dimCnt, false);
					} 
					// else if(msrSelectedCnt > 0) {
					// 	$rootScope.showFirstStepTip = false;
					// }
				}

				$scope.hideFirstSteps = function() {
					let dimCnt = $scope.getDimensionsCnt();
					let msrSelectedCnt = $scope.getMeasuresCnt();
					if(document.querySelector("#collapseMeasures.show")) {
						//hide first step msg when measures section is collapsed
						$rootScope.$broadcast('showFirstStepEvent', 1, true);
					} else {
						let dimCnt = $scope.getDimensionsCnt();
						let msrSelectedCnt = $scope.getMeasuresCnt();
						$rootScope.$broadcast('showFirstStepEvent', dimCnt, msrSelectedCnt);
					}
				}

				$scope.$on('clearSelectionsEvent', function (e, skipSettingDefaults, removeRecodes) {
					$scope.clearSelections(skipSettingDefaults, removeRecodes);
				});
				$scope.clearSelections = function (skipSettingDefaults, removeRecodes) {
					skipSettingDefaults = skipSettingDefaults || false;
					var Promise = qlik.Promise;
					return new Promise(function (resolve, reject) {
						$rootScope.visObj.table.OnData.unbind($scope.tblListener);
						try {

							if($scope.amountOptions.show) {
								$scope.unitsSelected = String($scope.amountOptions.unitsOfMeasure[$scope.amountOptions.defaultUnitsOfMeasure].value);
								$scope.unitsSelectedName = String($scope.amountOptions.unitsOfMeasure[$scope.amountOptions.defaultUnitsOfMeasure].name);
								$scope.deflatorSelected = String($scope.amountOptions.deflators[0].value);
								$scope.deflatorSelectedName = String($scope.amountOptions.deflators[0].name);                                  

								appUtilities.setAppVariable(qApp, 'vUnitsOfMeasure', $scope.unitsSelected);
								appUtilities.setAppVariable(qApp, 'vDeflatorValue', $scope.deflatorSelected);
							}
							$rootScope.selectedAmountCount = 0;
							var currentItem = "";

							$rootScope.$broadcast('clearSuggestionEvent');
							$rootScope.$broadcast('resetStatsEvent');
							$rootScope.$broadcast('resetExpandedEvent');
							let genericNotice = {}
							genericNotice.showNoticeFlag = false;
							$rootScope.$broadcast('displayGenericNoticeEvent', genericNotice);
							
							var apiTopics = $rootScope.measureProperties.apiMeasureTopics;
							for (var i = 0; i < apiTopics.length; i++) {
								apiTopics[i].selectedGrpCount = 0;
								var apiGrps = apiTopics[i].measureGroups;
								for (var j = 0; j < apiGrps.length; j++) {
									apiGrps[j].resetMsrs = null;
									var apiMeasures = apiGrps[j].measures;
									for (var m = 0; m < apiMeasures.length; m++) {
										currentItem = apiMeasures[m];
										currentItem.selected = false;
										currentItem.checked = false;
										currentItem.selectedValuesCount = 0;
										currentItem.disabled = false;
										delete currentItem.newTitle;
									}
								}
							}

							var apiTopics = $rootScope.dimensionProperties.apiDimTopics;
							for (var i = 0; i < apiTopics.length; i++) {
								for (var j = 0; j < apiTopics[i].dimensionGroups.length; j++) {
									var apiDims = apiTopics[i].dimensionGroups[j].dimensions;
									for (var m = 0; m < apiDims.length; m++) {
										dimensions.resetDimension($rootScope, apiDims[m]);
										if (apiDims[m].commonRecodes != null) {
											for (var n = 0; n < apiDims[m].commonRecodes.length; n++) {
												dimensions.resetDimension($rootScope, apiDims[m].commonRecodes[n]);
											}
										}
										if (apiDims[m].commonRecodeTrees != null) {
											for (var n = 0; n < apiDims[m].commonRecodeTrees.length; n++) {
												dimensions.resetDimension($rootScope, apiDims[m].commonRecodeTrees[n]);
											}
										}
										if (apiDims[m].recodes != null) {
											for (var n = 0; n < apiDims[m].recodes.length; n++) {
												dimensions.resetDimension($rootScope, apiDims[m].recodes[n]);
											}
											if(removeRecodes) {
												delete apiDims[m].recodes;
											}
										} 
										if (apiDims[m].recodeTrees != null) {
											for (var n = 0; n < apiDims[m].recodeTrees.length; n++) {
												dimensions.resetDimension($rootScope, apiDims[m].recodeTrees[n]);
											}
											if(removeRecodes) {
												delete apiDims[m].recodeTrees;
											}
										}
									}
								}
							}

							var variablesRow = $("#variablesRows");
							var variablesCol = $("#variablesCols");
							var variableFilters = $("#variableFilters");
							variablesCol.empty();
							variablesRow.empty();
							variableFilters.empty();
							$rootScope.selectedAmountCount = 0;
							$rootScope.leftRail = {};
							$rootScope.leftRail.card1 = {};
							$rootScope.leftRail.card2 = {};
							$rootScope.$broadcast('clearInstFilterEvent');
							$rootScope.$broadcast('clearInstRecodeFilterEvent');
							//$scope.clearInstFilter();
							//$scope.closeLeftRail();
							//$scope.selectedInstValues = [];
							$rootScope.chart = {};
							$rootScope.chart.dimCount = 0;
							$rootScope.chart.barType = "";
							if($rootScope.displayVisType != 'pivot-table'){
								$rootScope.chart.useCustomColors = false;
								$rootScope.previousThemeName = null;
							}

							
							qApp.clearAll(true).then(function () {
								qApp.getObject($rootScope.visObjId).then(function (obj) {
									setTableDefaults($rootScope, $scope, qApp, obj, skipSettingDefaults).then(function(action) {
										if(action == 'resetLineChartEvent') {
											if ($rootScope.survey.abbreviation == "NSCG") {
												$rootScope.$broadcast('resetBarChartEvent');										
											} else {
												$rootScope.$broadcast('resetLineChartEvent');	
											}
										} else {
											$rootScope.visObj.table.OnData.bind($scope.tblListener);
											// CB - Zoom - Clear Table does not reset axes limits / https://jira.nsf.gov/browse/NDT-7321
											$rootScope.$broadcast('resetZoomEvent');	
										}
										return resolve('ok');
									}, function(err) {
										//Sometimes initial call to claerSoftPatches() fails, so try again
										setTableDefaults($rootScope, $scope, qApp, obj, skipSettingDefaults).then(function(action) {
											if(action == 'resetLineChartEvent') {
												if ($rootScope.survey.abbreviation == "NSCG") {resetBarChartEvent
													$rootScope.$broadcast('resetBarChartEvent');										
												} else {
													$rootScope.$broadcast('resetLineChartEvent');	
												}
											} else {
												$rootScope.visObj.table.OnData.bind($scope.tblListener);
												// CB - Zoom - Clear Table does not reset axes limits / https://jira.nsf.gov/browse/NDT-7321
												$rootScope.$broadcast('resetZoomEvent');
											}
											return resolve('ok');
										}, function(err) {
											$rootScope.visObj.table.OnData.bind($scope.tblListener);
											$scope.toggleReadOnly(false);
											appUtilities.showError(err);
											return reject(err);
										})
									})
								});
					
							}, function (err) {
								$rootScope.visObj.table.OnData.bind($scope.tblListener);
								$scope.toggleReadOnly(false);
								appUtilities.showError(err);
								return reject(err);
							});
						} catch (err) {
							$rootScope.visObj.table.OnData.bind($scope.tblListener);
							$scope.toggleReadOnly(false);
							appUtilities.showError(err);
							return reject(err);						
						}
						
					})
				}
				
				function setTableDefaults($rootScope, $scope, qApp, obj, skipSettingDefaults) {
					return new qlik.Promise(function (resolve, reject) {
						if ($rootScope.displayVisType == "barchart") {
							return resolve('resetLineChartEvent');
						} else {
							if(!skipSettingDefaults) {
								hyperCubeProperties.setVisualizationDefaults($rootScope, $scope, qApp).then(function () {
									return resolve('setDefaults');
								}, function (err) {
									return reject(err);
								});
							} else {
								return resolve('skipSetDefaults');
							}
						}
					})
				}					
				
				$scope.sortTopicOrder = function (apiDimTopic) {
					return parseInt(apiDimTopic.topicOrderPosition);
				};

				$scope.replaceIllegalChars = function(id) {
					return appUtilities.replaceIllegalChars(id);
				}

				function getMeasuresCountByProperty(topics, property) {
					var cnt = 0;
					for (var x = 0; x < topics.length; x++) {
						for (var y = 0; y < topics[x].measureGroups.length; y++) {
							for (var z = 0; z < topics[x].measureGroups[y].measures.length; z++) {
								if (topics[x].measureGroups[y].measures[z][property] == true)
									cnt++;
							}
						}
					}
					return cnt;
				}

				$scope.getMeasuresCnt = function() {
					let msrsCnt = 0;
					if(Array.isArray($rootScope.measureProperties.apiMeasureTopics)) {
						for(let apiMsrTopic of $rootScope.measureProperties.apiMeasureTopics) {
							msrsCnt += apiMsrTopic.selectedGrpCount;
						}
					}
					return msrsCnt;
				}

				$scope.getDimensionsCnt = function() {
					let cnt = 0;
					if(Array.isArray($rootScope.dimensionProperties.apiDimTopics)) {
						for(let apiDimTopic of $rootScope.dimensionProperties.apiDimTopics) {
							cnt += apiDimTopic.selectedGrpCount;
						}
					}
					return cnt;
				}		
			}
		])
});

'use strict'
define('scripts/directives/leftRail1Directive',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/measures", "scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, recodes) {

	angular.module("appModule").directive("dtLeftRail1", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtLeftRail1.html',
			scope: true,
			controller: 'LeftRail1Controller'
		};
	});

	angular.module("appModule").controller("LeftRail1Controller", ["$scope", "$rootScope", "$timeout",
			function ($scope, $rootScope, $timeout) {
				var qApp = $rootScope.qApp;

				$scope.$on('openLeftRailDimGrp', function (e, item, btn) {
					//don't automatically popup filters to provide users with option to select the 'i' link to variables details
					if (item.shortName == "instName") {
						return;
					} else if (item.hierarchyAvailable == 'Y') {
						return;
					}

					dimensions.getValuesByDimension(qApp, item, null, null, 0, 50).then(function (values) {
						if (values.length > 10) {
							return;
						} else {
							$scope.btnLeftRailDimGrp(item, btn);
						}
					})
				})

				$scope.btnLeftRailDimGrp = function(item, btn) {
					$rootScope.leftRailMessage = "";

					if (item.selectedValuesCount == null)
						item.selectedValuesCount = 0;

					$rootScope.leftRail.card2.dim = item;
					if ($rootScope.leftRail.card1.btn)
						$rootScope.leftRail.card1.btn.classList.remove("active");

					if(btn != null) {
						$rootScope.leftRail.card1.btn = btn;
						$rootScope.leftRail.card1.btn.classList.add("active");
					} else {
					// highlight first item in slideout
						$timeout(function(){
							$rootScope.leftRail.card1.btn = $('#left-rail-slideout-dimGroups-repeat button');
							if($rootScope.leftRail.card1.btn.length > 0) {
								$rootScope.leftRail.card1.btn[0].classList.add("active");
							}
						}, 100);
					}

					if (item.shortName == "instName") {
						//$scope.showInstPopup(item);
						$rootScope.$broadcast('showInstFilterPopupEvent', item);
						return;
					} else if (item.hierarchyAvailable == 'Y') {
						//$scope.showTreeFilterPopup(item);
						$rootScope.$broadcast('showTreeFilterPopupEvent', item);
						return;
					}
					//$rootScope.leftRail.card2.dim.valueChecked = true;
					dimensions.getValuesByDimension(qApp, item, null, null, 0, 50).then(function (values) {

						if (values.length > 10) {
							//$scope.showFilterPopup(item);
							$rootScope.$broadcast('showFilterPopupEvent', item);
							//$scope.$emit('showFilterPopupEvent', item);
						} else {
							$rootScope.leftRail.card2.show = true;
							$rootScope.leftRail.card2.type = 'dim';
							$rootScope.leftRail.card2.title = item.title;

							var list = processDimValues(values, $rootScope.leftRail.card2.dim);
							$rootScope.leftRail.card2.dim.valueChecked = getSelectedCount(list) > 0 ? true : false;
							$rootScope.leftRail.card2.dim.values = recodes.processRecodedValues(list, $rootScope.leftRail.card2.dim);

							if ($rootScope.leftRail.card2.dim.selected) {
								if ($rootScope.displayVisType == "pivot-table") {
									$rootScope.leftRail.card2.label = "Update table";
								} else {
									$rootScope.leftRail.card2.label = "Update chart";
								}

							} else {
								//default all items to selected
								if ($rootScope.displayVisType == "pivot-table") {
									$rootScope.leftRail.card2.label = "Add to table as";
								} else {
									$rootScope.leftRail.card2.label = "Add to chart as";
								}
							}

						}
					});

					// set focus to first item in slideout
					$timeout(function(){
						var dimValues = $('#left-rail-slideout-dimValues-repeat');
						if(dimValues[0]) {
							if(dimValues[0].children.length == 0) {
								dimValues[0].children[0].children[0].selected = true;
							}
							if(dimValues[0].children[0]) {
								if(dimValues[0].children[0].children[0]) {
									dimValues[0].children[0].children[0].focus();
								}
							}
						}
					}, 30);
				}

				$scope.btnLeftRailClose = function (card, type) {
					if(type != null && type == 'msr') {
						if($rootScope.leftRail.card2.group.resetMsrs != null) {
							$rootScope.leftRail.card2.group.measures = angular.copy($rootScope.leftRail.card2.group.resetMsrs);
							delete $rootScope.leftRail.card2.group.resetMsrs
						}
					}
					$scope.closeLeftRail();
				}

				//Method used to open Common/Shared Recodes
				$scope.btnLeftRailOpenApplyRecode = function (recode) {
					let dim = dimensions.getDimensionByCid($rootScope, recode.dimCid);
					$rootScope.startingPoint = "init_common_recode_from_dim_slideout";
					if(recode.type == "recodeTree") {
						$rootScope.$broadcast('showRecodeTreeFilterPopupEvent', dim, recode); 
					} else if(recode.shortName == "instName") {
						$rootScope.$broadcast('showRecodeInstFilterPopupEvent', dim, recode); 
					} else {
						$rootScope.$broadcast('showRecodeFilterPopupEvent', dim, recode); 
					}
				}

				$scope.clickVariableDetails = function (item) {
					$rootScope.$broadcast('openVariableDetailsEvent', item);
				}
				
				//set dimension values selection and disabled state
				function processDimValues(dimValues, dim) {
					var list;
					//display only those values not part of current recode definition
					list = dimValues.map(function (v) {
						if (v.qState == 'S') {
							v.selected = true;
						} else if(v.qState == 'X' ||v.qState == "XS") {
							v.disabled = true;
						}

						//default all dim values to selected on initial display, does not apply to recodes
						if (!dim.selected && !dim.recodeSelected) {
							if (!v.disabled) {
								v.selected = true;
							}
						}
						return v;
					});

					return list;
				}

/* 				function getMeasuresCountByProperty(topics, property) {
					var cnt = 0;
					for (var x = 0; x < topics.length; x++) {
						for (var y = 0; y < topics[x].measureGroups.length; y++) {
							for (var z = 0; z < topics[x].measureGroups[y].measures.length; z++) {
								if (topics[x].measureGroups[y].measures[z][property] == true)
									cnt++;
							}
						}
					}
					return cnt;
				} */

				/*** Recodes section ***/
/* 				$scope.btnShowEditRecodeModal = function (dim, recode) {
					$rootScope.leftRail.card2.dim = dim;
					$rootScope.leftRail.card2.recode = recode;
					if(dim.shortName == "instName") {
						$scope.showRecodeInstitutionPopup(dim, recode);
					} else {
						$scope.showRecodeDimensionPopup(dim, recode);
					}
				}

				$scope.btnShowEditTreeRecodeModal = function (dim, treeRecode) {
					$rootScope.leftRail.card2.dim = dim;
					$scope.showRecodeTreePopup(dim, dim.recodedSrcDims, treeRecode);
				}
*/

				$scope.applyDisableDimRules = function(dim) {
					//Note: If in future we need same restriction on non-hierarchical dimensions
					//then clone section below and test exclusions against result from getDimensionByName()
					if(dim.hierarchyAvailable == "Y") {
						if(!dim.selected) {
							//disable duplicate trees if listed in exclusion array
							if(dim.exclusions != null) {
								for(let x = 0; x < dim.exclusions.length; x++) {
									let excludedDim = dimensions.getDimensionByTitle($rootScope, dim.exclusions[x]);
									
									if(excludedDim.selected) {
											return true;
									} else {
										if(excludedDim.recodeTrees != null) {
											for(let y = 0; y < excludedDim.recodeTrees.length; y++) {
													if(excludedDim.recodeTrees[y].selected) {
															return true;
													}
											}
										} 
										if(excludedDim.commonRecodeTrees != null) {
											for(let y = 0; y < excludedDim.commonRecodeTrees.length; y++) {
													if(excludedDim.commonRecodeTrees[y].selected) {
															return true;
													}
											}
										}
									}
								}
							}
							//always disable if parent tree has a child tree recode selected 
							if(dim.recodeTrees != null) {
								for (var x = 0; x < dim.recodeTrees.length; x++) {
									if (dim.recodeTrees[x].selected) {
										return true;
									}
								}
							}
							if(dim.commonRecodeTrees != null) {
								for (var x = 0; x < dim.commonRecodeTrees.length; x++) {
									if (dim.commonRecodeTrees[x].selected) {
										return true;
									}
								}
							}
						}
					} 
					//Example logic if need to make non-hierarchy fields mutually
					else {
						if(!dim.selected) {
								if(dim.exclusions != null) {
									for(let x = 0; x < dim.exclusions.length; x++) {
										let excludedDim = dimensions.getDimensionByName($rootScope, dim.exclusions[x]);
										
										if(excludedDim.selected) {
											return true;
										} else if(excludedDim.recodeSelected) {
											return true;
										}
									}                       
								}
						}						
					}
					//disable dim if it has any selected recodes
					// if(dim.recodeSelected) {
					// 		return true;
					// }
					return false;
				}

				$scope.applyDisableRecodeRules = function (dim, recode) {
					if (recode.type == "recodeTree") {
						if (!recode.selected) {
							if(dim.recodeTrees != null) {
								for (var x = 0; x < dim.recodeTrees.length; x++) {
									if (dim.recodeTrees[x].cId !== recode.cId
										&& dim.recodeTrees[x].selected) {
										//trees[x].treeDisabled = true;
										return true;
									}
								}
							}
							if(dim.commonRecodeTrees != null) {
								for (var x = 0; x < dim.commonRecodeTrees.length; x++) {
									if (dim.commonRecodeTrees[x].cId !== recode.cId
										&& dim.commonRecodeTrees[x].selected) {
										//trees[x].treeDisabled = true;
										return true;
									}
								}
							}
							//disable recode if the parent dim has excluded recodes selected 
							if (dim.exclusions != null) {
								for (let x = 0; x < dim.exclusions.length; x++) {
									let excludedDim = dimensions.getDimensionByTitle($rootScope, dim.exclusions[x]);
									if (excludedDim.selected) {
										return true;
									} else {
										if (excludedDim.recodeTrees != null) {
											for (let y = 0; y < excludedDim.recodeTrees.length; y++) {
												if (excludedDim.recodeTrees[y].selected) {
													return true;
												}
											}
										}
										if (excludedDim.commonRecodeTrees != null) {
											for (let y = 0; y < excludedDim.commonRecodeTrees.length; y++) {
												if (excludedDim.commonRecodeTrees[y].selected) {
													return true;
												}
											}
										}
									}
								}
							}
						}
					} else {
						//disable  recodes if dim already selected
						// if (dim.selected) {
						// 	return true;
						// }
						
						////disable other recodes
						// if (dim.recodes) {
						// 	for (var x = 0; x < dim.recodes.length; x++) {
						// 		if (dim.recodes[x].cId !== recode.cId
						// 			&& dim.recodes[x].selected) {
						// 			return true;
						// 		}
						// 	}
						// }
						return false;
					}
					return false;
				}

				function getSelectedCount(arr) {
					if (arr == null)
						return 0;

					return arr.filter(function (elm) {
						return elm.selected == true;
					}).length;
				}
			}
		])
});

'use strict'
define('scripts/directives/leftRail2Directive',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/measures", "scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, recodes) {

	angular.module("appModule").directive("dtLeftRail2", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtLeftRail2.html',
			scope: true,
			controller: 'LeftRail2Controller'
		};
	});

	angular.module("appModule").controller("LeftRail2Controller", ["$scope", "$rootScope", '$timeout',
			function ($scope, $rootScope, $timeout) {
				var qApp = $rootScope.qApp;
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

				$scope.$on('leftRail2OpenMsrEvent', function(e, group, btn) {
					$rootScope.leftRail.btn = btn;
					$rootScope.leftRail.btn.classList.add("active");

					$rootScope.leftRail.card2.show = true;
					$rootScope.leftRail.card2.type = 'msr';

					$rootScope.leftRail.totalSelectedMsrCount = getMeasuresCountByProperty($rootScope.measureProperties.apiMeasureTopics, "selected");
					$rootScope.leftRail.card2.title = group.groupName;
					$rootScope.leftRail.card2.group = group;
					$rootScope.leftRail.card2.msrItems = group.measures;

					//store current state of measure selection to restore in case user changes selections and then cancels
					$rootScope.leftRail.card2.group.resetMsrs = angular.copy($rootScope.leftRail.card2.msrItems);

					$rootScope.leftRail.card2.mutuallyExclusiveFlag = group.mutuallyExclusiveFlag;
					if($rootScope.leftRail.card2.mutuallyExclusiveFlag == 'Y'
					|| $rootScope.displayVisType != "pivot-table") {
						var item = appUtilities.search("selected", true, $rootScope.leftRail.card2.msrItems);
						if (item) {
							$rootScope.leftRail.selectedMsr = item.shortName;
							//$scope.leftRail.selectedMsr = item.shortName;
						} else {
							$rootScope.leftRail.selectedMsr = null
							//$scope.leftRail.selectedMsr = null;
							if(group.measures.length == 1 && group.measures[0].disabled == false) {
								group.measures[0].selected = true;
								//$rootScope.leftRail.selectedMsrCount = 1;
								$rootScope.leftRail.selectedMsr = group.measures[0].shortName;
							} else {
								$rootScope.leftRail.selectedMsr = null;
							}							
						}
					}
					//if API measure not matched with Qlik measure, then qID is null, disable it since it so it cant be selected
					$rootScope.leftRail.card2.msrItems.map(function (m) {
						if (m.qId == null) {
							m.disabled = true;
						}
						return;
					});

					$rootScope.leftRail.card2.alwaysDisabled = group.measures.length == 1
							&& group.measures.filter(function (elm) {
						return elm.alwaysDisabled == true;
					}).length > 0 ? true : false;

					// set focus to first item in slideout
					$timeout(function(){
						var msrItems = $('#left-rail-slideout-msrItems-repeat');
						// focus first radio btn for table builder
						if($rootScope.displayVisType == "pivot-table") {
							if(msrItems[0]) {
								// if(msrItems[0].children[0].children[0].children[0].children[0].children.length == 2) {
								// 	msrItems[0].children[0].children[0].children[0].children[0].children[0].checked = true;
								// }
								msrItems[0].children[0].children[0].children[0].children[0].children[0].focus();
							}
						}
						// focus first radio btn for chart builder
						else {
							if(msrItems[0])
									msrItems[0].children[1].children[0].children[0].children[0].focus();
						}
					}, 30);

				})

				$scope.isAddDisabledForMsr = function () {
					if ($rootScope.leftRail.card2.mutuallyExclusiveFlag == 'N') {
						//return $rootScope.leftRail.selectedMsrCount == null || $rootScope.leftRail.selectedMsrCount == 0 || $rootScope.leftRail.card2.alwaysDisabled || $scope.disableAll;
						return ($rootScope.leftRail.selectedMsr == null && ($rootScope.leftRail.selectedMsrCount == null || $rootScope.leftRail.selectedMsrCount == 0)) || $rootScope.leftRail.card2.alwaysDisabled || $scope.disableAll;
					} else {
						return $rootScope.leftRail.selectedMsr == null || $scope.disableAll;
					}
				}

				$scope.isUpdateDisabledForMsr = function () {
					if ($rootScope.leftRail.card2.mutuallyExclusiveFlag == 'N') {
						return $rootScope.leftRail.card2.alwaysDisabled || $scope.disableAll;
					} else {
						return $rootScope.leftRail.selectedMsr == null || $scope.disableAll;
					}
				}

				$scope.btnLeftRailClose = function (card, type) {
					if(type != null && type == 'msr') {
						if($rootScope.leftRail.card2.group.resetMsrs != null) {
							$rootScope.leftRail.card2.group.measures = angular.copy($rootScope.leftRail.card2.group.resetMsrs);
								delete $rootScope.leftRail.card2.group.resetMsrs
						}
					}
					$scope.closeLeftRail();
				}

				$scope.chkBoxMeasure = function (msr) {
					$rootScope.leftRail.selectedMsrCount = getMeasuresCountByProperty($rootScope.measureProperties.apiMeasureTopics, "selected");
				}

				$scope.chkBoxDimValue = function () {
					$rootScope.leftRail.card2.dim.valueChecked = getSelectedCount($rootScope.leftRail.card2.dim.values) > 0 ? true : false;
				}

				$scope.chkBoxRecodeValue = function () {
					//alert('hi');
					//$rootScope.leftRail.card2.recode.valueChecked = getSelectedCount($rootScope.leftRail.card2.recode.categories) > 0 ? true : false;
					var values = $scope.allValues;
					$rootScope.leftRail.card2.recode.valueChecked = getSelectedCount(values) > 0 ? true : false;

				}

				$scope.btnLeftRailMsrAddColumn = function () {
					$scope.toggleReadOnly(true);
					setMeasureRadioButton();
										
					//google analytics tracking
					var tags = getCheckedMeasureNames();
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Select measure', {
						'event_label': 'select',
						'event_category': 'measure',
						'event_variables': tags
					});	
					hyperCubeProperties.updateMultipleSelected(qApp, $rootScope).then(function () {
						delete $rootScope.leftRail.card2.group.resetMsrs
						$scope.closeLeftRail();
						//$scope.toggleReadOnly(false);
						$("#tblTabs a[href='#customTabPanel']").tab('show');
						showMeasureEditsNotice("fteMeasureEdit");
/* 					//sample code for new HERD msg	
						let msg = {};
						msg.title = "Test Error";
						msg.text = "Survey <b>requires</b> that at least 1 dim be selected.";
						//$scope.$broadcast('showMsgModalEvent', msg);
						$scope.$emit('showMsgModalEvent', msg);	 */						
					}, function (err) {
						appUtilities.showError(err);
					});
				}
				
				$scope.btnLeftRailMsrUpdate = function () {

					setMeasureRadioButton();
					let a1 = $rootScope.leftRail.card2.msrItems.filter((x) => x.selected === true)
					let a2 = $rootScope.leftRail.card2.group.resetMsrs.filter((x) => x.selected === true)

					const msrEquals = (o1, a2) => a2.find((o2) => o2.cId === o1.cId);
					const arraysEqual = (a1, a2) => 
					   a1.length === a2.length && a1.every((o) => msrEquals(o, a2));
					   
					delete $rootScope.leftRail.card2.group.resetMsrs
					if(arraysEqual(a1, a2)) {
						$scope.closeLeftRail();
						return;
					}

					$scope.toggleReadOnly(true);
					//google analytics tracking
					var tags = getCheckedMeasureNames();
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Update measure', {
						'event_label': 'select',
						'event_category': 'measure',
						'event_variables': tags
					});

					hyperCubeProperties.updateMultipleSelected(qApp, $rootScope).then(function () {
						//applySelectedMeasures();
						delete $rootScope.leftRail.card2.group.resetMsrs
						$scope.closeLeftRail();
						showMeasureEditsNotice("fteMeasureEdit");
						//$scope.toggleReadOnly(false);
					}, function (err) {
						appUtilities.showError(err);
					});
				}

				$scope.btnLeftRailDimAddColumn = function () {
					$scope.toggleReadOnly(true);
					//google analytics tracking
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Select dimension', {
						'event_label': 'select',
						'event_category': 'dimension',
						'event_variables': $rootScope.leftRail.card2.dim.shortName
					});
					$rootScope.leftRail.card2.dim.selected = true;
					hyperCubeProperties.updateFilterValueSingleList(qApp, $rootScope, $scope, $rootScope.leftRail.card2.dim, true).then(function () {
						$rootScope.leftRail.card2.dim.selectedValuesCount = getSelectedCount($rootScope.leftRail.card2.dim.values);
						$scope.closeLeftRail();
					  //$scope.toggleReadOnly(false);
					}, function (err) {
						appUtilities.showError(err);
					});
				}

				$scope.btnLeftRailDimAddRow = function () {
					$scope.toggleReadOnly(true);
					//google analytics tracking
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Select dimension', {
						'event_label': 'select',
						'event_category': 'dimension',
						'event_variables': $rootScope.leftRail.card2.dim.shortName
					});
					$rootScope.leftRail.card2.dim.selected = true;
					hyperCubeProperties.updateFilterValueSingleList(qApp, $rootScope, $scope, $rootScope.leftRail.card2.dim, false).then(function () {
						$rootScope.leftRail.card2.dim.selectedValuesCount = getSelectedCount($rootScope.leftRail.card2.dim.values);
						$scope.closeLeftRail();
						//$scope.toggleReadOnly(false);
					}, function (err) {
						appUtilities.showError(err);
					});
				}

				$scope.btnLeftRailDimUpdate = function () {
					if ($rootScope.leftRail.card2.dim.shortName.toLowerCase() == "year" ||
						$rootScope.leftRail.card2.dim.shortName.toLowerCase() == "refyr") {
						if (getSelectedCount($rootScope.leftRail.card2.dim.values) == 0) {
							let msg = {};
							msg.title = "Dimension Error";
							msg.text = "Survey requires that at least 1 " + $rootScope.leftRail.card2.dim.title + " be selected.";
							//$scope.$broadcast('showMsgModalEvent', msg);
							$scope.$emit('showMsgModalEvent', msg);												
							return;
						}
					}

					//$rootScope.leftRail.card2.show = false;
					$scope.toggleReadOnly(true);
					hyperCubeProperties.updateFilterValueSingleList(qApp, $rootScope, $scope, $rootScope.leftRail.card2.dim, null).then(function (action) {
						if (action == "del") {
							dimensions.resetDimension($rootScope, $rootScope.leftRail.card2.dim);
						} else {
							$rootScope.leftRail.card2.dim.selected = true;
							$rootScope.leftRail.card2.dim.selectedValuesCount = getSelectedCount($rootScope.leftRail.card2.dim.values);
						}
						$scope.closeLeftRail();
						//$scope.toggleReadOnly(false);
					}, function (err) {
						appUtilities.showError(err);
					});
				}

				$scope.btnLeftRailMsrChart = function () {
					setMeasureRadioButton();
					let a1 = $rootScope.leftRail.card2.msrItems.filter((x) => x.selected === true)
					let a2 = $rootScope.leftRail.card2.group.resetMsrs.filter((x) => x.selected === true)

					const msrEquals = (o1, a2) => a2.find((o2) => o2.cId === o1.cId);
					const arraysEqual = (a1, a2) => 
					   a1.length === a2.length && a1.every((o) => msrEquals(o, a2));
					   
					delete $rootScope.leftRail.card2.group.resetMsrs
					if(arraysEqual(a1, a2)) {
						$scope.closeLeftRail();
						return;
					}

					$scope.toggleReadOnly(true);
					var items = [];
					var item = appUtilities.search("shortName", $rootScope.leftRail.selectedMsr, $rootScope.leftRail.card2.msrItems);
					item.selected = true;
					items.push(item);
					if (items.length > 0) {
						var tags = getCheckedMeasureNames();
						let action = $rootScope.leftRail.totalSelectedMsrCount == 0?'-Select measure':'-Update measure';
						gtag('event', displayType + $rootScope.survey.abbreviation + action, {
							'event_label': 'select',
							'event_category': 'measure',
							'event_variables': tags
						});
						$rootScope.selectedAmountCount = 0;
						hyperCubeProperties.updateMultipleSelected(qApp, $rootScope).then(function () {
							delete $rootScope.leftRail.card2.group.resetMsrs
							$scope.closeLeftRail();
							showMeasureEditsNotice("fteMeasureEdit");
							if ($rootScope.displayVisType == "linechart") {
								var list = dimensions.getDimensionRequired($rootScope);
								for (var x = 0; x < list.length; x++) {
									if (list[x].shortName.toLowerCase() == "year" ||
										list[x].shortName.toLowerCase() == "refyr") {
										if (list[x].selectedValuesCount && list[x].selectedValuesCount < 3) {
											$scope.$broadcast('changeBarChartEvent', "v-grouped");
										}
									}
								}
							} else if ($rootScope.displayVisType == "barchart" && $rootScope.chart && $rootScope.chart.showPercentages) {
								$rootScope.chart.showPercentages = false;
							}
							$("#tblTabs a[href='#customTabPanel']").tab('show');
							//$scope.toggleReadOnly(false);
						}, function (err) {
							appUtilities.showError(err);
						});
					}
				}

				$scope.btnLeftRailDimChartApply = function () {
					if ($rootScope.leftRail.card2.dim.shortName.toLowerCase() == "year" ||
						$rootScope.leftRail.card2.dim.shortName.toLowerCase() == "refyr") {
						if (getSelectedCount($rootScope.leftRail.card2.dim.values) == 0) {
							$scope.title = "Dimension Error";
							$scope.msg = "Survey requires that at least 1 " + $rootScope.leftRail.card2.dim.title + " be selected.";
							$('#modal-msg').modal('show');
							return;
						}
					}

					$scope.toggleReadOnly(true);
					//google analytics tracking
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Select dimension', {
						'event_label': 'select',
						'event_category': 'dimension',
						'event_variables': $rootScope.leftRail.card2.dim.shortName
					});
					$rootScope.leftRail.card2.dim.selected = true;
					hyperCubeProperties.updateFilterValueSingleList(qApp, $rootScope, $scope, $rootScope.leftRail.card2.dim, false).then(function (action) {
						if (action == "del") {
							dimensions.resetDimension($rootScope, $rootScope.leftRail.card2.dim);
						} else {
							$rootScope.leftRail.card2.dim.selected = true;
							$rootScope.leftRail.card2.dim.selectedValuesCount = getSelectedCount($rootScope.leftRail.card2.dim.values);
						}
						delete $rootScope.leftRail.card2.group.resetMsrs
						$scope.closeLeftRail();
						//$scope.toggleReadOnly(false);
					}, function (err) {
						appUtilities.showError(err);
					});
				}
				
				function setMeasureRadioButton() {
					var apiTopics = $rootScope.measureProperties.apiMeasureTopics;
					for (var i = 0; i < apiTopics.length; i++) {
						var apiGrps = apiTopics[i].measureGroups;
						for (var j = 0; j < apiGrps.length; j++) {

							//If radio button, set only one measure, otherwise for checkboxes allow multiple selections
							if($rootScope.displayVisType !== "pivot-table"
								|| apiGrps[j].mutuallyExclusiveFlag == 'Y') {								
								var apiMeasures = apiGrps[j].measures;
								for (var m = 0; m < apiMeasures.length; m++) {
									var currentItem = apiMeasures[m];
									if (currentItem.shortName == $rootScope.leftRail.selectedMsr) {
										currentItem.selected = true;
									} else {
										currentItem.selected = false;
									}
								}
							}
						}
					}
				}
		
				$scope.clickVariableDetails = function (item) {
					$rootScope.$broadcast('openVariableDetailsEvent', item);
				}				

				$scope.btnShowRecodeDimension = function () {
					let dim = $rootScope.leftRail.card2.dim;
					$rootScope.startingPoint = "init_recode_from_dim_slideout";
					$scope.closeLeftRail();
					$scope.$emit('openRecodeAddEvent', $rootScope.eventSrc.DimRailPage, dim);
				}
				
				function getCheckedMeasureNames() {
					return $rootScope.leftRail.card2.msrItems.filter(function (x) {
						if (x.selected)
							return x;
						else
							return null;
					}).map(function (x) {
						return x.shortName;
					}).toString();
				}

				function getMeasuresCountByProperty(topics, property) {
					var cnt = 0;
					for (var x = 0; x < topics.length; x++) {
						for (var y = 0; y < topics[x].measureGroups.length; y++) {
							for (var z = 0; z < topics[x].measureGroups[y].measures.length; z++) {
								if (topics[x].measureGroups[y].measures[z][property] == true)
									cnt++;
							}
						}
					}
					return cnt;
				}

				function getSelectedCount(arr) {
					if (arr == null)
						return 0;

					return arr.filter(function (elm) {
						return elm.selected == true;
					}).length;
				}

				function showMeasureEditsNotice(editName) {
					if($rootScope.survey.abbreviation == "HERD"
						&& $rootScope.survey.notices != null)
					{
						let genericNotice = {};
						genericNotice.showNoticeFlag = false;
						for(x = 0; x < $rootScope.survey.notices.length; x++) {
							let notice = $rootScope.survey.notices[x];
							if(editName == notice.name) {
								let msrs = measures.getMeasureSelected($rootScope);
								for(let x = 0; x < msrs.length; x++) {
									if(msrs[x].shortName == "mHeadCtPers" 
										|| msrs[x].shortName == "mFTEPers") {
											genericNotice.showNoticeFlag = notice.showNoticeFlag;
											genericNotice.borderClass = notice.borderClass;
											genericNotice.bannerMsg = notice.bannerMsg;
											genericNotice.showFullMsgFlag = notice.showFullMsgFlag;
											genericNotice.fullMsg = notice.fullMsg;
											break;
									}
								}
							}
						}
						$rootScope.$broadcast('displayGenericNoticeEvent', genericNotice);
					}
				}
			}
		])
});

'use strict'
define('scripts/directives/leftRailSearchDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/appUtilities"],
	function (qlik, webProperties, appModule, appUtilities) {
	angular.module("appModule").directive("dtLeftRailSearch", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtLeftRailSearch.html',
			scope: false,
			controller: 'LeftRailSearchController'
		};
	});

	angular.module("appModule").controller("LeftRailSearchController", ["$scope", "$rootScope", "$http",
		function ($scope, $rootScope, $http) {
			let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

			/*** Typeahead section ***/
			$scope.typeaheadMouseover = function(e, item) {
				for(let x=0; x < $scope.suggestions.length; x++) {
					if($scope.suggestions[x] == item) {
						$scope.suggestions[x].active = true;
					} else {
						$scope.suggestions[x].active = false;
					}
				}
			}
			
			$scope.typeaheadKeyPressed = function(e) {
				if(e.keyCode === 32 || e.keyCode === 13) {
					for(let x=0; x < $scope.suggestions.length; x++) {
						if($scope.suggestions[x].active) {						
							$scope.highlightVariables($scope.suggestions[x]);
						}
					}
					return;
				} else if(e.keyCode === 38) {
					//up arrow key
					for(let x=0; x < $scope.suggestions.length; x++) {
						if($scope.suggestions[x].active) {
							if(x > 0) {
								$scope.suggestions[x].active = false;
								$scope.suggestions[x-1].active = true;
							}
							break;
						} 
					}						
					return;	
				} else if(e.keyCode === 40) {
					//down arrow key
					for(let x=0; x < $scope.suggestions.length; x++) {
						if($scope.suggestions[x].active) {
							if(x < $scope.suggestions.length -1) {
								$scope.suggestions[x].active = false;
								$scope.suggestions[x+1].active = true;
							}
							break;
						} 
					}						
					return;						
				} else {
					console.log('other')
					return;
				}				
		};		
			
			$scope.typeaheadChange = function (queryText) {
				$scope.closeLeftRail();
				if ($scope.typeaheadQueryText && $scope.typeaheadQueryText.length > 2) {
					appUtilities.getTypeaheadSuggestionsFromApi(qlik, $http, $scope.typeaheadQueryText, $rootScope.survey.abbreviation).then(function (resp) {
						// google analytics tracking
						gtag('event', displayType + $rootScope.survey.abbreviation + '-search-autocomplete', {
							'event_label': 'typeahead',
							'event_category': 'variable_selection',
							'event_variables': $scope.typeaheadQueryText
						});
						if (resp.data.body.content) {
							$scope.suggestions = resp.data.body.content;
							var ranksEncountered = [];
							$scope.suggestions.forEach(suggestion => {
								if (suggestion.valueSource == 'CODE_VALUE') {
									suggestion.valueSource = 'FIELD_LABEL'
								}
								suggestion.valueSource = appUtilities.toTitleCase(suggestion.valueSource.replace('_', ' ') + 's');
								var typeaheadItemRank = suggestion.rank;
								const found = ranksEncountered.find(element => element == typeaheadItemRank);
								if (found) {
									suggestion.isFirstInRank = false;
								} else {
									suggestion.isFirstInRank = true;
									ranksEncountered.push(typeaheadItemRank);
								}
							});
							$scope.suggestions.unshift({
								matchedValue: $scope.typeaheadQueryText,
								topic: 'All Results',
								survey: $rootScope.survey.abbreviation,
								active: true
							});
							$scope.showSuggestions = true;
						} else {
							$scope.showSuggestions = false;
						}
					}, function (err) {
						$scope.showSuggestions = false;
						return;
					});
				} else {
					$scope.showSuggestions = false;
				}
			}

			$scope.showClearSuggestionBtn = false;
			$scope.typeaheadQueryText = "";				

			$scope.variableIdsToHighlight = [];
			$rootScope.variableIdsToHighlight = [];
			$scope.showSuggestionSearchBox = true;
			$scope.suggestionBubble = {};
			$rootScope.suggestionBubble = {};

			$scope.highlightVariables = function (suggestion) {
				var term = '';
				if(suggestion.topic == "All Results") {
					term = $scope.typeaheadQueryText;
				}
				else {
					term = suggestion.storedValue;
				}
				appUtilities.getSuggestionVariableIdsFromApi(qlik, $http, term, suggestion.topic, $rootScope.survey.abbreviation).then(function (resp) {
					// google analytics tracking
					gtag('event', displayType + suggestion.survey + '-search-autocomplete-match', {
						'event_label': 'suggestions',
						'event_category': 'variable_selection',
						'event_variables': 'Matched:'+ suggestion.matchedValue + '-Suggested:' + suggestion.topic
					});
					$scope.showSuggestions = false;
					$scope.highlightVariableIds = resp.data.body.content;
					$scope.variableIdsToHighlight = [];
					$rootScope.variableIdsToHighlight = [];
					$scope.suggestionBubble = suggestion;
					$rootScope.suggestionBubble = suggestion;
					$scope.highlightVariableIds.forEach(variable => {
						$scope.variableIdsToHighlight.push(variable.variableId);
						$rootScope.variableIdsToHighlight.push(variable.variableId);
					});
					$scope.showSuggestionSearchBox = false;
					$scope.showClearSuggestionBtn = true;
				}, function (err) {
					$scope.showSuggestions = false;
					$scope.showSuggestionSearchBox = true;
					$scope.showClearSuggestionBtn = false;
					$scope.suggestionBubble = {};
					$rootScope.suggestionBubble = {};
					return;
				});
			}

			$scope.btnClearSuggestion = function () {
				$scope.closeLeftRail();
				clearSuggestion();
			}

			$scope.msrTopicHighlighted = function (msrTopic) {
				for (var i = 0; i < msrTopic.measureGroups.length; i++) {
					var measureGroup = msrTopic.measureGroups[i];
					for (var j = 0; j < measureGroup.measures.length; j++) {
						var measure = measureGroup.measures[j];
						if ($scope.variableIdsToHighlight.includes(measure.variableId)) {
							return true;
						}
					}
				}
			}

			$scope.msrGroupTopicHighlighted = function (grp) {
				for (var i = 0; i < grp.measures.length; i++) {
					var measure = grp.measures[i];
					if ($scope.variableIdsToHighlight.includes(measure.variableId)) {
						return true;
					}
				}
			}

			$scope.dimTopicHighlighted = function (apiDimTopic) {
				for (var i = 0; i < apiDimTopic.dimensionGroups.length; i++) {
					if (apiDimTopic.dimensionGroups[i].dimensions == null) {
						return;
					}
					for (var j = 0; j < apiDimTopic.dimensionGroups[i].dimensions.length; j++) {
						var dimension = apiDimTopic.dimensionGroups[i].dimensions[j];
						if ($scope.variableIdsToHighlight.includes(dimension.variableId)) {
							return true;
						}
						if (dimension.hierarchyAvailable == 'Y') {
							return suggestionMatchInDimHeirs(dimension);
						}

					}

				}

			}

			$scope.dimHighlighted = function (dim) {
				if ($scope.variableIdsToHighlight.includes(dim.variableId)) {
					return true;
				}

				if (dim.hierarchyAvailable == 'Y') {
					return suggestionMatchInDimHeirs(dim);
				}
			}

			$scope.valueTopicHighlighted = function (dim, value) {
				if ($scope.suggestionBubble.valueSource == 'Field Labels') {
					if ($scope.variableIdsToHighlight.includes(dim.variableId)) {
						if (value.qText == $scope.suggestionBubble.storedValue) {
							return true;
						}
					}

					if (dim.hierarchyAvailable == 'Y') {
						var suggestionMatchInDimHeirs = suggestionMatchInDimHeirs(dim);
						if (suggestionMatchInDimHeirs) {
							if (value.qText == $scope.suggestionBubble.storedValue) {
								return true;
							}
						}
					}
				}
			}

			$scope.msrTitleTopicHighlighted = function (msr) {
				if ($scope.suggestionBubble.valueSource == 'Field Labels') {
					if ($scope.variableIdsToHighlight.includes(msr.variableId)) {
						if (msr.title == $scope.suggestionBubble.storedValue) {
							return true;
						}
					}
				}
			}

			$scope.$on('clearSuggestionEvent', function (e) {
				clearSuggestion();
			});	

			function clearSuggestion() {
				$scope.variableIdsToHighlight = [];
				$rootScope.variableIdsToHighlight = [];
				$scope.showSuggestionSearchBox = true;
				$scope.showClearSuggestionBtn = false;
				$scope.suggestionBubble = {};
				$rootScope.suggestionBubble = {};
				$scope.typeaheadQueryText = "";
			}

			function suggestionMatchInDimHeirs(dimension) {
				if (dimension.dimHier1) {
					for (var k = 0; k < dimension.dimHier1.length; k++) {
						if ($scope.variableIdsToHighlight.includes(dimension.dimHier1[k].variableId)) {
							return true;
						}

						if (dimension.dimHier1[k].dimHier2) {
							for (var l = 0; l < dimension.dimHier1[k].dimHier2.length; l++) {
								if ($scope.variableIdsToHighlight.includes(dimension.dimHier1[k].dimHier2[l].variableId)) {
									return true;
								}

								if (dimension.dimHier1[k].dimHier2[l].dimHier3) {
									for (var m = 0; m < dimension.dimHier1[k].dimHier2[l].dimHier3.length; m++) {
										if ($scope.variableIdsToHighlight.includes(dimension.dimHier1[k].dimHier2[l].dimHier3[m].variableId)) {
											return true;
										}

										if (dimension.dimHier1[k].dimHier2[l].dimHier3[m].dimHier4) {
											for (var n = 0; n < dimension.dimHier1[k].dimHier2[l].dimHier3[m].dimHier4.length; n++) {
												if ($scope.variableIdsToHighlight.includes(dimension.dimHier1[k].dimHier2[l].dimHier3[m].dimHier4[n].variableId)) {
													return true;
												}
											}
										}
									}
								}
							}
						}
					}
				}
				return false;
			}
		}
	])
});
/******
This module contains the methods for setting up the recodes selection page.  The recodes selection page will be 
depending on the dimension being recoded. If the dimension has less than 20 values than the selections will be 
through checkboxs on the left rail slide out.  If over 20 values will use a scrollable list box.  Institutions
and hierarchal dimensions will also use selectable listboxes.   Each typr of recode interface works a little 
dirrerently so these methods are flexable to work with each recode type's requirements.
- Slide out checkbox:  selections are determined on the value's .selected property.
- Standard scrollable lists (ie. State): Selections are determined by value's .qState property
- Institutions scrollable list: Selections are determined by value's .class property
*******/
define('scripts/shared/tableSelections',["scripts/shared/appUtilities", "scripts/shared/dimensions", "scripts/shared/measures", "scripts/shared/hyperCubeProperties"], 
function (appUtilities, dimensions, measures, hyperCubeProperties) {

	function applyVariablesToTable($rootScope, $scope, jsonObj) {
		return new Promise(function (resolve, reject) {
			
			let qApp = $rootScope.qApp;
			let recodeTree = null;
			$rootScope.$broadcast('clearSelectionsEvent', true, true);
			//$scope.clearSelections(true, true).then(function () {
				qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getProperties(obj).then(function (props) {
						props.qHyperCubeDef.qInterColumnSortOrder = [];
						props.qHyperCubeDef.qNoOfLeftDims = 0;
						let dimArray = [];
						let applyErr = applyVariables($rootScope, $scope, props, jsonObj, dimArray);
						// props.qHyperCubeDef.qInterColumnSortOrder = jsonObj.data.order;
						// props.qHyperCubeDef.qNoOfLeftDims = jsonObj.data.noOfLeftDims;
						if(applyErr != null)
							return reject("Bad File, " + applyErr);
				
						obj.setProperties(props).then(function (properties_set) {
							async function applyValues() {
								for (let i = 0; i < dimArray.length; i++) {	
									let dim = dimArray[i];
									if(dim.hierarchyAvailable == "Y") {
										dim.selectedValuesCount = 0;
										for (let i = 0; i < dim.savedDims.length; i++) {
											if(dim.savedDims[i].selected) {
												let valCnts = await getValues(qApp, dim.savedDims[i]);
												dim.selectedValuesCount += valCnts.selectedValuesCount;
												await applyFilters(qApp, dim.savedDims[i]);
											}
										}
									} else if(dim.type == "recodeTree") {
										recodeTree = dim;
										let selectedValuesCount = 0
										for (let i = 0; i < dim.savedDims.length; i++) {
											if(dim.savedDims[i].selected) {
												let valCnts = await getValues(qApp, dim.savedDims[i]);
												selectedValuesCount += valCnts.selectedValuesCount;
												await applyFilters(qApp, dim.savedDims[i]);
											}
										}
										if(dim.selectedValuesCount == null) {
											dim.selectedValuesCount = selectedValuesCount;
										}
									} else if(dim.type == "recode") {
										if(dim.selected) {
											let valCnts = await getValues(qApp, dim);
											dim.selectedValuesCount = valCnts.selectedValuesCount;
											await applyFilters(qApp, dim);
										}
									} else {
										if(dim.selected) {
											let counts = await getValues(qApp, dim);
											dim.selectedValuesCount = counts.selectedValuesCount;
											await applyFilters(qApp, dim);
										}
									}
								}
								return resolve();
							}
							applyValues().then(function() {
								if (jsonObj.data.deflator != null && $scope.amountOptions.show) {
									for (let i = 0; i < $scope.amountOptions.deflators.length; i++) {
										if ($scope.amountOptions.deflators[i].name == jsonObj.data.deflator) {
											$scope.deflatorSelected = $scope.amountOptions.deflators[i].value;
											appUtilities.setAppVariable($rootScope.qApp, 'vDeflatorValue', $scope.deflatorSelected);
											break;
										}
									}
								}
								if (jsonObj.data.unitOfMeasure != null && $scope.amountOptions.show) {
									for (let i = 0; i < $scope.amountOptions.unitsOfMeasure.length; i++) {
										if ($scope.amountOptions.unitsOfMeasure[i].name == jsonObj.data.unitOfMeasure) {
											$scope.unitsSelected = $scope.amountOptions.unitsOfMeasure[i].value;
											appUtilities.setAppVariable($rootScope.qApp, 'vUnitsOfMeasure', $scope.unitsSelected);
											break;
										}
									}
								}
								//invoke event to populate the modalRecodeTreeFilterDirective modal with the selected values so that both left and right lists display correctly if user edits selections
								if(recodeTree){
									$scope.$broadcast('invokedImportTableRecodedTree', {recodeTree: recodeTree});
								}
								return resolve();
							}, function (err) {
								//console.log('');
								return reject(err);
							});
						}, function (err) {
							//console.log('setPropErr1stTry');
							return reject(err);
						});
					}, function (err) {
						//console.log('getObj err');
						return reject(err);
					});	
				}, function (err) {
					//console.log('getObj err');
					return reject(err);
				});
			}, function (err) {
				return reject(err);
			});						
		//})						
	}
	
	function getValues(qApp, dim) {
		return new Promise(function (resolve, reject) {
			let retObj = {};
			if(dim.type == "dimension" || dim.type == "dim-branch") {
				if(dim.restoreValues && dim.restoreValues.length > 0) {
					dimensions.getValuesByDimension(qApp, dim).then(function (qlikValues) {
						var selectedCnt = 0;
						dim.values = [];
						for (var x = 0; x < dim.restoreValues.length; x++) {
							selectedCnt++;
							for (var y = 0; y < qlikValues.length; y++) {
								if(dim.restoreValues[x].qText === qlikValues[y].qText) {
									qlikValues[y].selected = true;
									dim.values.push(qlikValues[y]);
									break;
								}
							}
						}
						
						retObj.selectedValuesCount = selectedCnt;
						retObj.totalValuesCount = qlikValues.length;
						return resolve(retObj);
					}, function (err) {
						return reject(err);
					});
				} else {
					retObj.selectedValuesCount = 0;
					retObj.totalValuesCount = null;
					return resolve(retObj);
				}
			} else if(dim.type == "recode") {
				dimensions.getValuesByDimension(qApp, dim).then(function (qlikValues) {
					var selectedCnt = 0, found = false;
					dim.values = [];
					
					for (var i = 0; i < dim.categories.length; i++) {
						dim.categories[i].values = [];
						for (var x = 0; x < dim.categories[i].restoreValues.length; x++) {
							for (var y = 0; y < qlikValues.length; y++) {
								if(dim.categories[i].restoreValues[x].qText === qlikValues[y].qText) {
									dim.categories[i].values.push(qlikValues[y]);
									break;
								}
							}
						}
						if(dim.categories[i].selected) {
							selectedCnt++;
						}
					}
					dim.nonRecodeValues = [];
					if(dim.restoreNonRecodeValues) {
						dim.restoreNonRecodeValues.forEach(function(val) {	
							let value = {};
							for (var y = 0; y < qlikValues.length; y++) {
								if(val.qText === qlikValues[y].qText) {
									selectedCnt++;
									qlikValues[y].selected = true;
									dim.nonRecodeValues.push(qlikValues[y]);
									break;
								}
							}
						})
					}
					retObj.selectedValuesCount = selectedCnt;
					retObj.totalValuesCount = qlikValues.length;
					return resolve(retObj);
				});	
			} else {
				retObj.selectedValuesCount = 0;
				retObj.totalValuesCount = null;
				return resolve(retObj);
			}
		})
	};	
	
	function applyFilters(appObj, dim) {
		return new Promise(function (resolve, reject) {	
			var selectedValues = [];
				
			if(dim.type == "dimension" || dim.type == "dim-branch") {
				if (dim.values != null) {
					for (var x = 0; x < dim.values.length; x++) {
						if (dim.values[x].selected) {
							selectedValues.push(Number(dim.values[x].qElemNumber));
						}
					}
				}
			} else if(dim.type == "recode") {
				for (var x = 0; x < dim.categories.length; x++) {
					if(dim.categories[x].selected) {
						for (var y = 0; y < dim.categories[x].values.length; y++) {
							selectedValues.push(Number(dim.categories[x].values[y].qElemNumber));
						}
					}
				}
				for (var x = 0; x < dim.nonRecodeValues.length; x++) {
					selectedValues.push(Number(dim.nonRecodeValues[x].qElemNumber));
				}
			}
			if (selectedValues.length > 0) {
				appObj.field(dim.shortName).clear().then(function () {
					appObj.field(dim.shortName).select(selectedValues, false, true).then(function () {
						if(dim.shortName == "instName") {
							dim.savedValues = dim.values;
						}
						return resolve();
					});
				});
			} else {
				return resolve();
			}
		})
	}	

	function applyVariables($rootScope, $scope, props, jsonObj, dimArray) {
		//let dimArray = [];
		let msrParms = jsonObj.data.measures, dimParms = jsonObj.data.dimensions;
		if (msrParms == null || msrParms.length == 0) {
			return "missing measure";
		}
		if (dimParms == null || dimParms.length == 0) {
			return "missing dimensions";
		}		
		//default totals to false
		$rootScope.displayTableTotals = false;

		props.qHyperCubeDef.qDimensions = [];
		if (dimParms != null && dimParms.length > 0) {
			for(let w =0; w < dimParms.length; w++) {
				let jsonDim = dimParms[w];
				for (let x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
					let apiGrps = $rootScope.dimensionProperties.apiDimTopics[x].dimensionGroups;
					for (let y = 0; y < apiGrps.length; y++) {
						for (let z = 0; z < apiGrps[y].dimensions.length; z++) {
							let item = apiGrps[y].dimensions[z];
							if(item.shortName == null)
								continue;
							if (jsonDim.shortName.toLowerCase().trim() == item.shortName.toLowerCase().trim()
								&& jsonDim.title == item.title) {
								if (jsonDim.hierarchyAvailable == 'Y' && item.hierarchyAvailable == 'Y') {
									if(jsonDim.type == "dimension") {
										item.selected = true;
										let tree = dimensions.getDimensionsForTree(item);
										item.savedDims = tree;
										for (let i = 0; i < jsonDim.dimLevels.length; i++) {
											if(jsonDim.dimLevels[i].selected) {
												for (let j = 0; j < tree.length; j++) {
													if (tree[j].shortName.toLowerCase().trim() == jsonDim.dimLevels[i].shortName.toLowerCase().trim()) {
														tree[j].selected = true;
														tree[j].restoreValues = jsonDim.dimLevels[i].values;
														
														let tempDim = oneTimeSortOverride(tree[j], jsonDim.dimLevels[i]);								
														dimensions.defineDimension($rootScope, tempDim, props, false);
														if (hyperCubeProperties.hasAssociationsArray(tree[j])) {
															hyperCubeProperties.getSelectedAssociations($rootScope, tree[j]);
														}
														break;
													}
												}
											}
										}
										dimArray.push(item);
									} else if(jsonDim.type == "recodeTree") {
										//First, restore the recodedSrcDims array which contains the tree structure and custom recoded dimensions that
										//are then available for selection to build custom hierarchies 
										let tree = dimensions.getDimensionsForTree(item);
										item.recodedSrcDims = tree;
										item.recodeTrees = [];
										
										for (let i = 0; i < jsonDim.dimLevels.length; i++) {
											if(jsonDim.dimLevels[i].selected) {
												for (let j = 0; j < tree.length; j++) {
													if (tree[j].shortName.toLowerCase().trim() == jsonDim.dimLevels[i].shortName.toLowerCase().trim()) {
														tree[j].selected = jsonDim.dimLevels[i].selected;
														tree[j].restoreValues = jsonDim.dimLevels[i].values;	
														if(jsonDim.dimLevels[i].type== "recode") {
															tree[j].recodes = [];
															let recode = {};
															recode.cId = 'recode' + appUtilities.randomCid();
															recode.dimCid = tree[j].cId;
															recode.shortName = jsonDim.dimLevels[i].shortName;
															recode.recodeName = jsonDim.dimLevels[i].recodeName;
															recode.title = jsonDim.dimLevels[i].title;
															recode.type = "recode";
															recode.associations = tree[j].associations;
															recode.variableId = tree[j].variableId;
															recode.categories = [];
															jsonDim.dimLevels[i].categories.forEach(function(cat) {
																let category = {};
																category.qText = cat.qText;
																category.type = cat.type;
																category.cId = appUtilities.randomCid();
																category.selected = cat.selected;
																category.values = cat.values;
																recode.categories.push(category);
															});
															tree[j].recodes.push(recode);
															break;																																				
														}
													}
												}
											}
										}
										
										//Next, restore the actual recoded tree which contains the custom recoded hierarchy dimensions														
										let recodeTree = {};
										recodeTree.savedDims = [];
										recodeTree.cId = appUtilities.randomCid();
										recodeTree.rootShortName = jsonDim.shortName;
										recodeTree.rootTitle = jsonDim.title;	
										recodeTree.treeName = jsonDim.treeName;
										recodeTree.type = jsonDim.type;
										recodeTree.selected = jsonDim.selected;
										recodeTree.selectedValuesCount = jsonDim.selectedValuesCount;
										for (let i = 0; i < jsonDim.dimLevels.length; i++) {
											if(jsonDim.dimLevels[i].selected) {			
												for (let j = 0; j < tree.length; j++) {
													if (tree[j].shortName.toLowerCase().trim() == jsonDim.dimLevels[i].shortName.toLowerCase().trim()) {
														let savedDim;
														if(jsonDim.dimLevels[i].type== "recode") {

															savedDim = JSON.parse(JSON.stringify(tree[j].recodes.filter(function(rec) {
																return rec.recodeName.toLowerCase().trim() == jsonDim.dimLevels[i].recodeName.toLowerCase().trim();
															})[0]));																	
															
															savedDim.shortName = jsonDim.dimLevels[i].shortName;
															savedDim.recodeName = jsonDim.dimLevels[i].recodeName;
															savedDim.title = jsonDim.dimLevels[i].title;
															savedDim.type = "recode";
															savedDim.recodeDef = hyperCubeProperties.buildRecode(jsonDim.dimLevels[i], jsonDim.dimLevels[i]);
															savedDim.selected = jsonDim.dimLevels[i].selected;
															savedDim.restoreValues = jsonDim.dimLevels[i].values;				
															savedDim.categories = [];
															jsonDim.dimLevels[i].categories.forEach(function(cat) {
																let category = {};
																category.qText = cat.qText;
																category.type = cat.type;
																category.cId = appUtilities.randomCid();
																category.selected = cat.selected;
																category.restoreValues = [];
																cat.values.forEach(function(val) {
																	let value = {};
																	value.qText = val.qText;
																	category.restoreValues.push(value);
																})																		
																savedDim.categories.push(category);
															})
															
															savedDim.restoreNonRecodeValues = [];
															jsonDim.dimLevels[i].values.forEach(function(val) {
																if(!val.recode) {
																	let found = false;
																	for(let x = 0; x < savedDim.categories.length; x++) {
																		for(let y = 0; y < savedDim.categories[x].restoreValues.length; y++) {
																			if(val.qText == savedDim.categories[x].restoreValues[y].qText) {
																				found = true;
																				break;
																			}																				
																		}
																		if(found)
																			break;
																	};
																		
																	if(!found) 
																		savedDim.restoreNonRecodeValues.push(val);
																}
															});																	
														} else {
															savedDim = JSON.parse(JSON.stringify(tree[j]));
															delete savedDim.recodes;
															savedDim.selected = jsonDim.dimLevels[i].selected;
															savedDim.restoreValues = jsonDim.dimLevels[i].values;
														}																	
																									
														recodeTree.savedDims.push(savedDim);

														let tempDim = oneTimeSortOverride(savedDim, jsonDim.dimLevels[i]);
														dimensions.defineDimension($rootScope, tempDim, props, false);																
														if (hyperCubeProperties.hasAssociationsArray(savedDim)) {
															hyperCubeProperties.getSelectedAssociations($rootScope, savedDim);
														}				
														break;
													}
												}			
											}
										}
										recodeTree.dimensions = recodeTree.savedDims;
										dimArray.push(recodeTree);
										item.recodeTrees.push(recodeTree);



									}
								} else if(jsonDim.type == "dimension") {
									item.selected = true;
									item.restoreValues = jsonDim.values;
									dimArray.push(item);
									let tempDim = oneTimeSortOverride(item, jsonDim);

									dimensions.defineDimension($rootScope, tempDim, props, false);
									if (hyperCubeProperties.hasAssociationsArray(item)) {
										hyperCubeProperties.getSelectedAssociations($rootScope, item);
									}								
									break;
								} else if(jsonDim.type == "recode") {
									item.recodeSelected = true;
									item.recodes = item.recodes || [];											
									let recode = {};
									recode.shortName = jsonDim.shortName;
									recode.recodeName = jsonDim.recodeName;											
									recode.title = jsonDim.title;
									recode.dimCid = item.cId;
									recode.cId = 'recode' + appUtilities.randomCid();												
									recode.type = "recode";
									recode.recodeDef = hyperCubeProperties.buildRecode(jsonDim, jsonDim);
									recode.categories = [];
									jsonDim.categories.forEach(function(cat) {
										let category = {};
										category.qText = cat.qText;
										category.type = cat.type;
										category.cId = appUtilities.randomCid();
										category.selected = cat.selected;
										category.restoreValues = [];
										cat.values.forEach(function(val) {
											let value = {};
											value.qText = val.qText;
											category.restoreValues.push(value);
										})
										recode.categories.push(category);
									})

									recode.restoreNonRecodeValues = [];
									jsonDim.values.forEach(function(val) {
										let found = false;
										for(let x = 0; x < recode.categories.length; x++) {
											for(let y = 0; y < recode.categories[x].restoreValues.length; y++) {
												if(val.qText == recode.categories[x].restoreValues[y].qText) {
													found = true;
													break;
												}
											};
											if(found)
												break;
										};
											
										if(!found) 
											recode.restoreNonRecodeValues.push(val);

									});	

									recode.selected = true;	
									item.recodes.push(recode)
									dimArray.push(recode);
									let tempDim = oneTimeSortOverride(recode, jsonDim);
									dimensions.defineDimension($rootScope, tempDim, props, false);
									if (hyperCubeProperties.hasAssociationsArray(item)) {
										hyperCubeProperties.getSelectedAssociations($rootScope, item);
									}
									break;
								}
							}
						}
					}
				}
			}
		}
		  

		props.qHyperCubeDef.qMeasures = [];
		if (msrParms != null && msrParms.length > 0) {
			for(let w =0; w < msrParms.length; w++) {
				let jsonMsr = msrParms[w];
				for (let x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
					let apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
					for (let y = 0; y < apiGrps.length; y++) {
						for (let z = 0; z < apiGrps[y].measures.length; z++) {
							let item = apiGrps[y].measures[z];
							if (item.shortName.toLowerCase().trim() == jsonMsr.shortName.toLowerCase().trim()) {
								item.selected = true;
								item.checked = true;
								measures.defineMeasure($rootScope, item, props);
								if (hyperCubeProperties.hasAssociationsArray(item)) {
									hyperCubeProperties.getSelectedAssociations($rootScope, item);
								}
							}
						};
					};
				};
			};
		};

		//set dimension order to import value only if all dimensions were successfully added, 
		//which is the case when the 2 columnSortOrder props have the same length
		if(props.qHyperCubeDef.qInterColumnSortOrder.length == jsonObj.data.order.length) {
			props.qHyperCubeDef.qInterColumnSortOrder = jsonObj.data.order;
			props.qHyperCubeDef.qNoOfLeftDims = jsonObj.data.noOfLeftDims;
		} else {
			//at least one dim failed to load, so default layout to have year in cols 1st pos
			for(let x=0; x < props.qHyperCubeDef.qDimensions.length; x++) {
				let dim = dimensions.getDimensionByCid($rootScope, props.qHyperCubeDef.qDimensions[x].qDef.cId);
				if(dim.shortName == $rootScope.survey.dimToLock) {
					props.qHyperCubeDef.qNoOfLeftDims = x;
					break;
				}
			}
		}
		//limitation with Qlik is expand all cols does not work when msrs in rows, so if true disable expand all cols button
		let pos = props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1);
		if(pos > -1 && pos < props.qHyperCubeDef.qNoOfLeftDims) {
			$rootScope.disableExpandCollapseFunctions = true;
		} else {
			$rootScope.disableExpandCollapseFunctions = false;
		}

		if(jsonObj.data.displayTableTotals == null)
			$rootScope.displayTableTotals = false;
		else
			$rootScope.displayTableTotals = jsonObj.data.displayTableTotals;

		if($rootScope.displayTableTotals)
			dimensions.applyTotalsProperties($rootScope, props);

		if($rootScope.survey.allowTablePercentages && jsonObj.data.displayTablePercentageType != null) {
			$rootScope.displayTablePercentageType = jsonObj.data.displayTablePercentageType;
		}

		if($rootScope.survey.allowTablePercentages && $rootScope.displayTablePercentageType != null) {
			measures.applyPercentages($rootScope, props);
		}
		return;
	};

	function oneTimeSortOverride(dim, jsonDim) {
		let tmpDim = {};
		tmpDim.cId = dim.cId;
		tmpDim.shortName = dim.shortName;
		if(jsonDim.valueSortDefault != null) {
			tmpDim.valueSortDefault = jsonDim.valueSortDefault;
		}
		tmpDim.title = dim.title;
		tmpDim.recodeName = dim.recodeName;
		tmpDim.recodeDef = dim.recodeDef;
		tmpDim.def = dim.def;
		return tmpDim;
	}	

	return {
		applyVariablesToTable : applyVariablesToTable
	};
});

'use strict'
define('scripts/directives/leftRailOptionsDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/appUtilities",
		"scripts/shared/dimensions", "scripts/shared/tableSelections", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, appUtilities, dimensions, tableSelections, recodes) {
	angular.module("appModule").directive("dtLeftRailOptions", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtLeftRailOptions.html',
			scope: true,
			controller: 'LeftRailOptionsController'
		};
	});

	angular.module("appModule").controller("LeftRailOptionsController", ["$scope", "$rootScope", "$location",
			function ($scope, $rootScope, $location) {
				let qApp = $rootScope.qApp;
				let jsonObj;
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				const confirmationErrorTypes = {
					OpenTblWrongTblDef: {title: "Open Table", msg: "The file selected will open a new survey and replace the current table.  Do you want to continue?"},
					OpenTblWrongRecodeDef: {title: "Open Table", msg: "The file selected will apply custom dimensions so that you will be able to add to your table. Do you want to continue?"},
					OpenTblWrongSurveyRecodeDef: {title: "Open Table", "msg": "The file selected will apply custom dimensions created for a different survey.  Applying them will replace your current table. Do you want to continue?"},
					OpenRecodeWrongRecodeDef: {title: "Open Dimension", msg: "The file selected will open a new survey and apply the custom dimensions so that you will be able to add to your table.  Do you want to continue?"},
					OpenRecodeWrongTblDef:  {title: "Open Dimension", msg: "The file selected will apply custom table definitions.  Applying them will replace your current table.  Do you want to continue?"},
					OpenRecodeWrongSurveyTblDef: {title: "Open Dimension", msg: "The file selected will open a new survey and replace the current table.  Do you want to continue?"}};

				$scope.confirmationErrorType = null;
				let saveFile = null;

				$scope.$on('loadRecodesEvent', function (e, commonRecodeObj) {
					if(commonRecodeObj != null) {
						recodes.loadRecodeObj($rootScope, qApp, commonRecodeObj).then(function(recodeErrors) {
							if(recodeErrors == null) {
								recodes.setRecodeValues($rootScope, commonRecodeObj, true);
							} else {
								if(Array.isArray(recodeErrors)) {
									$scope.recodeErrs = recodeErrors;
									$('#modal-recode-errors').modal('show');
								} else {
									$scope.msgTitle = "Invalid recode file";
									$scope.msgText = recodeErrors.message;
									$scope.$apply();
									$('#modal-options-msg').modal({
										toggle: true,
										backdrop: 'static',
										keyboard: false
									});
								}
							}
						},function(err) {
							$scope.msgTitle = "Error processing common recodes";
							$scope.msgText = err;
							$scope.$apply();
							$('#modal-options-msg').modal({
								toggle: true,
								backdrop: 'static',
								keyboard: false
							});
						});							
					} else {
						recodes.loadRecodeObj($rootScope, qApp, $rootScope.importDefJson).then(function(recodeErrors) {
							if(recodeErrors == null) {
								recodes.setRecodeValues($rootScope, $rootScope.importDefJson);
								$('#modal-confirm').modal('hide');
								$rootScope.$broadcast('rebuildRecodesListEvent');
								$scope.msgTitle = "Custom Dimensions Available";
								$scope.msgText = "You can now select your custom dimension(s) from the left panel.";
								$('#modal-options-msg').modal({
									toggle: true,
									backdrop: 'static',
									keyboard: false
								});
							} else {
								if(Array.isArray(recodeErrors)) {
									$scope.recodeErrs = recodeErrors;
									$('#modal-recode-errors').modal('show');
								} else {
									$scope.msgTitle = "Invalid recode file";
									$scope.msgText = recodeErrors.message;
									$scope.$apply();
									$('#modal-options-msg').modal({
										toggle: true,
										backdrop: 'static',
										keyboard: false
									});
								}
							}
						},function(err) {
							$scope.msgTitle = "Error processing imported recodes";
							$scope.msgText = err;
							$scope.$apply();
							$('#modal-options-msg').modal({
								toggle: true,
								backdrop: 'static',
								keyboard: false
							});
						});								
					}
				});	

				$scope.$on('loadTableEvent', function (e, fileName) {
					loadTable(fileName);
				})

				function loadTable(fileName) {
					$scope.importFileName = null;
					$scope.showPreview = false;
					$scope.errorMsg = null;
					$scope.warnMsg = null;
					//$scope.showAlert = false;
					$scope.savedMeasures = null;
					$scope.savedDimensions = null;
					$scope.disableApplyBtn = false;
					$('#modal-draft-table').modal('show');
					$scope.importFileName = decodeURI(fileName);
					jsonObj = $rootScope.importDefJson;
					previewDraft(jsonObj);
				};
				
				$scope.btnClearSelections = function () {
					$scope.toggleReadOnly(true);
					$scope.showTable = false;
					//google analytics tracking
					let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Clear selections', {
						'event_label': 'clear',
						'event_category': 'clear_selections'
					});
					$scope.clearSelections().then(function () {
                        //$("#left-rail").css("max-height","calc(100vh - 202px)");
						$scope.toggleReadOnly(false);
					}, function (err) {
						$scope.toggleReadOnly(false);
						$scope.msgTitle = "Error loading file";
						$scope.msgText = err;
						//$scope.$apply();
						$('#modal-options-msg').modal({
							toggle: true,
							backdrop: 'static',
							keyboard: false
						});	
					});
				}

				$scope.btnLeftRailOptionsOpen = function () {
					$scope.recodeList = recodes.getDefinedRecodes($rootScope);
					var defaultTab = document.querySelector('#tabSaveFileLink')
					var tab = new bootstrap.Tab(defaultTab)
					tab.show();	
					$('#modal-left-rail-options').modal('show');
					$scope.confirmationErrorType = null;
					$scope.errorMsg = null;
					$scope.warnMsg = null;
					$scope.disableSaveTable = !$scope.isPivotTableVisible
				}

				$scope.btnSaveFile = function () {
						saveAs(saveFile, $scope.exportFileName);
						$('#modal-confirm-filename').modal('hide');
						saveFile = null;
				}

				$scope.btnListRecodes = function () {
					$('#modal-show-recodes').modal('show');
				}

				$scope.btnExportDraftTable = function () {

					// gtag('event', ($rootScope.displayVisType == 'pivot-table'?'TB-':'CB-') + $rootScope.survey.abbreviation + '-Save Table', {
					// 	'event_label': 'export',
					// 	'event_category': 'save_table'
					// });
					qApp.getObject($rootScope.visObjId).then(function (obj) {
						obj.getEffectiveProperties().then(function (effProps) {

							let msrs = getSelectedMeasures();
							let dims = getSelectedDimensions(effProps);

							let promises = [];
							for (let i = 0; i < dims.length; i++) {

								if (dims[i].hierarchyAvailable == "Y") {
									dims[i].dimLevels.forEach(function (lvl) {
										promises.push(getDimensionValues(obj, lvl));
									})

								} else {
									promises.push(getDimensionValues(obj, dims[i]));
								}
							}

							Promise.all(promises).then(function () {
								function makeTextFile(text) {
									let data = new Blob([text], {
										type: 'text/json'
									});
									return data;
								};

								let filePrefix = "ncses_cust_table_";

								let dateTime = new Date();
								let fileName = filePrefix + $rootScope.survey.abbreviation + "_" + dateTime.toISOString().split('.')[0] + "Z";
								let jsonObj = {};
								jsonObj.survey = $rootScope.survey.abbreviation;
								jsonObj.surveyTitle = $rootScope.survey.properties.surveyName;
								jsonObj.appTitle = $rootScope.qApp.model.layout.qTitle;
								jsonObj.lastReloadTime = $rootScope.qApp.model.layout.qLastReloadTime;
								jsonObj.contentType = "tableSelections";
								let data = buildJson(effProps, dims, msrs);
								jsonObj.data = data;
								saveFile = makeTextFile(JSON.stringify(jsonObj));
								$scope.exportFileName = fileName + ".json";

								$('#modal-left-rail-options').modal('hide');
								$('#modal-confirm-filename').modal('show');
				
								let tags = msrs.map(function (x) {
									return x.shortName;
								});
								tags = tags.concat(dims.map(function (x) {
											return x.shortName;
										})).toString();
								gtag('event', displayType + $rootScope.survey.abbreviation + '-Save table definition file', {
									'event_label': 'save',
									'event_category': 'table_def',
									'event_variables': tags
								});
							})
						})
					})
				}

				$scope.btnFilePreviewDraftTable = function () {
					let filePicker = document.getElementById('fileLoadDraftTable');
					filePicker.value = "";
					filePicker.addEventListener("change", fileDraftTableSelected);
					filePicker.click();

					function fileDraftTableSelected() {
						filePicker.removeEventListener("change", fileDraftTableSelected);
						$('#modal-left-rail-options').modal('hide');

						$scope.importFileName = null;
						$scope.showPreview = false;
						$scope.errorMsg = null;
						$scope.warnMsg = null;
						$scope.savedMeasures = null;
						$scope.savedDimensions = null;
						$scope.disableApplyBtn = false;
						$('#modal-draft-table').modal('show');
						$scope.$apply();

						let obj;
						let f = filePicker.files[0];
						if(f == null)
							return;

						let promise = appUtilities.loadJsonFile(f, obj);
						promise.then((savedObj) => {
							try {
								jsonObj = savedObj;
								filePicker.value = "";
								$scope.importFileName = f.name;
								if (jsonObj.survey == null) {
									throw ("File content type is not valid for loading.");
								}
								if (jsonObj.contentType != "tableSelections") {
									if (jsonObj.recodedDims == null || jsonObj.recodedDims.length == 0) {
										throw ("File content type is not valid for loading.");
									} else {
										//User selected recodes file
										if (jsonObj.survey != $rootScope.survey.abbreviation) {
											$scope.confirmationErrorType = confirmationErrorTypes.OpenTblWrongSurveyRecodeDef;
										} else {
											$scope.confirmationErrorType = confirmationErrorTypes.OpenTblWrongRecodeDef;
										}
										$rootScope.importDefJson = jsonObj;
										$('#modal-confirm').modal('show');
										$('#modal-draft-table').modal('hide');
										$scope.$apply();
									}
								} else if (jsonObj.survey != $rootScope.survey.abbreviation) {
									$rootScope.importDefJson = jsonObj;
									$scope.confirmationErrorType = confirmationErrorTypes.OpenTblWrongTblDef;
									$('#modal-confirm').modal('show');
									$('#modal-draft-table').modal('hide');
									$scope.$apply();

								} else {
									//table def for current suvey, confirmation not needed
									previewDraft(jsonObj)
								}

							} catch (err) {
								//$scope.errorMsg = err;
								$scope.disableApplyBtn = true;
								$scope.toggleReadOnly(false);
								$scope.msgTitle = "Error loading file";
								$scope.msgText = err;
								$scope.$apply();
								$('#modal-options-msg').modal({
									toggle: true,
									backdrop: 'static',
									keyboard: false
								});
							}
						}, function (err) {
							//$scope.errorMsg = err;
							$scope.disableApplyBtn = true;
							$scope.toggleReadOnly(false);
							//appUtilities.showError(err);
							$scope.msgTitle = "Error loading file";
							$scope.msgText = err;
							$scope.$apply();
							$('#modal-options-msg').modal({
								toggle: true,
								backdrop: 'static',
								keyboard: false
							});
						});
					}
				}
				
				function previewDraft(jsonObj) {
					$scope.showPreview = true;
					if (jsonObj.appTitle != $rootScope.qApp.model.layout.qTitle) {
						$scope.warnMsg = "Survey in file was created in a different survey cycle.";
					}
					
					//var spinner = appUtilities.initSpinner();
					$scope.toggleReadOnly(true)
					verifyJsonData(jsonObj).then(function (unMatchedCount) {
						$scope.savedMeasures = jsonObj.data.measures;
						$scope.savedDimensions = getJsonDimensions(jsonObj.data.dimensions);
						$scope.unMatchedCount = unMatchedCount;
						$scope.$apply();
						//spinner.stop();
						$scope.toggleReadOnly(false)
					}, function (err) {
						console.log('Error', err);
						$scope.disableApplyBtn = true;
						//spinner.stop();
						$scope.toggleReadOnly(false);
						$scope.msgTitle = "Error loading file";
						$scope.msgText = "Error processing custom table file";
						$scope.$apply();
						$('#modal-options-msg').modal({
							toggle: true,
							backdrop: 'static',
							keyboard: false
						});
					});	
				}

				$scope.btnClearSearchDraftTableFileClick = function () {
					$scope.importFileName = null;
					$scope.errorMsg = null;
					$scope.warnMsg = null;
					$scope.showPreview = false;
					$scope.disableApplyBtn = true;
					$scope.savedMeasures = null;
					$scope.savedDimensions = null;
					$scope.unMatchedCount = null;
				}

				$scope.btnContinueAction = function () {
					if($scope.confirmationErrorType == confirmationErrorTypes.OpenTblWrongRecodeDef) {
						let recodeErrors = recodes.loadRecodeObj($rootScope, qApp, $rootScope.importDefJson)
						if(recodeErrors == null) {
							recodes.setRecodeValues($rootScope, $rootScope.importDefJson);
							$('#modal-confirm').modal('hide');
							$rootScope.$broadcast('rebuildRecodesListEvent');
							$scope.msgTitle = "Custom Dimensions Available";
							$scope.msgText = "You can now select your custom dimension(s) from the left panel.";
							//$scope.$apply();
							$('#modal-options-msg').modal({
								toggle: true,
								backdrop: 'static',
								keyboard: false
							});
						} else {
							if(Array.isArray(recodeErrors)) {
								$scope.recodeErrs = recodeErrors;
								$('#modal-recode-errors').modal('show');
							} else {
								$scope.msgTitle = "Invalid recode file";
								$scope.msgText = recodeErrors.message;
								//$scope.$apply();
								$('#modal-options-msg').modal({
									toggle: true,
									backdrop: 'static',
									keyboard: false
								});
							}
						}
						$rootScope.importDefJson = null;
					} else if($scope.confirmationErrorType == confirmationErrorTypes.OpenTblWrongTblDef
					|| $scope.confirmationErrorType == confirmationErrorTypes.OpenRecodeWrongSurveyTblDef
					|| $scope.confirmationErrorType == confirmationErrorTypes.OpenRecodeWrongTblDef) {
						if($location.search().localtabledef == encodeURI($scope.importFileName)){

							$scope.btnClearSelections();
							$('#modal-confirm').modal('hide');
							loadTable(encodeURI($scope.importFileName))
						} else {
							$location.path( "/" + $rootScope.importDefJson.survey.toLowerCase());
							//remove old criteria
							$location.search('');
							$location.search('localtabledef', encodeURI($scope.importFileName));
						}
					} else if($scope.confirmationErrorType == confirmationErrorTypes.OpenTblWrongSurveyRecodeDef
					|| $scope.confirmationErrorType == confirmationErrorTypes.OpenRecodeWrongRecodeDef) {
						$location.path( "/" + $rootScope.importDefJson.survey.toLowerCase());
						$location.search('localtabledef', null);
						$location.search('localrecodedef', encodeURI($scope.importFileName));
					}
					return;
				}

				$scope.btnCancelAction = function () {
					$('#modal-confirm').modal('hide');
					$('#modal-left-rail-options').modal('show');
				}				

				$scope.kbLink = function (path) {
					gtag('event', displayType + 'Save/Open Knowledgebase', { 'event_label': 'link', 'event_category': 'knowledgebase'});
					let url = webProperties.props.kbUrl + path;
					window.open(url, "_blank");
				}					

				$scope.btnApplyDraftTable = function () {
				
					//var spinner = appUtilities.initSpinner();
					$scope.toggleReadOnly(true)
/*					'event_label': 'import',
						'event_category': 'import_table'
					}); */

					let tags = $scope.savedMeasures.map(function (x) {
						return x.shortName;
					});
					tags = tags.concat($scope.savedDimensions.map(function (x) {
								return x.shortName;
							})).toString();
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Load table definition file', {
						'event_label': 'load',
						'event_category': 'table_def',
						'event_variables': tags
					});					

					tableSelections.applyVariablesToTable($rootScope, $scope, jsonObj).then(function (o) {
						//$scope.msgTitle = "Load Saved Selections";
						$scope.msgText = "File loaded successfully.";
						//$scope.$apply();
						$('#modal-options-msg').modal({
							toggle: true,
							backdrop: 'static',
							keyboard: false
						});
						$('#modal-draft-table').modal('hide');
						$rootScope.$broadcast('rebuildRecodesListEvent');
						//spinner.stop();
						$scope.toggleReadOnly(false)
					}, function (err) {
						console.log('Error', err);
						//spinner.stop();
						$scope.errorMsg = err;
						$scope.toggleReadOnly(false)
					});
				}

				function buildJson(effProps, dims, msrs) {
					let jsonObj = {};
					jsonObj.dimensions = [];
					jsonObj.measures = [];

					//add dims to list in the hypercube order
					for (let h = 0; h < effProps.qHyperCubeDef.qDimensions.length; h++) {
						let qDef = effProps.qHyperCubeDef.qDimensions[h].qDef;
						for (let d = 0; d < dims.length; d++) {

							if (dims[d].cId == qDef.cId) {
								//remove cId from export since it cannot be used by import process
								delete dims[d].cId;
								if (qDef.qSortCriterias[0].qSortByAscii != null) {
									dims[d].valueSortDefault = qDef.qSortCriterias[0].qSortByAscii == -1 ? 'DESC' : 'ASC'
								}
								jsonObj.dimensions.push(dims[d]);
								break;
							} else if (dims[d].hierarchyAvailable == "Y") {
								if (dims[d].type == "dimension") {
									//check if tree branch.cid matches hypercube cid, then store tree root dim and all component dims
									for (let e = 0; e < dims[d].dimLevels.length; e++) {
										if (dims[d].dimLevels[e].cId == qDef.cId) {
											if (qDef.qSortCriterias[0].qSortByAscii != null) {
												dims[d].dimLevels[e].valueSortDefault = qDef.qSortCriterias[0].qSortByAscii == -1 ? 'DESC' : 'ASC'
											}

											let treeObj = {};
											treeObj.shortName = dims[d].shortName;
											treeObj.title = dims[d].title;
											treeObj.type = dims[d].type;
											treeObj.selected = true;
											treeObj.hierarchyAvailable = "Y";
											dims[d].dimLevels.forEach(function (item) {
												//delete cid so that levels are skipped after initial add
												delete item.cId;
											});
											treeObj.dimLevels = dims[d].dimLevels;
											jsonObj.dimensions.push(treeObj);
											break;
										}
									}
								} else if (dims[d].type == "recodeTree") {
									//check if tree branch.cid matches hypercube cid, then store tree root dim and all component dims
									for (let e = 0; e < dims[d].dimLevels.length; e++) {
										if (dims[d].dimLevels[e].cId == qDef.cId) {
											let treeObj = {};
											treeObj.shortName = dims[d].shortName;
											treeObj.title = dims[d].title;
											treeObj.type = dims[d].type;
											treeObj.treeName = dims[d].treeName;
											treeObj.selected = true;
											treeObj.hierarchyAvailable = "Y";
											treeObj.selectedValuesCount = dims[d].selectedValuesCount;
											dims[d].dimLevels.forEach(function (item) {
												//delete cid so that levels are skipped after initial add
												delete item.cId;
											});
											treeObj.dimLevels = dims[d].dimLevels;
											jsonObj.dimensions.push(treeObj);
											break;
										}
									}
								}
							}
						}
					}

					//add msrs to list in the hypercube order
					for (let h = 0; h < effProps.qHyperCubeDef.qMeasures.length; h++) {
						let cId = effProps.qHyperCubeDef.qMeasures[h].qDef.cId;
						for (let d = 0; d < msrs.length; d++) {
							if (msrs[d].cId == cId) {
								delete msrs[d].cId;
								jsonObj.measures.push(msrs[d]);
							}
						}
					}

					if (effProps.qHyperCubeDef.qSortbyYValue != null) {
						jsonObj.qSortbyYValue = effProps.qHyperCubeDef.qSortbyYValue;
					}
					jsonObj.order = effProps.qHyperCubeDef.qInterColumnSortOrder;
					jsonObj.noOfLeftDims = effProps.qHyperCubeDef.qNoOfLeftDims;
					if ($rootScope.selectedAmountCount > 0) {
						for (let i = 0; i < $scope.amountOptions.deflators.length; i++) {
							if ($scope.amountOptions.deflators[i].value == $scope.deflatorSelected)
								jsonObj.deflator = $scope.amountOptions.deflators[i].name;
						}

						for (let i = 0; i < $scope.amountOptions.unitsOfMeasure.length; i++) {
							if ($scope.amountOptions.unitsOfMeasure[i].value == $scope.unitsSelected)
								jsonObj.unitOfMeasure = $scope.amountOptions.unitsOfMeasure[i].name;
						}
					}
                    if($rootScope.displayTableTotals != null)
                        jsonObj.displayTableTotals = $rootScope.displayTableTotals;
                    if($rootScope.displayTablePercentageType != null)
                        jsonObj.displayTablePercentageType = $rootScope.displayTablePercentageType;                    
					return jsonObj;
				}

				function getSelectedMeasures() {
					let msrList = [];
					for (let x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
						let apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
						for (let y = 0; y < apiGrps.length; y++) {
							for (let z = 0; z < apiGrps[y].measures.length; z++) {
								if (apiGrps[y].measures[z].selected == true) {
									let msr = {};
									msr.shortName = apiGrps[y].measures[z].shortName;
									msr.title = apiGrps[y].measures[z].title;
									msr.variableName = apiGrps[y].measures[z].variableName;
									msr.cId = apiGrps[y].measures[z].cId;
									msrList.push(msr);
								}
							};
						};
					};
					return msrList;
				}

				function getSelectedDimensions(props) {
					let dimList = [];
					let recodes = [];
					let promises = [];
					for (let w = 0; w < $rootScope.dimensionProperties.apiDimTopics.length; w++) {
						let topic = $rootScope.dimensionProperties.apiDimTopics[w];
						for (let x = 0; x < topic.dimensionGroups.length; x++) {
							let grp = topic.dimensionGroups[x];
							for (let y = 0; y < grp.dimensions.length; y++) {
								if (grp.dimensions[y].hierarchyAvailable == "Y") {
									if (grp.dimensions[y].selected == true) {
										let currentItem = {};
										currentItem.shortName = grp.dimensions[y].shortName;
										currentItem.title = grp.dimensions[y].title;
										currentItem.type = grp.dimensions[y].type;
										currentItem.hierarchyAvailable = "Y";
										currentItem.selected = true;

										currentItem.dimLevels = [];
										grp.dimensions[y].savedDims.forEach(function (item) {
											if (item.selected) {
												let dim = {};
												dim.shortName = item.shortName;
												dim.title = item.title;
												dim.cId = item.cId;
												dim.type = item.type;
												dim.selected = item.selected;
												dim.valueSortDefault = findSortValue(props, item.cId)
													currentItem.dimLevels.push(dim);
											}
										})
										dimList.push(currentItem);
									} else if (grp.dimensions[y].recodeTrees != null) {
										for (let a = 0; a < grp.dimensions[y].recodeTrees.length; a++) {
											if (grp.dimensions[y].recodeTrees[a].selected) {
												let recodeTree = grp.dimensions[y].recodeTrees[a];
												let currentItem = {};
												currentItem.shortName = recodeTree.rootShortName;
												currentItem.title = recodeTree.rootTitle;
												currentItem.treeName = recodeTree.treeName;
												currentItem.type = recodeTree.type;
												currentItem.hierarchyAvailable = "Y";
												currentItem.selectedValuesCount = recodeTree.selectedValuesCount
												currentItem.selected = true;

												currentItem.dimLevels = [];
												recodeTree.savedDims.forEach(function (item) {
													if (item.selected) {
														let dim = {};
														dim.shortName = item.shortName;
														dim.title = item.title;
														dim.type = item.type;
														dim.cId = item.cId;
														dim.selected = item.selected;
														dim.valueSortDefault = findSortValue(props, item.cId);
														if (item.type == "recode") {
															dim.recodeName = item.recodeName;
															dim.categories = [];
															item.categories.forEach(function (cat) {
																let category = {};
																category.qText = cat.qText;
																category.type = cat.type;
																category.selected = recodeTree.savedList.findIndex(function (val) {
																	return (val.qText == category.qText && val.shortName == dim.shortName && (val.class == 's' || val.class == 't'));
																}) > -1 ? true : false;
																category.values = [];
																cat.values.forEach(function (val) {
																	let value = {};
																	value.qText = val.qText;
																	category.values.push(value);
																})
																dim.categories.push(category);
															})
														}

														currentItem.dimLevels.push(dim);
													}
												})

												currentItem.dimLevels.forEach(function (dim) {
													dim.values = [];
													recodeTree.savedList.forEach(function (item) {
														if (dim.shortName == item.shortName && item.selected) {
															let val = {};
															val.qText = item.qText;
															val.parent = item.parent;
															if (dim.type == "recode") {
																if (item.recode != null && item.recode == true)
																	val.recode = true;
																else
																	val.recode = false;
															}
															dim.values.push(val);
														}
													})
												})
												dimList.push(currentItem);
											}
										}
									}
								} else {
									if (grp.dimensions[y].selected == true) {
										let currentItem = {};
										currentItem.shortName = grp.dimensions[y].shortName;
										currentItem.title = grp.dimensions[y].title;
										currentItem.cId = grp.dimensions[y].cId;
										currentItem.type = "dimension";
										currentItem.selected = true;
										currentItem.valueSortDefault = findSortValue(props, grp.dimensions[y].cId);
										dimList.push(currentItem);
									}
									if (grp.dimensions[y].recodes && grp.dimensions[y].recodeSelected) {
										let dim = grp.dimensions[y];
										for (let a = 0; a < dim.recodes.length; a++) {
											if (dim.recodes[a].selected) {
												let recode = {};
												recode.shortName = dim.recodes[a].shortName;
												recode.recodeName = dim.recodes[a].recodeName;
												recode.title = dim.recodes[a].title;
												recode.cId = dim.recodes[a].cId
												recode.type = dim.recodes[a].type;
												recode.recodeSelected = true;
												recode.valueSortDefault = findSortValue(props, dim.recodes[a].cId);
												recode.categories = [];
												dim.recodes[a].categories.forEach(function (cat) {
													let category = {};
													category.qText = cat.qText;
													category.type = cat.type;
													category.selected = cat.selected;
													category.values = [];
													cat.values.forEach(function (val) {
														let value = {};
														value.qText = val.qText;
														category.values.push(value);
													})
													recode.categories.push(category);
												})

												dimList.push(recode);
											}
										}
									}
								}
							};
						};
					};
					return dimList;
				}

				function findSortValue(props, cId) {
					for (let x = 0; x < props.qHyperCubeDef.qDimensions.length; x++) {
						if (props.qHyperCubeDef.qDimensions[x].qDef.cId == cId) {
							if( props.qHyperCubeDef.qDimensions[x].qDef.qSortCriterias[0].qSortByAscii == -1) {
								return 'DESC'
							} else if( props.qHyperCubeDef.qDimensions[x].qDef.qSortCriterias[0].qSortByAscii == 1) {
								return 'ASC'
							} else {
								return 'DEF'
							}
						}							
					}
					return 'DEF'
				}

				function getDimensionValues(obj, dim) {
					return new Promise(function (resolve, reject) {
						renderList(dim).then(function (values) {
							dim.values = [];
							values.forEach(function (item) {
								if (item.qState == 'S') {
									let val = {};
									val.qText = item.qText;
									dim.values.push(val);
								}
							});
							if(dim.values.length == 0) {
								//all vals selected, so add them all
								values.forEach(function (item) {
									let val = {};
									val.qText = item.qText;
									dim.values.push(val);
								});
							}
							return resolve();
						});
					})
				}

				function getJsonDimensions(jsonDims) {
					let list = [];
					for (let w = 0; w < jsonDims.length; w++) {
						let jsonDim = jsonDims[w];
						if (jsonDim.hierarchyAvailable == 'Y') {
							for (let x = 0; x < jsonDim.dimLevels.length; x++) {
								if (jsonDim.dimLevels[x].selected) {
									list.push(jsonDim.dimLevels[x]);
								}
							}
						} else {
							list.push(jsonDim);
						}
					}
					return list;
				};

				function verifyJsonData(jsonObj) {
					return new Promise(function (resolve, reject) {
						let dimArray = [];
						let unMatchedCount = verifyVariables($rootScope, $scope, qApp, jsonObj.data.measures, jsonObj.data.dimensions, dimArray);

						async function processValues() {
							for (let i = 0; i < dimArray.length; i++) {
								let dim = dimArray[i];

								let cnts = await verifyValues(dim);
								dim.selectedValuesCount = cnts.selectedValuesCount;
								unMatchedCount += cnts.unMatchedCount;
							}
							return resolve(unMatchedCount);
						}
						processValues();
					})
				}

				function verifyValues(dim) {
					return new Promise(function (resolve, reject) {
						let retObj = {};
						let unMatchedCount = 0;
						dimensions.getValuesByDimension(qApp, dim).then(function (qlikValues) {
							var selectedCnt = 0,
							found = false;
							for (var x = 0; x < dim.values.length; x++) {
								found = false;
								selectedCnt++;
								for (var y = 0; y < qlikValues.length; y++) {
									if (dim.values[x].qText === qlikValues[y].qText) {
										found = true;
										break;
									}
								}
								if (!found) {
									dim.values[x].unMatched = true;
									unMatchedCount++;
								}
							}

							retObj.selectedValuesCount = selectedCnt;
							retObj.totalValuesCount = qlikValues.length;
							retObj.unMatchedCount = unMatchedCount;
							return resolve(retObj);
						});
					})
				};

				function verifyVariables($rootScope, $scope, qApp, msrParms, dimParms, dimArray) {
					let unMatchedCount = 0;
					if ((msrParms == null || msrParms.length == 0) && (dimParms == null || dimParms.length == 0))
						return 0;

					if (msrParms != null && msrParms.length > 0) {
						for (let w = 0; w < msrParms.length; w++) {
							let jsonMsr = msrParms[w];
							let matched = false;
							for (let x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
								let apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
								for (let y = 0; y < apiGrps.length; y++) {
									for (let z = 0; z < apiGrps[y].measures.length; z++) {
										let item = apiGrps[y].measures[z];
										if (item.shortName.toLowerCase().trim() == jsonMsr.shortName.toLowerCase().trim()) {
											matched = true;
										}
									};
								};
							};
							if (!matched) {
								jsonMsr.unMatched = true;
								unMatchedCount++;
							}
						};
					};

					if (dimParms != null && dimParms.length > 0) {
						for (let w = 0; w < dimParms.length; w++) {
							let jsonDim = dimParms[w];
							let matched = false;
							for (let x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
								let apiGrps = $rootScope.dimensionProperties.apiDimTopics[x].dimensionGroups;
								for (let y = 0; y < apiGrps.length; y++) {
									for (let z = 0; z < apiGrps[y].dimensions.length; z++) {
										let item = apiGrps[y].dimensions[z];
										if(item.shortName == null)
											continue;										
										
										//find selected dims based on matching shortNames, also need tyo check for matching titles
										//for cases where a survey shares the same dim as a component in multiple hierarchies
										if (jsonDim.shortName.toLowerCase().trim() == item.shortName.toLowerCase().trim()
											&& jsonDim.title.toLowerCase().trim() == item.title.toLowerCase().trim()) {
											if (jsonDim.hierarchyAvailable == 'Y' && item.hierarchyAvailable == 'Y') {
												if (jsonDim.type == "dimension") {
													let tree = dimensions.getDimensionsForTree(item);
													for (let i = 0; i < jsonDim.dimLevels.length; i++) {
														if (jsonDim.dimLevels[i].selected) {
															let matchedLvl = false;
															for (let j = 0; j < tree.length; j++) {
																if (tree[j].shortName.toLowerCase().trim() == jsonDim.dimLevels[i].shortName.toLowerCase().trim()) {
																	matchedLvl = true;
																	break;
																}
															}
															if (!matchedLvl) {
																jsonDim.dimLevels[i].unMatched = true;
																unMatchedCount++;
															}
															dimArray.push(jsonDim.dimLevels[i]);
														}
													}
												} else if (jsonDim.type == "recodeTree") {
													//First, restore the recodedSrcDims array which contains the tree structure and custom recoded dimensions that
													//are then available for selection to build custom hierarchies
													let tree = dimensions.getDimensionsForTree(item);
													for (let i = 0; i < jsonDim.dimLevels.length; i++) {
														if (jsonDim.dimLevels[i].selected) {
															let matchedLvl = false;
															for (let j = 0; j < tree.length; j++) {
																if (tree[j].shortName.toLowerCase().trim() == jsonDim.dimLevels[i].shortName.toLowerCase().trim()) {
																	matchedLvl = true;
																	break;
																}
															}
															if (!matchedLvl) {
																jsonDim.dimLevels[i].unMatched = true;
																unMatchedCount++;
															}
															dimArray.push(jsonDim.dimLevels[i]);
														}
													}
												}
											} else {
												matched = true;
												dimArray.push(jsonDim);
											}
											break;
										}
									}
									if (matched) {
										break;
									}
								}
								if (matched) {
									break;
								}
							}
							if (!matched) {
								jsonDim.unMatched = true;
								unMatchedCount++;
							}
						}
					}
					return unMatchedCount; //dimArray;
				};

				function renderList(dim) {
					return new qlik.Promise(function (resolve, reject) {

						dimensions.getValuesByDimension(qApp, dim, null, null, 0).then(function (values) {
							return resolve(values);
						});

					})
				};

				/*** Recodes Section ****/
				$scope.btnSaveRecodes = function () {
					var recodedDims = getRecodes();

					if (recodedDims != null && recodedDims.length > 0) {
						var tags = recodedDims.map(function (x) {
							return x.shortName;
						}).toString();
						gtag('event', displayType + $rootScope.survey.abbreviation + '-Save Recode File', {
							'event_label': 'save',
							'event_category': 'recode_file',
							'event_variables':tags
						});

						function makeTextFile(text) {
							var data = new Blob([text], {
								type: 'text/json'
							});
							return data;
						};

						var filePrefix = "ncses_cust_dim_";

						var dateTime = new Date();
						var fileName = filePrefix + $rootScope.survey.abbreviation + "_" + dateTime.toISOString().split('.')[0] + "Z" + ".json";
						var jsonObj = {};
						jsonObj.survey = $rootScope.survey.abbreviation;
						jsonObj.lastReloadTime = $rootScope.qApp.model.layout.qLastReloadTime;
						jsonObj.title = $rootScope.qApp.model.layout.qTitle;
						jsonObj.recodedDims = recodedDims;
						saveFile = makeTextFile(JSON.stringify(jsonObj));
						$scope.exportFileName = fileName;
						$('#modal-left-rail-options').modal('hide');
						$('#modal-confirm-filename').modal('show');
					}
				}

				$scope.btnLoadRecodes = function () {
					var filePicker = document.getElementById('fileLoadRecodes');
					filePicker.value = "";
					filePicker.addEventListener("change", fileSelected);
					filePicker.click();
					function fileSelected() {
						filePicker.removeEventListener("change", fileSelected);
						let obj;
						let f = filePicker.files[0];
						if(f == null)
							return;
						
						let promise = appUtilities.loadJsonFile(f, obj);
						promise.then((recodeObj) => {
							try {
								$scope.importFileName = f.name;
								if (recodeObj.survey == null) {
									throw ("File content type is not valid for loading.");
								}
									
								if (recodeObj.contentType == "tableSelections") {
									//User selected table def file
									if( $rootScope.displayVisType !== "pivot-table") {
										throw ("File content type is not valid for loading into a chart.");
									}
									if (recodeObj.survey != $rootScope.survey.abbreviation) {
										$scope.confirmationErrorType = confirmationErrorTypes.OpenRecodeWrongSurveyTblDef;
									} else {
										$scope.confirmationErrorType = confirmationErrorTypes.OpenRecodeWrongTblDef;
									}
									$rootScope.importDefJson = recodeObj;
									$('#modal-confirm').modal('show');
									$('#modal-left-rail-options').modal('hide');
									$scope.$apply();	
								} else {
									if (recodeObj.recodedDims == null || recodeObj.recodedDims.length == 0) {
										throw ("File content type is not valid for loading.");
									}
									//User selected recodes file
									if (recodeObj.survey != $rootScope.survey.abbreviation) {
										$scope.confirmationErrorType = confirmationErrorTypes.OpenRecodeWrongRecodeDef;

										$rootScope.importDefJson = recodeObj;
										$('#modal-confirm').modal('show');
										$('#modal-left-rail-options').modal('hide');
										$scope.$apply();
									} else {
										//recode def for current suvey, confirmation not needed
										recodes.loadRecodeObj($rootScope, qApp, recodeObj).then(function(recodeErrors) {
											if(recodeErrors == null) {
												recodes.setRecodeValues($rootScope, recodeObj);
											}
											if(recodeErrors == null) {
												$('#modal-left-rail-options').modal('hide');
												recodes.setRecodeValues($rootScope, recodeObj);
												filePicker.value = "";
												$rootScope.$broadcast('rebuildRecodesListEvent');
												$scope.msgTitle = "Custom Dimensions Available";
												$scope.msgText = "You can now select your custom dimension(s) from the left panel.";
												$scope.$apply();
												$('#modal-options-msg').modal({
													toggle: true,
													backdrop: 'static',
													keyboard: false
												});
												var tags = recodeObj.recodedDims.map(function (x) {
													return x.shortName;
												}).toString();
												gtag('event', displayType + $rootScope.survey.abbreviation + '-Load Recodes File', {
													'event_label': 'load',
													'event_category': 'recode_file',
													'event_variables':tags
												});												
											} else {
												if(Array.isArray(recodeErrors)) {
													$scope.recodeErrs = recodeErrors;
													$scope.$apply();
													$('#modal-recode-errors').modal('show');
												} else {
													$scope.msgTitle = "Invalid recode file";
													$scope.msgText = recodeErrors.message;
													$scope.$apply();
													$('#modal-options-msg').modal({
														toggle: true,
														backdrop: 'static',
														keyboard: false
													});
												}
											}
										},function(err) {
											$scope.msgTitle = "Error processing recode file";
											$scope.msgText = err;
											$scope.$apply();
											$('#modal-options-msg').modal({
												toggle: true,
												backdrop: 'static',
												keyboard: false
											});
										});
									}
								}							
							} catch (err) {
								$scope.toggleReadOnly(false);
								$('#modal-left-rail-options').modal('hide');
								$scope.msgTitle = "Error loading recode file";
								$scope.msgText = err;
								$scope.$apply();
								$('#modal-options-msg').modal({
									toggle: true,
									backdrop: 'static',
									keyboard: false
								});
							}
						}, function (err) {
							//alert(err);
							//filePicker.value = "";
							$('#modal-left-rail-options').modal('hide');
							$scope.msgTitle = "Error loading recode file";
							$scope.msgText = err.message;
							$scope.$apply();
							$('#modal-options-msg').modal({
								toggle: true,
								backdrop: 'static',
								keyboard: false
							});
						});
					}
				}


				function getRecodes() {
					var recodeObjs = [];
					for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
						var topic = $rootScope.dimensionProperties.apiDimTopics[x];
						for (var y = 0; y < topic.dimensionGroups.length; y++) {
							var grp = topic.dimensionGroups[y];
							for (var z = 0; z < grp.dimensions.length; z++) {
								if (grp.dimensions[z].recodes) {
									var dimProp = grp.dimensions[z];
									var dim = {};
									dim.shortName = dimProp.shortName;
									dim.type = "recode";
									dim.recodes = [];
									for (var b = 0; b < dimProp.recodes.length; b++) {
										var recode = {};
										recode.shortName = dimProp.recodes[b].shortName;
										recode.recodeName = dimProp.recodes[b].recodeName;
										recode.title = dimProp.recodes[b].title;
										recode.type = dimProp.recodes[b].type;
										recode.categories = [];
										for (var c = 0; c < dimProp.recodes[b].categories.length; c++) {
											var recodeValue = {};
											recodeValue.qText = dimProp.recodes[b].categories[c].qText;
											recodeValue.type = dimProp.recodes[b].categories[c].type;
											var cat = dimProp.recodes[b].categories[c];
											recodeValue.values = [];
											for (var d = 0; d < cat.values.length; d++) {
												var value = {}
												value.qText = cat.values[d].qText;
												recodeValue.values.push(value);
											}
											if (dimProp.recodes[b].categories[c].dropDowns && dimProp.recodes[b].categories[c].dropDowns.length > 0) {
												recodeValue.dropDowns = dimProp.recodes[b].categories[c].dropDowns;
											}
											recode.categories.push(recodeValue);
										}
										dim.recodes.push(recode);
									}
									recodeObjs.push(dim);
								} else if (grp.dimensions[z].hierarchyAvailable == 'Y') {

									if (grp.dimensions[z].recodeTrees != null) {
										var trees = grp.dimensions[z].recodeTrees;
										if (trees.length > 0) {
											var recode = {};
											recode.shortName = grp.dimensions[z].shortName;
											recode.title = grp.dimensions[z].title;
											recode.type = "recodeTree";
											recode.recodeTrees = [];

											for (var a = 0; a < trees.length; a++) {
												//if (dims[a].recodes) {
												var t = trees[a];
												var tree = {};
												tree.treeName = t.treeName;
												tree.type = t.type;
												tree.dimensions = [];

												for (var b = 0; b < t.dimensions.length; b++) {
													var dim = {};
													dim.shortName = t.dimensions[b].shortName;
													dim.title = t.dimensions[b].title;
													//dim."def": "fieldBroad"
													dim.type = t.dimensions[b].type;
													if (dim.type == "recode") {
														dim.recodeName = t.dimensions[b].recodeName;
														dim.categories = [];
														var cats = t.dimensions[b].categories;
														for (var c = 0; c < cats.length; c++) {
															var cat = {};
															cat.qText = cats[c].qText;
															cat.type = cats[c].type;
															cat.values = [];
															for (var d = 0; d < cats[c].values.length; d++) {
																var value = {}
																value.qText = cats[c].values[d].qText;
																cat.values.push(value);
															}
															dim.categories.push(cat);
														}
													}
													tree.dimensions.push(dim);
												}
												recode.recodeTrees.push(tree);

												//}
											}

											if (grp.dimensions[z].recodedSrcDims != null) {
												var recodedSrcDims = [];
												for (var a = 0; a < grp.dimensions[z].recodedSrcDims.length; a++) {
													var dim = {};
													dim.shortName = grp.dimensions[z].recodedSrcDims[a].shortName;
													dim.title = grp.dimensions[z].recodedSrcDims[a].title;
													dim.type = grp.dimensions[z].recodedSrcDims[a].type;
													if (grp.dimensions[z].recodedSrcDims[a].recodes != null) {
														dim.recodes = [];
														for (var b = 0; b < grp.dimensions[z].recodedSrcDims[a].recodes.length; b++) {
															var src = grp.dimensions[z].recodedSrcDims[a].recodes[b];
															var catRecode = {};
															catRecode.shortName = src.shortName;
															catRecode.recodeName = src.recodeName;
															catRecode.type = src.type;
															catRecode.title = src.title;
															catRecode.categories = [];
															if (src.categories != null) {
																for (var c = 0; c < src.categories.length; c++) {
																	var cat = {};
																	cat.qText = src.categories[c].qText;
																	cat.qElemNumber = src.categories[c].qElemNumber;
																	cat.values = [];
																	for (var d = 0; d < src.categories[c].values.length; d++) {
																		var value = {}
																		value.qText = src.categories[c].values[d].qText;
																		cat.values.push(value);
																	}
																	catRecode.categories.push(cat);
																}
															}
															dim.recodes.push(catRecode);
														}
													}
													recodedSrcDims.push(dim);
												}
												recode.recodedSrcDims = recodedSrcDims;
											}
											recodeObjs.push(recode);
										}
									}
								}
							};
						};
					};
					return recodeObjs;
				}
			}
		])
});

'use strict'
define('scripts/directives/leftRailRecodesDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/measures", "scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, recodes) {

	angular.module("appModule").directive("dtLeftRailRecodes", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtLeftRailRecodes.html',
			scope: true,
			controller: 'LeftRailRecodesController'
		};
	});

	angular.module("appModule").controller("LeftRailRecodesController", ["$scope", "$rootScope",
			function ($scope, $rootScope) {
				//var qApp = $rootScope.qApp;
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				
				$rootScope.recodeAction = {
					AddRecode: 'addRecode',
					EditRecode: 'editeRecode',
					AddCategory: 'addCat',
					EditCategory: 'editCat',
					NoAction: 'noAction'
				}
				
				$rootScope.eventSrc = {
					DimRailPage: 'dimRail',
					LeftRailPage: 'leftRail',
					EditRecodePage: 'editRecode',
					EditTreePage: 'editTree',
					SelectDimensionPage: 'selectDim',
					FinishedCreatePage: 'finished'
				}	
				
				$rootScope.startingPoint;
							
				$scope.$on('rebuildRecodesListEvent', function (e) {
					recodesRebuildList();
				});	

				function recodesRebuildList() {
					$scope.recodesList = [];
					$scope.selectedRecodeCnt = 0;
					let recodes = [];
					for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
						var topic = $rootScope.dimensionProperties.apiDimTopics[x];
						
						for (var y = 0; y < topic.dimensionGroups.length; y++) {
							var grp = topic.dimensionGroups[y];
							for (var z = 0; z < grp.dimensions.length; z++) {
								if (grp.dimensions[z].recodes) {
									for (var a = 0; a < grp.dimensions[z].recodes.length; a++) {
										//let item = JSON.parse(JSON.stringify(grp.dimensions[z].recodes[a]));
										let item = grp.dimensions[z].recodes[a];

										// if(grp.dimensions[z].selected) {
										// 	item.disabled = true;
										// }
										//  else {
										// 	item.disabled = false;
										// }
										recodes.push(item);
										if (item.selected) {
											$scope.selectedRecodeCnt += 1;
										}
									}
								}
								else if (grp.dimensions[z].hierarchyAvailable == "Y") {
									let dim = grp.dimensions[z]; 
									let recodeTrees = grp.dimensions[z].recodeTrees;

									if(recodeTrees != null) {
										for (var a = 0; a < recodeTrees.length; a++) {
											//let item = JSON.parse(JSON.stringify(tmpTrees[z]));
											let item = recodeTrees[a];
											item.disabled = false;
											if(dim.selected) {
												item.disabled = true;
											} else if(item.selected != true){
												recodeTrees.forEach((v, x) => {
													if(x != a && v.selected)
														item.disabled = true
												});
												let sharedTrees = grp.dimensions[z].commonRecodeTrees;				
												if(sharedTrees != null) {
													sharedTrees.forEach((v, x) => {
														if(x != a && v.selected)
															item.disabled = true
													});
												}
											}
											//item.disabled = false;
											//check if parent has exclussion rules
											if(dim.exclusions != null) {
												for(let x = 0; x < dim.exclusions.length; x++) {
													let excludedDim = dimensions.getDimensionByTitle($rootScope, dim.exclusions[x]);
													if(excludedDim.selected) {
														item.disabled = true;
													} else {
														if(excludedDim.recodeTrees != null) {
															for(let y = 0; y < excludedDim.recodeTrees.length; y++) {
																if(excludedDim.recodeTrees[y].selected) {
																	item.disabled = true;
																}
															}
														}
														if(excludedDim.commonRecodeTrees != null) {
															for(let y = 0; y < excludedDim.commonRecodeTrees.length; y++) {
																if(excludedDim.commonRecodeTrees[y].selected) {
																	item.disabled = true;
																}
															}
														}
													}
												}
											}
											recodes.push(item);
											if (item.selected) {
												$scope.selectedRecodeCnt += 1;
											}
										}
									}

									let sharedTrees = grp.dimensions[z].commonRecodeTrees;				
									if(sharedTrees != null) {
										for (var a = 0; a < sharedTrees.length; a++) {
											//let item = JSON.parse(JSON.stringify(tmpTrees[z]));
											let item = sharedTrees[a];
											if(dim.selected) {
												item.disabled = true;
											} else if(item.selected){
												dim.disabled = true;
												item.dimCid = dim.cId;
												sharedTrees.forEach((v, x) => {
													if(x != a && v.selected)
														item.disabled = true
												});
											}		
											//item.disabled = false;
											//check if parent has exclussion rules
											if(dim.exclusions != null) {
												for(let x = 0; x < dim.exclusions.length; x++) {
													let excludedDim = dimensions.getDimensionByTitle($rootScope, dim.exclusions[x]);
													if(excludedDim.selected) {
														item.disabled = true;;
													} else {
														if(excludedDim.recodeTrees != null) {
															for(let y = 0; y < excludedDim.recodeTrees.length; y++) {
																if(excludedDim.recodeTrees[y].selected) {
																	item.disabled = true;
																}
															}
														}
														if(excludedDim.commonRecodeTrees != null) {
															for(let y = 0; y < excludedDim.commonRecodeTrees.length; y++) {
																if(excludedDim.commonRecodeTrees[y].selected) {
																	item.disabled = true;
																}
															}
														}
													}
												}
											}
											// recodes.push(item);
											// if (item.selected) {
											// 	$scope.selectedRecodeCnt += 1;
											// }											
										}
									}
								}
							}
						};
					};
					const uniqueObjects = Array.from(new Map(recodes.map(item => [JSON.stringify(item), item])).values());
					uniqueObjects.sort((a, b) => {
						if ( a.recodeName.toLowerCase() < b.recodeName.toLowerCase()  ){
							return -1;
						}
						if ( a.recodeName.toLowerCase() > b.recodeName.toLowerCase()  ){
							return 1;
						}
						return 0;
					})
					$scope.recodesList = uniqueObjects;
				};
				
				$scope.btnLeftRailOpenApplyRecode = function (recode) {
					let dim = dimensions.getDimensionByCid($rootScope, recode.dimCid);
					$rootScope.startingPoint = "init_recode_from_main_left_rail";
					if(recode.type == "recodeTree") {
						$rootScope.$broadcast('showRecodeTreeFilterPopupEvent', dim, recode); 
					} else if(recode.shortName == "instName") {
						$rootScope.$broadcast('showRecodeInstFilterPopupEvent', dim, recode); 
					} else {
						$rootScope.$broadcast('showRecodeFilterPopupEvent', dim, recode); 
					}
					
				}

				$scope.btnLeftRailEditRecode = function (recode) {
					$rootScope.startingPoint = "init_recode_from_main_left_rail";
					if(recode.type == "recodeTree") {
						let rootDim = dimensions.getDimensionByCid($rootScope, recode.dimCid);
						$rootScope.$broadcast('openRecodeEditTreeEvent',  $rootScope.recodeAction.EditRecode, $rootScope.eventSrc.LeftRailPage, rootDim, recode); 
					} else {
						let dim = dimensions.getDimensionByCid($rootScope, recode.dimCid)
						$rootScope.$broadcast('openRecodeEditEvent', $rootScope.recodeAction.EditRecode, $rootScope.eventSrc.LeftRailPage, dim, recode); 
					}
				}

				$scope.btnLeftRailAddRecode = function () {
					$rootScope.startingPoint = "init_recode_from_main_left_rail";				
					$scope.$emit('openRecodeSelectDimEvent');
					$scope.closeLeftRail();
				}

				$scope.clickRecodeHelp = function () {
					gtag('event', $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-' + 'Recode Knowledgebase', { 'event_label': 'link', 'event_category': 'knowledgebase'});
					let url = webProperties.props.kbUrl + "?id=kb_article&sysparm_article=KB0011389&in_context=true";
					window.open(url, "_blank");
				}				
			}
		])
});

'use strict'
define('scripts/directives/recodeSelectDimDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, dimensions, recodes) {

	angular.module("appModule").directive("dtRecodeSelectDim", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeSelectDim.html',
			scope: true,
			controller: 'RecodeSelectDimController'
		}
	});

	/********** Notes:
	json structure showing recodes
	dim.recodes: array of recodes defined for the dimension
	dim.recodes[x].recode: object that contains a dimension recode definition
	dim.recodes[x].recode.categories: array of value categories that are part of a dimension recode
	dim.recodes[x].recode.categories[x].value: object that defines a value category
	dim.recodes[x].recode.nonRecodeValues: array of dimension values that are not part of a category

	 ********/
	angular.module("appModule").controller("RecodeSelectDimController", ["$scope", "$rootScope", "$timeout",
			function ($scope, $rootScope, $timeout) {
				$scope.selectedDimBtn;
				let dimGrp = null;

				$rootScope.$on('openRecodeSelectDimEvent', function() {
					$scope.selectedTopicName = "Select a dimension"
					$scope.dimGrps = [];
					$scope.recode = null;
					$scope.category = null;
					$scope.selectedDimBtn = null;
					$scope.topicList = $rootScope.dimensionProperties.apiDimTopics;

					//$scope.topicList = [];
					for(let i = 0; i < $scope.topicList.length; i++)
					{
						for(let j = 0; j < $scope.topicList[i].dimensionGroups.length; j++)
						{
							for(let k = 0; k < $scope.topicList[i].dimensionGroups[j].dimensions.length; k++)
								{
									if($scope.topicList[i].dimensionGroups[j].dimensions[k].hierarchyAvailable == null ||
										$scope.topicList[i].dimensionGroups[j].dimensions[k].hierarchyAvailable == 'N') {
										$scope.topicList[i].allowRecoding = true;
										$scope.topicList[i].dimensionGroups[j].allowRecoding = true;
										$scope.topicList[i].dimensionGroups[j].dimensions[k].allowRecoding = true;
									}
								}	
						}
					}
					$("#recodeSelectDim").show();
				})

				$rootScope.$on('reopenRecodeSelectDimEvent', function() {
					$("#recodeSelectDim").show();
				})				

				$scope.btnNextClick = function () {
					if( $scope.dimension.hierarchyAvailable == 'Y') {
						$scope.$emit('openRecodeEditTreeEvent', $rootScope.recodeAction.AddRecode, $rootScope.eventSrc.SelectDimensionPage, $scope.dimension);
					} else if( $scope.dimension.shortName == "instName") {
						$scope.$emit('openRecodeEditInstEvent', $rootScope.recodeAction.AddRecode, $rootScope.eventSrc.SelectDimensionPage, $scope.dimension);
					} else {
						$scope.$emit('openRecodeAddEvent', $rootScope.eventSrc.SelectDimensionPage, $scope.dimension);
					}
					$("#recodeSelectDim").hide();
				}

				$scope.btnCloseClick = function () {
					$("#recodeSelectDim").hide();
					//$scope.showSearchFilterText = false;
				}			

				$scope.btnRecodeSelectDimDropdown = function () {
					if ($scope.selectedDimBtn) {
						$scope.selectedDimBtn.classList.remove("active");	
						$scope.selectedDimBtn = null;
					}
				}

				$scope.btnRecodeSelectDimTopic = function (e, topic) {
					$scope.selectedTopicName = topic.topicName;
					$scope.dimGrps = topic.dimensionGroups
					if(topic.dimensionGroups.length == 1) {
						$scope.collapseState = "show";
						let dims = topic.dimensionGroups[0].dimensions.filter(g => g.hierarchyAvailable === 'N' && g.type === "dimension")
						if(dims.length == 1) {
							let dim = dims[0];
							$timeout(() => {
								let btn = document.querySelectorAll("#recodeSelectDim .collapse.show .btn-list-item")[0];
								$scope.btnRecodeSelectDimClick(dim, btn );
							}, 100)
						}
					} else {
							$scope.collapseState = "";
					}
				}

				$scope.btnRecodeSelectDimGrpClick = function(dGrp) {
					dimGrp = dGrp;
					if ($scope.selectedDimBtn) {
						$scope.selectedDimBtn.classList.remove("active");
						$scope.selectedDimBtn = null;
					}
				}

				$scope.btnRecodeSelectDimClick = function(dim, btn) {
					$scope.dimension = dim;
					if ($scope.selectedDimBtn)
						$scope.selectedDimBtn.classList.remove("active");
					$scope.selectedDimBtn = btn;
					$scope.selectedDimBtn.classList.add("active");
				}
			}
		]);
});

'use strict'
define('scripts/directives/recodeAddDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, dimensions, recodes) {

	angular.module("appModule").directive("dtRecodeAdd", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeAdd.html',
			scope: true,
			controller: 'RecodeAddController'
		}
	});

	/********** Notes:
	json structure showing recodes
	dim.recodes: array of recodes defined for the dimension
	dim.recodes[x].recode: object that contains a dimension recode definition
	dim.recodes[x].recode.categories: array of value categories that are part of a dimension recode
	dim.recodes[x].recode.categories[x].value: object that defines a value category
	dim.recodes[x].recode.nonRecodeValues: array of dimension values that are not part of a category

	 ********/
	
	angular.module("appModule").controller("RecodeAddController", ["$scope", "$rootScope",
			function ($scope, $rootScope) {
				var qApp = $rootScope.qApp;
				$scope.checkedValueCount = 0;
				$scope.recode = {};
				$scope.recode.recodeName = "";

				var allValues = [];
				var searchValues = [];
				var list = [];
				var _scrollRecodeList;
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				let source;

				var validateRecodeName = function (val) {
					for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
						var topic = $rootScope.dimensionProperties.apiDimTopics[x];						
						for (var y = 0; y < topic.dimensionGroups.length; y++) {
							var grp = topic.dimensionGroups[y];
							for (var z = 0; z < grp.dimensions.length; z++) {
								if (grp.dimensions[z].recodes) {
									for (var a = 0; a < grp.dimensions[z].recodes.length; a++) {
										let item = grp.dimensions[z].recodes[a];
										if ($scope.recode.cId == null || $scope.recode.cId != item.cId) {
											if (val.toLowerCase() == item.recodeName.toLowerCase()) {
												$scope.recodeAddForm.recodeAddName.$setValidity('noNameConflict', false);
												return;
											}
										}
									}
								}
								else if (grp.dimensions[z].hierarchyAvailable == "Y") {
									let recodeTrees = grp.dimensions[z].recodeTrees;
									if(recodeTrees != null) {
										for (var a = 0; a < recodeTrees.length; a++) {
											let item = recodeTrees[a];
											if ($scope.recode.cId == null || $scope.recode.cId != item.cId) {
												if (val.toLowerCase() == item.treeName.toLowerCase()) {
													$scope.recodeAddForm.recodeAddName.$setValidity('noNameConflict', false);
													return;
												}
											}
										}
									}

									let sharedTrees = grp.dimensions[z].commonRecodeTrees;				
									if(sharedTrees != null) {
										for (var a = 0; a < sharedTrees.length; a++) {
											let item = sharedTrees[a];
											if ($scope.recode.cId == null || $scope.recode.cId != item.cId) {
												if (val.toLowerCase() == item.treeName.toLowerCase()) {
													$scope.recodeAddForm.recodeAddName.$setValidity('noNameConflict', false);
													return;
												}
											}
										}
									}
								}
							}
						};
					};
					$scope.recodeAddForm.recodeAddName.$setValidity('noNameConflict', true);
					return val;					
				};

				var validateValueName = function (val) {
					if ($scope.recode.categories != null) {
						for (var x = 0; x < $scope.recode.categories.length; x++) {
							if ($scope.category.cId == null || $scope.category.cId != $scope.recode.categories[x].cId) {
								if (val == $scope.recode.categories[x].qText) {
									$scope.categoryAddForm.categoryAddName.$setValidity('noNameConflict', false);
									return;
								}
							}
						}
					}
					$scope.categoryAddForm.categoryAddName.$setValidity('noNameConflict', true);
					return val;
				}

				$rootScope.$on('openRecodeAddEvent', function(e, src, dim) {
					source = src;
					$("#recodeAdd").show();

					//$rootScope.startingPoint = source == $rootScope.eventSr.DimRailPage?" - Start from dim slideout":" - Start from left rail" 
					//action = act;
					$scope.dimension = dim;
					$scope.dimName = $scope.dimension.title;

					$scope.catEditMode = null;
					$scope.valuesAll = false;
					$scope.recode = {};

					$scope.recode.shortName = $scope.dimension.shortName;
					$scope.recode.dimCid = $scope.dimension.cId;
					$scope.checkedValueCount = 0;
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Open recode wizard', {
						'event_label': $rootScope.startingPoint,
						'event_category': 'recode_open_add',
						'event_variables': dim.shortName
					})
					showCategorySection().then(function() {
						$scope.recode.categories =  [];
						$scope.recodeAddForm.recodeAddName.$parsers = [];
						$scope.recodeAddForm.recodeAddName.$parsers.push(validateRecodeName);
						$scope.categoryAddForm.categoryAddName.$parsers = [];
						$scope.categoryAddForm.categoryAddName.$parsers.push(validateValueName);

						$scope.recodeAddForm.$setPristine();
						$scope.categoryAddForm.$setPristine();
						$scope.recodeAddForm.recodeAddName.$setPristine();
						$scope.categoryAddForm.categoryAddName.$setPristine();	
					});	
				})

				$scope.chkBoxAddCategoryAllValues = function () {
					$scope.checkedValueCount = 0;
					for (var x = 0; x < list.length; x++) {
						if($scope.valuesAll) {
							list[x].selected = true;
							$scope.checkedValueCount++;
						} else {
							list[x].selected = false;
						}
					}
				}

				$scope.chkBoxAddCategoryValue = function (value) {
					if(value.selected == false)
						$scope.valuesAll = false;

					$scope.checkedValueCount = 0;
					for (var x = 0; x < $scope.availValues.length; x++) {
						// if($scope.valuesAll)
						// 	$scope.availValues[x].selected = true;
						if ($scope.availValues[x].selected)
							$scope.checkedValueCount++;
					}
				}				

				$scope.btnRecodeAddCloseClick = function () {
					$scope.recode.recodeName = null;
					$scope.category.qText = null;
					$("#recodeAdd").hide();
				}

				$scope.btnBack = function () {
					$scope.recode.recodeName = null;
					$scope.category.qText = null;		
					if(source == $rootScope.eventSrc.EditTreePage) {
						$scope.$emit('refreshRecodeEditTreeEvent');
					} else if(source == $rootScope.eventSrc.SelectDimensionPage) {
						$scope.$emit('reopenRecodeSelectDimEvent');
					}
					$("#recodeAdd").hide();
				}

				$scope.btnNext = function () {

					gtag('event', displayType + $rootScope.survey.abbreviation + '-Create recode', {
						'event_label': $rootScope.startingPoint,
						'event_category': 'recode_create',
						'event_variables': $scope.dimension.shortName
					});
					saveCategory();
					saveRecode();
					$scope.$emit('openRecodeFinishedEvent', $rootScope.recodeAction.AddRecode, $scope.dimension, $scope.recode);
					$("#recodeAdd").hide();
				}

 				function saveRecode() {

					//$scope.recodeAddForm.recodeAddName.$setValidity('nameConflict', true);
					$scope.recode.cId = 'recode' + appUtilities.randomCid();
					$scope.recode.shortName = $scope.dimension.shortName;
					$scope.recode.variableId = $scope.dimension.variableId;
					//Recodes need Associations to complete add/upd/del processing
					$scope.recode.associations = $scope.dimension.associations;
					$scope.recode.qId = $scope.dimension.qId;  //needed by export ecache service
					$scope.recode.title = $scope.dimension.title; //$scope.recode.recodeName; 
					$scope.recode.type = "recode";
					$scope.recode.disabled = $scope.dimension.disabled;
					$scope.recode.nonRecodeValues = [];
					$scope.dimension.recodes = $scope.dimension.recodes || [];
					$scope.dimension.recodes.push($scope.recode);

					$rootScope.$broadcast('rebuildRecodesListEvent');
				}

				function saveCategory() {

					if ($scope.category.cId == null) {
						$scope.category.cId = appUtilities.randomCid();
						$scope.category.type = "recode";
						$scope.recode.categories = $scope.recode.categories || [];
						$scope.recode.categories.push($scope.category);
					} 
					$scope.category.values = getSelectedValues();

					if ($scope.category.values.length + getDisabledValues().length == allValues.length) {
						$scope.disableNewCategories = true;
					}

					$scope.catEditMode = null;
				}

				$scope.inputAddSearchTextChange = function (evt) {
					var textChange = function () {
						//if user clears all characters, re-build list with no search criteria
						searchValues = [];
						if ($scope.searchRecodeText.length == 0) {
							$('#recodeAddViewport').scrollTop(0);
							$scope.availValues = [];
							pageRecodeList();
							//setFilterButtons();
							$scope.$apply();
						} else if ($scope.searchRecodeText.length > 2) {
							//get search results if user hase entered 3 or more characters
							$('#recodeAddViewport').scrollTop(0);
							$scope.availValues = [];
							//var tmp = [];

							var tmpDim = {};
							tmpDim.shortName = $scope.dimension.shortName;
							tmpDim.valueSortDefault = $scope.dimension.valueSortDefault;
							renderList(tmpDim).then(function (list) {
								//populate availValues with search results for those values that have not been marked as selected
								//Also populate searchVales to hold results so it can be used for paging if needed
								//Using the main allValues as the source for both AvailVals and searchVals
								//since selectedVals shares array element references with allValues.
								for (var x = 0; x < list.length; x++) {
									for (var y = 0; y < allValues.length; y++) {
										if (list[x].qText == allValues[y].qText) {
											searchValues.push(allValues[y]);
											break;
										}
									}
								}
								pageRecodeList();
								//setFilterButtons();
								return;
							});
						}
						return;
					}
					_.debounce(textChange, 300, false)();
				};

				function getSelectedValues() {
					var values = [];
					allValues.forEach(function (item) {
						if (item.selected) {
							values.push(item);

						}
					});
					return values;
				}

				function getDisabledValues() {
					var values = [];
					allValues.forEach(function (item) {
						if (item.disabled) {
							values.push(item);

						}
					});
					return values;
				}

				function disableUnavailableValues(currentCat) {
					var allCategories = $scope.recode.categories;
					if (allCategories != null) {
						for (var x = 0; x < allCategories.length; x++) {
							if (currentCat.cId == null ||
								currentCat.cId !== allCategories[x].cId) {
								var otherRecodeValues = allCategories[x].values;
								for (var y = 0; y < otherRecodeValues.length; y++) {
									for (var z = 0; z < allValues.length; z++) {
										if (otherRecodeValues[y].qText == allValues[z].qText) {
											allValues[z].disabled = true;
										}
									}
								}
							}
						}
					}
				}

				function scrollRecodeList() {
					$('#recodeAddViewport').off('scroll', _scrollRecodeList);
					$scope.availValues = [];
					pageRecodeList();
					$('#recodeAddViewport').on('scroll', _scrollRecodeList);
					$scope.$apply();
				}

				function showCategorySection() {
					return new qlik.Promise(function (resolve, reject) {
						$scope.checkedValueCount = 0;
						$scope.searchRecodeText = "";
						$scope.availValues = [];
						allValues = [];
						searchValues = [];

						//$scope.categcategoryAddFormoryForm.categoryName.$setPristine();

						//$("#recodeFormList").collapse('hide');
						//$("#categoryDiv").collapse('show');

						$scope.category =  {};
						var tmpDim = {};
						tmpDim.shortName = $scope.dimension.shortName;
						tmpDim.valueSortDefault = $scope.dimension.valueSortDefault;

						_scrollRecodeList = _.debounce(scrollRecodeList, 100, false);
						$('#recodeAddViewport').off('scroll', _scrollRecodeList).on('scroll', _scrollRecodeList);

						renderList(tmpDim).then(function (list) {
							allValues = list;
							$scope.recode.listCount = list.length;
					
							if ($scope.category.values != null) {
								for (var y = 0; y < $scope.category.values.length; y++) {
									for (var z = 0; z < allValues.length; z++) {
										if ($scope.category.values[y].qText == allValues[z].qText) {
											$scope.category.values[y].qElemNumber = allValues[z].qElemNumber;
											allValues[z].selected = true;
											$scope.checkedValueCount++;
										}
									}
								}
							}
							disableUnavailableValues($scope.category);
							pageRecodeList();
							return resolve();
						});
					});
				}

				function renderList(tmpDim) {
					return new qlik.Promise(function (resolve, reject) {
						var list = [];
						dimensions.getValuesByDimension(qApp, tmpDim, $scope.searchRecodeText, null, 0).then(function (values) {
							values.forEach(function (e) {
								if (e.qState == "O" || e.qState == "S" || e.qState == "A") {
									list.push(e);
								}
							});
							values.forEach(function (e) {
								if (e.qState == "X" || e.qState == "XS") {
									list.push(e);
								}
							});
							return resolve(list);
						});

					})
				};

				function pageRecodeList() {
					var recodeViewport = $('#recodeAddViewport');
					var recodeListContent = $('#recodeAddListContent');
					var recodeListVisNodes = $('#recodeAddListVisNodes');
					var itemCount;
					var rowHeight = 40;
					var nodePadding = 2;

					//var list = [];
					if (searchValues.length > 0) {
						list = searchValues;
					} else {
						list = allValues;
					}

					itemCount = list.length;

					var totalContentHeight = (itemCount * rowHeight) + 'px';
					recodeListContent.height(totalContentHeight);
					var scrollTop = recodeViewport.scrollTop();

					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(recodeViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					$scope.availValues = [];
					for (var x = startNode; x < list.length; x++) {
						$scope.availValues.push(list[x]);
						if ($scope.availValues.length == visibleNodesCount) {
							break;
						}
					}
					recodeListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}
			}
		]);
});

'use strict'
define('scripts/directives/recodeEditInstDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, dimensions, recodes) {

	angular.module("appModule").directive("dtRecodeEditInst", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeEditInst.html',
			scope: true,
			controller: 'RecodeEditInstController'
		}
	});

	/********** Notes:
	json structure showing recodes
	dim.recodes: array of recodes defined for the dimension
	dim.recodes[x].recode: object that contains a dimension recode definition
	dim.recodes[x].recode.categories: array of value categories that are part of a dimension recode
	dim.recodes[x].recode.categories[x].value: object that defines a value category
	dim.recodes[x].recode.nonRecodeValues: array of dimension values that are not part of a category

	 ********/
	angular.module("appModule").controller("RecodeEditInstController", ["$scope", "$rootScope",
			function ($scope, $rootScope) {
				var qApp = $rootScope.qApp;
				$scope.checkedValueCount = 0;
				$scope.recode = {};
				$scope.recode.recodeName = "";
				//$scope.disableNewCategories = false;

				//var initRecode = {};
				//var dim;
				let initCat;
				let source;
				var allValues = [];
				var searchValues = [];
				var list = [];
				var _scrollRecodeList;
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				$scope.filterListExpanded = false;
				//$scope.selAltState = qApp.selectionState('altState1');
				//Listener is invoked each time a sub-filter drop-down selection is made
				//Its purpose is to update the availInstList with the latest filtering changes as a result of a user applying a sub-filter
				var filterRecodeListener = function () {

					var modal = document.querySelector("#recodeEditInst");
					if (modal && modal.style.display == "block") {
						//logic for looping promise calls; need to re-build each list with excluded items
						//after user has made a selection from one of the drop-down list

						renderList($scope.dimension).then(function (list) {

							allValues = list;
							$scope.recode.listCount = list.length;
							if ($scope.category.values != null) {
								for (var y = 0; y < $scope.category.values.length; y++) {
									for (var z = 0; z < allValues.length; z++) {
										if ($scope.category.values[y].qElemNumber == allValues[z].qElemNumber) {
											allValues[z].selected = true;
											$scope.checkedValueCount++;
										}
									}
								}
							}
							disableUnavailableValues($scope.category);
							pageRecodeList();
						});
						return;
					}
				};

				var validateRecodeName = function (val) {
					if ($scope.dimension.recodes != null) {
						for (var x = 0; x < $scope.dimension.recodes.length; x++) {
							if ($scope.recode.cId == null || $scope.recode.cId != $scope.dimension.recodes[x].cId) {
								if (val == $scope.dimension.recodes[x].recodeName) {
									$scope.recodeEditInstForm.recodeEditName.$setValidity('noNameConflict', false);
									return;
								}
							}
						}
					}
					$scope.recodeEditInstForm.recodeEditName.$setValidity('noNameConflict', true);
					return val;
				}

				var validateValueName = function (val) {
					if ($scope.recode.categories != null) {
						for (var x = 0; x < $scope.recode.categories.length; x++) {
							if ($scope.category.cId == null || $scope.category.cId != $scope.recode.categories[x].cId) {
								if (val == $scope.recode.categories[x].qText) {
									$scope.categoryEditInstForm.categoryEditName.$setValidity('noNameConflict', false);
									return;
								}
							}
						}
					}
					$scope.categoryEditInstForm.categoryEditName.$setValidity('noNameConflict', true);
					return val;
				}
				
				$rootScope.$on('openRecodeEditInstEvent', function(e, action, src,  dim, recode, cat) {
					source = src;
					$scope.action = action;

					$("#recodeEditInst").show();
					if(action == $rootScope.recodeAction.AddRecode) {
						gtag('event', displayType + $rootScope.survey.abbreviation + '-Edit recode', {
							'event_label': $rootScope.startingPoint,
							'event_category': 'recode_open_add',
							'event_variables': dim.shortName
						})
					}			
					if(action == $rootScope.recodeAction.AddRecode) {
						$scope.title = "Create Custom Dimension"
					} else if(action == $rootScope.recodeAction.AddCategory) {
						$scope.title = "Add Group"
					} else if(action == $rootScope.recodeAction.EditCategory) {
						$scope.title = "Edit Group"
					}
					$scope.dimension = dim;
					$scope.dimName = $scope.dimension.title;

					$scope.catEditMode = null;
					$scope.setAllValues = false;
					$scope.recodeDropdownControl = [];
					$scope.recodeDimDropDowns = [];				
					//initRecode = recode || {};
					//$scope.recode = JSON.parse(JSON.stringify(initRecode));
					if(action == $rootScope.recodeAction.AddRecode) {
						$scope.recode = {};
						$scope.recode.shortName = $scope.dimension.shortName;
						$scope.recode.dimCid = $scope.dimension.cId;
						$scope.recode.categories =  [];
						$scope.category = {}
					} else {
						$scope.recode = recode;
						if(action == $rootScope.recodeAction.AddCategory) {
							$scope.category = {}
						} else if(action == $rootScope.recodeAction.EditCategory) {
							initCat = cat;
							$scope.category = JSON.parse(JSON.stringify(cat))
						}
					}

					$scope.checkedValueCount = 0;
					$scope.recodeDimDropDowns = dim.subFilters;
					showCategorySection().then(function() {
						$scope.recodeEditInstForm.recodeEditName.$parsers = [];
						$scope.recodeEditInstForm.recodeEditName.$parsers.push(validateRecodeName);

						$scope.categoryEditInstForm.categoryEditName.$parsers = [];
						$scope.categoryEditInstForm.categoryEditName.$parsers.push(validateValueName);
						$scope.recodeEditInstForm.$setPristine();
						$scope.categoryEditInstForm.$setPristine();
						$scope.recodeEditInstForm.recodeEditName.$setPristine();
						$scope.categoryEditInstForm.categoryEditName.$setPristine();
					})
				})

				$scope.btnClose = function () {
					if(source == $rootScope.eventSrc.SelectDimensionPage) {
						$scope.$emit('reopenRecodeSelectDimEvent');
					} else if(source == $rootScope.eventSrc.FinishedCreatePage) {
						$rootScope.$emit('refreshRecodeFinishedEvent', $rootScope.recodeAction.NoAction);
					} else if(source == $rootScope.eventSrc.EditRecodePage) {
						$scope.$emit('reopenRecodeEditEvent');
					}
					closeDialog();
				}

				function closeDialog() {
					$scope.selAltState.OnData.unbind(filterRecodeListener);
					$("#recodeEditInst").hide();
					//$scope.showSearchFilterText = false;
				}				


				$scope.toggleFilterListExpanded = function () {
					$scope.filterListExpanded = !$scope.filterListExpanded;
				}

				$scope.chkBoxEditCategoryAllValues = function() {
					$scope.checkedValueCount = 0;
					for (var x = 0; x < list.length; x++) {
						if($scope.setAllValues && (list[x].disabled == null || list[x].disabled == false)) {
							list[x].selected = true;
							$scope.checkedValueCount++;
						} else {
							list[x].selected = false;
						}
					}
				}

				$scope.chkBoxEditCategoryValue = function (val) {
					if(val.selected == false)
						$scope.setAllValues = false;
					
					$scope.checkedValueCount = 0;
					for (var x = 0; x < $scope.availValues.length; x++) {
						if ($scope.availValues[x].selected)
							$scope.checkedValueCount++;
					}
				}				

				$scope.btnNextClick = function () {
					editSaveCategory();
					editSaveRecode();
					//google analytics tracking

					gtag('event', displayType + $rootScope.survey.abbreviation + '-Create recode', {
						'event_label': $rootScope.startingPoint,
						'event_category': 'recode_create',
						'event_variables': $scope.dimension.shortName
					});									
					$scope.$emit('openRecodeFinishedEvent', $rootScope.recodeAction.AddRecode, $scope.dimension, $scope.recode);
					closeDialog();
				}

				$scope.btnAddCatClick = function () {
					editSaveCategory();
					//$scope.$emit('openRecodeFinishedEvent', $rootScope.recodeAction.AddCategory, $scope.dimension, $scope.recode);
					if(source == $rootScope.eventSrc.SelectDimensionPage) {
						$scope.$emit('reopenRecodeSelectDimEvent');
					} else if(source == $rootScope.eventSrc.FinishedCreatePage) {
						$rootScope.$emit('refreshRecodeFinishedEvent', $scope.action, $scope.recode.categories, $scope.category);
					} else if(source == $rootScope.eventSrc.EditRecodePage) {
						$scope.$emit('refreshRecodeEditEvent', $scope.action, $scope.category, $scope.recode.categories);
					}
					closeDialog();
				}

				$scope.btnSaveClick = function () {
					editSaveCategory();

					//$scope.$emit('openRecodeFinishedEvent', $rootScope.recodeAction.EditCategory, $scope.dimension, $scope.recode);
					if(source == $rootScope.eventSrc.SelectDimensionPage) {
						$scope.$emit('reopenRecodeSelectDimEvent');
					} else if(source == $rootScope.eventSrc.FinishedCreatePage) {
						$rootScope.$emit('refreshRecodeFinishedEvent', $scope.action, $scope.recode.categories, $scope.category);
					} else if(source == $rootScope.eventSrc.EditRecodePage) {
						$scope.$emit('refreshRecodeEditEvent', $scope.action, $scope.category, $scope.recode.categories);
					}

					closeDialog();
				}

 				let editSaveRecode = function () {
					
					//$scope.recodeEditForm.recodeEditName.$setValidity('nameConflict', true);
					$scope.recode.cId = 'recode' + appUtilities.randomCid();
					$scope.recode.shortName = $scope.dimension.shortName;
					$scope.recode.variableId = $scope.dimension.variableId;
					//Recodes need Associations to complete add/upd/del processing
					$scope.recode.associations = $scope.dimension.associations;
					$scope.recode.qId = $scope.dimension.qId;  //needed by export ecache service
					$scope.recode.title = $scope.dimension.title; //$scope.recode.recodeName; 
					$scope.recode.type = "recode";
					$scope.recode.nonRecodeValues = [];
					$scope.dimension.recodes = $scope.dimension.recodes || [];
					$scope.dimension.recodes.push($scope.recode);

					// $scope.btnFilterCloseClick();
					// $scope.btnInstCloseClick();
					// $scope.closeLeftRail();;
					// $scope.btnFilterTreeCloseClick();
					$rootScope.$broadcast('rebuildRecodesListEvent');
				}

				let editSaveCategory = function () {

					if ($scope.category.cId == null) {
						$scope.category.cId = appUtilities.randomCid();
						$scope.category.type = "recode";
						$scope.recode.categories = $scope.recode.categories || [];
						$scope.category.values = getSelectedValues();
						$scope.recode.categories.push($scope.category);
					} else {
						$scope.recode.categories.forEach(c => {
							if($scope.category.cId == c.cId) {
								c.qText = $scope.category.qText;
								c.values = getSelectedValues();
							}
						})
					}
					$scope.category.dropdownControl = JSON.parse(JSON.stringify($scope.recodeDropdownControl));
					$scope.recodeDropdownControl.forEach(function(val) {
						if(val.savedValues)
							delete val.savedValues;
					});

					if ($scope.category.values.length + getDisabledValues().length == allValues.length) {
						$scope.disableNewCategories = true;
					}

					$scope.catEditMode = null;
					$scope.selAltState.OnData.unbind(filterRecodeListener);
				}

				$scope.inputEditSearchTextChange = function (evt) {
					var textChange = function () {
						//if user clears all characters, re-build list with no search criteria
						searchValues = [];
						if ($scope.searchRecodeText.length == 0) {
							$('#recodeEditInstViewport').scrollTop(0);
							$scope.availValues = [];
							pageRecodeList();
							$scope.$apply();
						} else if ($scope.searchRecodeText.length > 1) {
							//get search results if user hase entered 2 or more characters
							$('#recodeEditInstViewport').scrollTop(0);
							$scope.availValues = [];
							//var tmp = [];
							var tmpDim = {};
							tmpDim.shortName = $scope.recode.shortName;
							renderList(tmpDim).then(function (list) {
								//populate availValues with search results for those values that have not been marked as selected
								//Also populate searchVales to hold results so it can be used for paging if needed
								//Using the main allValues as the source for both AvailVals and searchVals
								//since selectedVals shares array element references with allValues.
								for (var x = 0; x < list.length; x++) {
									for (var y = 0; y < allValues.length; y++) {
										if (list[x].qText == allValues[y].qText) {
											searchValues.push(allValues[y]);
											break;
										}
									}
								}
								pageRecodeList();
								return;
							});
						}
						return;
					}
					_.debounce(textChange, 300, false)();
				};


				$scope.btnOpenMakeAvail = function (value) {
					$scope.selectedValue = value;
					if($scope.hideMakeAvailConfirm) {
						applyMakeAvail();
					} else {
						$("#recodeEditInst").hide();
						$("#makeAvailCatInst").show();
					}
				}

				$scope.btnMakeAvailClose = function () {
					$scope.hideMakeAvailConfirm = false;
					$("#makeAvailCatInst").hide();
					$("#recodeEditInst").show();	
				}

				$scope.btnApplyMakeAvail = function () {
					applyMakeAvail();
					$("#makeAvailCatInst").hide();
					$("#recodeEditInst").show();	
				}

				function applyMakeAvail() {
					let value = allValues.find(val => val.qText == $scope.selectedValue.qText);
					if(value != null) {
						value.selected = false;
						value.disabled = false;
						delete value.otherCatName;
						for(let x = 0; x < $scope.recode.categories.length; x++) {
							let i = $scope.recode.categories[x].values.findIndex(v => v.qText == value.qText);
							if(i > -1) {
								$scope.recode.categories[x].values.splice(i,1);
								break;
							}
						}
					}
				}


				$scope.toggleEditInstFilterListExpanded = function () {
					$scope.filterListExpanded = !$scope.filterListExpanded;
				}				

				$scope.getAvailInstListClass = function (value) {
					var retCls = value.qState.toLowerCase();
					return retCls;
				}

				function getSelectedValues() {
					var values = [];
					allValues.forEach(function (item) {
						if (item.selected) {
							values.push(item);

						}
					});
					return values;
				}

				function getDisabledValues() {
					var values = [];
					allValues.forEach(function (item) {
						if (item.disabled) {
							values.push(item);

						}
					});
					return values;
				}

				function disableUnavailableValues(currentCat) {
					var allCategories = $scope.recode.categories;
					if (allCategories != null) {
						for (var x = 0; x < allCategories.length; x++) {
							if (currentCat.cId == null ||
								currentCat.cId !== allCategories[x].cId) {
								var otherRecodeValues = allCategories[x].values;
								for (var y = 0; y < otherRecodeValues.length; y++) {
									for (var z = 0; z < allValues.length; z++) {
										if (otherRecodeValues[y].qText == allValues[z].qText) {
											allValues[z].disabled = true;
											allValues[z].otherCatName = allCategories[x].qText;
										}
									}
								}
							}
						}
					}
				}

				function scrollRecodeList() {
					$('#recodeEditInstViewport').off('scroll', _scrollRecodeList);
					$scope.availValues = [];
					pageRecodeList();
					$('#recodeEditInstViewport').on('scroll', _scrollRecodeList);
					$scope.$apply();
				}

				function showCategorySection() {
					return new qlik.Promise(function(resolve,reject) {
						$scope.checkedValueCount = 0;
						$scope.searchRecodeText = "";
						$scope.availValues = [];
						allValues = [];
						searchValues = [];

						//$scope.categcategoryEditFormoryForm.categoryName.$setPristine();

						//$("#recodeFormList").collapse('hide');
						//$("#categoryDiv").collapse('show');
						var tmpDim = {};
						tmpDim.shortName = $scope.recode.shortName;
						tmpDim.valueSortDefault = $scope.dimension.valueSortDefault;

						_scrollRecodeList = _.debounce(scrollRecodeList, 100, false);
						$('#recodeEditInstViewport').off('scroll', _scrollRecodeList).on('scroll', _scrollRecodeList);

						$scope.selAltState.clearAll(false).then(function () {

							renderList(tmpDim).then(function(list) {
								allValues = list;
								$scope.recode.listCount = list.length;
								if ($scope.category.values != null) {
									for (var y = 0; y < $scope.category.values.length; y++) {
										for (var z = 0; z < allValues.length; z++) {
											if ($scope.category.values[y].qText == allValues[z].qText) {
												$scope.category.values[y].qElemNumber = allValues[z].qElemNumber;
												allValues[z].selected = true;
												$scope.checkedValueCount++;
											}
										}
									}
								}
								disableUnavailableValues($scope.category);
								pageRecodeList();
								$scope.selAltState.OnData.bind(filterRecodeListener);
								return resolve();
							});
						});
					});
				}

				function renderList(tmpDim) {
					return new qlik.Promise(function (resolve, reject) {
						var list = [];
						dimensions.getValuesByDimension(qApp, tmpDim, $scope.searchRecodeText, 'altState1', 0).then(function (values) {
							values.forEach(function (e) {
								if (e.qState == "O" || e.qState == "S" || e.qState == "A") {
									list.push(e);
								}
							});
							return resolve(list);
						});

					})
				};

				function pageRecodeList() {
					var recodeViewport = $('#recodeEditInstViewport');
					var recodeListContent = $('#recodeEditInstListContent');
					var recodeListVisNodes = $('#recodeEditInstListVisNodes');
					var itemCount;
					var rowHeight = 40;
					var nodePadding = 2;

					//var list = [];
					if (searchValues.length > 0) {
						list = searchValues;
					} else {
						list = allValues;
					}

					itemCount = list.length;

					var totalContentHeight = (itemCount * rowHeight) + 'px';
					recodeListContent.height(totalContentHeight);
					var scrollTop = recodeViewport.scrollTop();

					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(recodeViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					$scope.availValues = [];
					for (var x = startNode; x < list.length; x++) {
						$scope.availValues.push(list[x]);
						if ($scope.availValues.length == visibleNodesCount) {
							break;
						}
					}
					recodeListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}
			}
		]);
});

'use strict'
define('scripts/directives/recodeFinishedDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, dimensions, recodes) {

	angular.module("appModule").directive("dtRecodeFinished", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeFinished.html',
			scope: true,
			controller: 'RecodeFinishedController'
		}
	});

	/********** Notes:
	json structure showing recodes
	dim.recodes: array of recodes defined for the dimension
	dim.recodes[x].recode: object that contains a dimension recode definition
	dim.recodes[x].recode.categories: array of value categories that are part of a dimension recode
	dim.recodes[x].recode.categories[x].value: object that defines a value category
	dim.recodes[x].recode.nonRecodeValues: array of dimension values that are not part of a category

	 ********/
	angular.module("appModule").controller("RecodeFinishedController", ["$scope", "$rootScope", '$timeout',
		function ($scope, $rootScope, $timeout) {
			let qApp = $rootScope.qApp;
			$scope.dim = null;
			let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

			//let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

			$rootScope.$on('openRecodeFinishedEvent', function(e, action, dim, recode) {

				$scope.dim = dim;
				$scope.recode = recode;
				$("#recodeFinished").show();
				switch(action) {
					case $rootScope.recodeAction.NoAction:
						$scope.title = "Custom Dimension Groups";
						return;
					case $rootScope.recodeAction.AddRecode:	
							$scope.title = "Group Successfully Created!";
							break;
					default:
						$scope.title = "Custom Dimension Groups";
				}
				if($scope.recode.categories.length > 0) {
					$timeout(() => {
						$('#' + $scope.replaceIllegalChars($scope.recode.categories[0].qText)+"_card").collapse('show');
					}, 100)					
				}
			})

			$rootScope.$on('refreshRecodeFinishedEvent', function(e, action, categories, cat) {
				$("#recodeFinished").show();
				switch(action) {
					case $rootScope.recodeAction.NoAction:
						$scope.title = "Custom Dimension Groups";
						return;
					case $rootScope.recodeAction.AddCategory:
						$scope.title = "Group Successfully Created!";
						$scope.recode.categories = categories;
						break;
					case $rootScope.recodeAction.EditCategory:
						$scope.title = "Group Successfully Updated!";
						$scope.recode.categories = categories;
						break;
					default:
						$scope.title = "Custom Dimension Groups";
				}
				
				if($scope.recode.categories.length > 0) {
					$timeout(() => {
						let i = $scope.recode.categories.findIndex(x => x.cId == cat.cId)
						$('#' + $scope.replaceIllegalChars($scope.recode.categories[i].qText)+"_card").collapse('show');
					}, 100)					
				}				
			})

			$scope.btnAddCat = function () {
				if($scope.dim.shortName == "instName"){
					$scope.$emit('openRecodeEditInstEvent', $rootScope.recodeAction.AddCategory, $rootScope.eventSrc.FinishedCreatePage, $scope.dim, $scope.recode);
				} else {
					$scope.$emit('openRecodeEditCatEvent', $rootScope.recodeAction.AddCategory, $rootScope.eventSrc.FinishedCreatePage, $scope.dim, $scope.recode);
				}
				$("#recodeFinished").hide();
			}

			$scope.btnEditCat = function (cat) {
				if($scope.dim.shortName == "instName"){
					$scope.$emit('openRecodeEditInstEvent', $rootScope.recodeAction.EditCategory, $rootScope.eventSrc.FinishedCreatePage, $scope.dim, $scope.recode, cat);
				} else {
					$scope.$emit('openRecodeEditCatEvent', $rootScope.recodeAction.EditCategory, $rootScope.eventSrc.FinishedCreatePage, $scope.dim, $scope.recode, cat);
				}
				$("#recodeFinished").hide();
			}
			
			$scope.btnRecodeDoneClick = function () {
				//$scope.$emit('rebuildRecodesListEvent');
				$("#recodeFinished").hide();
			}

			$scope.btnCloseClick = function () {
				$("#recodeFinished").hide();
			}

			$scope.btnAddToVisClick = function (type) {
				$scope.recode.selected = true;
				$scope.recode.categories.forEach(function(val) {
					val.selected = true;
				})

				$scope.toggleReadOnly(true);
				//google analytics tracking
				gtag('event', displayType + $rootScope.survey.abbreviation + '-Select recode', {
					'event_label': $rootScope.startingPoint,
					'event_category': 'recode_select',
					'event_variables': $scope.dim.shortName
				});
				hyperCubeProperties.applyRecode(qApp, $rootScope, $scope, type == "col"?true:false).then(function () {
					var values = $scope.recode.categories.concat($scope.recode.nonRecodeValues);
					$scope.recode.selectedValuesCount = getSelectedCount(values);
					$("#recodeFinished").hide();
				}, function (err) {
					appUtilities.showError(err);
				});
			}

			function getSelectedCount(arr) {
				if (arr == null)
					return 0;

				return arr.filter(function (elm) {
					return elm.selected == true;
				}).length;
			}
		}
	]);
});

'use strict'
define('scripts/directives/recodeEditCatDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, dimensions, recodes) {

	angular.module("appModule").directive("dtRecodeEditCat", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeEditCat.html',
			scope: true,
			controller: 'RecodeEditCatController'
		}
	});

	/********** Notes:
	json structure showing recodes
	dim.recodes: array of recodes defined for the dimension
	dim.recodes[x].recode: object that contains a dimension recode definition
	dim.recodes[x].recode.categories: array of value categories that are part of a dimension recode
	dim.recodes[x].recode.categories[x].value: object that defines a value category
	dim.recodes[x].recode.nonRecodeValues: array of dimension values that are not part of a category

	 ********/
	angular.module("appModule").controller("RecodeEditCatController", ["$scope", "$rootScope", 
			function ($scope, $rootScope) {
				let qApp = $rootScope.qApp;
				$scope.checkedCatEditValueCount = 0;

				let initDim;
				let tmpCat;
				let tmpRecode, initRecode;
				//let category;
				let allValues = [];
				let searchValues = [];
				let list = [];
				let _scrollRecodeList;
				let source;
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

				$scope.hideMakeAvailConfirm = false;


				var validateValueName = function (val) {
					if (tmpRecode.categories != null) {
						for (var x = 0; x < tmpRecode.categories.length; x++) {
							if (tmpCat.cId == null || tmpCat.cId != tmpRecode.categories[x].cId) {
								if (val == tmpRecode.categories[x].qText) {
									$scope.categoryEditForm.editCatName.$setValidity('noNameConflict', false);
									return;
								}
							}
						}
					}
					$scope.categoryEditForm.editCatName.$setValidity('noNameConflict', true);
					return val;
				}

				$rootScope.$on('openRecodeEditCatEvent', function(e, act, src, dim, recode, cat) {
					$scope.action = act;
					if($scope.action == $rootScope.recodeAction.AddCategory) {
						$scope.modalTitle = "Add Group";
					} else if($scope.action == $rootScope.recodeAction.EditCategory) {
						$scope.modalTitle = "Edit Group"
					}
					initDim = dim;
					tmpRecode = JSON.parse(JSON.stringify(recode));
					initRecode = recode;
					source = src
					tmpCat = cat || {};
					$scope.catName = tmpCat.qText || "";

					$scope.catEditMode = null;
					$scope.setAllValues = false;

					$scope.checkedCatEditValueCount = 0;
					$("#recodeEditCat").show();
					showCategorySection().then(function() {;
						$scope.categoryEditForm.editCatName.$parsers = [];
						$scope.categoryEditForm.editCatName.$parsers.push(validateValueName);
						$scope.categoryEditForm.$setPristine();
						$scope.categoryEditForm.editCatName.$setPristine();
					})			
				})

				$scope.txtChgCatName = function() {
					if(tmpCat.catName == $scope.catName) {
						$scope.changesPending = false;
					} else {
						$scope.changesPending = true;
					}
				}

				$scope.btnEditCatBack = function() {
					$("#recodeEditCat").hide();
					if(source == $rootScope.eventSrc.FinishedCreatePage) {
						$rootScope.$emit('refreshRecodeFinishedEvent', $rootScope.recodeAction.NoAction);
					} 
					else {
						$rootScope.$emit('reopenRecodeEditEvent');
					}
				}
				
				$scope.btnEditCatClose = function () {
					$("#recodeEditCat").hide();
					if(source == $rootScope.eventSrc.FinishedCreatePage) {
						$rootScope.$emit('refreshRecodeFinishedEvent');
					} 
					else {
						$rootScope.$emit('reopenRecodeEditEvent');
					}
				}

				$scope.chkBoxEditCatAllValues = function () {
					$scope.checkedCatEditValueCount = 0;
					for (var x = 0; x < list.length; x++) {
						if($scope.setAllValues && (list[x].disabled == null || list[x].disabled == false)) {
							list[x].selected = true;
							$scope.checkedCatEditValueCount++;
						} else {
							list[x].selected = false;
						}
					}
				}

				$scope.chkBoxEditCatValue = function (val) {
					if(val.selected == false)
						$scope.setAllValues = false;
					
					$scope.checkedCatEditValueCount = 0;
					for (var x = 0; x < $scope.availValues.length; x++) {
						if ($scope.availValues[x].selected)
							$scope.checkedCatEditValueCount++;
					}
				}

				$scope.btnEditCatSave = function () {
					if($scope.categoryEditForm.editCatName.$valid) {
						if (tmpCat.cId == null) {
							tmpCat.cId = appUtilities.randomCid();
							tmpCat.type = "recode";
							tmpCat.qText = $scope.catName;
							tmpCat.values = getSelectedValues();
							tmpRecode.categories.push(tmpCat);
							$("#recodeEditCat").hide();
							if(source == $rootScope.eventSrc.FinishedCreatePage) {							
								$rootScope.$emit('refreshRecodeFinishedEvent', $scope.action, tmpRecode.categories, tmpCat);
							} else {							
								$rootScope.$emit('refreshRecodeEditEvent', $scope.action, tmpCat, tmpRecode.categories);
							}
						} else {
							$("#recodeEditCat").hide();
							tmpRecode.categories.forEach(c => {
								if(tmpCat.cId == c.cId) {
									c.qText = $scope.catName;
									c.values = getSelectedValues();
								}
							})
							if(source == $rootScope.eventSrc.FinishedCreatePage) {															
								$rootScope.$emit('refreshRecodeFinishedEvent', $scope.action, tmpRecode.categories,tmpCat);
							} else {								
								$rootScope.$emit('refreshRecodeEditEvent', $scope.action, tmpCat, tmpRecode.categories);
							}
						}
					}
				}

				$scope.inputEditCatSearchTextChange = function (evt) {
					var textChange = function () {
						//if user clears all characters, re-build list with no search criteria
						searchValues = [];
						if ($scope.searchRecodeText.length == 0) {
							$('#recodeEditCatViewport').scrollTop(0);
							$scope.availValues = [];
							pageCatList();
							//setFilterButtons();
							$scope.$apply();
						} else if ($scope.searchRecodeText.length > 2) {
							//get search results if user hase entered 3 or more characters
							$('#recodeEditCatViewport').scrollTop(0);
							$scope.availValues = [];
							//var tmp = [];

							var tmpDim = {};
							tmpDim.shortName = tmpRecode.shortName;
							renderList(tmpDim).then(function (list) {
								//populate availValues with search results for those values that have not been marked as selected
								//Also populate searchVales to hold results so it can be used for paging if needed
								//Using the main allValues as the source for both AvailVals and searchVals
								//since selectedVals shares array element references with allValues.
								for (var x = 0; x < list.length; x++) {
									for (var y = 0; y < allValues.length; y++) {
										if (list[x].qText == allValues[y].qText) {
											searchValues.push(allValues[y]);
											break;
										}
									}
								}
								pageCatList();
								return;
							});
						}
						return;
					}
					_.debounce(textChange, 300, false)();
				};

				$scope.btnOpenMakeAvail = function (value) {
					$scope.selectedValue = value;
					if($scope.hideMakeAvailConfirm) {
						applyMakeAvail();
					} else {
						$("#recodeEditCat").hide();
						$("#makeAvailCat").show();
					}
				}

				$scope.btnMakeAvailClose = function () {
					$scope.hideMakeAvailConfirm = false;
					$("#makeAvailCat").hide();
					$("#recodeEditCat").show();	
				}

				function applyMakeAvail() {
					let value = allValues.find(val => val.qText == $scope.selectedValue.qText);
					if(value != null) {
						value.selected = false;
						value.disabled = false;
						delete value.otherCatName;
						for(let x = 0; x < tmpRecode.categories.length; x++) {
							let i = tmpRecode.categories[x].values.findIndex(v => v.qText == value.qText);
							if(i > -1) {
								tmpRecode.categories[x].values.splice(i,1);
								if(tmpRecode.categories[x].values.length == 0) {
									tmpRecode.categories.splice(x, 1);
								}
								break;
							}
						}
					}
				}

				$scope.btnApplyMakeAvail = function () {
					applyMakeAvail();
					$("#makeAvailCat").hide();
					$("#recodeEditCat").show();	
				}

				function getSelectedValues() {
					var values = [];
					allValues.forEach(function (item) {
						if (item.selected) {
							values.push(item);
						}
					});
					return values;
				}

				function disableUnavailableValues(currentCat) {
					var allCategories = tmpRecode.categories;
					if (allCategories != null) {
						for (var x = 0; x < allCategories.length; x++) {
							if (currentCat.cId == null ||
								currentCat.cId !== allCategories[x].cId) {
								var otherRecodeValues = allCategories[x].values;
								for (var y = 0; y < otherRecodeValues.length; y++) {
									for (var z = 0; z < allValues.length; z++) {
										if (otherRecodeValues[y].qText == allValues[z].qText) {
											allValues[z].disabled = true;
											allValues[z].otherCatName = allCategories[x].qText;
										}
									}
								}
							}
						}
					}
				}				

				function scrollCatList() {
					$('#recodeEditCatViewport').off('sCatcroll', _scrollRecodeList);
					$scope.availValues = [];
					pageCatList();
					$('#recodeEditCatViewport').on('scroll', _scrollRecodeList);
					$scope.$apply();
				}

				function showCategorySection() {
					return new qlik.Promise(function (resolve, reject) {
						$scope.checkedCatEditValueCount = 0;
						$scope.searchRecodeText = "";
						$scope.availValues = [];
						allValues = [];
						searchValues = [];

						renderList(initDim).then(function (list) {
							allValues = list;
							if (tmpCat.values != null) {
								for (var y = 0; y < tmpCat.values.length; y++) {
									for (var z = 0; z < allValues.length; z++) {
										if (tmpCat.values[y].qText == allValues[z].qText) {
											allValues[z].selected = true;
											$scope.checkedCatEditValueCount++;
										}
									}
								}
							}
							pageCatList();
							disableUnavailableValues(tmpCat)
							$('#recodeEditCatViewport').scrollTop(0);
							_scrollRecodeList = _.debounce(scrollCatList, 100, false);
							$('#recodeEditCatViewport').off('scroll', _scrollRecodeList).on('scroll', _scrollRecodeList);						
						});
						return resolve();
					});
				}

				function renderList(initDim) {
					return new qlik.Promise(function (resolve, reject) {
						var list = [];
						dimensions.getValuesByDimension(qApp, initDim, $scope.searchRecodeText, null, 0).then(function (values) {
							values.forEach(function (e) {
								if (e.qState == "O" || e.qState == "S" || e.qState == "A") {
									list.push(e);
								}
							});
							values.forEach(function (e) {
								if (e.qState == "X" || e.qState == "XS") {
									list.push(e);
								}
							});
							return resolve(list);
						});

					})
				};

				function pageCatList() {
					var recodeViewport = $('#recodeEditCatViewport');
					var recodeListContent = $('#recodeEditCatListContent');
					var recodeListVisNodes = $('#recodeEditCatListVisNodes');
					var itemCount;
					var rowHeight = 40;
					//var nodePadding = 2;

					if (searchValues.length > 0) {
						list = searchValues;
					} else {
						list = allValues;
					}

					itemCount = list.length;

					var totalContentHeight = (itemCount * rowHeight) + 'px';
					recodeListContent.height(totalContentHeight);
					var scrollTop = recodeViewport.scrollTop();

					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(recodeViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					$scope.availValues = [];
					for (var x = startNode; x < list.length; x++) {
						$scope.availValues.push(list[x]);
						if ($scope.availValues.length == visibleNodesCount) {
							break;
						}
					}	
					recodeListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}
			}
		]);
});

/*************************************************************
Description: This directive displays a filter popup for dimensions with more than 10 values.
There are 2 lists used in this procesing: availList (list on left side) which lists the available values for selction,
and selectedLIst (list on right side) which list values that have been selected by the user.

On popup load, values are retrieved from Qlik for the dimension.  Thesevalues are used to populate both availList and selectList.
CSS classes are used to hide selected values in the availList and display them in the selectedList.  Likewise, css styles are used
to hide selected values in the availList and show them in the selectedList.

If user performs a text search, then the availList is populated with the search reqults from Qlik, while the selectedList still
contains the full set of values for the dimensions, so at this point the 2 list each reference different objects.

THere are 3 key properties for determineing how to process a value in the selectList:
- selected - This property will be true whenever a user has selected a value from the availList or when a users de-selects
a previously added value to remove it from the selectList.  If a user has selected an item from availList but has not Added it yet
and then removes it from the selectList then the selected proprty will be false.
- qState - This property holds the selection state of the value within Qlik.  If qState = 'S' that means the vaalues has already been selected
and applied to the hypercube.  If qState = 'A' or 'O' then the value is available for selection and has not yet been
applied to the hypercube.  If qSate = 'X', then that means the value is excluded and should not be selected because it is
invalid with the current state of the hypercube.  This will hapen when users have applied filters on other dimensions thatmake the combintation
of selected dimensions and filters incompatable with the selected value.  For instance, if a user has previously applied the
filter of 'UVA" to the institutions dimension then the state values will show a qState of 'X' for all state values except
Virginina, since UVA is only applicable to Virginia.
- class - This property determines if the value should be displayed or hidden in the 2 lists.  If class set to 'o' then it will
be displayed in the availList and hidden in the selectList.  If class = 's' then it is hidden in the availList and displayed in
the selectList.

When the Exclude checkbox is applied logic will use the 3 properties to reverse how the values are applied to the hypercube.
Values in the availList are applied to the hypercube and any values in the selectedList are removed from the hypercube
 *************************************************************/
'use strict'
define('scripts/directives/recodeApplyFilterDirective',["qlik", "scripts/shared/hyperCubeProperties", "scripts/shared/dimensions", "scripts/shared/appUtilities", "scripts/shared/recodes"],
	function (qlik, hyperCubeProperties, dimensions, appUtilities, recodes) {

	angular.module("appModule").directive("dtRecodeApplyFilter", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeApplyFilter.html',
			scope: true,
			controller: 'RecodeApplyFilterController'
		};
	});

	angular.module("appModule").controller("RecodeApplyFilterController", ["$scope", "$rootScope", "$timeout",
			function ($scope, $rootScope, $timeout) {
				var appObj = $rootScope.qApp;
				$scope.filterDisplayField = '';
				$scope.searchFilterText = '';
				$scope.selectedValues = [];
				$scope.availRecodeValues = [];
				$scope.disableAddSelections = true;
				$scope.disableRemoveSelections = true;

				//console.log('availRecodeValues ',$scope.availRecodeValues );
				//console.log('$scope.selectedValues ', $scope.selectedValues);
				var totalCount = 0;
				var listObjId;
				var allValues = [];
				var searchValues = [];
				var insertedElements = [];
				var lastAvailActive = -1;
				var lastSelectActive = -1;
				var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

				var _scrollAvailList,
				_scrollSelectList;
				var isSingleClick = true;

				function scrollAvailList() {
					$('#availRecodeViewport').off('scroll', _scrollAvailList);
					$scope.availRecodeValues = [];
					pageAvailList();
					$('#availRecodeViewport').on('scroll', _scrollAvailList);
					$scope.$apply();
				}

				function scrollSelectList() {
					$('#selectRecodeViewport').off('scroll', _scrollSelectList);
					pageSelectList();
					$('#selectRecodeViewport').on('scroll', _scrollSelectList);
					$scope.$apply();
				}

				$scope.clearFilter = function (name) {
					$scope.availRecodeValues = [];
					$scope.selectedValues = [];
					$scope.searchFilterText = "";
					appObj.field(name).clear();
					$scope.dim.selected = false;
					$scope.dim.selectedValuesCount = 0;
				}


				$scope.$on('showRecodeFilterPopupEvent', function (e, dim, recode) {
					showFilterPopup(dim, recode);
				});

				function showFilterPopup(dim, recode) {

					$scope.dim = dim
					$scope.recode = recode;
					$scope.searchFilterText = "";
					$scope.selectedValues = [];
					$scope.availRecodeValues = [];
					allValues = [];
					searchValues = [];
					setFilterButtons(true);

					$("#recodeApplyfilter").show();
					$scope.filterDisplayDimName= $scope.dim.title;
					$scope.filterDisplayRecodeName= $scope.recode.recodeName;


					_scrollAvailList = _.debounce(scrollAvailList, 100, false);
					$('#availRecodeViewport').off('scroll', _scrollAvailList).on('scroll', _scrollAvailList);

					_scrollSelectList = _.debounce(scrollSelectList, 100, false);
					$('#selectRecodeViewport').off('scroll', _scrollSelectList).on('scroll', _scrollSelectList);

					renderList().then(function (list) {
						list = recodes.excludeValuesAppliedByOtherRecodes(list, $scope.dim, $scope.recode);
						if ($scope.recode) {
							list = recodes.showRecodeCategories(list, $scope.dim, $scope.recode);
						}

						allValues = list;
						$('#availRecodeViewport').scrollTop(0);
						$('#selectRecodeViewport').scrollTop(0);
						pageAvailList();
						pageSelectList();
						//setSelectedValues(dim);
						var disableUpd = false;
						if ($scope.dim.shortName.toLowerCase() == "year"
							|| $scope.dim.shortName.toLowerCase() == "refyr") {
							var selValue = appUtilities.search("qState", "S", $scope.selectedValues);
							if (selValue !== null) {
								disableUpd = false;
							} else {
								disableUpd = true;
							}
						}

						setFilterButtons(false);
						return;
					});
				}

				function closeDialog(evt) {
					$("#recodeApplyfilter").hide();
					$scope.closeLeftRail();
				};

				$scope.availListDblClicked = function (value, evt) {
					if (value.qState == 'X' || value.qState == 'XS')
						return;

					isSingleClick = false;
					value.qState = 'S';
					clearAvailList();
					clearSelectList()
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				}

				$scope.availListClicked = function (value, evt) {
					isSingleClick = true;
					$timeout(() => {
						if (isSingleClick) {
							doAvailSingleClick();
						}
					}, 200)

					function doAvailSingleClick() {
						if (value.qState == 'X' || value.qState == 'XS')
							return;

						if (window.getSelection) {
							window.getSelection().removeAllRanges();
						} else if (document.selection) {
							document.selection.empty();
						}

						var list = []
						if (searchValues.length > 0) {
							list = searchValues;
						} else {
							list = allValues;
						}

						if (value.qState == 'lh') {
							value.qState = 'O';
							lastAvailActive = -1;
						} else {
							value.qState = 'lh';
							if (evt.shiftKey && lastAvailActive != -1) {

								var currentIndx = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
								var start = lastAvailActive,
								end = currentIndx;
								if (currentIndx < lastAvailActive) {
									start = currentIndx;
									end = lastAvailActive;
								}

								for (var x = start; x < end; x++) {
									list[x].qState = 'lh';
								}
							} else {
								lastAvailActive = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
							}
						}

						if (appUtilities.search("qState", "lh", list)) {
							$scope.disableAddSelections = false;
						} else {
							$scope.disableAddSelections = true;
						}
					};
				};

				$scope.selectListClicked = function (value, evt) {
					isSingleClick = true;
					$timeout(() => {
						if (isSingleClick) {
							doSelectSingleClick();
						}
					}, 200)
					function doSelectSingleClick() {
						if (window.getSelection) {
							window.getSelection().removeAllRanges();
						} else if (document.selection) {
							document.selection.empty();
						}

						var list = allValues;
						if (value.qState == 'rh') {
							value.qState = 'S';
							lastSelectActive = -1;
						} else {
							value.qState = 'rh';
							if (evt.shiftKey && lastSelectActive != -1) {

								var currentIndx = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
								var start = lastSelectActive,
								end = currentIndx;
								if (currentIndx < lastSelectActive) {
									start = currentIndx;
									end = lastSelectActive;
								}
								for (var x = start; x < end; x++) {
									list[x].qState = 'rh';
								}
							} else {
								lastSelectActive = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
							}
						}
						if (appUtilities.search("qState", "rh", list)) {
							$scope.disableRemoveSelections = false;
						} else {
							$scope.disableRemoveSelections = true;
						}
					};

				}

				$scope.selectListDblClicked = function (value, evt) {
					isSingleClick = false;

					setFilterButtons(true);
					value.qState = 'O';
					clearAvailList();
					clearSelectList()
					pageAvailList();
					pageSelectList();

					setFilterButtons(false);
				}

				function setFilterButtons(disableUpd) {

					lastAvailActive = -1;
					lastSelectActive = -1;
					$scope.disableAddSelections = true;
					$scope.disableRemoveSelections = true;

					$scope.disableActions = disableUpd;

					if ($scope.disableActions) {
						$("#recodeApplyfilter .avail-list li").addClass("disable-item");
						$("#recodeApplyfilter .selected-list li").addClass("disable-item");
					} else {
						$("#recodeApplyfilter .avail-list li").removeClass("disable-item");
						$("#recodeApplyfilter .selected-list li").removeClass("disable-item");
						var visible = $scope.selectedValues.length;

						if (visible == 0) {
							if ($scope.dim.shortName.toLowerCase() == 'year'
								 || $scope.dim.shortName.toLowerCase() == 'refyr') {
								$scope.disableActions = true;
							} else if ($scope.dim.selectedValuesCount > 0) {
								$scope.disableActions = false;
							} else {
								$scope.disableActions = true;
							}
						} else {
							$scope.disableActions = false;
						}

						//enable  Clear all only when selecteed list has one or more visible
						if (visible > 0) {
							$scope.disableClearAll = false;
						} else {
							$scope.disableClearAll = true;
						}

						var avail = $scope.availRecodeValues.length;
						if (avail > 0) {
							$scope.disableAddAll = false;
						} else {
							$scope.disableAddAll = true;
						}
						
						$scope.selectedFilterCountsMsg = getMarkedForSelectionCount(allValues) + " selected";
					}
				}

				$scope.txtSearchFilterChange = function (evt) {
					var textChange = function () {
						//if user clears all characters, re-build list with no search criteria
						searchValues = [];
						$('#availRecodeViewport').scrollTop(0);
						$('#selectRecodeViewport').scrollTop(0);
						$scope.availRecodeValues = [];						
						if ($scope.searchFilterText.length == 0) {
							pageAvailList();
							//pageSelectList();
							$scope.$apply();
						} else if ($scope.searchFilterText.length > 1) {
							//get search results if user hase entered 2 or more characters

							setFilterButtons(true);
							for(let x = 0; x < allValues.length; x++) {
								if(allValues[x].type != null && allValues[x].type == 'recode') { 
									let vals = allValues[x].values.find(v => v.qText.toLowerCase().startsWith($scope.searchFilterText.toLowerCase()))
									if(vals) {
										searchValues.push(allValues[x]);
									} else {
										let vals = allValues[x].qText.toLowerCase().startsWith($scope.searchFilterText.toLowerCase())
										if(vals)
											searchValues.push(allValues[x]);
									}
								} else if(allValues[x].qText.toLowerCase().startsWith($scope.searchFilterText.toLowerCase())) {
									searchValues.push(allValues[x]);
								} 
							}
							$scope.availRecodeValues = searchValues
							$scope.$apply()
							pageAvailList(true);
							//pageSelectList();
							setFilterButtons(false);
							$scope.$apply()
							return;
						}
						return;
					}
					_.debounce(textChange, 300, false)();
				};

				$scope.btnAddSelectionsClick = function (evt) {

					$scope.selectedValues = [];
					setFilterButtons(true);
					for (var i = 0; i < allValues.length; i++) {
						if (allValues[i].qState == 'S'
							 || allValues[i].qState == 'lh') {
							allValues[i].qState = 'S';
							$scope.selectedValues.push(allValues[i]);
						}
					}
					clearSelectList();
					$('#availRecodeViewport').scrollTop(0);
					$('#selectRecodeViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons(false);
				};

				$scope.btnAddAllSelectionsClick = function (evt) {
					var list = [];
					setFilterButtons(true);
					if (searchValues.length > 0) {
						list = searchValues;
					} else {
						list = allValues;
					}

					for (var i = 0; i < list.length; i++) {
						var value = list[i];
						if (value.qState != 'X') {
							value.qState = 'S';
						}
					};

					$('#availRecodeViewport').scrollTop(0);
					$('#selectRecodeViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons(false);
				};

				$scope.btnRemoveSelectionsClick = function (evt) {
					setFilterButtons(true);
					for (var i = 0; i < allValues.length; i++) {
						if (allValues[i].qState == 'rh') {
							allValues[i].qState = 'O';
						}
					}
					clearAvailList();

					$('#availRecodeViewport').scrollTop(0);
					$('#selectRecodeViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons(false);
				};

				$scope.btnFilterClearAllClick = function (evt) {
					setFilterButtons(true);
					for (var i = 0; i < allValues.length; i++) {
						var value = allValues[i];
						if (value.qState != 'X') {
							value.qState = 'O';
						}
					};

					$('#availRecodeViewport').scrollTop(0);
					$('#selectRecodeViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();
					$scope.searchFilterText = ""
					setFilterButtons(false);
				};

				$scope.btnShowFilterRecodeDimension = function () {
					$scope.showRecodeDimensionPopup($scope.dim);
				}

				$scope.btnFilterCloseClick = function (evt) {
					closeDialog();
				};

				function clearSelectList() {
					for (var i = 0; i < $scope.selectedValues.length; i++) {
						if ($scope.selectedValues[i].qState == 'rh') {
							$scope.selectedValues[i].qState = 'S';
						}
					}
					$scope.searchFilterText = ""
				}

				function clearAvailList() {
					for (var i = 0; i < $scope.availRecodeValues.length; i++) {
						if ($scope.availRecodeValues[i].qState == 'lh') {
							$scope.availRecodeValues[i].qState = 'O';
						}
					}
				}

				$scope.btnFilterRecodeApply = function (addToCol) {
					$rootScope.leftRailMessage = "";
					$scope.recode.selected = true;
					setFilterButtons(true);
					//$scope.toggleReadOnly(true);
					//google analytics tracking
					gtag('event', $rootScope.survey.abbreviation + '-Select recode', {
						'event_label': $rootScope.startingPoint,
						'event_category': 'recode_select',
						'event_variable': $scope.dim.shortName
					});

					//set values to selected so values are found by generic applyRecode() method
					var nonRecodeSelected = [];
					allValues.forEach(function (item) {
						if (item.qState == 'S') {
							item.selected = true;
							if (item.type != 'recode') {
								nonRecodeSelected.push(item);
							}
						}
					});
					$scope.recode.nonRecodeValues = nonRecodeSelected;

					var categories = $scope.recode.categories;
					for (var a = 0; a < categories.length; a++) {
						if (categories[a].qState == 'S') {
							categories[a].selected = true;
						} else {
							categories[a].selected = false;
						}
					}

					hyperCubeProperties.applyRecode(appObj, $rootScope, $scope, addToCol).then(function () {
						var values = $scope.recode.categories.concat($scope.recode.nonRecodeValues);
						$scope.recode.selectedValuesCount = getAppliedSelectedCount(values);
						closeDialog();
						setFilterButtons(false);
					}, function (err) {
						setFilterButtons(false);						
						appUtilities.showError(err);
					});
				}
				
				$scope.getAvailListClass = function (value) {
					if(value.qState == null)
						return null;
					var retCls = " " + value.qState.toLowerCase();

					return retCls;
				}

				$scope.getSelectListClass = function (value) {
					if(value.qState == null)
						return null;
					var retCls = " " + value.qState.toLowerCase();

					return retCls;
				}				

				function pageAvailList(pageSearch) {
					var availViewport = $('#availRecodeViewport');
					var availListContent = $('#availRecodeListContent');
					var availListVisNodes = $('#availRecodeListVisNodes');
					var itemCount;
					var rowHeight = 29;
					var nodePadding = 2;

					var list = [],
					filteredList = [];
					if (pageSearch) {
						list = searchValues;
					} else {
						list = allValues;
					}
					filteredList = list.filter(function (item) {
						if (item.qState !== 'S')
							return item;
					})
						itemCount = filteredList.length;

					var totalContentHeight = (itemCount * rowHeight) + 'px';
					//availListContent.attr("style","height:"+totalContentHeight);
					availListContent.height(totalContentHeight);
					var scrollTop = availViewport.scrollTop();

					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(availViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					let availValues = [];
					for (var x = startNode; x < filteredList.length; x++) {
						if (filteredList[x].qState != "S") {
							availValues.push(filteredList[x]);
							if (availValues.length == visibleNodesCount) {
								break;
							}
						}
					}
					$scope.availRecodeValues = availValues;
					availListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}

				function pageSelectList() {
					var selectViewport = $('#selectRecodeViewport');
					var selectListContent = $('#selectRecodeListContent');
					var selectListVisNodes = $('#selectRecodeListVisNodes');
					var itemCount;
					var rowHeight = 29;
					var nodePadding = 2;
					var viewportHeight = 280;

					var list = [];
					list = allValues.filter(function (item) {
						if (item.qState == 'S')
							return item;
					})
					itemCount = list.length;

					var totalContentHeight = ((itemCount) * rowHeight) + 'px';
					//selectListContent.attr("style","height:"+totalContentHeight);
					selectListContent.height(totalContentHeight);

					var scrollTop = selectViewport.scrollTop();
					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(selectViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					$scope.selectedValues = [];
					for (var x = startNode; x < list.length; x++) {
						if (list[x].qState == "S") {
							$scope.selectedValues.push(list[x]);
							if ($scope.selectedValues.length == visibleNodesCount) {
								break;
							}
						}
					}
					selectListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}

				function renderList() {
					return new qlik.Promise(function (resolve, reject) {
						var list = [];
						dimensions.getValuesByDimension(appObj, $scope.dim, $scope.searchFilterText, null, 0).then(function (values) {
							values.forEach(function (e) {
								if (e.qState == "O" || e.qState == "S" || e.qState == "A") {
									list.push(e);
								}
							});
							values.forEach(function (e) {
								if (e.qState == "X" || e.qState == "XS") {
									list.push(e);
								}
							});
							return resolve(list);
						});

					})
				};

				function getAppliedSelectedCount(arr) {
					if (arr == null)
						return 0;

					return arr.filter(function (elm) {
						return elm.selected == true;
					}).length;
				}

				function getMarkedForSelectionCount(arr) {
					if (arr == null)
						return 0;

					return arr.filter(function (elm) {
						return elm.qState == 'S';
					}).length;
				}

			}
		]);
});

'use strict'
define('scripts/directives/recodeApplyInstFilterDirective',["qlik", "scripts/shared/hyperCubeProperties", "scripts/shared/dimensions", "scripts/shared/appUtilities", "scripts/shared/recodes"],
	function (qlik, hyperCubeProperties, dimensions, appUtilities, recodes) {

	angular.module("appModule").directive("dtRecodeApplyInstFilter", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeApplyInstFilter.html',
			scope: true,
			controller: 'RecodeApplyInstFilterController'
		};
	});

	angular.module("appModule").controller("RecodeApplyInstFilterController", ["$scope", "$rootScope", "$timeout",
			function ($scope, $rootScope, $timeout) {
				var appObj = $rootScope.qApp;
				$scope.filterDisplayField = '';
				$scope.searchFilterText = '';
				$scope.selectedValues = [];
				$scope.availValues = [];
				$scope.disableAddSelections = true;
				$scope.disableRemoveSelections = true;
				$scope.recodeDropdownControl = [];
				$scope.recodeDimDropDowns = [];	

				var allValues = [];
				var searchValues = [];
				var lastAvailActive = -1;
				var lastSelectActive = -1;
				var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				const INST = "institution";

				var _scrollAvailList,
				_scrollSelectList;
				var isSingleClick = true;

				var filterInstRecodeListener = function () {

					var modal = document.querySelector("#recodeApplyInstfilter");
					if (modal && modal.style.display == "block") {
						//logic for looping promise calls; need to re-build each list with excluded items
						//after user has made a selection from one of the drop-down list
						$scope.searchFilterText = '';
						searchValues = [];
						renderList($scope.dim).then(function (list) {
							list = recodes.excludeValuesAppliedByOtherRecodes(list, $scope.dim, $scope.recode);
							if ($scope.recode) {
								list = recodes.showRecodeCategories(list, $scope.dim, $scope.recode, INST);
							}
							allValues = list;
							$scope.recode.listCount = list.length;

							//mark all values in selected list as selected in the allValues list
							$scope.selectedValues.map(v => {
								let selected = allValues.find(av => av.qText == v.qText)
								if(selected && selected.qState != 'S') {
									selected.qState = 'S';
								}
							})

							pageAvailList();
							pageSelectList();
						});
						return;
					}
				};


				function scrollAvailList() {
					$('#availInstRecodeViewport').off('scroll', _scrollAvailList);
					$scope.availValues = [];
					pageAvailList();
					$('#availInstRecodeViewport').on('scroll', _scrollAvailList);
					$scope.$apply();
				}

				function scrollSelectList() {
					$('#selectInstRecodeViewport').off('scroll', _scrollSelectList);
					pageSelectList();
					$('#selectInstRecodeViewport').on('scroll', _scrollSelectList);
					$scope.$apply();
				}

				$scope.$on('clearInstRecodeFilterEvent', function () {
					$scope.availValues = [];
					$scope.selectedValues = [];
					$scope.searchFilterText = "";
					appObj.field('instName').clear();

					allValues = [];
					if ($scope.recode) {
						$scope.recode.nonRecodeValues = [];
						$scope.recode.selectedValuesCount = 0;
						$scope.recode.selected = false;
					}

					if($scope.dim) {
						$scope.dim.selectedValuesCount = 0;
						$scope.dim.recodeDimDropDowns = [];
						//$scope.dim.recodeSelected = false;
						$scope.dim.selected = false;
						$scope.dim.selectedValuesCount = 0;
						//clear all drop-down selections
					}

					$scope.recodeDropdownControl.forEach(function (e) {
						e.clearDropDown();
						delete e.savedValues;
					});	
										
					//clear all drop-down filters that have been applied to the institutions
					$scope.selAltState.clearAll(false);
				})


				$scope.$on('showRecodeInstFilterPopupEvent', function (e, dim, recode) {
					showFilterPopup(dim, recode);
				});

				function showFilterPopup(dim, recode) {

					$scope.dim = dim
					$scope.recode = recode;
					$scope.searchFilterText = "";
					$scope.selectedValues = [];
					$scope.availValues = [];
					allValues = [];
					searchValues = [];

					$("#recodeApplyInstfilter").show();
					$scope.filterDisplayDimName= $scope.dim.title;
					$scope.filterDisplayRecodeName= $scope.recode.recodeName;


					_scrollAvailList = _.debounce(scrollAvailList, 100, false);
					$('#availInstRecodeViewport').off('scroll', _scrollAvailList).on('scroll', _scrollAvailList);

					_scrollSelectList = _.debounce(scrollSelectList, 100, false);
					$('#selectInstRecodeViewport').off('scroll', _scrollSelectList).on('scroll', _scrollSelectList);

					$scope.recodeDimDropDowns = dim.subFilters;
					renderList().then(function (list) {
						list = recodes.excludeValuesAppliedByOtherRecodes(list, $scope.dim, $scope.recode);
						if ($scope.recode) {
							list = recodes.showRecodeCategories(list, $scope.dim, $scope.recode, INST);
						}

						allValues = list;
						$scope.selAltState.OnData.bind(filterInstRecodeListener);
						$('#availInstRecodeViewport').scrollTop(0);
						$('#selectInstRecodeViewport').scrollTop(0);
						pageAvailList();
						pageSelectList();
						
						setFilterButtons(false);
						return;
					});
				}			

				function closeDialog(evt) {
					$("#recodeApplyInstfilter").hide();
					$scope.selAltState.OnData.unbind(filterInstRecodeListener);
					if($scope.recode.cId == null) {
						$scope.btnInstReloadPopup();
					}
					$scope.showSearchInstText = false;					
					$scope.closeLeftRail();
				};

				$scope.toggleFilterListExpanded = function () {
					$scope.filterListExpanded = !$scope.filterListExpanded;
				}					

				$scope.availListDblClicked = function (value, evt) {
					if (value.qState == 'X' || value.qState == 'XS')
						return;

					isSingleClick = false;
					value.qState = 'S';
					clearAvailList();
					clearSelectList()
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				}

				$scope.availListClicked = function (value, evt) {
					isSingleClick = true;
					$timeout(() => {
						if (isSingleClick) {
							doAvailSingleClick();
						}
					}, 200)

					function doAvailSingleClick() {
						if (value.qState == 'X' || value.qState == 'XS')
							return;

						if (window.getSelection) {
							window.getSelection().removeAllRanges();
						} else if (document.selection) {
							document.selection.empty();
						}

						var list = []
						if (searchValues.length > 0) {
							list = searchValues;
						} else {
							list = allValues;
						}

						if (value.qState == 'lh') {
							value.qState = 'O';
							lastAvailActive = -1;
						} else {
							value.qState = 'lh';
							if (evt.shiftKey && lastAvailActive != -1) {

								var currentIndx = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
								var start = lastAvailActive,
								end = currentIndx;
								if (currentIndx < lastAvailActive) {
									start = currentIndx;
									end = lastAvailActive;
								}

								for (var x = start; x < end; x++) {
									list[x].qState = 'lh';
								}
							} else {
								lastAvailActive = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
							}
						}

						if (appUtilities.search("qState", "lh", list)) {
							$scope.disableAddSelections = false;
						} else {
							$scope.disableAddSelections = true;
						}
					};
				};

				$scope.selectListClicked = function (value, evt) {
					isSingleClick = true;
					$timeout(() => {
						if (isSingleClick) {
							doSelectSingleClick();
						}
					}, 200)
					function doSelectSingleClick() {
						if (window.getSelection) {
							window.getSelection().removeAllRanges();
						} else if (document.selection) {
							document.selection.empty();
						}

						var list = allValues;
						if (value.qState == 'rh') {
							value.qState = 'S';
							lastSelectActive = -1;
						} else {
							value.qState = 'rh';
							if (evt.shiftKey && lastSelectActive != -1) {

								var currentIndx = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
								var start = lastSelectActive,
								end = currentIndx;
								if (currentIndx < lastSelectActive) {
									start = currentIndx;
									end = lastSelectActive;
								}
								for (var x = start; x < end; x++) {
									list[x].qState = 'rh';
								}
							} else {
								lastSelectActive = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
							}
						}
						if (appUtilities.search("qState", "rh", list)) {
							$scope.disableRemoveSelections = false;
						} else {
							$scope.disableRemoveSelections = true;
						}
					};

				}

				$scope.selectListDblClicked = function (value, evt) {
					isSingleClick = false;

					value.qState = 'O';
					clearAvailList();
					clearSelectList()
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				}

				function setFilterButtons(disableUpd) {

					lastAvailActive = -1;
					lastSelectActive = -1;
					$scope.disableAddSelections = true;
					$scope.disableRemoveSelections = true;

					$scope.disableActions = disableUpd;

					if ($scope.disableActions) {
						$("#recodeApplyInstfilter .avail-list li").addClass("disable-item");
						$("#recodeApplyInstfilter .selected-list li").addClass("disable-item");
					} else {
						$("#recodeApplyInstfilter .avail-list li").removeClass("disable-item");
						$("#recodeApplyInstfilter .selected-list li").removeClass("disable-item");
						var visible = $scope.selectedValues.length;

						if (visible == 0) {
							if ($scope.dim.shortName.toLowerCase() == 'year'
								 || $scope.dim.shortName.toLowerCase() == 'refyr') {
								$scope.disableActions = true;
							} else if ($scope.dim.selectedValuesCount > 0) {
								$scope.disableActions = false;
							} else {
								$scope.disableActions = true;
							}
						} else {
							$scope.disableActions = false;
						}

						//enable  Clear all only when selecteed list has one or more visible
						if (visible > 0) {
							$scope.disableClearAll = false;
						} else {
							$scope.disableClearAll = true;
						}

						var avail = $scope.availValues.length;
						if (avail > 0) {
							$scope.disableAddAll = false;
						} else {
							$scope.disableAddAll = true;
						}
						
						$scope.selectedFilterCountsMsg = getMarkedForSelectionCount(allValues) + " selected";
					}
				}

				$scope.txtSearchFilterChange = function (evt) {
					var textChange = function () {
						//if user clears all characters, re-build list with no search criteria
						searchValues = [];
						$('#availInstRecodeViewport').scrollTop(0);
						$('#selectInstRecodeViewport').scrollTop(0);
						$scope.availValues = [];						
						if ($scope.searchFilterText.length > 1) {
							//get search results if user hase entered 2 or more characters

							for(let x = 0; x < allValues.length; x++) {
								if(allValues[x].type != null && allValues[x].type == 'recode') { 
									let vals = allValues[x].values.find(v => v.qText.toLowerCase().startsWith($scope.searchFilterText.toLowerCase()))
									if(vals) {
										searchValues.push(allValues[x]);
									} else {
										let vals = allValues[x].qText.toLowerCase().startsWith($scope.searchFilterText.toLowerCase())
										if(vals)
											searchValues.push(allValues[x]);
									}

								} else if(allValues[x].qText.toLowerCase().startsWith($scope.searchFilterText.toLowerCase())) {
									searchValues.push(allValues[x]);
								} 
							}
							$scope.availValues = searchValues
							$scope.$apply()
							pageAvailList();
							//pageSelectList();
							setFilterButtons();
							$scope.$apply()
							return;
						} else {
							$scope.searchFilterText == '';
							pageAvailList();
							//pageSelectList();
							setFilterButtons();
							$scope.$apply();
						}
						return;
					}
					_.debounce(textChange, 300, false)();
				};

				$scope.btnAddSelectionsClick = function (evt) {

					$scope.selectedValues = [];
					for (var i = 0; i < allValues.length; i++) {
						if (allValues[i].qState == 'S'
							 || allValues[i].qState == 'lh') {
							allValues[i].qState = 'S';
							$scope.selectedValues.push(allValues[i]);
						}
					}
					clearSelectList();
					$('#availInstRecodeViewport').scrollTop(0);
					$('#selectInstRecodeViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				};

				$scope.btnAddAllSelectionsClick = function (evt) {
					var list = [];
					if (searchValues.length > 0) {
						list = searchValues;
					} else {
						list = allValues;
					}

					for (var i = 0; i < list.length; i++) {
						var value = list[i];
						if (value.qState != 'X') {
							value.qState = 'S';
						}
					};

					$('#availInstRecodeViewport').scrollTop(0);
					$('#selectInstRecodeViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				};

				$scope.btnRemoveSelectionsClick = function (evt) {
					for (var i = 0; i < allValues.length; i++) {
						if (allValues[i].qState == 'rh') {
							allValues[i].qState = 'O';
						}
					}
					clearAvailList();

					$('#availInstRecodeViewport').scrollTop(0);
					$('#selectInstRecodeViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				};

				$scope.btnFilterClearAllClick = function (evt) {
					for (var i = 0; i < allValues.length; i++) {
						var value = allValues[i];
						if (value.qState != 'X') {
							value.qState = 'O';
						}
					};

					$('#availInstRecodeViewport').scrollTop(0);
					$('#selectInstRecodeViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();
					$scope.searchFilterText = ""
					setFilterButtons();
				};

				$scope.btnShowFilterRecodeDimension = function () {
					$scope.showRecodeDimensionPopup($scope.dim);
				}

				$scope.btnFilterCloseClick = function (evt) {
					closeDialog();
				};

				function clearSelectList() {
					for (var i = 0; i < $scope.selectedValues.length; i++) {
						if ($scope.selectedValues[i].qState == 'rh') {
							$scope.selectedValues[i].qState = 'S';
						}
					}
					$scope.searchFilterText = ""
				}

				function clearAvailList() {
					for (var i = 0; i < $scope.availValues.length; i++) {
						if ($scope.availValues[i].qState == 'lh') {
							$scope.availValues[i].qState = 'O';
						}
					}
				}

				$scope.btnFilterRecodeApply = function (addToCol) {
					$rootScope.leftRailMessage = "";
					$scope.recode.selected = true;

					$scope.toggleReadOnly(true);
					//google analytics tracking
					gtag('event', $rootScope.survey.abbreviation + '-Select recode', {
						'event_label': $rootScope.startingPoint,
						'event_category': 'recode_select',
						'event_variable': $scope.dim.shortName
					});

					//set values to selected so values are found by generic applyRecode() method
					var nonRecodeSelected = [];
					allValues.forEach(function (item) {
						if (item.qState == 'S') {
							item.selected = true;
							if (item.type != 'recode') {
								nonRecodeSelected.push(item);
							}
						}
					});
					$scope.recode.nonRecodeValues = nonRecodeSelected;

					let categories = $scope.recode.categories;
					let selectedCatCnt = 0;
					for (var a = 0; a < categories.length; a++) {
						if (categories[a].qState == 'S') {
							selectedCatCnt++;
							categories[a].selected = true;
						} else {
							categories[a].selected = false;
						}
					}

					hyperCubeProperties.applyRecode(appObj, $rootScope, $scope, addToCol).then(function () {
						$scope.recode.selectedValuesCount = selectedCatCnt + nonRecodeSelected.length;					
						closeDialog();
					}, function (err) {
						appUtilities.showError(err);
					});
				}
				
				$scope.getAvailListClass = function (value) {
					if(value.qState == null)
						return null;
					var retCls = " " + value.qState.toLowerCase();

					return retCls;
				}

				$scope.getSelectListClass = function (value) {
					if(value.qState == null)
						return null;
					var retCls = " " + value.qState.toLowerCase();

					return retCls;
				}				

				function pageAvailList() {
					var availViewport = $('#availInstRecodeViewport');
					var availListContent = $('#availInstRecodeListContent');
					var availListVisNodes = $('#availInstRecodeListVisNodes');
					var itemCount;
					var rowHeight = 29;
					var nodePadding = 2;
					var list = [], filteredList = [];

					if (searchValues.length > 0) {
						list = searchValues;
					} else {
						list = allValues;
					}
					filteredList = list.filter(function (item) {
						if (item.qState !== 'S')
							return item;
					})
					itemCount = filteredList.length;

					var totalContentHeight = (itemCount * rowHeight) + 'px';
					//availListContent.attr("style","height:"+totalContentHeight);
					availListContent.height(totalContentHeight);
					var scrollTop = availViewport.scrollTop();

					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(availViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					let availValues = [];
					for (var x = startNode; x < filteredList.length; x++) {
						if (filteredList[x].qState != "S") {
							availValues.push(filteredList[x]);
							if (availValues.length == visibleNodesCount) {
								break;
							}
						}
					}
					$scope.availValues = availValues;
					availListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}

				function pageSelectList() {
					var selectViewport = $('#selectInstRecodeViewport');
					var selectListContent = $('#selectInstRecodeListContent');
					var selectListVisNodes = $('#selectInstRecodeListVisNodes');
					var itemCount;
					var rowHeight = 29;
					var nodePadding = 2;
					var viewportHeight = 280;

					var list = [];
					list = allValues.filter(function (item) {
						if (item.qState == 'S')
							return item;
					})
					itemCount = list.length;

					var totalContentHeight = ((itemCount) * rowHeight) + 'px';
					//selectListContent.attr("style","height:"+totalContentHeight);
					selectListContent.height(totalContentHeight);

					var scrollTop = selectViewport.scrollTop();
					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(selectViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					$scope.selectedValues = [];
					for (var x = startNode; x < list.length; x++) {
						if (list[x].qState == "S") {
							$scope.selectedValues.push(list[x]);
							if ($scope.selectedValues.length == visibleNodesCount) {
								break;
							}
						}
					}
					selectListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}

				function renderList() {
					return new qlik.Promise(function (resolve, reject) {
						var list = [];
						dimensions.getValuesByDimension(appObj, $scope.dim, $scope.searchFilterText, 'altState1', 0).then(function (values) {
							values.forEach(function (e) {
								if (e.qState == "O" || e.qState == "S" || e.qState == "A") {
									list.push(e);
								}
							});
							values.forEach(function (e) {
								if (e.qState == "X" || e.qState == "XS") {
									list.push(e);
								}
							});
							return resolve(list);
						});

					})
				};

				function getMarkedForSelectionCount(arr) {
					if (arr == null)
						return 0;

					return arr.filter(function (elm) {
						return elm.qState == 'S';
					}).length;
				}
			}
		]);
});

/*************************************************************
Description: This directive displays the dimension hierarchy filter popup.
This popup is similar to the simple filter popup used for dimensions with over 20 values
except it also provides the capability to filter on multiple dimensions that are related through a parent child relationship.
The Survey Get Dimensions API returns a modified structure that contains the hierarchical structure.  This structure is
returned for the top level dimension that has hierarchyAvailable flag set to Y.

This directive utilizes the qlik alternate state, which enables the user to filter on the institutions list without effecting the main table

Unlike the simple filter popup, this directive cannot use the Qlik List obj since it only supports retrieving values
for a single dimension and the tree modal must support 2 or more dimensions that have a parent/child relationship.
So this directive displays the hierachy tree structure using the table hypercube object.
The main differences between list obj and hypercube obj is that the Qlik list object retutns all values for a dimension.
Those values that have been applied to the filter are returned with a qState property of 'S',
this enables the directive to determine how to display values  with differrent states.  On the other hand,
the hypercube object only returns values that meet the filter criteria, so if a user returns to the tree modal after
previusly applying filters, then the table generated from the
hypercube will only display those previously selected values in the left side available list.  The workaround to this issue
is to store the state of the filtered data in memory. A copy of the list is stored to a scope variable called savedList.  On popup onpe, if savedList exist it is used to populateArray
both the availList and selectedList.  Upon returning to the treee modal, the program will retrieve the full set of values including those not previously selected to build
left side and right side tables in the modal.

Logic utilizes an object property named class to both determine when to display the value in the list and track if the value has been
previously selected.  States of the class property are:
- class='o' - This state indicates value has not been selected and is displayed in availList but not shown in selectedList
- class='s' - This state indicates value has been selected, so it is not shown in availList but shown in selectedList
- class='t' - This indicates value has been selected and the value has children that are both selected and unselected,
so this value needs to be shown in both the availList and selectedList

Because of the complexity of this directive, each time a user performs an update to the selected tree values, any previously applied
filter values are removed; the hypercube is then updated with the current set of selected dimensions; and then the
selected filters are applied to the the main pivot table hypercube.

 ***************************************/
'use strict'
define('scripts/directives/recodeTreeApplyFilterDirective',["qlik", "scripts/shared/appUtilities", "scripts/shared/hyperCubeProperties", "scripts/shared/dimensions"],
	function (qlik, appUtilities, hyperCubeProperties, dimensions) {

	angular.module("appModule").directive("dtRecodeTreeApplyFilter", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeTreeApplyFilter.html',
			scope: true,
			controller: 'FilterRecodeTreeApplyController'
		};
	});

	angular.module("appModule").controller("FilterRecodeTreeApplyController", ["$scope", "$rootScope",
			function ($scope, $rootScope) {
				var appObj = $rootScope.qApp;

				$scope.recodeTree = {};
				$scope.recodeTree.dimensions = [];
				$scope.showRecodeTreeSearchText = false;
				var rootObj;
				var totalCount = 0;
				var listObjId;
				var isOpenFromLeftRail = true;
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

				var rootDim;  //, recodeTree;

				$scope.clearRecodeTreeFilter = function (recodeTree) {
					$rootScope.selAltState.clearAll(false);
					dimensions.resetDimension($rootScope, recodeTree);
				}
				
				$scope.$on('showRecodeTreeFilterPopupEvent', function (e, dim, recode) {
					showRecodeTreeFilterPopup(dim, recode);
				});

				$scope.$on('importTableRecodedTreeEvent', function (e, params) {
					importTableRecodedTree(e, params);
				});

				//method called after a table with a recoded tree has been imported into table builder. Method sets selected items so that right and left lists display correc tly when user edits selections
				function importTableRecodedTree(e, params) {
					$scope.recodeTree = params.recodeTree;
					$rootScope.selAltState.clearAll(false).then(function () {
						renderList().then(function () {

							//If modal being displayed after user has imported saved data, then initialization 
							//needs to set list selections to match the imported data.  This condition is identified by savedDims haing data and savedList being empty
							$scope.recodeTree.selectedTreeValues = $scope.recodeTree.availTreeValues;
							let dimLevels = $scope.recodeTree.savedDims;
							let dim;	
							
							$scope.recodeTree.availTreeValues.forEach(function(availItem) {
								dim = dimLevels[availItem.level]
								let matchedItem = findMatchingSelectedDimValue(availItem, dim);
								if(matchedItem != null) {
									setImportSelectedState(availItem, dimLevels);
								}
							})
							//loop thru list again to clean up any parents that are in available list but do not have unselected children
							$scope.recodeTree.availTreeValues.forEach(function(availVal) {
								var kids = findChildren(availVal, $scope.recodeTree.availTreeValues);
								if(availVal.class == 't' && kids.filter(function (elm) {
										return elm.class == "s" || elm.class == "t";
									}).length == kids.length) {
									availVal.selected = true;
									availVal.class = "s";
								}
							})

							$scope.recodeTree.dimensions = $scope.recodeTree.savedDims;
							$scope.recodeTree.savedList = $scope.recodeTree.availTreeValues;

							setFilterButtons();
						});
					});	
				}

				function showRecodeTreeFilterPopup (dim, recode) {
					//$scope.recodeTree.topic = topic;
					rootDim = dim;
					$scope.recodeTree = recode;
					$scope.recodeTree.searchFilterTreeText = '';
					//$scope.recodeTree.dimensions = [];
					//if popup displayed previously, use values from previous display, otherwise default all dimensions to selected
					if ($scope.recodeTree.savedDims != null && $scope.recodeTree.savedDims.length > 0) {
						$scope.recodeTree.dimensions = $scope.recodeTree.savedDims;
					} else {
						//poup not previously displayed, so default all dims to selected unless TB was invoked from ME,
						//in that case, only select the dimension passed in from ME
						//$scope.recodeTree.dimensions = recodeTree.dimensions;
						for (var x = 0; x < $scope.recodeTree.dimensions.length; x++) {
							if ($scope.recodeTree.dimensions[x].disabled) {
								$scope.recodeTree.dimensions[x].selected = false;
							} else {
								$scope.recodeTree.dimensions[x].selected = true;
								$scope.recodeTree.dimensions[x].disabled = false;
							}
						}
					}

					//remove dims that are not valid with selected measures
					var selectedMsrs = [];
					for (var x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
						var apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
						for (var y = 0; y < apiGrps.length; y++) {
							var selected = appUtilities.findMatches("selected", true, apiGrps[y].measures);
							if (selected.length > 0) {
								selectedMsrs = selectedMsrs.concat(selected);
							}
						}
					}
					if (selectedMsrs.length > 0) {
						var tmpTree = $scope.recodeTree.dimensions;
						for (var x = 0; x < $scope.recodeTree.dimensions.length; x++) {
							var dim = $scope.recodeTree.dimensions[x];
							var found = false;
							for (var y = 0; y < selectedMsrs.length; y++) {
								if (selectedMsrs[y].associations.indexOf(dim.shortName) == -1) {
									found = false;
									break;
								} else {
									found = true;
								}
							}
							if (!found) {
								dim.disabled = true;
								dim.selected = false;
							} else {
								dim.disabled = false;
							}
						}
					}

					//if user has previously selected from tree, then show that copy of the tree which is in savedList
					if ($scope.recodeTree.savedList != null
						 && $scope.recodeTree.savedList.length > 0) {
						//do deep copy so availList does not reference the same array as savedList
						$scope.recodeTree.availTreeValues = JSON.parse(JSON.stringify($scope.recodeTree.savedList));
						$scope.recodeTree.selectedTreeValues = $scope.recodeTree.availTreeValues;
						$scope.recodeTree.selectedValuesCount = appUtilities.findMatches("class", "s", $scope.recodeTree.selectedTreeValues).length;
						setFilterButtons();
					} else {
						$rootScope.selAltState.clearAll(false).then(function () {
							renderList().then(function () {

								//If modal being displayed after user has imported saved data, then initialization 
								//needs to set list selections to match the imported data.  This condition is identified by savedDims haing data and savedList being empty
								if ($scope.recodeTree.savedDims != null && $scope.recodeTree.savedDims.length > 0) {
									$scope.recodeTree.selectedTreeValues = $scope.recodeTree.availTreeValues;
									let dimLevels = $scope.recodeTree.savedDims;
									let dim;	
									
									$scope.recodeTree.availTreeValues.forEach(function(availItem) {
										dim = dimLevels[availItem.level]
										let matchedItem = findMatchingSelectedDimValue(availItem, dim);
										if(matchedItem != null) {
											setImportSelectedState(availItem, dimLevels);
										}
									})
									//loop thru list again to clean up any parents that are in available list but do not have unselected children
									$scope.recodeTree.availTreeValues.forEach(function(availVal) {
										var kids = findChildren(availVal, $scope.recodeTree.availTreeValues);
										if(availVal.class == 't' && kids.filter(function (elm) {
												return elm.class == "s" || elm.class == "t";
											}).length == kids.length) {
											availVal.selected = true;
											availVal.class = "s";
										}
									})

									$scope.recodeTree.dimensions = $scope.recodeTree.savedDims;
									$scope.recodeTree.savedList = $scope.recodeTree.availTreeValues;
								} else {
									$scope.recodeTree.selectedTreeValues = $scope.recodeTree.availTreeValues;
									$scope.recodeTree.selectedValuesCount = appUtilities.findMatches("class", "s", $scope.recodeTree.selectedTreeValues).length;
								}

								// auto-populate the searchFilterText if the user has selected a Field Label from
								// the left rail autocomplete. By-pass ng-change method txtSearchTreeFilterChange()
								// as it uses Qlik to do the search. This search does not return one result as expected
								if (isOpenFromLeftRail) {
									isOpenFromLeftRail = false;
									if ($rootScope.suggestionBubble.valueSource == 'Field Labels') {
										for (var i = 0; i < $scope.recodeTree.dimensions.length; i++) {
											if ($rootScope.variableIdsToHighlight.includes($scope.recodeTree.dimensions[i].variableId)) {
												for (var x = 0; x < $scope.recodeTree.availTreeValues.length; x++) {
													if ($scope.recodeTree.availTreeValues[x].qText == $rootScope.suggestionBubble.storedValue) {
														var nodeMatchingBubble = JSON.parse(JSON.stringify($scope.recodeTree.availTreeValues[x]));
														nodeMatchingBubble.listType = "search";
														nodeMatchingBubble.selected = undefined;
														delete nodeMatchingBubble.level;
														delete nodeMatchingBubble.listId;
														delete nodeMatchingBubble.padding;
														delete nodeMatchingBubble.parent;
														delete nodeMatchingBubble.parentId;
														$scope.recodeTree.availTreeValues = [nodeMatchingBubble];
														break;
													}
												}
												$scope.recodeTree.searchFilterTreeText = $rootScope.suggestionBubble.storedValue;
											}
										}
									}
								}

								setFilterButtons();

								//after modal displayed for first time, set initMeParam to false
								//so logic that one time property setting code is not executed again
								for (var y = 0; y < $scope.recodeTree.dimensions.length; y++) {
									if ($scope.recodeTree.dimensions[y].initializeToMeParam) {
										$scope.recodeTree.dimensions[y].initializeToMeParam = false;
									}
								}
							});
						});
					}
					$("#filterRecodeTreeModal").show();
					return;
				}

				$scope.btnFilterRecodeTreeClose = function (evt) {
					closeDialog();
				};

				$scope.listFilterRecodeTreeSelected = function (availValue, evt) {
					//if user entered text to search on then the values in avail list
					//are different objects then values in selected list, so update corresponding class in avail list
					var resetAvailList = false;
					if ($scope.recodeTree.availTreeValues[0] && $scope.recodeTree.availTreeValues[0].listType
						 && $scope.recodeTree.availTreeValues[0].listType == "search") {
						resetAvailList = true;
					}
					if (resetAvailList) {
						for (var x = 0; x < $scope.recodeTree.selectedTreeValues.length; x++) {
							if (availValue.qText == $scope.recodeTree.selectedTreeValues[x].qText
								 && availValue.shortName == $scope.recodeTree.selectedTreeValues[x].shortName) {
								setSelected($scope.recodeTree.selectedTreeValues[x], resetAvailList);
							}
						}
						for (var x = 0; x < $scope.recodeTree.availTreeValues.length; x++) {
							if (availValue.qText == $scope.recodeTree.availTreeValues[x].qText &&
								availValue.shortName == $scope.recodeTree.availTreeValues[x].shortName) {
								$scope.recodeTree.availTreeValues[x].class = "s";
							}
						}
					} else {
						setSelected(availValue, resetAvailList);
					}
					//check if parent
					setFilterButtons();
				};

				$scope.listFilterRecodeTreeUnselected = function (value, evt) {
					var resetAvailList = false;
					if ($scope.recodeTree.availTreeValues[0] && $scope.recodeTree.availTreeValues[0].listType
						 && $scope.recodeTree.availTreeValues[0].listType == "search") {
						resetAvailList = true;
					}
					clearSelected(value, resetAvailList);
					setFilterButtons();
				};

				function setSelected(value, resetAvailList) {
					if (value.class == 'x')
						return;

					value.selected = true;
					value.class = 's';
					//if all branch nodes are selected, mark branch as selected too
					var parent = value;
					for (var lvl = parent.level - 1; lvl >= 0; lvl--) {
						var parent = findParent(parent, $scope.recodeTree.selectedTreeValues);
						if (parent) {
							parent.selected = true;

							var kids = findChildren(parent, $scope.recodeTree.selectedTreeValues);
							if (kids.filter(function (elm) {
									return elm.class == "s";
								}).length == kids.length) {
								parent.class = "s";
							} else {
								//show in both avail list and selectedList since parent has kids in bpth lists
								parent.class = "t";
							}
						}
					}

					if (!resetAvailList) {
						processLevel(value);
					}
					function processLevel(value) {
						var list = findChildren(value, $scope.recodeTree.selectedTreeValues);
						for (var i = 0; i < list.length; i++) {
							list[i].selected = true;
							list[i].class = 's';
							processLevel(list[i]);
						}
					}
				}

				function findMatchingSelectedDimValue(availItem, dim) {
					if(dim.nonRecodeValues) {
						for(let x = 0; x < dim.nonRecodeValues.length; x++) {
							if(dim.nonRecodeValues[x].qText == availItem.qText) {
								//console.log('non-recode', availItem);
								return availItem;
							}
						}
					}
					if(dim.categories) {
						for(let x = 0; x < dim.categories.length; x++) {
							if(dim.categories[x].selected && dim.categories[x].qText == availItem.qText) {
								//console.log('cat', availItem);
								return availItem;
							}
						}
					} else {
						if(dim.values) {
							//dim not recoded, only hierarchy structure was modified
							for(let x = 0; x < dim.values.length; x++) {
								if(dim.values[x].qText == availItem.qText) {
									//console.log('value', availItem);
									return availItem;
								}
							}
						}
					}
					return null;
				}

				function setImportSelectedState(value, dimLevels) {

					//Start with lowest level value, work up chain to top level, check if parent is selected.  
					//If all parents are selected then mark value selected, otherwise mark unselected
					if(value.level > 0) {
						let parent = findParent(value, $scope.recodeTree.selectedTreeValues);
						let matchedValue = findMatchingSelectedDimValue(parent, dimLevels[parent.level])

						if(matchedValue != null && matchedValue.selected) {
							var kids = findChildren(value, $scope.recodeTree.selectedTreeValues);
							if(kids.length == 0) {
								value.selected = true;
								value.class = "s";
							} else {
								//show in both avail list and selectedList since item has kids in bpth lists
								value.selected = true;
								value.class = "t";
							}
						}
					} else {
						var kids = findChildren(value, $scope.recodeTree.selectedTreeValues);
						if (kids.filter(function (elm) {
								return elm.class == "s";
							}).length == kids.length) {
							value.selected = true;
							value.class = "s";
						} else {
							//show in both avail list and selectedList since item has kids in bpth lists
							value.selected = true;
							value.class = "t";
						}
					}
				}

				function clearSelected(value, resetAvailList) {
					value.class = 'o';
					value.selected = false;
					if (resetAvailList) {
						var availVal = findItem(value, $scope.recodeTree.availTreeValues);
						if (availVal != null)
							availVal.class = 'o';
					}

					processLevel(value);
					function processLevel(value) {
						//Traverse tree to find lowest level and mark the item unselected
						var list = findChildren(value, $scope.recodeTree.selectedTreeValues);
						for (var i = 0; i < list.length; i++) {
							list[i].class = 'o';
							list[i].selected = false;
							if (resetAvailList) {
								var availVal = findItem(list[i], $scope.recodeTree.availTreeValues);
								if (availVal != null)
									availVal.class = 'o';
							}
							processLevel(list[i]);
						}
					}

					if (!resetAvailList) {
						var parent = value;
						for (var lvl = parent.level; lvl >= 0; lvl--) {
							var parent = findParent(parent, $scope.recodeTree.selectedTreeValues);
							if (parent) {
								var kids = findChildren(parent, $scope.recodeTree.selectedTreeValues);
								if (kids.filter(function (elm) {
										return elm.class == "s" || elm.class == "t";
									}).length == 0) {
									parent.class = "o";
									//no more children, so remove value from filter if it has been applied
									parent.selected = false;
								} else {
									parent.class = "t";
								}
							}
						}
					}
				}

				function findItem(searchValue, searchArray) {
					for (var i = 0; i < searchArray.length; i++) {
						if (searchArray[i].qText == searchValue.qText
							 && searchArray[i].shortName == searchValue.shortName) {
							return searchArray[i];
						}
					}
					return null;
				}

				function findParent(searchValue, searchArray) {
					for (var i = 0; i < searchArray.length; i++) {
						if (searchArray[i].listId == searchValue.parentId) {
							return searchArray[i];
						}
					}
					return searchValue;
				}

				function findChildren(searchValue, searchArray) {
					var retArr = [];
					for (var i = 0; i < searchArray.length; i++) {
						if (searchArray[i].parentId == searchValue.listId) {
							retArr.push(searchArray[i]);
						}
					}
					return retArr;
				}

				function setFilterButtons(disable) {
					if (disable) {
						$scope.disableActions = true;
						$scope.disableAddAll = true;
						$scope.disableClearAll = true;
						$("#filterTreeModal .avail-list li").addClass("disable-item");
						$("#filterTreeModal .selected-list li").addClass("disable-item");
					} else {
						$("#filterTreeModal .avail-list li").removeClass("disable-item");
						$("#filterTreeModal .selected-list li").removeClass("disable-item");
						var selected = appUtilities.findValuesMatches("class", ["s", "t"], $scope.recodeTree.selectedTreeValues).length;
						if (selected > 0 || $scope.recodeTree.selectedValuesCount > 0) {
							$scope.disableActions = false;
						} else {
							$scope.disableActions = true;
						}
						if (selected > 0) {
							$scope.disableClearAll = false;
						} else {
							$scope.disableClearAll = true;
						}
						var avail = appUtilities.findMatches("class", "o", $scope.recodeTree.availTreeValues).length;
						if (avail > 0) {
							$scope.disableAddAll = false;
						} else {
							$scope.disableAddAll = true;
						}
						$scope.selectedRecodeTreeFilterCountsMsg = selected + " selected";
					}
				}

				function closeDialog(evt) {
					$("#filterRecodeTreeModal").hide();
					$rootScope.selAltState.clearAll(false);
					$scope.closeLeftRail();;
					isOpenFromLeftRail = true;
					$scope.showRecodeTreeSearchText = false;
				};

				function filterListCallBack(reply) {
					listObjId = reply.qInfo.qId;
				}

				function destroyObj() {
					appObj.destroySessionObject(listObjId).then(function (obj) {}, function (err) {
						//console.log('destroyObj err', err);
					});
				}

				$scope.checkRecodeTreeDimension = function (dim) {
					renderList().then(function () {
						$scope.recodeTree.selectedTreeValues = $scope.recodeTree.availTreeValues;
						setFilterButtons();
					});
				}

				$scope.txtSearchRecodeTreeFilterChange = function (evt) {
					var textChange = function () {
						if ($scope.recodeTree.searchFilterTreeText.length == 0 ||
							$scope.recodeTree.searchFilterTreeText.length > 2) {
							renderList().then(function () {
								if ($scope.recodeTree.searchFilterTreeText.length == 0) {
									for (var x = 0; x < $scope.recodeTree.availTreeValues.length; x++) {
										$scope.recodeTree.availTreeValues[x].class = $scope.recodeTree.selectedTreeValues[x].class;
										$scope.recodeTree.availTreeValues[x].selected = $scope.recodeTree.selectedTreeValues[x].selected;
									}
									$scope.recodeTree.selectedTreeValues = $scope.recodeTree.availTreeValues;
								}
								return;
							});
						} else
							return;
					}
					_.debounce(textChange, 300, false)();
				};

				$scope.btnFilterRecodeTreeClearSearchBox = function (evt) {
					$scope.recodeTree.searchFilterTreeText = "";
					$scope.showRecodeTreeSearchText = false;
					renderList().then(function () {
						for (var x = 0; x < $scope.recodeTree.availTreeValues.length; x++) {
							$scope.recodeTree.availTreeValues[x].class = $scope.recodeTree.selectedTreeValues[x].class;
							$scope.recodeTree.availTreeValues[x].selected = $scope.recodeTree.selectedTreeValues[x].selected;
						}
						$scope.recodeTree.selectedTreeValues = $scope.recodeTree.availTreeValues;
						setFilterButtons();
					});
				};

				$scope.btnFilterRecodeTreeUpdate = function () {
					upd();
					$rootScope.$broadcast('resetExpandedEvent');
				}

				$scope.btnFilterRecodeTreeUpdChart = function () {
					upd();
				}

				function upd() {
					$scope.toggleReadOnly(true);
					setFilterButtons(true);
					
					var id = $("#variablesCols [data-cid='" + $scope.recodeTree.cId + "']");
					var toCol = id.length > 0 ? true : false;
					closeDialog();
					hyperCubeProperties.updateRecodeTreeFilterValue(appObj, $rootScope, $scope, $scope.recodeTree, toCol).then(function (action) {
						if (action == "del") {
							$scope.clearRecodeTreeFilter($scope.recodeTree);
							//qlik.resize(); //manually trigger listener event, needed to reenable left rail after removing dim
							$rootScope.$broadcast('modifiedVisualizationEvent');
							$scope.toggleReadOnly(false); //resize() not working
						} else {
							$scope.recodeTree.selectedValuesCount = $scope.recodeTree.selectedTreeValues.filter(function(value) {
								if (value.class === 's' || value.class === 't') {
									return value;
								}
							}).length

							$scope.recodeTree.selected = true;
							$scope.recodeTree.savedList = $scope.recodeTree.selectedTreeValues;
							$scope.recodeTree.savedDims = $scope.recodeTree.dimensions;
						}
						hyperCubeProperties.getSelectedAssociations($rootScope, $scope.recodeTree);
						
					}, function (err) {
						appUtilities.showError(err);
					});
				}

				$scope.btnFilterRecodeTreeAddColumn = function () {
					add(true);
				}

				$scope.btnFilterRecodeTreeAddRow = function () {
					add(false)
				}

				$scope.btnFilterRecodeTreeAddChart = function () {
					add(false)
				}

				function add(toCol) {
					$scope.toggleReadOnly(true);
					setFilterButtons(true);
					//google analytics tracking
					var tags = $scope.recodeTree.dimensions.map(function (x) {
						return x.shortName;
					}).toString();
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Select recode', {
						'event_label': $rootScope.startingPoint,
						'event_category': 'recode_select',
						'event_variable': tags
					});

					closeDialog();
					//$rootScope.leftRail.card2.dim.selected = true;
					hyperCubeProperties.updateRecodeTreeFilterValue(appObj, $rootScope, $scope, $scope.recodeTree, toCol).then(function () {
						$scope.recodeTree.selectedValuesCount = $scope.recodeTree.selectedTreeValues.filter(function(value) {
							if (value.class === 's' || value.class === 't') {
								return value;
							}
						}).length

						$scope.recodeTree.savedList = $scope.recodeTree.selectedTreeValues;
						$scope.recodeTree.savedDims = $scope.recodeTree.dimensions;
						$scope.recodeTree.selected = true;
						hyperCubeProperties.getSelectedAssociations($rootScope, $scope.recodeTree);
					}, function (err) {
						appUtilities.showError(err);
					});
				}

				$scope.btnAddAllRecodeTreeSelections = function (evt) {

					var resetAvailList = false;
					if ($scope.recodeTree.availTreeValues[0] && $scope.recodeTree.availTreeValues[0].listType
						 && $scope.recodeTree.availTreeValues[0].listType == "search") {
						resetAvailList = true;
					}

					if (resetAvailList) {
						for (var x = 0; x < $scope.recodeTree.availTreeValues.length; x++) {
							for (var y = 0; y < $scope.recodeTree.selectedTreeValues.length; y++) {
								if ($scope.recodeTree.availTreeValues[x].qElemNumber == $scope.recodeTree.selectedTreeValues[y].qElemNumber
									 && $scope.recodeTree.availTreeValues[x].shortName == $scope.recodeTree.selectedTreeValues[y].shortName) {
									$scope.recodeTree.availTreeValues[x].class = 's';
									setSelected($scope.recodeTree.selectedTreeValues[y], resetAvailList);
								}
							}
						}
					} else {
						var level = $scope.recodeTree.dimensions.length - 1;
						for (var i = 0; i < $scope.recodeTree.selectedTreeValues.length; i++) {
							$scope.recodeTree.selectedTreeValues[i].selected = true;
							$scope.recodeTree.selectedTreeValues[i].class = 's';
						};
					}
					setFilterButtons();
				};

				$scope.btnFilterRecodeTreeClearAllSelections = function (evt) {

					if ($scope.recodeTree.searchFilterTreeText.length > 0) {
						for (var x = 0; x < $scope.recodeTree.availTreeValues.length; x++) {
							for (var y = 0; y < $scope.recodeTree.selectedTreeValues.length; y++) {
								if ($scope.recodeTree.availTreeValues[x].qElemNumber == $scope.recodeTree.selectedTreeValues[y].qElemNumber
									 && $scope.recodeTree.availTreeValues[x].shortName == $scope.recodeTree.selectedTreeValues[y].shortName) {
									$scope.recodeTree.availTreeValues[x].class = 'o'; //$scope.recodeTree.selectedTreeValues[y].class;
									$scope.recodeTree.availTreeValues[x].selected = false; //$scope.recodeTree.selectedTreeValues[y].selected;
								}
							}
						}
					}

					for (var x = 0; x < $scope.recodeTree.selectedTreeValues.length; x++) {
						var value = $scope.recodeTree.selectedTreeValues[x];
						if (value.class == 's' || value.class == 't') {
							value.class = 'o'
								value.selected = false;
						}
					}
					setFilterButtons();
				};

				function getDimListDef(startRow, name) {
					var dimListDef = {
						qInfo: {
							qType: "filter"
						},
						qListObjectDef: {
							qDef: {
								qFieldDefs: [name],
								qSortCriterias: [{
										qSortByAscii: 1,
										//qSortByLoadOrder: 1
									}
								]
							},
							qShowAlternatives: true,
							qStateName: "altState1",
							qInitialDataFetch: [{
									qLeft: 0,
									qWidth: 1,
									qTop: startRow,
									qHeight: 5000
								}
							]
						}
					}
					return dimListDef;
				}

				function getDimHierarchyDef(startRow) {
					var dimDef = {};
					dimDef.qHyperCubeDef = {
						qSuppressZero: true,
						qSuppressMissing: true,
						qMode: "S"
					};

					dimDef.qHyperCubeDef.qDimensions = [];
					for (var x = 0; x < $scope.recodeTree.dimensions.length; x++) {
						if ($scope.recodeTree.dimensions[x].selected) {
							if ($scope.recodeTree.dimensions[x].type == "dim-branch") {
								dimDef.qHyperCubeDef.qDimensions.push({
									qDef: {
										qFieldDefs: [$scope.recodeTree.dimensions[x].shortName],
										qSortCriterias: [{
												qSortByAscii: 0,
												qSortByLoadOrder: 1
											}
										]
									}
								});
							} else if ($scope.recodeTree.dimensions[x].type == "recode") {

								var recodeDef = hyperCubeProperties.buildRecode($scope.recodeTree.dimensions[x], $scope.recodeTree.dimensions[x]);

								dimDef.qHyperCubeDef.qDimensions.push({
									qDef: {
										qFieldDefs: [recodeDef],
										qFieldLabels: [$scope.recodeTree.dimensions[x].recodeName],
										qSortCriterias: [{
												qSortByAscii: 0,
												qSortByLoadOrder: 1
											}
										]
									}
								});
							};
						};
					};

					dimDef.qHyperCubeDef.qMeasures = [{
							qDef: {
								//qDef : "1"
								qDef: "=Count(1)"
							}
						}
					];
					dimDef.qHyperCubeDef.qStateName = "altState1";
					dimDef.qHyperCubeDef.qInitialDataFetch = [{
							qLeft: 0,
							qTop: startRow,
							qWidth: 5,
							qHeight: 2000
						}
					];
					return dimDef;
				}

				$scope.toggleRecodeTreeSearchText = function(){
					$scope.showRecodeTreeSearchText = true;

				}

				/******
				The matrix processing can be confussing so this comment	describes the matrix structure to help developer understand the
				processing logic that follows.

				// qArea:
				// qLeft: 0
				// qTop: 0
				// qWidth: 4  //3 dims selected: S&EFields, BroadFields, and DetailedFields
				// qHeight: 39
				// __proto__: Array(0)
				0: Array(4)
				0: {qText: "Non-science and engineering", qNum: "NaN", qElemNumber: 1, qState: "O"}
				1: {qText: "Education", qNum: "NaN", qElemNumber: 5, qState: "O"}
				2: {qText: "Education administration", qNum: "NaN", qElemNumber: 18, qState: "O"}
				3: {qText: "1", qNum: 1, qElemNumber: 0, qState: "L"}
				length: 4
				__proto__: Array(0)
				1: Array(4)
				0: {qText: "Non-science and engineering", qNum: "NaN", qElemNumber: 1, qState: "O"}
				1: {qText: "Education", qNum: "NaN", qElemNumber: 5, qState: "O"}
				2: {qText: "Education research", qNum: "NaN", qElemNumber: 11, qState: "O"}
				3: {qText: "1", qNum: 1, qElemNumber: 0, qState: "L"}
				//console.log('matrix', hyperCube.layout.qHyperCube.qDataPages[0].qMatrix);
				 ******/
				var cntr = (function () {
					var cnt = 0;
					return function () {
						cnt += 1;
						return cnt
					}
				})();

				function buildList(modal, hyperCube) {
					modal = document.querySelector("#filterRecodeTreeModal");
					var colsFilled = [];
					var availList = [];
					var cnt = 0;
					var selDims = appUtilities.findMatches("selected", true, $scope.recodeTree.dimensions);
					//code for converting matrix into a table with inedented rows
					hyperCube.layout.qHyperCube.qDataPages[0].qMatrix.forEach(function (e) {
						for (var x = 0; x < hyperCube.layout.qHyperCube.qDataPages[0].qArea.qWidth; x++) {
							if (e[x].qState !== 'L') {
								if (colsFilled[x] == null
									 || (colsFilled[x].qElemNumber !== e[x].qElemNumber
										 && colsFilled[x].shortName !== e[x].shortName)) {
									colsFilled[x] = e[x];
									populateArray(colsFilled, availList, e, x);
								}
							}
						}
					});
					$scope.recodeTree.availTreeValues = availList;

					function populateArray(colsFilled, availList, e, x) {
						if (x == 0) {
							e[x].parent = null;
							e[x].parentId = null
						} else {
							e[x].parent = colsFilled[x - 1].qText;
							e[x].parentId = colsFilled[x - 1].listId; //e[x-1].qElemNumber;
						}
						e[x].level = x;
						e[x].shortName = selDims[x].shortName;
						//mark field value as recoded to flag it within filtering logic to be replaced with the recode's underlying values
						if(selDims[x].categories != null) {
							for(var y = 0; y < selDims[x].categories.length; y++) {
								if(e[x].qText == selDims[x].categories[y].qText)
									e[x].recode = true;
							}
						}
						e[x].qId = selDims[x].qId;
						e[x].listId = cnt++;
						e[x].padding = {
							'padding-left': (x * 15) + 'px'
						};
						//if dim was paseed in from ME, set all values to show in right side (selected) list
						if (selDims[x].initializeToMeParam) {
							e[x].class = 's';
						} else {
							e[x].class = e[x].qState.toLowerCase();
						}
						availList.push(e[x]);

					}
				}

				function renderList() {
					return new qlik.Promise(function (resolve, reject) {
						var values = [];
						var startRow = 0;
						var modal;

						modal = document.querySelector("#filterRecodeTreeModal");
						getListPage(startRow).then(function (hyperCube) {
							if (hyperCube != null) {
								buildList(modal, hyperCube);
							}
							return resolve();
						}, function (err) {
							console.log('err', err);
						});

						function getListPage(startRow) {
							return new qlik.Promise(function (resolve, reject) {
								if ($scope.recodeTree.searchFilterTreeText !=null && $scope.recodeTree.searchFilterTreeText.length > 0) {
									//logic for looping promise calls; need to build list after sequentially retrieving search results for each dimension in tree
									$scope.recodeTree.availTreeValues = [];
									var p = Promise.resolve();
									var selDims = appUtilities.findMatches("selected", true, $scope.recodeTree.dimensions);
									for (var i = 0; i < selDims.length; i++) {
										var x = 0;
										p = p.then(function () {
											return new Promise(function (resolve, reject) {
												var dimName = selDims[x].shortName;
												var qId = selDims[x].qId;
												appObj.createGenericObject(getDimListDef(startRow, dimName), filterListCallBack).then(function (dimList) {
													dimList.searchListObjectFor("/qListObjectDef", $scope.recodeTree.searchFilterTreeText).then(function (resp) {
														destroyObj();
														dimList.getLayout().then(function (layout) {
															if (layout.qListObject.qDataPages.length > 0) {
																var data = layout.qListObject.qDataPages[0].qMatrix;
																data.forEach(function (e) {
																	var obj = e[0];
																	obj.shortName = dimName;
																	obj.qId = qId;
																	obj.class = 'o';
																	obj.listType = "search";
																	$scope.recodeTree.availTreeValues.push(obj);
																});
																x += 1;
																return resolve();
															} else {
																x += 1;
																return resolve();
															}

														});
													}, function (err) {
														console.log('searchFilter', err);
														return reject(err);
													});
												}, function (err) {
													console.log('searchFilter', err);
													return reject(err);
												});
											});
										}, function (err) {
											console.log('searchFilter', err);
											return reject(err);
										});
									};
									p.then(function () {
										return resolve();
									});

								} else {
									appObj.createGenericObject(getDimHierarchyDef(startRow)).then(function (hcObj) {
										return resolve(hcObj);
									}, function (err) {
										console.log('err', err);
									});
								};
							})

						};
					});
				};
			}
		]);
});

'use strict'
define('scripts/directives/recodeEditDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, dimensions, recodes) {

	angular.module("appModule").directive("dtRecodeEdit", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeEdit.html',
			scope: true,
			controller: 'RecodeEditController'
		}
	});

	/********** Notes:
	json structure showing recodes
	dim.recodes: array of recodes defined for the dimension
	dim.recodes[x].recode: object that contains a dimension recode definition
	dim.recodes[x].recode.categories: array of value categories that are part of a dimension recode
	dim.recodes[x].recode.categories[x].value: object that defines a value category
	dim.recodes[x].recode.nonRecodeValues: array of dimension values that are not part of a category

	 ********/
	angular.module("appModule").controller("RecodeEditController", ["$scope", "$rootScope",
			function ($scope, $rootScope) {
				var qApp = $rootScope.qApp;
				$scope.checkedValueCount = 0;
				$scope.recode = {};
				$scope.recode.recodeName = "";
				//$scope.disableNewCategories = false;
				$scope.goodMsg = null;
				$scope.changesPending = false;

				let initRecode, catsChanged = false;
				let source, action;
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

				//event handler added to delay setting form fields until after angular has run digest after bootstrap .show() has completerd.
				$scope.$on('recodeEditModalShownEvent', function (event) {				
					$scope.recodeEditForm.recodeEditName.$parsers = [];
					$scope.recodeEditForm.recodeEditName.$parsers.push(validateRecodeName);
					$scope.recodeEditForm.$setPristine();
					$scope.recodeEditForm.recodeEditName.$setPristine();
				})
				
				var validateRecodeName = function (val) {
					for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
						var topic = $rootScope.dimensionProperties.apiDimTopics[x];						
						for (var y = 0; y < topic.dimensionGroups.length; y++) {
							var grp = topic.dimensionGroups[y];
							for (var z = 0; z < grp.dimensions.length; z++) {
								if (grp.dimensions[z].recodes) {
									for (var a = 0; a < grp.dimensions[z].recodes.length; a++) {
										let item = grp.dimensions[z].recodes[a];
										if ($scope.recode.cId == null || $scope.recode.cId != item.cId) {
											if (val.toLowerCase() == item.recodeName.toLowerCase()) {
												$scope.recodeEditForm.recodeEditName.$setValidity('noNameConflict', false);
												return;
											}
										}
									}
								}
								else if (grp.dimensions[z].hierarchyAvailable == "Y") {
									let recodeTrees = grp.dimensions[z].recodeTrees;
									if(recodeTrees != null) {
										for (var a = 0; a < recodeTrees.length; a++) {
											let item = recodeTrees[a];
											if ($scope.recode.cId == null || $scope.recode.cId != item.cId) {
												if (val.toLowerCase() == item.treeName.toLowerCase()) {
													$scope.recodeEditForm.recodeEditName.$setValidity('noNameConflict', false);
													return;
												}
											}
										}
									}

									let sharedTrees = grp.dimensions[z].commonRecodeTrees;				
									if(sharedTrees != null) {
										for (var a = 0; a < sharedTrees.length; a++) {
											let item = sharedTrees[a];
											if ($scope.recode.cId == null || $scope.recode.cId != item.cId) {
												if (val.toLowerCase() == item.treeName.toLowerCase()) {
													$scope.recodeEditForm.recodeEditName.$setValidity('noNameConflict', false);
													return;
												}
											}
										}
									}
								}
							}
						};
					};
					$scope.recodeEditForm.recodeEditName.$setValidity('noNameConflict', true);
					return val;					
				};


				$rootScope.$on('openRecodeEditEvent', function(e, act, src, dim, recode) {
					source = src;
					action = act;
					$scope.dim = dim;
					$scope.dimName = $scope.dim.title;
					$scope.modalTitle = "Edit Custom Dimension";

					$scope.recode = JSON.parse(JSON.stringify(recode));
					initRecode = recode;

					$scope.goodMsg = null;
					$scope.checkedValueCount = 0;
					$scope.checkedValueCount = 0;
					$scope.searchRecodeText = "";
					$("#recodeEdit").show();
					$scope.catEditMode = false;
					$scope.changesPending = false;
					catsChanged = false;
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Edit recode', {
						'event_label': $rootScope.startingPoint,
						'event_category': 'recode_open_edit',
						'event_variables': dim.shortName
					})
					$scope.$emit('recodeEditModalShownEvent');
				})

				$rootScope.$on('reopenRecodeEditEvent', function() {
					$scope.goodMsg = null;
					$("#recodeEdit").show();
				})

				$rootScope.$on('refreshRecodeEditEvent', function(e, action, cat, categories) {
					let label = null;
					$scope.recode.categories = categories;
					if(action == $rootScope.recodeAction.NoAction) {
						$scope.goodMsg = label;
					} else {
						if(action == $rootScope.recodeAction.AddCategory){
							catsChanged = true;
						 	label = "added";
						} else if(action == $rootScope.recodeAction.EditCategory){
							catsChanged = true;
							label = "updated";
						}
						$scope.goodMsg="<i class='fa-sharp fa-solid fa-circle-check'></i> " + cat.qText + " successfully " + label + ". Will be applied upon save."
					}
					checkChanges();
					$("#recodeEdit").show();
				})

				$scope.btnClose = function () {
					$("#recodeEdit").hide();
					if($scope.recode.categories.length == 0) {
						$("#promptRecodeDelete").show();
					}
				}
				
				$scope.btnCloseSave = function () {
					if($scope.changesPending && $scope.recodeEditForm.recodeEditName.$valid && $scope.recode.categories.length > 0) {
						initRecode.recodeName = $scope.recode.recodeName; 
						initRecode.categories = $scope.recode.categories;
						if(initRecode.selected) {
							initRecode.categories.forEach(v => v.selected = true)
						}
						//google analytics tracking
						gtag('event', displayType + $rootScope.survey.abbreviation + '-Update recode', {
							'event_label': $rootScope.startingPoint,
							'event_category': 'recode_update',
							'event_variable': $scope.dim.shortName
						});							
						applyRecodeUpdate().then(function() {
							$("#recodeEdit").hide();
							if(source == $rootScope.eventSrc.EditTreePage) {
								$rootScope.$broadcast('refreshRecodeEditTreeEvent', action, initRecode); 
							}
						}, function(err) {
							appUtilities.showError(err);
						})
					} else {
						$("#recodeEdit").hide();
						if($scope.recode.categories.length == 0) {
							$("#promptRecodeDelete").show();
						}						
					}
				}

				$scope.txtChgRecodeName = function() {
					checkChanges();
				}

				function checkChanges() {
					if(initRecode.recodeName == $scope.recode.recodeName && catsChanged == false) {
						$scope.changesPending = false;
					} else {
						$scope.changesPending = true;
					}
				}

				$scope.btnShowConfirmRecodeDelete = function() {				
					$("#recodeConfirmDelete").show();
					$("#recodeEdit").hide();	
				}

				$scope.btnCloseConfirmRecodeDelete = function () {
					$("#recodeEdit").show();	
					$("#recodeConfirmDelete").hide();
				}	

				$scope.btnPromptDeleteRecodeClose = function() {
					$("#recodeEdit").show();
					$("#promptRecodeDelete").hide();
				}

				$scope.btnPromptDeleteRecode = function() {
					$scope.btnRecodeDelete();
					$("#promptRecodeDelete").hide();
				}

				$scope.btnRecodeDelete = function() {
					$scope.removeRecode($scope.recode.cId).then(function() {
						for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
							var topic = $rootScope.dimensionProperties.apiDimTopics[x];
							
							for (var y = 0; y < topic.dimensionGroups.length; y++) {
								var grp = topic.dimensionGroups[y];
								for (var z = 0; z < grp.dimensions.length; z++) {
									if (grp.dimensions[z].recodes) {
										for (var a = 0; a < grp.dimensions[z].recodes.length; a++) {
											if (grp.dimensions[z].recodes[a].cId == $scope.recode.cId) {
												grp.dimensions[z].recodes.splice(a, 1);
											}
										}
									}
									else if (grp.dimensions[z].hierarchyAvailable == "Y") {
										var tmpTrees = grp.dimensions[z].recodeTrees;
										if(tmpTrees != null) {
											for (var z = 0; z < tmpTrees.length; z++) {
												if (tmpTrees[z].cId == $scope.recode.cId) {
													tmpTrees[z] = tmpTrees.splice(z, 1)
												}
											}
										}
									}
								}
							};
						};						
						$rootScope.$broadcast('rebuildRecodesListEvent');
						$("#recodeEdit").hide();						
						$("#recodeConfirmDelete").hide();

						let genericNotice = {};
						genericNotice.showNoticeFlag = true;
						genericNotice.borderClass = 'border-green';
						genericNotice.bannerMsg = `
							<span class="pr-2">
								<span class="banner-title banner-color-green pr-2">
									<i class="fa-sharp fa-solid fa-circle-check"></i>
								</span>
								<span class="banner-text banner-color-green">
									` + $scope.recode.recodeName + ` successfully deleted.
								</span>
							</span>`;
						genericNotice.showFullMsgFlag = false;
						$rootScope.$broadcast('displayGenericNoticeEvent', genericNotice);

					}, function(err) {
						appUtilities.showError(err);
					})					
				}					

				$scope.btnToggleCatEdit = function() {
					$scope.catEditMode = !$scope.catEditMode;
				}
				
				$scope.btnOpenAddCat = function() {
					$scope.goodMsg = null;
					if($scope.recode.shortName == "instName") {
						$scope.$emit('openRecodeEditInstEvent', $rootScope.recodeAction.AddCategory, $rootScope.eventSrc.EditRecodePage, $scope.dim, $scope.recode);
					} else {
						$scope.$emit('openRecodeEditCatEvent', $rootScope.recodeAction.AddCategory, $rootScope.eventSrc.EditRecodePage, $scope.dim, $scope.recode);
					}
					$("#recodeEdit").hide();
				}

				$scope.btnOpenEditCat = function(cat) {
					$scope.goodMsg = null;
					if($scope.recode.shortName == "instName") {
						$scope.$emit('openRecodeEditInstEvent', $rootScope.recodeAction.EditCategory, $rootScope.eventSrc.EditRecodePage, $scope.dim, $scope.recode, cat);
					} else {
						$scope.$emit('openRecodeEditCatEvent', $rootScope.recodeAction.EditCategory, $rootScope.eventSrc.EditRecodePage, $scope.dim, $scope.recode, cat);
					}
					$("#recodeEdit").hide();
				}

				$scope.btnOpenDeleteCat = function(cat) {
					$scope.selectedCat = cat
					$scope.goodMsg = null;
					$("#recodeDeleteCat").show();
				}			
				
				$scope.btnDeleteCat = function() {
					//google analytics tracking
/* 					gtag('event', displayType + $rootScope.survey.abbreviation + '-Delete recode category', {
						'event_label': 'delete',
						'event_category': 'recode_delete_cat',
						'event_variable': $scope.dim.shortName
					});	 */						
					let i = $scope.recode.categories.findIndex(cat => cat.cId == $scope.selectedCat.cId);
					$scope.recode.categories.splice(i, 1);
					$("#recodeDeleteCat").hide();
					catsChanged = true;
					checkChanges();
					$scope.catEditMode = $scope.recode.categories.length > 0?true:false;
					$scope.goodMsg="<i class='fa-sharp fa-solid fa-circle-check'></i> " + $scope.selectedCat.qText + " successfully deleted. " + ($scope.recode.categories.length > 0?" Will be applied upon save.":"")
				}			

				$scope.btnDeleteCatClose = function () {
					$("#recodeDeleteCat").hide();
				}

				$scope.btnMsgClose = function () {
					$scope.goodMsg = null;
				}				
 				
				function applyRecodeUpdate() {
					return new qlik.Promise(function(resolve, reject) {
						if($scope.recode.selected) {
							$scope.toggleReadOnly(true);

							hyperCubeProperties.applyRecode(qApp, $rootScope, $scope).then(function () {
								deselectNonRecodeValues();
								$rootScope.$broadcast('rebuildRecodesListEvent');
								return resolve();	
							}, function (err) {
								return reject(err);
							});
						} else {
							return resolve();
						}
					})
				}

				function deselectNonRecodeValues() {
					var allCategories = $scope.recode.categories;
					if (allCategories != null) {
						for (var x = 0; x < allCategories.length; x++) {
							if (allCategories[x].selected) {
								for (var y = 0; y < allCategories[x].values.length; y++) {
									for (var z = 0; z < $scope.recode.nonRecodeValues.length; z++) {
										if(allCategories[x].values[y].qText == $scope.recode.nonRecodeValues[z].qText
										&& $scope.recode.nonRecodeValues[z].selected) {
											$scope.recode.nonRecodeValues[z].selected = false;
										}
									}
								}
							}
						}
					}
				}
			}
		]);
});

'use strict'
define('scripts/directives/recodeEditTreeDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, dimensions, recodes) {

	angular.module("appModule").directive("dtRecodeEditTree", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtRecodeEditTree.html',
			scope: true,
			controller: 'RecodeEditTreeController'		
		}
	});

	/********** Notes:
	json structure showing tree recodes which are stored in the hierarchy root dimension:
	rootDim.recodeTrees: array of recodes defined for the root dimension
	rootDim.recodeTrees[x].recodeTree: object that contains a set of dimensions that will define the recode
	rootDim.recodeTrees[x].recodeTree.name: user given recode name 
	rootDim.recodeTrees[x].recodeTree.dimensions: array of dimensions that define a custom recode tree
	rootDim.recodeTrees[x].recodeTree.dimensions[x].recodes[]: an array of recodes for a recode tree object
	rootDim.recodeTrees[x].recodeTree.dimensions[x].recodes[x].categories: array of value categories that are part of a dimension recode
	rootDim.recodeTrees[x].recodeTree.dimensions[x].recodes[x].categories[x].value: object that defines a value for a category object
	rootDim.recodeTrees[x].recodeTree.dimensions[x].recodes[x].nonRecodeValues: array of dimension values that are not part of a category

	 ********/

	angular.module("appModule").controller("RecodeEditTreeController", ["$scope", "$rootScope",
			function ($scope, $rootScope) {
				var qApp = $rootScope.qApp;
				$scope.checkedValueCount = 0;
				$scope.recode = {};
				$scope.recode.recodeName = "";
				
				var initRecode = {};
				var rootDim;
				// var allValues = [];
				// var searchValues = [];
				let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				let action, source;

				var validateRecodeName = function (val) {
					if (rootDim.recodeTrees != null) {
						for (var x = 0; x < rootDim.recodeTrees.length; x++) {
							if ($scope.recodeTree.cId == null || $scope.recodeTree.cId != rootDim.recodeTrees[x].cId) {
								if (val == rootDim.recodeTrees[x].treeName) {
									$scope.recodeTreeForm.treeName.$setValidity('noNameConflict', false);
									return;
								}
							}
						}
					}
					if (rootDim.recodes != null) {
						for (var x = 0; x < rootDim.recodes.length; x++) {
							if ($scope.recodeTree.cId == null || $scope.recodeTree.cId != rootDim.recodes[x].cId) {
								if (val == rootDim.recodes[x].recodeName) {
									$scope.recodeTreeForm.treeName.$setValidity('noNameConflict', false);
									return;
								}
							}
						}
					}
					$scope.recodeTreeForm.treeName.$setValidity('noNameConflict', true);
					return val;
				}
				
				$rootScope.$on('refreshRecodeEditTreeEvent', function(e, action, recode) {
					$("#editRecodeTree").show();
				})

 				$rootScope.$on('openRecodeEditTreeEvent', function(e, act, src, treeRootDim, recode) {
					source = src;
					action = act;
					if(action == $rootScope.recodeAction.AddRecode) {
						gtag('event', displayType + $rootScope.survey.abbreviation + '-Edit recodetree', {
							'event_label': $rootScope.startingPoint,
							'event_category': 'recode_open_edit',
							'event_variables': treeRootDim.shortName
						})
					}
					showRecodeTreePopup(treeRootDim, recode);
				})

				function showRecodeTreePopup(treeRootDim, recode) {
					$scope.dimName = treeRootDim.title;

					rootDim = treeRootDim;
					if(recode != null) {
						initRecode = recode;
						$scope.recodeTree = JSON.parse(JSON.stringify(initRecode)); 
					} else {
						initRecode = {};
						initRecode.dimensions = [];
						$scope.recodeTree =	initRecode;					
					}
					
					var srcRecode = {};	
 					if(rootDim.recodedSrcDims) {
						srcRecode.recodedSrcDims = rootDim.recodedSrcDims;
					} else {
						//srcRecode.recodedSrcDims = JSON.parse(JSON.stringify(tree.dimensions));
						srcRecode.recodedSrcDims = JSON.parse(JSON.stringify(dimensions.getDimensionsForTree(rootDim)));											
					}					
					$scope.sourceTree = JSON.parse(JSON.stringify(srcRecode));
					
					for (var x = 0; x < $scope.sourceTree.recodedSrcDims.length; x++) {
						disableSrcDimensions($scope.sourceTree.recodedSrcDims[x]);
						if($scope.sourceTree.recodedSrcDims[x].recodes != null) {
							for (var y = 0; y < $scope.sourceTree.recodedSrcDims[x].recodes.length; y++) {
								disableSrcDimensions($scope.sourceTree.recodedSrcDims[x].recodes[y]);
							}
						}
					}
					$("#editRecodeTree").show();
					$scope.recodeTreeForm.treeName.$parsers = [];
					$scope.recodeTreeForm.treeName.$parsers.push(validateRecodeName);
					$scope.recodeTreeForm.$setPristine();
					$scope.recodeTreeForm.treeName.$setPristine();					
				}

				$scope.btnRecodeTreeCloseClick = function () {
					$("#editRecodeTree").hide();
				}

				$scope.btnBack = function () {
					if(source == $rootScope.eventSrc.SelectDimensionPage) {
						$scope.$emit('reopenRecodeSelectDimEvent');
					} else if(source == $rootScope.eventSrc.FinishedCreatePage) {
						$rootScope.$emit('refreshRecodeFinishedEvent', $rootScope.recodeAction.NoAction);
					}
					$("#editRecodeTree").hide();
				}	

				$scope.btnShowCustomizeRecodeLevel = function (dim, recode) {
					$scope.goodMsg = null;
					$("#editRecodeTree").hide();
					if(recode != null)
						$scope.$emit('openRecodeEditEvent', $rootScope.recodeAction.EditRecode, $rootScope.eventSrc.EditTreePage, dim, recode);
					else
						$scope.$emit('openRecodeAddEvent', $rootScope.eventSrc.EditTreePage, dim);
				}			

				$scope.btnSaveRecodeTree = function () {
					var tags = $scope.recodeTree.dimensions.map(function (x) {
						return x.shortName;
					}).toString();
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Create recodetree', {
						'event_label': 'create',
						'event_category': 'recode_create',
						'event_variable': tags
					});
					$scope.recodeTreeForm.treeName.$setValidity('nameConflict', true);
					if ($scope.recodeTree.cId == null) {
						$scope.recodeTree.type = "recodeTree";
						$scope.recodeTree.cId = appUtilities.randomCid();
						$scope.recodeTree.rootCid = rootDim.cId;
						$scope.recodeTree.rootShortName = rootDim.shortName;
						$scope.recodeTree.rootTitle = rootDim.title;
						rootDim.recodeTrees = rootDim.recodeTrees || [];
						rootDim.recodedSrcDims = $scope.sourceTree.recodedSrcDims;
						rootDim.recodeTrees.push($scope.recodeTree);
					} else {
						//initRecode = $scope.recode;
						var recodeIndx = appUtilities.findIndex("cId", $scope.recodeTree.cId, rootDim.recodeTrees);
						rootDim.recodeTrees[recodeIndx] = $scope.recodeTree;
						rootDim.recodedSrcDims = $scope.sourceTree.recodedSrcDims;
					}
					//recodes.setRecodeDefinedCount($scope);
					$("#editRecodeTree").hide();
					//$scope.btnFilterTreeCloseClick();
					$scope.$emit('rebuildRecodesListEvent');
					if(!$scope.recodeTree.disabled) {
						$rootScope.$broadcast('showRecodeTreeFilterPopupEvent', rootDim, $scope.recodeTree);
					}
				}
				
				$scope.btnShowConfirmRecodeTreeDelete = function() {
					$("#recodeTreeConfirmDelete").show();
					$("#editRecodeTree").hide();	
				}

				$scope.btnCloseConfirmRecodeTreeDelete = function () {
					$("#editRecodeTree").show();	
					$("#recodeTreeConfirmDelete").hide();
				}
				$scope.btnDeleteRecodeTree = function() {
					var tags = $scope.recodeTree.dimensions.map(function (x) {
						return x.shortName;
					}).toString();
					
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Delete recodetree', {
						'event_label': 'delete',
						'event_category': 'recode_delete',
						'event_variable': tags
					});
					
					for (var x = 0 ; x < rootDim.recodeTrees.length; x++) {
						if(rootDim.recodeTrees[x].cId == $scope.recodeTree.cId) {
							rootDim.recodeTrees.splice(x,1);
						}
					}
					for (var x = 0 ; x < rootDim.recodedSrcDims.length; x++) {
						if(rootDim.recodedSrcDims[x].cId == $scope.recodeTree.cId) {
							rootDim.recodedSrcDims.splice(x,1);	
						}
					}
					//recodes.setRecodeDefinedCount($scope);
					$scope.btnRecodeTreeCloseClick();
					$scope.closeLeftRail();;
					$scope.$emit('rebuildRecodesListEvent');
					
					let genericNotice = {};
					genericNotice.showNoticeFlag = true;
					genericNotice.borderClass = 'border-green';
					genericNotice.bannerMsg = `
						<span class="pr-2">
							<span class="banner-title banner-color-green pr-2">
								<i class="fa-sharp fa-solid fa-circle-check"></i>
							</span>
							<span class="banner-text banner-color-green">
								` + $scope.recodeTree.treeName + ` successfully deleted.
							</span>
						</span>`;
					genericNotice.showFullMsgFlag = false;
					$rootScope.$broadcast('displayGenericNoticeEvent', genericNotice);
					$("#recodeTreeConfirmDelete").hide();
				}
				
				$scope.btnRemoveRecodeTreeLevel = function(dim) {
					$scope.goodMsg = null;
					for (var x = 0; x < $scope.recodeTree.dimensions.length; x++) {
						if (dim.cId == $scope.recodeTree.dimensions[x].cId) {
							$scope.recodeTree.dimensions.splice(x, 1);
							break;
						}
					}
					
					for (var x = 0; x < $scope.sourceTree.recodedSrcDims.length; x++) {
						$scope.sourceTree.recodedSrcDims[x].disabled = false;
						for (var w = 0; w < $scope.recodeTree.dimensions.length; w++) {
							if ($scope.recodeTree.dimensions[w].cId == $scope.sourceTree.recodedSrcDims[x].cId) {
								$scope.sourceTree.recodedSrcDims[x].disabled = true;
								$scope.recodeTree.dimensions[w].selected = true;
								break;
							} else {
								if($scope.sourceTree.recodedSrcDims[x].recodes) {
									for(var y =0; y < $scope.sourceTree.recodedSrcDims[x].recodes.length; y++) {
										$scope.sourceTree.recodedSrcDims[x].recodes[y].disabled = false;
										if($scope.recodeTree.dimensions[w].cId == $scope.sourceTree.recodedSrcDims[x].recodes[y].cId) {
											$scope.sourceTree.recodedSrcDims[x].recodes[y].disabled = true;
											$scope.recodeTree.dimensions[w].selected = true;
											break;
										}
									}
								}
							}
						}
					}
				}

				$scope.btnRemoveRecodeTreeAllLevels = function(dim) {
					$scope.goodMsg = null;
					$scope.recodeTree.dimensions = [];
					for (var x = 0; x < $scope.sourceTree.recodedSrcDims.length; x++) {
						$scope.sourceTree.recodedSrcDims[x].disabled = false;
					}
				}

				
				$scope.btnAddLevel = function (dim, recode) {
					//console.log($scope.recodeTree.dimensions);
					$scope.goodMsg = null;
					if(recode != null) {
						var found = appUtilities.search("cId", recode.cId, $scope.recodeTree.dimensions)
						if(!found) {
							var r = JSON.parse(JSON.stringify(recode));
							r.selected = true;
							$scope.recodeTree.dimensions.push(r);
							disableSrcDimensions(recode);
						}
					} else {
						var found = appUtilities.search("cId", dim.cId, $scope.recodeTree.dimensions)
						if(!found) {
							var d = JSON.parse(JSON.stringify(dim)); 
							dim.addedToRecode = true;
							d.selected = true;
							$scope.recodeTree.dimensions.push(d);
							disableSrcDimensions(dim);
						}
					}
					
				}			
				
				//prevent user from adding or editing items that have been previously added to added as a level in the heirarchy.  
				//This applies to both recodes and dimensions displayed in the left side list.
				function disableSrcDimensions(item) {
					item.disabled = false;
					if($scope.recodeTree.dimensions != null) {
						for(var x =0; x < $scope.recodeTree.dimensions.length; x++) {
							if(item.cId == $scope.recodeTree.dimensions[x].cId) {
								item.disabled = true;
								break;
							} else {
								if($scope.recodeTree.dimensions[x].recodes) {
									for(var y =0; y < $scope.recodeTree.dimensions[x].recodes.length; y++) {
										if(item.cId == $scope.recodeTree.dimensions[x].recodes[y].cId) {
											item.disabled = true;
											break;
										}
									}
								}
							}
						}
					}
				}
			}
		]);
});

'use strict'
define('scripts/directives/modalRecodeTip',["js/qlik", "scripts/appModule", "scripts/shared/webProperties"],
	function (qlik, appModule, webProperties) {

	angular.module("appModule").directive("dtModalRecodeTip", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtModalRecodeTip.html',
			controller: 'ModalRecodeTipController'
		}
	});

	angular.module("appModule").controller("ModalRecodeTipController", ["$scope",
			function ($scope) {
				$scope.categories = [];
				
				$scope.clickRecodeTip = function (recodeItem) {
					$scope.recodeTip = {}

					$scope.recodeTip.type = recodeItem.type;
					$scope.recodeTip.categories = [];
					if(recodeItem.type == "recodeTree") {
						$scope.recodeTip.treeName = recodeItem.treeName;
						$scope.recodeTip.title = recodeItem.rootTitle;
						$scope.recodeTip.recodeName = recodeItem.treeName;							
						for(var v = 0; v < recodeItem.dimensions.length; v++) {
							var cats = transposeValues(recodeItem.dimensions[v]);
							for(var x=0; x < cats.length; x++) {
								$scope.recodeTip.categories.push(cats[x]);
							}
						}
					} else {
						$scope.recodeTip.title = recodeItem.title;
						$scope.recodeTip.recodeName = recodeItem.recodeName;							
						$scope.recodeTip.categories = transposeValues(recodeItem);						
					}
					$("#recodeTip").show({
						backdrop: 'static',
						keyboard: false
					});
				}

				$scope.clickCloseRecodeTip = function () {
					$("#recodeTip").hide();
				}

				function transposeValues(dim) {

					var cats = [];
					if(dim.type == "dim-branch") {
						var row = {};
						row.categoryName = dim.title
						row.valueName = dim.title;
						cats.push(row);
						return cats;
					}
					
					if(dim.categories == null)
						return cats;
					
					// Calculate the width and height of the Array
					var w = dim.categories.length;
					var h = dim.categories[0].values instanceof Array ? dim.categories[0].values.length : 0;

					// In case it is a zero matrix, no transpose routine needed.
					if (h === 0 || w === 0) {
						return [];
					}

					var i = 0,
					j = 0,
					k = 0;
					for (i = 0; i < w; i++) {
						h = dim.categories[i].values.length;
						for (j = 0; j < h; j++) {
							cats[k] = {};
							cats[k].categoryName = j == 0 ? dim.categories[i].qText : '';
							cats[k].valueName = dim.categories[i].values[j].qText;
							k++
						}
					}
					return cats;
				}

			}
		]);
});

'use strict'
define('scripts/directives/filterDropDownDirective',["qlik", "scripts/shared/hyperCubeProperties", "scripts/shared/dimensions"],
	function (qlik, hyperCubeProperties, dimensions) {
	angular.module("appModule").directive("dtFilterDropDown", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtFilterDropDown.html',
			scope: {
				pageId: '@pageId',
				ddLabel: '@label',
				ddValue: '@value',
				control: '='
			},
			controller: 'FilterDropDownController'
		}
	});

	angular.module("appModule").controller("FilterDropDownController", ["$scope", "$rootScope", "$location", "$http", "$timeout",
			function ($scope, $rootScope, $location, $http, $timeout) {
				var appObj = $rootScope.qApp;
				$scope.filterCountsMsg = "";
				var allFilterValues = [];
				var lastActive = -1;

				var viewport,
				listcontent,
				visnodes;
				var _scrollFilterlList;
				var variable;

				$scope.filterValues = [];
				$scope.internalControl = $scope.control || {};
				var lgFields = ["instUnitIDName", "instPostsecTitleIV", "instOPEFlag", "instCarnegie18",
					"instCarnegie15", "instCarnegie10", "instCarnegie"];
				var _scrollList;
				$scope.indx = $scope.internalControl.length;
				$scope.internalControl[$scope.indx] = {};
				$scope.internalControl[$scope.indx].dropDownSelected = false;
				$scope.internalControl[$scope.indx].shortName = $scope.ddValue;

				$scope.internalControl[$scope.indx].clearDropDown = function () {
					$scope.clearDropDownFilter();
				}

				$scope.internalControl[$scope.indx].loadDropDown = function (v) {
					return new qlik.Promise(function (resolve, reject) {
						variable = v;
						viewport = $("[data-viewport=" + $scope.pageId + '-' + $scope.ddValue + "]");
						listcontent = $("[data-listcontent=" + $scope.pageId + '-' + $scope.ddValue + "]");
						visnodes = $("[data-visnodes=" + $scope.pageId + '-' + $scope.ddValue + "]");
						allFilterValues = [];
						renderList(allFilterValues).then(function (len) {
							$scope.listWidth = (len * 7) + "px";
							return resolve();
						});
					});
				}
				
				$scope.internalControl[$scope.indx].setDropDownState = function (dropDown) {
					return new qlik.Promise(function (resolve, reject) {
						if (dropDown.savedValues.length > 0) {
							processSelections(dropDown.shortName, dropDown.savedValues).then(function () {
								return resolve();
							});
						} else {
							return resolve();
						}
					})
				}

				$scope.scrollFilterList = function () {
					viewport.off('scroll', _scrollFilterlList);
					$scope.pageFilterList();
					viewport.on('scroll', _scrollFilterlList);
					$scope.$apply();
				}

				$scope.clearDropDownFilter = function () {
					appObj.field($scope.ddValue, 'altState1').clear();
					var ind = $scope.internalControl.findIndex(function(val) {
						return val.shortName == $scope.ddValue;
					})

					variable = $scope.internalControl[ind];	
					if(variable.savedValues != null) {
						delete variable.savedValues;
					}

				}

				$scope.btnDropDownFilter = function (evt) {
					let initLoad = false;
					if($scope.listWidth == null) {
						initLoad = true;
						$(evt.currentTarget).dropdown('toggle')
					}

					var ind = $scope.internalControl.findIndex(function(val) {
						return val.shortName == $scope.ddValue;
					})

					variable = $scope.internalControl[ind];					

					if (variable.savedValues == null || variable.savedValues.length == 0) {
						$scope.internalControl[ind].loadDropDown(variable).then(function () {
							viewport.off('scroll', _scrollFilterlList);
							_scrollFilterlList = _.debounce($scope.scrollFilterList, 100, false);
							$scope.pageFilterList();
							//timeout required to allow angular digest to complete before external to angular scroll event triggered
							$timeout(() => {
									viewport.on('scroll', _scrollFilterlList);
									document.querySelector("[data-viewport=" + $scope.pageId + '-' + $scope.ddValue + "]").scrollTop = 0;
									if(initLoad) {
											$(evt.currentTarget).dropdown('toggle')
									}
							}, 30)
						})
					} 
				}

				$scope.applyBtn = function () {
					var selElm = [];
					for (var x = 0; x < allFilterValues.length; x++) {
						if (allFilterValues[x].class == "s") {
							selElm.push(Number(allFilterValues[x].qElemNumber));
						}
					}
					if (selElm.length == 0)
						return;

					processSelections($scope.ddValue, selElm).then(function () {
						variable.savedValues = selElm;
					});
				}

				$scope.ddSelectItem = function (evt, value) {
					evt.stopPropagation();
					if (value.qState == 'X' || value.qState == 'XS')
						return;

					if (window.getSelection) {
						window.getSelection().removeAllRanges();
					} else if (document.selection) {
						document.selection.empty();
					}

					var list = allFilterValues;
					if (value.class == 's') {
						value.class = 'o';
						lastActive = -1;
					} else {
						value.class = 's';
						if (evt.shiftKey && lastActive != -1) {

							var currentIndx = list.findIndex(function (item) {
								return item.qElemNumber == value.qElemNumber;
							});
							var start = lastActive,
							end = currentIndx;
							if (currentIndx < lastActive) {
								start = currentIndx;
								end = lastActive;
							}
							for (var x = start; x < end; x++) {
								list[x].class = 's';
							}
						} else {
							lastActive = list.findIndex(function (item) {
								return item.qElemNumber == value.qElemNumber;
							});
						}
					}
				};

				function processSelections(fld, selElm) {
					return new qlik.Promise(function (resolve, reject) {

						appObj.field(fld, 'altState1').select(selElm, false, true).then(function () {
							$scope.internalControl[$scope.indx].dropDownSelected = selElm.length > 0 ? true : false;
							return resolve();
						});
					});
				}

				$scope.pageFilterList = function () {
					var itemCount;
					var rowHeight = 28;
					var nodePadding = 2;

					itemCount = allFilterValues.length;
					var totalContentHeight = (itemCount * rowHeight) + 'px';
					listcontent.height(totalContentHeight);
					var scrollTop = viewport.scrollTop();

					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(viewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					$scope.filterValues = [];
					for (var x = startNode; x < allFilterValues.length; x++) {
						$scope.filterValues.push(allFilterValues[x]);
						if ($scope.filterValues.length == visibleNodesCount) {
							break;
						}
					}
					visnodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}

				function renderList(list) {

					return new qlik.Promise(function (resolve, reject) {
						var fields = [];
						var startRow = 0;
						var len = 0;

						getListPage(startRow, list, len).then(function (len) {
							return resolve(len);
						});

						function getListPage(startRow, list, len) {
							return new qlik.Promise(function (resolve, reject) {
								var dim = dimensions.getDimensionByName($scope.$parent, $scope.ddValue);
								dimensions.getValuesByDimension(appObj, dim, null, 'altState1', 0).then(function (values) {
									values.forEach(function (e) {
										e.class = e.qState.toLowerCase();
										if(e.qText.length > len)
											len = e.qText.length;
										list.push(e);
									});
									return resolve(len);
								});
							});
						}
					})

				};
			}
		]);
});

/*************************************************************
Description: This directive displays a filter popup for dimensions with more than 10 values.
There are 2 lists used in this procesing: availList (list on left side) which lists the available values for selction,
and selectedLIst (list on right side) which list values that have been selected by the user.

On popup load, values are retrieved from Qlik for the dimension.  Thesevalues are used to populate both availList and selectList.
CSS classes are used to hide selected values in the availList and display them in the selectedList.  Likewise, css styles are used
to hide selected values in the availList and show them in the selectedList.

If user performs a text search, then the availList is populated with the search reqults from Qlik, while the selectedList still
contains the full set of values for the dimensions, so at this point the 2 list each reference different objects.

THere are 3 key properties for determineing how to process a value in the selectList:
- selected - This property will be true whenever a user has selected a value from the availList or when a users de-selects
a previously added value to remove it from the selectList.  If a user has selected an item from availList but has not Added it yet
and then removes it from the selectList then the selected proprty will be false.
- qState - This property holds the selection state of the value within Qlik.  If qState = 'S' that means the vaalues has already been selected
and applied to the hypercube.  If qState = 'A' or 'O' then the value is available for selection and has not yet been
applied to the hypercube.  If qSate = 'X', then that means the value is excluded and should not be selected because it is
invalid with the current state of the hypercube.  This will hapen when users have applied filters on other dimensions thatmake the combintation
of selected dimensions and filters incompatable with the selected value.  For instance, if a user has previously applied the
filter of 'UVA" to the institutions dimension then the state values will show a qState of 'X' for all state values except
Virginina, since UVA is only applicable to Virginia.
- class - This property determines if the value should be displayed or hidden in the 2 lists.  If class set to 'o' then it will
be displayed in the availList and hidden in the selectList.  If class = 's' then it is hidden in the availList and displayed in
the selectList.

When the Exclude checkbox is applied logic will use the 3 properties to reverse how the values are applied to the hypercube.
Values in the availList are applied to the hypercube and any values in the selectedList are removed from the hypercube
 *************************************************************/
'use strict'
define('scripts/directives/modalFilterDirective',["qlik", "scripts/shared/hyperCubeProperties", "scripts/shared/dimensions", "scripts/shared/appUtilities", "scripts/shared/recodes"],
	function (qlik, hyperCubeProperties, dimensions, appUtilities, recodes) {

	angular.module("appModule").directive("dtModalFilter", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtModalFilter.html',
			scope: true,
			controller: 'FilterController'
		};
	});

	angular.module("appModule").controller("FilterController", ["$scope", "$rootScope", "$location", "$http", "$timeout",
			function ($scope, $rootScope, $location, $http, $timeout) {
				var appObj = $rootScope.qApp;
				$scope.filterDisplayField = '';
				$scope.searchFilterText = '';
				$scope.selectedValues = [];
				$scope.availValues = [];
				$scope.disableAddSelections = true;
				$scope.disableRemoveSelections = true;

				//console.log('availValues ',$scope.availValues );
				//console.log('$scope.selectedValues ', $scope.selectedValues);
				var totalCount = 0;
				var listObjId;
				var allValues = [];
				var searchValues = [];
				var insertedElements = [];
				var lastAvailActive = -1;
				var lastSelectActive = -1;
				var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

				var _scrollAvailList,
				_scrollSelectList;
				var isSingleClick = true;

				function scrollAvailList() {
					$('#availViewport').off('scroll', _scrollAvailList);
					$scope.availValues = [];
					pageAvailList();
					$('#availViewport').on('scroll', _scrollAvailList);
					$scope.$apply();
				}

				function scrollSelectList() {
					$('#selectViewport').off('scroll', _scrollSelectList);
					pageSelectList();
					$('#selectViewport').on('scroll', _scrollSelectList);
					$scope.$apply();
				}

				$scope.clearFilter = function (name) {
					$scope.availValues = [];
					$scope.selectedValues = [];
					$scope.searchFilterText = "";
					appObj.field(name).clear();
					$rootScope.leftRail.card2.dim.selected = false;
					$rootScope.leftRail.card2.dim.selectedValuesCount = 0;
				}

				$scope.$on('showFilterPopupEvent', function () {
					showFilterPopup();
				});

				function showFilterPopup() {

					//dim = $rootScope.leftRail.card2.dim;
					//recode = scope.leftRail.card2.recode;
					$scope.searchFilterText = "";
					$scope.selectedValues = [];
					$scope.availValues = [];
					allValues = [];
					searchValues = [];

					$("#filterModal").show();
					$scope.filterDisplayField = $rootScope.leftRail.card2.dim.title;

					_scrollAvailList = _.debounce(scrollAvailList, 100, false);
					$('#availViewport').off('scroll', _scrollAvailList).on('scroll', _scrollAvailList);

					_scrollSelectList = _.debounce(scrollSelectList, 100, false);
					$('#selectViewport').off('scroll', _scrollSelectList).on('scroll', _scrollSelectList);

					renderList().then(function (list) {
						list = recodes.excludeValuesAppliedByOtherRecodes(list, $rootScope.leftRail.card2.dim, $rootScope.leftRail.card2.recode);
						// if ($rootScope.leftRail.card2.recode) {
						// 	list = recodes.showRecodeCategories($scope.searchFilterText, list, $rootScope.leftRail.card2.dim, $rootScope.leftRail.card2.recode);
						// }

						allValues = list;
						$('#availViewport').scrollTop(0);
						$('#selectViewport').scrollTop(0);
						pageAvailList();
						pageSelectList();
						//setSelectedValues(dim);
						var disableUpd = false;
						if ($rootScope.leftRail.card2.dim.shortName.toLowerCase() == "year"
							 || $rootScope.leftRail.card2.dim.shortName.toLowerCase() == "refyr") {
							var selValue = appUtilities.search("qState", "S", $scope.selectedValues);
							if (selValue !== null) {
								disableUpd = false;
							} else {
								disableUpd = true;
							}
						}

						setFilterButtons(disableUpd);

						// auto-populate the searchFilterText if the user has selected a Field Label from
						// the left rail autocomplete. By-pass ng-change method txtSearchFilterChange()
						// as it uses Qlik to do the search. This search does not return one result as expected
						if ($rootScope.suggestionBubble.valueSource == 'Field Labels') {
							if ($rootScope.variableIdsToHighlight.includes(dimension.variableId)) {
								for (var x = 0; x < allValues.length; x++) {
									if (allValues[x].qText == $rootScope.suggestionBubble.storedValue) {
										var nodeMatchingBubble = JSON.parse(JSON.stringify(allValues[x]));
										nodeMatchingBubble.listType = "search";
										nodeMatchingBubble.selected = undefined;
										delete nodeMatchingBubble.level;
										delete nodeMatchingBubble.listId;
										delete nodeMatchingBubble.padding;
										delete nodeMatchingBubble.parent;
										delete nodeMatchingBubble.parentId;
										$scope.availValues = [nodeMatchingBubble];
										$scope.searchFilterText = $rootScope.suggestionBubble.storedValue;
										break;
									}
								}
							}
						}

						return;
					});
				}

				function closeDialog(evt) {
					$("#filterModal").hide();
					$scope.closeLeftRail();
				};

				$scope.availListDblClicked = function (value, evt) {
					if (value.qState == 'X' || value.qState == 'XS')
						return;

					isSingleClick = false;
					value.qState = 'S';
					clearAvailList();
					clearSelectList()
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				}

				$scope.availListClicked = function (value, evt) {
					isSingleClick = true;
					$timeout(() => {
						if (isSingleClick) {
							doAvailSingleClick();
						}
					}, 200)

					function doAvailSingleClick() {
						if (value.qState == 'X' || value.qState == 'XS')
							return;

						if (window.getSelection) {
							window.getSelection().removeAllRanges();
						} else if (document.selection) {
							document.selection.empty();
						}

						var list = []
						if (searchValues.length > 0) {
							list = searchValues;
						} else {
							list = allValues;
						}

						if (value.qState == 'lh') {
							value.qState = 'O';
							lastAvailActive = -1;
						} else {
							value.qState = 'lh';
							if (evt.shiftKey && lastAvailActive != -1) {

								var currentIndx = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
								var start = lastAvailActive,
								end = currentIndx;
								if (currentIndx < lastAvailActive) {
									start = currentIndx;
									end = lastAvailActive;
								}

								for (var x = start; x < end; x++) {
									list[x].qState = 'lh';
								}
							} else {
								lastAvailActive = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
							}
						}

						if (appUtilities.search("qState", "lh", list)) {
							$scope.disableAddSelections = false;
						} else {
							$scope.disableAddSelections = true;
						}
					};
				};

				$scope.selectListClicked = function (value, evt) {
					isSingleClick = true;
					$timeout(() => {
						if (isSingleClick) {
							doSelectSingleClick();
						}
					}, 200)
					function doSelectSingleClick() {
						if (window.getSelection) {
							window.getSelection().removeAllRanges();
						} else if (document.selection) {
							document.selection.empty();
						}

						var list = allValues;
						if (value.qState == 'rh') {
							value.qState = 'S';
							lastSelectActive = -1;
						} else {
							value.qState = 'rh';
							if (evt.shiftKey && lastSelectActive != -1) {

								var currentIndx = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
								var start = lastSelectActive,
								end = currentIndx;
								if (currentIndx < lastSelectActive) {
									start = currentIndx;
									end = lastSelectActive;
								}
								for (var x = start; x < end; x++) {
									list[x].qState = 'rh';
								}
							} else {
								lastSelectActive = list.findIndex(function (item) {
									return item.qElemNumber == value.qElemNumber;
								});
							}
						}
						if (appUtilities.search("qState", "rh", list)) {
							$scope.disableRemoveSelections = false;
						} else {
							$scope.disableRemoveSelections = true;
						}
					};

				}

				$scope.selectListDblClicked = function (value, evt) {
					isSingleClick = false;

					value.qState = 'O';
					clearAvailList();
					clearSelectList()
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				}

				function setFilterButtons(disableUpd) {
					lastAvailActive = -1;
					lastSelectActive = -1;
					$scope.disableAddSelections = true;
					$scope.disableRemoveSelections = true;

					$scope.disableActions = disableUpd;

					if ($scope.disableActions) {
						$("#filterModal .avail-list li").addClass("disable-item");
						$("#filterModal .selected-list li").addClass("disable-item");
					} else {
						$("#filterModal .avail-list li").removeClass("disable-item");
						$("#filterModal .selected-list li").removeClass("disable-item");
						var visible = $scope.selectedValues.length;

						if (visible == 0) {
							if ($rootScope.leftRail.card2.dim.shortName.toLowerCase() == 'year'
								 || $rootScope.leftRail.card2.dim.shortName.toLowerCase() == 'refyr') {
								$scope.disableActions = true;
							} else if ($rootScope.leftRail.card2.dim.selectedValuesCount > 0) {
								$scope.disableActions = false;
							} else {
								$scope.disableActions = true;
							}
						} else {
							$scope.disableActions = false;
						}

						//enable  Clear all only when selecteed list has one or more visible
						if (visible > 0) {
							$scope.disableClearAll = false;
						} else {
							$scope.disableClearAll = true;
						}

						var avail = $scope.availValues.length;
						if (avail > 0) {
							$scope.disableAddAll = false;
						} else {
							$scope.disableAddAll = true;
						}
						
						$scope.selectedFilterCountsMsg = getMarkedForSelectionCount(allValues) + " selected";
					}
				}

				$scope.txtSearchFilterChange = function (evt) {
					var textChange = function () {
						//if user clears all characters, re-build list with no search criteria
						searchValues = [];
						$('#availViewport').scrollTop(0);
						$('#selectViewport').scrollTop(0);
						if ($scope.searchFilterText.length == 0) {

							pageAvailList();
							pageSelectList();
							setFilterButtons();
							$scope.$apply();
						} else if ($scope.searchFilterText.length > 1) {
							//get search results if user hase entered 2 or more characters	
							renderList().then(function (list) {
								//populate availValues with search results for those values that have not been marked as selected
								//Also populate searchVales to hold results so it can be used for paging if needed
								//Using the main allValues as the source for both AvailVals and searchVals
								//since selectedVals shares array element references with allValues.
								for (var x = 0; x < list.length; x++) {
									for (var y = 0; y < allValues.length; y++) {
										if (list[x].qElemNumber == allValues[y].qElemNumber) {
											searchValues.push(allValues[y]);
											break;
										}
									}
								}
								
								pageAvailList(true);
								//pageSelectList();
								setFilterButtons();
								return;
							});
						}
						return;
					}
					_.debounce(textChange, 300, false)();
				};

				$scope.btnShowFilterRecodeDimension = function () {
					let dim = $rootScope.leftRail.card2.dim
					$rootScope.startingPoint = "init_from_dim_slideout"; 					
/* 					gtag('event', displayType + $rootScope.survey.abbreviation + '-Open recode wizard', {
						'event_label': $rootScope.startingPoint,
						'event_category': 'recode',
						'event_variables': dim.shortName
					}) */						
					closeDialog();
					$scope.$emit('openRecodeAddEvent', $rootScope.eventSrc.LeftRailPage, dim);
				}

				$scope.btnFilterClearSearchClick = function (evt) {
					$scope.searchFilterText = "";
					$scope.availValues = [];
					searchValues = [];
					pageAvailList();
					pageSelectList();
					setFilterButtons();
					return;

				};

				$scope.btnAddSelectionsClick = function (evt) {

					$scope.selectedValues = [];
					for (var i = 0; i < allValues.length; i++) {
						if (allValues[i].qState == 'S'
							 || allValues[i].qState == 'lh') {
							allValues[i].qState = 'S';
							$scope.selectedValues.push(allValues[i]);
						}
					}
					clearSelectList();
					$('#availViewport').scrollTop(0);
					$('#selectViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				};

				$scope.btnAddAllSelectionsClick = function (evt) {
					var list = [];
					if (searchValues.length > 0) {
						list = searchValues;
					} else {
						list = allValues;
					}

					for (var i = 0; i < list.length; i++) {
						var value = list[i];
						if (value.qState != 'X') {
							value.qState = 'S';
						}
					};

					$('#availViewport').scrollTop(0);
					$('#selectViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				};

				$scope.btnRemoveSelectionsClick = function (evt) {
					for (var i = 0; i < allValues.length; i++) {
						if (allValues[i].qState == 'rh') {
							allValues[i].qState = 'O';
						}
					}
					clearAvailList();

					$('#availViewport').scrollTop(0);
					$('#selectViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				};

				$scope.btnFilterClearAllClick = function (evt) {
					for (var i = 0; i < allValues.length; i++) {
						var value = allValues[i];
						if (value.qState != 'X') {
							value.qState = 'O';
						}
					};

					$('#availViewport').scrollTop(0);
					$('#selectViewport').scrollTop(0);
					pageAvailList();
					pageSelectList();

					setFilterButtons();
				};

				$scope.btnFilterCloseClick = function (evt) {
					closeDialog();
				};

				$scope.btnFilterAddColumnClick = function () {
					add(true)
				}

				$scope.btnFilterAddRowClick = function () {
					add(false);
				}

				$scope.btnFilterAddChartClick = function () {
					add(false);
				}

				$scope.btnFilterUpdateClick = function () {
					upd();
				}
				$scope.btnFilterUpdChartClick = function () {
					upd();
				}

				function clearSelectList() {
					for (var i = 0; i < $scope.selectedValues.length; i++) {
						if ($scope.selectedValues[i].qState == 'rh') {
							$scope.selectedValues[i].qState = 'S';
						}
					}
				}

				function clearAvailList() {
					for (var i = 0; i < $scope.availValues.length; i++) {
						if ($scope.availValues[i].qState == 'lh') {
							$scope.availValues[i].qState = 'O';
						}
					}
				}

				function add(toCol) {
					$scope.toggleReadOnly(true);
					setFilterButtons(true);
					//google analytics tracking
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Select dimension', {
						'event_label': 'select',
						'event_category': 'dimension',
						'event_variables': $rootScope.leftRail.card2.dim.shortName
					});

					var selected = [];
					allValues.forEach(function (item) {
						if (item.qState == 'S') {
							selected.push(item.qElemNumber);
						}
					});
					if (selected.length > 0) {
						$rootScope.leftRail.card2.dim.selected = true;
						$rootScope.visObj.table.OnData.unbind($scope.tblListener);
						hyperCubeProperties.updateSelected(appObj, $rootScope, $scope, $rootScope.leftRail.card2.dim, 'add', toCol).then(function () {

							appObj.field($rootScope.leftRail.card2.dim.shortName).select(selected, false, true).then(function () {
								$rootScope.visObj.table.OnData.bind($scope.tblListener);
								$rootScope.leftRail.card2.dim.selectedValuesCount = selected.length;
								closeDialog();
							});

						});
					} else {
						$rootScope.leftRail.card2.dim.selectedValuesCount = 0;
						closeDialog();
					}
				}

				function upd() {
					$scope.toggleReadOnly(true);
					setFilterButtons(true);

					var selected = [];
					allValues.forEach(function (item) {
						if (item.qState == 'S')
							selected.push(item.qElemNumber);
					});
					if (selected.length > 0) {
						$rootScope.leftRail.card2.dim.selected = true;
						appObj.field($rootScope.leftRail.card2.dim.shortName).clear().then(function () {
							appObj.field($rootScope.leftRail.card2.dim.shortName).select(selected, false, true).then(function () {
								$rootScope.leftRail.card2.dim.selectedValuesCount = selected.length;
								closeDialog();
							});
						});
					} else {
						$rootScope.leftRail.card2.dim.selected = false;
						hyperCubeProperties.updateSelected(appObj, $rootScope, $scope, $rootScope.leftRail.card2.dim, "remove").then(function () {
							$rootScope.leftRail.card2.dim.selectedValuesCount = 0;
							$scope.clearFilter();
							closeDialog();
						}, function (err) {
							return reject(err);
						});
					}
				}
				
				$scope.getAvailListClass = function (value) {
					if(value.qState == null)
						return null;
					var retCls = " " + value.qState.toLowerCase();

					return retCls;
				}

				$scope.getSelectListClass = function (value) {
					if(value.qState == null)
						return null;
					var retCls = " " + value.qState.toLowerCase();

					return retCls;
				}				

				function pageAvailList(pageSearch) {
					var availViewport = $('#availViewport');
					var availListContent = $('#availListContent');
					var availListVisNodes = $('#availListVisNodes');
					var itemCount;
					var rowHeight = 29;
					var nodePadding = 2;

					var list = [],
					filteredList = [];
					if (pageSearch) {
						list = searchValues;
					} else {
						list = allValues;
					}
					filteredList = list.filter(function (item) {
						if (item.qState !== 'S')
							return item;
					})
						itemCount = filteredList.length;

					var totalContentHeight = (itemCount * rowHeight) + 'px';
					//availListContent.attr("style","height:"+totalContentHeight);
					availListContent.height(totalContentHeight);
					var scrollTop = availViewport.scrollTop();

					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(availViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					$scope.availValues = [];
					for (var x = startNode; x < filteredList.length; x++) {
						if (filteredList[x].qState != "S") {
							$scope.availValues.push(filteredList[x]);
							if ($scope.availValues.length == visibleNodesCount) {
								break;
							}
						}
					}
					availListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}

				function pageSelectList() {
					var selectViewport = $('#selectViewport');
					var selectListContent = $('#selectListContent');
					var selectListVisNodes = $('#selectListVisNodes');
					var itemCount; //  = $rootScope.leftRail.card2.dim.totalValuesCount;
					var rowHeight = 29;
					var nodePadding = 2;
					var viewportHeight = 280;

					var list = [];
					list = allValues.filter(function (item) {
						if (item.qState == 'S')
							return item;
					})
					itemCount = list.length;

					var totalContentHeight = ((itemCount) * rowHeight) + 'px';
					//selectListContent.attr("style","height:"+totalContentHeight);
					selectListContent.height(totalContentHeight);

					var scrollTop = selectViewport.scrollTop();
					var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
					startNode = Math.max(0, startNode);

					var visibleNodesCount = Math.ceil(selectViewport.height() / rowHeight) + 2; //(2 * nodePadding);
					visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
					var offsetY = startNode * rowHeight;

					$scope.selectedValues = [];
					for (var x = startNode; x < list.length; x++) {
						if (list[x].qState == "S") {
							$scope.selectedValues.push(list[x]);
							if ($scope.selectedValues.length == visibleNodesCount) {
								break;
							}
						}
					}
					selectListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
				}

				function renderList() {
					return new qlik.Promise(function (resolve, reject) {
						var list = [];
						dimensions.getValuesByDimension(appObj, $rootScope.leftRail.card2.dim, $scope.searchFilterText, null, 0).then(function (values) {
							values.forEach(function (e) {
								if (e.qState == "O" || e.qState == "S" || e.qState == "A") {
									list.push(e);
								}
							});
							values.forEach(function (e) {
								if (e.qState == "X" || e.qState == "XS") {
									list.push(e);
								}
							});
							return resolve(list);
						});

					})
				};

/* 				function getAppliedSelectedCount(arr) {
					if (arr == null)
						return 0;

					return arr.filter(function (elm) {
						return elm.selected == true;
					}).length;
				} */

				function getMarkedForSelectionCount(arr) {
					if (arr == null)
						return 0;

					return arr.filter(function (elm) {
						return elm.qState == 'S';
					}).length;
				}
			}
		]);
});

/****
This directive is unusual in that it utilizes Qlik's Alternate States.
Alt States enables us to work with data seperately from the primary state, so updates to data in the Alt State
does not impact data in the primary state's hypercube.

Alt State is used here to retrieve institution data and the data in the drop-downs so that selections
to this data does not effect the pivot table's hypercube data.

When user clicks the Add or Update buttons a call is made to hyperCubeProperties.updateFilterValue(), this method takes the
selected data from the Alt State and applies it to the primary state - this is how the data between the 2 states is synced up

Because the alt state is also used by the Hierarchy modals, we need to clear it each time a program uses it.
This architecture requires us to store a copy of the full set of institutions in memory to track the current state of the
institution values selectedvalues selected and applied.

Additionally, the institutions modal uses virtual scrolling to ensure that html is generated for only those rows that are visible.
The previous architecture rendered html for all rows, so even though maybe 25 rows are vissible there could be 3,000 rows of schools
and the browser rendering process for 3,000 schools requires a lot of mremoray and processing resources which impacted performance.
 *******/
'use strict'
define('scripts/directives/modalInstFilterDirective',["qlik", "scripts/shared/hyperCubeProperties", "scripts/shared/dimensions", "scripts/shared/appUtilities",  "scripts/shared/recodes"],
	function (qlik, hyperCubeProperties, dimensions, appUtilities, recodes) {

	angular.module("appModule").directive("dtModalInstFilter", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtModalInstFilter.html',
			scope: true,
			controller: 'InstFilterController'
		};
	});

	angular.module("appModule").controller("InstFilterController", ["$scope", "$rootScope", "$location", "$http", "$timeout",
		function ($scope, $rootScope, $location, $http, $timeout) {
			var appObj = $rootScope.qApp;
			var appObj = $rootScope.qApp;

			$scope.filterInstDisplayField = '';
			$scope.searchInstText = '';
			$scope.selectedInstValues = [];
			$scope.dropdownControl = [];
			$scope.instDimDropDowns = [];
			$scope.disableAddSelections = true;
			$scope.disableRemoveSelections = true;
			$scope.filterListExpanded = false;

			var listObjId;
			var dim, recode;
			var _scrollAvailInstlList,
			_scrollSelectInstList;
			var isSingleClick = true;
			var isOpenFromLeftRail = true;
			var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

			/***
			allValues - array holding the full set of institutions, is populated the first time popup is initiated and will retain the institutions
			for as long as the current survey is loaded.  This array is used for paging against all schools when filtering and searches actions
			have not been performed.
			filteredAvailValues - array holds the subset of institutions that are result of a filter or search being applied.
			These records can span multiple pages of data and is the source of records for paging.
			These records will change as a result of user searches and filtering.  These records are synced up
			with the allValues records so that each record references the same record in AllValues.
			IMPORTANT: Therefore changing an allAvalValue record property will also change the corresponding property
			in the allValues record and vice versa.
			TODO: Refaactor this array, not sure why allValues cannot be used for paging, investigate?
			tmpValues - array temporary array that holds values retrieved from Qlik server and used
			in syncing code to populate te filteredAvailValues list with object references from allValues array

			 ***/
			var allValues = [];
			var filteredAvailValues = [];
			var tmpValues = [];
			var singleSelectedInst = null;
			var insertedElements = [];
			var lastAvailActive = -1;
			var lastSelectActive = -1;
			var totalSelectedInstCount = 0;

			//Listener is invoked each time a sub-filter drop-down selection is made
			//Its purpose is to update the availInstList with the latest filtering changes as a result of a user applying a sub-filter
			var filterListener = function () {

				//allValues = []
				var modal = document.querySelector("#instFilterModal");
				if (modal && modal.style.display == "block") {
					//logic for looping promise calls; need to re-build each list with excluded items
					//after user has made a selection from one of the drop-down list

					renderList().then(function (tmpValues) {
						//allValues = tmpValues;
						syncFilteredValues(tmpValues);
						pageAvailInstList();
						pageSelectInstList();
						setFilterButtons(false);
					});
					return;


				}
			};

			//Getting reference to Qlik alt state
			//$rootScope.selAltState = appObj.selectionState('altState1');

			function scrollAvailInstList() {

				$('#availInstViewport').off('scroll', _scrollAvailInstlList);
				$scope.availInstValues = [];
				pageAvailInstList();
				$('#availInstViewport').on('scroll', _scrollAvailInstlList);
				$scope.$apply();
			}

			function scrollSelectInstList() {
				$('#selectInstViewport').off('scroll', _scrollSelectInstList);
				pageSelectInstList();
				$('#selectInstViewport').on('scroll', _scrollSelectInstList);
				$scope.$apply();
			}

			$scope.$on('clearInstFilterEvent', function (e) {
				$scope.clearInstFilter();
			});

			$scope.clearInstFilter = function () {
				$scope.availInstValues = [];
				$scope.selectedInstValues = [];
				$scope.searchInstText = '';
				allValues = [];

				if(dim) {
					dim.savedValues = [];
					dim.selectedValuesCount = 0;
					dim.dropDowns = [];
					dim.recodeSelected = false;
				}

				//clear all drop-down selections
				$scope.dropdownControl.forEach(function (e) {
					e.clearDropDown();
					delete e.savedValues;
				});
				//clear all drop-down filters that have been applied to the institutions
				$rootScope.selAltState.clearAll(false);
			}
			
			$scope.$on('showInstFilterPopupEvent', function (e, dimension) {
				showInstPopup(dimension);
			});

			function showInstPopup(dimension) {
				$rootScope.leftRail.card2.dim = dimension;
				dim = $rootScope.leftRail.card2.dim;
				$scope.filterInstDisplayField = dim.title;
				$scope.instDimDropDowns = [];

				filteredAvailValues = [];
				$scope.searchInstText = "";

				if ($scope.selectedInstValues.length == 1)
					singleSelectedInst = $scope.selectedInstValues[0];
				else
					singleSelectedInst = null;

				$("#instFilterModal").show()
				_scrollAvailInstlList = _.debounce(scrollAvailInstList, 100, false);
				var aVp = $('#availInstViewport');
				aVp.off('scroll', _scrollAvailInstlList).on('scroll', _scrollAvailInstlList);
				aVp.scrollTop(0);

				_scrollSelectInstList = _.debounce(scrollSelectInstList, 100, false);
				var sVp = $('#selectInstViewport');
				sVp.off('scroll', _scrollSelectInstList).on('scroll', _scrollSelectInstList);
				sVp.scrollTop(0);

				$scope.instDimDropDowns = dim.subFilters
/* 				for(var x=0; x < dim.subFilters.length; x++) {
					var filterDim = dimensions.getDimensionBySubFilter($rootScope, dim.subFilters[x]);
					if(Object.keys(filterDim).length > 0) {
						$scope.instDimDropDowns.push(filterDim);
					}
				} */
				$("#instFilterModal").show();
					setupModal(dim);
			}

			function setupModal(dim) {
				setFilterButtons(true);

				$rootScope.selAltState.clearAll(false).then(function () {
					$scope.searchInstText = '';

 					var p = Promise.resolve();
					for (var i = 0; i < $scope.dropdownControl.length; i++) {
						var x = 0;
						p = p.then(function () {

							return new Promise(function (resolve, reject) {
								if (dim.savedValues != null && dim.savedValues.length > 0) {
									if($scope.dropdownControl[x].savedValues != null && $scope.dropdownControl[x].savedValues.length > 0) {
										$scope.dropdownControl[x].setDropDownState($scope.dropdownControl[x]).then(function() {
											x += 1;
											return resolve();
										})
									} else {
										x += 1;
										return resolve();
									}
								} else {
									x += 1;
									return resolve();
								}
							});
						})
					}
					p.then(function () {

						renderList().then(function (tmpValues) {
							allValues = tmpValues;
							if (dim.savedValues != null && dim.savedValues.length > 0) {
								syncAllValues(allValues, dim.savedValues);
								dim.selectedValuesCount = dim.savedValues.length;
							}
							filteredAvailValues = allValues;

							pageAvailInstList();
							pageSelectInstList();
							//after modal displayed for first time, set initMeParam to false
							//so logic that one time property setting code is not executed again
							$rootScope.leftRail.card2.dim.initializeToMeParam = false;

							$rootScope.selAltState.OnData.bind(filterListener);
							setFilterButtons(false);
							// if there is a Field Label search bubble in the left rail from the left rail autocomplete search,
							// then filter the available values according to the search bubble text

							leftRailAutocompleteSearch(dim);
							return;

						}, function (err) {
							console.log('inst list err', err)
						})
						//}
					});
				});
				return;
			}

			$scope.availInstListClicked = function (value, evt) {
				isSingleClick = true;
				$timeout(() => {
					if (isSingleClick) {
						doSingleClick();
					}
				}, 200)

				function doSingleClick() {

					if (value.class == 'x' || value.class == 'xs')
						return;

					if (window.getSelection) {
						window.getSelection().removeAllRanges();
					} else if (document.selection) {
						document.selection.empty();
					}

					var list = []
					if (filteredAvailValues.length > 0) {
						list = filteredAvailValues;
					} else {
						list = allValues;
					}

					if (value.class == 'lh') {
						value.class = 'o';
						lastAvailActive = -1;
					} else {
						value.class = 'lh';
						if (evt.shiftKey && lastAvailActive != -1) {
							var currentIndx = list.findIndex(function (item) {
								return item.qElemNumber == value.qElemNumber;
							});
							var start = lastAvailActive,
							end = currentIndx;
							if (currentIndx < lastAvailActive) {
								start = currentIndx;
								end = lastAvailActive;
							}

							for (var x = start; x < end; x++) {
								list[x].class = 'lh';
							}
						} else {
							lastAvailActive = list.findIndex(function (item) {
								return item.qElemNumber == value.qElemNumber;
							});
						}
					}

					if (appUtilities.search("class", "lh", list)) {

						$scope.disableAddSelections = false;
					} else {
						$scope.disableAddSelections = true;
					}
				};
			};

			$scope.selectInstListClicked = function (value, evt) {
				isSingleClick = true;
				$timeout(() => {
					if (isSingleClick) {
						doSingleClick();
					}
				}, 200)
				function doSingleClick() {
					if (window.getSelection) {
						window.getSelection().removeAllRanges();
					} else if (document.selection) {
						document.selection.empty();
					}

					var list = allValues;
					if (value.class == 'rh') {
						value.class = 's';
						lastSelectActive = -1;
					} else {
						value.class = 'rh';
						if (evt.shiftKey && lastSelectActive != -1) {

							var currentIndx = list.findIndex(function (item) {
								return item.qElemNumber == value.qElemNumber;
							});
							var start = lastSelectActive,
							end = currentIndx;
							if (currentIndx < lastSelectActive) {
								start = currentIndx;
								end = lastSelectActive;
							}
							for (var x = start; x < end; x++) {
								list[x].class = 'rh';
							}
						} else {
							lastSelectActive = list.findIndex(function (item) {
								return item.qElemNumber == value.qElemNumber;
							});
						}
					}
					if (appUtilities.search("class", "rh", list)) {
						$scope.disableRemoveSelections = false;
					} else {
						$scope.disableRemoveSelections = true;
					}
				};

			}

			$scope.availInstListDblClicked = function (value, evt) {
				isSingleClick = false;
				if (value.class == 'x' || value.class == 'xs')
					return;

				setFilterButtons(true)
				value.class = 's';
				clearAvailInstList();
				clearSelectInstList()
				pageAvailInstList();
				pageSelectInstList();
				setFilterButtons(false)
			}

			$scope.selectInstListDblClicked = function (value, evt) {
				isSingleClick = false;

				setFilterButtons(true)
				value.class = 'o';
				clearAvailInstList();
				clearSelectInstList()
				pageAvailInstList();
				pageSelectInstList();

				setFilterButtons(false);
			}

			//Add all schools
			$scope.btnInstAddAllSelectionsClick = function (evt) {
				// console.log('1111',allValues)
				setFilterButtons(true)
				var list = [];
				if (filteredAvailValues.length > 0) {
					list = filteredAvailValues;
				} else {
					list = allValues;

				}

				for (var i = 0; i < list.length; i++) {
					var value = list[i];
					if (value.class != 'x') {
						value.class = 's';
					}
				};

				$('#availInstViewport').scrollTop(0);
				$('#selectInstViewport').scrollTop(0);
				pageAvailInstList();
				pageSelectInstList();

				setFilterButtons(false);
			};

			//Add selected schools (right-arrow button)
			$scope.btnInstAddSelectionsClick = function (evt) {
				setFilterButtons(true);

				$scope.selectedInstValues = [];
				for (var i = 0; i < allValues.length; i++) {
					if (allValues[i].class == 's'
						 || allValues[i].class == 'lh') {
						allValues[i].class = 's';
						$scope.selectedInstValues.push(allValues[i]);
					}
				}
				clearSelectInstList();
				$('#availInstViewport').scrollTop(0);
				$('#selectInstViewport').scrollTop(0);
				pageAvailInstList();
				pageSelectInstList();

				setFilterButtons(false);

			}

			// clear selected schools (left-arrow button)
			$scope.btnInstRemoveSelectionsClick = function (evt) {
				setFilterButtons(true);
				for (var i = 0; i < allValues.length; i++) {
					if (allValues[i].class == 'rh') {
						allValues[i].class = 'o';
					}
				}
				clearAvailInstList();

				$('#availInstViewport').scrollTop(0);
				$('#selectInstViewport').scrollTop(0);
				pageAvailInstList();
				pageSelectInstList();

				setFilterButtons(false);
			};

			//clear all seclections
			$scope.btnInstClearAllClick = function (evt) {
				setFilterButtons(true);
				for (var i = 0; i < allValues.length; i++) {
					var value = allValues[i];
					if (value.class != 'x') {
						value.class = 'o';
					}
				};

				$('#availInstViewport').scrollTop(0);
				$('#selectInstViewport').scrollTop(0);
				pageAvailInstList();
				pageSelectInstList();

				setFilterButtons(false);
			};

			$scope.txtSearchInstChange = function (evt) {
				

				var textChange = function () {
					if ($scope.searchInstText.length == 0 || $scope.searchInstText.length > 1) {
						setFilterButtons(true);
						$('#availInstViewport').scrollTop(0);
						$('#selectInstViewport').scrollTop(0);
						$scope.availInstValues = [];

						//tmpValues = [];
						renderList().then(function (tmpValues) {
							syncFilteredValues(tmpValues);
							pageAvailInstList();
							setFilterButtons(false);
							return;
						});

					}
					return;
				}
				_.debounce(textChange, 300, false)();
			}

			$scope.btnInstClearSearchClick = function (evt) {
				$scope.searchInstText = "";
				setFilterButtons(true);
				renderList().then(function (tmpValues) {
					syncFilteredValues(tmpValues);
					pageAvailInstList();
					pageSelectInstList();
					setFilterButtons(false);
				});
			};

			$scope.btnInstUpdateClick = function () {
				update();
			}

			$scope.btnInstAddColumnClick = function () {
				add(true);
			}

			$scope.btnInstAddRowClick = function () {
				add(false);
			}

			$scope.btnInstAddChartClick = function () {
				add(false);
			}

			$scope.btnInstUpdChartClick = function () {
				update();
			}

			$scope.btnInstCloseClick = function () {
				closeDialog();
			};

			$scope.btnShowInstFilterRecodeDimension = function () {
				let dim = $rootScope.leftRail.card2.dim
				closeDialog();
				$rootScope.startingPoint = "init_recode_from_dim_slideout";
				$scope.$emit('openRecodeEditInstEvent', $rootScope.recodeAction.AddRecode, $rootScope.eventSrc.LeftRailPage, dim);
			}

			$scope.btnInstReloadPopup = function () {
				setupModal(dim);
			};

			function update() {
				$scope.toggleReadOnly(true);
				setFilterButtons(true);

				//workaround for Qlik error where updating an existing single school that has already been selected results in filter being removed and all schools listed
				if (singleSelectedInst != null && $scope.selectedInstValues.length == 1 && singleSelectedInst == $scope.selectedInstValues[0]) {
					$scope.toggleReadOnly(false);
					closeDialog();
					return;
				}

				var selected = [],
				saved = [];
				allValues.forEach(function (item) {
					if (item.class == 's') {
						selected.push(item.qElemNumber);
						saved.push(item);
					}
				});
				if (selected.length > 0) {
					dim.selected = true;
					appObj.field(dim.shortName).clear().then(function () {
						appObj.field(dim.shortName).select(selected, true, true).then(function () {
							dim.savedValues = saved;
							dim.selectedValuesCount = selected.length;

							closeDialog();
						});
					});
				} else {
					$rootScope.leftRail.card2.dim.selected = false;
					$scope.clearInstFilter();
					hyperCubeProperties.updateSelected(appObj, $rootScope, $scope, $rootScope.leftRail.card2.dim, "remove").then(function () {
						dim.selectedValuesCount = 0;
						closeDialog();
					}, function (err) {
						console.log('err', err);
						return;
					});
				}
			}

			function add(addCol) {
				$scope.toggleReadOnly(true);
				setFilterButtons(true);

				//google analytics tracking
				gtag('event', displayType + $rootScope.survey.abbreviation + '-Selecte dimension', {
					'event_label': 'select',
					'event_category': 'dimension',
					'event_variables': $rootScope.leftRail.card2.dim.shortName
				});

				$rootScope.visObj.table.OnData.unbind($scope.tblListener);
				var selected = [],
				saved = [];
				allValues.forEach(function (item) {
					if (item.class == 's') {
						selected.push(item.qElemNumber);
						saved.push(item);
					}
				});

				if (selected.length > 0) {
					$rootScope.leftRail.card2.dim.selected = true;
					hyperCubeProperties.updateSelected(appObj, $rootScope, $scope, dim, 'add', addCol).then(function () {

						appObj.field(dim.shortName).select(selected, false, true).then(function () {
							dim.savedValues = saved;
							dim.selectedValuesCount = selected.length;

							$rootScope.visObj.table.OnData.bind($scope.tblListener);
							closeDialog();
						});
					});
				} else {
					dim.selectedValuesCount = 0;
					closeDialog();
				}
			}

			function clearSelectInstList() {
				for (var i = 0; i < $scope.selectedInstValues.length; i++) {
					if ($scope.selectedInstValues[i].class == 'rh') {
						$scope.selectedInstValues[i].class = 's';
					}
				}
			}

			function clearAvailInstList() {
				for (var i = 0; i < $scope.availInstValues.length; i++) {
					if ($scope.availInstValues[i].class == 'lh') {
						$scope.availInstValues[i].class = 'o';
					}
				}
			}

			function setFilterButtons(disable) {
				lastAvailActive = -1;
				lastSelectActive = -1;
				$scope.disableAddSelections = true;
				$scope.disableRemoveSelections = true;

				if (disable) {
					$scope.disableActions = true;
					$scope.disableAddAll = true;
					$scope.disableClearAll = true;
					$("#instFilterModal .avail-list li").addClass("disable-item");
					$("#instFilterModal .selected-list li").addClass("disable-item");
					$("#instFilterModal .filter-dropdown button").addClass("disable-item");

				} else {
					var avail = 0;

					if (filteredAvailValues.length > 0) {
						avail = appUtilities.findMatches("class", "o", filteredAvailValues).length;
						avail += appUtilities.findMatches("class", "a", filteredAvailValues).length;
						$scope.availInstCountsMsg = avail + " institutions";
					} else {
						avail = appUtilities.findMatches("class", "o", allValues).length;
						avail += appUtilities.findMatches("class", "a", allValues).length;
						$scope.availInstCountsMsg = avail + " institutions";
					}

					var visible = getVisible(allValues);

					if (visible == 0) {
						if ($rootScope.leftRail.card2.recode != null) {
							if ($rootScope.leftRail.card2.recode.selectedValuesCount > 0) {
								$scope.disableActions = false;
							} else {
								$scope.disableActions = true;
							}
						} else {
							if ($rootScope.leftRail.card2.dim.selectedValuesCount > 0) {
								$scope.disableActions = false;
							} else {
								$scope.disableActions = true;
							}
						}
					} else {
						$scope.disableActions = false;
					}
					$("#instFilterModal .avail-list li").removeClass("disable-item");
					$("#instFilterModal .selected-list li").removeClass("disable-item");
					$("#instFilterModal .filter-dropdown button").removeClass("disable-item");
					//enable  Clear all only when selected list has one or more visible

					$scope.selectedInstCountsMsg = visible + " selected";
					if (visible > 0) {
						$scope.disableClearAll = false;
					} else {
						$scope.disableClearAll = true;
					}
					if (avail > 0) {
						$scope.disableAddAll = false;
					} else {
						$scope.disableAddAll = true;
					}

				}
			}

			function closeDialog(evt) {
				$("#instFilterModal").hide();
				isOpenFromLeftRail = true;
				$rootScope.selAltState.OnData.unbind(filterListener);
				$scope.closeLeftRail();
			};

			function getVisible(arr) {
				var selected = appUtilities.findMatches("class", "s", arr);
				return selected.length;
			}

			function syncAllValues(allValues, savedValues) {
				for (var x = 0; x < savedValues.length; x++) {
					var value = appUtilities.search("qElemNumber", savedValues[x].qElemNumber, allValues);
					if (value != null) {
						value.class = 's';						}
				}
				return;
			}

			function syncFilteredValues(tmp) {
				filteredAvailValues = [];
				for (var x = 0; x < tmp.length; x++) {
					var value = appUtilities.search("qElemNumber", tmp[x].qElemNumber, allValues);
					if (value != null) {
						if (value.class !== 's')
							value.class = tmp[x].qState.toLowerCase();

						filteredAvailValues.push(value);
					}
				}
				return;
			}

			function leftRailAutocompleteSearch(dim) {
				// auto-populate the searchInstText if the user has selected a Field Label from
				// the left rail autocomplete. By-pass ng-change method txtSearchInstChange()
				// as it uses Qlik to do the search. This search does not return one result as expected
				if (isOpenFromLeftRail) {
					isOpenFromLeftRail = false;
					if ($rootScope.suggestionBubble.valueSource == 'Field Labels') {
						if ($rootScope.variableIdsToHighlight.includes(dim.variableId)) {
							var availInstValueMatchingBubble = null;
							for (var x = 0; x < allValues.length; x++) {
								if (allValues[x].qText == $rootScope.suggestionBubble.storedValue) {
									availInstValueMatchingBubble = allValues[x];
									break;
								}
							}
							if (availInstValueMatchingBubble != null) {
								$scope.searchInstText = $rootScope.suggestionBubble.storedValue;

								var nodeMatchingBubble = availInstValueMatchingBubble;
								delete nodeMatchingBubble.listType;
								delete nodeMatchingBubble.selected;
								delete nodeMatchingBubble.level;
								delete nodeMatchingBubble.listId;
								delete nodeMatchingBubble.padding;
								delete nodeMatchingBubble.parent;
								delete nodeMatchingBubble.parentId;
								if ($scope.selectedInstValues.find(selectedValue => selectedValue.qText == $rootScope.suggestionBubble.storedValue))
									nodeMatchingBubble.class = 's';

								$scope.availInstValues = [nodeMatchingBubble];
								filteredAvailValues = [nodeMatchingBubble];
							}
						}
					}
				}
				setFilterButtons(false);
			}

			function pageAvailInstList() {
				var availViewport = $('#availInstViewport');
				var availListContent = $('#availInstListContent');
				var availListVisNodes = $('#availInstListVisNodes');
				var itemCount;
				var rowHeight = 29;
				var nodePadding = 2;

				var availList = filteredAvailValues.filter(function (item) {
					//console.log(item);
					if (item.class !== 's')
						return item;
				})
					itemCount = availList.length;

				var totalContentHeight = (itemCount * rowHeight ) + 'px';
				availListContent.height(totalContentHeight);
				var scrollTop = availViewport.scrollTop();

				var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
				startNode = Math.max(0, startNode);

				var visibleNodesCount = Math.ceil(availViewport.height() / rowHeight) + 2; //(2 * nodePadding);
				visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
				var offsetY = startNode * rowHeight;
				$scope.availInstValues = [];
				for (var x = startNode; x < availList.length; x++) {
					if (availList[x].class != "s") {
						$scope.availInstValues.push(availList[x]);
						if ($scope.availInstValues.length == visibleNodesCount) {
							break;
						}
					}
				}
				availListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
			}

			function pageSelectInstList() {
				var selectViewport = $('#selectInstViewport');
				var selectListContent = $('#selectInstListContent');
				var selectListVisNodes = $('#selectInstListVisNodes');
				var itemCount;
				var rowHeight = 29;
				var nodePadding = 2;
				var viewportHeight = 280;
				totalSelectedInstCount = 0;

				var list = [];
				list = allValues.filter(function (item) {
					if (item.class == 's')
						return item;
				})
					itemCount = list.length;
				// console.log('itemCount', itemCount);
				var totalContentHeight = ((itemCount) * rowHeight ) + 'px';
				selectListContent.height(totalContentHeight);

				var scrollTop = selectViewport.scrollTop();
				var startNode = Math.floor(scrollTop / rowHeight) - 1; //nodePadding;
				startNode = Math.max(0, startNode);

				var visibleNodesCount = Math.ceil(selectViewport.height() / rowHeight) + 2; //(2 * nodePadding);
				visibleNodesCount = Math.min(itemCount - startNode, visibleNodesCount);
				var offsetY = startNode * rowHeight;

				$scope.selectedInstValues = [];
				for (var x = startNode; x < list.length; x++) {
					if (list[x].class == "s") {
						//console.log('list ', list)
						$scope.selectedInstValues.push(list[x]);
						if ($scope.selectedInstValues.length == visibleNodesCount) {
							break;
						}
					}
				}

				selectListVisNodes.attr("style", "transform: translateY(" + (offsetY) + "px);");
			}

			function renderList() {
				return new qlik.Promise(function (resolve, reject) {
					// if(list.length > 0)
					// return resolve();

					var tmpValues = [];

					getListPage(tmpValues).then(function () {
						return resolve(tmpValues);
					});

					function getListPage(tmpValues) {
						return new qlik.Promise(function (resolve, reject) {

							dimensions.getValuesByDimension(appObj, dim, $scope.searchInstText, 'altState1').then(function (values) {
								values.forEach(function (e) {
									if (e.qState == "O" || e.qState == "S" || e.qState == "A") {
										if (dim.initializeToMeParam) {
											e.class = 's';
										} else {
											e.class = e.qState.toLowerCase();
										}
										tmpValues.push(e);
									}
								});
								values.forEach(function (e) {
									if (e.qState == "X" || e.qState == "XS") {
										e.class = 'x';
										tmpValues.push(e);
									}
								});
								return resolve(tmpValues);
							});

						});
					}

				})

			};

			$scope.getAvailInstListClass = function (value) {
				var retCls = value.class;
				return retCls;
			}

			$scope.getSelectInstListClass = function (value) {
				var retCls = value.class;
				return retCls;
			}

			$scope.toggleFilterListExpanded = function () {
				$scope.filterListExpanded = !$scope.filterListExpanded;
			}
		}
	]);
});

/*************************************************************
Description: This directive displays the dimension hierarchy filter popup.
This popup is similar to the simple filter popup used for dimensions with over 20 values
except it also provides the capability to filter on multiple dimensions that are related through a parent child relationship.
The Survey Get Dimensions API returns a modified structure that contains the hierarchical structure.  This structure is
returned for the top level dimension that has hierarchyAvailable flag set to Y.

This directive utilizes the qlik alternate state, which enables the user to filter on the institutions list without effecting the main table

Unlike the simple filter popup, this directive cannot use the Qlik List obj since it only supports retrieving values
for a single dimension and the tree modal must support 2 or more dimensions that have a parent/child relationship.
So this directive displays the hierachy tree structure using the table hypercube object.
The main differences between list obj and hypercube obj is that the Qlik list object retutns all values for a dimension.
Those values that have been applied to the filter are returned with a qState property of 'S',
this enables the directive to determine how to display values  with differrent states.  On the other hand,
the hypercube object only returns values that meet the filter criteria, so if a user returns to the tree modal after
previusly applying filters, then the table generated from the
hypercube will only display those previously selected values in the left side available list.  The workaround to this issue
is to store the state of the filtered data in memory. A copy of the list is stored to a scope variable called savedList.  On popup onpe, if savedList exist it is used to populateArray
both the availList and selectedList.  Upon returning to the treee modal, the program will retrieve the full set of values including those not previously selected to build
left side and right side tables in the modal.

Logic utilizes an object property named class to both determine when to display the value in the list and track if the value has been
previously selected.  States of the class property are:
- class='o' - This state indicates value has not been selected and is displayed in availList but not shown in selectedList
- class='s' - This state indicates value has been selected, so it is not shown in availList but shown in selectedList
- class='t' - This indicates value has been selected and the value has children that are both selected and unselected,
so this value needs to be shown in both the availList and selectedList

Because of the complexity of this directive, each time a user performs an update to the selected tree values, any previously applied
filter values are removed; the hypercube is then updated with the current set of selected dimensions; and then the
selected filters are applied to the the main pivot table hypercube.

 ***************************************/
'use strict'
define('scripts/directives/modalTreeFilterDirective',["qlik", "scripts/shared/appUtilities", "scripts/shared/hyperCubeProperties", "scripts/shared/dimensions"],
	function (qlik, appUtilities, hyperCubeProperties, dimensions) {

	angular.module("appModule").directive("dtModalTreeFilter", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtModalTreeFilter.html',
			scope: true,
			controller: 'FilterHierController'
		};
	});

	angular.module("appModule").controller("FilterHierController", ["$scope", "$rootScope", "$location", "$http",
			function ($scope, $rootScope, $location, $http) {
				var appObj = $rootScope.qApp;

				$scope.tree = {};
				$scope.tree.dimensions = [];
				var rootObj;
				var totalCount = 0;
				var listObjId;
				var isOpenFromLeftRail = true;
				var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

				$scope.clearTreeFilter = function (rootDim) {
					$rootScope.selAltState.clearAll(false);
					dimensions.resetDimension($rootScope, rootDim);
				}

				$scope.$on('showTreeFilterPopupEvent', function (e, item) {
					showTreeFilterPopup(item);
				});

				let showTreeFilterPopup = function (rootDim) {

					$scope.tree.rootDim = rootDim;
					$scope.tree.searchFilterTreeText = '';
					$scope.tree.dimensions = [];
					//if popup displayed previously, use values from previous display, otherwise default all dimensions to selected
					if ($scope.tree.rootDim.savedDims != null && $scope.tree.rootDim.savedDims.length > 0) {
						$scope.tree.dimensions = JSON.parse(JSON.stringify($scope.tree.rootDim.savedDims));
					} else {
						//poup not previously displayed, so default all dims to selected unless TB was invoked from ME,
						//in that case, only select the dimension passed in from ME
						$scope.tree.dimensions = JSON.parse(JSON.stringify(dimensions.getDimensionsForTree($scope.tree.rootDim)));
						//If dim was selected by call from ME, the dims will already have been elected
						var dimsSelected = appUtilities.findMatches("selected", true, $scope.tree.dimensions);
						if (dimsSelected.length == 0) {
							for (var x = 0; x < $scope.tree.dimensions.length; x++) {
								if ($scope.tree.dimensions[x].disabled) {
									$scope.tree.dimensions[x].selected = false;
								} else {
									$scope.tree.dimensions[x].selected = true;
									$scope.tree.dimensions[x].disabled = false;
								}
							}
						}
					}

					//remove dims that are not valid with selected measures
					var selectedMsrs = [];
					for (var x = 0; x < $rootScope.measureProperties.apiMeasureTopics.length; x++) {
						var apiGrps = $rootScope.measureProperties.apiMeasureTopics[x].measureGroups;
						for (var y = 0; y < apiGrps.length; y++) {
							var selected = appUtilities.findMatches("selected", true, apiGrps[y].measures);
							if (selected.length > 0) {
								selectedMsrs = selectedMsrs.concat(selected);
							}
						}
					}
					
					if (selectedMsrs.length > 0) {
						var tmpTree = $scope.tree.dimensions;
						for (var x = 0; x < $scope.tree.dimensions.length; x++) {
							let dim = $scope.tree.dimensions[x];							
							let found = false;
							for (var y = 0; y < selectedMsrs.length; y++) {
								if (selectedMsrs[y].associations.indexOf(dim.shortName) == -1) {
									found = false;
									break;
								} else {
									found = true;
								}
							}
							if (!found) {
								dim.disabled = true;
								dim.selected = false;
							} else {
								dim.disabled = false;
							}
						}
					}

					//if user has previously selected from tree, then show that copy of the tree which is in savedList
					if ($scope.tree.rootDim.savedList != null
						 && $scope.tree.rootDim.savedList.length > 0) {
						//do deep copy so availList does not reference the same array as savedList
						$scope.tree.availTreeValues = JSON.parse(JSON.stringify($scope.tree.rootDim.savedList));
						$scope.tree.selectedTreeValues = $scope.tree.availTreeValues;
						$scope.tree.rootDim.selectedValuesCount = appUtilities.findMatches("class", "s", $scope.tree.selectedTreeValues).length;
						setFilterButtons();
					} else {
						$rootScope.selAltState.clearAll(false).then(function () {
							renderList().then(function () {
								//If modal being displayed after user has imported saved data, then initialization 
								//needs to set list selections to match the imported data.  This condition is identified by savedDims haing data and savedList being empty
								if ($scope.tree.rootDim.savedDims != null && $scope.tree.rootDim.savedDims.length > 0) {
									$scope.tree.selectedTreeValues = $scope.tree.availTreeValues;
									
									let dimLevels = appUtilities.findMatches("selected", true, $scope.tree.rootDim.savedDims);
									//get lowest level in tree
									let dim = dimLevels[dimLevels.length - 1];
									if(dim.restoreValues) {
											dim.restoreValues.forEach(function(val) {
													$scope.tree.availTreeValues.forEach(function(availItem) {
															if(dim.shortName == availItem.shortName && val.qText == availItem.qText) {
																	if(dimLevels.length > 1) {
																			dimLevels[dimLevels.length - 2].restoreValues.forEach(function(val) {
																					if(availItem.parent == val.qText) {
																							setSelected(availItem, false);
																					}
																			})
																	} else {
																			//test with top level tree selected only
																			setSelected(availItem, false);
																	}												
															}															
													})
											})
									}									
									$scope.tree.rootDim.savedList = $scope.tree.availTreeValues;
								} else {
									$scope.tree.selectedTreeValues = $scope.tree.availTreeValues;
								}
								
								// auto-populate the searchFilterText if the user has selected a Field Label from
								// the left rail autocomplete. By-pass ng-change method txtSearchTreeFilterChange()
								// as it uses Qlik to do the search. This search does not return one result as expected
								if (isOpenFromLeftRail) {
									isOpenFromLeftRail = false;
									if ($rootScope.suggestionBubble.valueSource == 'Field Labels') {
										for (var i = 0; i < $scope.tree.dimensions.length; i++) {
											if ($rootScope.variableIdsToHighlight.includes($scope.tree.dimensions[i].variableId)) {
												for (var x = 0; x < $scope.tree.availTreeValues.length; x++) {
													if ($scope.tree.availTreeValues[x].qText == $rootScope.suggestionBubble.storedValue) {
														var nodeMatchingBubble = JSON.parse(JSON.stringify($scope.tree.availTreeValues[x]));
														nodeMatchingBubble.listType = "search";
														nodeMatchingBubble.selected = undefined;
														delete nodeMatchingBubble.level;
														delete nodeMatchingBubble.listId;
														delete nodeMatchingBubble.padding;
														delete nodeMatchingBubble.parent;
														delete nodeMatchingBubble.parentId;
														$scope.tree.availTreeValues = [nodeMatchingBubble];
														break;
													}
												}
												$scope.tree.searchFilterTreeText = $rootScope.suggestionBubble.storedValue;
											}
										}
									}
								}

								setFilterButtons();

								//after modal displayed for first time, set initMeParam to false
								//so logic that one time property setting code is not executed again
                                //clear initialization field in both savedDims and working dims
								for (var y = 0; y < $scope.tree.rootDim.savedDims.length; y++) {
									if ($scope.tree.rootDim.savedDims[y].initializeToMeParam) {
										$scope.tree.rootDim.savedDims[y].initializeToMeParam = false;
									}
								}
								for (var y = 0; y < $scope.tree.dimensions.length; y++) {
									if ($scope.tree.dimensions[y].initializeToMeParam) {
										$scope.tree.dimensions[y].initializeToMeParam = false;
									}
								}
								//$scope.tree.rootDim.savedList = JSON.parse(JSON.stringify($scope.tree.availTreeValues));
							});
						});
					}
					$("#filterTreeModal").show();
					return;
				}

				$scope.btnFilterTreeCloseClick = function (evt) {
					closeDialog();
				};

				$scope.listFilterTreeSelected = function (availValue, evt) {
					//if user entered text to search on then the values in avail list
					//are different objects then values in selected list, so update corresponding class in avail list
					var resetAvailList = false;
					if ($scope.tree.availTreeValues[0] && $scope.tree.availTreeValues[0].listType
						 && $scope.tree.availTreeValues[0].listType == "search") {
						resetAvailList = true;
					}
					if (resetAvailList) {
						for (var x = 0; x < $scope.tree.selectedTreeValues.length; x++) {
							if (availValue.qElemNumber == $scope.tree.selectedTreeValues[x].qElemNumber
								 && availValue.shortName == $scope.tree.selectedTreeValues[x].shortName) {
								setSelected($scope.tree.selectedTreeValues[x], resetAvailList);
							}
						}
						for (var x = 0; x < $scope.tree.availTreeValues.length; x++) {
							if (availValue.qElemNumber == $scope.tree.availTreeValues[x].qElemNumber &&
								availValue.shortName == $scope.tree.availTreeValues[x].shortName) {
								$scope.tree.availTreeValues[x].class = "s";
							}
						}
					} else {
						setSelected(availValue, resetAvailList);
					}
					//check if parent
					setFilterButtons();
				};

				$scope.listFilterTreeUnselected = function (value, evt) {
					var resetAvailList = false;
					if ($scope.tree.availTreeValues[0] && $scope.tree.availTreeValues[0].listType
						 && $scope.tree.availTreeValues[0].listType == "search") {
						resetAvailList = true;
					}

					clearSelected(value, resetAvailList);
					setFilterButtons();
				};

				function setSelected(value, resetAvailList) {
					if (value.class == 'x')
						return;

					value.selected = true;
					value.class = 's';
					//if all branch nodes are selected, mark branch as selected too
					var parent = value;
					for (var lvl = parent.level - 1; lvl >= 0; lvl--) {
						var parent = findParent(parent, $scope.tree.selectedTreeValues);
						if (parent) {
							parent.selected = true;

							var kids = findChildren(parent, $scope.tree.selectedTreeValues);
							if (kids.filter(function (elm) {
									return elm.class == "s";
								}).length == kids.length) {
								parent.class = "s";
							} else {
								//show in both avail list and selectedList since parent has kids in bpth lists
								parent.class = "t";
							}
						}
					}

					processLevel(value);
					function processLevel(value) {
						//Traverse tree to find lowest level and mark the item selected
						if (!resetAvailList) {
							var list = findChildren(value, $scope.tree.selectedTreeValues);
							for (var i = 0; i < list.length; i++) {
								list[i].selected = true;
								list[i].class = 's';
								processLevel(list[i]);
							}
						}
					}
				}

				function clearSelected(value, resetAvailList) {
					value.class = 'o';
					value.selected = false;
					if (resetAvailList) {
						var availVal = findItem(value, $scope.tree.availTreeValues);
						if (availVal != null)
							availVal.class = 'o';
					}

					processLevel(value);
					function processLevel(value) {
						//Traverse tree to find lowest level and mark the item unselected
						var list = findChildren(value, $scope.tree.selectedTreeValues);
						for (var i = 0; i < list.length; i++) {
							list[i].class = 'o';
							list[i].selected = false;
							if (resetAvailList) {
								var availVal = findItem(list[i], $scope.tree.availTreeValues);
								if (availVal != null)
									availVal.class = 'o';
							}
							processLevel(list[i]);
						}
					}

					if (!resetAvailList) {
						var parent = value;
						for (var lvl = parent.level; lvl >= 0; lvl--) {
							var parent = findParent(parent, $scope.tree.selectedTreeValues);
							if (parent) {
								var kids = findChildren(parent, $scope.tree.selectedTreeValues);
								if (kids.filter(function (elm) {
										return elm.class == "s" || elm.class == "t";
									}).length == 0) {
									parent.class = "o";
									//no more children, so remove value from filter if it has been applied
									parent.selected = false;
								} else {
									parent.class = "t";
								}
							}
						}
					}
				}

				function findItem(searchValue, searchArray) {
					for (var i = 0; i < searchArray.length; i++) {
						if (searchArray[i].qElemNumber == searchValue.qElemNumber
							 && searchArray[i].shortName == searchValue.shortName) {
							return searchArray[i];
						}
					}
					return null;
				}

				function findParent(searchValue, searchArray) {
					for (var i = 0; i < searchArray.length; i++) {
						if (searchArray[i].listId == searchValue.parentId) {
							return searchArray[i];
						}
					}
					return searchValue;
				}

				function findChildren(searchValue, searchArray) {
					var retArr = [];
					for (var i = 0; i < searchArray.length; i++) {
						if (searchArray[i].parentId == searchValue.listId) {
							retArr.push(searchArray[i]);
						}
					}
					return retArr;
				}

/* 				function findSiblings(searchValue, searchArray) {
					var retArr = [];
					for (var i = 0; i < searchArray.length; i++) {
						if (searchArray[i].listId == searchValue.parentId) {
							retArr = findChildren(searchArray[i], searchArray);
						}
					}
					return retArr;
				} */

				function setFilterButtons(disable) {
					if (disable) {
						$scope.disableActions = true;
						$scope.disableAddAll = true;
						$scope.disableClearAll = true;
						$("#filterTreeModal .avail-list li").addClass("disable-item");
						$("#filterTreeModal .selected-list li").addClass("disable-item");
					} else {
						$("#filterTreeModal .avail-list li").removeClass("disable-item");
						$("#filterTreeModal .selected-list li").removeClass("disable-item");
						var selected = appUtilities.findValuesMatches("class", ["s", "t"], $scope.tree.selectedTreeValues).length;
						if (selected > 0 || $scope.tree.rootDim.selectedValuesCount > 0) {
							$scope.disableActions = false;
						} else {
							$scope.disableActions = true;
						}
						if (selected > 0) {
							$scope.disableClearAll = false;
						} else {
							$scope.disableClearAll = true;
						}
						var avail = appUtilities.findMatches("class", "o", $scope.tree.availTreeValues).length;
						if (avail > 0) {
							$scope.disableAddAll = false;
						} else {
							$scope.disableAddAll = true;
						}
						
						//$scope.selectedFilterCountsMsg = getMarkedForSelectionCount($scope.tree.availTreeValues) + " values selected";
						$scope.selectedTreeFilterCountsMsg = selected + " selected";
					}
				}

				function closeDialog(evt) {
					$("#filterTreeModal").hide();
					$rootScope.selAltState.clearAll(false);
					$scope.closeLeftRail();;
					isOpenFromLeftRail = true;
				};

				function filterListCallBack(reply) {
					listObjId = reply.qInfo.qId;
				}

				function destroyObj() {
					appObj.destroySessionObject(listObjId).then(function (obj) {}, function (err) {
						//console.log('destroyObj err', err);
					});
				}

				$scope.checkDimension = function (dim) {
					renderList().then(function () {
						$scope.tree.selectedTreeValues = $scope.tree.availTreeValues;
						setFilterButtons();
					});
				}

				$scope.txtSearchTreeFilterChange = function (evt) {
					var textChange = function () {
						if ($scope.tree.searchFilterTreeText.length == 0 ||
							$scope.tree.searchFilterTreeText.length > 2) {
							renderList().then(function () {
								if ($scope.tree.searchFilterTreeText.length == 0) {
									for (var x = 0; x < $scope.tree.availTreeValues.length; x++) {
										$scope.tree.availTreeValues[x].class = $scope.tree.selectedTreeValues[x].class;
										$scope.tree.availTreeValues[x].selected = $scope.tree.selectedTreeValues[x].selected;
									}
									$scope.tree.selectedTreeValues = $scope.tree.availTreeValues;
								}
								return;
							});
						} else
							return;
					}
					_.debounce(textChange, 300, false)();
				};

				$scope.btnFilterTreeClearSearchBoxClick = function (evt) {
					$scope.tree.searchFilterTreeText = "";
					renderList().then(function () {
						for (var x = 0; x < $scope.tree.availTreeValues.length; x++) {
							$scope.tree.availTreeValues[x].class = $scope.tree.selectedTreeValues[x].class;
							$scope.tree.availTreeValues[x].selected = $scope.tree.selectedTreeValues[x].selected;
						}
						$scope.tree.selectedTreeValues = $scope.tree.availTreeValues;
						setFilterButtons();
					});
				};

				$scope.btnFilterTreeUpdateClick = function () {
					upd();
					$rootScope.$broadcast('resetExpandedEvent');
				}

				$scope.btnFilterTreeUpdChartClick = function () {
					upd();
				}

				function upd() {
					$scope.toggleReadOnly(true);
					setFilterButtons(true);

					var id = $("#variablesCols [data-cid='" + $scope.tree.rootDim.cId + "']");
					var toCol = id.length > 0 ? true : false;

					hyperCubeProperties.updateTreeFilterValue(appObj, $rootScope, $scope, toCol).then(function (action) {
						if (action == "del") {
							$scope.clearTreeFilter($scope.tree.rootDim);
							$rootScope.$broadcast('modifiedVisualizationEvent');
							$scope.toggleReadOnly(false); //resize() not working
						} else {
							//$scope.tree.rootDim.selectedValuesCount = appUtilities.findMatches("selected", true, $scope.tree.selectedTreeValues).length;
							$scope.tree.rootDim.selectedValuesCount = appUtilities.findMatches("class", "s", $scope.tree.selectedTreeValues).length;
							$scope.tree.rootDim.selected = true;
							$scope.tree.rootDim.savedList = $scope.tree.selectedTreeValues;
							$scope.tree.rootDim.savedDims = $scope.tree.dimensions;
						}
						hyperCubeProperties.getSelectedAssociations($rootScope, $scope.tree.rootDim);
						closeDialog();
					}, function (err) {
						appUtilities.showError(err);
					});
				}

				$scope.btnFilterTreeAddColumnClick = function () {
					add(true);
				}

				$scope.btnFilterTreeAddRowClick = function () {
					add(false)
				}

				$scope.btnFilterTreeAddChartClick = function () {
					add(false)
				}

				function add(toCol) {
					$scope.toggleReadOnly(true);
					setFilterButtons(true);
					//google analytics tracking
					var tags = $scope.tree.dimensions.map(function (x) {
						return x.shortName;
					}).toString();
					gtag('event', displayType + $rootScope.survey.abbreviation + '-Select dimension', {
						'event_label': 'select',
						'event_category': 'dimension',
						'event_variables': tags
					});

					$rootScope.leftRail.card2.dim.selected = true;
					hyperCubeProperties.updateTreeFilterValue(appObj, $rootScope, $scope, toCol).then(function () {
						$scope.tree.rootDim.selectedValuesCount = appUtilities.findMatches("selected", true, $scope.tree.selectedTreeValues).length;
						$scope.tree.rootDim.savedList = $scope.tree.selectedTreeValues;
						$scope.tree.rootDim.savedDims = $scope.tree.dimensions;
						$scope.tree.rootDim.selected = true;
						hyperCubeProperties.getSelectedAssociations($rootScope, $scope.tree.rootDim);
						closeDialog();
					}, function (err) {
						appUtilities.showError(err);
					});
				}

				$scope.btnAddAllTreeSelectionsClick = function (evt) {

					var resetAvailList = false;
					if ($scope.tree.availTreeValues[0] && $scope.tree.availTreeValues[0].listType
						 && $scope.tree.availTreeValues[0].listType == "search") {
						resetAvailList = true;
					}

					if (resetAvailList) {
						for (var x = 0; x < $scope.tree.availTreeValues.length; x++) {
							for (var y = 0; y < $scope.tree.selectedTreeValues.length; y++) {
								if ($scope.tree.availTreeValues[x].qElemNumber == $scope.tree.selectedTreeValues[y].qElemNumber
									 && $scope.tree.availTreeValues[x].shortName == $scope.tree.selectedTreeValues[y].shortName) {
									$scope.tree.availTreeValues[x].class = 's';
									setSelected($scope.tree.selectedTreeValues[y], resetAvailList);
								}
							}
						}
					} else {
						var level = $scope.tree.dimensions.length - 1;
						for (var i = 0; i < $scope.tree.selectedTreeValues.length; i++) {
							$scope.tree.selectedTreeValues[i].selected = true;
							$scope.tree.selectedTreeValues[i].class = 's';
						};
					}
					setFilterButtons();
				};

				$scope.btnFilterTreeClearAllSelectionsClick = function (evt) {

					if ($scope.tree.searchFilterTreeText.length > 0) {
						for (var x = 0; x < $scope.tree.availTreeValues.length; x++) {
							for (var y = 0; y < $scope.tree.selectedTreeValues.length; y++) {
								if ($scope.tree.availTreeValues[x].qElemNumber == $scope.tree.selectedTreeValues[y].qElemNumber
									 && $scope.tree.availTreeValues[x].shortName == $scope.tree.selectedTreeValues[y].shortName) {
									$scope.tree.availTreeValues[x].class = 'o';
									$scope.tree.availTreeValues[x].selected = false;
								}
							}
						}
					}

					for (var x = 0; x < $scope.tree.selectedTreeValues.length; x++) {
						var value = $scope.tree.selectedTreeValues[x];
						if (value.class == 's' || value.class == 't') {
							value.class = 'o'
								value.selected = false;
						}
					}
					setFilterButtons();
				};

/* 				$scope.btnShowRecodeTree = function () {
					$scope.showRecodeTreePopup($scope.tree.rootDim, $scope.tree.dimensions);
				} */

				function getDimListDef(startRow, dim) {
					var dimListDef = {
						qInfo: {
							qType: "filter"
						},
						qListObjectDef: {
							qDef: {
								qFieldDefs: [dim.shortName],
								qSortCriterias: [{
										qSortByAscii: dimensions.getSortDefault(dim.valueSortDefault)
										//qSortByLoadOrder: 1
									}
								]
							},
							qShowAlternatives: true,
							qStateName: "altState1",
							qInitialDataFetch: [{
									qLeft: 0,
									qWidth: 1,
									qTop: startRow,
									qHeight: 5000
								}
							]
						}
					}
					return dimListDef;
				}

				function getDimHierarchyDef(startRow) {
					var dimDef = {};
					dimDef.qHyperCubeDef = {
						qSuppressZero: true,
						qSuppressMissing: true,
						qMode: "S"
					};

					dimDef.qHyperCubeDef.qDimensions = [];
					for (var x = 0; x < $scope.tree.dimensions.length; x++) {
						if ($scope.tree.dimensions[x].selected) {
							dimDef.qHyperCubeDef.qDimensions.push({
								qDef: {
									qFieldDefs: [$scope.tree.dimensions[x].shortName],
									qSortCriterias: [{
											qSortByAscii: 0,
											qSortByLoadOrder: 1
										}
									]
								}
							});
						};
					};

					dimDef.qHyperCubeDef.qMeasures = [{
							qDef: {
								//qDef : "1"
								qDef: "=Count(1)"
							}
						}
					];
					dimDef.qHyperCubeDef.qStateName = "altState1";
					dimDef.qHyperCubeDef.qInitialDataFetch = [{
							qLeft: 0,
							qTop: startRow,
							qWidth: 5,
							qHeight: 2000
						}
					];
					return dimDef;
				}

				/******
				The matrix processing can be confussing so this comment	describes the matrix structure to help developer understand the
				processing logic that follows.

				// qArea:
				// qLeft: 0
				// qTop: 0
				// qWidth: 4  //3 dims selected: S&EFields, BroadFields, and DetailedFields
				// qHeight: 39
				// __proto__: Array(0)
				0: Array(4)
				0: {qText: "Non-science and engineering", qNum: "NaN", qElemNumber: 1, qState: "O"}
				1: {qText: "Education", qNum: "NaN", qElemNumber: 5, qState: "O"}
				2: {qText: "Education administration", qNum: "NaN", qElemNumber: 18, qState: "O"}
				3: {qText: "1", qNum: 1, qElemNumber: 0, qState: "L"}
				length: 4
				__proto__: Array(0)
				1: Array(4)
				0: {qText: "Non-science and engineering", qNum: "NaN", qElemNumber: 1, qState: "O"}
				1: {qText: "Education", qNum: "NaN", qElemNumber: 5, qState: "O"}
				2: {qText: "Education research", qNum: "NaN", qElemNumber: 11, qState: "O"}
				3: {qText: "1", qNum: 1, qElemNumber: 0, qState: "L"}
				//console.log('matrix', hyperCube.layout.qHyperCube.qDataPages[0].qMatrix);
				 ******/
				var cntr = (function () {
					var cnt = 0;
					return function () {
						cnt += 1;
						return cnt
					}
				})();

				function buildList(hyperCube) {
					//modal = document.querySelector("#filterTreeModal");
					var colsFilled = [];
					var availList = [];
					var cnt = 0;
					var selDims = appUtilities.findMatches("selected", true, $scope.tree.dimensions);
					//code for converting matrix into a table with indented rows
					hyperCube.layout.qHyperCube.qDataPages[0].qMatrix.forEach(function (e) {
						for (var x = 0; x < hyperCube.layout.qHyperCube.qDataPages[0].qArea.qWidth; x++) {
							if (e[x].qState !== 'L') {
								if (colsFilled[x] == null
									 || (colsFilled[x].qElemNumber !== e[x].qElemNumber
										 && colsFilled[x].shortName !== e[x].shortName)) {
									colsFilled[x] = e[x];
									populateArray(colsFilled, availList, e, x);
								}
							}
						}
					});
                    $scope.tree.availTreeValues = availList;

					function populateArray(colsFilled, availList, e, x) {
						if (x == 0) {
							e[x].parent = null;
							e[x].parentId = null
						} else {
							e[x].parent = colsFilled[x - 1].qText;
							e[x].parentId = colsFilled[x - 1].listId; //e[x-1].qElemNumber;
						}
						e[x].level = x;
						e[x].shortName = selDims[x].shortName;
						e[x].qId = selDims[x].qId;
						e[x].listId = cnt++;
						e[x].padding = {
							'padding-left': (x * 15) + 'px'
						};
						//if dim was paseed in from ME, set all values to show in right side (selected) list
						if (selDims[x].initializeToMeParam) {
							e[x].class = 's';
						} else {
							e[x].class = e[x].qState.toLowerCase();
						}
						availList.push(e[x]);
					}
				}

				function renderList() {
					return new qlik.Promise(function (resolve, reject) {
						var values = [];
						var startRow = 0;
						//var modal;

						//modal = document.querySelector("#filterTreeModal");
						getListPage(startRow).then(function (hyperCube) {
							if (hyperCube != null) {
								buildList(hyperCube);
							}
							return resolve();
						}, function (err) {
							console.log('err', err);
						});

						function getListPage(startRow) {
							return new qlik.Promise(function (resolve, reject) {
								if ($scope.tree.searchFilterTreeText.length > 0) {
									//logic for looping promise calls; need to build list after sequentially retrieving search results for each dimension in tree
									$scope.tree.availTreeValues = [];
									var p = Promise.resolve();
									var selDims = appUtilities.findMatches("selected", true, $scope.tree.dimensions);
									for (var i = 0; i < selDims.length; i++) {
										var x = 0;
										p = p.then(function () {
											return new Promise(function (resolve, reject) {
												var dimName = selDims[x].shortName;
												var qId = selDims[x].qId;
												appObj.createGenericObject(getDimListDef(startRow, selDims[x]), filterListCallBack).then(function (dimList) {
													dimList.searchListObjectFor("/qListObjectDef", $scope.tree.searchFilterTreeText).then(function (resp) {
														destroyObj();
														dimList.getLayout().then(function (layout) {
															if (layout.qListObject.qDataPages.length > 0) {
																var data = layout.qListObject.qDataPages[0].qMatrix;
																data.forEach(function (e) {
																	var obj = e[0];
																	obj.shortName = dimName;
																	obj.qId = qId;
																	obj.class = 'o';
																	obj.listType = "search";
																	$scope.tree.availTreeValues.push(obj);
																});
																x += 1;
																return resolve();
															} else {
																x += 1;
																return resolve();
															}

														});
													}, function (err) {
														console.log('searchFilter', err);
														return reject(err);
													});
												}, function (err) {
													console.log('searchFilter', err);
													return reject(err);
												});
											});
										}, function (err) {
											console.log('searchFilter', err);
											return reject(err);
										});
									};
									p.then(function () {
										return resolve();
									});

								} else {
									appObj.createGenericObject(getDimHierarchyDef(startRow)).then(function (hcObj) {
										return resolve(hcObj);
									}, function (err) {
										console.log('err', err);
									});
								};
							})

						};
					});
				};
				
/* 				function getMarkedForSelectionCount(arr) {
					if (arr == null)
						return 0;

					return arr.filter(function (elm) {
						return elm.qState == 'S';
					}).length;
				}	 */			
			}
		]);
});

'use strict'
define('scripts/directives/dataSummaryDirective',["qlik", "scripts/shared/webProperties", "scripts/shared/appUtilities", "scripts/shared/dimensions", "scripts/shared/measures"],
	function (qlik, webProperties, appUtilities, dimensions, measures) {
	angular.module("appModule").directive("dtDataSummary", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtDataSummary.html',
			scope: true,
			transclude: false,
			controller: 'DataSummaryController'
		};
	});

	angular.module("appModule").controller("DataSummaryController", ["$rootScope", "$scope", "$http", function ($rootScope, $scope, $http) {

				$scope.$on('loadDataSummaryEvent', function (e) {
					$scope.loadDataSummary();
				});		

				$scope.loadDataSummary = function () {
					return new qlik.Promise(function (resolve, reject) {
						$scope.summaryList = [];
						var selectedList = [];
						var resp;

						var list = []
						for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
							var apiGrps = $rootScope.measureProperties.apiMeasureTopics[i].measureGroups;
							for (var j = 0; j < apiGrps.length; j++) {
								for (var k = 0; k < apiGrps[j].measures.length; k++) {
									if (apiGrps[j].measures[k].selected == true) {
										selectedList.push(apiGrps[j].measures[k].variableId);
										list.push(apiGrps[j].measures[k]);
									}
								}
							}
						}

						for (var w = 0; w < $rootScope.dimensionProperties.apiDimTopics.length; w++) {
							var topic = $rootScope.dimensionProperties.apiDimTopics[w];
							for (var x = 0; x < topic.dimensionGroups.length; x++) {
								var grp = topic.dimensionGroups[x];
								for (var y = 0; y < grp.dimensions.length; y++) {
									if (grp.dimensions[y].hierarchyAvailable == "Y") {
										if (grp.dimensions[y].selected) {
											var definedTree = grp.dimensions[y].savedDims;
											for (var z = 0; z < definedTree.length; z++) {
												if (definedTree[z].selected) {
													selectedList.push(definedTree[z].variableId);
													var item = definedTree[z];
													list.push(item);
												}
											}
										} else if (grp.dimensions[y].recodeTrees != null) {
											var recodeTree = grp.dimensions[y].recodeTrees;
											for (var z = 0; z < recodeTree.length; z++) {
												if (recodeTree[z].selected) {
													for (var a = 0; a < recodeTree[z].dimensions.length; a++) {
														if (recodeTree[z].dimensions[a].selected) {
															selectedList.push(recodeTree[z].dimensions[a].variableId);
															list.push(recodeTree[z].dimensions[a]);
														}
													}
												}
											}
										} else if (grp.dimensions[y].commonRecodeTrees != null) {
											var recodeTree = grp.dimensions[y].commonRecodeTrees;
											for (var z = 0; z < recodeTree.length; z++) {
												if (recodeTree[z].selected) {
													for (var a = 0; a < recodeTree[z].dimensions.length; a++) {
														if (recodeTree[z].dimensions[a].selected) {
															selectedList.push(recodeTree[z].dimensions[a].variableId);
															list.push(recodeTree[z].dimensions[a]);
														}
													}
												}
											}
										}
									} else {
										
										if (grp.dimensions[y].selected == true) {
											selectedList.push(grp.dimensions[y].variableId);
											list.push(grp.dimensions[y]);
										} 
									
										if (grp.dimensions[y].recodes) {
											for (var a = 0; a < grp.dimensions[y].recodes.length; a++) {
												if (grp.dimensions[y].recodes[a].selected) {
													selectedList.push(grp.dimensions[y].variableId);
													var item = {};
													item.variableId = grp.dimensions[y].variableId
														item.recodeName = grp.dimensions[y].recodes[a].recodeName;
													item.recode = grp.dimensions[y].recodes[a];
													list.push(item);
												}
											}
										}

										if (grp.dimensions[y].commonRecodes) {
											for (var a = 0; a < grp.dimensions[y].commonRecodes.length; a++) {
												if (grp.dimensions[y].commonRecodes[a].selected) {
													selectedList.push(grp.dimensions[y].variableId);
													var item = {};
													item.variableId = grp.dimensions[y].variableId
														item.recodeName = grp.dimensions[y].commonRecodes[a].recodeName;
													item.recode = grp.dimensions[y].commonRecodes[a];
													list.push(item);
												}
											}
										}
									}
								};
							}
						};

						appUtilities.getSurveyVariableListFromApi(qlik, $http, selectedList).then(function (apiDetails) {
							for (var d = 0; d < list.length; d++) {
								setDetailsProperties(list[d], apiDetails.data.body.content);
							}
							return resolve();
						}, function (err) {
							return reject(err);
						});

					});
				}

				$scope.clickVariableDetails = function (item) {
					$rootScope.$broadcast('openVariableDetailsEvent', item);
				}

				function setDetailsProperties(variable, content) {
					for (var d = 0; d < content.length; d++) {
						if (content[d].variableType.toLowerCase() == 'measure') {
							if (variable.variableId == content[d].variableId) {
								variable.variableYearsAvailable = content[d].variableYearsAvailable;
								variable.survey = content[d].survey;
								variable.units = content[d].units;
								variable.variableShortDescription = content[d].variableShortDescription;
								variable.variableName = content[d].variableName;
								variable.measures = null;
								$scope.summaryList.push(variable);
							}
						}
					}

					for (var d = 0; d < content.length; d++) {
						if (content[d].variableType.toLowerCase() == 'dimension') {
							if (variable.variableId == content[d].variableId) {
								variable.variableYearsAvailable = content[d].variableYearsAvailable;
								variable.survey = content[d].survey;
								variable.units = content[d].units;
								variable.variableShortDescription = content[d].variableShortDescription;
								if (variable.recodeName != null) {
									variable.variableName = content[d].variableName + " [Custom: " + variable.recodeName + "]";
								} else {
									variable.variableName = content[d].variableName;
								}
								variable.measures = content[d].measures;
								$scope.summaryList.push(variable);
							}
						}
					}
					$scope.summaryList = appUtilities.removeDuplicates($scope.summaryList, 'variableName');
					return;
				}
			}
		])
});

'use strict'
define('scripts/directives/variableDetailsDirective',["qlik", "scripts/shared/webProperties", "scripts/shared/dimensions", "scripts/shared/appUtilities"],
	function (qlik, webProperties, dimensions, appUtilities) {
	angular.module("appModule").directive("dtVariableDetails", function() {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtVariableDetails.html',
      scope: true,
			controller: ("variableDetailsCtrl", ["$scope","$rootScope", "$http", function($scope, $rootScope, $http) {
      	$scope.variableDetailsDisplay = false;
				$scope.countSection = {};
				$scope.numOfTopics = 0;
				var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				$scope.clickOpenFB = function (tab) {
					//google analytics tracking
					gtag('event', displayType + $rootScope.survey.abbreviation+'-Open feedback', {
						'event_label': 'open',
						'event_category': 'feedback'
					});
					//$scope.postSuccessful = false;
					//$scope.postHasErrors = false;
					if(tab) {
						$('#feedbackMenu a[href="#' + tab + '"]').tab('show');
					}
					$("#feedbackModal").modal();
				}

				$scope.$on('closeVariableDetailsEvent', function() {
					$scope.clickCloseVariableDetails();
				})

				$scope.clickCloseVariableDetails = function() {
          $scope.variableDetailsDisplay = false;
					document.removeEventListener('click',variableDetailPanelEventListener);
        }

				$scope.clickOpenPulblicUseFile = function(id) {
					window.open($scope.variableDetails.publicUseUrl);
				}

				$scope.clickOpenDataTablesUrl = function() {
					window.open($scope.variableDetails.dataTablesUrl);
				}

				function calculateFieldLabelDimensions(variablesFieldValuesData) {
					setTimeout(function() {
					  if(variablesFieldValuesData) {
							$scope.variablesFieldValuesData = variablesFieldValuesData;
							var labelIds = [];
							for(var i = 0; i < variablesFieldValuesData.length; i++) {
								labelIds.push('fieldLabelContainer'+ i.toString())
							}
							/**Caluclate Min-Height **/

							for(var i = 0; i < labelIds.length; i++) {
								var id = labelIds[i];
								var elem = document.getElementById(id);
								if(elem !== null) {
									var height = elem.innerText.trim().split('\n').length * 24;
									if (height < 10 * 21) {
										document.getElementById(id).style['overflow-y'] = 'hidden';
										document.getElementById(id).style.height = height.toString() + 'px';
										document.getElementById(id).style.border = 'none';
									} else {
										document.getElementById(id).style['overflow-y'] = 'scroll';
										document.getElementById(id).style.height =  '210px';
										document.getElementById(id).style.border = '1px solid slategray';
									}
								}
							}
						}
					}, 100);
				}


				$scope.qlikName = function(){
					var definition =  "Qlik is the tabulation engine used to run the Data Tool. You can use the Qlik Name of the variable to create a direct URL to preselect that variable in the Table Builder or Chart Builder. \nTable Builder:\nTo preselect only measure:\nhttps://ncsesdata.nsf.gov/builder/(survey name abbreviation)?msr=(Qlik Name)\nExample:\nhttps://ncsesdata.nsf.gov/builder/fac?msr=mComplCostCurrNewFld\n\nTo preselect only dimension:\nhttps://ncsesdata.nsf.gov/builder/(survey name abbreviation)?dim=(Qlik Name)\nExample:\nhttps://ncsesdata.nsf.gov/builder/gss?dim=instCarnegie2018\n\nTo preselect a measure and dimension:\nhttps://ncsesdata.nsf.gov/builder/(survey name abbreviation)?msr=(Qlik Name of measure)&dim=(Qlik Name of dimension)\nExample:\nhttps://ncsesdata.nsf.gov/builder/herd?msr=mRDExpFldFundSrc&dim=fundingAgency\n\nChart Builder:\n\nTo preselect a measure:\nhttps://ncsesdata.nsf.gov/builder/(survey name abbreviation)?type=chart&msr=(Qlik Name)\nExample:\nhttps://ncsesdata.nsf.gov/builder/fac?type=chart&msr=mComplCostCurrRepairFld\n\nTo preselect a dimension:\nhttps://ncsesdata.nsf.gov/builder/(survey name abbreviation)?type=chart&dim=(Qlik Name)\nExample:\nhttps://ncsesdata.nsf.gov/builder/gss?type=chart&dim=instCarnegie2018\n\nTo preselect a measure and dimension:\nhttps://ncsesdata.nsf.gov/builder/(survey name abbreviation)?type=chart&msr=(Qlik name of measure)&dim=(Qlik name of dimension)\nExample:\nhttps://ncsesdata.nsf.gov/builder/herd?type=chart&msr=mRDExpFldFundSrc&dim=fundingAgency\n";
					let item = definition.split('\n');
					let replacedItem = '';
					for(var i=0; i < item.length; i++){
						var itemDef = item[i] + '\n';
						if(!itemDef.includes('(survey name abbreviation)')){
							let exp_match = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
						    replacedItem += itemDef.replaceAll(exp_match, "<a href='$1' target='_blank'>$1</a>");
							//console.log('replacedItem', replacedItem)
						}else {
                            replacedItem += itemDef;
						}
					}
					return replacedItem;
				}

				function calculateDescriptionHeight() {
					setTimeout(function(){
					if(document.getElementById('measureDescription') !== null){
						var height = document.getElementById('measureDescription').innerText.trim().split('\n').length * 24;
						if (height < 10 * 24) {
						}
					}
					else if(document.getElementById('dimensionDescription') !== null){
						var height = document.getElementById('dimensionDescription').innerText.trim().split('\n').length * 24;
						if (height < 10 * 24) {
						}
					}
					}, 100);
				}

				function updateCountsYearDropdown(variableId) {
					// alert('111 $scope.countYearModel: ' + $scope.countYearModel);
					appUtilities.getSurveyVariableDetailsFromApi(qlik, $http, variableId).then(function(resp){
						if(resp.data.body.countedYears){
							$scope.countedYears = resp.data.body.countedYears.reverse();
							$scope.countSection.countYearModel = $scope.countedYears[0];
							appUtilities.getVariableCountsFromApi(qlik,$http,variableId,$scope.countedYears[0]).then(function(resp){
								if(resp){
									// console.log('resp2: ', resp)
									$scope.countError = false;
									$scope.sampleCounts = resp.data.body.counts;
									for(var i = 0; i < $scope.sampleCounts.length; i++){
										var sampleCount = $scope.sampleCounts[i];
										sampleCount.unweightedTotal = sampleCount.unweightedTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
										sampleCount.weightedTotal = sampleCount.weightedTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
									}
								} else{
									$scope.countError = true;
								}
							});
						}
					});

				}

				$scope.countYearSelect = function() {
					//$scope.countYearModel = countYear;
					// console.log('333 $scope.countYearModel: ' + $scope.countYearModel);

					appUtilities.getVariableCountsFromApi(qlik,$http, $scope.variableDetails.variableId, $scope.countSection.countYearModel).then(function(resp){
						if(resp){
							// console.log('resp2: ', resp)

							$scope.sampleCounts = resp.data.body.counts;
							for(var i = 0; i < $scope.sampleCounts.length; i++){
								var sampleCount = $scope.sampleCounts[i];
								sampleCount.unweightedTotal = sampleCount.unweightedTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								sampleCount.weightedTotal = sampleCount.weightedTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
							}
						} else {
							console.log('no count year selected response');
						}
					}, function(err) {
						console.log('count year selected err', err);
					});

				}

				function parseMarkup(field) {
					field = marked.parse(field);
					field = field.replaceAll('<li>', '<li class="variables-disc">')
					return field;
				}

				function variableDetailPanelEventListener (e) {
					if (!document.getElementById('variableDetailsPanel').contains(e.target)){
						//clicked outside left rail
						//console.log('outside');                         
						document.removeEventListener('click',variableDetailPanelEventListener);
						$scope.variableDetailsDisplay = false;
						var phase = $rootScope.$$phase;
						if (phase !== '$apply' && phase !== '$digest') {
							//console.log('invoking apply()')
							$scope.$apply();
						}
					}
				}

				$scope.scrollClasses = {'measureVariableLongDescription':'variables-no-scrollbox', 'key2':'value2'}

				$scope.$on('openVariableDetailsEvent', function(e, item) {
					$scope.clickVariableDetails(item);
				})

				$scope.clickVariableDetails = function(dim) {
					$scope.$broadcast('closeSurveyDetailsEvent');

					gtag('event', displayType +  $rootScope.survey.abbreviation+'-Open variable details', { 
						'event_label': 'view', 
						'event_category': 'metadata'}
					);
					var variable = {};
                    $scope.numOfTopics = 0;
					var title = dim.title;
					appUtilities.getSurveyVariableDetailsFromApi(qlik, $http, dim.variableId).then(function(resp) {
						$scope.variableDetails = resp.data.body;

						if($scope.variableDetails.variableLongDescription) {
							$scope.variableDetails.variableLongDescription = $scope.variableDetails.variableLongDescription.trim();
							$scope.variableDetails.variableLongDescription = parseMarkup($scope.variableDetails.variableLongDescription);
						}

						if($scope.variableDetails.variableDerived)
							$scope.variableDetails.variableDerived = $scope.variableDetails.variableDerived.trim();

						if($scope.variableDetails.surveyQuestionNumbers)
							$scope.variableDetails.surveyQuestionNumbers = $scope.variableDetails.surveyQuestionNumbers.trim();

						if($scope.variableDetails.surveySummary) {
							$scope.variableDetails.surveySummary = $scope.variableDetails.surveySummary.trim();
							$scope.variableDetails.surveySummary = parseMarkup($scope.variableDetails.surveySummary);
						}
						if($scope.variableDetails.surveyQuestionText) {
							$scope.variableDetails.surveyQuestionText = $scope.variableDetails.surveyQuestionText.trim();
							$scope.variableDetails.surveyQuestionText = parseMarkup($scope.variableDetails.surveyQuestionText);
						}
						// $scope.calculateScrollBoxRules('measureVariableLongDescription', true);
						// $scope.calculateScrollBoxRules('measureHowVariableIsDerived', true);
						// $scope.calculateScrollBoxRules('dimensionVariableLongDescription', true);
						// $scope.calculateScrollBoxRules('dimensionHowVariableIsDerived', true);
						$scope.variableDetails.surveyQuestions = $scope.variableDetails.surveyQuestions? $scope.variableDetails.surveyQuestions.split("\r\n"): null;
						for(var i=0; i < $scope.variableDetails.topics.length; i++){
		                    var topic = $scope.variableDetails.topics[i];
							$scope.numOfTopics++;
							$scope.numOfTopics += topic.topics.length;
						}
						// console.log('details', $scope.variableDetails);
						$scope.variableDetailsDisplay = true;
						document.addEventListener('click', variableDetailPanelEventListener);	
						$scope.$watch("variableDetailsDisplay", function (value) {
 							setTimeout(function() {
								$("#variableDetailsPanel a[data-tooltip='survey']").popover({trigger: 'focus'} );
							}, 500);
						});
						if($scope.variableDetails.variableType == "Dimension") {
                            $('#tabDimensionLink').tab('show');
							appUtilities.getSurveyVariableValuesFromApi(qlik, $http, dim.variableId).then(function(resp) {
								for(var x=0; x < resp.data.body.length; x++) {
									if(resp.data.body[x].dimensionHierarchyName) {
/* 										if(dim.type == "dim-branch") {
											var treeRoot = dimensions.getTreeRootByBranchCID($rootScope, dim.cId);
											title = treeRoot != null ? treeRoot.title: "";
										} else if(dim.type == "recode") {
											var recodeDim = dimensions.getDimensionByCid($rootScope, dim.cId);
											$scope.variableDetails.values = recodeDim.values;
											calculateFieldLabelDimensions(resp.data.body);
											calculateDescriptionHeight();
										} */

										if(dim.type == "dim-branch") {
											var treeRoot = dimensions.getTreeRootByBranchCID($rootScope, dim.cId);
											title = treeRoot != null ? treeRoot.title: "";
										} else if(dim.type == "recode") {
											// var recodeDim = dimensions.getDimensionByCid($rootScope, dim.dimCid);
											// title = recodeDim != null ? recodeDim.title: "";
											var treeRoot = dimensions.getTreeRootByBranchCID($rootScope, dim.dimCid);
											title = treeRoot != null ? treeRoot.title: "";
										}

										if(resp.data.body[x].dimensionHierarchyName == title) {
											$scope.variableDetails.values = resp.data.body[x].codeHier1;
											$scope.variableDetails.dimensionHierarchyName = resp.data.body[x].dimensionHierarchyName;
											$scope.variableDetails.treeFound = resp.data.body[x].varDimHier1 != null?  true: false;
											$scope.variableDetails.dimTree = dimensions.getDimensionsForValueTree(resp.data.body[x]);
											calculateFieldLabelDimensions(resp.data.body);
											calculateDescriptionHeight();
											break;
										}
									} else {
										$scope.variableDetails.values = resp.data.body[x].codeHier1;
										calculateFieldLabelDimensions(resp.data.body);
										calculateDescriptionHeight();
									}
								}
								//console.log('dimTree', $scope.variableDetails.dimTree);
							},  function(err) {
								if(err != "empty")
									appUtilities.showError(err);
								return;
							})
						}
						else {
                            $('#tabMeasureLink').tab('show');
						}
					},  function(err) {
						appUtilities.showError(err);
						return;
					})

					updateCountsYearDropdown(dim.variableId);
				}

				var imageWindow;
				$scope.thumnailClickHandler = function(e){

					var imgObj = new Image();
					imgObj.src = e.target.src;
					//var imgW = imgObj.width > 100? imgObj.width : 100;
					//var imgH = imgObj.height > 100? imgObj.height : 100;

					var imgW = window.innerWidth * .5;
					var imgH = window.innerHeight * .5;

					var windowOptions = "location=no,width=" + (imgW + 10) + ",height=" + (imgH + 60);
					var windowTitle = "QuestionnaireImage";
					if(imageWindow){
						imageWindow.close();
						imageWindow = null;
					}
					imageWindow = window.open("", windowTitle, windowOptions);
					imageWindow.document.body.appendChild(imgObj);

					var div = document.createElement("div");
					var attr = document.createAttribute("style");
					attr.value = "margin: 15px 0 20px 0";
					div.setAttributeNode(attr);
					imageWindow.document.body.appendChild(div);

					var btn = document.createElement("button");
					btn.innerText = "Close"
					var attB = document.createAttribute("style");
					attB.value = "margin:0 auto; width:80px; display:block";
					btn.setAttributeNode(attB);
					btn.addEventListener("click", function(){
						imageWindow.close();
						imageWindow = null;
					});
					div.appendChild(btn);
				}

				$scope.clickExportDetails = function () {
					$rootScope.$broadcast('showExportMetadataEvent', $scope.variableDetails, 'variable');	
				}

				$scope.clickVarDetailsTab = function(e, tabGroupId, tabName, scrollToId=false) {
					e.preventDefault();
					$(tabName).tab('show');
					if(scrollToId) {
						document.getElementById(scrollToId).scrollIntoView(true);
					}
				}

				$scope.calculateScrollBoxRules = function(elementId, st) {
					if(st) {
						setTimeout(function () {
							return countLines(elementId);
						}.bind(this), 200);
					}
					else {
						return countLines(elementId);
					}

				}

				function countLines(elementId) {
					var el = document.getElementById(elementId);
					if(el && el.offsetHeight) {
						var divHeight = el.offsetHeight
						var lineHeight = 21;
						var lines = divHeight / lineHeight;

						if (lines !== null && lines <= 10) {
							$scope.scrollClasses[elementId] = "variables-no-scrollbox";
							return 'variables-no-scrollbox';
						}
						else if (lines !== null && lines > 10) {
							$scope.scrollClasses[elementId] = "variables-scrollbox";
							return 'variables-scrollbox';
						}
					}
				}

				$scope.getScrollBoxClass = function(item) {
					if(item.length > 800)
						return true;
					else
						return false;
				}

				$scope.isNotTbaNaOrNull = function(field) {
					if(field == 'TBD') {
						return false;
					}
					else if(field == 'N/A') {
						return false;
					}
					else if(field == null) {
						return false;
					}
					else {
						return true;
					}
				}

			}])
		};
	})
});
'use strict'

define('scripts/directives/surveyDetailsDirective',["qlik", "scripts/shared/webProperties", "scripts/shared/dimensions", "scripts/shared/appUtilities"],
	function (qlik, webProperties, dimensions, appUtilities) {
	angular.module("appModule").directive("dtSurveyDetails", function() {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtSurveyDetails.html',
			scope: true,
			controller: ("surveyDetailsCtrl", ["$scope","$rootScope", "$http", "$timeout","$q",
				function($scope, $rootScope, $http, $timeout, $q) {


				$scope.$on('showSurveyDetailsEvent', function(e) {
					$scope.clickSurveyDetails();
				});

				$scope.$on('closeSurveyDetailsEvent', function() {
					$scope.clickCloseSurveyDetails();
				})

				$scope.surveyDetailsDisplay = false;

				$scope.clickCloseSurveyDetails = function() {
					$scope.surveyDetailsDisplay = false;
					document.removeEventListener('click',surveyDetailPanelEventListener);
				}


				$scope.clickOpenSurveyPublicUseFile = function(id) {
					window.open($scope.surveyDetails.publicUseUrl);
				}

				$scope.clickOpenSurveyDataTablesUrl = function() {
					window.open($scope.surveyDetails.dataTablesUrl);
				}
				var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
				$scope.clickOpenFB = function (tab) {
					//google analytics tracking
					gtag('event', displayType + $rootScope.survey.abbreviation+'-Open feedback', {
						'event_label': 'open',
						'event_category': 'feedback'
					});
					//$scope.postSuccessful = false;
					//$scope.postHasErrors = false;
					if(tab) {
						$('#feedbackMenu a[href="#' + tab + '"]').tab('show');
					}
					$("#feedbackModal").modal();
				}

				function surveyDetailPanelEventListener (e) {
					if (!document.getElementById('surveyDetailsPanel').contains(e.target)){
						//clicked outside left rail
						//console.log('outside');
						document.removeEventListener('click',surveyDetailPanelEventListener);
						$scope.surveyDetailsDisplay = false;
						var phase = $rootScope.$$phase;
						if (phase !== '$apply' && phase !== '$digest') {
							//console.log('invoking apply()')
							$scope.$apply();
						}
					}
				}
				
				function parseMarkup(field) {
					field = marked.parse(field);
					field = field.replaceAll('<li>', '<li class="variables-disc">')
					return field;
				}

				$scope.replaceNewLines = function(text) {
					return text ? text.replace(/\n/g, '<br/>') : '';
				}

				$scope.clickSurveyDetails = function() {
					$scope.$broadcast('closeVariableDetailsEvent');
					gtag('event', displayType +  $rootScope.survey.abbreviation+'-Open survey details', { 'event_label': 'view', 'event_category': 'metadata'});

					appUtilities.getSurveyProperties($http, $q, $rootScope.survey.abbreviation).then(function(resp) {
						$scope.surveyDetails = resp.data.body;
						
						$scope.surveyDetails.surveySummary = parseMarkup($scope.surveyDetails.surveySummary);

						$scope.surveyDetailsDisplay = true;
						document.addEventListener('click', surveyDetailPanelEventListener);
						$scope.$watch("surveyDetailsDisplay", function (value) {
							setTimeout(function() {
							//    $("#surveyDetailsPanel a[data-tooltip='survey']").popover({trigger: 'focus'} );
							}, 500);
						});
						$('#surveyTabs' + " a[href='" + '#surveyDescriptionTabPanel' + "']").tab('show');


					}, function(err) {
						appUtilities.showError(err);
						return;
					})

				}

				$scope.clickExportSurveyDetails = function (exportDetailsSurveyDetails) {
					$rootScope.$broadcast('showExportMetadataEvent', exportDetailsSurveyDetails, 'survey');	
				}

				$scope.clickSurveyDetailsTab = function(e, tabGroupId, tabName, scrollId=false) {
					e.preventDefault();
                    $(tabName).tab('show');
					if(scrollId) {
						document.getElementById(scrollId).scrollIntoView(true);
						console.log('scrollToId', scrollId);
					}
				}

				$scope.isNotTbaNaOrNull = function(field) {
					if(field == 'TBD') {
						return false;
					}
					else if(field == 'N/A') {
						return false;
					}
					else if(field == null) {
						return false;
					}
					else {
						return true;
					}
				}				

			}])
		};
	})
});
'use strict'
define('scripts/directives/tableVariablesDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions", "scripts/lib/FileSaver.min.js" ],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtTableVariables", function() {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtTableVariables.html',
			// scope: {
				// tbltab: '='
			// },
			scope: true,
			controller: 'TblVariableController'
		};
	});

	angular.module("appModule").controller("TblVariableController", ["$rootScope", "$scope", "$http", function ($rootScope, $scope, $http) {

		var variablesRow = $("#variablesRows");
		var variablesCol = $("#variablesCols");
		var variablesContainer = $("#variablesTblContainer");

		$scope.$on('displayTblVariableCustomEvent', function (e, params) {
			displayTblVariableCustom(params.qHyperCube, params.dimToLock, params.removeSelection);
		});	


		function displayTblVariableCustom(hc, dimToLock, removeSelection) {
			variablesRow.empty();
			variablesCol.empty();
			var div = document.createElement("div");
			div.setAttribute("style", "width:100%");
			let qApp = $rootScope.qApp;

			var mIndx = hc.qEffectiveInterColumnSortOrder.indexOf(-1);

			var divCol = document.createElement("div");
			divCol.setAttribute("class", "basic-pt-selected-variables");
			divCol.setAttribute("data-section", "col");
			
			if(hc.qNoOfLeftDims < hc.qEffectiveInterColumnSortOrder.length) {
				for(var x=hc.qNoOfLeftDims; x < hc.qEffectiveInterColumnSortOrder.length; x++){
					buildFilterDiv(hc, divCol, x, mIndx);
				}
			} else {
				divCol.innerHTML = '&nbsp';
			}
			var divRow = document.createElement("div");
			divRow.setAttribute("class", "basic-pt-selected-variables");
			divRow.setAttribute("data-section", "row");
			
			if(hc.qNoOfLeftDims > 0) {
				for(var x=0; x < hc.qNoOfLeftDims; x++){
					buildFilterDiv(hc, divRow, x, mIndx);
				}
			} else {
				divRow.innerHTML = '&nbsp';
			}

			variablesRow.append(divRow);
			variablesCol.append(divCol);
			attachEvents(qApp, $rootScope.visObjId, variablesContainer, dimToLock, removeSelection);
			return;
		};

		function attachEvents(qApp, pivId,  element, dimToLock, callBack) {
			// Get the elements and clear their content where necessary
			element.find('.basic-pt-selected-variables').on('dragover', function(ev) {
				ev.preventDefault();
			});

			element.find('.bpt-btn-variable').on('dragover', function(ev) {
				this.classList.add('over');
			});

			element.find('.bpt-btn-variable').on('dragleave', function(ev) {
				this.classList.remove('over');
			});

			element.find('.basic-pt-selected-variables').on('drop', function(ev) {
				ev.preventDefault();
				var data = ev.originalEvent.dataTransfer.getData("bubbleBtn");
				var dest = document.getElementById(ev.target.id);
				
				var destId = "";
				if(dest != null) {
					dest.classList.remove('over');
					destId = dest.id;
				}


				ev.currentTarget.insertBefore(document.getElementById(data),dest);
				//Lock FY to 1st pos
				let btnToLock = "btn-" + dimToLock
				if(btnToLock == data && ev.currentTarget.children[0].id != btnToLock) {
					ev.currentTarget.insertBefore(document.getElementById(data),ev.currentTarget.children[0]);
				} else if(btnToLock == destId && ev.currentTarget.children[0].id != btnToLock) {
					ev.currentTarget.insertBefore(dest,ev.currentTarget.children[0]);
				}

				//Make sure Percents btn is always the last variable in rows or columns section
				var btnPercents = ev.currentTarget.parentElement.querySelector("#btn-percents")
				if(btnPercents) {
					ev.currentTarget.insertBefore(btnPercents, null);
				}
				updateProperties(qApp, pivId, element);

			});

			element.find('.bpt-btn-variable').on('dragstart', function(event) {
				event.originalEvent.dataTransfer.setData("bubbleBtn", event.target.id);
				event.target.style.opacity = '.4';
			});

			element.find('.bpt-btn-variable').on('dragend', function(event) {
				event.target.style.opacity = '1.0';
			});

			element.find(".bpt-btn-variable span[data-close]").each(function(ind, btn) {
				btn.addEventListener("click", function(evt) {
					var name = evt.currentTarget.parentElement.attributes["data-cid"].value;
					callBack(name);
				});
			});	


		};


		function buildFilterDiv(hc, divItem, x, mIndx) {
			if(x == mIndx) {
				let isPercent = false;
				for (let m of hc.qMeasureInfo) {
					if(m.cId && m.cId.startsWith('percent')) {
						isPercent = true;
						break;
					}
				}
				let msrId = "btn-values"
				if(isPercent) {
					msrId = "btn-percents"
				}					
				var btnM = buildButton(msrId, "Measures");
				divItem.appendChild(btnM);
			} else {
				var title;
				var val = hc.qEffectiveInterColumnSortOrder[x];
				var cId = hc.qDimensionInfo[val].cId;
				var name = hc.qDimensionInfo[val].qFallbackTitle;
				var dim = dimensions.getDimensionByCid($rootScope, cId);
				//var dimRoot = null;
				if(dim.type == 'dim-branch') {
					//must be a tree component, which are listed as part of tree hierarcy so dim won't be found in name lookup
					var dim = dimensions.getTreeRootByBranchCID($rootScope, cId);

					//check dim has not been included in a recode tree
					if(dim.recodeTrees != null) {
						for(var x = 0; x < dim.recodeTrees.length; x++) {
							if(dim.recodeTrees[x].selected){
								var tmp = {};
								tmp.type = "recodeTree";
								tmp.treeName = dim.recodeTrees[x].treeName;
								tmp.cId = dim.recodeTrees[x].cId;
								tmp.shortName = dim.shortName;
								dim = tmp;
								break;
							}
						}
					}
					if(dim.commonRecodeTrees != null) {
						for(var x = 0; x < dim.commonRecodeTrees.length; x++) {
							if(dim.commonRecodeTrees[x].selected){
								var tmp = {};
								tmp.type = "recodeTree";
								tmp.treeName = dim.commonRecodeTrees[x].treeName;
								tmp.cId = dim.commonRecodeTrees[x].cId;
								tmp.shortName = dim.shortName;
								dim = tmp;
								break;
							}
						}
					}					
				} else if(dim.type == 'recode') {
					//see if recode belongs to a selected tree
					var dimRoot = dimensions.getTreeRootByBranchCID($rootScope, dim.dimCid);
					if(dimRoot.cId != null) {
						if(dimRoot.selected == null || dimRoot.selected == false) {
							//get recodeTree
							if(dimRoot.recodeTrees != null) {
								for(var x = 0; x < dimRoot.recodeTrees.length; x++) {
									if(dimRoot.recodeTrees[x].selected){
										dim = dimRoot.recodeTrees[x];
										break;
									}
								}
							}
							if(dimRoot.commonRecodeTrees != null) {
								for(var x = 0; x < dimRoot.commonRecodeTrees.length; x++) {
									if(dimRoot.commonRecodeTrees[x].selected){
										dim = dimRoot.commonRecodeTrees[x];
										break;
									}
								}
							}							
						}	
					}
				}

				if(Object.keys(dim).length > 0) {
					var btnId;
					if(dim.type == "recodeTree") {
 
						btnId = "btn-" + dim.treeName.replace(/( |\(|\)|\'|#|&|:|-)/g, "");
						title = dim.treeName;
					} else if(dim.type == "recode") {
						btnId = "btn-" + dim.recodeName.replace(/( |\(|\)|\'|#|&|:|-)/g, ""); 
						title = dim.recodeName;
					} else {
						btnId = "btn-" + dim.shortName.replace(/( |\(|\)|#|&|:|-)/g, "");
						title = dim.title;
					}

					if(divItem.querySelector('#' + btnId) == null)
					{
						var btn = buildButton(btnId, title,
							dim);
						divItem.appendChild(btn);
					}
				}
			}
		}

		function buildButton(id, title, dim) {
			var btn = document.createElement("button");
			var suffix = "";

			if(dim) {
				//if treeRecode use rootDimCid for data-cid
				btn.setAttribute("data-cid", dim.cId);
				btn.setAttribute("data-name", dim.type=="recode"?dim.recodeName:dim.type=="recodeTree"?dim.treeName:dim.shortName);
				if(dim.hierarchyAvailable == 'Y') {
					
					btn.setAttribute("data-tree-root", dim.cId);
				} else if(dim.type == 'recodeTree') {
					btn.setAttribute("data-tree-recode", dim.cId);
				}
				if(dim.dimensionRequiredFlag !== true) {
					suffix = "<span data-close class='icon'><i role='img' aria-label='Close button' class='fa-solid fa-xmark'></i></span>"
				}
			} else {
				btn.setAttribute("data-name", title);  //title = 'values' for measures
			}
			btn.setAttribute("id", id);
			btn.setAttribute("draggable", "true");
			btn.classList.add("bpt-btn-variable");
			btn.innerHTML = '<i class="fa-sharp fa-solid fa-grip-dots-vertical" style="margin-right: 0.625rem;"></i> ' + title + suffix;
			return btn;
		}

		function updateProperties(qApp, pivId,  element) {
			var updProps = [];

			qApp.getObject(pivId).then(function (obj) {
				obj.getProperties().then(function (props) {

					var rowNodelist = element.find('.basic-pt-selected-variables[data-section="row"] > button');
					var colNodelist = element.find('.basic-pt-selected-variables[data-section="col"] > button');

					var btnArray = [];
					for(var x=0; x < rowNodelist.length; x++) {
						btnArray.push(rowNodelist[x]);
					}
					for(var x=0; x < colNodelist.length; x++) {
						btnArray.push(colNodelist[x]);
					}
					var dims = obj.layout.qHyperCube.qDimensionInfo;
					var dimName, dim, treeDims, cid, tree;
					for (var i = 0; i < btnArray.length; i++) {
						if(btnArray[i].attributes["data-tree-root"] != null ) {					
							dim = dimensions.getDimensionByCid($rootScope, btnArray[i].attributes["data-tree-root"].value);
							treeDims = dimensions.getDimensionsForTree(dim);
							treeDims.forEach(function(value) {
								for(var x= 0; x < dims.length; x++) {
									if(dims[x].cId == value.cId) {
										updProps.push(props.qHyperCubeDef.qDimensions[x]);
										break;
									}
								}
							})
						} else if(btnArray[i].attributes["data-tree-recode"] != null ) { 
							tree = dimensions.getDimensionByCid($rootScope, btnArray[i].attributes["data-tree-recode"].value);
							if(tree.selected) {
								tree.dimensions.forEach(function(value) {
									for(var x= 0; x < dims.length; x++) {
										if(value.selected){
											if(dims[x].cId == value.cId) {
												//console.log('dim', props.qHyperCubeDef.qDimensions[x]);
												updProps.push(props.qHyperCubeDef.qDimensions[x]);
												break;
											}
										}
									}
								})
							} 					
						} else {
							cid = btnArray[i].attributes["data-cid"];
							if(cid != null) {
								for(var x= 0; x < dims.length; x++) {
									if(dims[x].cId == cid.value) {
										updProps.push(props.qHyperCubeDef.qDimensions[x]);
										break;
									}
								}
							}
						}

					}
					props.qHyperCubeDef.qDimensions = updProps;

					//Count dims represented by row btns; also, include all dims that are grouped by tree
					var leftDims = 0;
					for (var i = 0, x=0; i < rowNodelist.length; i++) {
						if(rowNodelist[i].attributes["data-tree-root"] != null)
						{
							dim = dimensions.getDimensionByCid($rootScope, btnArray[i].attributes["data-tree-root"].value);
							treeDims = dim.savedDims; //dimensions.getDimensionsForTree(dim);
							var selDims = appUtilities.findMatches("selected", true, treeDims);
							for(var z= 0; z < selDims.length; z++) {
								leftDims++;
							}
						} else if(rowNodelist[i].attributes["data-tree-recode"] != null)
						{
							tree = dimensions.getDimensionByCid($rootScope, btnArray[i].attributes["data-tree-recode"].value);
							var selDims = appUtilities.findMatches("selected", true, tree.dimensions);
							for(var z= 0; z < selDims.length; z++) {
								leftDims++;
							}
						} else {
							leftDims++;
						}
					}

					var sortOrder = [];
					for (var i = 0, x=0; i < btnArray.length; i++) {
						dimName = btnArray[i].attributes["data-name"].value
						if(dimName == 'Measures') {
							sortOrder.push(-1);
						} else {
							if(btnArray[i].attributes["data-tree-root"] != null)
							{
								dim = dimensions.getDimensionByCid($rootScope, btnArray[i].attributes["data-tree-root"].value);							
								treeDims = dim.savedDims; //dimensions.getDimensionsForTree(dim);
								var selDims = appUtilities.findMatches("selected", true, treeDims);
								for(var z= 0; z < selDims.length; z++) {
									sortOrder.push(x++);
								}

							} else if(btnArray[i].attributes["data-tree-recode"] != null)
							{
								var selDims = appUtilities.findMatches("selected", true, tree.dimensions);
								for(var z= 0; z < selDims.length; z++) {
									sortOrder.push(x++);
								}
 
							} else {
								sortOrder.push(x++);
							}
						}
					}             

					if(props.qHyperCubeDef.qSortbyYValue) {
						delete props.qHyperCubeDef.qSortbyYValue;
					}
					props.qHyperCubeDef.qInterColumnSortOrder = sortOrder;
					props.qHyperCubeDef.qNoOfLeftDims = leftDims;
					props.qHyperCubeDef.qAlwaysFullyExpanded = false;
					//Set flag to disable expand/collapse buttons when measures button in rows section, Qlik doesn't support expanding cols when msrs in rows 
					let pos = props.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1);
					if(pos > -1 && pos < props.qHyperCubeDef.qNoOfLeftDims) {
						$rootScope.disableExpandCollapseFunctions = true;
					} else {
						$rootScope.disableExpandCollapseFunctions = false;
					}
					//$rootScope.$broadcast('resetExpandedEvent');
					//Toggle Totals on/off based on toggle switch and placement of variables
					dimensions.applyTotalsProperties($rootScope, props);
					//update percent measures based on placement of dims
					measures.applyPercentages($rootScope, props);
					obj.setProperties(props).then(function() {
					},function(err) {
						console.log(err);
					});
				});
			});
		}
	}]);
});

'use strict'
define('scripts/directives/chartVariablesDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/measures", "scripts/shared/dimensions", "scripts/lib/FileSaver.min.js"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtChartVariables", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtChartVariables.html',
			scope: true,
			controller: 'ChartVariableController'
		};
	});

	angular.module("appModule").controller("ChartVariableController", ["$rootScope", "$scope", "$http", function ($rootScope, $scope, $http) {
				var variableFilters = $("#variableFilters");

				$scope.$on('displayChartVariableCustomEvent', function (e, params) {
					displayChartVariableCustom(params.qHyperCube, params.dimToLock, params.removeSelection);
				});	
					
				function displayChartVariableCustom(hc, dimToLock, removeSelection) {
					let qApp = $rootScope.qApp;
					qApp.getObject($rootScope.visObjId).then(function (obj) {
						obj.getEffectiveProperties().then(function (props) {

							variableFilters.empty();

							var divF = document.createElement("div");
							divF.setAttribute("class", "bpt-filter-variables");
							divF.setAttribute("data-section", "f");
							divF.innerHTML = '&nbsp';

							var dims;
							if (props.qHyperCubeDef.qLayoutExclude != null) {
								dims = props.qHyperCubeDef.qDimensions.concat(props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions);
							} else {
								dims = props.qHyperCubeDef.qDimensions;
							}
							for (var x = 0; x < dims.length; x++) {
								var dim = dimensions.getDimensionByCid($rootScope, dims[x].qDef.cId);
								for (var y = 0; y < $rootScope.selState.selections.length; y++) {
									if (dim.shortName == $rootScope.selState.selections[y].fieldName) {
										if ($rootScope.selState.selections[y].qSelected !== "ALL" &&
											$rootScope.selState.selections[y].selectedValues.length !== $rootScope.selState.selections[y].totalCount) {
											buildFilterDiv(hc, divF, dim);
										}
									}
								}
							}
							variableFilters.append(divF);
							attachEvents(variableFilters, removeSelection);
						})
					})
					return;
				};

				function attachEvents(element, callBack) {
					// Get the elements and clear their content where necessary
					element.find('.bpt-filter-variables').on('dragover', function (ev) {
						ev.preventDefault();
					});

					element.find(".bpt-filter-variables .bpt-btn-variable div[data-close]").each(function (ind, btn) {
						btn.addEventListener("click", function (evt) {
							var name = evt.currentTarget.parentElement.attributes["data-cid"].value;
							callBack(name);
						});
					});
				};

				function buildFilterDiv(hc, divItem, dim) {

					var title;

					if (dim.type == "dim-branch") {
						//a dim that has not been recoded and belongs to a hierarchy (tree) has been selected, get tree root for dim
						dim = dimensions.getTreeRootByBranchCID($rootScope, dim.cId);

						//If tree root contains recoded trees then find the selected tree
						if (dim.recodeTrees != null) {
							for (var x = 0; x < dim.recodeTrees.length; x++) {
								if (dim.recodeTrees[x].selected) {
									//Btn properties will be a combination of the tree root properties
									//and the selected tree recode properties
									var tmp = {};
									tmp.type = "recodeTree";
									tmp.treeName = dim.recodeTrees[x].treeName;
									tmp.cId = dim.recodeTrees[x].cId;
									//tmp.hierarchyAvailable = "Y";
									tmp.shortName = dim.shortName;
									dim = tmp;
									break;
								}
							}
						} else if (dim.commonRecodeTrees != null) {
							for (var x = 0; x < dim.commonRecodeTrees.length; x++) {
								if (dim.commonRecodeTrees[x].selected) {
									//Btn properties will be a combination of the tree root properties
									//and the selected tree recode properties
									var tmp = {};
									tmp.type = "recodeTree";
									tmp.treeName = dim.commonRecodeTrees[x].treeName;
									tmp.cId = dim.commonRecodeTrees[x].cId;
									//tmp.hierarchyAvailable = "Y";
									tmp.shortName = dim.shortName;
									dim = tmp;
									break;
								}
							}
						}
					} else if (dim.type == 'recode') {
						//The selected dim is either a non-hierarchy (tree) dim that has been recoded
						//or a hierarchy dim has been been recoded.  If dim belongs to a tree, get the tree root
						var dimRoot = dimensions.getTreeRootByBranchCID($rootScope, dim.dimCid);
						if (dimRoot.cId != null) {
							if (dimRoot.selected == null || dimRoot.selected == false) {
								//find the seected recode tree associated with the tree root
								for (var x = 0; x < dimRoot.recodeTrees.length; x++) {
									if (dimRoot.recodeTrees[x].selected) {
										//override the dim to use the selected recode tree
										dim = dimRoot.recodeTrees[x];
										break;
									}
								}
							}
						}
					} else if (dim.type == 'commonRecode') {
						//The selected dim is either a non-hierarchy (tree) dim that has been recoded
						//or a hierarchy dim has been been recoded.  If dim belongs to a tree, get the tree root
						var dimRoot = dimensions.getTreeRootByBranchCID($rootScope, dim.dimCid);
						if (dimRoot.cId != null) {
							if (dimRoot.selected == null || dimRoot.selected == false) {
								//find the seected recode tree associated with the tree root
								for (var x = 0; x < dimRoot.recodeTrees.length; x++) {
									if (dimRoot.recodeTrees[x].selected) {
										//override the dim to use the selected recode tree
										dim = dimRoot.recodeTrees[x];
										break;
									}
								}
							}
						}
					}

					var btnId;
					if (dim.type == "recodeTree") {
						btnId = dim.treeName.replace(/( |\(|\)|\'|#|&|:|-)/g, "");
						title = dim.treeName;
					} else if (dim.type == "recode") {
						btnId = dim.recodeName.replace(/( |\(|\)|\'|#|&|:|-)/g, "");
						title = dim.recodeName;
					} else {
						//btnId = dim.shortName.replace(/( |\(|\)|#|&|:|-)/g, "");
						btnId = dim.shortName.replace(/( |\(|\)|#|&|:|-)/g, "");
						title = dim.title;
					}

					if (divItem.querySelector('#' + btnId) == null) {
						var btn = buildButton(btnId, title,
								dim);
						divItem.appendChild(btn);
					}
				}

				function buildButton(id, name, item) {
					var btn = document.createElement("button");
					var suffix = "";

					if (item) {
						btn.setAttribute("data-cid", item.cId);
						btn.setAttribute("data-name", item.shortName);
						/* 				if(item.hierarchyAvailable == 'Y') {
						btn.setAttribute("data-tree-root", item.shortName);
						} */
						btn.setAttribute("data-name", item.type == "recode" ? item.recodeName : item.type == "recodeTree" ? item.treeName : item.shortName);
						if (item.hierarchyAvailable == 'Y') {

							btn.setAttribute("data-tree-root", item.cId);
						} else if (item.type == 'recodeTree') {
							btn.setAttribute("data-tree-recode", item.cId);
						}
						if (item.dimensionRequiredFlag !== true) {
							suffix = "<div role='img' data-close style='margin-left:10px; cursor: pointer' class='fas fa-times'></div>"
						}
					} else {
						btn.setAttribute("data-name", name);
					}
					btn.setAttribute("id", id);
					btn.setAttribute("draggable", "false");
					btn.setAttribute("role", "button");
					btn.classList.add("bpt-btn-variable");
					btn.setAttribute("style", "cursor:default");

					btn.innerHTML = name + suffix;
					return btn;
				}
			}
		]);
});

'use strict'
define('scripts/directives/tooltipDirective',[], function () {
	angular.module("appModule").directive("dtTooltip", function () {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				$(element)[0].onmouseenter = function () {
					// on mouseenter
					if (attrs.toggle == 'tooltip') {
						setTimeout(function () {
							if ($(element).is(':hover')) {
								$(element).tooltip('show');
							}

						}, 500);
					} 
					return;
				};
				$(element)[0].onmouseleave = function () {
					// on mouseenter
					if (attrs.toggle == 'tooltip') {
						$(element).tooltip('hide');
					} 	
					return;
				};				
				
				$(element).click(function () {
					if (attrs.toggle == 'tooltip') {
						$(element).tooltip('hide');
					}
				});
			}
		}
	});
});

'use strict'
define('scripts/directives/bannerNoticeDirective',["js/qlik",  "scripts/appModule", "scripts/shared/webProperties"],
	function (qlik, appModule, webProperties) {
		angular.module("appModule").directive("dtBannerNotice", function() {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtBannerNotice.html',
			controller: 'BannerNoticeController',
			scope: {
				type: '@',
				placement: '@',
				notice: '='
			}
		}
	});

	angular.module("appModule").controller("BannerNoticeController", ["$scope", "$sce", "$rootScope", "$timeout",
		function ($scope, $sce, $rootScope, $timeout) {
			$scope.hideModal = true;
			$scope.closeBanner = function() {
				$scope.notice.showNoticeFlag = false;
				if($scope.type == "system") {
					sessionStorage.setItem("hideSystemNoticeFlag", "true");
				} else if($scope.type == "survey") {
					sessionStorage.setItem("hide" + $rootScope.survey.abbreviation.toUpperCase() + "SurveyNoticeFlag", "true");
				} else if($scope.type == "generic") {
					sessionStorage.setItem("hideGenericNoiceFlag", "true");
				}

			}
			
			$scope.showNotice = function () {
				console.log('notice', $scope.notice)
				//Banners are placed in 2 locations: 1) main - full screen mode where banner is displayed in the main part of page
				//to the right of the left panel and above the table row/col section
				//2) side - for smaller screen devices where page sections (left panel and main) are stackked in a column. Banner is placed above the left panel.
				$('#' + $scope.type + '-' + $scope.placement + '-banner-notice').modal('toggle');
			}
			
 			$scope.clickOpenUrl = function(article) {
				gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-')  + $rootScope.survey.abbreviation + '-Banner article knowledgebase', {
					'event_label': 'open',
					'event_category': 'knowledgebase'
				});				
				let url = webProperties.props.kbUrl + article;
				window.open(url, "_blank");
			}
		}
	])
});
'use strict'
define('scripts/directives/tableMenuDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities", 
	"scripts/shared/measures", "scripts/shared/dimensions" ], 
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {
		
	angular.module("appModule").directive("dtTableMenu", function() {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtTableMenu.html',
			scope: true,
			controller: 'TblMenuController'
		};
	});	
	
	
	angular.module("appModule").controller("TblMenuController", ["$scope", "$rootScope", "$q", "$http",
	function ($scope, $rootScope, $q, $http) {	
		let displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
		$scope.isTopExpanded = false;
		$scope.isLeftExpanded = false;

		$scope.$on('resetExpandedEvent', function (e) {
			$scope.isLeftExpanded = $scope.isTopExpanded = false;
/* 			$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.collapseLeft('/qHyperCubeDef', 0, 0, true).then(
					function(){
						obj.collapseTop('/qHyperCubeDef', 0, 0, true).then(
						function(){}, 
						function(err){ console.log(err)});
					}, 
					function(err){ console.log(err)});
				// return obj.applyPatches([{
					// "qPath": "/qHyperCubeDef/qAlwaysFullyExpanded",
					// "qOp": "replace",
					// "qValue": "false"
				// }], true);
			}) */
		});

		$scope.$on('setExpandedEvent', function (e, type, flag) {
			if(type == "rows")
				$scope.isLeftExpanded = flag;
			else
			$scope.isTopExpanded = flag;
		});	
		
		$scope.clickToggleExpandCollapseLeft = function(evt) {
			$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
				$(evt.target).toggleClass('active');
				if($scope.isLeftExpanded) {
					$scope.isLeftExpanded = false;
					$scope.toggleReadOnly(true);
					return obj.collapseLeft('/qHyperCubeDef', 0, 0, true).then(
						function(){}, 
						function(err){ console.log(err)});
				}
				else {
					$scope.isLeftExpanded = true;
					$scope.toggleReadOnly(true);
					return obj.expandLeft('/qHyperCubeDef', 0, 0, true).then(
						function() {}, 
						function(err){ console.log(err)});
				}
			});
		}

		$scope.clickToggleExpandCollapseTop = function(evt) {
			$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
				$(evt.target).toggleClass('active');
				if($scope.isTopExpanded) {
					$scope.isTopExpanded = false;
					$scope.toggleReadOnly(true);
					return obj.collapseTop('/qHyperCubeDef', 0, 0, true).then(
						function(){}, 
						function(err){ console.log(err)});
				}
				else {
					$scope.isTopExpanded = true;
					$scope.toggleReadOnly(true);
					return obj.expandTop('/qHyperCubeDef', 0, 0, true).then(
						function(){}, 
						function(err){ console.log(err)});
				}
			});
		}
		
		$scope.clickToggleExpandCollapse = function(evt) {
			$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
				obj.getEffectiveProperties().then(function (obj_properties) {

					$(evt.target).toggleClass('active');
					var elementsExpanded;
					if(obj_properties.qHyperCubeDef.qDimensions.length < 2)
						elementsExpanded = false;
					else
						elementsExpanded = !(obj_properties.qHyperCubeDef.qAlwaysFullyExpanded?true:false);
					return obj.applyPatches([{
						"qPath": "/qHyperCubeDef/qAlwaysFullyExpanded",
						"qOp": "replace",
						"qValue": "true" //String(elementsExpanded)
					}], true).then(function(){}, function(err){ console.log(err)});
				})
			});
		}		

		$scope.tableColumnsBtnDisabled = function() {
			var fixed = $(".basic-pt.scroll > thead > tr > th.selectable");
			return fixed.length == 0 || $rootScope.disableExpandCollapseFunctions;
		}
		$scope.tableRowsBtnDisabled = function() {
			var scroll = $(".basic-pt.scroll > tbody > tr > th.selectable");
			return scroll.length == 0 || $rootScope.disableExpandCollapseFunctions;
		}
	}])
});

'use strict'

define('scripts/directives/tableSubMenuExportDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions", "scripts/lib/jszip"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, JSZip) {
	angular.module("appModule").directive("dtTableSubMenuExport", function() {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtTableSubMenuExport.html',
			scope: true,
			controller: 'TableSubMenuExportController'
		};
	});


	angular.module("appModule").controller("TableSubMenuExportController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {
		var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
		
		$('.dropdown-menu.table-export-files').on("click.bs.dropdown", function (e) {
			if (e.target.id != "idTableExportFilesSave" && e.target.id != "idTableExportFilesClose") {
				e.stopPropagation();
				//e.preventDefault();
			}
		});
		$scope.fileType = "";
		let debug = false;

		$scope.btnExportSelectedFormats = function(){
			//let spinner = appUtilities.initSpinner();
			$scope.toggleReadOnly(true)
			let exports = "-Export Table as "
			if(debug) {
				console.time("Download");
				console.log("Download started");
				console.log(appUtilities.getSurveySource($rootScope));
			}
			var dateObj = new Date();
			var dateStr = dateObj.toString();
			
			exports += $scope.fileType
			let promise = {}
			if($scope.fileType == "xlsx") {				
				promise = exportXlsx($scope.fileType);
			}
			if($scope.fileType == "csv") {
				promise = exportCsv($scope.fileType);
			}			
			
			// google analytics tracking
			gtag('event', displayType + $rootScope.survey.abbreviation+exports, { 'event_label': 'export', 'event_category': 'download'});

			promise.then(function(exportedResults) {
				getSupplementalData(dateStr, exportedResults.notes).then(function(metadata) {
					exportedResults.metadata = metadata
					saveSelectedExportResults(exportedResults, dateObj).then(function() {
						//spinner.stop();
						$scope.toggleReadOnly(false)
						$scope.fileType = "";
						if(debug) {
							console.timeEnd("Download");
							console.log("Download completed");
						}
					})
				}, function(err) {
					$scope.toggleReadOnly(false)
					//spinner.stop();
					console.log("metadata err", err);
					throw err;
				});
			}, function(err) {
				$scope.toggleReadOnly(false)
				//spinner.stop();
				console.log("export err", err);
				throw err;
			});
		}


		function exportXlsx(selectedExportType) {
			let Promise = qlik.Promise;
			return new Promise(function(resolve, reject) {
				let settings = {format:'OOXML', state: 'A', download: false};
				getImageFileURL('xlsx', settings).then(function(exportResult) {
					exportResult.type = selectedExportType;
					return resolve(exportResult);
				}, function(err){
					reject(err);
				});
			});
		}
		
		function exportCsv(selectedExportType) {
			let Promise = qlik.Promise;
			return new Promise(function(resolve, reject) {
				let settings = {format:'CSV_C', state: 'A', download: false};
				//var settings = {format:'OOXML', state: 'P', download: true};
							 
				getImageFileURL('csv', settings).then(function(exportResult) {
					exportResult.type = selectedExportType;
					return resolve(exportResult);
				}, function(err){
					reject(err);
				});
			});
		}

		function getImageFileURL(type, settings) {
			return new qlik.Promise(function(resolve, reject) {
				var exportResult = {};

				if(type == "csv"){
					if(debug) {
						console.time("CSV URL from Qlik");
					}
					$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
						obj.getProperties().then(function (obj_properties) {
							let cols = [];
							let dims = obj_properties.qHyperCubeDef.qDimensions;
							let msrs = obj_properties.qHyperCubeDef.qMeasures;
							//Remove totals since not needed in raw data; 
							//Place year as first column followed by dimensions from rows then columns, and then measures
							dims.forEach(function(dim) {
								dim.qOtherTotalSpec = {"qTotalMode": "TOTAL_OFF"};
								dim.qTotalLabel = {};
								let tmpDim = dimensions.getDimensionByCid($rootScope, dim.qDef.cId);
								if(tmpDim.shortName === $rootScope.survey.dimToLock) {
									cols.push(dim); 
									//cols.push(structuredClone(dim));
								}
							})
							dims.forEach(function(dim) {
								let tmpDim = dimensions.getDimensionByCid($rootScope, dim.qDef.cId);
								if(tmpDim.shortName !== $rootScope.survey.dimToLock) {
									cols.push(dim); 
									//cols.push(structuredClone(dim));
								}
							});
							//remove commas from CSV data
							msrs.forEach(function(msr) {
								msr.qDef.qNumFormat.qFmt = '##0'
								cols.push(msr); 
							})

							//set hypercube def properties for new Table vis
							let props = {qHyperCubeDef: {
								qAlwaysFullyExpanded: false,
								qSuppressZero: true,
								qSuppressMissing: true}};
							
							$rootScope.qApp.visualization.create('table', cols, props).then(function(vis){
								if(debug) {
									let sizes = vis.model.layout.qHyperCube.qSize;
									console.time("CSV URL from Qlik");
									console.log('qcx: ' + sizes.qcx + ', qcy: ' + sizes.qcy + ', total cells: ' + (sizes.qcx * sizes .qcy));
								}

								if(debug) {
									let dimStr = ''
									vis.model.layout.qHyperCube.qDimensionInfo.forEach(function(d) {
										dimStr += d.qFallbackTitle + ', '
									})
									let msrStr = ''
									vis.model.layout.qHyperCube.qMeasureInfo.forEach(function(d) {
										msrStr += d.qFallbackTitle + ', '
									})
									console.log('Dimensions', dimStr);
									console.log('Measures', msrStr);
								}
								vis.exportData(settings).then(function (result) {
									if(debug) {
										console.timeEnd("CSV URL from Qlik");
										console.log("Completed building export file on Qlik server, returned URL for file");
									}
									//bug workaround, Qlik server returns URL string that contains 2 "https" tas, so remove the unnecessary 1st one if it exists
									var n = result.lastIndexOf("https");
									if(n > 0)  {
										result = result.substr(n);
									}  
									exportResult.url = result;
									$rootScope.qApp.destroySessionObject(vis.id);
									return resolve(exportResult);
								}, function(err) {
									console.log(err);
									return reject(err);
								});
							}, function(err) {  
								console.log(err);
								return reject(err);
							});

						}, function(err) {
							return reject(err);
						});

					}, function(err) {
						return reject(err);
					});
				} else if(type == "xlsx"){
					//Code for fully expanding rows/cols without impacting existing hypercube, need to create a 2nd cube that is fully expanded
					if(debug) {
						console.time("XLSX URL from Qlik")
						console.time("Build temp expanded table")
					}

					$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
						obj.getProperties().then(function (props) {

							//If table displayed with Totals, temporarially remove Totals so that they do not appear in the Excel file.
							//After Excel file is generated, add the Totals back into the table
							let dims = props.qHyperCubeDef.qDimensions;
							let msrs = props.qHyperCubeDef.qMeasures;
							const notes = new Array();

							let code = 97;
							let numLeftDims = props.qHyperCubeDef.qNoOfLeftDims;
							let resetTopDims = [];
							//set the top dims first, to capture the correct footnote code
							//copy existing total label before disabling so that it can be used to reset lable after export
							for(let x = numLeftDims; x < dims.length; x++) {
								let dim = dims[x];
								if(dim.qOtherTotalSpec.qTotalMode == "TOTAL_OFF")
									continue;

								let tmpDim = {}
								tmpDim.cId = dim.qDef.cId;
								tmpDim.qTotalLabel = dim.qTotalLabel
								tmpDim.qTotalMode = dim.qOtherTotalSpec.qTotalMode
								resetTopDims.push(tmpDim)
								//dim.qTotalLabel = {"qv": "Total (" + String.fromCharCode(code) + ")"};
								dim.qOtherTotalSpec = {"qTotalMode": "TOTAL_OFF"};
								dim.qTotalLabel = {};									
								notes.push("(" + String.fromCharCode(code) + ") Total based on selected " + dim.qDef.qFieldLabels[0] + " categories")
								code++;
							}							

							//process the first left dim total since the tool only displays the outter most total for left dims
							let resetLeftDim = {};
							if(numLeftDims > 0) {
								if(dims[0].qOtherTotalSpec.qTotalMode == "TOTAL_EXPR") {

									let dim = dims[0];
									resetLeftDim.cId = dim.qDef.cId;
									resetLeftDim.qTotalMode = dim.qOtherTotalSpec.qTotalMode;
									resetLeftDim.qTotalLabel = dim.qTotalLabel
									dim.qOtherTotalSpec = {"qTotalMode": "TOTAL_OFF"};
									dim.qTotalLabel = {};
									notes.push("(" + String.fromCharCode(code) + ") Total based on selected " + dim.qDef.qFieldLabels[0] + " categories")
								}
							}

							//Totals not displayed so simply export data
							$rootScope.visObj.exportData(settings).then(function (result) {
								if(debug) {
									console.timeEnd("Call exportDatae");
									console.timeEnd("XLSX URL from Qlik");
									console.log("Completed building export file on Qlik server, returned URL for file");
								}
								//bug workaround, Qlik server returns URL string that contains 2 "https" tas, so remove the unnecessary 1st one if it exists
								var n = result.lastIndexOf("https");
								if(n > 0)  {
									result = result.substr(n);
								} 
								exportResult.url = result;
								exportResult.notes = notes;
								return resolve(exportResult);
								
							}, function(err) {
								console.log(err);
								return reject(err);
							});
						})
					})
				} else {
					return reject('Invalid file type');
				}
			})
		}
		
		function getSupplementalData(dateStr, notes) {
			return new Promise(function(resolve, reject) {
				hyperCubeProperties.getExportSupplementalData(qlik, $rootScope, $scope, $http, dateStr, notes).then(function(data) {
					return resolve(data)
				})
			})
		}

		function saveSelectedExportResults(exportedResults, dateObj) {
			return new qlik.Promise(function(resolve, reject) {
				if (exportedResults && exportedResults.url.length > 0) {
					var zip = new JSZip();
					var count = 0;
					var m = new Date();
					var dateString = m.toString();
					var filename = "ncses_table_srv_data_" + $rootScope.survey.abbreviation + "_" + dateObj.toISOString().replace(/:/g, "_").split('.')[0]+"Z";
					let processExports = async () => {
						await getfileData(zip, exportedResults, filename)

						zip.file("table-description-"+$rootScope.survey.abbreviation+".txt", exportedResults.metadata);
						zip.generateAsync({type:'blob'}).then(function(content) {
							saveAs(content, filename + ".zip");
							return resolve();
						});
					};
					processExports();
				
				}
			})
		}

		function getfileData(zip, exportedResult, filename) {
			let Promise = qlik.Promise;
			return new Promise(function(resolve, reject) {
				if(debug) {
					console.time("Getting file from Qlik");
					console.log("retrieving file from Qlik");
				}
				$http.get(exportedResult.url,{responseType: 'arraybuffer'}).then(function (response) {
					let blob = new Blob([response.data]);
					if(debug) {
						console.timeEnd("Getting file from Qlik");
						console.log("Completed retrieving file from Qlik");
					}
					if(exportedResult.type == 'xlsx') {
						try {
							if(debug) {
								console.time("Reading file into arraybuffer");
								console.log("Reading file into arraybuffer");
							}
							var fr = new FileReader();
							fr.onload = receivedXlsx;
							fr.readAsArrayBuffer(blob);
						} catch (err) {
							alert('Error reading data: ' + err);
							reject(err);
						}
							
						function receivedXlsx(e) {
							if(debug) {
								console.timeEnd("Reading file into arraybuffer");
								console.log("Completed reading file into arraybuffer");
							}
							let str = '';
							const buffer = e.target.result;
							var data = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'});
							let fname = filename.replace('srv_data','formatted_data');
							zip.file(fname + "." + exportedResult.type, data);
							if(debug) {
								console.timeEnd("Reading file into arraybuffer");
								console.log("Completed reading file into arraybuffer");
							}
							resolve("Success!");
						}
					} else if(exportedResult.type == 'csv') {
						if(debug) {
							console.time("Reading file as text");
							console.log("Reading file as text");
						}
						var fr = new FileReader();
						fr.onload = receivedText;
						fr.readAsText(blob);
						function receivedText(e) {
							var strCsv = e.srcElement.result;
							//strContent += "\n\"" + appUtilities.getSurveySource($rootScope) +  "\"\nDownloaded: " + dateString;
							var file = new Blob([strCsv], {type: "text/plain;charset=utf-8"});
							if(debug) {
								console.timeEnd("Reading file as text");
								console.log("Completed reading file as text");
							}
							let fname = filename.replace('srv_data','raw_data');
							zip.file(fname + "." + exportedResult.type, file);
							resolve("Success!");
						}
					} else {
						reject('Invalid export type')
					}
				}, function (err) {
					console.lor('http get error', err);
					reject(err); // or handle the error
				});
			});
		}
	}]);
});
'use strict'
define('scripts/directives/chartMenuDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities", 
	"scripts/shared/measures", "scripts/shared/dimensions" ], 
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {
		
	angular.module("appModule").directive("dtChartMenu", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartMenu.html',
		// scope: {
			// tbltab: '='
		// },
		scope: true,
		controller: 'ChartMenuController'
	};
});	

angular.module("appModule").controller("ChartMenuController", ["$scope", "$rootScope",
	function ($scope, $rootScope) {

		$scope.clickColorPopup = function (tab) {
			$rootScope.$broadcast('openColorDialogEvent');
		}
		
		$scope.clickZoomPopup = function (tab) {
			$rootScope.$broadcast('openZoomDialogEvent');
		}			
	}])
});
'use strict'
define('scripts/directives/chartSubMenuLineDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtChartSubMenuLine", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartSubMenuLine.html',
		// scope: {
			// tbltab: '='
		// },
		scope: true,
		controller: 'ChartSubMenuLineController'
	  };
	});

	angular.module("appModule").controller("ChartSubMenuLineController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {

			//$rootScope.chart.barType = "grouped";
			$scope.$on('resetLineChartEvent', function(e) {
				//console.log('e', e);
				$rootScope.visObj.close().then(function() {
					var qApp = $rootScope.qApp;
					$rootScope.displayVisType = "linechart";
					setChartProps('linechart');

					qApp.visualization.create(
					  'linechart',
					  [],
					  $scope.qAdhocProps)
					.then(function (vis) {
						$rootScope.visObjId = vis.id;
						$rootScope.visObj = vis;

						hyperCubeProperties.setVisualizationDefaults($rootScope, $scope, qApp).then(function() {
							vis.table.OnData.bind( $scope.tblListener );
							$(".chart-container").width("");
							vis.show("QV01");
							return;
						}, function(err) {
							appUtilities.showError(err);
							return;
						});
					}, function (error) {
						appUtilities.showError(error);
						return;
					});
				});
			});

			$scope.btnLineChart = function () {
				var app = $rootScope.qApp;
				$rootScope.displayVisType = "linechart";
				setChartProps($rootScope.displayVisType);
				
				gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-')  + $rootScope.survey.abbreviation + '-Select Line Chart', {
					'event_label': 'select',
					'event_category': 'line_chart_type'
				});					
				app.getObject($rootScope.visObjId).then(function (obj) {
					obj.getEffectiveProperties().then(function(props) {
						$scope.qAdhocProps.color = props.color;
						$rootScope.chart.dimCount = props.qHyperCubeDef.qDimensions.length + (props.qHyperCubeDef.qLayoutExclude?props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length:0);
						$scope.qAdhocProps.qHyperCubeDef.qDimensions = props.qHyperCubeDef.qDimensions;
						$scope.qAdhocProps.qHyperCubeDef.qMeasures = props.qHyperCubeDef.qMeasures;
						$scope.qAdhocProps.qHyperCubeDef.qLayoutExclude = props.qHyperCubeDef.qLayoutExclude;
                        $rootScope.chart.barType = "";

						if(props.barGrouping)
							props.barGrouping.grouping = "";
						else {
							props.barGrouping = {};
							props.barGrouping.grouping = "";
						}
						if(props.showTitles == true) {
							$scope.qAdhocProps.title = props.title;
							$scope.qAdhocProps.showTitles = true;
						}

						if(props.qHyperCubeDef.qDimensions.length > 1) {
							$scope.qAdhocProps.qHyperCubeDef.qMode = "K";
							$scope.qAdhocProps.qHyperCubeDef.qAlwaysFullyExpanded = true;
						} else {  //cluster
							$scope.qAdhocProps.qHyperCubeDef.qMode = "S";
							$scope.qAdhocProps.qHyperCubeDef.qAlwaysFullyExpanded = false;
						}

						$rootScope.visObj.close().then(function() {
							clearYearFilter(app, props).then(function(cubeDim) {
								if(cubeDim) {
									var dim = dimensions.getDimensionByCid($rootScope, cubeDim.qDef.cId)
									dim.selectedValuesCount = dim.totalValuesCount;
								}
								$(".chart-container").css({maxWidth: ""});
								app.visualization.create($rootScope.displayVisType, [], $scope.qAdhocProps).then(function (vis) {
									$rootScope.visObjId = vis.id;
									$rootScope.visObj = vis;
									vis.table.OnData.bind( $scope.tblListener );

									$rootScope.visObj.show("QV01");
								});
							});
						});
					});
				});
			}

			function clearYearFilter(app, props) {
				return new qlik.Promise(function(resolve, reject) {
					var found = false;
					for(var x = 0; x < props.qHyperCubeDef.qDimensions.length; x++) {
						var name = props.qHyperCubeDef.qDimensions[x].qDef.qFieldDefs[0].match(/[a-zA-Z]+/g)[0];
						if(name.toLowerCase() == "year" || name.toLowerCase() == "refyr") {
							found = true;
							var dim = props.qHyperCubeDef.qDimensions[x];
							var myField = app.field(name).clear().then(function() {
								return resolve(dim);
							});
						}
					}
					if(!found)
						return resolve();
				})
			}

			function setChartProps(type) {
				$scope.qAdhocProps = {
					"qInfo": {
						"qType": "linechart"
					},
					"nullMode": "connect",
					"scrollbar": "miniChart",  //"bar"
					"showTitles": true,
					"footnote": appUtilities.getSurveySource($rootScope),
					"nullMode": "connect",
					"legend": {
					  "show": true,
					  "dock": "right"
					},
					"qHyperCubeDef": {
						"qSuppressZero": false,
						"qSuppressMissing": true,
						"qInitialDataFetch": [{
							"qLeft": 0,
							"qTop": 0,
							"qWidth": 20,
							"qHeight": 500
						}],
						"qReductionMode": "N",
						"qMode": "S",
						"qPseudoDimPos": -1,
						"qNoOfLeftDims": -1,
						"qAlwaysFullyExpanded": true,
						"qMaxStackedCells": 5000,
						"qPopulateMissing": false,
						"qShowTotalsAbove": false,
						"qIndentMode": false
					},
					"dataPoint": {
						"show": true,
						"showLabels": false,
						"showSegmentLabels": false,
						"showTotalLabels": false
					},
					"dimensionAxis": {
						"continuousAuto": true,
						"show": "all",
						"label": "auto",
						"dock": "near",
						"axisDisplayMode": "auto",
						"maxVisibleItems": 10
					}
				}
			}
        }
	]);
});
'use strict'

define('scripts/directives/chartSubMenuBarDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/measures", "scripts/shared/dimensions"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtChartSubMenuBar", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtChartSubMenuBar.html',
			// scope: {
			// tbltab: '='
			// },
			scope: true,
			controller: 'ChartSubMenuBarController'
		};
	});

	angular.module("appModule").controller("ChartSubMenuBarController", ["$scope", "$rootScope", "$q", "$location", "$http",
			function ($scope, $rootScope, $q, $location, $http) {
				//$rootScope.chart.barType = 'grouped';
				// $rootScope.chart.dimCount = 0;
				$scope.btnChartSubmenuBar = function () {
					//changeChartType(barType);
					
					if ($rootScope.displayVisType == "linechart")
						$rootScope.chart.barType = '';

					var app = $rootScope.qApp;
					app.getObject($rootScope.visObjId).then(function (obj) {
						obj.getEffectiveProperties().then(function (props) {
							$rootScope.chart.dimCount = props.qHyperCubeDef.qDimensions.length + (props.qHyperCubeDef.qLayoutExclude ? props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length : 0);
                            $rootScope.chart.disablePercentages = ($rootScope.chart.dimCount < 2 || dimensions.getDimensionByCid($rootScope,  props.qHyperCubeDef.qDimensions[0].qDef.cId).shortName !== $rootScope.survey.dimToLock);
						});
					});
				}

				$scope.$on('resetBarChartEvent', function (e) {
					//console.log('e', e);
					$rootScope.visObj.close().then(function () {
						var qApp = $rootScope.qApp;
						$rootScope.displayVisType = "barchart";
						$rootScope.chart.barType = 'v-grouped';
						setChartProps();
						$scope.qAdhocProps.qHyperCubeDef.qMode = "S";
						$scope.qAdhocProps.qHyperCubeDef.qAlwaysFullyExpanded = false;
						$scope.qAdhocProps.barGrouping = {};
						$scope.qAdhocProps.barGrouping.grouping = "grouped";
						qApp.visualization.create(
							'barchart',
							[],
							$scope.qAdhocProps)
						.then(function (vis) {
							$rootScope.visObjId = vis.id;
							$rootScope.visObj = vis;

							hyperCubeProperties.setVisualizationDefaults($rootScope, $scope, qApp).then(function () {
								qApp.getObject($rootScope.visObjId).then(function (obj) {
									obj.getProperties().then(function (props) {
										dimensions.setYearFilter(qApp, props).then(function (cubeDim) {
											if (cubeDim) {
												var dim = dimensions.getDimensionByCid($rootScope, cubeDim.qDef.cId)
													dim.selectedValuesCount = 1;
											}
											$rootScope.visObj.table.OnData.bind($scope.tblListener);
											return resolve('ok');
										})
									})
								});

								vis.table.OnData.bind($scope.tblListener);
								$(".chart-container").width("");
								vis.show("QV01");
								return;
							}, function (err) {
								appUtilities.showError(err);
								return;
							});
						}, function (error) {
							appUtilities.showError(error);
							return;
						});
					});
				});

				$scope.$on('changeBarChartEvent', function (e, barType) {
					//console.log('e', e);
					//console.log('$scope', $scope)
					changeChartType(barType);
				});

				$scope.btnChangeBarchart = function (barType) {
					//$(".chart-bar-menu").toggle();
					changeChartType(barType);
					$(".chart-bar-menu").click();
					
				}

				function changeChartType(barType) {
					var app = $rootScope.qApp;

					$rootScope.chart.barType = barType;
					setChartProps();

					gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-')  + $rootScope.survey.abbreviation + '-Select Bar Chart - ' + barType, {
						'event_label': 'select',
						'event_category': 'bar_chart_type'
					});	

					app.getObject($rootScope.visObjId).then(function (obj) {
						obj.getEffectiveProperties().then(function (props) {
							$scope.qAdhocProps.color = props.color;
							$scope.qAdhocProps.qHyperCubeDef.qDimensions = props.qHyperCubeDef.qDimensions;
							$scope.qAdhocProps.qHyperCubeDef.qMeasures = props.qHyperCubeDef.qMeasures;
							$scope.qAdhocProps.qHyperCubeDef.qLayoutExclude = props.qHyperCubeDef.qLayoutExclude;

							if ($rootScope.chart.barType == "v-stacked") {
								$scope.qAdhocProps.qHyperCubeDef.qMode = "K";
								$scope.qAdhocProps.qHyperCubeDef.qAlwaysFullyExpanded = true;
								$scope.qAdhocProps.barGrouping = {};
								$scope.qAdhocProps.barGrouping.grouping = "stacked";
								$scope.qAdhocProps.orientation = "vertical";
								$scope.qAdhocProps.measureAxis.dock = "near";
								$scope.qAdhocProps.dimensionAxis.dock = "near";
							} else if ($rootScope.chart.barType == "v-grouped") { //cluster
								$scope.qAdhocProps.qHyperCubeDef.qMode = "S";
								$scope.qAdhocProps.qHyperCubeDef.qAlwaysFullyExpanded = false;
								$scope.qAdhocProps.barGrouping = {};
								$scope.qAdhocProps.barGrouping.grouping = "grouped";
								$scope.qAdhocProps.orientation = "vertical";
								$scope.qAdhocProps.measureAxis.dock = "near";
								$scope.qAdhocProps.dimensionAxis.dock = "near";
							} else if ($rootScope.chart.barType == "h-stacked") {
								$scope.qAdhocProps.qHyperCubeDef.qMode = "K";
								$scope.qAdhocProps.qHyperCubeDef.qAlwaysFullyExpanded = true;
								$scope.qAdhocProps.barGrouping = {};
								$scope.qAdhocProps.barGrouping.grouping = "stacked";
								$scope.qAdhocProps.orientation = "horizontal";
								$scope.qAdhocProps.measureAxis.dock = "near";
								$scope.qAdhocProps.dimensionAxis.dock = "near";
							} else { //cluster
								$scope.qAdhocProps.qHyperCubeDef.qMode = "S";
								$scope.qAdhocProps.qHyperCubeDef.qAlwaysFullyExpanded = false;
								$scope.qAdhocProps.barGrouping = {};
								$scope.qAdhocProps.barGrouping.grouping = "grouped";
								$scope.qAdhocProps.orientation = "horizontal";
								$scope.qAdhocProps.measureAxis.dock = "near";
								$scope.qAdhocProps.dimensionAxis.dock = "near";
							}

							if (props.showTitles == true) {
								$scope.qAdhocProps.title = props.title;
								$scope.qAdhocProps.showTitles = true;
							}

							$rootScope.visObj.close().then(function () {
								if ($rootScope.displayVisType == "linechart") {
									$rootScope.displayVisType = "barchart";
									dimensions.setYearFilter(app, $scope.qAdhocProps).then(function (cubeDim) {
										if (cubeDim) {
											var dim = dimensions.getDimensionByCid($rootScope, cubeDim.qDef.cId)
												dim.selectedValuesCount = 1;
											var topic = dimensions.getDimensionTopicByDim($rootScope, dim.shortName);
											topic.selectedGrpCount = 1;
										}
										createChartWithVisObj();
									})
								} else {

									createChartWithVisObj();
								}
							});
						});
					});
				}

				function createChartWithVisObj() {
					$rootScope.qApp.visualization.create($rootScope.displayVisType, [], $scope.qAdhocProps).then(function (vis) {
						$rootScope.visObjId = vis.id;
						$rootScope.visObj = vis;
						vis.table.OnData.bind($scope.tblListener);
						$rootScope.visObj.show("QV01").then(function(){
							$rootScope.$broadcast('modifiedVisualizationEvent');
						});
						
					});
				}

				function setChartProps() {
					$scope.qAdhocProps = {
						"qInfo": {
							"qType": "barchart"
						},
						"scrollbar": "miniChart", //"bar"
						"showTitles": true,
						"footnote": appUtilities.getSurveySource($rootScope),
						"nullMode": "connect",
						// "dataPoint": {
						// "showLabels": false
						// },
						"legend": {
							"show": true,
							"dock": "right"
						},
						"qHyperCubeDef": {
							"qSuppressZero": false,
							"qSuppressMissing": true,
							"qInitialDataFetch": [{
									"qLeft": 0,
									"qTop": 0,
									"qWidth": 20,
									"qHeight": 500
								}
							],
							"qReductionMode": "N",
							"qMode": "S",	
							"qPseudoDimPos": -1,
							"qNoOfLeftDims": -1,
							"qAlwaysFullyExpanded": true,
							"qMaxStackedCells": 5000,
							"qPopulateMissing": false,
							"qShowTotalsAbove": false,
							"qIndentMode": false
						},
						"dimensionAxis": {
							"continuousAuto": true,
							"show": "all",
							"label": "auto",
							"dock": "near",
							"axisDisplayMode": "auto",
							"maxVisibleItems": 10
						},
						"measureAxis": {
							"show": "all",
							"dock": "far",
							"spacing": 1,
							"autoMinMax": true,
							"minMax": "min",
							"min": 0,
							"max": 10
						}						
					}
				}
			}
		]);
});

'use strict'

define('scripts/directives/chartSubMenuBarPercentageDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities", 
	"scripts/shared/measures", "scripts/shared/dimensions" ], 
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {
	
	angular.module("appModule").directive("dtChartSubMenuBarPercentage", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartSubMenuBarPercentage.html',
		scope: true,
		controller: 'ChartSubMenuBarPercentageController'
	  };
	});	
	
		
	angular.module("appModule").controller("ChartSubMenuBarPercentageController", ["$scope", "$rootScope", "$q", "$location", "$http", 
		function ($scope, $rootScope, $q, $location, $http) { 
        
            //$scope.disablePercentages = true;
            //alert($scope.disablePercentages);
            $scope.$on('setChartPercentagesEvent', function (e, val) {
                $rootScope.visObj.table.OnData.unbind($scope.tblListener);
                $rootScope.chart.showPercentages = val;
                $scope.chkPercentages();
                $rootScope.visObj.table.OnData.bind( $scope.tblListener );
            });	            
            
			$scope.chkPercentages = function () {			
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {					
					obj.getProperties().then(function(props) {
						if(props.visualization === 'barchart') {			
							var msr = measures.getMeasureByCid($rootScope, props.qHyperCubeDef.qMeasures[0].qDef.cId);				
							if($rootScope.chart.showPercentages) {
								gtag('event', 'CB-' + $rootScope.survey.abbreviation + '-Apply Percentages', {
									'event_label': 'apply',
									'event_category': 'chart_percentages'
								});									
								if(msr != null && msr.percentDef != null) {
									var expr = msr.percentDef;
									if(msr.percentDef.includes("<GROUP>")) { 
										var dim  = dimensions.getDimensionByCid($rootScope,  props.qHyperCubeDef.qDimensions[0].qDef.cId);
										if(dim != null) {
											if(dim.shortName != $rootScope.survey.dimToLock) {
													alert('X-Axis must be Year display as percentages');
													$rootScope.chart.showPercentages = false;
													return;                                               
											}
											expr = msr.percentDef.replace("GROUP",dim.shortName);
										}
									} 
									props.qHyperCubeDef.qMeasures[0].qDef.qDef = expr;
									props.qHyperCubeDef.qMeasures[0].qDef.qNumFormat.qType = "R";
									props.qHyperCubeDef.qMeasures[0].qDef.qNumFormat.qFmt = "#,##0%";
								} else {
									alert('Selected measure not valid for display as percentages');
									$rootScope.chart.showPercentages = false;
									return;
								}	

								//Set scale to 0.0 to 1.0 if scale has been set
								$rootScope.chart.rangeMinInit = $rootScope.chart.rangeMin;
								$rootScope.chart.rangeMaxInit = $rootScope.chart.rangeMax;										
								$rootScope.chart.rangeMin = 0;
								$rootScope.chart.rangeMax = 1;								
								if(props.measureAxis.autoMinMax == false){
									props.measureAxis.min = $rootScope.chart.rangeMin;
									props.measureAxis.max = $rootScope.chart.rangeMax;									
								}
							} else {
								props.qHyperCubeDef.qMeasures[0].qDef.qDef = msr.def;
								props.qHyperCubeDef.qMeasures[0].qDef.qNumFormat.qType = "F";
								props.qHyperCubeDef.qMeasures[0].qDef.qNumFormat.qFmt = "#,##0";
								props.qHyperCubeDef.qMeasures[0].qDef.qNumFormat.qDec = ".";
								props.qHyperCubeDef.qMeasures[0].qDef.qNumFormat.qThou = ",";
								props.qHyperCubeDef.qMeasures[0].qDef.qNumFormat.qUseThou = 0;
								props.qHyperCubeDef.qMeasures[0].qDef.qNumFormat.qnDec = 2;
								
								//reset scale back to original value when show percent turned off
								$rootScope.chart.rangeMin = $rootScope.chart.rangeMinInit;
								$rootScope.chart.rangeMax = $rootScope.chart.rangeMaxInit;
								if(props.measureAxis.autoMinMax == true){
									props.measureAxis.min = $rootScope.chart.rangeMin;
									props.measureAxis.max = $rootScope.chart.rangeMax;									
								}															
							}
							
							obj.setProperties(props).then(function() {
							},function(err) {
								console.log(err);
							});							
							
						}
						
					}); 
				});				
			} 		
        }		 				
	]);
});
'use strict'

define('scripts/directives/chartSubMenuLabelsDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions" ],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtChartSubMenuLabels", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartSubMenuLabels.html',
		scope: true,
		controller: 'ChartSubMenuLabelsController'
	  };
	});



	angular.module("appModule").controller("ChartSubMenuLabelsController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {
			$('.dropdown-menu.chart-labels').on("click.bs.dropdown", function (e) {
				if (e.target.id != "idLabelsSave" && e.target.id != "idLabelsClose") {
					e.stopPropagation();
					e.preventDefault();
				}
			});


/* 			$scope.btnCloseSubMenuLabels = function(){
				$('.dropdown-menu.chart-labels').on('hide.bs.dropdown', function (e) {
					if (e.target.id == "btnLblSave") {
						e.stopPropagation();
					  e.preventDefault();
					}
				});
			} */

			$scope.btnChartSubMenuLabels = function() {

				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					let msr = measures.getMeasureByCid($rootScope, obj.layout.qHyperCube.qMeasureInfo[0].cId);
					let dim = dimensions.getDimensionByCid($rootScope, obj.layout.qHyperCube.qDimensionInfo[0].cId);
					if(obj.layout.qHyperCube.qMeasureInfo.length > 0) {
						if($rootScope.displayVisType == "linechart" || $rootScope.chart.barType == 'v-grouped' || $rootScope.chart.barType  == 'v-stacked'){
							$rootScope.chart.yAxis = msr.newTitle != null && msr.newTitle?msr.newTitle: msr.variableName;
						} else {
							$rootScope.chart.yAxis = dim.newTitle != null && dim.newTitle?dim.newTitle: dim.title;
						}
					}

					if(obj.layout.qHyperCube.qDimensionInfo.length > 0) {
						if($rootScope.displayVisType == "linechart" || $rootScope.chart.barType == 'v-grouped' || $rootScope.chart.barType == 'v-stacked'){
							$rootScope.chart.xAxis = dim.newTitle != null && dim.newTitle?dim.newTitle: dim.title;
						} else {
							$rootScope.chart.xAxis = dim.newTitle != null && msr.newTitle?msr.newTitle: msr.variableName;
						}
					}

					if(obj.layout.qHyperCube.qDimensionInfo.length > 1) {
						dim = dimensions.getDimensionByCid($rootScope, obj.layout.qHyperCube.qDimensionInfo[1].cId);
						if($rootScope.displayVisType == "linechart" || $rootScope.chart.barType == 'v-grouped' || $rootScope.chart.barType == 'v-stacked'){
							$rootScope.chart.xAxisGrp = dim.newTitle != null && dim.newTitle?dim.newTitle:dim.title;
						} else {
							$rootScope.chart.yAxisGrp = dim.newTitle != null && dim.newTitle?dim.newTitle:dim.title;
						}

						$rootScope.chart.showXAxisGrp = true;
					} else {
						$rootScope.chart.yAxisGrp = "";
						$rootScope.chart.showXAxisGrp = false;
					}
					$rootScope.chart.title = obj.layout.title;
				});
			}

			$scope.btnSetLabels = function () {
				gtag('event', 'CB-' + $rootScope.survey.abbreviation + '-Apply Labels', {
					'event_label': 'apply',
					'event_category': 'chart_labels'
				});	
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getEffectiveProperties().then(function(props) {
						if($rootScope.chart.xAxis != null) {
							if(props.qHyperCubeDef.qDimensions.length > 0) {
								props.qHyperCubeDef.qDimensions[0].qDef.qFieldLabels[0] = $rootScope.chart.xAxis;
								var dim = dimensions.getDimensionByCid($rootScope, props.qHyperCubeDef.qDimensions[0].qDef.cId)
								dim.newTitle = $rootScope.chart.xAxis;
							}
						}

						if($rootScope.chart.xAxisGrp != null) {
							if(props.qHyperCubeDef.qDimensions.length > 1) {
								props.qHyperCubeDef.qDimensions[1].qDef.qFieldLabels[0] = $rootScope.chart.xAxisGrp;
								var dim = dimensions.getDimensionByCid($rootScope, props.qHyperCubeDef.qDimensions[1].qDef.cId)
								dim.newTitle = $rootScope.chart.xAxisGrp;
							}
						}

						if($rootScope.chart.yAxis != null) {
							if(props.qHyperCubeDef.qMeasures.length > 0) {
								props.qHyperCubeDef.qMeasures[0].qDef.qLabel = $rootScope.chart.yAxis;
								var msr = measures.getMeasureByCid($rootScope, props.qHyperCubeDef.qMeasures[0].qDef.cId)
								msr.newTitle = $rootScope.chart.yAxis;
							}
						}

						if($rootScope.chart.title != null && $rootScope.chart.title.length > 0) {
							props.title = $rootScope.chart.title;
							angular.element(document.querySelector(".chart-container h1.qv-object-title.qvt-visualization-title")).css("display","inline-block");
						} else {
							props.title = "";
              angular.element(document.querySelector(".chart-container h1.qv-object-title.qvt-visualization-title")).css("display","none");
						}

						obj.setProperties(props).then(function() {
						},function(err) {
							console.log(err);
						});

					});
				});
			}
        }
	]);
});
'use strict'

define('scripts/directives/chartSubMenuExportDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions", "scripts/lib/jszip"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, JSZip) {
	angular.module("appModule").directive("dtChartSubMenuExport", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartSubMenuExport.html',
		scope: true,
		controller: 'ChartSubMenuExportController'
	  };
	});



	angular.module("appModule").controller("ChartSubMenuExportController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {
			var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';
			
			$('.dropdown-menu.chart-export-files').on("click.bs.dropdown", function (e) {
				if (e.target.id != "idChartExportFilesSave" && e.target.id != "idChartExportFilesClose") {
					e.stopPropagation();
					//e.preventDefault();
				}
			});				

			$scope.btnExportSelectedFormats = function(){
				var selectedExportTypes = getSelectedExportTypes();

				let exports = "-Export Chart as"
				var promises = [];
				for(var i=0; i < selectedExportTypes.length; i++) {
					exports+=i>0?", ":""
					var selectedExportType = selectedExportTypes[i];
					if(selectedExportType == "pdf") {
						exports += " PDF"
						promises.push($scope.exportPdf());
					}
					if(selectedExportType == "png") {
						exports += " PNG"
						promises.push($scope.exportPng());
					}
					if(selectedExportType == "jpg") {
						exports += " JPG"
						promises.push($scope.exportJpg());
					}
					if(selectedExportType == "csv") {
						exports += " CSV"
						promises.push($scope.exportCsv());
					}
				}
				// google analytics tracking
				gtag('event', displayType + $rootScope.survey.abbreviation + exports, {
					'event_label': 'export',
					'event_category': 'download'
				});	
				Promise.all(promises).then(function(exportedResults) {
					var dateObj = new Date();
					var dateStr = dateObj.toString();
					console.log('exportedResults in promise.all: ', exportedResults);
					//var tmp = exportedResults
					hyperCubeProperties.getExportSupplementalData(qlik, $rootScope, $scope, $http, dateStr).then(function(metadata) {
						//exportedResults.metadata = metadata;
						//console.log('exportedResults in promise.all: ', exportedResults);
						saveSelectedExportResults(exportedResults, metadata).then(function() {
							$scope.clearSelectedExportedTypes();
						});
					})
				});

			}
			
			// Initialize the export types
			$scope.exportTypes = {
				jpg: false,
				png: false,
				pdf: false,
				csv: false
			}

			$scope.isExportTypeSelected = function(){
				var selectedExportTypes = getSelectedExportTypes();
				return selectedExportTypes.length > 0;

			}

			$scope.clearSelectedExportedTypes = function(){
				$scope.exportTypes = {
					jpg: false,
					png: false,
					pdf: false,
					csv: false
				}
			}

			function getSelectedExportTypes(){
				var keys = Object.keys($scope.exportTypes);
				// Loop through the types chosen by the user
				var selectedExportTypes = keys.filter(function(key) {
					return $scope.exportTypes[key];
				});
				return selectedExportTypes;
			}

			$scope.exportJpg = function () {
				return new qlik.Promise(function(resolve, reject) {
					//var spinner = appUtilities.initSpinner();
					$scope.toggleReadOnly(true)
					var wrapper =  document.querySelector(".chart-container");
					var defSettings = { format: 'jpg', height: Math.round(wrapper.offsetHeight), width: Math.round(wrapper.offsetWidth)} 
					getImageFile('jpg', defSettings, wrapper).then(function(exportResult) {
						$scope.toggleReadOnly(false)
						//spinner.stop();
						return resolve(exportResult);
					}, function(err){
						console.log('JPG' + ' Err', err);
						//spinner.stop();
						$scope.toggleReadOnly(false)
					});
				});
			}


			$scope.exportPng = function () {
				return new qlik.Promise(function(resolve, reject) {
					//var spinner = appUtilities.initSpinner();
					$scope.toggleReadOnly(true)
					var wrapper =  document.querySelector(".chart-container");
					var defSettings = { format: 'png', height: Math.round(wrapper.offsetHeight), width: Math.round(wrapper.offsetWidth) };
					getImageFile('png', defSettings, wrapper).then(function(exportResult) {
						//spinner.stop();
						$scope.toggleReadOnly(false);
						return resolve(exportResult);
					}, function(err){
						console.log('PNG' + ' Err', err);
						$scope.toggleReadOnly(false);
						//spinner.stop();
					});
				});
			}

			$scope.exportPdf = function () {
				return new qlik.Promise(function(resolve, reject) {
					//var spinner = appUtilities.initSpinner();
					$scope.toggleReadOnly(true)
					var wrapper =  document.querySelector(".chart-container");
					var defSettings = { documentSize: 'a3', aspectRatio: 2, orientation: "landscape" };
					getImageFile('pdf', defSettings, wrapper).then(function(exportResult) {
						//spinner.stop();
						$scope.toggleReadOnly(false);
						return resolve(exportResult);
					}, function(err){
						console.log('PDF' + ' Err', err);
						$scope.toggleReadOnly(false)
						//spinner.stop();
					});
				});
			}

			$scope.exportCsv = function () {
				return new qlik.Promise(function(resolve, reject) {
					//var spinner = appUtilities.initSpinner();
					$scope.toggleReadOnly(true)
					var wrapper =  document.getElementById("chartWrapper");
					var settings = {format:'CSV_C', state: 'A'};
					getImageFile('csv', settings, wrapper).then(function(exportResult) {
						//spinner.stop();
						$scope.toggleReadOnly(false)
						return resolve(exportResult);
					}, function(err){
						console.log('csv' + ' Err', err);
						//spinner.stop();
						$scope.toggleReadOnly(false)
					});
				});
			}



			function getImageFile(type, settings, wrapper) {
				return new qlik.Promise(function(resolve, reject) {
					$rootScope.qApp.visualization.get($rootScope.visObjId ).then(function(vis){
						var exportResult = {};
						var dateObj = new Date();
						var dateStr = dateObj.toString();
						if(type == 'pdf') {
							
							if( $rootScope.displayVisType == "linechart") {
								if(vis.table.qHyperCube.qDimensionInfo[0].qCardinalities.qHypercubeCardinal > 64) {
									settings.documentSize = {};
									settings.documentSize.width = 600;
									settings.documentSize.height = 330;				
								} else if(vis.table.qHyperCube.qDimensionInfo[0].qCardinalities.qHypercubeCardinal > 40) {
									settings.documentSize = {};
									settings.documentSize.width = 580;
									settings.documentSize.height = 319;
								}								
							}

							vis.exportPdf(settings).then(function (result) {
								console.log('Image download link: ', result);
								exportResult.result = result;
								exportResult.wrapper = wrapper;
								exportResult.type = type;
								return resolve(exportResult);
							}, function(err) {
								return reject(err);
							});	
							
						}

						if(type == 'csv'){

 							$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
								obj.getProperties().then(function (obj_properties) {
									let cols = [];
									let dims = obj_properties.qHyperCubeDef.qDimensions;
									let msrs = obj_properties.qHyperCubeDef.qMeasures;
									//Remove totals since not needed in raw data; 
									//Place year as first column followed by dimensions from rows then columns, and then measures
									dims.forEach(function(dim) {
										let tmpDim = dimensions.getDimensionByCid($rootScope, dim.qDef.cId);
										if(tmpDim.shortName === $rootScope.survey.dimToLock) {
											cols.push(dim);
										}
									})
									dims.forEach(function(dim) {
										let tmpDim = dimensions.getDimensionByCid($rootScope, dim.qDef.cId);
										if(tmpDim.shortName !== $rootScope.survey.dimToLock) {
											cols.push(dim);
										}
									});
									//remove commas from CSV data
									msrs.forEach(function(msr) {
										msr.qDef.qNumFormat.qFmt = '##0'
										cols.push(msr); 
									})
		
									//set hypercube def properties for new Table vis
									let props = {qHyperCubeDef: {
										qSuppressZero: true,
										qSuppressMissing: true}};
									
									$rootScope.qApp.visualization.create('table', cols, props).then(function(vis){
										vis.exportData(settings).then(function (result) {
											//bug workaround, Qlik server returns URL string that contains 2 "https" tas, so remove the unnecessary 1st one if it exists
											var n = result.lastIndexOf("https");
											if(n > 0)  {
												result = result.substr(n);
											}  
											exportResult.result = result;
											exportResult.wrapper = wrapper;
											exportResult.type = type;											
											$rootScope.qApp.destroySessionObject(vis.id);
											return resolve(exportResult);
										}, function(err) {
											console.log(err);
											return reject(err);
										});
									}, function(err) {  
										console.log(err);
										return reject(err);
									});
		
								}, function(err) {
									return reject(err);
								});
		
							}, function(err) {
								return reject(err);
							});
						}
						if(type == 'png' || type == 'jpg') {

							if( $rootScope.displayVisType == "linechart") {
								const leftM = 84, rightM = 164;
								
								let xPts = vis.table.qHyperCube.qDimensionInfo[0].qCardinalities.qHypercubeCardinal;
								let overrideWidth = leftM + rightM + (xPts * 30)
								
								if(overrideWidth > settings.width)
									settings.width = overrideWidth;
							}
							
							vis.exportImg(settings).then(function (result) {
								console.log('Image download link: ', result);
								exportResult.result = result;
								exportResult.wrapper = wrapper;
								exportResult.type = type;
								return resolve(exportResult);
							}, function(err) {
								return reject(err);
							});
						}
					}, function(err) {
						return reject(err);
					});
				})
			}




			function saveSelectedExportResults(exportedResults, metadata) {
				return new qlik.Promise(function(resolve, reject) {
					if (exportedResults && exportedResults.length > 0) {
						var zip = new JSZip();
						var count = 0;

						// Start
						exportedResults.forEach(function(exportedResult){
							// loading a file and add it in a zip file
							$http.get(exportedResult.result,{responseType: 'arraybuffer'}).then(function (response) {
								var blob = new Blob([response.data]);
								var strContent = '';
								var m = new Date();
								var dateString = m.toString();
								var filename = "ncses_chart_srv_data_" + $rootScope.survey.abbreviation + "_" + m.toISOString().replace(/:/g, "_").split('.')[0]+"Z";
								zip.file(filename + "." + exportedResult.type, blob, {base64: true});
								count++;

								if (count == exportedResults.length) {
									zip.file("chart-description-"+$rootScope.survey.abbreviation+".txt", metadata);						
									zip.generateAsync({type:'blob'}).then(function(content) {
										saveAs(content, filename + ".zip");
										resolve();
									});
								}	
							}, function (err) {
								return reject(err); // or handle the error
							});
						  });
						  
					  
					}
				})
			}
        }
	]);
});
'use strict'

define('scripts/directives/chartSubMenuScaleDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions" ],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtChartSubMenuScale", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartSubMenuScale.html',
		scope: true,
		controller: 'ChartSubMenuScaleController'
	  };
	});


	angular.module("appModule").controller("ChartSubMenuScaleController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {

			//$rootScope.chart = {};
			//$rootScope.chart.type = '';

			$('.dropdown-menu.chart-scale').on("click.bs.dropdown", function (e) {
				if (e.target.id != "idScaleSave" && e.target.id != "idScaleClose") {
					e.stopPropagation();
					e.preventDefault();
				}
			});

			$scope.btnChartSubMenuScale = function() {
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					if($rootScope.chart.rangeMax == null || $rootScope.chart.rangeMax.length == 0) {
						var tmpMax = Math.round(obj.layout.qHyperCube.qMeasureInfo[0].qMax);
						$rootScope.chart.rangeMax = tmpMax;
						$rootScope.chart.rangeMaxInit = tmpMax;
					}

					if($rootScope.chart.rangeMin == null || $rootScope.chart.rangeMin.length == 0) {
						var tmpMin = Math.round(obj.layout.qHyperCube.qMeasureInfo[0].qMin);
						$rootScope.chart.rangeMin = 0;
						$rootScope.chart.rangeMinInit = 0;
					}

				});
			}

			$scope.btnSetScale = function () {
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getProperties().then(function(props) {
						var msr = measures.getMeasureByCid($rootScope, props.qHyperCubeDef.qMeasures[0].qDef.cId);
						var def = msr.def; //props.qHyperCubeDef.qMeasures[0].qDef.qDef;
						if(props.visualization === 'linechart') {
							// var expr = "if(" + def + "<=" + $rootScope.chart.rangeMax + " and " + def + ">=" + $rootScope.chart.rangeMin + "," + def + ")";
							// props.qHyperCubeDef.qMeasures[0].qDef.qDef = expr;
						}
						else if(props.visualization === 'barchart') {
							var expr = "if(" + def + "<=" + $rootScope.chart.rangeMax + " and " + def + ">=" + $rootScope.chart.rangeMin + "," + def + ")";
							props.measureAxis.autoMinMax = false;
							props.measureAxis.minMax = "minMax";
							props.measureAxis.min = $rootScope.chart.rangeMin;
							props.measureAxis.max = $rootScope.chart.rangeMax;
						}

						obj.setProperties(props).then(function() {
						},function(err) {
							console.log(err);
						});

					});
				});
			}
        }
	]);
});
'use strict'
define('scripts/shared/charts',[], function () {

	function buildColorExpression(shortName, colorCodes) {
		var defs = [];
		var defStr = "<FIELD>";

		var divisor = colorCodes.length;
		for (var y = 0; y < divisor -1; y++) {
			defs.push("if(mod(FieldIndex('"+ shortName + "', " + shortName + ")," + divisor + ")=" + y +", rgb(" + colorCodes[y] + "), <FIELD>)");
		}
		
		defStr = "<FIELD>";
		for (var x = 0; x < defs.length; x++) {
			if (x == 0)
				defStr = defs[x];
			else {
				defStr = defStr.replace("<FIELD>", defs[x]);
			}
		}
		defStr = defStr.replace("<FIELD>", " rgb(" + colorCodes[divisor-1] + ")");
		return defStr;
	}	

	function convertToRgbFromHexMultiDimension(colorCodes) {
		var rgbs = [];
		for (var i = 0; i < colorCodes.length; i++) {
			rgbs.push(hexToRgbString(colorCodes[i]))
		}
		return rgbs;
	}

	function convertToRgbFromHexSingleDimension(colorCodes) {
		var rgbs = [];
		rgbs.push(hexToRgbString(colorCodes))
		return rgbs;
	}


	function hexToRgbString (hex) {
		if(!!hex){
		  let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
		  return r + r + g + g + b + b;
		});
		let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		if(result) {
			var redColor = parseInt(result[1],  16);
			var greenColor = parseInt(result[2],  16);
			var blueColor = parseInt(result[3],  16);
			return "" + redColor + "," + greenColor + "," + blueColor;
		 }
		}
	  }	

	function componentToHex(c) {
		var hex = c.toString(16);
		return hex.length == 1 ? "0" + hex : hex;
	} 

	function rgbToHex(rgb) {
		let rgbArr = rgb.split(",");
		//return "#" + ((1 << 24) + (rgbArr[0] << 16) + (rgbArr[1] << 8) + rgbArr[2]).toString(16).slice(1);
		return "#" + componentToHex(parseInt(rgbArr[0])) + componentToHex(parseInt(rgbArr[1])) + componentToHex(parseInt(rgbArr[2]));
	}	  

	return {
		buildColorExpression: buildColorExpression,
		convertToRgbFromHexMultiDimension: convertToRgbFromHexMultiDimension,
		convertToRgbFromHexSingleDimension: convertToRgbFromHexSingleDimension,
		hexToRgbString: hexToRgbString,
		rgbToHex: rgbToHex
	};

});		
'use strict'

define('scripts/directives/chartSubMenuColorDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions", "scripts/shared/charts" ],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, charts) {

	angular.module("appModule").directive("dtChartSubMenuColor", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartSubMenuColor.html',
		scope: true,
		controller: 'ChartSubMenuColorController'
	  };
	});


	angular.module("appModule").controller("ChartSubMenuColorController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {
			$rootScope.chart = {};
			$rootScope.chart.useCustomColors = false;
			$rootScope.chart.colorCodes;
			$scope.disableButton = false;
			$scope.themeName = null;
			$scope.previousThemeName = null;

			$scope.$on('openColorDialogEvent', function() {
				$scope.openColorDialog();
			});

			$scope.openColorDialog = function() {
				$("#ddChartColor").modal('show');
				$scope.previousThemeName = $rootScope.previousThemeName;
				isRevertDefaultDisabled().then(function(result) {
					$scope.disableButton = result;
				});
			}

			$scope.closeColorDialog = function() {
				$("#ddChartColor").modal('hide');

			}
			$scope.btnChartSubMenuColor = function() {
				$("#ddChartColor").show();
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					if($rootScope.chart.rangeMax == null || $rootScope.chart.rangeMax.length == 0) {
						var tmpMax = Math.round(obj.layout.qHyperCube.qMeasureInfo[0].qMax);
						$rootScope.chart.rangeMax = tmpMax;
						$rootScope.chart.rangeMaxInit = tmpMax;
					}

					if($rootScope.chart.rangeMin == null || $rootScope.chart.rangeMin.length == 0) {
						var tmpMin = Math.round(obj.layout.qHyperCube.qMeasureInfo[0].qMin);
						$rootScope.chart.rangeMin = tmpMin;
						$rootScope.chart.rangeMinInit = tmpMin;
					}

				});
			}


			$scope.btnLoadTheme = function () {
				var filePicker = document.getElementById('fileLoadTheme');

				filePicker.addEventListener("change", fileSelected);
				filePicker.click();
				function fileSelected() {
					filePicker.removeEventListener("change", fileSelected);
					let obj;
					let f = filePicker.files[0];
					let promise = loadFile(f, obj);
					promise.then((themeObj) => {
						gtag('event', 'CB-' + $rootScope.survey.abbreviation + '-Load Custom Color Theme', {
							'event_label': 'load',
							'event_category': 'color_theme'
						});												
						var themeName = themeObj.themeName;
						var themeColorCodes = themeObj.colorCodes;
							filePicker.value = "";

							if (!themeName && !themeColorCodes) {
								filePicker.value = "";
								$('#errorMsg').text("File is not a valid JSON file. Please make sure file was created from custom color theme.");
								$('#DisplayErrorMessage').modal({
									toggle: true,
									backdrop: true,
									keyboard: false
								});
								$("#DisplayErrorMessage").css('z-index', 3000);
								$("#DisplayErrorMessage").css('margin-top', 12+'rem');
								return;
							} else{
								$scope.loadThemeObj = themeObj;
								$scope.loadColorCodes = []
								themeObj.colorCodes.forEach(function(color) {
									$scope.loadColorCodes.push(color.trim());
								});
								//$scope.loadColorCodes = themeObj.colorCodes;
							    $scope.themeName = themeObj.themeName;
							}
							$scope.$apply();
							return;


					}, function (err) {
						filePicker.value = "";
						$('#errorMsg').text(err);
						$('#DisplayErrorMessage').modal({
							toggle: true,
							backdrop: 'static',
							keyboard: false
						});
							$("#DisplayErrorMessage").css('z-index', 3000);
							$("#DisplayErrorMessage").css('margin-top', 12+'rem')
						});;
				}
			}


			function loadFile(file, dimsObj) {
				return new Promise(function (resolve, reject) {
					var fr;

					if (typeof window.FileReader !== 'function') {
						//alert("The file API isn't supported on this browser yet.");
						// $('#errorMsg').text("The file API isn't supported on this browser yet.");
						// $('#DisplayErrorMessage').modal({
						// toggle: true,
						// backdrop: 'static',
						// keyboard: false
						// });
						return reject("The file API isn't supported on this browser yet");
					}
					fr = new FileReader();
					fr.onload = receivedText;
					fr.readAsText(file);

					function receivedText(e) {
						let resp = e.target.result;
						try {
							let tmpObj = JSON.parse(resp);
							if (!tmpObj) {
								//alert('Invlaid json file, missing result property');
								// $('#errorMsg').text("FInvlaid json file, missing result property");
								// $('#DisplayErrorMessage').modal({
								// toggle: true,
								// backdrop: 'static',
								// keyboard: false
								// });
								return reject("Invlaid json file, missing result property");
							}
							return resolve(tmpObj);
						} catch (err) {
							console.log('Error opening file', err);
							//alert('File is not a valid JSON file. Please make sure file was created from custom dimensions');
							return reject("File is not a valid JSON file. Please make sure file was created from custom color theme.");
						}
					}
				});
			}

			function isRevertDefaultDisabled() {
				var Promise = qlik.Promise;
				return new Promise(function(resolve, reject) {
					$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
						obj.getEffectiveProperties().then(function(props) {
							if(props.color.auto){
								return resolve(true);
							}else {
								return resolve(false);
							}
						}, function(err) {
							return reject(err);
						});
					}, function(err) {
						return reject(err);
					});
				});
			}

			$scope.revertToDefaultTheme  = function(){
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getEffectiveProperties().then(function(props) {
						props.qHyperCubeDef.qMeasures[0].qAttributeExpressions = [];
						delete props.color.colorExpression;

						props.color.auto = true;
						props.color.mode = "primary";
						props.color.dimensionScheme = "12";
						props.color.byDimDef = {};
						props.color.altLabel = {};

						var legend = {
							"show": true
							}

						props.legend = legend;

						obj.setProperties(props).then(function() {
						$rootScope.chart.useCustomColors = false;
						},function(err) {
							console.log(err);
						});
					})
				});
				$rootScope.previousThemeName = null;
				$("#ddChartColor").modal('hide');
			}

			$scope.btnColorThemeApply = function () {
				gtag('event', 'CB-' + $rootScope.survey.abbreviation + '-Apply Custom Color Theme', {
					'event_label': 'apply',
					'event_category': 'color_theme'
				});				
				
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getEffectiveProperties().then(function(props) {
						$scope.previousThemeName = $scope.themeName;
						$rootScope.previousThemeName = $scope.previousThemeName;
						$rootScope.chart.colorCodes = charts.convertToRgbFromHexMultiDimension($scope.loadColorCodes);
						if(props.qHyperCubeDef.qDimensions.length > 1) {
							var dim = dimensions.getDimensionByCid($rootScope, props.qHyperCubeDef.qDimensions[1].qDef.cId);
							var shortName = dim.shortName;
							var colorExp = charts.buildColorExpression(shortName, $rootScope.chart.colorCodes);
							props.color.mode = "byExpression";
							props.color.auto = false;
							props.color.persistent = true;
							props.color.useBaseColors = "off";
							props.color.expressionIsColor = true;
							props.color.useDimColVal = true;
							props.color.colorExpression = colorExp;

							props.qHyperCubeDef.qMeasures[0].qAttributeExpressions = [];
							props.qHyperCubeDef.qDimensions[1].qAttributeDimensions = [];
							props.qHyperCubeDef.qDimensions[1].qAttributeExpressions = [];

							var attrExp = {};
							attrExp.qExpression = props.color.colorExpression;
							attrExp.qLibraryId = "";
							attrExp.qAttribute = true;
							attrExp.qNumFormat = null;
							attrExp.qLabel = "";
							attrExp.qLabelExpression = "";
							attrExp.id = "colorByExpression";
							props.qHyperCubeDef.qMeasures[0].qAttributeExpressions.push(attrExp);

						} else{

							props.qHyperCubeDef.qDimensions[0].qAttributeDimensions = [];
							props.qHyperCubeDef.qDimensions[0].qAttributeExpressions = [];							

							props.color.mode = "primary";
							props.color.auto = false;
							props.color.persistent = false;		
							props.color.useBaseColors = "off";
							props.color.paletteColor = {}
							props.color.paletteColor.index = -1;
							props.color.paletteColor.color = $scope.loadColorCodes[0]; //"#FFCC00";
							props.color.useDimColVal = true;
							props.color.useMeasureGradient = false;
							props.color.persistent = false;
							props.color.expressionIsColor = true;
							props.color.expressionLabel = "";
						}

						isRevertDefaultDisabled().then(function(result) {
							$scope.disableButton = result;
						});						

						/*Do not show color legend*/
						var legend = {
							"show": true
						}
						props.legend = legend;
						//props.qHyperCubeDef.qMeasures[0].qDef.qDef = expr;
						obj.setProperties(props).then(function() {
							$rootScope.chart.useCustomColors = true;
						},function(err) {
							console.log(err);
						});
					});
				});

				$("#ddChartColor").modal('hide');

				$scope.clickOpenFeedback = function (tab) {
					//google analytics tracking
					gtag('event', displayType + 'Open Feedback', {
						'event_label': 'open',
						'event_category': 'feedback'
					});
					$rootScope.$broadcast('openFeedbackEvent');
				}

			}
		}
	]);
});



'use strict'

define('scripts/directives/chartSubMenuZoomDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions" ],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, charts) {

	angular.module("appModule").directive("dtChartSubMenuZoom", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartSubMenuZoom.html',
		scope: true,
		controller: 'ChartSubMenuZoomController'
	  };
	});


	angular.module("appModule").controller("ChartSubMenuZoomController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {
			var appObj = $rootScope.qApp;
			$scope.measureSliderChanged = false;
			$scope.measureSliderApplied = false;
			$scope.measureSliderDisabled = false;
			$scope.dimYearSliderDisabled = false;
			$scope.dimYearSliderShow = false;

			$('#modal-zoom').on('show.bs.modal', function (e) {
				$scope.zoomMeasure = {};
				$scope.zoomDimYear = {};
				$scope.measureSliderChanged = false;
				$scope.dimYearSliderShow = false;
				$scope.zoomObjProperties = {};
				$scope.getMeasureScale();
				$scope.getZoomProperties();
			});

			$scope.getMeasureScale = function() {
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getProperties().then(function (obj_properties) {
						$scope.zoomObjProperties = obj_properties;
						$scope.zoomObj = obj;
						// disable measure slider if linechart
						// if(obj_properties.visualization === 'linechart') {
						// 	$scope.measureSliderDisabled = true;
						// else {
						// 	$scope.measureSliderDisabled = false;
						// }

						var tmpMax = Math.round(obj.layout.qHyperCube.qMeasureInfo[0].qMax);
						$rootScope.chart.rangeMax = tmpMax;
						$rootScope.chart.rangeMaxInit = tmpMax;

						var tmpMin = Math.round(obj.layout.qHyperCube.qMeasureInfo[0].qMin);
						$rootScope.chart.rangeMin = 0;
						$rootScope.chart.rangeMinInit = 0;

						$rootScope.chart.measureAxis = obj_properties.measureAxis;
						initializeMeasureSlider($rootScope.chart);
					});
				});
			}

			$scope.getZoomProperties = function () {
				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getProperties().then(function (obj_properties) {
						$scope.zoomObjProperties = obj_properties;
						if(obj_properties.visualization === 'barchart') {
							$scope.dimYearSliderDisabled = true;
						}
						else {
							$scope.dimYearSliderDisabled = false;
						}
						$scope.objectProperties = obj_properties;
						$scope.qHyperCubeDef = obj_properties.qHyperCubeDef;

						// find the Year dim and get the dim's values
						$scope.objectProperties.qHyperCubeDef.qDimensions.forEach(function(dim, i) {
							if(i == 0 && (
								dim.qDef.qFieldDefs[0].toUpperCase() == 'YEAR'
								|| dim.qDef.qFieldDefs[0].toUpperCase() == '=YEAR'
								|| dim.qDef.qFieldDefs[0].toUpperCase() == 'REFYR'
								)) {
								// do not show the Year (Dimenestion) slider if Year is not the dimension axis
								// the dim is of index = 0 when it is on the dimension axis
								$scope.dimYearSliderShow = true;
							}

							if(dim.qDef.qFieldDefs[0].toUpperCase() == 'YEAR'
								|| dim.qDef.qFieldDefs[0].toUpperCase() == '=YEAR'
								|| dim.qDef.qFieldDefs[0].toUpperCase() == 'REFYR') {
								$scope.zoomDimYear = dim;

								renderList(dim.qDef.qFieldDefs[0]).then(function (list) {
									list = list.sort((a, b) => (Number(a.qText) > Number(b.qText)) ? 1 : -1)
									$scope.zoomDimYear.values = list;
									initializeDimYearSlider($scope.zoomDimYear);
								});
							}
						});

					});
				})
			};

			$scope.btnApplyZoom = function () {
				gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-')  + $rootScope.survey.abbreviation + '-Apply Zoom', {
					'event_label': 'apply',
					'event_category': 'zoom'
				});					
				
				$scope.closeZoomDialog();
				var dimYearSlider = document.getElementById('dimYear-slider');
				var leftRailYearDim;
				if($rootScope.dimensionProperties.apiDimTopics) {
					$rootScope.dimensionProperties.apiDimTopics.forEach(function(apiDimTopic) {
						apiDimTopic.dimensionGroups.forEach(function(dimensionGroup) {
							dimensionGroup.dimensions.forEach(function(dimension) {
								if(dimension.cId == $scope.zoomDimYear.qDef.cId) {
									leftRailYearDim = dimension;
								}
							});
						});
					});
				}

				var yearSliderValues = dimYearSlider.noUiSlider.get();
				yearSliderValues[0] = Math.round(yearSliderValues[0]);
				yearSliderValues[1] = Math.round(yearSliderValues[1]);

				var newSelectedValuesCount = 0;
				for(var i = 0; i < $scope.zoomDimYear.values.length; i++) {
					if(Number($scope.zoomDimYear.values[i].qText) >= Number(yearSliderValues[0])
						&& Number($scope.zoomDimYear.values[i].qText) <= Number(yearSliderValues[1])) {
						$scope.zoomDimYear.values[i].qState = 'S';
						$scope.zoomDimYear.values[i].selected = true;
						newSelectedValuesCount++;
					}
					else {
						$scope.zoomDimYear.values[i].qState = 'A';
						$scope.zoomDimYear.values[i].selected = false;
					}
				}

				var copyZoomDimYearValues = JSON.parse(JSON.stringify($scope.zoomDimYear.values))
				var copyZoomDimYearValuesReversed = copyZoomDimYearValues.sort((a, b) => (Number(a.qText) < Number(b.qText)) ? 1 : -1);

				leftRailYearDim.values = copyZoomDimYearValuesReversed;
				leftRailYearDim.selectedValuesCount = newSelectedValuesCount;

				$scope.toggleReadOnly(true);
				hyperCubeProperties.updateFilterValueSingleList(appObj, $rootScope, $scope, leftRailYearDim, false).then(function (action) {
					$scope.toggleReadOnly(false);
				}, function (err) {
					appUtilities.showError(err);
				});

				if($scope.measureSliderChanged) {
					$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
						obj.getProperties().then(function(props) {
							// if(props.visualization === 'barchart') {
								props.measureAxis.autoMinMax = false;
								props.measureAxis.minMax = "minMax";
								var measureSliderValues = $scope.measureSlider.noUiSlider.get();
								props.measureAxis.min = Math.round(measureSliderValues[0]);
								props.measureAxis.max = Math.round(measureSliderValues[1]);
								$scope.measureSliderApplied = true;
							// }

							obj.setProperties(props).then(function() {
							},function(err) {
								console.log(err);
							});

						});
					});
				}

			}

			function initializeMeasureSlider(chart) {
				return new qlik.Promise(function (resolve, reject) {
					// Measure Implementation
					$scope.measureSlider = document.getElementById('measure-slider');
					var measureInput0 = document.getElementById('measure-input-with-keypress-0');
					var measureInput1 = document.getElementById('measure-input-with-keypress-1');
					var measureInputs = [measureInput0, measureInput1];
					// The density value controls how many pips are placed on one percent of the slider range.
					// With the default value of 1, there is one pip per percent. For a value of 2, a pip is placed for every 2 percent.
					var measureDensity = 2;

					var measureStart = {};
					// The range contains percentages (location across the slider) for each year value. We need to calculate a percentage across for all Year values.
					// Our formula to calculate these range percentages is: (index of the Year value in the list of values) * (density)
					var measureRange = {};
					// the measureAxis has already been changed, get values from the measureAxis xxx
					if($rootScope.chart.measureAxis.autoMinMax == false) {
						measureRange.min = $rootScope.chart.rangeMin;
						measureRange.max = $rootScope.chart.rangeMax;
						measureStart.min = $rootScope.chart.measureAxis.min;
						measureStart.max = $rootScope.chart.measureAxis.max;
					}
					else {
						measureRange.min = $rootScope.chart.rangeMin;
						measureRange.max = $rootScope.chart.rangeMax;
						measureStart.min = 0;
						measureStart.max = $rootScope.chart.rangeMax;
					}

					// determine each snap point - no need for this when using stepSize
					// for (let i = 1; i < $rootScope.chart.rangeMax.length - 1; i++) {
					// 	eval('measureRange[\'' + Math.round(((i * measureDensity) + Number.EPSILON) * 100) / 100 + '%\']' + ' = [' + $scope.zoomDimYear.values[i].qText + ']' );
					// }

					// Our formula for step size is 10^(number digits in the max value of the measure - 2)
					$scope.stepSize = Math.pow(10, ($rootScope.chart.rangeMax.toString().length-2));

					// destroy
					if($scope.measureSlider.noUiSlider) {
						$scope.measureSlider.noUiSlider.destroy();
					}

					noUiSlider.create($scope.measureSlider, {
						connect: true,
						start: [measureStart.min, measureStart.max],
						step: $scope.stepSize,
						pips: {
							mode: 'steps',
							density: measureDensity,
							filter: filterMeasurePips,
							format: wNumb({
								decimals: 0,
							})
						},
						range: {
							'min': [measureRange.min],
							'max': [measureRange.max]
						},
						animate: false
					});

					setHumanReadableMsrLabels(measureRange);

					$scope.measureSlider.noUiSlider.on('update', function (values, handle) {
                        console.log('m', Math.round(values[handle]));
						$('#measure-input-with-keypress-' + handle).val(Math.round(values[handle]));
                        //dimYearInputs[handle].value = Math.round(values[handle]);
						$scope.measureSliderChanged = true;
					});

					// Listen to keydown events on the input field.
					measureInputs.forEach(function (input, handle) {

						input.addEventListener('change', function () {
                            //this.value = this.value - 200;
							$scope.measureSlider.noUiSlider.setHandle(handle, this.value);
						});

						input.addEventListener('keydown', function (e) {

							var values = $scope.measureSlider.noUiSlider.get();
							var value = Number(values[handle]);

							// [[handle0_down, handle0_up], [handle1_down, handle1_up]]
							var steps = $scope.measureSlider.noUiSlider.steps();

							// [down, up]
							var step = steps[handle];

							var position;

							// 13 is enter,
							// 38 is key up,
							// 40 is key down.
							switch (e.which) {

								case 13:
									$scope.measureSlider.noUiSlider.setHandle(handle, this.value);
									break;

								case 38:

									// Get step to go increase slider value (up)
									position = step[1];

									// false = no step is set
									if (position === false) {
										position = 1;
									}

									// null = edge of slider
									if (position !== null) {
										$scope.measureSlider.noUiSlider.setHandle(handle, value + position);
									}

									break;

								case 40:

									position = step[0];

									if (position === false) {
										position = 1;
									}

									if (position !== null) {
										$scope.measureSlider.noUiSlider.setHandle(handle, value - position);
									}

									break;
							}
						});
					});

					// disable the measure slider if needed
					if($scope.measureSliderDisabled) {
						$scope.measureSlider.setAttribute('disabled', true);
					}
					else {
						$scope.measureSlider.removeAttribute('disabled');
					}

				})
			};

			function initializeDimYearSlider(zoomDimYear) {
				return new qlik.Promise(function (resolve, reject) {
					// Dim Year Implementation
					var dimYearSlider = document.getElementById('dimYear-slider');
					var dimYearInput0 = document.getElementById('dimYear-input-with-keypress-0');
					var dimYearInput1 = document.getElementById('dimYear-input-with-keypress-1');
					var dimYearInputs = [dimYearInput0, dimYearInput1];
					// The density value controls how many pips are placed on one percent of the slider range.
					// With the default value of 1, there is one pip per percent. For a value of 2, a pip is placed for every 2 percent.
					// Our formula to calculate density for the Year dimension is: (100) / (total number of years - 1)
					var dimYearDensity = 100 / ($scope.zoomDimYear.values.length - 1);

					// The range contains percentages (location across the slider) for each year value. We need to calculate a percentage across for all Year values.
					// Our formula to calculate these range percentages is: (index of the Year value in the list of values) * (density)
					var dimYearRange = {};
					dimYearRange.min = [ Number($scope.zoomDimYear.values[0].qText) ];
					dimYearRange.max = [ Number($scope.zoomDimYear.values[$scope.zoomDimYear.values.length-1].qText) ];
					var dimYearsSelectedCount = 0;
					for (let i = 1; i < $scope.zoomDimYear.values.length - 1; i++) {
						eval('dimYearRange[\'' + Math.round(((i * dimYearDensity) + Number.EPSILON) * 100) / 100 + '%\']' + ' = [' + $scope.zoomDimYear.values[i].qText + ']' );
					}

					// selected min/max
					var minSelectedYear;
					var maxSelectedYear;
					for (let i = 0; i < $scope.zoomDimYear.values.length; i++) {
						// set min year
						if(!minSelectedYear) {
							if($scope.zoomDimYear.values[i].qState == 'S'
								|| $scope.zoomDimYear.values[i].qState == 'O') {
								minSelectedYear = Number($scope.zoomDimYear.values[i].qText);
							}
						}
						// set max year
						else {
							if($scope.zoomDimYear.values[i].qState == 'S') {
								maxSelectedYear = Number($scope.zoomDimYear.values[i].qText);

								// disable if years are not continuous 
								if($scope.zoomDimYear.values[i-1].qState == 'A') {
									$scope.dimYearSliderDisabled = true;
								}
							}
						}

						// disable year silder if only 1 year is selected
						if($scope.zoomDimYear.values[i].qState == 'S'
							|| $scope.zoomDimYear.values[i].qState == 'O') {
							dimYearsSelectedCount++;
						}
					}
					// CB - Zoom feature - Zoom slider when only 1 year is selected on line chart / https://jira.nsf.gov/browse/NDT-7316
					if(maxSelectedYear == undefined) {
						maxSelectedYear = minSelectedYear;
					}
					// disable year silder if only 1 year is selected
					if(dimYearsSelectedCount <= 1) {
						$scope.dimYearSliderDisabled = true;
					}

					if(dimYearSlider.noUiSlider) {
						dimYearSlider.noUiSlider.set([minSelectedYear, maxSelectedYear]);
					}
					else {
						noUiSlider.create(dimYearSlider, {
							connect: true,
							start: [minSelectedYear, maxSelectedYear],
							pips: {
								mode: 'steps',
								density: dimYearDensity,
								filter: filterPips,
								format: wNumb({
									decimals: 0,
								})
							},
							snap: true,
							range: dimYearRange,
							animate: false
						});

						dimYearSlider.noUiSlider.on('update', function (values, handle) {
							dimYearInputs[handle].value = Math.round(values[handle]);
						});

						// Listen to keydown events on the input field.
						dimYearInputs.forEach(function (input, handle) {

							input.addEventListener('change', function () {
								dimYearSlider.noUiSlider.setHandle(handle, this.value);
							});

							input.addEventListener('keydown', function (e) {

								var values = dimYearSlider.noUiSlider.get();
								var value = Number(values[handle]);

								// [[handle0_down, handle0_up], [handle1_down, handle1_up]]
								var steps = dimYearSlider.noUiSlider.steps();

								// [down, up]
								var step = steps[handle];

								var position;

								// 13 is enter,
								// 38 is key up,
								// 40 is key down.
								switch (e.which) {

									case 13:
										dimYearSlider.noUiSlider.setHandle(handle, this.value);
										break;

									case 38:

										// Get step to go increase slider value (up)
										position = step[1];

										// false = no step is set
										if (position === false) {
											position = 1;
										}

										// null = edge of slider
										if (position !== null) {
											dimYearSlider.noUiSlider.setHandle(handle, value + position);
										}

										break;

									case 40:

										position = step[0];

										if (position === false) {
											position = 1;
										}

										if (position !== null) {
											dimYearSlider.noUiSlider.setHandle(handle, value - position);
										}

										break;
								}
							});
						});
					}

					// disable the year slider if needed
					if($scope.dimYearSliderDisabled) {
						dimYearSlider.setAttribute('disabled', true);
					}
					else {
						dimYearSlider.removeAttribute('disabled');
					}

				})
			};

			$scope.$on('resetZoomEvent', function () {
				$scope.btnResetZoom();
			});			

			$scope.btnResetZoom = function() {
				$scope.closeZoomDialog();
				
				var dimYearSlider = document.getElementById('dimYear-slider');

				$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
					obj.getProperties().then(function(props) {
						var msr = measures.getMeasureByCid($rootScope, props.qHyperCubeDef.qMeasures[0].qDef.cId);
						var def = msr.def; //props.qHyperCubeDef.qMeasures[0].qDef.qDef;
						if(props.visualization === 'linechart') {
							// reset measure axis
							props.measureAxis.autoMinMax = true;
							props.measureAxis.minMax = "min";
							props.measureAxis.min = 0;
							props.measureAxis.max = 10;

							// reset dimension year axis
							var leftRailYearDim;
							if($rootScope.dimensionProperties.apiDimTopics) {
								$rootScope.dimensionProperties.apiDimTopics.forEach(function(apiDimTopic) {
									apiDimTopic.dimensionGroups.forEach(function(dimensionGroup) {
										dimensionGroup.dimensions.forEach(function(dimension) {
											if(dimension.cId == $scope.zoomDimYear.qDef.cId) {
												leftRailYearDim = dimension;
											}
										});
									});
								});
							}

							var newSelectedValuesCount = 0;
							for(var i = 0; i < $scope.zoomDimYear.values.length; i++) {
								$scope.zoomDimYear.values[i].qState = 'S';
								$scope.zoomDimYear.values[i].selected = true;
								newSelectedValuesCount++;
							}

							var copyZoomDimYearValues = JSON.parse(JSON.stringify($scope.zoomDimYear.values))
							var copyZoomDimYearValuesReversed = copyZoomDimYearValues.sort((a, b) => (Number(a.qText) < Number(b.qText)) ? 1 : -1);

							leftRailYearDim.values = copyZoomDimYearValuesReversed;
							leftRailYearDim.selectedValuesCount = newSelectedValuesCount;

							$scope.toggleReadOnly(true);
							hyperCubeProperties.updateFilterValueSingleList(appObj, $rootScope, $scope, leftRailYearDim, false).then(function (action) {
								dimYearSlider.noUiSlider.set([$scope.zoomDimYear.values[0].qText, $scope.zoomDimYear.values[$scope.zoomDimYear.values.length - 1].qText]);
								$scope.toggleReadOnly(false);

								$scope.measureSlider.noUiSlider.set([$rootScope.chart.rangeMinInit, $rootScope.chart.rangeMaxInit]);

							}, function (err) {
								appUtilities.showError(err);
							});
						}
						else if(props.visualization === 'barchart') {
							// reset measure axis only
							props.measureAxis.autoMinMax = true;
							props.measureAxis.minMax = "min";
							props.measureAxis.min = 0;
							props.measureAxis.max = 10;

							// reset dimension year axis
							var leftRailYearDim;
							if($rootScope.dimensionProperties.apiDimTopics) {
								$rootScope.dimensionProperties.apiDimTopics.forEach(function(apiDimTopic) {
									apiDimTopic.dimensionGroups.forEach(function(dimensionGroup) {
										dimensionGroup.dimensions.forEach(function(dimension) {
											if(dimension.cId == $scope.zoomDimYear.qDef.cId) {
												leftRailYearDim = dimension;
											}
										});
									});
								});
							}

							var newSelectedValuesCount = 0;
							for(var i = 0; i < $scope.zoomDimYear.values.length; i++) {
								$scope.zoomDimYear.values[i].qState = 'A';
								$scope.zoomDimYear.values[i].selected = false;
								newSelectedValuesCount++;
							}
							$scope.zoomDimYear.values[$scope.zoomDimYear.values.length-1].qState = 'S';
							$scope.zoomDimYear.values[$scope.zoomDimYear.values.length-1].selected = true;
							newSelectedValuesCount = 1

							var copyZoomDimYearValues = JSON.parse(JSON.stringify($scope.zoomDimYear.values))
							var copyZoomDimYearValuesReversed = copyZoomDimYearValues.sort((a, b) => (Number(a.qText) < Number(b.qText)) ? 1 : -1);

							leftRailYearDim.values = copyZoomDimYearValuesReversed;
							leftRailYearDim.selectedValuesCount = newSelectedValuesCount;

							$scope.toggleReadOnly(true);
							hyperCubeProperties.updateFilterValueSingleList(appObj, $rootScope, $scope, leftRailYearDim, false).then(function (action) {
								$scope.toggleReadOnly(false);
							}, function (err) {
								appUtilities.showError(err);
							});
						}

						obj.setProperties(props).then(function() {
							$scope.measureSlider.noUiSlider.set([$rootScope.chart.rangeMinInit, $rootScope.chart.rangeMaxInit]);
						},function(err) {
							console.log(err);
						});

					});
				});			
			}

			function renderList(shortName) {
				return new qlik.Promise(function (resolve, reject) {
					var dim = {};
					dim.shortName = shortName;
					var list = [];
					list = dimensions.getValuesByDimension(appObj, dim, null, null, 0).then(function (values) {
						return resolve(values);
					});
				})
			};

			function filterMeasurePips(value, type) {
				var divideByN = Math.pow(10, (Number($rootScope.chart.rangeMax.toString().length) - 1));
				var isDivisibleByN = value % divideByN ? 0 : 1;
				if(isDivisibleByN) {
					// do not show second to last pip (large tick), the text sometimes overlaps the last pip text
					if(value > ($rootScope.chart.rangeMax - divideByN) ) {
						return 0;
					}
					else {
						return 1;
					}
				}
				if(value == $rootScope.chart.rangeMax) {
					return 1;
				}
				else {
					return 0;
				}
			}

			function filterPips(value, type) {
				if(value == Number($scope.zoomDimYear.values[0].qText)) {
					return 1;
				}
                //If the last year in range is always displayed then the last year label can overlay the 10 year label resulting in unreadable text
/* 				else if(value == Number($scope.zoomDimYear.values[$scope.zoomDimYear.values.length-1].qText)) {
					return 1;
				} */
				else {
					// every half decade
					if($scope.zoomDimYear.values.length <=40) {
						var isDivisibleBy5 = value % 5 ? 0 : 1;
						if(isDivisibleBy5) {
							if(value - Number($scope.zoomDimYear.values[0].qText) >= 3) {
								return 1
							}
							else {
								return 0;
							}
						}
						else {
							return 0;
						}
					}
					// every decade
					else {
						var isDivisibleBy10 = value % 10 ? 0 : 1;
						if(isDivisibleBy10) {
							if(value - Number($scope.zoomDimYear.values[0].qText) >= 4) {
								return 1
							}
							else {
								return 0;
							}
						}
						else {
							return 0;
						}
					}
				}
			}

			function setHumanReadableMsrLabels(measureRange) {
				var formatPips = $("#measure-slider > div.noUi-pips.noUi-pips-horizontal").children();
					for(var i = 0; i < formatPips.length; i++) {
						if(formatPips[i].classList[0] == 'noUi-value') {
							var numDigits = formatPips[i].innerText.length;
							if(formatPips[i].innerText != measureRange.min
								&& formatPips[i].innerText != measureRange.max) {
								if(numDigits >= 4 && numDigits <= 6) {
									formatPips[i].innerText = (Number(formatPips[i].innerText) / 1000) + 'K';
								}
								else if(numDigits >= 7 && numDigits <= 9) {
									formatPips[i].innerText = (Number(formatPips[i].innerText) / 1000000) + 'M';
								}
								else if(numDigits >= 10 && numDigits <= 12) {
									formatPips[i].innerText = (Number(formatPips[i].innerText) / 1000000000) + 'B';
								}
								else if(numDigits >= 13 && numDigits <= 15) {
									formatPips[i].innerText = (Number(formatPips[i].innerText) / 1000000000000) + 'T';
								}
							}
							else if(formatPips[i].innerText == measureRange.max) {
								if(numDigits >= 4 && numDigits <= 6) {
									formatPips[i].innerText = (Number(formatPips[i].innerText) / 1000).toFixed(1) + 'K';
								}
								else if(numDigits >= 7 && numDigits <= 9) {
									formatPips[i].innerText = (Number(formatPips[i].innerText) / 1000000).toFixed(1) + 'M';
								}
								else if(numDigits >= 10 && numDigits <= 12) {
									formatPips[i].innerText = (Number(formatPips[i].innerText) / 1000000000).toFixed(1) + 'B';
								}
								else if(numDigits >= 13 && numDigits <= 15) {
									formatPips[i].innerText = (Number(formatPips[i].innerText) / 1000000000000).toFixed(1) + 'T';
								}
							}
						}
					}
			}

			$scope.$on('openZoomDialogEvent', function() {
				openZoomDialog();
			})
				
			function openZoomDialog() {
				$("#modal-zoom").modal('show');
			}

			$scope.closeZoomDialog = function() {
				$("#modal-zoom").modal('hide');
			}

			$scope.clickZoom = function () {
				$('#modal-zoom').modal('toggle');
			}

		}
	]);
});



'use strict'

define('scripts/directives/chartSubMenuDataPointsDirective',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		"scripts/shared/measures", "scripts/shared/dimensions"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtChartSubMenuDataPoints", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtChartSubMenuDataPoints.html',
			scope: true,
			controller: 'ChartSubMenuDataPointsController'
		};
	});

	angular.module("appModule").controller("ChartSubMenuDataPointsController", ["$scope", "$rootScope", "$q", "$location", "$http",
			function ($scope, $rootScope, $q, $location, $http) {

				$('.dropdown-menu.chart-datapoints').on("click.bs.dropdown", function (e) {
					if (e.target.id != "idDataPointSave" && e.target.id != "idDataPointClose") {
						e.stopPropagation();
						//e.preventDefault();
					}
				});

				$scope.btnChartSubMenuDataPoints = function () {

					$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
						if (obj.layout.dataPoint != null) {
							$rootScope.chart.dpShow = obj.layout.dataPoint.show;
							$rootScope.chart.dpShowLabels = obj.layout.dataPoint.showLabels;
							// $rootScope.chart.dpShowSegmentLabels = obj.layout.dataPoint.showSegmentLabels;
							// $rootScope.chart.dpShowTotalLabels = obj.layout.dataPoint.showTotalLabels;
						}
					});
				}

				$scope.btnUpdateDataPoints = function () {
					gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-')  + $rootScope.survey.abbreviation + '-Apply Data Markers', {
						'event_label': 'apply',
						'event_category': 'data_markers'
					});	
					$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
						obj.getEffectiveProperties().then(function (props) {
							props.dataPoint.show = $rootScope.chart.dpShow;
							props.dataPoint.showLabels = $rootScope.chart.dpShowLabels;

							//Enable to show Bar Chart segment percentages
							props.dataPoint.showSegmentLabels = $rootScope.chart.dpShowLabels;
							props.dataPoint.showTotalLabels = $rootScope.chart.dpShowLabels;

							obj.setProperties(props).then(function () {
							}, function (err) {
								console.log(err);
							});

						});
					});
				}
			}
		]);
});

'use strict'

define('scripts/directives/tableToChartDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions", "scripts/shared/recodes"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, recodes) {

	angular.module("appModule").directive("dtTableToChart", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtTableToChart.html',
		scope: false,
		controller: 'TableToChartController'
	  };
	});


	angular.module("appModule").controller("TableToChartController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {
			var appObj = $rootScope.qApp;
			var jsonObj;
			var instSelectedSubFiltersMap = new Map();
			var fieldsOfStudyShortNames = ['fieldBroad', '=fieldBroad', 'fieldDetailed', "=typRDRDPlnt", "typRDRDPlnt"];
			var instNameShortNames = ['instName'];
			var excludeShortNames = [];
			//excludeShortNames array of fields that already contain values, so don't need to retrieve
			excludeShortNames = excludeShortNames.concat(instNameShortNames, fieldsOfStudyShortNames);

			$('#ddTableToChart').on('show.bs.modal', function (e) {
				$scope.onInitalPage = true;

				// buildDownloadPropertiesJSON().then(function (obj) {
				// 	jsonObj = obj;
				// });

				$scope.tableToChartModel = {};

				$scope.allShortNamesByCID = populateAllShortNamesByCID();

				$scope.tableToChartModel.sourceApp = $rootScope.displayVisType;
				$scope.lineChartOptionDisabled = false;
				$scope.barChartStyleDisabled = true;
				if($scope.tableToChartModel.sourceApp == "pivot-table") {
					if($rootScope.survey.abbreviation == 'NSCG' || $rootScope.survey.abbreviation == 'NTEWS') {		
						$scope.tableToChartModel.chartType = "Bar Chart";
						$scope.lineChartOptionDisabled = true;
						$scope.barChartStyleDisabled = false;
						//$scope.barChartClicked({});
					}
					else {
						$scope.tableToChartModel.chartType = "Line Chart";
					}
					$scope.barChartStyles = [
						{ displayText: 'Vertical Cluster', value: 'v-grouped' },
						{ displayText: 'Vertical Stacked', value: 'v-stacked' },
						{ displayText: 'Horizontal Cluster', value: 'h-grouped' },
						{ displayText: 'Horizontal Stacked', value: 'h-stacked' }
					];
					$scope.tableToChartModel.barChartStyle = $scope.barChartStyles[0];
				} else {
					$scope.tableToChartModel.chartType = "";
				}
				$scope.selectedConversionPrimaryDimension;
				delete $scope.selectedConversionPrimaryDimension;
				$scope.selectedConversionPrimaryDimension;
				delete $scope.selectedConversionLineDimension;
				$scope.selectedConversionLineDimension;
				$scope.conversionLineDimensionDisabled = false;
				$scope.tableToChartModel.hierDimTitles = new Map();

				$scope.tableToChartModel.filteredBy = [];

				$scope.tableToChartModel.allRecodesByCID = [];
				findAllRecodes();
				$scope.getAxisProperties();

			})

			$scope.getAxisProperties = function () {
				
				$scope.conversionMeasures = [];
				$rootScope.measureProperties.apiMeasureTopics.forEach(function(topic) {
					topic.measureGroups.forEach(function(grp) {
						grp.measures.forEach(function(msr) {
							if(msr.selected) {
								$scope.conversionMeasures.push(msr);
								if($rootScope.displayVisType != 'pivot-table' || $scope.conversionMeasures.length == 1) {
									$scope.tableToChartModel.conversionMeasure = msr;
								}
							}
						})
					})
				})	

				$scope.conversionPrimaryDimensions = [];
				$scope.conversionLineDimensions = [];
				$rootScope.dimensionProperties.apiDimTopics.forEach(function(topic) {
					topic.dimensionGroups.forEach(function(grp) {
						grp.dimensions.forEach(function(dim) {
							if(dim.selected) {
								dim.label = dim.title
								if (dim.shortName.toLowerCase() == "year" ||
									dim.shortName.toLowerCase() == "refyr") {
									$scope.conversionPrimaryDimensions.push(dim);
									$scope.selectedConversionPrimaryDimension = dim;
								} else {
									if(dim.hierarchyAvailable == "Y" && dim.selected) {
										$scope.tableToChartModel.hierDimTitles.set(dim.title, dim)
										dim.savedDims.forEach(function(branch) {
											if(branch.selected) {
												branch.label = branch.title
												$scope.conversionLineDimensions.push(branch);
											}
										})
									} else {
										$scope.conversionLineDimensions.push(dim);
									}
								}
								

							}	
							if(dim.recodes) {
								dim.recodes.forEach(function(recode) {
									if(recode.selected) {
										recode.label = recode.recodeName;
										$scope.conversionLineDimensions.push(recode);
									}
								})
							}
							if(dim.commonRecodes) {
								dim.commonRecodes.forEach(function(recode) {
									if(recode.selected) {
										recode.label = recode.recodeName;
										$scope.conversionLineDimensions.push(recode);
									}
								})
							}
							if(dim.recodeTrees) {
								dim.recodeTrees.forEach(function(tree) {
									if(tree.selected) {
										//tree.label = tree.treeName;
										//$scope.conversionLineDimensions.push(tree);
										tree.dimensions.forEach(function(branch) {
											if(branch.selected) {
												if(branch.type == "recode") {
													branch.label = branch.recodeName
												} else {
													branch.label = branch.title
												}
												branch.treeName = tree.treeName
												$scope.conversionLineDimensions.push(branch);
											}
										})
									}
								})
							}
							if(dim.commonRecodeTrees) {
								dim.commonRecodeTrees.forEach(function(tree) {
									if(tree.selected) {
										//tree.label = tree.treeName;
										//$scope.conversionLineDimensions.push(tree);
										tree.dimensions.forEach(function(branch) {
											if(branch.selected) {
												if(branch.type == "recode") {
													branch.label = branch.recodeName
												} else {
													branch.label = branch.title
												}
												branch.treeName = tree.treeName
												$scope.conversionLineDimensions.push(branch);
											}
										})
									}
								})
							}
						})
					})
				})
				// auto-select first
				$scope.selectedConversionLineDimension = $scope.conversionLineDimensions[0];
				addShortNamesFromHier();
				$scope.tableToChartModel.recodedDims = recodes.saveRecodes($rootScope);			
			};

			$scope.openTableToChartDialog = function() {
				$("#ddTableToChart").modal('show');
			}

			$scope.closeTableToChartDialog = function() {
				$("#ddTableToChart").modal('hide');
			}

			$scope.lineChartClicked = function(evt) {
				$scope.strErrMsg = null;
				$scope.barChartStyleDisabled = true;
				$scope.tableToChartModel.barChartStyle = $scope.barChartStyles[0];
			}

			$scope.barChartClicked = function(evt) {
				$scope.strErrMsg = null;
				$scope.barChartStyleDisabled = false;

				if($scope.tableToChartModel.chartType == "Bar Chart" &&
					($scope.tableToChartModel.barChartStyle.value == 'v-stacked' ||
					$scope.tableToChartModel.barChartStyle.value == 'h-stacked')) {
					if($scope.selectedConversionLineDimension == null) {
						$scope.strErrMsg = "You must select a Series Group dimension for a stacked bar chart";
						return;
					}
				}
				if($scope.selectedConversionLineDimension != null && $scope.selectedConversionPrimaryDimension.cId == $scope.selectedConversionLineDimension.cId) {
					$scope.strErrMsg = "Cannot have the same dimension selected."
					return;
				}

				// remove stacked barchart style options if Year is the only option
				if($scope.conversionLineDimensions.length < 1) {
					$scope.barChartStyles = [
						{ displayText: 'Vertical Cluster', value: 'v-grouped' },
						{ displayText: 'Horizontal Cluster', value: 'h-grouped' },
					];
				}
				else {
					$scope.barChartStyles = [
						{ displayText: 'Vertical Cluster', value: 'v-grouped' },
						{ displayText: 'Vertical Stacked', value: 'v-stacked' },
						{ displayText: 'Horizontal Cluster', value: 'h-grouped' },
						{ displayText: 'Horizontal Stacked', value: 'h-stacked' }
					];
				}
			}

			$scope.clickBarChartStyles = function(evt) {
				$scope.strErrMsg = null;
				if($scope.tableToChartModel.chartType == "Bar Chart" &&
					($scope.tableToChartModel.barChartStyle.value == 'v-stacked' ||
					$scope.tableToChartModel.barChartStyle.value == 'h-stacked')) {
					if($scope.selectedConversionLineDimension == null) {
						$scope.strErrMsg = "You must select a Series Group dimension for a stacked bar chart";
						return;
					}
				}
				if($scope.selectedConversionLineDimension != null && $scope.selectedConversionPrimaryDimension.cId == $scope.selectedConversionLineDimension.cId) {
					$scope.strErrMsg = "Cannot have the same dimension selected."
					return;
				}
			}				

			$scope.clickSecondaryDimension = function(evt) {
				$scope.strErrMsg = null;
				if($scope.tableToChartModel.chartType == "Bar Chart" &&
					($scope.tableToChartModel.barChartStyle.value == 'v-stacked' ||
					$scope.tableToChartModel.barChartStyle.value == 'h-stacked')) {
					if($scope.selectedConversionLineDimension == null) {
						$scope.strErrMsg = "You must select a Series Group dimension for a stacked bar chart";
						return;
					}
				}
				if($scope.selectedConversionLineDimension != null && $scope.selectedConversionPrimaryDimension.cId == $scope.selectedConversionLineDimension.cId) {
					$scope.strErrMsg = "Cannot have the same dimension selected."
					return;
				}
			}

			$scope.clickConfirm = function(evt) {
				// $scope.onInitalPage = false;

				//findInstSelectedSubFilters();

				$scope.tableToChartModel.filteredBy = [];

				/*** Populate Primary Dimension ***/
				$scope.tableToChartModel.conversionPrimaryDimensionValues = new Map();
				var conversionPrimaryDimensionsShortName = $scope.allShortNamesByCID.get($scope.selectedConversionPrimaryDimension.cId);
				var conversionPrimaryDimensionsFieldLabel = $scope.selectedConversionPrimaryDimension.label;
				var primaryIsRecode = false;
				$scope.tableToChartModel.allRecodesByCID.forEach(function(recodeByCID) {
					if(recodeByCID.cId == $scope.selectedConversionPrimaryDimension.cId) {
						primaryIsRecode = true;
						conversionPrimaryDimensionsShortName = recodeByCID.recodeName;
						$scope.tableToChartModel.conversionPrimaryDimensionValues.set(conversionPrimaryDimensionsShortName, []);
					}
				});
				if(!primaryIsRecode) {
					if(!excludeShortNames.includes(conversionPrimaryDimensionsShortName)) {
						renderList($scope.selectedConversionPrimaryDimension).then(function (list) {
							if(hasFilter(list)) {
								if(!$scope.tableToChartModel.filteredBy.includes(conversionPrimaryDimensionsFieldLabel)) {
									$scope.tableToChartModel.filteredBy.push(conversionPrimaryDimensionsFieldLabel);
								}
							}

							// dimension values to be used by TB or CB when loading after hitting the Convert button
							mostRecentYear(conversionPrimaryDimensionsShortName, list);
							$scope.tableToChartModel.conversionPrimaryDimensionValues.set(conversionPrimaryDimensionsShortName, list);
						});
					}
					else {
						if(conversionPrimaryDimensionsShortName == 'instName') {
							$scope.tableToChartModel.conversionPrimaryDimensionValues.set(conversionPrimaryDimensionsShortName, $scope.selectedConversionPrimaryDimension.savedValues);
						}
						else if(fieldsOfStudyShortNames.includes(conversionPrimaryDimensionsShortName)) {
							findHierDimFilter($scope.selectedConversionPrimaryDimension, $scope.tableToChartModel.conversionPrimaryDimensionValues);
						}
					}
				}

				/** Populate Line and Secondary Line dimensions **/
				$scope.tableToChartModel.conversionLineDimensionsValuesMap = new Map();
				$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap = new Map();
				$scope.conversionLineDimensions.forEach(function(conversionLineDimension) {
					if(conversionLineDimension.cId != $scope.selectedConversionPrimaryDimension.cId) {
						var shortName = $scope.allShortNamesByCID.get(conversionLineDimension.cId);
						var lineIsRecode = false;
						$scope.tableToChartModel.allRecodesByCID.forEach(function(recodeByCID) {
							if(recodeByCID.type == 'recode' || recodeByCID.type == 'commonRecode') {
								if(recodeByCID.cId == conversionLineDimension.cId) {
									lineIsRecode = true;
									if(recodeByCID.cId == $scope.selectedConversionLineDimension.cId) {
										$scope.tableToChartModel.conversionLineDimensionsValuesMap.set(recodeByCID.label, []);
									}
									else {
										$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap.set(recodeByCID.label, []);
									}
								}
							}	else if(recodeByCID.type == 'recodeTree' || recodeByCID.type == 'commonRecodeTree') {
								for (var j=0; j < recodeByCID.dimensions.length; j++) {
									var recodeTreeDimension = recodeByCID.dimensions[j];
									if(recodeTreeDimension.cId == conversionLineDimension.cId) {
										lineIsRecode = true;
										if(recodeTreeDimension.cId == $scope.selectedConversionLineDimension.cId) {
											$scope.tableToChartModel.conversionLineDimensionsValuesMap.set(conversionLineDimension.label, []);
											findHierRecodeFilter(conversionLineDimension, recodeByCID, $scope.tableToChartModel.conversionLineDimensionsValuesMap);
										}
										else {
											$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap.set(conversionLineDimension.label, []);
											findHierRecodeFilter(conversionLineDimension, recodeByCID, $scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap);
										}
										break;
									}
								}
							}
						});
						if(!lineIsRecode) {
							if(!excludeShortNames.includes(shortName)) {
								renderList(conversionLineDimension).then(function (list) {
									// dimension values to be used by TB or CB when loading after hitting the Convert button
									mostRecentYear(shortName, list);
									if(shortName == $scope.allShortNamesByCID.get($scope.selectedConversionLineDimension.cId)) {
										$scope.tableToChartModel.conversionLineDimensionsValuesMap.set(shortName, list);
									}
									// secondary
									else {
										$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap.set(shortName, list);
									}

									if(hasFilter(list)) {
										if(!$scope.tableToChartModel.filteredBy.includes(conversionLineDimension.label)) {
											$scope.tableToChartModel.filteredBy.push(conversionLineDimension.label);
										}
									}
								});
							}
							// instName and hierarchical dimensions
							else {
								if(shortName == $scope.allShortNamesByCID.get($scope.selectedConversionLineDimension.cId)) {
									if($scope.allShortNamesByCID.get($scope.selectedConversionLineDimension.cId) == 'instName') {
										$scope.tableToChartModel.conversionLineDimensionsValuesMap.set($scope.allShortNamesByCID.get($scope.selectedConversionLineDimension.cId), $scope.selectedConversionLineDimension.savedValues);
									}
									else {
										findHierDimFilter(conversionLineDimension, $scope.tableToChartModel.conversionLineDimensionsValuesMap);
									}
								}
								// secondary
								else {
									if(shortName == 'instName') {
										$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap.set(shortName, conversionLineDimension.savedValues);
									}
									else {
										findHierDimFilter(conversionLineDimension, $scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap);
									}
								}
							}
						}
					}

				});

			}
			
			function populateAllShortNamesByCID() {
				var allShortNames = new Map();
				if($rootScope.dimensionProperties) {
					if($rootScope.dimensionProperties.apiDimTopics) {
						var allShortNames = new Map();
						$rootScope.dimensionProperties.apiDimTopics.forEach(function(apiDimTopic) {
							apiDimTopic.dimensionGroups.forEach(function(dimensionGroup) {
								dimensionGroup.dimensions.forEach(function(dimension) {
									allShortNames.set(dimension.cId, dimension.shortName);
									if(dimension.recodes && dimension.recodes.length > 0) {
										dimension.recodes.forEach(function(dimRecode) {
											if(dimRecode.selected) {
												allShortNames.set(dimRecode.cId, dimRecode.recodeName);
											}
										})
									} else if(dimension.commonRecodes && dimension.commonRecodes.length > 0) {
										dimension.commonRecodes.forEach(function(dimRecode) {
											if(dimRecode.selected) {
												allShortNames.set(dimRecode.cId, dimRecode.recodeName);
											}
										})
									}
									if(dimension.dimHier1) {
										dimension.dimHier1.forEach(function(dimHier1Dim) {
											allShortNames.set(dimHier1Dim.cId, dimHier1Dim.shortName);
											if(dimHier1Dim.dimHier2) {
												dimHier1Dim.dimHier2.forEach(function(dimHier2Dim) {
													allShortNames.set(dimHier2Dim.cId, dimHier2Dim.shortName);

													if(dimHier2Dim.dimHier3) {
														dimHier2Dim.dimHier3.forEach(function(dimHier3Dim) {
															allShortNames.set(dimHier3Dim.cId, dimHier3Dim.shortName);

															if(dimHier3Dim.dimHier4) {
																dimHier3Dim.dimHier4.forEach(function(dimHier4Dim) {
																	allShortNames.set(dimHier4Dim.cId, dimHier4Dim.shortName);
																});
															}
														});
													}
												});
											}
										});
									}
									if(dimension.recodeTrees && dimension.recodeTrees.length > 0) {
										dimension.recodeTrees.forEach(function(tree) {
											if(tree.selected) {
												tree.dimensions.forEach(function(dim) {
													if(!allShortNames.has(dim.cId) && dim.recodeName) {
														allShortNames.set(dim.cId, dim.recodeName);
													}
												})
											}
										})
									} else if(dimension.commonRecodeTrees && dimension.commonRecodeTrees.length > 0) {
										dimension.commonRecodeTrees.forEach(function(tree) {
											if(tree.selected) {
												tree.dimensions.forEach(function(dim) {
													if(!allShortNames.has(dim.cId) && dim.recodeName) {
														allShortNames.set(dim.cId, dim.recodeName);
													}
												})
											}
										})
									}
								});
							});
						});
					}
				}
				return allShortNames;
			};

			function findHierDimFilter(dim, mapOfValues) {
				let findCID = dim.cId;
				let findShortName = $scope.allShortNamesByCID.get(dim.cId);
				mapOfValues.set(findShortName, []);
				if($rootScope.dimensionProperties) {
					if($rootScope.dimensionProperties.apiDimTopics) {
						$rootScope.dimensionProperties.apiDimTopics.forEach(function(apiDimTopic) {
							apiDimTopic.dimensionGroups.forEach(function(dimensionGroup) {
								dimensionGroup.dimensions.forEach(function(dimension) {
									var savedList = dimension.savedList;
									if(savedList && savedList.length > 0) {
/* 										savedList.forEach(function(savedListValue) {
											if(savedListValue.selected) {
												savedListValue.class = 's';
											}
										}); */

										if(dimension.dimHier1) {
											dimension.dimHier1.forEach(function(dimHier1Dim) {
												if(dimHier1Dim.cId == findCID) {
													if(dimension.savedList.length > dimension.selectedValuesCount) {
														if(!$scope.tableToChartModel.filteredBy.includes(dimension.title)) {
															$scope.tableToChartModel.filteredBy.push(dimension.title);
														}
													}

													var sValues = savedList.filter(function (value) {
														return value.shortName == findShortName && value.selected;
													});
													mapOfValues.set(findShortName, sValues);
													$scope.tableToChartModel.hierDimTitles.set(findShortName, {title: dimension.title, selectedValuesCount: dimension.selectedValuesCount, savedList: dimension.savedList});
													return dimension;
												}
												if(dimHier1Dim.dimHier2) {
													dimHier1Dim.dimHier2.forEach(function(dimHier2Dim) {
														if(dimHier2Dim.cId == findCID) {
															var sValues = savedList.filter(function (value) {
																return value.shortName == findShortName && value.selected;
															});
															mapOfValues.set(findShortName, sValues);
															$scope.tableToChartModel.hierDimTitles.set(findShortName, {title: dimension.title, selectedValuesCount: dimension.selectedValuesCount, savedList: dimension.savedList});
															return dimension;
														}
														if(dimHier2Dim.dimHier3) {
															dimHier2Dim.dimHier3.forEach(function(dimHier3Dim) {
																if(dimHier3Dim.cId == findCID) {
																	var sValues = savedList.filter(function (value) {
																		return value.shortName == findShortName && value.selected;
																	});
																	mapOfValues.set(findShortName, sValues);
																	$scope.tableToChartModel.hierDimTitles.set(findShortName, {title: dimension.title, selectedValuesCount: dimension.selectedValuesCount, savedList: dimension.savedList});
																	return dimension;
																}

																if(dimHier3Dim.dimHier4) {
																	dimHier3Dim.dimHier4.forEach(function(dimHier4Dim) {
																		if(dimHier4Dim.cId == findCID) {
																			var sValues = savedList.filter(function (value) {
																				return value.shortName == findShortName && value.selected;
																			});
																			mapOfValues.set(findShortName, sValues);
																			$scope.tableToChartModel.hierDimTitles.set(findShortName, {title: dimension.title, selectedValuesCount: dimension.selectedValuesCount, savedList: dimension.savedList});
																			return dimension;
																		}
																	});
																}
															});
														}
													});
												}
											});
										}
									}
								});
							});
						});
					}
				}
			};

			function findHierRecodeFilter(recode, tree, mapOfValues) {
				mapOfValues.set(recode.label, []);
				
				for(x =0; x< tree.dimensions.length; x++) {
					if(recode.cId == tree.dimensions[x].cId) {
						if(tree.savedList && tree.savedList.length > 0) {
/* 							tree.savedList.forEach(function(savedListValue) {
								if(savedListValue.selected) {
									savedListValue.class = 's';
								}
							}); */
							
							if(tree.selected) {
								if(!$scope.tableToChartModel.filteredBy.includes(tree.treeName)) {
									$scope.tableToChartModel.filteredBy.push(tree.treeName);
								}
							}													
							var sValues = tree.savedList.filter(function (value) {
								return value.shortName == recode.shortName && value.selected;
							});
							mapOfValues.set(recode.label, sValues);
							//tree.rootTitle
							$scope.tableToChartModel.hierDimTitles.set(recode.shortName, {recodeName: recode.recodeName, title: recode.title, selectedValuesCount: tree.selectedValuesCount, savedList: tree.savedList});
							return recode;
						}
					}
				}
			};

			$scope.clickBack = function(evt) {
				$scope.onInitalPage = true;
			}

			function renderList(dim) {
				return new qlik.Promise(function (resolve, reject) {
					$rootScope.leftRail.card2.dim = {};
					$rootScope.leftRail.card2.dim.shortName = dim.shortName;
					var list = [];
					list = dimensions.getValuesByDimension(appObj, dim, null, null, 0).then(function (values) {
						return resolve(values);
					});
				})
			};

			function findInstSelectedSubFilters() {
				return new qlik.Promise(function (resolve, reject) {
					instSelectedSubFiltersMap = new Map();
					$scope.instDimDropDowns.forEach(function (instDimDropDown) {
						renderInstSelectedSubFilterList(instSelectedSubFiltersMap, instDimDropDown.shortName).then(function () {
							return resolve();
						});
					});
				});
			};

			function renderInstSelectedSubFilterList(map, subFilterShortName) {
				return new qlik.Promise(function (resolve, reject) {
					var fields = [];
					var startRow = 0;

					getListPage(startRow, map, subFilterShortName).then(function () {
						return resolve();
					});

					function getListPage(startRow, map, subFilterShortName) {
						return new qlik.Promise(function (resolve, reject) {
							var dim = dimensions.getDimensionByName($rootScope, subFilterShortName);
							dimensions.getValuesByDimension(appObj, dim, null, 'altState1', 0).then(function (values) {
								var subFilterValues = []
								values.forEach(function (e) {
									if (e.qState == "S") {
										subFilterValues.push(e);
										
									}
								});
								map.set(subFilterShortName, subFilterValues);
								return resolve(map);
							});
						});
					}
				})

			};

			function hasFilter(list) {
				var sValues = list.filter(function (value) {
					return value.qState == 'S';
				});
				if(sValues.length < list.length) {
					return true;
				}
				else {
					return false;
				}
			};

/* 			function findInstitutionNamefilter() {
				var dimInstNameValues = {};
				if($rootScope.dimensionProperties) {
					if($rootScope.dimensionProperties.apiDimTopics) {
						var institutionNameTopic = $rootScope.dimensionProperties.apiDimTopics.filter(function (value) {
							return value.topicName == 'Institution Name';
						});
						if(institutionNameTopic && institutionNameTopic.length == 1) {
							var institutionNameTopic = institutionNameTopic[0];
							if(institutionNameTopic.dimensionGroups && institutionNameTopic.dimensionGroups.length > 0) {
								var dimensionGroup = institutionNameTopic.dimensionGroups[0];
								if(dimensionGroup.dimensions && dimensionGroup.dimensions.length > 0) {
									var instNameDimension = dimensionGroup.dimensions.filter(function (value) {
										return value.def == 'instName';
									});
									// determine if there is a filter
									if(instNameDimension && instNameDimension.length > 0) {
										instNameDimension = instNameDimension[0];
										dimInstNameValues = {shortName: instNameDimension.def, values: $scope.selectedInstValues};
										if(instNameDimension.selectedValuesCount < instNameDimension.totalValuesCount) {
											if(!$scope.tableToChartModel.filteredBy.includes(instNameDimension.title)) {
											$scope.tableToChartModel.filteredBy.push(instNameDimension.title);
										}
									}
										// return values
										return dimInstNameValues;
									}
								}
							}
						}
					}
				}
			}; */

		$scope.clickConvert = function(evt) {
			$scope.tableToChartModel.expired = false;
			gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-') + $rootScope.survey.abbreviation + '-Convert to ' + ($rootScope.displayVisType == 'pivot-table' ? 'Chart':'Table'), {
				'event_label': 'select',
				'event_category': 'convert_visual'
			});
			$scope.tableToChartModel.apiMeasureTopics = $rootScope.measureProperties.apiMeasureTopics;
			$scope.tableToChartModel.apiDimTopics = $rootScope.dimensionProperties.apiDimTopics;
			$scope.tableToChartModel.selectedInstValues = [];
			$scope.conversionLineDimensions.forEach(function(item) {
				if(item.shortName == "instName" && item.cId != $scope.selectedConversionLineDimension.cId) {
					$scope.tableToChartModel.selectedInstValues = item.savedValues;
				}
			})
			//conversionLineDimensionsSecondaryValuesMap
			//$scope.tableToChartModel.selectedInstValues = $scope.selectedInstValues;
			$scope.tableToChartModel.instSelectedSubFiltersMap = Object.fromEntries(instSelectedSubFiltersMap);
			if($scope.tableToChartModel.conversionPrimaryDimensionValues) {
				for(const [key, value] of $scope.tableToChartModel.conversionPrimaryDimensionValues) {
					$scope.tableToChartModel.conversionPrimaryDimensionValues = {shortName: key, values: value};
				}
			}
			$scope.tableToChartModel.conversionLineDimensionsValuesMap = Object.fromEntries($scope.tableToChartModel.conversionLineDimensionsValuesMap);
			$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap = Object.fromEntries($scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap);
			$scope.tableToChartModel.hierDimTitles = Object.fromEntries($scope.tableToChartModel.hierDimTitles);
			if($rootScope.displayVisType != 'pivot-table' && $scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap.size > 1) {
				sortLineDimensionsSecondaryValuesMap();
			}
			//console.log('tableToChartModel', $scope.tableToChartModel)			
			sessionStorage.setItem("tableToChartSession", JSON.stringify($scope.tableToChartModel));
			sessionStorage.setItem("testSession", JSON.stringify({test: true, text: 'hi there', num:99}));
			// console.log('sessionStorage tableToChartSession=', sessionStorage.getItem("tableToChartSession"));

			// $scope.closeTableToChartDialog();
			$scope.onInitalPage = true;

			// open the app to convert to in a new tab
			openConversionUrl();

			$scope.tableToChartModel.hierDimTitles = new Map(Object.entries($scope.tableToChartModel.hierDimTitles));
		}

		$scope.clickConfirmAndConvert = function(evt) {
			$scope.clickConfirm(evt);
			setTimeout(function(){ 
				$scope.clickConvert(evt);
			}, 1000);
		}

		function openConversionUrl() {
			var survey = $rootScope.survey.properties.survey;
			var typeParamIndex = window.location.href.indexOf("type");
			var chartUrl = webProperties.props.webUrl+"index.html#";
			if (typeParamIndex > -1) {
				window.open(chartUrl + survey.toLowerCase() + "?convert=1", "_blank");
				//window.open(chartUrl + survey.toLowerCase() + "?convert=1", "_self");
			} else {
				if($scope.tableToChartModel.chartType == "Bar Chart") {
					window.open(chartUrl + survey.toLowerCase() + '?type=barchart&convert=1', "_blank");
					//window.open(chartUrl + survey.toLowerCase() + '?type=barchart&convert=1', "_self");
				} else {
					window.open(chartUrl + survey.toLowerCase() + '?type=linechart&convert=1', "_blank");
					//window.open(chartUrl + survey.toLowerCase() + '?type=linechart&convert=1', "_self");
				}
        	}

		};

		function sortLineDimensionsSecondaryValuesMap() {
			// sort conversionLineDimensionsSecondaryValuesMap
			if($rootScope.displayVisType != 'pivot-table') {
				$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap = new Map(Object.entries($scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap));
				// the order in which the dimensions are nested in the Rows section is based on the order in which
				// they appear on the left rail
				var lineDimensionsSecondaryValuesMap = new Map();
				$rootScope.dimensionProperties.apiDimTopics.forEach(function(apiDimTopic) {
					apiDimTopic.dimensionGroups.forEach(function(dimensionGroup) {
						dimensionGroup.dimensions.forEach(function(dimension) {
							for(const [key, value] of $scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap) {
								if(dimension.shortName == key) {
									lineDimensionsSecondaryValuesMap.set(key, value);
									break;
								}
							}

						});
					});
				});
				if(lineDimensionsSecondaryValuesMap.size > 0) {
					$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap = lineDimensionsSecondaryValuesMap;
				}
				$scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap = Object.fromEntries($scope.tableToChartModel.conversionLineDimensionsSecondaryValuesMap);
				
			}
		};

		function addShortNamesFromHier() {
			if($rootScope.dimensionProperties) {
				if($rootScope.dimensionProperties.apiDimTopics) {
					$rootScope.dimensionProperties.apiDimTopics.forEach(function(apiDimTopic) {
						apiDimTopic.dimensionGroups.forEach(function(dimensionGroup) {
							dimensionGroup.dimensions.forEach(function(dimension) {
								if(dimension.shortName) {
									if(dimension.hierarchyAvailable && dimension.hierarchyAvailable == 'Y') {
										if(!excludeShortNames.includes(dimension.shortName )) {
											excludeShortNames.push(dimension.shortName);
										}
										if(dimension.def) {
											if(!excludeShortNames.includes(dimension.shortName)) {
												excludeShortNames.push(dimension.shortName);
											}
										}
										if(dimension.dimHier1) {
											dimension.dimHier1.forEach(function(dimHier1Dim) {
												if(!excludeShortNames.includes(dimHier1Dim.shortName)) {
													excludeShortNames.push(dimHier1Dim.shortName);
												}
												if(dimHier1Dim.dimHier2) {
													dimHier1Dim.dimHier2.forEach(function(dimHier2Dim) {
														if(!excludeShortNames.includes(dimHier2Dim.shortName)) {
															excludeShortNames.push(dimHier2Dim.shortName);
														}
														if(dimHier2Dim.dimHier3) {
															dimHier2Dim.dimHier3.forEach(function(dimHier3Dim) {
																if(!excludeShortNames.includes(dimHier3Dim.shortName)) {
																	excludeShortNames.push(dimHier3Dim.shortName);
																}
																if(dimHier3Dim.dimHier4) {
																	dimHier3Dim.dimHier4.forEach(function(dimHier4Dim) {
																		if(!excludeShortNames.includes(dimHier4Dim.shortName)) {
																			excludeShortNames.push(dimHier4Dim.shortName);
																		}
																	});
																}
															});
														}
													});
												}
											});
										}
									}
								}
							});
						});
					});
				}
			}

		};

		function findAllRecodes() {
			if($rootScope.dimensionProperties) {
				if($rootScope.dimensionProperties.apiDimTopics) {
					$rootScope.dimensionProperties.apiDimTopics.forEach(function(apiDimTopic) {
						apiDimTopic.dimensionGroups.forEach(function(dimensionGroup) {
							dimensionGroup.dimensions.forEach(function(dimension) {
								if(dimension.recodes) {
									dimension.recodes.forEach(function(recode) {
										if(recode.selected) {
											$scope.tableToChartModel.allRecodesByCID.push(recode);
										}
									});
								}
								if(dimension.commonRecodes) {
									dimension.commonRecodes.forEach(function(recode) {
										if(recode.selected) {
											$scope.tableToChartModel.allRecodesByCID.push(recode);
										}
									});
								}								
								if(dimension.recodeTrees && dimension.recodedSrcDims) {
									dimension.recodeTrees.forEach(function(tree) {
										if(tree.selected) {
											$scope.tableToChartModel.allRecodesByCID.push(tree)
										}
									})
								}
								if(dimension.commonRecodeTrees && dimension.recodedSrcDims) {
									dimension.commonRecodeTrees.forEach(function(tree) {
										if(tree.selected) {
											$scope.tableToChartModel.allRecodesByCID.push(tree)
										}
									})
								}								
							});
						});
					});
				}
			}
		};

		function hasAssociatedRecode(dim) {
			var isAssociatedRecode = false;
			var recodeTreeAssocCIDs = [];
			if($scope.tableToChartModel.allRecodesByCID) {
				$scope.tableToChartModel.allRecodesByCID.forEach(function(recode) {
					if(recode.recodeTrees && recode.recodeTrees.length > 0) {
						recode.recodeTrees.forEach(function(recodeTree) {
							recodeTree.dimensions.forEach(function(recodeDimension) {
								if(recodeDimension.type != 'recode') {
									recodeTreeAssocCIDs.push(recodeDimension.cId);
								}
							});
						});
					}
				});
			}

			if(recodeTreeAssocCIDs.includes(dim.qDef.cId)) {
				isAssociatedRecode = true;
			}

			return isAssociatedRecode;

		};

		function mostRecentYear(conversionDimShortName, list) {
			if( (conversionDimShortName.toLowerCase() == 'Year'.toLowerCase()
			|| conversionDimShortName.toLowerCase() == 'REFYR'.toLowerCase() )
			&& $scope.tableToChartModel.chartType == "Bar Chart") {
			list.forEach(function(eachYear, i) {
				if(i == 0) {
					eachYear.qState = 'S';
				}
				else {
					eachYear.qState = 'A';
				}
			});
		}
		};

    }]);
});
'use strict'
define('scripts/directives/popoverDirective',["js/qlik",  "scripts/appModule"], 
	function (qlik, appModule) {
		
	angular.module("appModule").directive("dtPopover", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtPopover.html',
		scope: {
			msg: '@'
		},
		transclude : true,
		controller: 'PopoverController'
	  };
	});	
	
	angular.module("appModule").controller("PopoverController", ["$scope", "$rootScope",  
		function ($scope, $rootScope) { 
			$scope.show = true;
			
			$scope.btnCloseClick = function() {
				$scope.show = false;
			}

			$scope.showPopup = function() {
				 return $rootScope.chart.dimCount > 2?true:false;
			}
	}])	
});

'use strict'
define('scripts/directives/displayWarningMessageDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
"scripts/shared/measures", "scripts/shared/dimensions", "scripts/lib/FileSaver.min.js"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtDisplayWarningMessage", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtDisplayWarningMessage.html',
		scope: false,
		transclude : false,
		controller: 'DisplayWarningMessageController'
	  };
	});

	angular.module("appModule").controller("DisplayWarningMessageController", ["$scope", "$rootScope", "$q", "$location", "$http", "$window",
		function ($scope, $rootScope, $q, $location, ) {
			var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';

			$scope.closePopUp = function(){
				$('#warning-message-popup').addClass('warning-message-hide');
			}

			$scope.clickOpenFeedback = function (tab) {
				//google analytics tracking
				gtag('event', displayType + 'Open Feedback', {
						'event_label': 'open',
						'event_category': 'feedback'
				});

				if(tab) {
						$('#feedbackMenu a[href="#' + tab + '"]').tab('show');
				}
				$("#feedbackModal").modal();
				$('#warning-message').css('display', 'none');
			}
	}])
});

'use strict'

define('scripts/directives/chartColorThemeDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtChartColorTheme", function() {
	  return {
		restrict: 'EA',
		templateUrl: 'templates/dtChartColorTheme.html',
		scope: true,
		controller: 'ChartColorThemeController'
	  };
	});


	angular.module("appModule").controller("ChartColorThemeController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {

      $scope.colorPallete = {
       hexModel: '#313A53',
       redColor: '49',
       greenColor: '58',
       blueColor: '83'

      };


$scope.schemeName = '';
$scope.colorCodes = [];
$scope.selectedColor = '';
$scope.deleteColorCode = null;


$scope.setColorPallete = function() {
  $("#color").val( $scope.demo.hexModel);
}

$scope.addColorCode = function(){
  // console.log('$scope.colorCodes');
  if( $scope.colorPallete.hexModel && !$scope.colorCodes.includes($scope.colorPallete.hexModel )) {
    $scope.colorCodes.push($scope.colorPallete.hexModel.trim());
    $scope.deleteColorCode = null;
    // console.log('$scope.colorCodes', $scope.colorCodes);
  }

}

$scope.saveColorTheme = function() {
  if($scope.colorCodes != null && $scope.colorCodes.length > 0) {
    function makeTextFile(text) {
      var data = new Blob([text], {type: 'text/json'});
      return data;
    };
	gtag('event', 'CB-' + $rootScope.survey.abbreviation + '-Export Custom Color Theme', {
		'event_label': 'save',
		'event_category': 'color_theme'
	});
    var filePrefix = $scope.schemeName;
    console.log('filePrefix: ', filePrefix);
    var dateTime = new Date();
    var fileName = filePrefix + "_" + dateTime.toISOString()+".json";
    var jsonObj = {
      themeName: filePrefix,
      colorCodes: $scope.colorCodes
    };
    var file = makeTextFile(JSON.stringify(jsonObj));
    saveAs(file, fileName);
  }
}


function rgba2hex(rgba) {
	rgba = rgba.match(
	  /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
	);
	return rgba && rgba.length === 4
	  ? "#" +
		  ("0" + parseInt(rgba[1], 10).toString(16)).slice(-2) +
		  ("0" + parseInt(rgba[2], 10).toString(16)).slice(-2) +
		  ("0" + parseInt(rgba[3], 10).toString(16)).slice(-2)
	  : "";
  }


  // $scope.rgbToHex= function(r, g, b) {
  //   "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  // }

  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  $scope.rgbToHex = function(r, g, b) {
    if (!isNaN(parseInt(r)) && !isNaN(parseInt(g)) && !isNaN(parseInt(b))) {
      $scope.colorPallete.hexModel = "#" + componentToHex(parseInt(r)) + componentToHex(parseInt(g)) + componentToHex(parseInt(b));
    } else{
      $scope.colorPallete.hexModel = '';
    }
  }




  $scope.hexToRgb = function(hex) {
    if(!!hex){
      let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if(result) {
        $scope.colorPallete.redColor = parseInt(result[1],  16);
        $scope.colorPallete.greenColor = parseInt(result[2],  16);
        $scope.colorPallete.blueColor = parseInt(result[3],  16);
     }

    } else{
      $scope.colorPallete.redColor = '';
      $scope.colorPallete.greenColor = '';
      $scope.colorPallete.blueColor = '';
    }

  }

$scope.setColor = function(colorCode) {
  $scope.deleteColorCode =   $scope.deleteColorCode == null ||  $scope.deleteColorCode != colorCode ? colorCode: null;
}

$scope.deleteColor = function(colorCode) {
  if ($scope.colorCodes.length > 0) {
    var index = $scope.colorCodes.indexOf(colorCode);
    if (index > -1) {
      $scope.colorCodes.splice(index, 1);
    }
  }
  // console.log('$scope.colorCodes: ',  $scope.colorCodes);
}

$scope.deleteAllColors = function() {
  if ($scope.colorCodes && $scope.colorCodes.length >= 1) {
    $scope.colorCodes = [];
    $scope.deleteColorCode = null;
  }
}

$scope.createTheme = function() {
	$("#colorTheme").show();
	$scope.colorPallete = {
		hexModel: '#005495 ',
		redColor: '0',
		greenColor: '84',
		blueColor: '149'
	};

	//  $('#color-map').addClass("active").siblings().removeClass("active");
	activeFirstTab();

	gtag('event', 'CB-' + $rootScope.survey.abbreviation + '-Create Custom Color Theme', {
		'event_label': 'create',
		'event_category': 'color_theme'
	});
}

function activeFirstTab() {
  $('a[href="#colormap-tab"]').tab('show');
  $('#hex-rgb').removeClass("active");
  $('#color-map').addClass('active');

}

$scope.closeColorThemeDialog = function() {
	$("#colorTheme").hide();
  $scope.schemeForm.$setPristine();
  $scope.schemeForm1.$setPristine();
  $scope.schemeName = '';
  $scope.colorCodes = [];
  $scope.hexName = '';
}

$scope.isLimitReached = function(){
  // console.log('$scope.colorCodes.length ', $scope.colorCodes.length )
  return $scope.colorCodes && $scope.colorCodes.length >= 12;
}

  $scope.setActiveTab = function(e) {
    // e.preventDefault();
    $("li").on("click", function(e) {
      $(this).addClass("active").siblings().removeClass("active");
    });
  }
}
	]);
});
'use strict'

define('scripts/directives/hexColorPickerDirective',["js/qlik",  "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {

	angular.module("appModule").directive("dtHexColorpicker", function() {
	  return {
      templateUrl: 'templates/dtHexColorPicker.html',
      restrict: 'EA',
      scope: {
        hexModel: '=',
        redColor: '=',
        greenColor: '=',
        blueColor: '='
      },
      controller: 'HexColorPickerController',
      link: function($scope, element) {
        $scope.posX = null
        $scope.posY = null


        $scope.selectArea = function (area) {

          $scope.hexModel  = '#'+ area.hex
          $scope.posX      = '' + area.x + 'px'
          $scope.posY      = '' + area.y + 'px'
          setRgb();



        }


 function setRgb(){
  var colorInRgb =  $scope.hexModel;
  $scope.redColor= parseInt(colorInRgb.substr(1,2), 16);
  $scope.greenColor= parseInt(colorInRgb.substr(3,2), 16);
  $scope.blueColor= parseInt(colorInRgb.substr(5,2), 16);
}

 $scope.areas = [
          { hex: '003366', coords: '63,0,72,4,72,15,63,19,54,15,54,4',                 x: 53,  y: -205 },
          { hex: '336699', coords: '81,0,90,4,90,15,81,19,72,15,72,4',                 x: 71,  y: -205 },
          { hex: '3366CC', coords: '99,0,108,4,108,15,99,19,90,15,90,4',               x: 89,  y: -205 },
          { hex: '003399', coords: '117,0,126,4,126,15,117,19,108,15,108,4',           x: 107, y: -205 },
          { hex: '000099', coords: '135,0,144,4,144,15,135,19,126,15,126,4',           x: 125, y: -205 },
          { hex: '0000CC', coords: '153,0,162,4,162,15,153,19,144,15,144,4',           x: 143, y: -205 },
          { hex: '000066', coords: '171,0,180,4,180,15,171,19,162,15,162,4',           x: 161, y: -205 },
          { hex: '006666', coords: '54,15,63,19,63,30,54,34,45,30,45,19',              x: 44,  y: -190 },
          { hex: '006699', coords: '72,15,81,19,81,30,72,34,63,30,63,19',              x: 62,  y: -190 },
          { hex: '0099CC', coords: '90,15,99,19,99,30,90,34,81,30,81,19',              x: 80,  y: -190 },
          { hex: '0066CC', coords: '108,15,117,19,117,30,108,34,99,30,99,19',          x: 98,  y: -190 },
          { hex: '0033CC', coords: '126,15,135,19,135,30,126,34,117,30,117,19',        x: 116, y: -190 },
          { hex: '0000FF', coords: '144,15,153,19,153,30,144,34,135,30,135,19',        x: 134, y: -190 },
          { hex: '3333FF', coords: '162,15,171,19,171,30,162,34,153,30,153,19',        x: 152, y: -190 },
          { hex: '333399', coords: '180,15,189,19,189,30,180,34,171,30,171,19',        x: 170, y: -190 },
          { hex: '669999', coords: '45,30,54,34,54,45,45,49,36,45,36,34',              x: 35,  y: -175 },
          { hex: '009999', coords: '63,30,72,34,72,45,63,49,54,45,54,34',              x: 53,  y: -175 },
          { hex: '33CCCC', coords: '81,30,90,34,90,45,81,49,72,45,72,34',              x: 71,  y: -175 },
          { hex: '00CCFF', coords: '99,30,108,34,108,45,99,49,90,45,90,34',            x: 89,  y: -175 },
          { hex: '0099FF', coords: '117,30,126,34,126,45,117,49,108,45,108,34',        x: 107, y: -175 },
          { hex: '0066FF', coords: '135,30,144,34,144,45,135,49,126,45,126,34',        x: 125, y: -175 },
          { hex: '3366FF', coords: '153,30,162,34,162,45,153,49,144,45,144,34',        x: 143, y: -175 },
          { hex: '3333CC', coords: '171,30,180,34,180,45,171,49,162,45,162,34',        x: 161, y: -175 },
          { hex: '666699', coords: '189,30,198,34,198,45,189,49,180,45,180,34',        x: 179, y: -175 },
          { hex: '339966', coords: '36,45,45,49,45,60,36,64,27,60,27,49',              x: 25,  y: -160 },
          { hex: '00CC99', coords: '54,45,63,49,63,60,54,64,45,60,45,49',              x: 44,  y: -160 },
          { hex: '00FFCC', coords: '72,45,81,49,81,60,72,64,63,60,63,49',              x: 62,  y: -160 },
          { hex: '00FFFF', coords: '90,45,99,49,99,60,90,64,81,60,81,49',              x: 80,  y: -160 },
          { hex: '33CCFF', coords: '108,45,117,49,117,60,108,64,99,60,99,49',          x: 98,  y: -160 },
          { hex: '3399FF', coords: '126,45,135,49,135,60,126,64,117,60,117,49',        x: 116, y: -160 },
          { hex: '6699FF', coords: '144,45,153,49,153,60,144,64,135,60,135,49',        x: 134, y: -160 },
          { hex: '6666FF', coords: '162,45,171,49,171,60,162,64,153,60,153,49',        x: 152, y: -160 },
          { hex: '6600FF', coords: '180,45,189,49,189,60,180,64,171,60,171,49',        x: 170, y: -160 },
          { hex: '6600CC', coords: '198,45,207,49,207,60,198,64,189,60,189,49',        x: 188, y: -160 },
          { hex: '339933', coords: '27,60,36,64,36,75,27,79,18,75,18,64',              x: 16,  y: -145 },
          { hex: '00CC66', coords: '45,60,54,64,54,75,45,79,36,75,36,64',              x: 34,  y: -145 },
          { hex: '00FF99', coords: '63,60,72,64,72,75,63,79,54,75,54,64',              x: 53,  y: -145 },
          { hex: '66FFCC', coords: '81,60,90,64,90,75,81,79,72,75,72,64',              x: 71,  y: -145 },
          { hex: '66FFFF', coords: '99,60,108,64,108,75,99,79,90,75,90,64',            x: 89,  y: -145 },
          { hex: '66CCFF', coords: '117,60,126,64,126,75,117,79,108,75,108,64',        x: 107, y: -145 },
          { hex: '99CCFF', coords: '135,60,144,64,144,75,135,79,126,75,126,64',        x: 125, y: -145 },
          { hex: '9999FF', coords: '153,60,162,64,162,75,153,79,144,75,144,64',        x: 143, y: -145 },
          { hex: '9966FF', coords: '171,60,180,64,180,75,171,79,162,75,162,64',        x: 161, y: -145 },
          { hex: '9933FF', coords: '189,60,198,64,198,75,189,79,180,75,180,64',        x: 179, y: -145 },
          { hex: '9900FF', coords: '207,60,216,64,216,75,207,79,198,75,198,64',        x: 197, y: -145 },
          { hex: '006600', coords: '18,75,27,79,27,90,18,94,9,90,9,79',                x: 7,   y: -130 },
          { hex: '00CC00', coords: '36,75,45,79,45,90,36,94,27,90,27,79',              x: 25,  y: -130 },
          { hex: '00FF00', coords: '54,75,63,79,63,90,54,94,45,90,45,79',              x: 44,  y: -130 },
          { hex: '66FF99', coords: '72,75,81,79,81,90,72,94,63,90,63,79',              x: 62,  y: -130 },
          { hex: '99FFCC', coords: '90,75,99,79,99,90,90,94,81,90,81,79',              x: 80,  y: -130 },
          { hex: 'CCFFFF', coords: '108,75,117,79,117,90,108,94,99,90,99,79',          x: 98,  y: -130 },
          { hex: 'CCCCFF', coords: '126,75,135,79,135,90,126,94,117,90,117,79',        x: 116, y: -130 },
          { hex: 'CC99FF', coords: '144,75,153,79,153,90,144,94,135,90,135,79',        x: 134, y: -130 },
          { hex: 'CC66FF', coords: '162,75,171,79,171,90,162,94,153,90,153,79',        x: 152, y: -130 },
          { hex: 'CC33FF', coords: '180,75,189,79,189,90,180,94,171,90,171,79',        x: 170, y: -130 },
          { hex: 'CC00FF', coords: '198,75,207,79,207,90,198,94,189,90,189,79',        x: 188, y: -130 },
          { hex: '9900CC', coords: '216,75,225,79,225,90,216,94,207,90,207,79',        x: 206, y: -130 },
          { hex: '003300', coords: '9,90,18,94,18,105,9,109,0,105,0,94',               x: -1,  y: -115 },
          { hex: '009933', coords: '27,90,36,94,36,105,27,109,18,105,18,94',           x: 16,  y: -115 },
          { hex: '33CC33', coords: '45,90,54,94,54,105,45,109,36,105,36,94',           x: 34,  y: -115 },
          { hex: '66FF66', coords: '63,90,72,94,72,105,63,109,54,105,54,94',           x: 53,  y: -115 },
          { hex: '99FF99', coords: '81,90,90,94,90,105,81,109,72,105,72,94',           x: 71,  y: -115 },
          { hex: 'CCFFCC', coords: '99,90,108,94,108,105,99,109,90,105,90,94',         x: 89,  y: -115 },
          { hex: 'FFFFFF', coords: '117,90,126,94,126,105,117,109,108,105,108,94',     x: 107, y: -115 },
          { hex: 'FFCCFF', coords: '135,90,144,94,144,105,135,109,126,105,126,94',     x: 125, y: -115 },
          { hex: 'FF99FF', coords: '153,90,162,94,162,105,153,109,144,105,144,94',     x: 143, y: -115 },
          { hex: 'FF66FF', coords: '171,90,180,94,180,105,171,109,162,105,162,94',     x: 161, y: -115 },
          { hex: 'FF00FF', coords: '189,90,198,94,198,105,189,109,180,105,180,94',     x: 179, y: -115 },
          { hex: 'CC00CC', coords: '207,90,216,94,216,105,207,109,198,105,198,94',     x: 197, y: -115 },
          { hex: '660066', coords: '225,90,234,94,234,105,225,109,216,105,216,94',     x: 215, y: -115 },
          { hex: '336600', coords: '18,105,27,109,27,120,18,124,9,120,9,109',          x: 7,   y: -100 },
          { hex: '009900', coords: '36,105,45,109,45,120,36,124,27,120,27,109',        x: 25,  y: -100 },
          { hex: '66FF33', coords: '54,105,63,109,63,120,54,124,45,120,45,109',        x: 44,  y: -100 },
          { hex: '99FF66', coords: '72,105,81,109,81,120,72,124,63,120,63,109',        x: 62,  y: -100 },
          { hex: 'CCFF99', coords: '90,105,99,109,99,120,90,124,81,120,81,109',        x: 80,  y: -100 },
          { hex: 'FFFFCC', coords: '108,105,117,109,117,120,108,124,99,120,99,109',    x: 98,  y: -100 },
          { hex: 'FFCCCC', coords: '126,105,135,109,135,120,126,124,117,120,117,109',  x: 116, y: -100 },
          { hex: 'FF99CC', coords: '144,105,153,109,153,120,144,124,135,120,135,109',  x: 134, y: -100 },
          { hex: 'FF66CC', coords: '162,105,171,109,171,120,162,124,153,120,153,109',  x: 152, y: -100 },
          { hex: 'FF33CC', coords: '180,105,189,109,189,120,180,124,171,120,171,109',  x: 170, y: -100 },
          { hex: 'CC0099', coords: '198,105,207,109,207,120,198,124,189,120,189,109',  x: 188, y: -100 },
          { hex: '993399', coords: '216,105,225,109,225,120,216,124,207,120,207,109',  x: 206, y: -100 },
          { hex: '333300', coords: '27,120,36,124,36,135,27,139,18,135,18,124',        x: 16,  y: -85 },
          { hex: '669900', coords: '45,120,54,124,54,135,45,139,36,135,36,124',        x: 34,  y: -85 },
          { hex: '99FF33', coords: '63,120,72,124,72,135,63,139,54,135,54,124',        x: 53,  y: -85 },
          { hex: 'CCFF66', coords: '81,120,90,124,90,135,81,139,72,135,72,124',        x: 71,  y: -85 },
          { hex: 'FFFF99', coords: '99,120,108,124,108,135,99,139,90,135,90,124',      x: 89,  y: -85 },
          { hex: 'FFCC99', coords: '117,120,126,124,126,135,117,139,108,135,108,124',  x: 107, y: -85 },
          { hex: 'FF9999', coords: '135,120,144,124,144,135,135,139,126,135,126,124',  x: 125, y: -85 },
          { hex: 'FF6699', coords: '153,120,162,124,162,135,153,139,144,135,144,124',  x: 143, y: -85 },
          { hex: 'FF3399', coords: '171,120,180,124,180,135,171,139,162,135,162,124',  x: 161, y: -85 },
          { hex: 'CC3399', coords: '189,120,198,124,198,135,189,139,180,135,180,124',  x: 179, y: -85 },
          { hex: '990099', coords: '207,120,216,124,216,135,207,139,198,135,198,124',  x: 197, y: -85 },
          { hex: '666633', coords: '36,135,45,139,45,150,36,154,27,150,27,139',        x: 25,  y: -70 },
          { hex: '99CC00', coords: '54,135,63,139,63,150,54,154,45,150,45,139',        x: 44,  y: -70 },
          { hex: 'CCFF33', coords: '72,135,81,139,81,150,72,154,63,150,63,139',        x: 62,  y: -70 },
          { hex: 'FFFF66', coords: '90,135,99,139,99,150,90,154,81,150,81,139',        x: 80,  y: -70 },
          { hex: 'FFCC66', coords: '108,135,117,139,117,150,108,154,99,150,99,139',    x: 98,  y: -70 },
          { hex: 'FF9966', coords: '126,135,135,139,135,150,126,154,117,150,117,139',  x: 116, y: -70 },
          { hex: 'FF6666', coords: '144,135,153,139,153,150,144,154,135,150,135,139',  x: 134, y: -70 },
          { hex: 'FF0066', coords: '162,135,171,139,171,150,162,154,153,150,153,139',  x: 152, y: -70 },
          { hex: 'CC6699', coords: '180,135,189,139,189,150,180,154,171,150,171,139',  x: 170, y: -70 },
          { hex: '993366', coords: '198,135,207,139,207,150,198,154,189,150,189,139',  x: 188, y: -70 },
          { hex: '999966', coords: '45,150,54,154,54,165,45,169,36,165,36,154',        x: 34,  y: -55 },
          { hex: 'CCCC00', coords: '63,150,72,154,72,165,63,169,54,165,54,154',        x: 53,  y: -55 },
          { hex: 'FFFF00', coords: '81,150,90,154,90,165,81,169,72,165,72,154',        x: 71,  y: -55 },
          { hex: 'FFCC00', coords: '99,150,108,154,108,165,99,169,90,165,90,154',      x: 89,  y: -55 },
          { hex: 'FF9933', coords: '117,150,126,154,126,165,117,169,108,165,108,154',  x: 107, y: -55 },
          { hex: 'FF6600', coords: '135,150,144,154,144,165,135,169,126,165,126,154',  x: 125, y: -55 },
          { hex: 'FF5050', coords: '153,150,162,154,162,165,153,169,144,165,144,154',  x: 143, y: -55 },
          { hex: 'CC0066', coords: '171,150,180,154,180,165,171,169,162,165,162,154',  x: 161, y: -55 },
          { hex: '660033', coords: '189,150,198,154,198,165,189,169,180,165,180,154',  x: 179, y: -55 },
          { hex: '996633', coords: '54,165,63,169,63,180,54,184,45,180,45,169',        x: 44,  y: -40 },
          { hex: 'CC9900', coords: '72,165,81,169,81,180,72,184,63,180,63,169',        x: 62,  y: -40 },
          { hex: 'FF9900', coords: '90,165,99,169,99,180,90,184,81,180,81,169',        x: 80,  y: -40 },
          { hex: 'CC6600', coords: '108,165,117,169,117,180,108,184,99,180,99,169',    x: 98,  y: -40 },
          { hex: 'FF3300', coords: '126,165,135,169,135,180,126,184,117,180,117,169',  x: 116, y: -40 },
          { hex: 'FF0000', coords: '144,165,153,169,153,180,144,184,135,180,135,169',  x: 134, y: -40 },
          { hex: 'CC0000', coords: '162,165,171,169,171,180,162,184,153,180,153,169',  x: 152, y: -40 },
          { hex: '990033', coords: '180,165,189,169,189,180,180,184,171,180,171,169',  x: 170, y: -40 },
          { hex: '663300', coords: '63,180,72,184,72,195,63,199,54,195,54,184',        x: 53,  y: -25 },
          { hex: '996600', coords: '81,180,90,184,90,195,81,199,72,195,72,184',        x: 71,  y: -25 },
          { hex: 'CC3300', coords: '99,180,108,184,108,195,99,199,90,195,90,184',      x: 89,  y: -25 },
          { hex: '993300', coords: '117,180,126,184,126,195,117,199,108,195,108,184',  x: 107, y: -25 },
          { hex: '990000', coords: '135,180,144,184,144,195,135,199,126,195,126,184',  x: 125, y: -25 },
          { hex: '800000', coords: '153,180,162,184,162,195,153,199,144,195,144,184',  x: 143, y: -25 },
          { hex: '993333', coords: '171,180,180,184,180,195,171,199,162,195,162,184',  x: 161, y: -25 }
        ]

        var area, i, len, ref;

        ref = $scope.areas
        for (i = 0, len = ref.length; i < len; i++) {
          area = ref[i]
          if (area.hex === $scope.hexModel) {
            $scope.selectArea(area)
          }
        }
      }
	  };
	});


	angular.module("appModule").controller("HexColorPickerController", ["$scope", "$rootScope", "$q", "$location", "$http",
		function ($scope, $rootScope, $q, $location, $http) {

    }

  ]);
});
'use strict'
define('scripts/directives/dragDropListDirective',[], function () {
	let dim;
	angular.module("appModule").controller("dragDropListCtrl",['$scope', function ($scope) {
		$scope.leaveBtn = function(e) {
			//this property set through mouse event, so it will be null if user uses keyboard, don't resdt if user mves items using arrow keys 
			if(e.relatedTarget == null)
				return;
			
			var draggingEle = e.target.parentElement.parentElement.parentElement;
			dim = null;
			draggingEle.style.backgroundColor = "#fff";
			draggingEle.style.opacity = 1;
		}
		
		$scope.keyPressed = function(e, item) {
			var draggingEle = e.target.parentElement.parentElement.parentElement;

			//spacebar key, enter key
			if(e.keyCode === 32 || e.keyCode === 13) {
				
				if(dim == null) {
					dim = item;					
					draggingEle.style.backgroundColor = "#DFECFD";
					draggingEle.style.opacity = .6;				
				} else {
					dim = null;
					draggingEle.style.backgroundColor = "#fff";
					draggingEle.style.opacity = 1;						
				}
				return;
			} else if(e.keyCode === 38) {
				//up arrow key
				const prevEle = draggingEle.previousElementSibling;
				var dragBtn;				
				
				if (prevEle && dim != null) {
					var unregister = $scope.$watch("recodeTree.dimensions", function (newValue, oldValue) {
						unregister();
						dragBtn.focus();						
					})						
					$scope.swap(draggingEle, prevEle);
					dragBtn = $(draggingEle).find("button.btn-drag-drop");
				} 
				else {
					dragBtn = $(prevEle).find("button.btn-drag-drop");
					dragBtn.focus();
				}
				return;				
			} else if(e.keyCode === 40) {
				//down arrow key
				const nextEle = draggingEle.nextElementSibling;
				var dragBtn;			
				
				if (nextEle && dim != null) {
					var unregister = $scope.$watch("recodeTree.dimensions", function (newValue, oldValue) {
						unregister();
						dragBtn.focus();
					})						
					$scope.swap(nextEle, draggingEle);
					dragBtn = $(draggingEle).find("button.btn-drag-drop");						
				} 
				else {
					dragBtn = $(nextEle).find("button.btn-drag-drop");
					dragBtn.focus();
				}
				return;
			} else {
					dim = null;
					draggingEle.style.backgroundColor = "#fff";
					draggingEle.style.opacity = 1;
			}				
		};
	
		$scope.swap = function (nodeA, nodeB) {
			const parentA = nodeA.parentNode;
			var nodes = nodeA.parentNode.children;
			// Move nodeA before  nodeB
			parentA.insertBefore(nodeA, nodeB);

			//update recode's dimension order
			let dims = $scope.recodeTree.dimensions;
			let xA = dims.findIndex(function(item, indx) {
				return item.cId == nodeA.attributes["data-cid"].value;
			});				
			
			let xB = dims.findIndex(function(item, indx) {
				return item.cId == nodeB.attributes["data-cid"].value;
			});	
			var x = dims[xA];
			dims[xA] = dims[xB];
			dims[xB] = x;					
		};		
		
	}]);		
	
	angular.module("appModule").directive("dtDraggableListItem",function(){
		return {
			restrict: 'EA',
			scope: true,			
			link:function(scope,elem,attr){
			
                let draggingEle;
                let placeholder;
                let isDraggingStarted = false;

                // The current position of mouse relative to the dragging element
                let x = 0;
                let y = 0;
				
				dim = null;

                // Check if `nodeA` is above `nodeB`
                const isAbove = function (nodeA, nodeB) {
                    // Get the bounding rectangle of nodes
                    const rectA = nodeA.getBoundingClientRect();
                    const rectB = nodeB.getBoundingClientRect();

                    return rectA.top + rectA.height / 2 < rectB.top + rectB.height / 2;
                };

                function mouseDownHandler(e) {
                    draggingEle = e.target.parentElement.parentElement.parentElement.parentElement;
					
                    // Calculate the mouse position
                    const rect = draggingEle.getBoundingClientRect();
                    //x = e.pageX - rect.left;
                    y = e.pageY - rect.top;
					draggingEle.style.backgroundColor = "#DFECFD";
					draggingEle.style.opacity = .6;
					
                    // Attach the listeners to `document`
                    draggingEle.addEventListener('mousemove', mouseMoveHandler);
                    draggingEle.addEventListener('mouseup', mouseUpHandler);
					draggingEle.addEventListener('mouseleave', mouseUpHandler);
                };

                function mouseMoveHandler(e) {
					if(draggingEle == null) {
						return;
					}
					
                    const draggingRect = draggingEle.getBoundingClientRect();

                    if (!isDraggingStarted) {
                        isDraggingStarted = true;
                    }      

					draggingEle.style.width = draggingRect.right - draggingRect.left + 'px';                
					draggingEle.style.position = 'fixed';
                    draggingEle.style.top = (e.pageY - y) + 'px'; //`${e.pageY - y}px`;

                    const prevEle = draggingEle.previousElementSibling;
                    const nextEle = draggingEle.nextElementSibling;
                    // User moves the dragging element to the top
                    if (prevEle && isAbove(draggingEle, prevEle)) {
                        scope.swap(draggingEle, prevEle);
                        return;
                    }

                    // User moves the dragging element to the bottom
                    if (nextEle && isAbove(nextEle, draggingEle)) {
						scope.swap(nextEle, draggingEle);
                    }
                };

                function mouseUpHandler(e) {
                    draggingEle.style.removeProperty('top');
                    draggingEle.style.removeProperty('left');
                    draggingEle.style.removeProperty('position');
					draggingEle.style.removeProperty('background-color');
					draggingEle.style.removeProperty('opacity');
					
                    // Remove the handlers of `mousemove` and `mouseup`
                    draggingEle.removeEventListener('mousemove', mouseMoveHandler);
                    draggingEle.removeEventListener('mouseup', mouseUpHandler);
					draggingEle.removeEventListener('mouseleave', mouseUpHandler);
					var dragBtn = $(draggingEle).find("button.btn-drag-drop");
					dragBtn.blur()
					
					document.getSelection().removeAllRanges();					
                    x = null;
                    y = null;
                    draggingEle = null;
                    isDraggingStarted = false;	

                };
				var btn = $(elem)[0].querySelector('.fa-grip-dots-vertical');
				btn.addEventListener('mousedown', mouseDownHandler);	
			}
		};
	});
});
'use strict'
define('scripts/directives/metadataExportDirective',["js/qlik",  "scripts/appModule", "scripts/shared/appUtilities"], 
function (qlik, appModule, appUtilities) {
		
	angular.module("appModule").directive("dtMetadataExport", function() {	
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtMetadataExport.html',
			scope: true,
			controller: 'MetadataExportController'
		}  
	});

			


	angular.module("appModule").controller("MetadataExportController", ["$scope", "$rootScope", "$http", 
		function ($scope, $rootScope, $http) {	
			$scope.display = {}
			$scope.exportTypes = [{'value':'csv', 'name': 'CSV'},{'value': 'xml', 'name':'XML'},{'value':'json', 'name': 'JSON'},{'value': 'xlsx', 'name':'XLSX'}];
			$scope.disableDownload = true;
			$scope.allMetaData = {};
			
			let metadata = null, dataType = null, dataLabel;

			$scope.checkAllField = function() {
				if($scope.allMetaData.selected) {
					$scope.metaFields.forEach(function(fld) {
						fld.selected = true;
					})
					$scope.disableDownload = false;
				} else {
					$scope.metaFields.forEach(function(fld) {
						fld.selected = false;
					})
					$scope.disableDownload = true;			
				}
			}

			$scope.checkField = function() {
				$scope.disableDownload = true;
				$scope.allMetaData.selected = false;
				$scope.metaFields.forEach(function(fld) {
					if(fld.selected == true)
						$scope.disableDownload = false;
				})				
			}
			
			$scope.exportMetadataDetails = function() {

				let fields = $scope.metaFields.filter(function(v) {
					return v.selected
				}).map(function(v) {
					return v.fieldName;
				}) 
				
				var displayType = $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-';			
				gtag('event', displayType  +  $rootScope.survey.abbreviation+'-Export metadata details', 
					{ 'event_label': 'metadata', 'event_category': 'download'});
					
				
				if(dataType == "variable") {
					appUtilities.exportVariableDetailsFromApi(qlik, $http, metadata.variableId, fields, $scope.display.exportType).then(function (resp) {
						saveAsFile(resp, metadata);
					}, function (err) {
						appUtilities.showError(err);
					})	
				} else {
					appUtilities.exportSurveyDetailsFromApi(qlik, $http, metadata.survey, fields, $scope.display.exportType).then(function (resp) {
						saveAsFile(resp, metadata)
					}, function (err) {
						appUtilities.showError(err);
					})					
				}
				$('#metadata-export-modal').modal('toggle');
			}
		
			$scope.$on('showExportMetadataEvent', function(e,obj, type) {
				metadata = obj;
				dataType = type;
				dataLabel = dataType == "variable"?metadata.universalId:metadata.survey;
				showExportVariables();
			});	

			function saveAsFile(resp, metadata) {
				var file, dateTime, filename;
				switch($scope.display.exportType) {	
					case "csv":
						file = new Blob([resp.data], { type: "text/plain;charset=utf-8" });
						break;
					case "xlsx":
						file = new Blob([resp.data], {  type: 'application/octet-stream'});
						break;	
					case "json":
						file = new Blob([JSON.stringify(resp.data)], { type: "application/json" });
						break;
					case "xml":
						file = new Blob([resp.data], { type: "text/xml;charset=utf-8" });
						break;								
					default:
						return;
				}
				
				dateTime = new Date();
				var product = $rootScope.displayVisType == "pivot-table" ? 'table' : 'chart';						
				filename = "ncses_" + product + "_var_meta_" + dataLabel + "_" + dateTime.toISOString().split('.')[0]+"Z";
				saveAs(file, filename + "." + $scope.display.exportType);			
			}

			function showExportVariables() {
				var product = $rootScope.displayVisType == "pivot-table" ? 'table' : 'chart';
				let date = new Date();
				let dt = date.getFullYear() + "-" + ('0' + (date.getMonth()+1)).slice(-2) + "-" + ('0' + (date.getDate())).slice(-2);				
				$scope.downloadName = "ncses_" + product + "_var_meta_" + dataLabel + "-" + dt + "<timestamp>.";					
				
				if(dataType == "variable") {
					appUtilities.getVariableMetaFieldsFromApi(qlik, $http).then(function (resp) {
						$scope.metaFields = resp.data.body;
					}, function (err) {
						console.log('api survey err', err);
					});
				} else {
					appUtilities.getSurveyMetaFieldsFromApi(qlik, $http).then(function (resp) {
						$scope.metaFields = resp.data.body;
					}, function (err) {
						console.log('api survey err', err);
					});
					
				}
				$scope.display.exportType = 'csv';
				$scope.disableDownload = true;
				$scope.allMetaData.selected = false;
				$('#metadata-export-modal').modal('toggle');
			}
			
		}])			
});
'use strict'

// define(["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
		// "scripts/shared/measures", "scripts/shared/dimensions"],
	// function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions) {
define('scripts/directives/tableSubMenuStatisticsDirective',["scripts/shared/dimensions", "scripts/shared/measures", "scripts/shared/appUtilities"],function(dimensions, measures, appUtilities) {
	angular.module("appModule").directive("dtTableSubMenuStatistics", function () {
		return {
			restrict: 'EA',
			templateUrl: 'templates/dtTableSubMenuStatistics.html',
			scope: true,
			controller: 'TableSubMenuStatisticsController'
		};
	});

	angular.module("appModule").controller("TableSubMenuStatisticsController", ["$scope", "$rootScope",
			function ($scope, $rootScope) {
                $scope.percentColFlag = false;
				$scope.percentRowFlag = false;
				$scope.percentAnnualFlag = false;
				$rootScope.displayTableTotals = $scope.totalsFlag = true;
                
				$scope.$on('resetStatsEvent', function (e) {
					$rootScope.displayTableTotals = $scope.totalsFlag = true;
					$scope.percentColFlag = false;
					$scope.percentRowFlag = false;
					$scope.percentAnnualFlag = false;
					$rootScope.displayTablePercentageType = null;
				});
				
				if($rootScope.survey.allowTablePercentages) {
					$scope.disablePercentage = false;
				} else {
					$scope.disablePercentage = true;
				}
				
				$('#ddTableStats .dropdown-menu').on("click.bs.dropdown", function (e) {
						e.stopPropagation();
				});
                

				$('#ddTableStats .btn-group').on("shown.bs.dropdown", function (e) {
                    $("#table-stats-btn i").removeClass( "fa-caret-down" );  
                    $("#table-stats-btn i").addClass( "fa-caret-up" );
					$("#statsMainForm").css("display", "block");
					$("#statsPrctForm").css("display", "none");										
				});

				$('#ddTableStats .btn-group').on('hide.bs.dropdown', function() {
						$("#table-stats-btn i").removeClass( "fa-caret-up" );
						$("#table-stats-btn i").addClass( "fa-caret-down" );
				});

				//M<ethod for adding a Totals row/column option
				$scope.chkToggleTotals = function() {
					$rootScope.displayTableTotals = $scope.totalsFlag;
					if($rootScope.displayTableTotals == false) {
						$scope.percentColFlag = $scope.percentRowFlag = $scope.percentAnnualFlag = false;
						$rootScope.displayTablePercentageType = null;
					}
					updateTable();
					$("#table-stats-btn").dropdown('toggle');
					gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-')  + $rootScope.survey.abbreviation + '-Toggle On Totals', {
						'event_label': 'apply',
						'event_category': 'totals',
						'event_variable': $rootScope.displayTableTotals
					});
				}
				
				function updateTable() {
					if($rootScope.displayVisType != "pivot-table") {
							return;
					}
					$rootScope.qApp.getObject($rootScope.visObjId).then(function (obj) {
						//call effProps to retain col/row expansion state
						obj.getEffectiveProperties().then(function (effProps) {
							dimensions.applyTotalsProperties($rootScope, effProps);
							measures.applyPercentages($rootScope, effProps)
					
							//TODO: Logic for setting total row/column background color
							////var exp = { "qExpression": "If(dimensionality() = 0, RGB(204, 229, 255), if(dimensionality() = 1 AND NoOfColumns() > 1 AND secondaryDimensionality()=0, RGB(204, 229, 255)))" };
							////effProps.qHyperCubeDef.qMeasures[0].qAttributeExpressions.push(exp);
							// if($scope.displayTotals  && effProps.qHyperCubeDef.qInterColumnSortOrder.indexOf(-1)== -1) {
									// var exp = { "qExpression": "If(dimensionality() = 0, RGB(204, 229, 255), if(dimensionality() = 1 AND NoOfColumns() > 1 AND secondaryDimensionality()=0, RGB(204, 229, 255)))" };
									////effProps.qHyperCubeDef.qMeasures[0].qAttributeExpressions.push(exp);                                // effProps.qHyperCubeDef.qMeasures[0].qAttributeExpressions[0] = exp;
							// } else {
									// effProps.qHyperCubeDef.qMeasures[0].qAttributeExpressions = [];
							// }
							obj.setProperties(effProps).then(function() {
								}, function(err) {
									console.log(err);
							});	
						});
					});
				}		
				
				
				$scope.btnPercentagesShowClick = function() {
					$("#statsMainForm").css("display", "none");
					$("#statsPrctForm").css("display", "block");

					switch($rootScope.displayTablePercentageType) {	
						case measures.PercentageType.COLUMN:
							$scope.percentColFlag = true;
							$scope.percentRowFlag = false;
							$scope.percentAnnualFlag = false;
							break;
						case measures.PercentageType.ROW:
							$scope.percentColFlag = false;
							$scope.percentRowFlag = true;
							$scope.percentAnnualFlag = false;
							break;	
						case measures.PercentageType.ANNUAL:
							$scope.percentColFlag = false;
							$scope.percentRowFlag = false;
							$scope.percentAnnualFlag = true;
							break;
					}   
				}
				
				$scope.btnPercentagesHideClick = function() {
					$("#statsMainForm").css("display", "block");
					$("#statsPrctForm").css("display", "none");
				}

				$scope.showStatsItemHelp = function(item) {
					$rootScope.$broadcast('openHelpEvent',item);	
				}
				
				$scope.chkPercentValue = function(item) {
					$rootScope.displayTablePercentageType = null;
					switch(item) {	
						case measures.PercentageType.COLUMN:
							if($scope.percentColFlag) {
								$rootScope.displayTablePercentageType = item;
								$scope.percentRowFlag = false;
								$scope.percentAnnualFlag = false;
								$rootScope.displayTableTotals = $scope.totalsFlag = true;
							}
							updateTable();
							break;
						case measures.PercentageType.ROW:
							if($scope.percentRowFlag) {
								$rootScope.displayTablePercentageType = item;
								$scope.percentColFlag = false;
								$scope.percentAnnualFlag = false;
								$rootScope.displayTableTotals = $scope.totalsFlag = true;
							}
							updateTable();
							break;	
						case measures.PercentageType.ANNUAL:
							if($scope.percentAnnualFlag) {
								$rootScope.displayTablePercentageType = item;
								$scope.percentColFlag = false;
								$scope.percentRowFlag = false;
								$rootScope.displayTableTotals = $scope.totalsFlag = true;
							}
							updateTable();
							break;
					}
					$("#statsMainForm").css("display", "block");
					$("#statsPrctForm").css("display", "none");
					$("#table-stats-btn").dropdown('toggle');
					gtag('event', ($rootScope.displayVisType == 'pivot-table' ? 'TB-':'CB-')  + $rootScope.survey.abbreviation + '-Toggle On Percentages', {
						'event_label': 'apply',
						'event_category': 'percentages',
						'event_variable': item
					});
				}
			}
		]);
});

'use strict'
define('scripts/controllers/layoutCtrl',["scripts/shared/appUtilities"],function (appUtilities) {		
	angular.module("appModule").controller('layoutCtrl', ['$scope','$rootScope', '$location', 
    function($scope, $rootScope, $location) {
		$scope.connectionOffline = false;
		//$rootScope.showFirstStepTip = true;
        
		if($location.hash().length > 0) {
			$location.url('/'+$location.hash().toLowerCase());
		}
    
		appUtilities.cleanUrlParams($location);
		window.addEventListener("offline", (event) => {
			console.log("offline");
			$scope.connectionOffline = true;
			$scope.disableScreen();
		  });
		  
		window.addEventListener("online", (event) => {
			console.log("online");
			$scope.connectionOffline = false;
			$scope.enableScreen();
		});
		
		$scope.disableScreen = function() {
			$('#offlineErrorMsg').text("The page has been disabled while your local network connection is offline. Once reconnected, the page will enable automatically.");
			$('#offlineAdditionalErrorMsg').text("If you believe this was received in error, press Close. Optionally, you can contact IT Help Central 703-292-HELP (x4357) or 800-711-8084 (Hours: 6AM - 7PM).");
			$('#DisplayOfflineErrorMessage').modal({toggle: true, backdrop: 'static', keyboard: false});	
		}

		$scope.enableScreen = function() {
			$('#DisplayOfflineErrorMessage').modal('hide')
		}

	}]);
});

'use strict'
define('scripts/controllers/surveyListCtrl',[],function () {

	angular.module("appModule").controller('SurveyListCtrl', ['$scope', function($scope) {		
		$scope.toggleIcon = function(obj,card) {
			//var toggle = obj.currentTarget.attributes["data-toggle"];
			var expanded = $('#' + card)[0].classList.contains("collapsing");
			if(expanded)
				return;
			
			if(obj.target.tagName == 'I') {
				$(obj.target).toggleClass( "fa-angle-up fa-angle-down" );
			} else {
				$(obj.target).find("I").toggleClass( "fa-angle-up fa-angle-down" );	
			}			
		}
	}]);  
});	

/**
 * @license text 2.0.16 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/text/LICENSE
 */
/*jslint regexp: true */
/*global require, XMLHttpRequest, ActiveXObject,
  define, window, process, Packages,
  java, location, Components, FileUtils */

define('text',['module'], function (module) {
    'use strict';

    var text, fs, Cc, Ci, xpcIsWindows,
        progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'],
        xmlRegExp = /^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im,
        bodyRegExp = /<body[^>]*>\s*([\s\S]+)\s*<\/body>/im,
        hasLocation = typeof location !== 'undefined' && location.href,
        defaultProtocol = hasLocation && location.protocol && location.protocol.replace(/\:/, ''),
        defaultHostName = hasLocation && location.hostname,
        defaultPort = hasLocation && (location.port || undefined),
        buildMap = {},
        masterConfig = (module.config && module.config()) || {};

    function useDefault(value, defaultValue) {
        return value === undefined || value === '' ? defaultValue : value;
    }

    //Allow for default ports for http and https.
    function isSamePort(protocol1, port1, protocol2, port2) {
        if (port1 === port2) {
            return true;
        } else if (protocol1 === protocol2) {
            if (protocol1 === 'http') {
                return useDefault(port1, '80') === useDefault(port2, '80');
            } else if (protocol1 === 'https') {
                return useDefault(port1, '443') === useDefault(port2, '443');
            }
        }
        return false;
    }

    text = {
        version: '2.0.16',

        strip: function (content) {
            //Strips <?xml ...?> declarations so that external SVG and XML
            //documents can be added to a document without worry. Also, if the string
            //is an HTML document, only the part inside the body tag is returned.
            if (content) {
                content = content.replace(xmlRegExp, "");
                var matches = content.match(bodyRegExp);
                if (matches) {
                    content = matches[1];
                }
            } else {
                content = "";
            }
            return content;
        },

        jsEscape: function (content) {
            return content.replace(/(['\\])/g, '\\$1')
                .replace(/[\f]/g, "\\f")
                .replace(/[\b]/g, "\\b")
                .replace(/[\n]/g, "\\n")
                .replace(/[\t]/g, "\\t")
                .replace(/[\r]/g, "\\r")
                .replace(/[\u2028]/g, "\\u2028")
                .replace(/[\u2029]/g, "\\u2029");
        },

        createXhr: masterConfig.createXhr || function () {
            //Would love to dump the ActiveX crap in here. Need IE 6 to die first.
            var xhr, i, progId;
            if (typeof XMLHttpRequest !== "undefined") {
                return new XMLHttpRequest();
            } else if (typeof ActiveXObject !== "undefined") {
                for (i = 0; i < 3; i += 1) {
                    progId = progIds[i];
                    try {
                        xhr = new ActiveXObject(progId);
                    } catch (e) {}

                    if (xhr) {
                        progIds = [progId];  // so faster next time
                        break;
                    }
                }
            }

            return xhr;
        },

        /**
         * Parses a resource name into its component parts. Resource names
         * look like: module/name.ext!strip, where the !strip part is
         * optional.
         * @param {String} name the resource name
         * @returns {Object} with properties "moduleName", "ext" and "strip"
         * where strip is a boolean.
         */
        parseName: function (name) {
            var modName, ext, temp,
                strip = false,
                index = name.lastIndexOf("."),
                isRelative = name.indexOf('./') === 0 ||
                             name.indexOf('../') === 0;

            if (index !== -1 && (!isRelative || index > 1)) {
                modName = name.substring(0, index);
                ext = name.substring(index + 1);
            } else {
                modName = name;
            }

            temp = ext || modName;
            index = temp.indexOf("!");
            if (index !== -1) {
                //Pull off the strip arg.
                strip = temp.substring(index + 1) === "strip";
                temp = temp.substring(0, index);
                if (ext) {
                    ext = temp;
                } else {
                    modName = temp;
                }
            }

            return {
                moduleName: modName,
                ext: ext,
                strip: strip
            };
        },

        xdRegExp: /^((\w+)\:)?\/\/([^\/\\]+)/,

        /**
         * Is an URL on another domain. Only works for browser use, returns
         * false in non-browser environments. Only used to know if an
         * optimized .js version of a text resource should be loaded
         * instead.
         * @param {String} url
         * @returns Boolean
         */
        useXhr: function (url, protocol, hostname, port) {
            var uProtocol, uHostName, uPort,
                match = text.xdRegExp.exec(url);
            if (!match) {
                return true;
            }
            uProtocol = match[2];
            uHostName = match[3];

            uHostName = uHostName.split(':');
            uPort = uHostName[1];
            uHostName = uHostName[0];

            return (!uProtocol || uProtocol === protocol) &&
                   (!uHostName || uHostName.toLowerCase() === hostname.toLowerCase()) &&
                   ((!uPort && !uHostName) || isSamePort(uProtocol, uPort, protocol, port));
        },

        finishLoad: function (name, strip, content, onLoad) {
            content = strip ? text.strip(content) : content;
            if (masterConfig.isBuild) {
                buildMap[name] = content;
            }
            onLoad(content);
        },

        load: function (name, req, onLoad, config) {
            //Name has format: some.module.filext!strip
            //The strip part is optional.
            //if strip is present, then that means only get the string contents
            //inside a body tag in an HTML string. For XML/SVG content it means
            //removing the <?xml ...?> declarations so the content can be inserted
            //into the current doc without problems.

            // Do not bother with the work if a build and text will
            // not be inlined.
            if (config && config.isBuild && !config.inlineText) {
                onLoad();
                return;
            }

            masterConfig.isBuild = config && config.isBuild;

            var parsed = text.parseName(name),
                nonStripName = parsed.moduleName +
                    (parsed.ext ? '.' + parsed.ext : ''),
                url = req.toUrl(nonStripName),
                useXhr = (masterConfig.useXhr) ||
                         text.useXhr;

            // Do not load if it is an empty: url
            if (url.indexOf('empty:') === 0) {
                onLoad();
                return;
            }

            //Load the text. Use XHR if possible and in a browser.
            if (!hasLocation || useXhr(url, defaultProtocol, defaultHostName, defaultPort)) {
                text.get(url, function (content) {
                    text.finishLoad(name, parsed.strip, content, onLoad);
                }, function (err) {
                    if (onLoad.error) {
                        onLoad.error(err);
                    }
                });
            } else {
                //Need to fetch the resource across domains. Assume
                //the resource has been optimized into a JS module. Fetch
                //by the module name + extension, but do not include the
                //!strip part to avoid file system issues.
                req([nonStripName], function (content) {
                    text.finishLoad(parsed.moduleName + '.' + parsed.ext,
                                    parsed.strip, content, onLoad);
                }, function (err) {
                    if (onLoad.error) {
                        onLoad.error(err);
                    }
                });
            }
        },

        write: function (pluginName, moduleName, write, config) {
            if (buildMap.hasOwnProperty(moduleName)) {
                var content = text.jsEscape(buildMap[moduleName]);
                write.asModule(pluginName + "!" + moduleName,
                               "define(function () { return '" +
                                   content +
                               "';});\n");
            }
        },

        writeFile: function (pluginName, moduleName, req, write, config) {
            var parsed = text.parseName(moduleName),
                extPart = parsed.ext ? '.' + parsed.ext : '',
                nonStripName = parsed.moduleName + extPart,
                //Use a '.js' file name so that it indicates it is a
                //script that can be loaded across domains.
                fileName = req.toUrl(parsed.moduleName + extPart) + '.js';

            //Leverage own load() method to load plugin value, but only
            //write out values that do not have the strip argument,
            //to avoid any potential issues with ! in file names.
            text.load(nonStripName, req, function (value) {
                //Use own write() method to construct full module value.
                //But need to create shell that translates writeFile's
                //write() to the right interface.
                var textWrite = function (contents) {
                    return write(fileName, contents);
                };
                textWrite.asModule = function (moduleName, contents) {
                    return write.asModule(moduleName, fileName, contents);
                };

                text.write(pluginName, nonStripName, textWrite, config);
            }, config);
        }
    };

    if (masterConfig.env === 'node' || (!masterConfig.env &&
            typeof process !== "undefined" &&
            process.versions &&
            !!process.versions.node &&
            !process.versions['node-webkit'] &&
            !process.versions['atom-shell'])) {
        //Using special require.nodeRequire, something added by r.js.
        fs = require.nodeRequire('fs');

        text.get = function (url, callback, errback) {
            try {
                var file = fs.readFileSync(url, 'utf8');
                //Remove BOM (Byte Mark Order) from utf8 files if it is there.
                if (file[0] === '\uFEFF') {
                    file = file.substring(1);
                }
                callback(file);
            } catch (e) {
                if (errback) {
                    errback(e);
                }
            }
        };
    } else if (masterConfig.env === 'xhr' || (!masterConfig.env &&
            text.createXhr())) {
        text.get = function (url, callback, errback, headers) {
            var xhr = text.createXhr(), header;
            xhr.open('GET', url, true);

            //Allow plugins direct access to xhr headers
            if (headers) {
                for (header in headers) {
                    if (headers.hasOwnProperty(header)) {
                        xhr.setRequestHeader(header.toLowerCase(), headers[header]);
                    }
                }
            }

            //Allow overrides specified in config
            if (masterConfig.onXhr) {
                masterConfig.onXhr(xhr, url);
            }

            xhr.onreadystatechange = function (evt) {
                var status, err;
                //Do not explicitly handle errors, those should be
                //visible via console output in the browser.
                if (xhr.readyState === 4) {
                    status = xhr.status || 0;
                    if (status > 399 && status < 600) {
                        //An http 4xx or 5xx error. Signal an error.
                        err = new Error(url + ' HTTP status: ' + status);
                        err.xhr = xhr;
                        if (errback) {
                            errback(err);
                        }
                    } else {
                        callback(xhr.responseText);
                    }

                    if (masterConfig.onXhrComplete) {
                        masterConfig.onXhrComplete(xhr, url);
                    }
                }
            };
            xhr.send(null);
        };
    } else if (masterConfig.env === 'rhino' || (!masterConfig.env &&
            typeof Packages !== 'undefined' && typeof java !== 'undefined')) {
        //Why Java, why is this so awkward?
        text.get = function (url, callback) {
            var stringBuffer, line,
                encoding = "utf-8",
                file = new java.io.File(url),
                lineSeparator = java.lang.System.getProperty("line.separator"),
                input = new java.io.BufferedReader(new java.io.InputStreamReader(new java.io.FileInputStream(file), encoding)),
                content = '';
            try {
                stringBuffer = new java.lang.StringBuffer();
                line = input.readLine();

                // Byte Order Mark (BOM) - The Unicode Standard, version 3.0, page 324
                // http://www.unicode.org/faq/utf_bom.html

                // Note that when we use utf-8, the BOM should appear as "EF BB BF", but it doesn't due to this bug in the JDK:
                // http://bugs.sun.com/bugdatabase/view_bug.do?bug_id=4508058
                if (line && line.length() && line.charAt(0) === 0xfeff) {
                    // Eat the BOM, since we've already found the encoding on this file,
                    // and we plan to concatenating this buffer with others; the BOM should
                    // only appear at the top of a file.
                    line = line.substring(1);
                }

                if (line !== null) {
                    stringBuffer.append(line);
                }

                while ((line = input.readLine()) !== null) {
                    stringBuffer.append(lineSeparator);
                    stringBuffer.append(line);
                }
                //Make sure we return a JavaScript string and not a Java string.
                content = String(stringBuffer.toString()); //String
            } finally {
                input.close();
            }
            callback(content);
        };
    } else if (masterConfig.env === 'xpconnect' || (!masterConfig.env &&
            typeof Components !== 'undefined' && Components.classes &&
            Components.interfaces)) {
        //Avert your gaze!
        Cc = Components.classes;
        Ci = Components.interfaces;
        Components.utils['import']('resource://gre/modules/FileUtils.jsm');
        xpcIsWindows = ('@mozilla.org/windows-registry-key;1' in Cc);

        text.get = function (url, callback) {
            var inStream, convertStream, fileObj,
                readData = {};

            if (xpcIsWindows) {
                url = url.replace(/\//g, '\\');
            }

            fileObj = new FileUtils.File(url);

            //XPCOM, you so crazy
            try {
                inStream = Cc['@mozilla.org/network/file-input-stream;1']
                           .createInstance(Ci.nsIFileInputStream);
                inStream.init(fileObj, 1, 0, false);

                convertStream = Cc['@mozilla.org/intl/converter-input-stream;1']
                                .createInstance(Ci.nsIConverterInputStream);
                convertStream.init(inStream, "utf-8", inStream.available(),
                Ci.nsIConverterInputStream.DEFAULT_REPLACEMENT_CHARACTER);

                convertStream.readString(inStream.available(), readData);
                convertStream.close();
                inStream.close();
                callback(readData.value);
            } catch (e) {
                throw new Error((fileObj && fileObj.path || '') + ': ' + e);
            }
        };
    }
    return text;
});


define('text!BasicPivotTable/BasicPivotTable.css',[],function () { return '.qv-object {\r\n\tuser-select: text;\r\n\t-webkit-user-select: text;\r\n\t-moz-user-select: text;\r\n}\r\n#basic-pt-container {\r\n\tposition: static;\r\n\toverflow: hidden;\r\n\tmax-width: 3250px;\r\n\tborder-top: 4px solid #119DA4;\r\n\tfont-family: "Roboto", sans-serif!important;\r\n\tfont-size: 12px;\r\n\theight: 100%;\r\n}\r\n#basic-pt-container .full-table {\r\n\tposition: relative;\r\n}\r\n#basic-pt-container .scroll-wrapper {\r\n\toverflow-x: auto;\r\n\toverflow-y: auto;\r\n\tmax-height: 1380px;    \r\n\tposition: static;\r\n\twidth: 100%;\r\n\tpadding-right: 2px;\r\n\theight: 100%;\r\n\tborder-left: 1px solid #ccc;\r\n\tborder-right: 1px solid #ccc;\r\n}\r\n#basic-pt-container table.basic-pt {\r\n\tborder-collapse: separate;\r\n\tborder-spacing: 0;\r\n\tborder-bottom: 1px solid #ccc;\r\n}\r\n#basic-pt-container table.basic-pt th {\r\n\tfont-weight: 400;\r\n}\r\n#basic-pt-container table.basic-pt .scroll-padding {\r\n\tpadding: 0!important;\r\n\tdisplay: none;\r\n}\r\n#basic-pt-container .scroll-wrapper::-webkit-scrollbar-thumb {\r\n\tbackground: #A9B7C7 !important;\r\n\tborder-radius: 24px;\r\n}\r\n  \r\n#basic-pt-container .scroll-wrapper::-webkit-scrollbar-track{\r\n\tbackground: #FAFAFA !important;\r\n\tborder-radius: 0px !important;\r\n}\r\n#basic-pt-container .hdr {\r\n\tposition: -webkit-sticky;   \r\n\tposition: sticky; \r\n\ttop: 0;\r\n\tleft: 0;\r\n\tz-index: 2;\r\n}\r\n#basic-pt-container table.basic-pt thead tr{\r\n\tline-height:22px;\r\n\theight: 30px;\r\n\tbackground-color: #FAFAFA;\r\n}\r\n#basic-pt-container table.basic-pt thead th,\r\n#basic-pt-container table.basic-pt thead td {\r\n\ttext-align: center;\r\n\tborder: 1px solid #E8E8E8;\r\n\tfont-family: \'Roboto\',sans-serif;\r\n\tfont-style: normal;\r\n\tfont-size: 12px;\r\n\tcolor: #171717;\r\n}\r\n#basic-pt-container table.basic-pt thead tr .blank:first-child {\r\n\tposition: -webkit-sticky; \r\n\tposition: sticky;\r\n\tleft: 0;\r\n\ttop: 0;\t\r\n\topacity: 1;\r\n\tz-index: 1;\r\n\tbackground-color: #FAFAFA; \r\n\tborder-top: none;\r\n\tborder-bottom: none;\r\n}\r\n#basic-pt-container table.basic-pt thead th.bold-txt{\r\n\tfont-weight: bold;\r\n}\r\n#basic-pt-container table.basic-pt tbody tr:nth-child(even){\r\n\tbackground-color: #FAFAFA;\r\n}\r\n#basic-pt-container table.basic-pt tbody tr:nth-child(odd){\r\n\tbackground-color: #FFFFFF;\r\n}\r\n#basic-pt-container table.basic-pt tbody tr {\r\n\tline-height: 26px;\r\n\theight: 26px;\r\n}\r\n#basic-pt-container table.basic-pt tbody td {\r\n\tpadding: 1px 2px;\r\n\tborder: 1px solid #E8E8E8;\r\n\ttext-align: center;\r\n\tfont-family: "Roboto", sans-serif!important;\r\n\tfont-size: 12px;\t\r\n}\r\n#basic-pt-container table.basic-pt tbody th,\r\n#basic-pt-container table.basic-pt tbody tr td:first-child {\r\n\tposition: -webkit-sticky;\r\n\tposition: sticky;\r\n\tleft: 0;\r\n\topacity: 1;\r\n\tbackground-color: #FAFAFA;\r\n\tborder: 1px solid #E8E8E8;\r\n}\r\n#basic-pt-container table.basic-pt .lui-icon--minus, #basic-pt-container table.basic-pt .lui-icon--plus {\r\n\tdisplay: inline-block;\r\n\tvertical-align: baseline;\r\n\tfont-size: 10px;\r\n\tcolor: #005495;\r\n\tpadding:0px 5px 0px 3px;\r\n}\r\n#basic-pt-container table.basic-pt .bold-txt  {\r\n\tfont-weight: 700;\r\n}\r\n#basic-pt-container table.basic-pt th.selectable:hover {\r\n\tcursor:pointer;\r\n}\r\n#basic-pt-container table.basic-pt td.selectable:hover {\r\n\tcursor:pointer;\r\n}\r\n#basic-pt-container table.basic-pt > tbody > tr[data-row]:hover  {\r\n\tbackground-color: #e6e6ff;\r\n}\r\n#basic-pt-container .md-text {\r\n\tcolor: #333333;\r\n\tfont-family: "Roboto", sans-serif!important;\r\n\tfont-weight: normal;\r\n\tfont-size: 12px;\t\r\n}\r\n#basic-pt-container .sm-margin {\r\n\tmargin:10px;\r\n}\r\n#basic-pt-container .bold-border-left {\r\n\tborder-left: 2px solid #D8D8D8!important;\r\n}\r\n#basic-pt-container a {\r\n\ttext-decoration: underline;\r\n}\r\n\t\r\n#basic-pt-container #single-measure {\r\n\tline-height: 30px; \r\n\theight: 30px; \r\n\twidth: 100%; \r\n\tborder:1px solid #ccc; \r\n\tbackground-color: #fafafa; \r\n\ttext-align: center;\r\n}\r\n';});

'use strict'
define( 'BasicPivotTable/basicPivotTable',["qlik", "jquery", "text!./BasicPivotTable.css"],
	function (qlik, $,  cssContent) {
		$("<style>").html(cssContent).appendTo("head");
		
		const scrollevent = {
			UP: 'up',
			DOWN: 'down',
			RESET: 'reset',
			LEFT: 'left',
			RIGHT: 'right'
		}
			
		var ptProps = {
			maxRowCount: 40,
			maxColCount: 20,
			rowStart: 0,
			rowCount: 0,
			rowHeight: 30,
			colCount: 0,
			colStart: 0,
			colWidth: 130,
			nodePadding: 2,
			scrollTopPrevOffset: 0,
			scrollLeftPrevOffset: 0,
			scrollRowPadding: 0,
			qcx: 0,
			qcy: 0,		
			leftDimsCnt: 0,
			topDimRowsCnt: 0,
			dataPages: 0,
			matrix: null
		};
		
		var refreshExpandCollapseCell = false;
		var _scrollTbl;
		
		Array.matrix = function(numrows, numcols, initial) {
			var arr = [];
			for (var i = 0; i < numrows; ++i) {
				var columns = [];
				for (var j = 0; j < numcols; ++j) {
					columns[j] = initial;
				}
				arr[i] = columns;
			}
			return arr;
		};
		
		return {
		beforeDestroy: function() {
			refreshExpandCollapseCell=false;
		},
		paint: function ( $element, layout ) {
			var caller = this;
			var hc = layout.qHyperCube; 
			let showTotalsNotice = this.$scope.$parent.$root.survey.showTotalsNotice;

			let colNotes = [], rowNotes = [];
			let totalsId = 96, headerRow = -1;
			ptProps.qcx = hc.qSize.qcx;
			ptProps.qcy = hc.qSize.qcy;		

			//let scrollTopPrevOffset, scrollLeftPrevOffset, scrollRowPadding;
			if(refreshExpandCollapseCell == true) {
				refreshExpandCollapseCell = false;
				applyExpandCollapse(ptProps.rowStart, ptProps.colStart).then(function() {
					addScrollPadding();
					//scrollTopPrevOffset = ptProps.colStart;
					//scrollLeftPrevOffset = ptProps.rowStart;
					attachControlEvents();				
				});
				return;		
			}

			ptProps.dataPages = hc.qPivotDataPages[0];
			ptProps.colCount = ptProps.dataPages.qArea.qWidth;
			ptProps.rowCount = ptProps.dataPages.qArea.qHeight;
			ptProps.leftDimsCnt = hc.qNoOfLeftDims;
			ptProps.totalDimsCnt = hc.qDimensionInfo.length;
			ptProps.topDimRowsCnt = hc.qEffectiveInterColumnSortOrder.length - hc.qNoOfLeftDims==0?1:hc.qEffectiveInterColumnSortOrder.length - hc.qNoOfLeftDims; 

			ptProps.scrollTopPrevOffset = 0, ptProps.scrollLeftPrevOffset = 0, ptProps.scrollRowPadding = 0;
			ptProps.rowStart = 0;
			ptProps.colStart = 0;


			buildTable();

			function getRequestPage(startRow, startCol, pageLen, pageWidth) {
				var requestPage = [{
					qTop: startRow,
					qLeft: startCol,
					qWidth: pageWidth, 
					qHeight: pageLen
				}];	
				return requestPage;
			}
			
			function buildTable() {
				//build container to hold table if it doesn't exist
				var container = $element.find('#basic-pt-container');
				if(container.length == 0) {
					let outterDiv = $('<div></div>')
					outterDiv.attr("id", "basic-pt-container");
					$element.append(outterDiv);	
				}
		
				if(container) {
					container.empty();
				}

				if(hc.qMeasureInfo.length == 1) {
					if (ptProps.leftDimsCnt < ptProps.totalDimsCnt) {
						let hdr = '<div id="single-measure">';
						
						hdr += hc.qMeasureInfo[0].qFallbackTitle; 
						hdr += '</div>';
						container.append(hdr);
					}
				}

				//build container to hold table if it doesn't exist
				let table = '<table class="basic-pt scroll">'; 	
				table += '<thead class="hdr">';
				table += buildHeaderRows(ptProps.colStart)
				table += '</thead><tbody>';
				
				var htmlRows = buildRows();
				for(var x=0; x < htmlRows.length; x++) {
					table += htmlRows[x];
				}
				table += '</tbody>';
				table += '</table>';

 				let $scrollTbl = $(table);
				let $hdrTbl = $scrollTbl.find("thead");
				let $swrap = $('<div class="scroll-wrapper" tabindex="0"/>');

				//setup virtual scroll window to represent the full set of data
				let $fullDiv = $('<div class="full-table" />');
				$fullDiv.append($scrollTbl);
				$swrap.append($fullDiv);
				container.append($swrap);

				let footer = $("<div id='tblFooter' />");
				let footerText = buildTblFooter();
				footer.append(footerText) 
				container.append(footer);

				attachCellEvents($hdrTbl);
				attachCellEvents($scrollTbl.find("tbody"));
				attachControlEvents();
				resizeScrollTbl();
			}; //end of BuildTable

			function buildHeaderRows(col) {
				var hdr = '';
				//var nodes = ptProps.dataPages.qTop;	
				ptProps.matrix = buildMatrix();
				
				totalsId = 96;
				colNotes = [];
				headerRow = -1;

				for(var r = 0; r < ptProps.matrix.length; r++) {
					if((function() {
						for(var i=0; i< ptProps.matrix[r].length;i++) {
							if(ptProps.matrix[r][i].qText != null)
								return true;
						}
						return false;
					})()==true){
						hdr = processHeaderRow(hdr, r, ptProps.matrix, col); 
					}
				}
				//console.log(ptProps.matrix);
				return hdr;
			}

			function processHeaderRow(table, r, matrix, colStart) {
				let rowCells = matrix[r];
				table += '<tr data-row="' + r + '">';
				var noLeftHdr = (ptProps.leftDimsCnt==0?1:ptProps.leftDimsCnt);
				table += '<td class="blank" aria-label="No value" style="min-width: ' + ptProps.colWidth + 'px;" colspan="' + noLeftHdr + '"><span style="visibility:hidden">No data</span></td>';
				table += '<td class="scroll-padding"  aria-label="no value"><div style="width:0; visibility:hidden"></div></td>'
				let totalsCol = false;
				for (var c = 0; c < rowCells.length; c++) {
					var node = rowCells[c];	
					if(node == null || node.qType == null) {
						colStart++;
						continue;
					}

					var classes = "";
					if(matrix[0][c].qType != null) {
						classes = "bold-border-left "; 
					}
					if(node.qType == 'E') {
						table += '<td aria-label="no value"' + ' data-col="' + colStart + '" colspan="' + node.colSpan + 
						'" style="min-width:' + ptProps.colWidth + 'px;" class="blank cell ' + classes + (colStart==0?"first":"other") + '"><span style="visibility:hidden">No data</span></td>';
					} else if(node.qType == "T") {
						if(node.qText == null) {
							table += '<td aria-label="no value"' + ' data-col="' + colStart + '" colspan="' + node.colSpan + 
							'" style="min-width:' + ptProps.colWidth + 'px;" class="blank cell ' + classes + (colStart==0?"first":"other") + '"><span style="visibility:hidden">No data</span></td>';							
						} else {
							classes += " bold-txt totals ";
							totalsCol = true;
							let nodeLabel = node.qText;
							let ndx = r + hc.qNoOfLeftDims  //get dim that is in column section

							//ensure that we only show a single footer per total when the same total appears for multiple columns
							if(r != headerRow) {
								headerRow = r;
								totalsId++;
								//account for pseudo dim Values (-1) by using the columnSortOrder as lookup index rather than row position in matrix
								colNotes.push({id: totalsId, text: "Total based on selected " + hc.qDimensionInfo[hc.qEffectiveInterColumnSortOrder[ndx]].qFallbackTitle + " categories"});
							}
							nodeLabel += '<a class="ml-1" id="note_' + totalsId + '_ref" data-total-id="note_' + totalsId + '" href="javascript:void(0)" aria-labelledby="table_footer_notes"><sup>' + String.fromCharCode(totalsId) + '</sup></a>';
							table += '<th id="total-' + r + '" data-col="' + colStart + '" colspan="' + node.colSpan + '" style="min-width:' + ptProps.colWidth + 
							'px;" class="' + classes + ' cell ' + (colStart==0?"first":"other") + '">' + nodeLabel + '</th>';
						}
					} else {
						
						classes += colStart==0?"":" other";

						var dataSign, sign;
						if(node.qCanExpand == true) {
							sign = '+';
							classes += " bold-txt selectable";
							dataSign = ' data-pos-sign="header"';
						} else if(node.qCanCollapse == true) {
							sign = '-';
							classes += " bold-txt selectable";
							dataSign = ' data-neg-sign="header"';
						} else {
							sign = '';
							dataSign = '';
						}
						
						table += '<th id="' + r + '-' + colStart + '" style="min-width:'+ptProps.colWidth+'px;" colspan="' + node.colSpan + '" class="' + classes + '"' +
							' data-col="' + colStart + '" ' + dataSign + '>'; 
						if(sign == '+') {
							table +=  '<span class="lui-icon lui-icon--plus"></span>'; 
						} else if(sign == '-') {
							table +=  '<span class="lui-icon lui-icon--minus"></span>'; 
						}
						table += node.qText;
						table += '</th>';
					}
					colStart++;
				}
				table += '</tr>';
				return table;
			}
			
			function buildRows() {
				var htmlRows = [];
				rowNotes = [];
				var dataRowCnt = 0, tblColCnt = 0, nodeCol = 0, qlikRowIndx = ptProps.rowStart;
				try {
					//if table has no selected variables in the Rows section, show empty first column 
					if( ptProps.dataPages.qLeft.length == 0 && ptProps.dataPages.qData.length > 0 && ptProps.dataPages.qData[0].length > 0) {
						var node = {};
						node.qElemNo = 1;
						node.qText = "";
						node.qSubNodes = [];
						var obj = processDataNode(node, ptProps.dataPages, dataRowCnt, qlikRowIndx, tblColCnt, true, -1);
						dataRowCnt = obj.dataRowCnt;
						qlikRowIndx = obj.qlikRowIndx;
						htmlRows.push(obj.tblRow);
						tblColCnt=0;
					} else {
						//table has at least one variable in rows section
						for (var r = 0; r < ptProps.dataPages.qLeft.length; r++) {
							if(dataRowCnt >= ptProps.dataPages.qData.length)
								break;
							var obj;
							
							var node = ptProps.dataPages.qLeft[r];
							var psuedoNodes = findPsuedoNodes(node); 
							if(psuedoNodes.length > 0) {
								var lbl = node.qText;
								for (var pseudoCnt = 0; pseudoCnt < psuedoNodes.length; pseudoCnt++) {
									if(dataRowCnt >= ptProps.dataPages.qData.length)
										break;
									node.qText =  lbl + ' - ' + psuedoNodes[pseudoCnt].qText;
									var expandLeg = false;
									if(pseudoCnt == psuedoNodes.length-1) {
										expandLeg = true;  //last pseudo item, so write all subnodes
									} else if(node.qSubNodes.length > 0 && node.qSubNodes[0].qType=='P') {
										expandLeg = true; //subnodes are pseudo nodes, so expand the parent nodes
									}

								obj = processDataNode(node, ptProps.dataPages, dataRowCnt, qlikRowIndx, tblColCnt, expandLeg, pseudoCnt, true);
									dataRowCnt = obj.dataRowCnt;
									qlikRowIndx = obj.qlikRowIndx;
									htmlRows.push(obj.tblRow);
								}
							} else {
							obj = processDataNode(node, ptProps.dataPages, dataRowCnt, qlikRowIndx, tblColCnt, true, -1, true);	
								dataRowCnt = obj.dataRowCnt;
								qlikRowIndx = obj.qlikRowIndx;
								htmlRows.push(obj.tblRow);
							}
							tblColCnt=0;
						}
					}
					return htmlRows;
					
				} catch (err)
				{
					console.log('err process root',err);
				}
			}
				
			function processDataNode(node, dataPage, dataRowCnt, qlikRowIndx, col, expandLeg, pseudoCnt, isTopLevelPseudoNode) {
				let tblRow = '';
				//write html for currrent node 
				if((node.qText != null && isTopLevelPseudoNode)||(node.qText != null && node.qType != 'P')) {
					let sign='', dataSign = '', clBold = '', clSelectable='', spanIcon = '';
					let lpad = (col * 20) + 2;	
					let nodeLabel = node.qText;
					if(node.qSubNodes.length > 0 &&  node.qType == 'P') {
						clBold = ' bold-txt ';
						lpad += 3;
					} else if(node.qType == 'T') {
						clBold = ' bold-txt totals';
						if(hc.qNoOfLeftDims > 0) {
							totalsId++;
							if(hc.qEffectiveInterColumnSortOrder[hc.qNoOfLeftDims -1] == -1) {
								//row is for measure, since the total row for measure already specifies "Total" with measure label, no need for footer
								//rowNotes.push({id: totalsId, text: "Total - all selected " + node.qText + " categories"});
							} else {
								rowNotes.push({id: totalsId, text: "Total based on selected " + hc.qDimensionInfo[0].qFallbackTitle + " categories"});
								nodeLabel += "<a class='ml-1' id='note_" + totalsId + "_ref' data-total-id='note_" + totalsId + "' href='javascript:void(0)' aria-labelledby='table_footer_notes'><sup>" + String.fromCharCode(totalsId) + "</sup></a>";
							}
						}
					} else if(node.qCanExpand == true) {
						sign = '+';
						clBold = ' bold-txt ';
						clSelectable = ' selectable ';
						dataSign = ' data-pos-sign="data"';
						spanIcon = '<span class="lui-icon lui-icon--plus" ></span>'; 	
					} else if(node.qCanCollapse == true) {
						sign = '-';
						clBold = ' bold-txt ';
						clSelectable = ' selectable ';
						dataSign = ' data-neg-sign="data"';
						spanIcon = '<span class="lui-icon lui-icon--minus"></span>'; 
					}		
					
					let noLeftHdr = (ptProps.leftDimsCnt==0?1:ptProps.leftDimsCnt);
					tblRow += '<tr data-row="' + qlikRowIndx + '">';
					let rowHdId = 'r' +  qlikRowIndx;

					if(node.qText=='') {
						tblRow += '<td colspan="' + noLeftHdr + '" id="' + rowHdId
						+ '" aria-label="no value"'
						//+ ' style="width: 1%; min-width: 1%; max-width: 1%; white-space: nowrap;' 
						+ ' style="white-space: nowrap;' 
						+ ' padding-left:' + lpad + 'px; padding-right:' + lpad + 'px;"' + ' data-col="' + col + '"></td>' 

					} else {
						tblRow += '<th colspan="' + noLeftHdr + '" id="' + rowHdId
							+ '" style="white-space: nowrap;'  
							// + '" style="width: 1%; min-width: 1%; max-width: 1%; white-space: nowrap;'  
							+ ' padding-left:' + lpad + 'px; padding-right:' + lpad + 'px;"' + ' data-col="' + col + '"' + dataSign + ' class="' + clBold + clSelectable + '">';				
						tblRow += spanIcon; 
						tblRow += nodeLabel
						tblRow += '</th>';
					}
					tblRow += '<td class="scroll-padding" aria-label="no value"><div style="width:0; visibility:hidden"></div></td>'

					// iterate over all cells within a row
					let dataRow = dataPage.qData[dataRowCnt];
					for (var c = 0; c < dataRow.length; c++) {
						//if row header cell is bolded then all row data cells are rollups so bold them
						let classes = clBold;
						//If row header cell is not bolded, need to check is column header cell bolded, if so, then all column data cells are rollups so bold them
						if(classes == '') {
							for(let r = 0; r < ptProps.matrix.length; r++) {
								for(let s = 0; s < ptProps.matrix[r].length; s++) {
									if(ptProps.matrix[r][s] != null && ptProps.matrix[r][s].qType == 'T') {
										//account for data cell that falls under total header cell that spans columns
										let e = s + (ptProps.matrix[r][s].colSpan -1);
										if(c >= s && c <= e) {
											classes = ' bold-txt ';
											break;
										}
									}
								}
							}
						}
						if(ptProps.matrix[0][c].qType != null) {
							classes += " bold-border-left "; 
						}
						tblRow += '<td colspan="1" ' +  ' headers="' + rowHdId + ' ' + getHeadersAttribute(c) +'" class="' + classes + (c==0?'first ':'other ') + (dataRow[c].qType=='U'?' empty ':'') + (dataRow[c].qNum != 'NaN'?' numeric ':'')+ '">';
							tblRow += dataRow[c].qText;
						tblRow += '</td>';
					}

					tblRow += '</tr>';
					dataRowCnt++;
					qlikRowIndx++;
				} 
				var nodeCol = col + 1;
				try {
					//process the current node's subnodes
					if(expandLeg) {
						//if multiple measures selected (psuedo node exists) then need to perform special processing:
						//recursive call processNodes() for each psuedo node and process its subnodes
						var psuedoNodes = findPsuedoNodes(node);
						if(psuedoNodes.length > 0 && dataRowCnt < dataPage.qData.length) {
							if(node.qSubNodes.length > 0 && node.qSubNodes[0].qType=='P') {
								//block invoked as part of paging - processes a specific pseudo node 
								//so that data lines up with previous page's data
								var subNode = node.qSubNodes[pseudoCnt];  //pseudo node	
								var obj = processDataNode(subNode, dataPage, dataRowCnt, qlikRowIndx, nodeCol, true, pseudoCnt, false);													
								dataRowCnt = obj.dataRowCnt;
								qlikRowIndx = obj.qlikRowIndx;
								tblRow += obj.tblRow;	
							} 
							else {
								//block invoked when row subnode is expanded
								for (var r = 0; r < node.qSubNodes.length; r++) {
									if(dataRowCnt >= dataPage.qData.length)
										break;
									var subNode = node.qSubNodes[r];
									if(subNode.qElemNo !== -1) {
										var lbl = subNode.qText;
										for (var cnt = 0; cnt < psuedoNodes.length; cnt++) {
											if(dataRowCnt >= dataPage.qData.length)
												break;
											var expandLeg = false;
											subNode.qText = lbl;
											if(cnt == psuedoNodes.length-1) {
												expandLeg = true;  //last pseudo item, so write all subnodes
											} else if(subNode.qSubNodes.length > 0 && subNode.qSubNodes[0].qType=='P') {
												expandLeg = true; //subnodes are pseudo nodes, so expand the parent nodes
											}
											if(subNode.qText != null) {
												if(psuedoNodes[cnt].qText == null) {
													subNode.qText = null;	
												}
												else {
													subNode.qText = lbl + ' - ' + psuedoNodes[cnt].qText;
												}
											} 
											
											var obj = processDataNode(subNode, dataPage, dataRowCnt, qlikRowIndx, nodeCol, expandLeg, cnt, false);
											dataRowCnt = obj.dataRowCnt;
											qlikRowIndx = obj.qlikRowIndx;
											tblRow += obj.tblRow;
										}
									}
								}
							}
						} else {
							//default block, invoked when only 1 measure selected
							for (var r = 0; r < node.qSubNodes.length; r++) {
								if(dataRowCnt >= dataPage.qData.length)
									break;
								var obj = processDataNode(node.qSubNodes[r], dataPage, dataRowCnt, qlikRowIndx, nodeCol, true, -1, false);	
								dataRowCnt = obj.dataRowCnt;
								qlikRowIndx = obj.qlikRowIndx;
								tblRow += obj.tblRow;
							}
						}
					}
				} catch (err)
				{
					console.log('err process subnode',err);
				}
				return {"dataRowCnt" : dataRowCnt, "qlikRowIndx": qlikRowIndx, "tblRow" : tblRow};
			}	

			function buildMatrix() {
				var hdrCol = 0;
				var hdrRow = 0;
				var nodes = ptProps.dataPages.qTop;
				
				//create matrix with size matching data page qTop height and width (qTop array defines the column headers)
				var matrix = Array.matrix(ptProps.topDimRowsCnt,ptProps.colCount,{});
				//populate matrix cells based on position of qTop node/subnode
				for (var c = 0; c < nodes.length; c++) {	
					var node = nodes[c];
					matrix[hdrRow][hdrCol] = node;
					//set colspan used by html tbl tag, set to number of empty matrix cells between cells with values
					node.colSpan = populateMatrixCells(node, matrix, hdrRow+1, hdrCol);
					hdrCol += node.colSpan;
				}
				
				function populateMatrixCells(node, matrix, row, col) {
					var ret = 0;
					for (var c = 0; c < node.qSubNodes.length; c++) {
						var subnode = node.qSubNodes[c];
						matrix[row][col] = subnode;
						subnode.colSpan = populateMatrixCells(subnode, matrix, row+1, col);
						col += subnode.colSpan;
						ret += subnode.colSpan;
					}
					return (ret == 0?1: ret);
				}
				return matrix;
			}

			function buildTblFooter() {
				if(colNotes.length > 0 || rowNotes.length > 0) {
					let str = "<div class='py-2' id='table_footer_notes'>"
					if(showTotalsNotice) {
						//Show footer msg when UoM is over 1 or if UoM is 0 (which means UoM does not apply)
						if (caller.$scope.$root.unitsOfMeasureValue != 1) {
							str += "<div>Note(s): Because of rounding, detail may not add to total.</div>"
						}
					} 
					for(let x = 0; x < colNotes.length; x++) {
						str += '<div class="ml-1"><a id="note_' + colNotes[x].id + '" href="javascript:void(0)" aria-label="Return to content"><sup>' + 
							String.fromCharCode(colNotes[x].id) + '</sup></a>' + '<span class="ml-1">' + colNotes[x].text + '</span></div>';
					};
					for(let x = 0; x < rowNotes.length; x++) {
						str += '<div class="ml-1 pr-1"><a id="note_' + rowNotes[x].id + '" href="javascript:void(0)" aria-label="Return to content"><sup>' + 
							String.fromCharCode(rowNotes[x].id) + '</sup></a>' + '<span class="ml-1">' + rowNotes[x].text + '</span></div>';
					};                   
					str += "</div>";
					let $str = $(str);
					let elems = $str.find('a');
					for (var x = 0; x < elems.length; x++) {
						let id = $(elems[0]).attr("id")
						$(elems[x]).on('click', {id: id + "_ref"}, scrollToNote);	
					}
					return $str;
				}
				return "";
			}

			function getHeadersAttribute(nodeCol) {
				var headers = "";
				for(var r = 0; r < ptProps.matrix.length; r++) {
					for(var i=0; i< ptProps.matrix[r].length;i++) {
						if( ptProps.matrix[r][i].colSpan == null)
							continue;
						if(ptProps.matrix[r][i].qType == null ||
							ptProps.matrix[r][i].qType == 'E')
							continue;
						var cols = (i + ptProps.matrix[r][i].colSpan);
						if(nodeCol == i || (nodeCol > i && nodeCol < cols))
						{
							headers += " "+ r + "-" + i;
							continue;
						}
					}
				}
				return headers.trim();
			}
			
			function findPsuedoNodes(node) {
				//qType='P' means node is psuedo type which means multiple measures
				//This function is used to identify when a pseudo (2 or more measures) has been applied to table
				var psuedoNodes = [];
				if(node.qType == 'P') {
					null;
				} else {
					for (var c = 0; c < node.qSubNodes.length; c++) {
						if(node.qSubNodes[c].qType == 'P') {
							psuedoNodes.push(node.qSubNodes[c]);
						} else {
							if(node.qSubNodes[c].qSubNodes !=null &&
								node.qSubNodes[c].qSubNodes.length > 0)
								psuedoNodes = findPsuedoNodes(node.qSubNodes[c]);
								psuedoNodes = findPsuedoNodes(node.qSubNodes[c]);
								if(psuedoNodes.length > 0)
									break;
						}
					}	
				}
				//console.log('psuedoNodes', psuedoNodes)
				return psuedoNodes;
			}

			function getSingleDataPage(requestPage) {
				var Promise = qlik.Promise;
				return new Promise(function(resolve, reject) {	
					caller.backendApi.getPivotData( requestPage ).then(function ( data) {
						ptProps.dataPages = data[0];
						ptProps.colStart = ptProps.dataPages.qArea.qLeft;
						ptProps.rowStart = ptProps.dataPages.qArea.qTop;
						ptProps.colCount = ptProps.dataPages.qArea.qWidth;
						ptProps.rowCount = ptProps.dataPages.qArea.qHeight;	

						ptProps.qcx = hc.qSize.qcx;
						ptProps.qcy = hc.qSize.qcy;	

						let hdr = buildHeaderRows(ptProps.colStart);
						let $hdr = $(hdr);
						attachCellEvents($hdr);
						let $tblHdr = $("table.basic-pt thead");
						$tblHdr.empty();
						$tblHdr.append($hdr);

						try {
							var htmlRows = buildRows();
							return resolve(htmlRows);
						} catch (err) {
							console.log('process page warning',err.message);
							return reject(err);
						}
					}, function(err) {
						console.log('single page warning',err.message);
						return reject(err);
					})
				});	
			}
			
			function resizeScrollTbl() {
				let scrollwrp = $(".scroll-wrapper");
				if(scrollwrp.length == 0)
					return;

				//const containerBorder = 4;  //this is the space used for border in frame for scrolling table, 4px top, 1px bottom border, 1px extra
				const scrollbarSize = 12;
				let minScrollContainerHt =  64;

				let tbl = $("table.basic-pt");
				let tblHdr = tbl.find("thead");
				let noticeHt = $(".survey-notice").outerHeight();
				//tbl bottom border 1px
				let displayHt = 1 + tblHdr.outerHeight() + (ptProps.rowCount * ptProps.rowHeight); 

				let maxWindowScrollHt = window.innerHeight - (window.innerHeight * .25)
				let maxDataScrollHt = tblHdr.outerHeight() + ((ptProps.maxRowCount - ptProps.nodePadding) * ptProps.rowHeight);
				let maxTblScrollHt = Math.min(maxWindowScrollHt, maxDataScrollHt)

				//minScrollContainerHt -= noticeHt;
				if(scrollwrp[0].clientWidth < scrollwrp[0].scrollWidth) {
				   minScrollContainerHt -= scrollbarSize; //account for horizontal scrollbar
				   maxTblScrollHt += scrollbarSize; //account for horizontal scrollbar
				   displayHt += scrollbarSize;
				}

				if (displayHt < minScrollContainerHt) {
					displayHt = minScrollContainerHt;
				} else if( displayHt > maxTblScrollHt) {
					displayHt = maxTblScrollHt;  //enable height of scroll tbl to expand until maxScroll size
				}

				let contentHeight = (ptProps.qcy * ptProps.rowHeight);
				let fullDiv = $('.full-table');
				let totalContentWidth = (ptProps.qcx * ptProps.colWidth) + ptProps.colWidth;
				fullDiv.css({"height": contentHeight + "px", "width": totalContentWidth + "px"});
				
				let scrollWidth = scrollwrp.width();
				if(scrollwrp[0].clientHeight < scrollwrp[0].scrollHeight) {
					scrollWidth -= scrollbarSize;
				}
				tbl.css("width", scrollWidth + "px");   


				let tblFooterHt = $("#tblFooter").outerHeight() == null?0:$("#tblFooter").outerHeight(); 
				let singleMsr = $("#single-measure").outerHeight()== null?0:$("#single-measure").outerHeight();

				var containerHt = $element.find('#basic-pt-container').innerHeight();
				let displayPadding = 0;
				if(displayHt + singleMsr + tblFooterHt > containerHt)
					displayPadding = displayHt + singleMsr + tblFooterHt - containerHt;

				scrollwrp.css("height", (displayHt - displayPadding) + "px");				
			}

			function applyExpandCollapse(row, col) {
				var Promise = qlik.Promise;
				return new Promise(function(resolve, reject) {
					var $tblBody = $("table.basic-pt tbody");

					var requestPage = getRequestPage(row, col, ptProps.maxRowCount, ptProps.maxColCount);
					getSingleDataPage(requestPage).then(function(rows) {

						var body = $("<tbody>");
						for(var x=0; x< rows.length; x++) {
							body.append($(rows[x]));
						}
						attachCellEvents(body);
                        if(row > 0) {
							let scrollInfo = getScrollInfo();
							ptProps.scrollRowPadding = Math.max(0, scrollInfo.scrollTop - scrollInfo.tableHeader); // - ((ptProps.nodePadding / 2) * ptProps.rowHeight));
							if(scrollInfo.isHorzScrollbarVisible)
								ptProps.scrollRowPadding -= 12;
							insertRow(body[0], 0,  ptProps.scrollRowPadding);
                        }
						$tblBody.empty();
						$tblBody.append(body.find("tr"));
						let footer = $element.find('#tblFooter');
						let footerText = buildTblFooter();
						footer.empty();
						footer.append(footerText)

						//addScrollPadding();
						return resolve();
					}, function(err) {
						console.log("ExpandCollapseError", err);
						return reject(err);
					});
				});
			}
			
			function insertRow(body, pos, offsetY) {
				if(offsetY > 0) {
					var row = body.insertRow(pos);
					row.setAttribute("style", "height: " + (offsetY) + "px;");
					row.innerHTML = '<td aria-label="no value"></td>';
				}
			}

			function addScrollPadding() {
				resizeScrollTbl() ;
 
				//quirky workaround issue where table's first column is a column of headers
				//Use a padded column instead of shifting entire table with X scroll
				//Insert padding column after first column which is a frozen header col.
				//var scrollInfo = getScrollInfo(); 
				//var start = Math.floor((scrollInfo.scrollLeft - (2 * ptProps.nodePadding * ptProps.colWidth)) / ptProps.colWidth); // - ptProps.nodePadding;
				//ptProps.colStart = Math.max(0, col);	
				
				let offsetX = (ptProps.colStart * (ptProps.colWidth));
				let $scrollPaddingDiv = $("table.basic-pt .scroll-padding div");
				$scrollPaddingDiv.css("width", offsetX+"px");

				if(offsetX > 0) {
					$("table.basic-pt .scroll-padding").css("display","table-cell");
				} else {
					$("table.basic-pt .scroll-padding").css("display","none");
				}
			}
		
			function attachCellEvents(rowSet) {
				
				var expdColapse = function() {
					refreshExpandCollapseCell = true;
					$('div.scroll-wrapper').off('scroll',  _scrollTbl);
					if(this.hasAttribute("data-pos-sign")) {
						var type = this.getAttribute("data-pos-sign");
						if(type == 'data') {
							//row expanded
							var row = parseInt(this.parentElement.getAttribute("data-row"), 10);
							var col = parseInt(this.getAttribute("data-col"), 10); 	
							caller.backendApi.expandLeft(row, col, false ).then(function(tmp) {
								// applyExpandCollapse(ptProps.rowStart, ptProps.colStart).then(function() {
								// });							
							});	
						} else {
							// column header expanded
							var row = parseInt(this.parentElement.getAttribute("data-row"), 10); 
							var col = parseInt(this.getAttribute("data-col"), 10); 	
							caller.backendApi.expandTop(row, col, false ).then(function() {						
								// applyExpandCollapse(ptProps.rowStart, ptProps.colStart).then(function() {
								// });
							}) 
						}
						
					}
					
					if(this.hasAttribute("data-neg-sign")) {
						var type = this.getAttribute("data-neg-sign");
						if(type == 'data') {
							//row collapsed
							var row = parseInt(this.parentElement.getAttribute("data-row"), 10);
							var col = parseInt(this.getAttribute("data-col"), 10);
							caller.backendApi.collapseLeft(row, col, false ).then(function() {
								// applyExpandCollapse(ptProps.rowStart, ptProps.colStart).then(function() {
								// });
							});	
						} else {
							// column header collapsed
							var row = parseInt(this.parentElement.getAttribute("data-row"), 10);
							var col = parseInt(this.getAttribute("data-col"), 10); 	
							caller.backendApi.collapseTop(row, col, false ).then(function() {
								// applyExpandCollapse(ptProps.rowStart, ptProps.colStart).then(function() {
								// });
							});
						}	
					}	
				};
				var elems = rowSet.find('.selectable');
				for (var x = 0; x < elems.length; x++) {
					$(elems[x]).on('click', expdColapse);	
				}

				var elems = rowSet.find('th.totals');
				for (var x = 0; x < elems.length; x++) {
					let id = $(elems[x]).children(0).attr("data-total-id")
					$(elems[x]).on('click', {id: id}, scrollToNote);
				}
			}

			function scrollToNote(event) {
				if(event.data.id && event.data.id.endsWith("_ref")) {
					document.querySelector(".scroll-wrapper").scrollTo(0,0);
				} else {
					document.getElementById(event.data.id).scrollIntoView(true);
				}
				return false;
			}
			
			function getScrollInfo() {
				var $sw = $('div.scroll-wrapper');
				var scrollTop = $sw.scrollTop(); 
				var offsetHeight = $sw[0].offsetHeight;
				var clientHeight = $sw[0].clientHeight;
				var scrollHeight = $sw[0].scrollHeight;	
				var isVertScrollbarVisible = scrollHeight > clientHeight;
				var scrollHeightPercentage = (clientHeight + scrollTop) / scrollHeight;

				var scrollLeft = $sw.scrollLeft();
				var offsetWidth = $sw[0].offsetWidth;
				var clientWidth = $sw[0].clientWidth;
				var scrollWidth = $sw[0].scrollWidth;
				var isHorzScrollbarVisible = scrollWidth > clientWidth;
				var scrollWidthPercentage = (clientWidth + scrollLeft) / scrollWidth;

				
				let tblHdr = $("table.basic-pt thead").outerHeight();
				//let tblHdr = tbl.find("thead");

				return {"scrollTop": scrollTop, "scrollHeight": scrollHeight, "offsetHeight": offsetHeight, "scrollHeightPercentage" : scrollHeightPercentage,
					"isVertScrollbarVisible": isVertScrollbarVisible, "clientHeight": clientHeight, "tableHeader": tblHdr,
					 "scrollLeft": scrollLeft, "scrollWidth": scrollWidth, "offsetWidth": offsetWidth, "scrollWidthPercentage": scrollWidthPercentage,
					 "isHorzScrollbarVisible": isHorzScrollbarVisible, "clientWidth": clientWidth};
			}

			function attachControlEvents() {

				var scrollTable = function() {
					if(refreshExpandCollapseCell == true)
						return;

					var scrollwrp = $(this);
					var scrollTbl = scrollwrp.find("table.basic-pt.scroll");
					if(scrollTbl.length == 0)
						return;

					var scrollInfo = getScrollInfo();
					var offsetTop = scrollwrp.scrollTop();
					var offsetLeft = scrollwrp.scrollLeft();

					if(offsetTop != ptProps.scrollTopPrevOffset) {
						scrollTblVertical(scrollInfo);
					} else if(offsetLeft != ptProps.scrollLeftPrevOffset) {
						scrollTblHorizontal(scrollInfo);
					}
				}	

				var scrollTblVertical = function(scrollInfo) {

					//Determine up scroll or down scroll
					let scrollDir = scrollInfo.scrollTop > ptProps.scrollTopPrevOffset?scrollevent.DOWN : scrollevent.UP;
					let scrollRow = Math.floor(scrollInfo.scrollTop / ptProps.rowHeight); 
					let hdrHt = $('.basic-pt.scroll thead')[0].clientHeight;
					let hdrRows = Math.floor(hdrHt / ptProps.rowHeight); 
					//let newRowStart = Math.max(0, scrollRow - (ptProps.nodePadding / 2));
					//let newRowStart = Math.max(0, scrollRow - ((ptProps.nodePadding / 2) + hdrRows));
					let newRowStart = scrollRow;
					if(scrollDir == scrollevent.DOWN) {
							if(newRowStart - ptProps.rowStart < (ptProps.nodePadding / 2) 
							|| ptProps.rowStart + ptProps.maxRowCount >= ptProps.qcy) {
								ptProps.scrollTopPrevOffset = scrollInfo.scrollTop;	
							return;
							}
					} else {
							if(ptProps.rowStart == 0 
							|| (ptProps.rowStart > (ptProps.nodePadding / 2)
							&& ptProps.rowStart - newRowStart < (ptProps.nodePadding / 2))) {
								ptProps.scrollTopPrevOffset = scrollInfo.scrollTop;	
							return;
							}
					}

					ptProps.scrollTopPrevOffset = scrollInfo.scrollTop;	
					ptProps.rowStart = newRowStart; //rowStartWithPadding;

					var requestPage = getRequestPage(ptProps.rowStart, ptProps.colStart, ptProps.maxRowCount, ptProps.maxColCount);
					getSingleDataPage(requestPage).then(function(rows) {
						try {
							let tmpbody = $("table.basic-pt tbody");
							tmpbody.empty();
							tmpbody.append($(rows.toString()));
							attachCellEvents(tmpbody);

							if(ptProps.rowStart > 0) {
								ptProps.scrollRowPadding = Math.max(0, scrollInfo.scrollTop - scrollInfo.tableHeader); // - ((ptProps.nodePadding / 2) * ptProps.rowHeight));
								if(scrollInfo.isHorzScrollbarVisible)
									ptProps.scrollRowPadding -= 12;
								insertRow(tmpbody[0], 0,  ptProps.scrollRowPadding);
							}

							let footer = $element.find('#tblFooter');
							let footerText = buildTblFooter();
							footer.empty();
							footer.append(footerText)
							addScrollPadding();

							return;
						} catch (err) {
							console.log("Vertical scroll warning:", err.message);
							return;
						}
					}, function(err) {
						console.log("vertical scroll warning:", err.message);
						return;
					});	
				} 
				
				function scrollTblHorizontal(scrollInfo) {
					let scrollDir = scrollInfo.scrollLeft > ptProps.scrollLeftPrevOffset?scrollevent.RIGHT : scrollevent.LEFT;
					let scrollCol = Math.floor((scrollInfo.scrollLeft - ptProps.colWidth) / ptProps.colWidth); 
					let newColStart = Math.max(0, scrollCol - (ptProps.nodePadding / 2));
					if(scrollDir == scrollevent.RIGHT) {
							if(newColStart - ptProps.colStart < (ptProps.nodePadding / 2)
							|| ptProps.colStart + ptProps.maxColCount >= ptProps.qcx) {
								ptProps.scrollLeftPrevOffset = scrollInfo.scrollLeft;
							return; 
							}
					} else {
							if(ptProps.colStart == 0 
							|| (ptProps.colStart > (ptProps.nodePadding / 2)
							&& ptProps.colStart - newColStart < (ptProps.nodePadding / 2))) {
								ptProps.scrollLeftPrevOffset = scrollInfo.scrollLeft;
							return;
							}
					}

					ptProps.scrollLeftPrevOffset = scrollInfo.scrollLeft;
					ptProps.colStart = newColStart;

					var requestPage = getRequestPage(ptProps.rowStart, ptProps.colStart, ptProps.maxRowCount, ptProps.maxColCount);
					getSingleDataPage(requestPage).then(function(rows) {
						try {
							let tmpbody = $("table.basic-pt tbody");
							tmpbody.empty();
							tmpbody.append($(rows.toString()));
							attachCellEvents(tmpbody);

							if(ptProps.rowStart > 0) {
								ptProps.scrollRowPadding = Math.max(0, scrollInfo.scrollTop - scrollInfo.tableHeader); // - ((ptProps.nodePadding / 2) * ptProps.rowHeight));
								if(scrollInfo.isHorzScrollbarVisible)
									ptProps.scrollRowPadding -= 12;

			//console.log(getScrollInfo())
			//console.log(ptProps)			
			
								insertRow(tmpbody[0], 0,  ptProps.scrollRowPadding);
							}
							let footer = $element.find('#tblFooter');
							let footerText = buildTblFooter();
							footer.empty();
							footer.append(footerText)
							addScrollPadding();

							return;
						} catch (err) {
							console.log("horizontal scroll warning:", err.message);
							return;
						}
					}, function(err) {
						console.log("horizontal scroll data warning:", err.message);
						return;
					});
				}

				_scrollTbl = _.debounce(scrollTable, 300, false);
				$('div.scroll-wrapper').off('scroll', _scrollTbl).on('scroll', _scrollTbl); //capture scroll event
			};
			return qlik.Promise.resolve();
		}
		
	};
});
 
'use strict'
function openFeedbackPopup() {
	angular.element(document.getElementById('feedbackModal')).scope().clickOpenFeedback('comments-tab');
	$('#modal-msg').modal('hide');
}

function openExternalUrl(article) {
	angular.element(document.getElementById('generic-main-banner-notice')).scope().clickOpenUrl(article);
}

define('scripts/controllers/surveyContentCtrl',["js/qlik", "scripts/shared/webProperties", "scripts/appModule", "scripts/shared/hyperCubeProperties", "scripts/shared/appUtilities",
	"scripts/shared/measures", "scripts/shared/dimensions", "scripts/shared/charts", "scripts/shared/recodes", "scripts/shared/tableSelections"],
	function (qlik, webProperties, appModule, hyperCubeProperties, appUtilities, measures, dimensions, charts, 
		recodeUtility, tableSelections) {
		angular.module("appModule").controller('SurveyContentCtrl', ['$scope', '$rootScope', '$q', '$window', '$document', '$http', '$interval', '$location', '$sce', '$timeout',
			function ($scope, $rootScope, $q, $window, $document, $http, $interval, $location, $sce, $timeout) {
				var qApp;
				var queryComplete = true;
				$scope.expandbar = false;

				//google analytics tracking
				gtag('config', 'UA-109024055-1', {
					'page_path': $scope.page
				});
/* 				gtag('config', '386148585', {
					'page_path': $scope.page
				});  */ 
				$rootScope.headerType = "survey";
				$window.scrollTo(0, 0);

				//If user previously accessed another survey, then need to remove all listenrs 
				//that were added otherwise Builder will add duplicate listeners
				for (const key in $rootScope.$$listeners) {
					if ($rootScope.$$listeners.hasOwnProperty(key)) {
					  //console.log(key, $rootScope.$$listeners[key]);
					  if(!key.startsWith('$')) {
						delete $rootScope.$$listeners[key];
					  }
					}
				}

				$scope.$on('displayGenericNoticeEvent', function (e, notice) {
					$scope.genericNotice.showNoticeFlag = notice.showNoticeFlag;
					$scope.genericNotice.borderClass = notice.borderClass;
					$scope.genericNotice.bannerMsg = $sce.trustAsHtml(notice.bannerMsg);	
					$scope.genericNotice.showFullMsgFlag = notice.showFullMsgFlag;
					$scope.genericNotice.fullMsg = $sce.trustAsHtml(notice.fullMsg);					
					//$scope.genericNotice = notice;
				});				
				
				function getQlikApp(appname) {
					config.identity = randomQID();
					return qlik.openApp(appname, config)
				}

				//Random qId generator for Pivot Tables
				function randomQID() {
					var text = "";
					var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

					for (var i = 0; i < 7; i++)
						text += possible.charAt(Math.floor(Math.random() * possible.length));

					return text;
				}				

				$scope.showSurveyDetailPanel = function() {
					$rootScope.$broadcast('showSurveyDetailsEvent');
				}

				$scope.visualizationTypes = [{
						'value': 'pivot-table',
						'name': 'Pivot Table'
					}, {
						'value': 'barchart',
						'name': 'Barchart'
					}, {
						'value': 'linechart',
						'name': 'Linechart'
					}
				];

				// if ($rootScope.displayVisType == null)
				// 	$rootScope.displayVisType = "";

				if($location.search().type != null) {
					document.getElementsByTagName("title")[0].innerText = 'Chart Builder | NCSES | NSF';
					if($location.search().type == 'linechart') {
						$rootScope.displayVisType = "linechart";
					} else if($location.search().type == 'barchart') {
						$rootScope.displayVisType = "barchart";
					} else {
						$rootScope.displayVisType = "linechart";
					}
				} else {
					$rootScope.displayVisType = "pivot-table";
					document.getElementsByTagName("title")[0].innerText = 'Table Builder | NCSES | NSF';
				}

				
				gtag('event', ($rootScope.displayVisType == 'pivot-table'?'TB-':'CB-') + $rootScope.survey.abbreviation + '-Load', {
					'event_label': 'load',
					'event_category': 'survey_load'
				});	
				$rootScope.abbreviation = $rootScope.survey.abbreviation;
				$rootScope.unitsOfMeasureValue = $scope.amountOptions.defaultUnitsOfMeasure?Number($scope.amountOptions.unitsOfMeasure[$scope.amountOptions.defaultUnitsOfMeasure].value):0,
				qApp = getQlikApp($rootScope.survey.appname);
				$rootScope.qApp = qApp;
				$rootScope.showFirstStepTip = true;
				//Change this value to 1 to prevent next step msg from being shown until after user has made a dim selection
				let firstStepMinDimCnt = 0;

				appUtilities.setUpKeepAlive($scope, qApp, $interval);
				qApp.clearAll();

				$rootScope.selState = qApp.selectionState();
				//Getting reference to Qlik alt state
				$rootScope.selAltState = qApp.selectionState('altState1');
/* 				qApp.addAlternateState('altState1').then(function(o) {
					$rootScope.selAltState = qApp.selectionState('altState1');
				}, function(err) {
					console.log(err)
				}); */
				$rootScope.selectedAmountCount = 0;
				$scope.isPivotTableVisible = false;
				$rootScope.displayTableTotals = true;
				$rootScope.displayTablePercentageType = null;
				$rootScope.disableExpandCollapseFunctions = false;
				$rootScope.chart = {};
				//console.log($rootScope.survey.abbreviation )
				$scope.systemNotice = {}
				$scope.genericNotice = {}

				$rootScope.chart.dimCount = 0;
				$rootScope.chart.barType = "";

				$rootScope.measureProperties = {};
				$rootScope.dimensionProperties = {};

				if($rootScope.survey.abbreviation == "NSCG" || $rootScope.survey.abbreviation == "SDR" || $rootScope.survey.abbreviation == "NTEWS") {
					$rootScope.survey.dimToLock = "REFYR";
				} else {
					$rootScope.survey.dimToLock = "Year";
				}
				var $content = $("#content");

				toggleDataDisplay(false);
				toggleReadOnly(true);
				let commonRecodesObj;


				$q.all([
					appUtilities.getSurveyProperties($http, $q, $rootScope.survey.abbreviation).then(
						function (resp) {
							$rootScope.survey.properties = resp.data.body;
						}
					),
					appUtilities.getResource(qlik, $http, 'notices/system_notification.xml').then(
						function (resp) {
							$rootScope.systemNotice = appUtilities.parseXmlDomIntoJson(resp.data) 
							$rootScope.systemNotice.bannerMsg = $sce.trustAsHtml($rootScope.systemNotice.bannerMsg);
							//console.log($scope.systemNotice)
							if($rootScope.systemNotice.showNoticeFlag == true) {

								if(sessionStorage.getItem("hideSystemNoticeFlag") == "true")
									$rootScope.systemNotice.showNoticeFlag = false;
								else
									$rootScope.systemNotice.showNoticeFlag = true;
							}
						}, function () {
							$rootScope.systemNotice = null;
						}
					),
					appUtilities.getResource(qlik, $http, 'notices/' + $rootScope.survey.abbreviation.toLowerCase() + '_notification.xml').then(
						function (resp) {
							$scope.surveyNotice = appUtilities.parseXmlDomIntoJson(resp.data) 
							$scope.surveyNotice.bannerMsg = $sce.trustAsHtml($scope.surveyNotice.bannerMsg);
							if($scope.surveyNotice.showNoticeFlag == true) {
								if(sessionStorage.getItem("hide" + $rootScope.survey.abbreviation.toUpperCase() + "SurveyNoticeFlag") == "true")
									$scope.surveyNotice.showNoticeFlag = false;
								else
									$scope.surveyNotice.showNoticeFlag = true;
							}
						}, function () {
							$scope.surveyNotice = null;
						}
					),
					appUtilities.getResource(qlik, $http, 'content/json/' + $rootScope.survey.abbreviation.toLowerCase() + '_exclusions.json').then(
						function (resp) {
							$scope.surveyExclusions = resp.data;
						}, function () {
							$rootScope.exclusions = null;
						}
					),
					appUtilities.getResource(qlik, $http, 'tabledefs/common-recodes/' + $rootScope.survey.abbreviation.toLowerCase() + '_common_recodes.json').then(
						function (resp) {
							commonRecodesObj = resp.data;
						}, function () {
							commonRecodesObj = null;
						}
					),
					dimensions.getApiDimensions($http, $q, $rootScope.survey.abbreviation).then(
						function (resp) {
							$rootScope.dimensionProperties.apiDimTopics = resp.data.body;
						}
					),
					dimensions.getQlikDimensions(qApp).then(
						function (resp) {
							$rootScope.dimensionProperties.qlikDimensions = resp.layout.qDimensionList.qItems;
						}
					),
					measures.getWebMeasures($http, $q, $rootScope.survey.abbreviation).then(
						function (resp) {
							$rootScope.measureProperties.webMsrs = resp == null ? null : resp.data;
						}
					),
					measures.getApiMeasures($http, $q, $rootScope.survey.abbreviation).then(
						function (resp) {
							$rootScope.measureProperties.apiMeasureTopics = resp.data.body;
						}
					),
					measures.getQlikMeasures(qApp).then(
						function (resp) {
							$rootScope.measureProperties.qlikMeasures = resp.layout.qMeasureList.qItems;
						}
					)
				]).then(function (success) {
					qlik.theme.apply('ncses-theme').then(function(result){
						if(result) {
							console.log('ncses-theme theme applied');
						} else {
							console.log('default theme applied');
						}
					}, function(err) {
						throw err;
					})

					let foundMsrs = setLeftRailMeasureProperties();
					let foundDims = setLeftRailDimensionProperties();
					if(commonRecodesObj) {
						$scope.$broadcast('loadRecodesEvent', commonRecodesObj);
					}

					let dimensionParms = [];
					let measureParms = [];

					if($location.search().tabledef != null) {
						gtag('event', ($rootScope.displayVisType == 'pivot-table'?'TB-':'CB-') + $rootScope.survey.abbreviation + '-Hosted Table', {
							'event_label': 'load',
							'event_category': 'survey_hosted'
						});	
						let fileName = "";
						if($location.search().tabledef.toLowerCase().endsWith(".json")) {
							fileName = $location.search().tabledef;
						} else {
							fileName = $location.search().tabledef + ".json";
						}
						appUtilities.getPredefinedTable(qlik, $http, fileName.toLowerCase()).then(
						function (resp) {
							//throw "getPredefinedTable err"
							try {
								 //throw "inner err"
								if(resp.data.survey == null || resp.data.contentType == null
								|| resp.data.contentType != "tableSelections") {
									throw "bad-response"
								} else if(resp.data.survey.toLowerCase() != $rootScope.survey.abbreviation.toLowerCase()) {
									throw "mismatch-survey"
								}

								visualizeData($scope, qApp, measureParms, dimensionParms, resp.data).then(function () {
									$scope.pageTitle = $rootScope.survey.properties.surveyName;				
									return;
								}, function (err) {
									toggleReadOnly(false);
									appUtilities.showError(err);
								});
								
							} catch (err) {
								toggleReadOnly(false);
								disablePage(true);
								let msg = {};
								msg.title = "Table Error";
								//let text;
								if(err == "mismatch-survey") {
									msg.text = "The URL specifies a survey that differs from the table properties selections in " + $location.search().tabledef + ". Please report this problem using <button type='button' onclick='openFeedbackPopup()' class='md-link'>Feedback</button>";
								} else { 
									msg.text = "The table selections contain errors in " + $location.search().tabledef + ". Please report this problem using <button type='button' onclick='openFeedbackPopup()' class='md-link'>Feedback</button>";
								}
								$scope.$emit('showMsgModalEvent', msg);	

							}
						}, function (err) {
							toggleReadOnly(false);
							disablePage(true);
							let msg = {};
							msg.title = "Table Error";
							msg.text = "The table selections cannot be found for " + $location.search().tabledef + ".  Please report this problem using <button type='button' onclick='openFeedbackPopup()' class='md-link'>Feedback</button>";
							$scope.$emit('showMsgModalEvent', msg);	
						}) 
					} else { 
						if ($location.search().msr != null || $location.search().dim != null) {
							if ($location.search().msr != null) {
								measureParms.push($location.search().msr);
							}

							if ($location.search().dim != null) {
								//Workaround for local Qlik Desktop which de-codes a parameter value containing a %26 to '&', so
								//that $location service then treats parameter as 2 separate parameters, i.e fields&e becomes 'fields' and 'e'
								//This hack needed to test locally, if in the future need to support passing multiple fields from ME to TB then this code
								//will need to be modified
								//dimensionParms.push($location.url().split('=')[1]);
								firstStepMinDimCnt ++;
								dimensionParms.push($location.search().dim);
							}
						} else if(sessionStorage.getItem("tableToChartSession") && $location.search().convert != null) {
							// load measure from Table to Chart Wizard redirect
							$scope.tableToChartSession = JSON.parse(sessionStorage.getItem("tableToChartSession"));
							//console.log('tableToChartSession=', $scope.tableToChartSession);
							sessionStorage.removeItem("tableToChartSession");

							// load recodes if any
							if($scope.tableToChartSession && $scope.tableToChartSession.recodedDims) {
								recodeUtility.loadRecodes($rootScope, $scope);
							}
						}

						visualizeData($scope, qApp, measureParms, dimensionParms).then(function () {
							$scope.pageTitle = $rootScope.survey.properties.surveyName;
							if($location.search().localtabledef != null) {
								$scope.$broadcast('loadTableEvent', $location.search().localtabledef);
							}
							if($location.search().localrecodedef != null) {
								$scope.$broadcast('loadRecodesEvent', null);
							}
							toggleReadOnly(false);
							return;
						}, function (err) {
							toggleReadOnly(false);
							appUtilities.showError(err);
						});
					}
				}, function (err) {
					toggleReadOnly(false);
					appUtilities.showError(err);
				})

				function visualizeData($scope, qApp, measureParms, dimensionParms, loadTableDef) {
					var Promise = qlik.Promise;
					return new Promise(function (resolve, reject) {
						if ($rootScope.displayVisType == "pivot-table") {
							require(["BasicPivotTable/basicPivotTable"], function (pvTable) {
								qlik.registerExtension('pvTable', pvTable);
								setTblProps($rootScope.displayVisType);
								qApp.visualization.create('pvTable', [], $scope.qAdhocProps)
								.then(function (pvTableObj) {
									$rootScope.visObj = pvTableObj;
									$rootScope.visObjId = pvTableObj.id;
									$scope.totalRecords = pvTableObj.table.qHyperCube.qSize.qcy;
									pvTableObj.show("QV01").then(function () {
										if(loadTableDef != null) {
											tableSelections.applyVariablesToTable($rootScope, $scope, loadTableDef).then(function(o) {
												return resolve();
											}, function(err) {
												return reject(err);
											});
										} else if($scope.tableToChartSession && $location.search().convert != null) {
											//$rootScope.visObj.table.OnData.bind($scope.tblListener);
											hyperCubeProperties.setTableChartVariables($rootScope, $scope, qApp).then(function () {
												$rootScope.visObj.table.OnData.bind($scope.tblListener);
												delete $scope.tableToChartSession;
												return resolve();
											}, function (err) {
												return reject(err);
											});
										} else {
											hyperCubeProperties.setVisualizationDefaults($rootScope, $scope, qApp, measureParms, dimensionParms).then(function () {
												$rootScope.visObj.table.OnData.bind($scope.tblListener);
												delete $scope.tableToChartSession;
												return resolve();
											}, function (err) {
												return reject(err);
											});
										}
									}, function (err) {
										return reject(err);
									}).catch((err) => {
										return reject(err);
									})
								}, function (err) {
									return reject(err);
								}).catch((err) => {	
									return reject(err);
								})
							});
						} else {
							setChartProps($rootScope.displayVisType);
							qApp.visualization.create(
								$rootScope.displayVisType,
								[],
								$scope.qAdhocProps)
							.then(function (vis) {
								$rootScope.visObjId = vis.id;
								$rootScope.visObj = vis;
								
								if($scope.tableToChartSession && $location.search().convert != null) {
									hyperCubeProperties.setTableChartVariables($rootScope, $scope, qApp).then(function () {
										$rootScope.visObj.table.OnData.bind($scope.tblListener);
										delete $scope.tableToChartSession;
										//vis.table.OnData.bind($scope.tblListener);
										vis.show("QV01");
										return resolve();
									}, function (err) {
										return reject(err);
									});	
								} else {
									hyperCubeProperties.setVisualizationDefaults($rootScope, $scope, qApp, measureParms, dimensionParms).then(function () {
										delete $scope.tableToChartSession;
										if ($rootScope.survey.abbreviation == "NSCG" || $rootScope.survey.abbreviation == "NTEWS") {
											//invoke event for bar chart listener to render visualization as bar chart
											//bar chart creation will bind to listener so don't do it here
											$scope.$broadcast('changeBarChartEvent', "v-grouped");
											toggleReadOnly(false);
										} else {
											//vis.table.OnData.bind($scope.tblListener);
											$rootScope.visObj.table.OnData.bind($scope.tblListener);
											vis.show("QV01");
										}
										return resolve('ok');
									}, function (err) {
										return reject(err);
									});
								}
							}, function (error) {
								$scope.isSpinning = false;
								appUtilities.showError(error);
								return reject(err);
							});
						}
					})
				};

				function leftRailEventListener (e) {
					//if (document.getElementById('left-rail').contains(e.target)){
					if(document.querySelector(".left-rail-slideout.open")) {
						//clicked left rail
						$document.off('click', leftRailEventListener);
						$('#measure-section').removeClass("highlight");
						$('.first-step-msg').css('display', 'none');
						//$('#welcomeInfoTbl').css('display', 'block');
						$scope.$apply();
					}
				}

				$scope.$on('modifiedVisualizationEvent', function (e) {
					$scope.tblListener();
				});	

				$scope.$on('showFirstStepEvent', function(e, dimCnt, isMsrSelected) {
					showFirstStep(dimCnt, isMsrSelected)
				})

				function showFirstStep(dimCnt, isMsrSelected) {

					if($rootScope.showFirstStepTip && dimCnt > firstStepMinDimCnt && !isMsrSelected) {
						angular.element($('#collapseMeasures').collapse('show'));
						$document[0].querySelector('#measure-section').classList.add("highlight");
						let top = $document[0].getElementById('welcomeInfoTbl').offsetTop;
						//console.log('welcomeTop', top);
						let padding = ($scope.surveyNotice && $scope.surveyNotice.showNoticeFlag == true)?30:50;
						$document[0].querySelector('.first-step-msg').style.top =  (top+padding)+'px';
						$document[0].querySelector('.first-step-msg').style.display = 'block';
						$document.on('click', leftRailEventListener );
					} else {
						$document[0].querySelector('#measure-section').classList.remove("highlight"); 
						$document[0].querySelector('.first-step-msg').style.display = 'none';
					}
					var phase = $rootScope.$$phase;
					if (phase !== '$apply' && phase !== '$digest') {
						//console.log('invoking apply()')
						$scope.$apply();
					}
				}					

				$scope.tblListener = function () {
					var isDimensionSelected = false; // default to display Welcome vs. Pivot Table
					$scope.isPivotTableVisible = false;

					//console.log('listener callled')
					var totalDimCount = 0;
					var selectedVariableIds = [];
					let isMeasureSelected = false;
					//track count of selected variables but only count once if variable appears in multiple groups, 
					//i.e. some Hierarchies have share dims
					var uniqueDimVariableIds = [];
					for (var x = 0; x < $rootScope.dimensionProperties.apiDimTopics.length; x++) {
						var topic = $rootScope.dimensionProperties.apiDimTopics[x];
						topic.selectedGrpCount = 0;

						for (var y = 0; y < topic.dimensionGroups.length; y++) {
							var grp = topic.dimensionGroups[y];
							grp.selectedDimCount = 0;
							for (var z = 0; z < grp.dimensions.length; z++) {
								if (grp.dimensions[z].selected == true) {
									selectedVariableIds.push(grp.dimensions[z].variableId);
									isDimensionSelected = true;
									grp.selectedDimCount += 1;
								}
								if (grp.dimensions[z].commonRecodes) {
									for (var a = 0; a < grp.dimensions[z].commonRecodes.length; a++) {
										if (grp.dimensions[z].commonRecodes[a].selected) {
											grp.selectedDimCount += 1;
										}
									}
								}
								else if (grp.dimensions[z].hierarchyAvailable == "Y") {
									var tmpTrees = grp.dimensions[z].commonRecodeTrees;
									if(tmpTrees != null) {
										for (var z = 0; z < tmpTrees.length; z++) {
											if (tmpTrees[z].selected) {
												grp.selectedDimCount += 1;
											}
										}
									}
								}
							};
							if (grp.selectedDimCount > 0) {
								topic.selectedGrpCount += grp.selectedDimCount;
							}
						};
					};

					selectedVariableIds.forEach(function (vId) {
						if (!uniqueDimVariableIds.includes(vId)) {
							uniqueDimVariableIds.push(vId);
						}
					});
					totalDimCount = uniqueDimVariableIds.length;

					for (var i = 0; i < $rootScope.measureProperties.apiMeasureTopics.length; i++) {
						var topic = $rootScope.measureProperties.apiMeasureTopics[i];
						topic.selectedGrpCount = 0;
						var apiGrps = topic.measureGroups;
						for (var j = 0; j < apiGrps.length; j++) {
							apiGrps[j].selectedMsrCount = 0;
							for (var k = 0; k < apiGrps[j].measures.length; k++) {
								if (apiGrps[j].measures[k].selected == true) {
									apiGrps[j].selectedMsrCount += 1;
									isMeasureSelected = true;
									if (isDimensionSelected == true) {
										$scope.isPivotTableVisible = true;
									}
								}
							}
							if (apiGrps[j].selectedMsrCount > 0) {
								topic.selectedGrpCount += 1;
							}
						}
					}

					//showFirstStep(totalDimCount, isMeasureSelected)
					$rootScope.$broadcast('rebuildRecodesListEvent');
					if ($rootScope.displayVisType == "pivot-table") {
						$rootScope.chart.barType = "";
						let params = {}
						params.qHyperCube = $rootScope.visObj.table.qHyperCube;
						params.dimToLock = $rootScope.survey.dimToLock; 
						params.removeSelection = removeSelection;

						$scope.$broadcast('displayTblVariableCustomEvent', params);
						toggleReadOnly(false);
						toggleDataDisplay($scope.isPivotTableVisible,  $rootScope.visObj.table);
						$timeout(()=> showFirstStep(totalDimCount, isMeasureSelected), 200);
					} else {
						if ($scope.isPivotTableVisible) {
							qApp.getObject($rootScope.visObjId).then(function (obj) {
								if ($rootScope.displayVisType == "barchart" &&
									($rootScope.chart.barType == 'v-grouped' || $rootScope.chart.barType == 'v-stacked')) {
									var chartSize = appUtilities.getChartWidth(obj.layout.qHyperCube, $rootScope);
									let setting = chartSize + "px";
									$(".chart-container").css({maxWidth: setting});
									delete $scope.tableToChartSession;
								} else {
									$(".chart-container").css({maxWidth: ""});
								}
								toggleDataDisplay($scope.isPivotTableVisible, obj.layout);
								obj.getEffectiveProperties().then(function (props) {
									for(let x =0; x < props.qHyperCubeDef.qDimensions.length; x++) {
										let dim = dimensions.getDimensionByCid($rootScope, props.qHyperCubeDef.qDimensions[x].qDef.cId);
										let label = dim.newTitle != null && dim.newTitle?dim.newTitle:dim.recodeName!=null?dim.recodeName:dim.title;
										if(props.qHyperCubeDef.qDimensions.length > 1) {
											if($rootScope.displayVisType == 'barchart' && $rootScope.chart.barType.startsWith("h-")) {
												if(x == 0){
													label = "Y-Axis - " +  label;
												} else {
													label = "Y-Axis Groups - " + label;
												}
											} else {
												if(x == 0){
													label = "X-Axis - " + label;
												} else {
													label = "X-Axis Groups - " + label;
												}
											}
										} 
										props.qHyperCubeDef.qDimensions[x].qDef.qFieldLabels[0] = label;
									}

									if(props.qHyperCubeDef.qLayoutExclude != null) {
										for(let x =0; x < props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions.length; x++) {
											let dim = dimensions.getDimensionByCid($rootScope, props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions[x].qDef.cId);
											//let label = dim.newTitle != null && dim.newTitle?dim.newTitle:dim.title;
											let label = dim.newTitle != null && dim.newTitle?dim.newTitle:dim.recodeName!=null?dim.recodeName:dim.title;
											props.qHyperCubeDef.qLayoutExclude.qHyperCubeDef.qDimensions[x].qDef.qFieldLabels[0] = label;
										}
									}

									if($rootScope.chart.useCustomColors) {
										if (props.qHyperCubeDef.qDimensions.length == 1) {
											props.qHyperCubeDef.qDimensions[0].qAttributeDimensions = [];
											props.qHyperCubeDef.qDimensions[0].qAttributeExpressions = [];
											props.color.mode = "primary";
											props.color.auto = false;
											props.color.persistent = false;
											props.color.useBaseColors = "off";
											props.color.paletteColor = {}
											props.color.paletteColor.index = -1;
											var colorExp = charts.rgbToHex($rootScope.chart.colorCodes[0])
											props.color.paletteColor.color = colorExp; //"#FFCC00";
											props.color.useDimColVal = true;
											props.color.useMeasureGradient = false;
											props.color.persistent = false;
											props.color.expressionIsColor = true;
											props.color.expressionLabel = "";
										} else if (props.qHyperCubeDef.qDimensions[1].qAttributeDimensions.length == 0 || props.qHyperCubeDef.qDimensions[1].qAttributeDimensions.length == 1
											|| props.qHyperCubeDef.qDimensions[1].qDef.qFieldLabels[0] != props.qHyperCubeDef.qDimensions[1].qAttributeDimensions[0].label) {
											//var dim = dimensions.getDimensionByCid($rootScope, props.qHyperCubeDef.qDimensions[1].qDef.cId);
 										
											//If chanrt refreshed due to new dim added or alt dim selected, then chart needs to be rebuilt with the color theme assigned to the correct dimension
											var dim = dimensions.getDimensionByCid($rootScope, props.qHyperCubeDef.qDimensions[1].qDef.cId);
											//var numberOfValues = obj.layout.qHyperCube.qDimensionInfo[1].qCardinalities.qHypercubeCardinal;
											var colorExp = charts.buildColorExpression(dim.shortName, $rootScope.chart.colorCodes);
											props.color.colorExpression = colorExp;
											var attrExp = {};
											props.qHyperCubeDef.qMeasures[0].qAttributeExpressions = [];
											attrExp.id = "colorByExpression";
											attrExp.qAttribute = true;
											attrExp.qLibraryId = "";
											attrExp.qNumFormat = null;
											attrExp.qLabel = "";
											attrExp.qLabelExpression = "";
											attrExp.id = "colorByExpression";
											attrExp.qExpression = colorExp;
											props.qHyperCubeDef.qMeasures[0].qAttributeExpressions.push(attrExp);

											props.color.auto = false;
											props.color.mode = "byExpression";
											props.color.useBaseColors = "off";
											props.color.useDimColVal = false;
											props.color.expressionIsColor = true;
											props.color.persistent = true;
										} 				
									}

									if($rootScope.visObj.table) {
										$rootScope.visObj.table.OnData.unbind($scope.tblListener);
										obj.setProperties(props).then(function () {
											$rootScope.visObj.table.OnData.bind($scope.tblListener);
											$rootScope.chart.dimCount = totalDimCount;
											if($rootScope.displayVisType == "barchart") {
												$rootScope.chart.disablePercentages = ($rootScope.chart.dimCount < 2 || dimensions.getDimensionByCid($rootScope,  props.qHyperCubeDef.qDimensions[0].qDef.cId).shortName !== $rootScope.survey.dimToLock);
												if($rootScope.chart.showPercentages && $rootScope.chart.disablePercentages) {
													$scope.$broadcast('setChartPercentagesEvent', false);
												}
											}
											//$scope.displayChartVariableCustom($scope, qApp, $rootScope.visObj.table.qHyperCube, $rootScope.survey.dimToLock, removeSelection);
											let params = {}
												params.qHyperCube = $rootScope.visObj.table.qHyperCube;
												params.dimToLock = $rootScope.survey.dimToLock; 
												params.removeSelection = removeSelection;
					
											$scope.$broadcast('displayChartVariableCustomEvent', params);											                                
											toggleReadOnly(false);
											$timeout(()=> showFirstStep(totalDimCount, isMeasureSelected), 200);
										}, function (err) {
											console.log(err);
											appUtilities.showError(err);
										});
									}
								});
							});
						} else {
							toggleReadOnly(false);
							toggleDataDisplay($scope.isPivotTableVisible, this);
							$timeout(()=> showFirstStep(totalDimCount, isMeasureSelected), 200);
						}
					}
				}

				$scope.disablePage = function(bool) {
					disablePage(bool)
				}

				function disablePage(bool) {
					$("#variablesTblContainer button").each(function () {
						$(this).prop("disabled", bool);
					});
					$("#variablesFilterContainer button").each(function () {
						$(this).prop("disabled", bool);
					});
					$scope.disableAll = bool;
					if (bool) {
						$('.left-rail-variables').addClass('readonly-backdrop');
						$('#variablesContainer').addClass('readonly-backdrop');
					} else {
						$('.left-rail-variables').removeClass('readonly-backdrop');
						$('#variablesContainer').removeClass('readonly-backdrop');
					}
				}

				$scope.toggleReadOnly = function (bool) {
					toggleReadOnly(bool);
				}
				
				function toggleReadOnly(bool) {
					disablePage(bool);
					setTimeout(function () {
						if (!queryComplete) {
							var popup = document.getElementById('warning-message-popup');
							if(popup != null) {
								$('#warning-message-popup').removeClass('warning-message-hide');
							} else {
								console.log("warning html not loaded");
							}
						}
					}, 2000);

					if (bool) {
						queryComplete = false;
					} else {
						queryComplete = true;
 						var popup = document.getElementById('warning-message-popup');
						if(popup != null) {
							$('#warning-message-popup').addClass('fade-out');
							setTimeout(function(){
							  $('#warning-message-popup').removeClass('fade-out');
							  $('#warning-message-popup').addClass('warning-message-hide');
						  }, 1000);
						}
					}
				}

				function toggleDataDisplay(showTbl, obj) {
					$scope.pivotTblMsg = "";
					if (showTbl) {
						if (obj == null || obj.qHyperCube == null || obj.qHyperCube.qSize.qcy == 0) {
							$scope.pivotTblMsg = "No Data Matches Filter";
						}
						$scope.showTable = true;
					} else {
						$scope.showTable = false;
						$('#variablesRows').html('');
						$('#variablesCols').html('');
					}
				}

				function setLeftRailMeasureProperties() {
					var apiTopics = $rootScope.measureProperties.apiMeasureTopics,
					qMeasures = $rootScope.measureProperties.qlikMeasures;
					apiTopics.sort(appUtilities.compareNumerics("topicOrderPosition", "acs"));
					let noMatchCount = 0;
					for (var i = 0; i < apiTopics.length; i++) {
						apiTopics[i].measureGroups.sort(appUtilities.compareNumerics("measureOrderPosition", "asc"));
						var apiGrps = apiTopics[i].measureGroups;
						for (var j = 0; j < apiGrps.length; j++) {
							for (var m = 0; m < apiGrps[j].measures.length; m++) {
								let matchFound = false;
								for (var q = 0; q < qMeasures.length; q++) {
									for (var x = 0; x < qMeasures[q].qMeta.tags.length; x++) {
										if (apiGrps[j].measures[m].shortName.toLowerCase().trim() == qMeasures[q].qMeta.tags[x].toLowerCase().trim()) {
											matchFound = true;
											apiGrps[j].measures[m].qId = qMeasures[q].qInfo.qId;
											apiGrps[j].measures[m].def = qMeasures[q].qData.qMeasure.qDef;
											apiGrps[j].measures[m].cId = randomCid();
											apiGrps[j].measures[m].type = "measure";
											break;
										}
									}
								}
								if(!matchFound) {
									noMatchCount++;
									console.log('API Msr not in QVF', apiGrps[j].measures[m]);
								}
							}
						}
					}
					//set percent definitions for measures
					if ($rootScope.measureProperties.webMsrs != null) {
						for (var h = 0; h < $rootScope.measureProperties.webMsrs.measures.length; h++) {
							var webDim = $rootScope.measureProperties.webMsrs.measures[h];
							for (var i = 0; i < apiTopics.length; i++) {
								var apiGrps = apiTopics[i].measureGroups;
								for (var j = 0; j < apiGrps.length; j++) {
									for (var m = 0; m < apiGrps[j].measures.length; m++) {
										if (apiGrps[j].measures[m].shortName.toLowerCase().trim() == webDim.shortName.toLowerCase().trim()) {
											apiGrps[j].measures[m].percentDef = webDim.percentDef;
										}
									}
								}
							}
						}
					}
					if(noMatchCount > 0) {
						return false;
					}									
					return true;
				}

				function setLeftRailDimensionProperties() {
					var apiDimTopics = $rootScope.dimensionProperties.apiDimTopics,
					qDimensions = $rootScope.dimensionProperties.qlikDimensions;
					apiDimTopics.sort(appUtilities.compareNumerics("topicOrderPosition", "acs"));
					let noMatchCount = 0;
					for (var i = 0; i < apiDimTopics.length; i++) {

						for (var j = 0; j < apiDimTopics[i].dimensionGroups.length; j++) {
							var apiDimensions = apiDimTopics[i].dimensionGroups[j].dimensions;
							apiDimensions.sort(appUtilities.compareNumerics("dimensionOrderPosition", "asc"));
							for (var m = 0; m < apiDimensions.length; m++) {
								let matchFound = false;
								for (var q = 0; q < qDimensions.length; q++) {
									if (apiDimensions[m].hierarchyAvailable == 'Y') {
										if (apiDimensions[m].dimHier1[0].shortName.toLowerCase().trim() == qDimensions[q].qMeta.title.toLowerCase().trim()
											 || apiDimensions[m].dimHier1[0].shortName.toLowerCase().trim() == (qDimensions[q].qMeta.masterScriptId != null ? qDimensions[q].qMeta.masterScriptId.toLowerCase().trim() : '')) {
											//set shortName for tree dim root which is not in api
											matchFound = true;
											if (qDimensions[q].qMeta.masterScriptId != null) {
												apiDimensions[m].shortName = qDimensions[q].qMeta.masterScriptId; //NSCG uses masterscriptid to hold short name
											} else {
												apiDimensions[m].shortName = qDimensions[q].qMeta.title; //most surveys use metadata.title to hold shortName
											}
											apiDimensions[m].qId = qDimensions[q].qInfo.qId;
											apiDimensions[m].cId = randomCid();
											apiDimensions[m].variableId = apiDimensions[m].dimHier1[0].variableId //default topic dim to root dim id
												apiDimensions[m].def = qDimensions[q].qData.qDimension.qFieldDefs[0];
											apiDimensions[m].type = "dimension";

											var tree = dimensions.getDimensionsForTree(apiDimensions[m]);
											for (var t = 0; t < tree.length; t++) {
												for (var d = 0; d < qDimensions.length; d++) {
													if (tree[t].shortName.toLowerCase().trim() == qDimensions[d].qMeta.title.toLowerCase().trim()) {
														tree[t].qId = qDimensions[d].qInfo.qId;
														tree[t].cId = randomCid();
														tree[t].def = qDimensions[d].qData.qDimension.qFieldDefs[0];
														tree[t].type = "dim-branch";
														break;
													}
												}
											}
											
											//console.log(apiDimensions[m].title);
											if($scope.surveyExclusions != null) {
												$scope.surveyExclusions.dimensions.forEach(function(dim) {
													if(dim.type == "hierarchy") {
														if(apiDimensions[m].title == dim.title) {
															apiDimensions[m].exclusions = dim.exclusions;
														}
													}
												})
											}											
											break;
										}
									} else if (apiDimensions[m].shortName.toLowerCase().trim() == qDimensions[q].qMeta.title.toLowerCase().trim()
										 || apiDimensions[m].shortName.toLowerCase().trim() == (qDimensions[q].qMeta.masterScriptId != null ? qDimensions[q].qMeta.masterScriptId.toLowerCase().trim() : '')) {

										//Example logic if need to make non-hierarchy fields mutually exclussive
/* 										if($rootScope.survey.abbreviation == 'SED') {
										
											//TEST
											if(apiDimensions[m].shortName == "instControl") {
												apiDimensions[m].exclusions = ['instHBCU'];  
											}
											if(apiDimensions[m].shortName == "instHBCU") {
												apiDimensions[m].exclusions = ['instControl'];  
											}											
										} */
										matchFound = true;
										//if dim is a duplicate under another topic then use the same dim fr both topics
										var dim = dimensions.getDimensionByName($rootScope, apiDimensions[m].shortName);
										if (dim.cId != null) {
											apiDimensions[m] = dim;

										} else {
											apiDimensions[m].qId = qDimensions[q].qInfo.qId;
											apiDimensions[m].cId = randomCid();
											apiDimensions[m].def = qDimensions[q].qData.qDimension.qFieldDefs[0];
											apiDimensions[m].type = "dimension";
											//override year sort to asc for charts
											if ($rootScope.displayVisType != "pivot-table") {
												if (apiDimensions[m].shortName.toLowerCase() == "year" ||
													apiDimensions[m].shortName.toLowerCase() == "refyr") {
													//console.log('year', apiDimensions[m]);
													apiDimensions[m].valueSortDefault = "ASC";
												}
											}
										}
										break;
									}
								}
								if(!matchFound) {
									noMatchCount++;
									console.log('API Dim not in QVF', apiDimensions[m]);
									//return false;
								}
							}
						}
					}

					if (apiDimTopics != null) {

						for (var i = 0; i < apiDimTopics.length; i++) {
							for (var j = 0; j < apiDimTopics[i].dimensionGroups.length; j++) {
								var apiDimensions = apiDimTopics[i].dimensionGroups[j].dimensions;
								for (var m = 0; m < apiDimensions.length; m++) {
									if (apiDimensions[m].shortName == 'instName') {
										var variableId = apiDimensions[m].variableId;
										//console.log('variableId: ', variableId);
										var subFilters = [];
										dimensions.getSubFilters($http, $q, variableId).then(function (resp) {
											var variableFilterAssociations = resp.data.body.variableFilterAssociations;
											// console.log('variableFilterAssociations: ', variableFilterAssociations.filterAssociations.length)
											for (var k = 0; k < variableFilterAssociations.filterAssociations.length; k++) {
												var filterAssociation = variableFilterAssociations.filterAssociations[k];
												subFilters.push(filterAssociation);
											}
											// console.log('subFilters: ', subFilters);
										});
										apiDimensions[m].subFilters = subFilters;
									}
								}
							}
						}
					}
					if(noMatchCount > 0) {
						//console.log('unmatched dim', apiDimensions[m]);
						return false;
					}
					return true;
				}

				$scope.removeRecode = function(cId) {
					var Promise = qlik.Promise;
					return new Promise(function (resolve, reject) {					
						removeSelection(cId).then(function() {
							return resolve();
						})
					})
				}

				var removeSelection = function (cId) {
					var Promise = qlik.Promise;
					return new Promise(function (resolve, reject) {				

						var rootDim = dimensions.getDimensionByCid($rootScope, cId);

						if (rootDim.type == "recodeTree") {
							hyperCubeProperties.removeTreeFilters(qApp, $rootScope, $scope, null, rootDim).then(function () {
								hyperCubeProperties.getSelectedAssociations($rootScope, rootDim);
								dimensions.resetDimension($rootScope, rootDim);
								return resolve();
							}, function(err) {
								appUtilities.showError(err);
								return resolve();
							});
						} else if (rootDim.hierarchyAvailable == "Y") {
							hyperCubeProperties.removeTreeFilters(qApp, $rootScope, $scope, rootDim, null).then(function () {
								hyperCubeProperties.getSelectedAssociations($rootScope, rootDim);
								dimensions.resetDimension($rootScope, rootDim);
								return resolve();
							}, function(err) {
								appUtilities.showError(err);
								return resolve();
							});
						} else {
							rootDim.selected = false;
							dimensions.resetDimension($rootScope, rootDim);
							hyperCubeProperties.updateSelected(qApp, $rootScope, $scope, rootDim, "remove").then(function () {
								//dimensions.resetDimension($rootScope, rootDim);
								if (rootDim.shortName == "instName") {
									//$scope.clearInstFilter(rootDim);
									$rootScope.$broadcast('clearInstFilterEvent');
								}							
								return resolve();
							}, function (err) {
								toggleReadOnly(false);
								appUtilities.showError(err);
								return resolve();
							});
						}
					});
				}

				/* 		function getTime() {
				var d = new Date();
				var s = d.getSeconds();
				var mil = d.getMilliseconds();
				var h = d.getHours();
				var m = d.getMinutes();
				return h+':'+m+':'+s+':'+mil;
				}	 */

				function setChartProps(type) {
					$scope.qAdhocProps = {
						qInfo: {
							qType: type
						},
						scrollbar: "miniChart", //"bar"
						showTitles: true,
						footnote: appUtilities.getSurveySource($rootScope),
						nullMode: "connect",
						legend: {
							show: true,
							dock: "right"
						},
						color: {
							persistent: true
						},
						barGrouping: {
							grouping: "grouped"
						},
						qHyperCubeDef: {
							qSuppressZero: true,
							qSuppressMissing: true,
							qInitialDataFetch: [{
									qLeft: 0,
									qTop: 0,
									qWidth: 20,
									qHeight: 500
								}
							],
							qReductionMode: "N",
							qMode: "S",
							qPseudoDimPos: -1,
							qNoOfLeftDims: -1,
							qAlwaysFullyExpanded: true,
							qMaxStackedCells: 5000,
							qPopulateMissing: false,
							qShowTotalsAbove: false,
							qIndentMode: false
						},
						dataPoint: {
							show: true,
							showLabels: false,
							showSegmentLabels: false,
							showTotalLabels: false
						},
					}
				}

				function setTblProps(type) {
					$scope.qAdhocProps = {
						qInfo: {
							qType: type
						},
						showTitles: false,
						qHyperCubeDef: {
							qAlwaysFullyExpanded: false,
							qIndentMode: true,
							qDimensions: [],
							qMeasures: [],
							qSuppressZero: true,
							qSuppressMissing: true,
							qShowTotalsAbove: true,
							qInitialDataFetch: [{
									qWidth: 20,
									qHeight: 40
								}
							],
							qMode: "EQ_DATA_MODE_PIVOT",
						}
						
						/* ,
						customTableParameters: {
							showTotalsNotice: $rootScope.survey.showTotalsNotice,
							
						} */
					}
				}

				var randomCid = function () {
					var text = "";
					var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

					for (var i = 0; i < 7; i++)
						text += possible.charAt(Math.floor(Math.random() * possible.length));

					return text;
				};

				$scope.logme2 = function () {
					console.time("timer");
					qApp.getObject($rootScope.visObjId).then(function (obj) {
						console.log('root vis id', $rootScope.visObjId)
						console.log("Get obj: ", obj);
						obj.getProperties().then(function (obj_properties) {
							console.log("Get Properties: NoOfLeftDims & InterColumnSortOrder: ", obj_properties.qHyperCubeDef.qNoOfLeftDims + " " + obj_properties.qHyperCubeDef.qInterColumnSortOrder.toString());
							console.log("Get Properties: ", obj_properties);
							console.log("Get Properties hypercube: ", obj_properties.qHyperCubeDef);
						});
						obj.getEffectiveProperties().then(function (obj_properties) {
							console.log("Get Effective Properties: NoOfLeftDims & InterColumnSortOrder: ", obj_properties.qHyperCubeDef.qNoOfLeftDims + " " + obj_properties.qHyperCubeDef.qInterColumnSortOrder.toString());
							console.log("Get Effective Properties: ", obj_properties);
							console.log("Get Effective Properties Hypercube: ", obj_properties.qHyperCubeDef);

							let dims = obj_properties.qHyperCubeDef.qDimensions;
							let msrs = obj_properties.qHyperCubeDef.qMeasures;
							const notes = new Array();
							if($rootScope.displayTableTotals) {
								let code = 97;
								let numLeftDims = obj_properties.qHyperCubeDef.qNoOfLeftDims;
								for(let x = numLeftDims; x < dims.length; x++) {
									let dim = dims[x];
									if(dim.qOtherTotalSpec.qTotalMode == "TOTAL_OFF")
										continue;

									dim.qTotalLabel = {"qv": "Total (" + String.fromCharCode(code) + ")"};
									notes.push("(" + String.fromCharCode(code) + ") Total based on selected " + dim.qDef.qFieldLabels[0] + " categories")
									code++;
								}

								if(numLeftDims > 0) {
									let dim = dims[0];

									dim.qTotalLabel = {"qv": "Total (" + String.fromCharCode(code) + ")"};
									notes.push("(" + String.fromCharCode(code) + ") Total based on selected " + dim.qDef.qFieldLabels[0] + " categories")
								}
							}

							let props = {
								id: appUtilities.randomCid(), 
								qHyperCubeDef: {
									qAlwaysFullyExpanded: true,
									qSuppressZero: true,
									qSuppressMissing: true
								}
							};
							props.qHyperCubeDef.qDimensions = dims;
							props.qHyperCubeDef.qMeasures = msrs;
							props.qHyperCubeDef.qInterColumnSortOrder = obj_properties.qHyperCubeDef.qInterColumnSortOrder
							props.qHyperCubeDef.qNoOfLeftDims = obj_properties.qHyperCubeDef.qNoOfLeftDims;
							props.id = appUtilities.randomCid();
							qlik.currApp().visualization.create('pivot-table', null, props).then(function(vis){
								//if(debug) {
									let sizes = vis.model.layout.qHyperCube.qSize;
									console.log('qcx: ' + sizes.qcx + ', qcy: ' + sizes.qcy + ', total cells: ' + (sizes.qcx * sizes .qcy));
									console.timeEnd("timer");
									//}
							})



						});
						var state = qApp.selectionState();
						console.log("Get Selctions: ", state);
						console.log('measures', $rootScope.measureProperties);
						console.log('dims', $rootScope.dimensionProperties);
					})
				};

				$scope.logme = function () {
					qApp.getObject($rootScope.visObjId).then(function (obj) {
						console.log('root vis id', $rootScope.visObjId)
						console.log("Get obj: ", obj);
						obj.getProperties().then(function (obj_properties) {
							console.log("Get Properties: NoOfLeftDims & InterColumnSortOrder: ", obj_properties.qHyperCubeDef.qNoOfLeftDims + " " + obj_properties.qHyperCubeDef.qInterColumnSortOrder.toString());
							console.log("Get Properties: ", obj_properties);
							console.log("Get Properties hypercube: ", obj_properties.qHyperCubeDef);
						});
						obj.getEffectiveProperties().then(function (obj_properties) {
							console.log("Get Effective Properties: NoOfLeftDims & InterColumnSortOrder: ", obj_properties.qHyperCubeDef.qNoOfLeftDims + " " + obj_properties.qHyperCubeDef.qInterColumnSortOrder.toString());
							console.log("Get Effective Properties: ", obj_properties);
							console.log("Get Effective Properties Hypercube: ", obj_properties.qHyperCubeDef);
						});
						var state = qApp.selectionState();
						console.log("Get Selctions: ", state);
						console.log('measures', $rootScope.measureProperties);
						console.log('dims', $rootScope.dimensionProperties);
					})
				};

				$scope.clickOpenVariableInfoTip = function(type) {
					$scope.title = type.charAt(0).toUpperCase() + type.slice(1);
					$scope.infoTipType = type + 's'

					if(type == "measure") {
						let list = [];
						for(const topic of $rootScope.measureProperties.apiMeasureTopics){
							for(const grp of topic.measureGroups) {
								for(const msr of grp.measures) {
									list.push(msr.title)
								}
							}
						}
						$scope.msrList = list;
					} else if(type == "dimension") {
						let list = [], cnt = 0, variableCnt = 0;
						for(const topic of $rootScope.dimensionProperties.apiDimTopics){
							for(const grp of topic.dimensionGroups) {
								for(const dim of grp.dimensions) {
									cnt++;
									variableCnt++;
									if(cnt < 6) {
										list.push(dim.title)
									}
								}
							}
						}
						$scope.dimListCnt = cnt;
						$scope.dimList = list;
					}
					gtag('event', $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-' + 'Welcome ' + type + ' tooltip', { 'event_label': 'open', 'event_category': 'welcome_tooltip'});
					$("#variableInfoTip").show();
				}

				$scope.clickVariableInfoTipHelp = function () {
					gtag('event', $rootScope.displayVisType == "pivot-table" ? 'TB-' : 'CB-' + 'Welcome Builder Knowledgebase', { 'event_label': 'link', 'event_category': 'knowledgebase'});
					let url = webProperties.props.kbUrl + "?id=kb_article_view&sys_kb_id=01c8b30a1b618a10a22a0e1ce54bcbfe";
					window.open(url, "_blank");
				}
				
				$scope.clickVariableInfoTipClose = function() {
					$("#variableInfoTip").hide();
				}

				$scope.closeColorWarningBanner = function(){
					$scope.useCustomColors = false;
					$scope.previousThemeName = null;
				}				
			}
		]);
	});

'use strict'
define('scripts/controllers/sedCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('SedCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
		//$scope.$parent.headerType = "survey";
		$rootScope.survey = {
            abbreviation: "SED",
            appname: webProperties.props["sed"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, Survey of Earned Doctorates.",
            showTotalsNotice: false,
            allowTablePercentages: false
		};
        
        $scope.amountOptions = {
            show: false
        }
        $scope.page = window.location.pathname;
	}]);
});
'use strict'
define('scripts/controllers/gssCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('GssCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
        $rootScope.survey = {
            abbreviation: "GSS",
            appname: webProperties.props["gss"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, Graduate Students and Postdoctorates in Science and Engineering Survey.",
            showTotalsNotice: false,
            allowTablePercentages: false
		};
        
        $scope.amountOptions = {
            show: false
        }
        
        $scope.page = window.location.pathname;
	}]);
});
'use strict'
define('scripts/controllers/herdCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('HerdCtrl', ['$scope', '$rootScope', function($scope,$rootScope) {		
        $rootScope.survey = {
            abbreviation: "HERD",
            appname: webProperties.props["herd"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, Higher Education Research and Development Survey.",
            showTotalsNotice: false,
            allowTablePercentages: false,
            notices: [
                {
                    "name": "fteMeasureEdit",
                    "showNoticeFlag": true,
                    "borderClass": "border-yellow",
                    "bannerMsg": `
                        <span class="pr-2">
                            <span class="banner-title banner-color-yellow pr-2">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                <span class='pl-2'>Personnel Data Change</span>
                            </span>
                            <span class="banner-text">
                                Data collection for R&D personnel changed in 2020 to provide more detail about staff roles. Compare with caution.
                            </span>
                        </span>
                        `,
                    "showFullMsgFlag": true,
                    "fullMsg": `
                    	<div class="m-2">
                            <div class='banner-lg-title mb-3'>R&D Tracking Update</div>
                            <hr class="content-seperator-steel" style="margin: 0 -1.5rem; width: calc(100% + 3rem)"/>
                            <div class="banner-text" style="margin:1rem 0">
                                <p>For 2019 and earlier, this measure counts the number of “principal 
                                investigators” and “all other personnel” that received salaries, wages, and fringe benefits from R&D 
                                accounts. Starting in 2020, the survey was revised to ask for a headcount and full-time equivalents (FTEs) 
                                for three R&D functions: researchers, R&D technicians, and R&D support staff. The data for the 
                                revised questions are not available for 2020 and 2021 but are available for 2022 and later. 
                                Please refer to the Data Tables for headcounts and FTE related data 
								for <a href="https://ncses.nsf.gov/pubs/nsf22311/assets/data-tables/tables/nsf22311-tab077.pdf" target="_blank">2020</a> 
                                and <a href="https://ncses.nsf.gov/surveys/higher-education-research-development/2021#data" target="_blank">2021</a>.
                                </p>
								<div style="text-align: right">
								For more information: <button type='button' onclick='openExternalUrl("?id=kb_article_view&sysparm_article=KB0012696")' class='md-link'>Missing Headcount for HERD</button>
                                </div>
                            </div>
                        </div>
                            `			
                }
            ]
		};
        
        $scope.amountOptions = {
            show: true,
            deflators: [{'value':'1.0', 'name': 'Current Dollars'},{'value': 'CY_Deflator', 'name':'2017 Dollars'}],
            deflatorTooltip: {
                title: "Inflation Adjustment",
                msg: `<p>Data on R&D expenditures in current dollars can be adjusted for inflation based on the implicit price deflator for gross domestic product (GDP). 
                This GDP price deflator for the United States is regularly reported by the Bureau of Economic Analysis (BEA) in the U.S. Department of Commerce
                (<a href='https://www.bea.gov/national/index.htm#gdp' target='_blank'>https://www.bea.gov/national/index.htm#gdp <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>).</p>
                <p>Use of the implicit GDP price deflator as the basis for R&D inflation adjustments is the standard practice of the national statistical offices for all the world’s major economies. 
                At present, the base year for inflation adjusted, constant dollars is 2017 – for a further explanation 
                see <a href='https://bea.gov/help/faq/513' target='_blank'>https://bea.gov/help/faq/513 <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a> 
                and <a href='https://en.wikipedia.org/wiki/GDP_deflator' target='_blank'>https://en.wikipedia.org/wiki/GDP_deflator <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>.</p>`
            },
            defaultUnitsOfMeasure: 1,
            unitsOfMeasure: [{'value':'1', 'name': 'Dollars'},{'value': '1000', 'name':'Thousands of Dollars'}]
        };        
        $scope.page = window.location.pathname;
	}]);
});
'use strict'
define('scripts/controllers/ffsCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('FfsCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
		$rootScope.survey = {
			abbreviation: "FFS",
			appname: webProperties.props["ffs"].appName,
			source: "SOURCE: National Center for Science and Engineering Statistics, Survey of Federal Funds for Research and Development.",
			showTotalsNotice: true,
			allowTablePercentages: false
		};
		$scope.amountOptions = {
			show: true,
			deflators: [{'value':'1.0', 'name': 'Current Dollars'},{'value': 'CY_2012_Deflator', 'name':'2012 Dollars'}],
			deflatorTooltip: {
				title: "Inflation Adjustment",
				msg: `<p>Data on R&D expenditures in current dollars can be adjusted for inflation based on the implicit price deflator for gross domestic product (GDP). 
				This GDP price deflator for the United States is regularly reported by the Bureau of Economic Analysis (BEA) in the U.S. Department of 
				Commerce (<a href='https://www.bea.gov/national/index.htm#gdp' target='_blank'>https://www.bea.gov/national/index.htm#gdp <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>).</p>
				<p>Use of the implicit GDP price deflator as the basis for R&D inflation adjustments is the standard practice of the national statistical offices for all the world’s major economies. 
				At present, the base year for inflation adjusted, constant dollars is 2017 – for a further explanation 
				see <a href='https://bea.gov/help/faq/513' target='_blank'>https://bea.gov/help/faq/513 <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a> 
				and <a href='https://en.wikipedia.org/wiki/GDP_deflator' target='_blank'>https://en.wikipedia.org/wiki/GDP_deflator <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>.</p>`
			},
			defaultUnitsOfMeasure: 1,            
			unitsOfMeasure: [{'value':'1', 'name': 'Dollars'},{'value': '1000', 'name':'Thousands of Dollars'}]
		};
		$scope.page = window.location.pathname;
		$rootScope.displayTotalsFooter = true;
	}]);
});
'use strict'
define('scripts/controllers/fssCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('FssCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
        $rootScope.survey = {
            abbreviation: "FSS",
            appname: webProperties.props["fss"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, Survey of Federal Science and Engineering Support to Universities, Colleges, and Nonprofit Institutions.",
            showTotalsNotice: true,
            allowTablePercentages: false
        };
        
        $scope.amountOptions = {
            show: true,
            deflators: [{'value':'1.0', 'name': 'Current Dollars'},{'value': 'FY_Deflator', 'name':'2017 Dollars'}],
            deflatorTooltip: {
                title: "Inflation Adjustment",
                msg: `<p>Data on R&D expenditures in current dollars can be adjusted for inflation based on the implicit price deflator for gross domestic product (GDP). 
                This GDP price deflator for the United States is regularly reported by the Bureau of Economic Analysis (BEA) in the U.S. Department of Commerce
                (<a href='https://www.bea.gov/national/index.htm#gdp' target='_blank'>https://www.bea.gov/national/index.htm#gdp <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>).</p>
                <p>Use of the implicit GDP price deflator as the basis for R&D inflation adjustments is the standard practice of the national statistical offices for all the world’s major economies. 
                At present, the base year for inflation adjusted, constant dollars is 2017 – for a further explanation 
                see <a href='https://bea.gov/help/faq/513' target='_blank'>https://bea.gov/help/faq/513 <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a> 
                and <a href='https://en.wikipedia.org/wiki/GDP_deflator' target='_blank'>https://en.wikipedia.org/wiki/GDP_deflator <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>.</p>`
            }, 
            defaultUnitsOfMeasure: 1,
            unitsOfMeasure: [{'value':'1', 'name': 'Dollars'},{'value': '1000', 'name':'Thousands of Dollars'}]
        }
        $scope.page = window.location.pathname;
	}]);
});

'use strict'
define('scripts/controllers/facCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('FacCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
        $rootScope.survey = {
            abbreviation: "FAC",
            appname: webProperties.props["fac"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, Survey of Science and Engineering Research Facilities.",
            showTotalsNotice: true,
            allowTablePercentages: false
        };

        $scope.amountOptions = {
            show: true,
            deflators: [{'value':'1.0', 'name': 'Current Dollars'},{'value': 'CY_2012_Deflator', 'name':'2012 Dollars'}],
            deflatorTooltip: {
                title: "Inflation Adjustment",
                msg: `<p>Data on R&D expenditures in current dollars can be adjusted for inflation based on the implicit price deflator for gross domestic product (GDP). 
                This GDP price deflator for the United States is regularly reported by the Bureau of Economic Analysis (BEA) in the U.S. Department of Commerce
                (<a href='https://www.bea.gov/national/index.htm#gdp' target='_blank'>https://www.bea.gov/national/index.htm#gdp <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>).</p>
                <p>Use of the implicit GDP price deflator as the basis for R&D inflation adjustments is the standard practice of the national statistical offices for all the world’s major economies. 
                At present, the base year for inflation adjusted, constant dollars is 2012 – for a further explanation 
                see <a href='https://bea.gov/help/faq/513' target='_blank'>https://bea.gov/help/faq/513 <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a> 
                and <a href='https://en.wikipedia.org/wiki/GDP_deflator' target='_blank'>https://en.wikipedia.org/wiki/GDP_deflator <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>.</p>`
            },
            defaultUnitsOfMeasure: 1,
            unitsOfMeasure: [{'value':'1', 'name': 'Dollars'},{'value': '1000', 'name':'Thousands of Dollars'}]
        };
        $scope.page = window.location.pathname;
	}]);
});
'use strict'
define('scripts/controllers/ipedsCompCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('IpedsCompCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
        $rootScope.survey = {
            abbreviation: "IPEDS_C",
            appname: webProperties.props["ipeds_c"].appName,
            source: {
                mAwrdsConfrd: "SOURCE: Department of Education, National Center for Education Statistics, Integrated Postsecondary Education Data System, Completions Survey, unrevised provisional release data.",
                mInstCount: "SOURCE: Department of Education, National Center for Education Statistics, Integrated Postsecondary Education Data System, Institutional Characteristics Survey, unrevised provisional release data.",
                combinedMsrs: "SOURCE: Department of Education, National Center for Education Statistics, Integrated Postsecondary Education Data System, Completions Survey and Institutional Characteristics Survey, unrevised provisional release data."
            },
            showTotalsNotice: false,
            allowTablePercentages: false
        };
        
        $scope.amountOptions = {
            show: false
        };
        
        $scope.page = window.location.pathname;
	}]);
});

'use strict'
define('scripts/controllers/ffrdcRdCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('FfrdcRdCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
        $rootScope.survey = {
            abbreviation: "FFRDC_RD",
            appname: webProperties.props["ffrdc_rd"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, Survey of Federal Funds for Research and Development.",
            showTotalsNotice: true,
            allowTablePercentages: false
		};
        
        $scope.amountOptions = {
            show: true,
            deflators: [{'value':'1.0', 'name': 'Current Dollars'},{'value': 'CY_2012_Deflator', 'name':'2012 Dollars'}],
            deflatorTooltip: {
                title: "Inflation Adjustment",
                msg: `<p>Data on R&D expenditures in current dollars can be adjusted for inflation based on the implicit price deflator for gross domestic product (GDP). 
                This GDP price deflator for the United States is regularly reported by the Bureau of Economic Analysis (BEA) in the U.S. Department of Commerce
                (<a href='https://www.bea.gov/national/index.htm#gdp' target='_blank'>https://www.bea.gov/national/index.htm#gdp <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>).</p>
                <p>Use of the implicit GDP price deflator as the basis for R&D inflation adjustments is the standard practice of the national statistical offices for all the world’s major economies. 
                At present, the base year for inflation adjusted, constant dollars is 2012 – for a further explanation 
                see <a href='https://bea.gov/help/faq/513' target='_blank'>https://bea.gov/help/faq/513 <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a> 
                and <a href='https://en.wikipedia.org/wiki/GDP_deflator' target='_blank'>https://en.wikipedia.org/wiki/GDP_deflator <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>.</p>`
            },
            defaultUnitsOfMeasure: 0,
            unitsOfMeasure: [{'value':'1', 'name': 'Dollars'},{'value': '1000', 'name':'Thousands of Dollars'}]            
        };
    
        $scope.page = window.location.pathname;
	}]);
});
'use strict'
define('scripts/controllers/ffrdcPdCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('FfrdcPdCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
        $rootScope.survey = {
            abbreviation: "FFRDC_PD",
            appname: webProperties.props["ffrdc_pd"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, Survey of Federal Funds for Research and Development.",
            showTotalsNotice: false,
            allowTablePercentages: false
		};
        
        $scope.amountOptions = {
            show: false
        };
        
        $scope.page = window.location.pathname;
	}]);
});
'use strict'
define('scripts/controllers/lgsdrCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('LgsdrCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
		$rootScope.survey = {
            abbreviation: "SDR",
            appname: webProperties.props["sdr"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, Survey of Doctorate Recipients.",
            bannerMsg: "The portion of the site with Survey of Doctorate Recipients data is currently available as a beta release. Although all of the published Survey of Doctorate Recipients data are final, the Web features are still in the process of being fully vetted.",
            surveyNoticeHtml: "templates/surveyNoticeLgsdr.html",
            showTotalsNotice: true,
            allowTablePercentages: true
		}
        
        $scope.amountOptions = {
            show: false
        }
		$scope.page = window.location.pathname; //   "/ids/sed";		
	}]);
});
'use strict'
define('scripts/controllers/sgrdCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('SgrdCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
		$rootScope.survey = {
            abbreviation: "SGRD",
            appname: webProperties.props["sgrd"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics.",
            showTotalsNotice: true,
            allowTablePercentages: false
        };
        
        $scope.amountOptions = {
            show: true,        
            defaultUnitsOfMeasure: 0,	
            deflators: [{'value':'1.0', 'name': 'Current Dollars'},{'value': 'FY_2017_Deflator', 'name':'2017 Dollars'}],
            deflatorTooltip: {
                title: "Inflation Adjustment",
                msg: `<p>Data on R&D expenditures in current dollars can be adjusted for inflation based on the implicit price deflator for gross domestic product (GDP). 
                This GDP price deflator for the United States is regularly reported by the Bureau of Economic Analysis (BEA) in the U.S. Department of Commerce
                (<a href='https://www.bea.gov/national/index.htm#gdp' target='_blank'>https://www.bea.gov/national/index.htm#gdp <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>).</p>
                <p>Use of the implicit GDP price deflator as the basis for R&D inflation adjustments is the standard practice of the national statistical offices for all the world’s major economies. 
                At present, the base year for inflation adjusted, constant dollars is 2017 – for a further explanation 
                see <a href='https://bea.gov/help/faq/513' target='_blank'>https://bea.gov/help/faq/513 <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a> 
                and <a href='https://en.wikipedia.org/wiki/GDP_deflator' target='_blank'>https://en.wikipedia.org/wiki/GDP_deflator <i class='fa-regular  fa-arrow-up-right-from-square' role='img' title='Open in new tab'></i></a>.</p>`
            },
            defaultUnitsOfMeasure: 1,
            unitsOfMeasure: [{'value':'1', 'name': 'Dollars'},{'value': '1000', 'name':'Thousands of Dollars'}]
        }
        
		$scope.page = window.location.pathname;
	}]);
});
'use strict'
define('scripts/controllers/nscgCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('NscgCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
		$rootScope.survey = {
            abbreviation: "NSCG",
            appname: webProperties.props["nscg"].appName,
            source: "SOURCE: National Center for Science and Engineering Statistics, National Survey of College Graduates.",
            showTotalsNotice: true,
            allowTablePercentages: true
        };
        
        $scope.amountOptions = {
            show: false
        };
        $scope.page = window.location.pathname;
	}]);
});
'use strict'
define('scripts/controllers/ntewsCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
	angular.module("appModule").controller('NtewsCtrl', ['$scope', '$rootScope', function($scope, $rootScope) {		
        $rootScope.survey = {
            abbreviation: "NTEWS",
            appname: webProperties.props["ntews"].appName,
            source: "SOURCE: National Training, Education, and Workforce Survey",         
            showTotalsNotice: false,
            allowTablePercentages: false
        };
        
        $scope.amountOptions = {
            show: false
        };
        
        $scope.page = window.location.pathname;
	}]);
});

'use strict'
define('scripts/controllers/landingCtrl',["scripts/shared/webProperties"], 
	function (webProperties) {
		
	angular.module("appModule").controller('LandingCtrl', ['$scope', '$rootScope', '$window', '$location', function($scope, $rootScope, $window, $location) {		
		$scope.page = window.location.pathname;
		$scope.type = "table";

		if($location.search().type != null && $location.search().type == 'chart') {
			$scope.type = "chart";
		} else {
			$scope.type = "table";
		}
		
		$scope.ddlSelectSurvey = function(survey) {
			var typeParamIndex = window.location.href.indexOf("type");
			var chartUrl = webProperties.props.webUrl+"index.html#";
			
			if ($location.search().type == 'chart') {
				window.open(chartUrl + survey.toLowerCase() + '?type=chart', "_blank");
			} else {
				window.open(chartUrl + survey.toLowerCase(), "_blank");
			}
		}

	}]);
});
var config = {
	host: "ncsesdata.nsf.gov",
	prefix: "/",
	port: window.location.port,
	isSecure: true
};

require.config({
	baseUrl: "https://" + config.host + config.prefix + "resources"
});
var angApp = {};
require(["js/qlik"], function (qlik) {
	require(["scripts/appModule"], function (appModule) {
		require(["scripts/shared/appUtilities", "scripts/directives/headerDirective", "scripts/directives/footerDirective",
			"scripts/directives/helpDirective", "scripts/directives/releaseNotesDirective",
			"scripts/directives/helpReleaseDirective", "scripts/directives/resizeDirective", "scripts/directives/tableOptionsDirective",
			"scripts/directives/modalSortDirective",  "scripts/directives/modalMsgDirective",
			"scripts/directives/modalErrorDirective",
			"scripts/directives/modalOfflineErrorDirective",
			"scripts/directives/feedbackDirective",
			"scripts/directives/surveyDropDownDirective",
			"scripts/directives/buildChartDropDownDirective",
			"scripts/directives/leftRail0Directive",
			"scripts/directives/leftRail1Directive",
			"scripts/directives/leftRail2Directive",
			"scripts/directives/leftRailSearchDirective",
			"scripts/directives/leftRailOptionsDirective",			
			"scripts/directives/leftRailRecodesDirective",
			"scripts/directives/recodeSelectDimDirective",
			"scripts/directives/recodeAddDirective",
			"scripts/directives/recodeEditInstDirective",
			"scripts/directives/recodeFinishedDirective",
			"scripts/directives/recodeEditCatDirective",	
			"scripts/directives/recodeApplyFilterDirective",
			"scripts/directives/recodeApplyInstFilterDirective",
			"scripts/directives/recodeTreeApplyFilterDirective",
			"scripts/directives/recodeEditDirective",
			"scripts/directives/recodeEditTreeDirective",
			"scripts/directives/modalRecodeTip",		
			"scripts/directives/filterDropDownDirective",
			"scripts/directives/modalFilterDirective",
			"scripts/directives/modalInstFilterDirective",
			"scripts/directives/modalTreeFilterDirective",
			"scripts/directives/helpReleaseDirective",
			"scripts/directives/dataSummaryDirective",
			"scripts/directives/variableDetailsDirective",
			"scripts/directives/surveyDetailsDirective",
			"scripts/directives/tableVariablesDirective",
			"scripts/directives/chartVariablesDirective",
			"scripts/directives/tooltipDirective",
			"scripts/directives/bannerNoticeDirective",
			"scripts/directives/tableMenuDirective",
			"scripts/directives/tableSubMenuExportDirective",
			"scripts/directives/chartMenuDirective",
			"scripts/directives/chartSubMenuLineDirective",
			"scripts/directives/chartSubMenuBarDirective",
			"scripts/directives/chartSubMenuBarPercentageDirective",
			"scripts/directives/chartSubMenuLabelsDirective",
			"scripts/directives/chartSubMenuExportDirective",
			"scripts/directives/chartSubMenuScaleDirective",
			"scripts/directives/chartSubMenuColorDirective",
			"scripts/directives/chartSubMenuZoomDirective",
			"scripts/directives/chartSubMenuDataPointsDirective",
			"scripts/directives/tableToChartDirective",
			"scripts/directives/popoverDirective",
			"scripts/directives/displayWarningMessageDirective",
			"scripts/directives/chartColorThemeDirective",
			"scripts/directives/hexColorPickerDirective",
			"scripts/directives/dragDropListDirective",
			"scripts/directives/metadataExportDirective",
			"scripts/directives/tableSubMenuStatisticsDirective",
			"scripts/controllers/layoutCtrl", "scripts/controllers/surveyListCtrl",
			"scripts/controllers/surveyContentCtrl", "scripts/controllers/sedCtrl",
			"scripts/controllers/gssCtrl",
			"scripts/controllers/herdCtrl", "scripts/controllers/ffsCtrl", "scripts/controllers/fssCtrl",
			"scripts/controllers/facCtrl", "scripts/controllers/ipedsCompCtrl",
			"scripts/controllers/ffrdcRdCtrl","scripts/controllers/ffrdcPdCtrl",
			"scripts/controllers/lgsdrCtrl", "scripts/controllers/sgrdCtrl",
			"scripts/controllers/nscgCtrl", "scripts/controllers/ntewsCtrl",
			"scripts/controllers/landingCtrl"], function (appUtilities) {
			angular.bootstrap(document, ["appModule", "qlik-angular"]);
			qlik.on("error", function (error) {
				console.log("error listener called for global", error);
				appUtilities.showError(error);
			});
			qlik.on("warning", function (warning) {
				console.log("Warning", warning.message);
				appUtilities.showError(warning);
			});	
		}, function (err) {
			alert(err);
		});
	});
});

define("scripts/datatool", function(){});

